(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 97748:
/***/ (function(module) {

(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;
var _$breadcrumbTypes_8 = ['navigation', 'request', 'process', 'log', 'user', 'state', 'error', 'manual'];

// Array#reduce
var _$reduce_17 = function (arr, fn, accum) {
  var val = accum;
  for (var i = 0, len = arr.length; i < len; i++) val = fn(val, arr[i], i, arr);
  return val;
};

/* removed: var _$reduce_17 = require('./reduce'); */;

// Array#filter
var _$filter_12 = function (arr, fn) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return !fn(item, i, arr) ? accum : accum.concat(item);
  }, []);
};

/* removed: var _$reduce_17 = require('./reduce'); */;
// Array#includes
var _$includes_13 = function (arr, x) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return accum === true || item === x;
  }, false);
};

// Array#isArray
var _$isArray_14 = function (obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

/* eslint-disable-next-line no-prototype-builtins */
var _hasDontEnumBug = !{
  toString: null
}.propertyIsEnumerable('toString');
var _dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];

// Object#keys
var _$keys_15 = function (obj) {
  // stripped down version of
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/Keys
  var result = [];
  var prop;
  for (prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
  }
  if (!_hasDontEnumBug) return result;
  for (var i = 0, len = _dontEnums.length; i < len; i++) {
    if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
  }
  return result;
};

var _$intRange_24 = function (min, max) {
  if (min === void 0) {
    min = 1;
  }
  if (max === void 0) {
    max = Infinity;
  }
  return function (value) {
    return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
  };
};

/* removed: var _$filter_12 = require('../es-utils/filter'); */;
/* removed: var _$isArray_14 = require('../es-utils/is-array'); */;
var _$listOfFunctions_25 = function (value) {
  return typeof value === 'function' || _$isArray_14(value) && _$filter_12(value, function (f) {
    return typeof f === 'function';
  }).length === value.length;
};

var _$stringWithLength_26 = function (value) {
  return typeof value === 'string' && !!value.length;
};

var _$config_5 = {};
/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;
/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;
/* removed: var _$keys_15 = require('./lib/es-utils/keys'); */;
/* removed: var _$isArray_14 = require('./lib/es-utils/is-array'); */;
/* removed: var _$includes_13 = require('./lib/es-utils/includes'); */;
/* removed: var _$intRange_24 = require('./lib/validators/int-range'); */;
/* removed: var _$stringWithLength_26 = require('./lib/validators/string-with-length'); */;
/* removed: var _$listOfFunctions_25 = require('./lib/validators/list-of-functions'); */;
/* removed: var _$breadcrumbTypes_8 = require('./lib/breadcrumb-types'); */;
var defaultErrorTypes = function () {
  return {
    unhandledExceptions: true,
    unhandledRejections: true
  };
};
_$config_5.schema = {
  apiKey: {
    defaultValue: function () {
      return null;
    },
    message: 'is required',
    validate: _$stringWithLength_26
  },
  appVersion: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || _$stringWithLength_26(value);
    }
  },
  appType: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || _$stringWithLength_26(value);
    }
  },
  autoDetectErrors: {
    defaultValue: function () {
      return true;
    },
    message: 'should be true|false',
    validate: function (value) {
      return value === true || value === false;
    }
  },
  enabledErrorTypes: {
    defaultValue: function () {
      return defaultErrorTypes();
    },
    message: 'should be an object containing the flags { unhandledExceptions:true|false, unhandledRejections:true|false }',
    allowPartialObject: true,
    validate: function (value) {
      // ensure we have an object
      if (typeof value !== 'object' || !value) return false;
      var providedKeys = _$keys_15(value);
      var defaultKeys = _$keys_15(defaultErrorTypes());
      // ensure it only has a subset of the allowed keys
      if (_$filter_12(providedKeys, function (k) {
        return _$includes_13(defaultKeys, k);
      }).length < providedKeys.length) return false;
      // ensure all of the values are boolean
      if (_$filter_12(_$keys_15(value), function (k) {
        return typeof value[k] !== 'boolean';
      }).length > 0) return false;
      return true;
    }
  },
  onError: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  onSession: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  onBreadcrumb: {
    defaultValue: function () {
      return [];
    },
    message: 'should be a function or array of functions',
    validate: _$listOfFunctions_25
  },
  endpoints: {
    defaultValue: function () {
      return {
        notify: 'https://notify.bugsnag.com',
        sessions: 'https://sessions.bugsnag.com'
      };
    },
    message: 'should be an object containing endpoint URLs { notify, sessions }',
    validate: function (val) {
      return (
        // first, ensure it's an object
        val && typeof val === 'object' &&
        // notify and sessions must always be set
        _$stringWithLength_26(val.notify) && _$stringWithLength_26(val.sessions) &&
        // ensure no keys other than notify/session are set on endpoints object
        _$filter_12(_$keys_15(val), function (k) {
          return !_$includes_13(['notify', 'sessions'], k);
        }).length === 0
      );
    }
  },
  autoTrackSessions: {
    defaultValue: function (val) {
      return true;
    },
    message: 'should be true|false',
    validate: function (val) {
      return val === true || val === false;
    }
  },
  enabledReleaseStages: {
    defaultValue: function () {
      return null;
    },
    message: 'should be an array of strings',
    validate: function (value) {
      return value === null || _$isArray_14(value) && _$filter_12(value, function (f) {
        return typeof f === 'string';
      }).length === value.length;
    }
  },
  releaseStage: {
    defaultValue: function () {
      return 'production';
    },
    message: 'should be a string',
    validate: function (value) {
      return typeof value === 'string' && value.length;
    }
  },
  maxBreadcrumbs: {
    defaultValue: function () {
      return 25;
    },
    message: 'should be a number ≤100',
    validate: function (value) {
      return _$intRange_24(0, 100)(value);
    }
  },
  enabledBreadcrumbTypes: {
    defaultValue: function () {
      return _$breadcrumbTypes_8;
    },
    message: "should be null or a list of available breadcrumb types (" + _$breadcrumbTypes_8.join(',') + ")",
    validate: function (value) {
      return value === null || _$isArray_14(value) && _$reduce_17(value, function (accum, maybeType) {
        if (accum === false) return accum;
        return _$includes_13(_$breadcrumbTypes_8, maybeType);
      }, true);
    }
  },
  context: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be a string',
    validate: function (value) {
      return value === undefined || typeof value === 'string';
    }
  },
  user: {
    defaultValue: function () {
      return {};
    },
    message: 'should be an object with { id, email, name } properties',
    validate: function (value) {
      return value === null || value && _$reduce_17(_$keys_15(value), function (accum, key) {
        return accum && _$includes_13(['id', 'email', 'name'], key);
      }, true);
    }
  },
  metadata: {
    defaultValue: function () {
      return {};
    },
    message: 'should be an object',
    validate: function (value) {
      return typeof value === 'object' && value !== null;
    }
  },
  logger: {
    defaultValue: function () {
      return undefined;
    },
    message: 'should be null or an object with methods { debug, info, warn, error }',
    validate: function (value) {
      return !value || value && _$reduce_17(['debug', 'info', 'warn', 'error'], function (accum, method) {
        return accum && typeof value[method] === 'function';
      }, true);
    }
  },
  redactedKeys: {
    defaultValue: function () {
      return ['password'];
    },
    message: 'should be an array of strings|regexes',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (s) {
        return typeof s === 'string' || s && typeof s.test === 'function';
      }).length;
    }
  },
  plugins: {
    defaultValue: function () {
      return [];
    },
    message: 'should be an array of plugin objects',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (p) {
        return p && typeof p === 'object' && typeof p.load === 'function';
      }).length;
    }
  },
  featureFlags: {
    defaultValue: function () {
      return [];
    },
    message: 'should be an array of objects that have a "name" property',
    validate: function (value) {
      return _$isArray_14(value) && value.length === _$filter_12(value, function (feature) {
        return feature && typeof feature === 'object' && typeof feature.name === 'string';
      }).length;
    }
  }
};

// extends helper from babel
// https://github.com/babel/babel/blob/916429b516e6466fd06588ee820e40e025d7f3a3/packages/babel-helpers/src/helpers.js#L377-L393
var _$assign_11 = function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};

/* removed: var _$reduce_17 = require('./reduce'); */;

// Array#map
var _$map_16 = function (arr, fn) {
  return _$reduce_17(arr, function (accum, item, i, arr) {
    return accum.concat(fn(item, i, arr));
  }, []);
};

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var schema = _$config_5.schema;
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;
/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;
var _$config_1 = {
  releaseStage: _$assign_11({}, schema.releaseStage, {
    defaultValue: function () {
      if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
      return 'production';
    }
  }),
  appType: _extends({}, schema.appType, {
    defaultValue: function () {
      return 'browser';
    }
  }),
  logger: _$assign_11({}, schema.logger, {
    defaultValue: function () {
      return (
        // set logger based on browser capability
        typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined
      );
    }
  })
};
var getPrefixedConsole = function () {
  var logger = {};
  var consoleLog = console.log;
  _$map_16(['debug', 'info', 'warn', 'error'], function (method) {
    var consoleMethod = console[method];
    logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[bugsnag]') : consoleLog.bind(console, '[bugsnag]');
  });
  return logger;
};

var Breadcrumb = /*#__PURE__*/function () {
  function Breadcrumb(message, metadata, type, timestamp) {
    if (timestamp === void 0) {
      timestamp = new Date();
    }
    this.type = type;
    this.message = message;
    this.metadata = metadata;
    this.timestamp = timestamp;
  }
  var _proto = Breadcrumb.prototype;
  _proto.toJSON = function toJSON() {
    return {
      type: this.type,
      name: this.message,
      timestamp: this.timestamp,
      metaData: this.metadata
    };
  };
  return Breadcrumb;
}();
var _$Breadcrumb_3 = Breadcrumb;

var _$stackframe_34 = {};
(function (root, factory) {
  'use strict';

  // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */
  if (typeof define === 'function' && define.amd) {
    define('stackframe', [], factory);
  } else if (typeof _$stackframe_34 === 'object') {
    _$stackframe_34 = factory();
  } else {
    root.StackFrame = factory();
  }
})(this, function () {
  'use strict';

  function _isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }
  function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
  }
  function _getter(p) {
    return function () {
      return this[p];
    };
  }
  var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
  var numericProps = ['columnNumber', 'lineNumber'];
  var stringProps = ['fileName', 'functionName', 'source'];
  var arrayProps = ['args'];
  var props = booleanProps.concat(numericProps, stringProps, arrayProps);
  function StackFrame(obj) {
    if (obj instanceof Object) {
      for (var i = 0; i < props.length; i++) {
        if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) {
          this['set' + _capitalize(props[i])](obj[props[i]]);
        }
      }
    }
  }
  StackFrame.prototype = {
    getArgs: function () {
      return this.args;
    },
    setArgs: function (v) {
      if (Object.prototype.toString.call(v) !== '[object Array]') {
        throw new TypeError('Args must be an Array');
      }
      this.args = v;
    },
    getEvalOrigin: function () {
      return this.evalOrigin;
    },
    setEvalOrigin: function (v) {
      if (v instanceof StackFrame) {
        this.evalOrigin = v;
      } else if (v instanceof Object) {
        this.evalOrigin = new StackFrame(v);
      } else {
        throw new TypeError('Eval Origin must be an Object or StackFrame');
      }
    },
    toString: function () {
      var functionName = this.getFunctionName() || '{anonymous}';
      var args = '(' + (this.getArgs() || []).join(',') + ')';
      var fileName = this.getFileName() ? '@' + this.getFileName() : '';
      var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
      var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
      return functionName + args + fileName + lineNumber + columnNumber;
    }
  };
  for (var i = 0; i < booleanProps.length; i++) {
    StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);
    StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function (p) {
      return function (v) {
        this[p] = Boolean(v);
      };
    }(booleanProps[i]);
  }
  for (var j = 0; j < numericProps.length; j++) {
    StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);
    StackFrame.prototype['set' + _capitalize(numericProps[j])] = function (p) {
      return function (v) {
        if (!_isNumber(v)) {
          throw new TypeError(p + ' must be a Number');
        }
        this[p] = Number(v);
      };
    }(numericProps[j]);
  }
  for (var k = 0; k < stringProps.length; k++) {
    StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);
    StackFrame.prototype['set' + _capitalize(stringProps[k])] = function (p) {
      return function (v) {
        this[p] = String(v);
      };
    }(stringProps[k]);
  }
  return StackFrame;
});

var _$errorStackParser_31 = {};
(function (root, factory) {
  'use strict';

  // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */
  if (typeof define === 'function' && define.amd) {
    define('error-stack-parser', ['stackframe'], factory);
  } else if (typeof _$errorStackParser_31 === 'object') {
    _$errorStackParser_31 = factory(_$stackframe_34);
  } else {
    root.ErrorStackParser = factory(root.StackFrame);
  }
})(this, function ErrorStackParser(StackFrame) {
  'use strict';

  var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
  var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
  var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
  return {
    /**
     * Given an Error object, extract the most information from it.
     *
     * @param {Error} error object
     * @return {Array} of StackFrames
     */
    parse: function ErrorStackParser$$parse(error) {
      if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
        return this.parseOpera(error);
      } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
        return this.parseV8OrIE(error);
      } else if (error.stack) {
        return this.parseFFOrSafari(error);
      } else {
        throw new Error('Cannot parse given Error object');
      }
    },
    // Separate line and column numbers from a string of the form: (URI:Line:Column)
    extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
      // Fail-fast but return locations like "(native)"
      if (urlLike.indexOf(':') === -1) {
        return [urlLike];
      }
      var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
      var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
      return [parts[1], parts[2] || undefined, parts[3] || undefined];
    },
    parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(CHROME_IE_STACK_REGEXP);
      }, this);
      return filtered.map(function (line) {
        if (line.indexOf('(eval ') > -1) {
          // Throw away eval information until we implement stacktrace.js/stackframe#8
          line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
        }
        var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '(');

        // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
        // case it has spaces in it, as the string is split on \s+ later on
        var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/);

        // remove the parenthesized location from the line, if it was matched
        sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
        var tokens = sanitizedLine.split(/\s+/).slice(1);
        // if a location was matched, pass it to extractLocation() otherwise pop the last token
        var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
        var functionName = tokens.join(' ') || undefined;
        var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
        return new StackFrame({
          functionName: functionName,
          fileName: fileName,
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    },
    parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !line.match(SAFARI_NATIVE_CODE_REGEXP);
      }, this);
      return filtered.map(function (line) {
        // Throw away eval information until we implement stacktrace.js/stackframe#8
        if (line.indexOf(' > eval') > -1) {
          line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
        }
        if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
          // Safari eval frames only have function names and nothing else
          return new StackFrame({
            functionName: line
          });
        } else {
          var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
          var matches = line.match(functionNameRegex);
          var functionName = matches && matches[1] ? matches[1] : undefined;
          var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
          return new StackFrame({
            functionName: functionName,
            fileName: locationParts[0],
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }
      }, this);
    },
    parseOpera: function ErrorStackParser$$parseOpera(e) {
      if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) {
        return this.parseOpera9(e);
      } else if (!e.stack) {
        return this.parseOpera10(e);
      } else {
        return this.parseOpera11(e);
      }
    },
    parseOpera9: function ErrorStackParser$$parseOpera9(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
      var lines = e.message.split('\n');
      var result = [];
      for (var i = 2, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);
        if (match) {
          result.push(new StackFrame({
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }
      return result;
    },
    parseOpera10: function ErrorStackParser$$parseOpera10(e) {
      var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
      var lines = e.stacktrace.split('\n');
      var result = [];
      for (var i = 0, len = lines.length; i < len; i += 2) {
        var match = lineRE.exec(lines[i]);
        if (match) {
          result.push(new StackFrame({
            functionName: match[3] || undefined,
            fileName: match[2],
            lineNumber: match[1],
            source: lines[i]
          }));
        }
      }
      return result;
    },
    // Opera 10.65+ Error.stack very similar to FF/Safari
    parseOpera11: function ErrorStackParser$$parseOpera11(error) {
      var filtered = error.stack.split('\n').filter(function (line) {
        return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
      }, this);
      return filtered.map(function (line) {
        var tokens = line.split('@');
        var locationParts = this.extractLocation(tokens.pop());
        var functionCall = tokens.shift() || '';
        var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
        var argsRaw;
        if (functionCall.match(/\(([^\)]*)\)/)) {
          argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
        }
        var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
        return new StackFrame({
          functionName: functionName,
          args: args,
          fileName: locationParts[0],
          lineNumber: locationParts[1],
          columnNumber: locationParts[2],
          source: line
        });
      }, this);
    }
  };
});

var _$errorStackParser_10 = _$errorStackParser_31;

var _$safeJsonStringify_30 = function (data, replacer, space, opts) {
  var redactedKeys = opts && opts.redactedKeys ? opts.redactedKeys : [];
  var redactedPaths = opts && opts.redactedPaths ? opts.redactedPaths : [];
  return JSON.stringify(prepareObjForSerialization(data, redactedKeys, redactedPaths), replacer, space);
};
var MAX_DEPTH = 20;
var MAX_EDGES = 25000;
var MIN_PRESERVED_DEPTH = 8;
var REPLACEMENT_NODE = '...';
function isError(o) {
  return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
}
function throwsMessage(err) {
  return '[Throws: ' + (err ? err.message : '?') + ']';
}
function find(haystack, needle) {
  for (var i = 0, len = haystack.length; i < len; i++) {
    if (haystack[i] === needle) return true;
  }
  return false;
}

// returns true if the string `path` starts with any of the provided `paths`
function isDescendent(paths, path) {
  for (var i = 0, len = paths.length; i < len; i++) {
    if (path.indexOf(paths[i]) === 0) return true;
  }
  return false;
}
function shouldRedact(patterns, key) {
  for (var i = 0, len = patterns.length; i < len; i++) {
    if (typeof patterns[i] === 'string' && patterns[i].toLowerCase() === key.toLowerCase()) return true;
    if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
  }
  return false;
}
function __isArray_30(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}
function safelyGetProp(obj, prop) {
  try {
    return obj[prop];
  } catch (err) {
    return throwsMessage(err);
  }
}
function prepareObjForSerialization(obj, redactedKeys, redactedPaths) {
  var seen = []; // store references to objects we have seen before
  var edges = 0;
  function visit(obj, path) {
    function edgesExceeded() {
      return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
    }
    edges++;
    if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
    if (edgesExceeded()) return REPLACEMENT_NODE;
    if (obj === null || typeof obj !== 'object') return obj;
    if (find(seen, obj)) return '[Circular]';
    seen.push(obj);
    if (typeof obj.toJSON === 'function') {
      try {
        // we're not going to count this as an edge because it
        // replaces the value of the currently visited object
        edges--;
        var fResult = visit(obj.toJSON(), path);
        seen.pop();
        return fResult;
      } catch (err) {
        return throwsMessage(err);
      }
    }
    var er = isError(obj);
    if (er) {
      edges--;
      var eResult = visit({
        name: obj.name,
        message: obj.message
      }, path);
      seen.pop();
      return eResult;
    }
    if (__isArray_30(obj)) {
      var aResult = [];
      for (var i = 0, len = obj.length; i < len; i++) {
        if (edgesExceeded()) {
          aResult.push(REPLACEMENT_NODE);
          break;
        }
        aResult.push(visit(obj[i], path.concat('[]')));
      }
      seen.pop();
      return aResult;
    }
    var result = {};
    try {
      for (var prop in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
        if (isDescendent(redactedPaths, path.join('.')) && shouldRedact(redactedKeys, prop)) {
          result[prop] = '[REDACTED]';
          continue;
        }
        if (edgesExceeded()) {
          result[prop] = REPLACEMENT_NODE;
          break;
        }
        result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
      }
    } catch (e) {}
    seen.pop();
    return result;
  }
  return visit(obj, []);
}

/* removed: var _$map_16 = require('./es-utils/map'); */;
/* removed: var _$filter_12 = require('./es-utils/filter'); */;
/* removed: var _$isArray_14 = require('./es-utils/is-array'); */;
/* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */;
function add(existingFeatures, existingFeatureKeys, name, variant) {
  if (typeof name !== 'string') {
    return;
  }
  if (variant === undefined) {
    variant = null;
  } else if (variant !== null && typeof variant !== 'string') {
    variant = _$safeJsonStringify_30(variant);
  }
  var existingIndex = existingFeatureKeys[name];
  if (typeof existingIndex === 'number') {
    existingFeatures[existingIndex] = {
      name: name,
      variant: variant
    };
    return;
  }
  existingFeatures.push({
    name: name,
    variant: variant
  });
  existingFeatureKeys[name] = existingFeatures.length - 1;
}
function merge(existingFeatures, newFeatures, existingFeatureKeys) {
  if (!_$isArray_14(newFeatures)) {
    return;
  }
  for (var i = 0; i < newFeatures.length; ++i) {
    var feature = newFeatures[i];
    if (feature === null || typeof feature !== 'object') {
      continue;
    }

    // 'add' will handle if 'name' doesn't exist & 'variant' is optional
    add(existingFeatures, existingFeatureKeys, feature.name, feature.variant);
  }
  return existingFeatures;
}

// convert feature flags from a map of 'name -> variant' into the format required
// by the Bugsnag Event API:
//   [{ featureFlag: 'name', variant: 'variant' }, { featureFlag: 'name 2' }]
function toEventApi(featureFlags) {
  return _$map_16(_$filter_12(featureFlags, Boolean), function (_ref) {
    var name = _ref.name,
      variant = _ref.variant;
    var flag = {
      featureFlag: name
    };

    // don't add a 'variant' property unless there's actually a value
    if (typeof variant === 'string') {
      flag.variant = variant;
    }
    return flag;
  });
}
function clear(features, featuresIndex, name) {
  var existingIndex = featuresIndex[name];
  if (typeof existingIndex === 'number') {
    features[existingIndex] = null;
    delete featuresIndex[name];
  }
}
var _$featureFlagDelegate_18 = {
  add: add,
  clear: clear,
  merge: merge,
  toEventApi: toEventApi
};

// Given `err` which may be an error, does it have a stack property which is a string?
var _$hasStack_19 = function (err) {
  return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
};

/**
 * Expose `isError`.
 */

var _$isError_32 = __isError_32;

/**
 * Test whether `value` is error object.
 *
 * @param {*} value
 * @returns {boolean}
 */

function __isError_32(value) {
  switch (Object.prototype.toString.call(value)) {
    case '[object Error]':
      return true;
    case '[object Exception]':
      return true;
    case '[object DOMException]':
      return true;
    default:
      return value instanceof Error;
  }
}

var _$iserror_20 = _$isError_32;

/* removed: var _$assign_11 = require('./es-utils/assign'); */;
var __add_22 = function (state, section, keyOrObj, maybeVal) {
  var _updates;
  if (!section) return;
  var updates;

  // addMetadata("section", null) -> clears section
  if (keyOrObj === null) return __clear_22(state, section);

  // normalise the two supported input types into object form
  if (typeof keyOrObj === 'object') updates = keyOrObj;
  if (typeof keyOrObj === 'string') updates = (_updates = {}, _updates[keyOrObj] = maybeVal, _updates);

  // exit if we don't have an updates object at this point
  if (!updates) return;

  // preventing the __proto__ property from being used as a key
  if (section === '__proto__' || section === 'constructor' || section === 'prototype') {
    return;
  }

  // ensure a section with this name exists
  if (!state[section]) state[section] = {};

  // merge the updates with the existing section
  state[section] = _$assign_11({}, state[section], updates);
};
var get = function (state, section, key) {
  if (typeof section !== 'string') return undefined;
  if (!key) {
    return state[section];
  }
  if (state[section]) {
    return state[section][key];
  }
  return undefined;
};
var __clear_22 = function (state, section, key) {
  if (typeof section !== 'string') return;

  // clear an entire section
  if (!key) {
    delete state[section];
    return;
  }

  // preventing the __proto__ property from being used as a key
  if (section === '__proto__' || section === 'constructor' || section === 'prototype') {
    return;
  }

  // clear a single value from a section
  if (state[section]) {
    delete state[section][key];
  }
};
var _$metadataDelegate_22 = {
  add: __add_22,
  get: get,
  clear: __clear_22
};

var _$stackGenerator_33 = {};
(function (root, factory) {
  'use strict';

  // Universal Module Definition (UMD) to support AMD, CommonJS/Node.js, Rhino, and browsers.

  /* istanbul ignore next */
  if (typeof define === 'function' && define.amd) {
    define('stack-generator', ['stackframe'], factory);
  } else if (typeof _$stackGenerator_33 === 'object') {
    _$stackGenerator_33 = factory(_$stackframe_34);
  } else {
    root.StackGenerator = factory(root.StackFrame);
  }
})(this, function (StackFrame) {
  return {
    backtrace: function StackGenerator$$backtrace(opts) {
      var stack = [];
      var maxStackSize = 10;
      if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') {
        maxStackSize = opts.maxStackSize;
      }
      var curr = arguments.callee;
      while (curr && stack.length < maxStackSize && curr['arguments']) {
        // Allow V8 optimizations
        var args = new Array(curr['arguments'].length);
        for (var i = 0; i < args.length; ++i) {
          args[i] = curr['arguments'][i];
        }
        if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
          stack.push(new StackFrame({
            functionName: RegExp.$1 || undefined,
            args: args
          }));
        } else {
          stack.push(new StackFrame({
            args: args
          }));
        }
        try {
          curr = curr.caller;
        } catch (e) {
          break;
        }
      }
      return stack;
    }
  };
});

function ___extends_6() { ___extends_6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_6.apply(this, arguments); }
/* removed: var _$errorStackParser_10 = require('./lib/error-stack-parser'); */;
/* removed: var _$stackGenerator_33 = require('stack-generator'); */;
/* removed: var _$hasStack_19 = require('./lib/has-stack'); */;
/* removed: var _$map_16 = require('./lib/es-utils/map'); */;
/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;
/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;
/* removed: var _$assign_11 = require('./lib/es-utils/assign'); */;
/* removed: var _$metadataDelegate_22 = require('./lib/metadata-delegate'); */;
/* removed: var _$featureFlagDelegate_18 = require('./lib/feature-flag-delegate'); */;
/* removed: var _$iserror_20 = require('./lib/iserror'); */;
var Event = /*#__PURE__*/function () {
  function Event(errorClass, errorMessage, stacktrace, handledState, originalError) {
    if (stacktrace === void 0) {
      stacktrace = [];
    }
    if (handledState === void 0) {
      handledState = defaultHandledState();
    }
    this.apiKey = undefined;
    this.context = undefined;
    this.groupingHash = undefined;
    this.originalError = originalError;
    this._handledState = handledState;
    this.severity = this._handledState.severity;
    this.unhandled = this._handledState.unhandled;
    this.app = {};
    this.device = {};
    this.request = {};
    this.breadcrumbs = [];
    this.threads = [];
    this._metadata = {};
    this._features = [];
    this._featuresIndex = {};
    this._user = {};
    this._session = undefined;
    this._correlation = undefined;
    this.errors = [createBugsnagError(errorClass, errorMessage, Event.__type, stacktrace)];

    // Flags.
    // Note these are not initialised unless they are used
    // to save unnecessary bytes in the browser bundle

    /* this.attemptImmediateDelivery, default: true */
  }
  var _proto = Event.prototype;
  _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
    return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
  }

  /**
     * Associate this event with a specific trace. This is usually done automatically when
     * using bugsnag-js-performance, but can also be set manually if required.
     *
     * @param traceId the ID of the trace the event occurred within
     * @param spanId the ID of the span that the event occurred within
     */;
  _proto.setTraceCorrelation = function setTraceCorrelation(traceId, spanId) {
    if (typeof traceId === 'string') {
      this._correlation = ___extends_6({
        traceId: traceId
      }, typeof spanId === 'string' ? {
        spanId: spanId
      } : {});
    }
  };
  _proto.getMetadata = function getMetadata(section, key) {
    return _$metadataDelegate_22.get(this._metadata, section, key);
  };
  _proto.clearMetadata = function clearMetadata(section, key) {
    return _$metadataDelegate_22.clear(this._metadata, section, key);
  };
  _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
    if (variant === void 0) {
      variant = null;
    }
    _$featureFlagDelegate_18.add(this._features, this._featuresIndex, name, variant);
  };
  _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
    _$featureFlagDelegate_18.merge(this._features, featureFlags, this._featuresIndex);
  };
  _proto.getFeatureFlags = function getFeatureFlags() {
    return _$featureFlagDelegate_18.toEventApi(this._features);
  };
  _proto.clearFeatureFlag = function clearFeatureFlag(name) {
    _$featureFlagDelegate_18.clear(this._features, this._featuresIndex, name);
  };
  _proto.clearFeatureFlags = function clearFeatureFlags() {
    this._features = [];
    this._featuresIndex = {};
  };
  _proto.getUser = function getUser() {
    return this._user;
  };
  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };
  _proto.toJSON = function toJSON() {
    return {
      payloadVersion: '4',
      exceptions: _$map_16(this.errors, function (er) {
        return _$assign_11({}, er, {
          message: er.errorMessage
        });
      }),
      severity: this.severity,
      unhandled: this._handledState.unhandled,
      severityReason: this._handledState.severityReason,
      app: this.app,
      device: this.device,
      request: this.request,
      breadcrumbs: this.breadcrumbs,
      context: this.context,
      groupingHash: this.groupingHash,
      metaData: this._metadata,
      user: this._user,
      session: this._session,
      featureFlags: this.getFeatureFlags(),
      correlation: this._correlation
    };
  };
  return Event;
}(); // takes a stacktrace.js style stackframe (https://github.com/stacktracejs/stackframe)
// and returns a Bugsnag compatible stackframe (https://docs.bugsnag.com/api/error-reporting/#json-payload)
var formatStackframe = function (frame) {
  var f = {
    file: frame.fileName,
    method: normaliseFunctionName(frame.functionName),
    lineNumber: frame.lineNumber,
    columnNumber: frame.columnNumber,
    code: undefined,
    inProject: undefined
  };
  // Some instances result in no file:
  // - calling notify() from chrome's terminal results in no file/method.
  // - non-error exception thrown from global code in FF
  // This adds one.
  if (f.lineNumber > -1 && !f.file && !f.method) {
    f.file = 'global code';
  }
  return f;
};
var normaliseFunctionName = function (name) {
  return /^global code$/i.test(name) ? 'global code' : name;
};
var defaultHandledState = function () {
  return {
    unhandled: false,
    severity: 'warning',
    severityReason: {
      type: 'handledException'
    }
  };
};
var ensureString = function (str) {
  return typeof str === 'string' ? str : '';
};
function createBugsnagError(errorClass, errorMessage, type, stacktrace) {
  return {
    errorClass: ensureString(errorClass),
    errorMessage: ensureString(errorMessage),
    type: type,
    stacktrace: _$reduce_17(stacktrace, function (accum, frame) {
      var f = formatStackframe(frame);
      // don't include a stackframe if none of its properties are defined
      try {
        if (JSON.stringify(f) === '{}') return accum;
        return accum.concat(f);
      } catch (e) {
        return accum;
      }
    }, [])
  };
}
function getCauseStack(error) {
  if (error.cause) {
    return [error].concat(getCauseStack(error.cause));
  } else {
    return [error];
  }
}

// Helpers

Event.getStacktrace = function (error, errorFramesToSkip, backtraceFramesToSkip) {
  if (_$hasStack_19(error)) return _$errorStackParser_10.parse(error).slice(errorFramesToSkip);
  // error wasn't provided or didn't have a stacktrace so try to walk the callstack
  try {
    return _$filter_12(_$stackGenerator_33.backtrace(), function (frame) {
      return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
    }).slice(1 + backtraceFramesToSkip);
  } catch (e) {
    return [];
  }
};
Event.create = function (maybeError, tolerateNonErrors, handledState, component, errorFramesToSkip, logger) {
  if (errorFramesToSkip === void 0) {
    errorFramesToSkip = 0;
  }
  var _normaliseError = normaliseError(maybeError, tolerateNonErrors, component, logger),
    error = _normaliseError[0],
    internalFrames = _normaliseError[1];
  var event;
  try {
    var stacktrace = Event.getStacktrace(error,
    // if an error was created/throw in the normaliseError() function, we need to
    // tell the getStacktrace() function to skip the number of frames we know will
    // be from our own functions. This is added to the number of frames deep we
    // were told about
    internalFrames > 0 ? 1 + internalFrames + errorFramesToSkip : 0,
    // if there's no stacktrace, the callstack may be walked to generated one.
    // this is how many frames should be removed because they come from our library
    1 + errorFramesToSkip);
    event = new Event(error.name, error.message, stacktrace, handledState, maybeError);
  } catch (e) {
    event = new Event(error.name, error.message, [], handledState, maybeError);
  }
  if (error.name === 'InvalidError') {
    event.addMetadata("" + component, 'non-error parameter', makeSerialisable(maybeError));
  }
  if (error.cause) {
    var _event$errors;
    var causes = getCauseStack(error).slice(1);
    var normalisedCauses = _$map_16(causes, function (cause) {
      // Only get stacktrace for error causes that are a valid JS Error and already have a stack
      var stacktrace = _$iserror_20(cause) && _$hasStack_19(cause) ? _$errorStackParser_10.parse(cause) : [];
      var _normaliseError2 = normaliseError(cause, true, 'error cause'),
        error = _normaliseError2[0];
      if (error.name === 'InvalidError') event.addMetadata('error cause', makeSerialisable(cause));
      return createBugsnagError(error.name, error.message, Event.__type, stacktrace);
    });
    (_event$errors = event.errors).push.apply(_event$errors, normalisedCauses);
  }
  return event;
};
var makeSerialisable = function (err) {
  if (err === null) return 'null';
  if (err === undefined) return 'undefined';
  return err;
};
var normaliseError = function (maybeError, tolerateNonErrors, component, logger) {
  var error;
  var internalFrames = 0;
  var createAndLogInputError = function (reason) {
    var verb = component === 'error cause' ? 'was' : 'received';
    if (logger) logger.warn(component + " " + verb + " a non-error: \"" + reason + "\"");
    var err = new Error(component + " " + verb + " a non-error. See \"" + component + "\" tab for more detail.");
    err.name = 'InvalidError';
    return err;
  };

  // In some cases:
  //
  //  - the promise rejection handler (both in the browser and node)
  //  - the node uncaughtException handler
  //
  // We are really limited in what we can do to get a stacktrace. So we use the
  // tolerateNonErrors option to ensure that the resulting error communicates as
  // such.
  if (!tolerateNonErrors) {
    if (_$iserror_20(maybeError)) {
      error = maybeError;
    } else {
      error = createAndLogInputError(typeof maybeError);
      internalFrames += 2;
    }
  } else {
    switch (typeof maybeError) {
      case 'string':
      case 'number':
      case 'boolean':
        error = new Error(String(maybeError));
        internalFrames += 1;
        break;
      case 'function':
        error = createAndLogInputError('function');
        internalFrames += 2;
        break;
      case 'object':
        if (maybeError !== null && _$iserror_20(maybeError)) {
          error = maybeError;
        } else if (maybeError !== null && hasNecessaryFields(maybeError)) {
          error = new Error(maybeError.message || maybeError.errorMessage);
          error.name = maybeError.name || maybeError.errorClass;
          internalFrames += 1;
        } else {
          error = createAndLogInputError(maybeError === null ? 'null' : 'unsupported object');
          internalFrames += 2;
        }
        break;
      default:
        error = createAndLogInputError('nothing');
        internalFrames += 2;
    }
  }
  if (!_$hasStack_19(error)) {
    // in IE10/11 a new Error() doesn't have a stacktrace until you throw it, so try that here
    try {
      throw error;
    } catch (e) {
      if (_$hasStack_19(e)) {
        error = e;
        // if the error only got a stacktrace after we threw it here, we know it
        // will only have one extra internal frame from this function, regardless
        // of whether it went through createAndLogInputError() or not
        internalFrames = 1;
      }
    }
  }
  return [error, internalFrames];
};

// default value for stacktrace.type
Event.__type = 'browserjs';
var hasNecessaryFields = function (error) {
  return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
};
var _$Event_6 = Event;

// This is a heavily modified/simplified version of
//   https://github.com/othiym23/async-some
// with the logic flipped so that it is akin to the
// synchronous "every" method instead of "some".

// run the asynchronous test function (fn) over each item in the array (arr)
// in series until:
//   - fn(item, cb) => calls cb(null, false)
//   - or the end of the array is reached
// the callback (cb) will be passed (null, false) if any of the items in arr
// caused fn to call back with false, otherwise it will be passed (null, true)
var _$asyncEvery_7 = function (arr, fn, cb) {
  var index = 0;
  var next = function () {
    if (index >= arr.length) return cb(null, true);
    fn(arr[index], function (err, result) {
      if (err) return cb(err);
      if (result === false) return cb(null, false);
      index++;
      next();
    });
  };
  next();
};

/* removed: var _$asyncEvery_7 = require('./async-every'); */;
var _$callbackRunner_9 = function (callbacks, event, onCallbackError, cb) {
  // This function is how we support different kinds of callback:
  //  - synchronous - return value
  //  - node-style async with callback - cb(err, value)
  //  - promise/thenable - resolve(value)
  // It normalises each of these into the lowest common denominator – a node-style callback
  var runMaybeAsyncCallback = function (fn, cb) {
    if (typeof fn !== 'function') return cb(null);
    try {
      // if function appears sync…
      if (fn.length !== 2) {
        var ret = fn(event);
        // check if it returned a "thenable" (promise)
        if (ret && typeof ret.then === 'function') {
          return ret.then(
          // resolve
          function (val) {
            return setTimeout(function () {
              return cb(null, val);
            });
          },
          // reject
          function (err) {
            setTimeout(function () {
              onCallbackError(err);
              return cb(null, true);
            });
          });
        }
        return cb(null, ret);
      }
      // if function is async…
      fn(event, function (err, result) {
        if (err) {
          onCallbackError(err);
          return cb(null);
        }
        cb(null, result);
      });
    } catch (e) {
      onCallbackError(e);
      cb(null);
    }
  };
  _$asyncEvery_7(callbacks, runMaybeAsyncCallback, cb);
};

var _$syncCallbackRunner_23 = function (callbacks, callbackArg, callbackType, logger) {
  var ignore = false;
  var cbs = callbacks.slice();
  while (!ignore) {
    if (!cbs.length) break;
    try {
      ignore = cbs.pop()(callbackArg) === false;
    } catch (e) {
      logger.error("Error occurred in " + callbackType + " callback, continuing anyway\u2026");
      logger.error(e);
    }
  }
  return ignore;
};

var _$pad_29 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_29 = require('./pad.js'); */;
var env = typeof window === 'object' ? window : self;
var globalCount = 0;
for (var prop in env) {
  if (Object.hasOwnProperty.call(env, prop)) globalCount++;
}
var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var clientId = _$pad_29((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);
var _$fingerprint_28 = function fingerprint() {
  return clientId;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */

/* removed: var _$fingerprint_28 = require('./lib/fingerprint.js'); */;
/* removed: var _$pad_29 = require('./lib/pad.js'); */;
var c = 0,
  blockSize = 4,
  base = 36,
  discreteValues = Math.pow(base, blockSize);
function randomBlock() {
  return _$pad_29((Math.random() * discreteValues << 0).toString(base), blockSize);
}
function safeCounter() {
  c = c < discreteValues ? c : 0;
  c++; // this is not subliminal
  return c - 1;
}
function cuid() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
    // hard-coded allows for sequential access

    // timestamp
    // warning: this exposes the exact date and time
    // that the uid was created.
    timestamp = new Date().getTime().toString(base),
    // Prevent same-machine collisions.
    counter = _$pad_29(safeCounter().toString(base), blockSize),
    // A few chars to generate distinct ids for different
    // clients (so different computers are far less
    // likely to generate the same id)
    print = _$fingerprint_28(),
    // Grab some more chars from Math.random()
    random = randomBlock() + randomBlock();
  return letter + timestamp + counter + print + random;
}
cuid.fingerprint = _$fingerprint_28;
var _$cuid_27 = cuid;

/* removed: var _$cuid_27 = require('@bugsnag/cuid'); */;
var Session = /*#__PURE__*/function () {
  function Session() {
    this.id = _$cuid_27();
    this.startedAt = new Date();
    this._handled = 0;
    this._unhandled = 0;
    this._user = {};
    this.app = {};
    this.device = {};
  }
  var _proto = Session.prototype;
  _proto.getUser = function getUser() {
    return this._user;
  };
  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };
  _proto.toJSON = function toJSON() {
    return {
      id: this.id,
      startedAt: this.startedAt,
      events: {
        handled: this._handled,
        unhandled: this._unhandled
      }
    };
  };
  _proto._track = function _track(event) {
    this[event._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
  };
  return Session;
}();
var _$Session_35 = Session;

/* removed: var _$config_5 = require('./config'); */;
/* removed: var _$Event_6 = require('./event'); */;
/* removed: var _$Breadcrumb_3 = require('./breadcrumb'); */;
/* removed: var _$Session_35 = require('./session'); */;
/* removed: var _$map_16 = require('./lib/es-utils/map'); */;
/* removed: var _$includes_13 = require('./lib/es-utils/includes'); */;
/* removed: var _$filter_12 = require('./lib/es-utils/filter'); */;
/* removed: var _$reduce_17 = require('./lib/es-utils/reduce'); */;
/* removed: var _$keys_15 = require('./lib/es-utils/keys'); */;
/* removed: var _$assign_11 = require('./lib/es-utils/assign'); */;
/* removed: var _$callbackRunner_9 = require('./lib/callback-runner'); */;
/* removed: var _$metadataDelegate_22 = require('./lib/metadata-delegate'); */;
/* removed: var _$syncCallbackRunner_23 = require('./lib/sync-callback-runner'); */;
/* removed: var _$breadcrumbTypes_8 = require('./lib/breadcrumb-types'); */;
var __add_4 = _$featureFlagDelegate_18.add,
  __clear_4 = _$featureFlagDelegate_18.clear,
  __merge_4 = _$featureFlagDelegate_18.merge;
var noop = function () {};
var Client = /*#__PURE__*/function () {
  function Client(configuration, schema, internalPlugins, notifier) {
    var _this = this;
    if (schema === void 0) {
      schema = _$config_5.schema;
    }
    if (internalPlugins === void 0) {
      internalPlugins = [];
    }
    // notifier id
    this._notifier = notifier;

    // intialise opts and config
    this._config = {};
    this._schema = schema;

    // i/o
    this._delivery = {
      sendSession: noop,
      sendEvent: noop
    };
    this._logger = {
      debug: noop,
      info: noop,
      warn: noop,
      error: noop
    };

    // plugins
    this._plugins = {};

    // state
    this._breadcrumbs = [];
    this._session = null;
    this._metadata = {};
    this._featuresIndex = {};
    this._features = [];
    this._context = undefined;
    this._user = {};

    // callbacks:
    //  e: onError
    //  s: onSession
    //  sp: onSessionPayload
    //  b: onBreadcrumb
    // (note these names are minified by hand because object
    // properties are not safe to minify automatically)
    this._cbs = {
      e: [],
      s: [],
      sp: [],
      b: []
    };

    // expose internal constructors
    this.Client = Client;
    this.Event = _$Event_6;
    this.Breadcrumb = _$Breadcrumb_3;
    this.Session = _$Session_35;
    this._config = this._configure(configuration, internalPlugins);
    _$map_16(internalPlugins.concat(this._config.plugins), function (pl) {
      if (pl) _this._loadPlugin(pl);
    });

    // when notify() is called we need to know how many frames are from our own source
    // this inital value is 1 not 0 because we wrap notify() to ensure it is always
    // bound to have the client as its `this` value – see below.
    this._depth = 1;
    var self = this;
    var notify = this.notify;
    this.notify = function () {
      return notify.apply(self, arguments);
    };
  }
  var _proto = Client.prototype;
  _proto.addMetadata = function addMetadata(section, keyOrObj, maybeVal) {
    return _$metadataDelegate_22.add(this._metadata, section, keyOrObj, maybeVal);
  };
  _proto.getMetadata = function getMetadata(section, key) {
    return _$metadataDelegate_22.get(this._metadata, section, key);
  };
  _proto.clearMetadata = function clearMetadata(section, key) {
    return _$metadataDelegate_22.clear(this._metadata, section, key);
  };
  _proto.addFeatureFlag = function addFeatureFlag(name, variant) {
    if (variant === void 0) {
      variant = null;
    }
    __add_4(this._features, this._featuresIndex, name, variant);
  };
  _proto.addFeatureFlags = function addFeatureFlags(featureFlags) {
    __merge_4(this._features, featureFlags, this._featuresIndex);
  };
  _proto.clearFeatureFlag = function clearFeatureFlag(name) {
    __clear_4(this._features, this._featuresIndex, name);
  };
  _proto.clearFeatureFlags = function clearFeatureFlags() {
    this._features = [];
    this._featuresIndex = {};
  };
  _proto.getContext = function getContext() {
    return this._context;
  };
  _proto.setContext = function setContext(c) {
    this._context = c;
  };
  _proto._configure = function _configure(opts, internalPlugins) {
    var schema = _$reduce_17(internalPlugins, function (schema, plugin) {
      if (plugin && plugin.configSchema) return _$assign_11({}, schema, plugin.configSchema);
      return schema;
    }, this._schema);

    // accumulate configuration and error messages
    var _reduce = _$reduce_17(_$keys_15(schema), function (accum, key) {
        var defaultValue = schema[key].defaultValue(opts[key]);
        if (opts[key] !== undefined) {
          var valid = schema[key].validate(opts[key]);
          if (!valid) {
            accum.errors[key] = schema[key].message;
            accum.config[key] = defaultValue;
          } else {
            if (schema[key].allowPartialObject) {
              accum.config[key] = _$assign_11(defaultValue, opts[key]);
            } else {
              accum.config[key] = opts[key];
            }
          }
        } else {
          accum.config[key] = defaultValue;
        }
        return accum;
      }, {
        errors: {},
        config: {}
      }),
      errors = _reduce.errors,
      config = _reduce.config;
    if (schema.apiKey) {
      // missing api key is the only fatal error
      if (!config.apiKey) throw new Error('No Bugsnag API Key set');
      // warn about an apikey that is not of the expected format
      if (!/^[0-9a-f]{32}$/i.test(config.apiKey)) errors.apiKey = 'should be a string of 32 hexadecimal characters';
    }

    // update and elevate some options
    this._metadata = _$assign_11({}, config.metadata);
    __merge_4(this._features, config.featureFlags, this._featuresIndex);
    this._user = _$assign_11({}, config.user);
    this._context = config.context;
    if (config.logger) this._logger = config.logger;

    // add callbacks
    if (config.onError) this._cbs.e = this._cbs.e.concat(config.onError);
    if (config.onBreadcrumb) this._cbs.b = this._cbs.b.concat(config.onBreadcrumb);
    if (config.onSession) this._cbs.s = this._cbs.s.concat(config.onSession);

    // finally warn about any invalid config where we fell back to the default
    if (_$keys_15(errors).length) {
      this._logger.warn(generateConfigErrorMessage(errors, opts));
    }
    return config;
  };
  _proto.getUser = function getUser() {
    return this._user;
  };
  _proto.setUser = function setUser(id, email, name) {
    this._user = {
      id: id,
      email: email,
      name: name
    };
  };
  _proto._loadPlugin = function _loadPlugin(plugin) {
    var result = plugin.load(this);
    // JS objects are not the safest way to store arbitrarily keyed values,
    // so bookend the key with some characters that prevent tampering with
    // stuff like __proto__ etc. (only store the result if the plugin had a
    // name)
    if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
    return this;
  };
  _proto.getPlugin = function getPlugin(name) {
    return this._plugins["~" + name + "~"];
  };
  _proto._setDelivery = function _setDelivery(d) {
    this._delivery = d(this);
  };
  _proto.startSession = function startSession() {
    var session = new _$Session_35();
    session.app.releaseStage = this._config.releaseStage;
    session.app.version = this._config.appVersion;
    session.app.type = this._config.appType;
    session._user = _$assign_11({}, this._user);

    // run onSession callbacks
    var ignore = _$syncCallbackRunner_23(this._cbs.s, session, 'onSession', this._logger);
    if (ignore) {
      this._logger.debug('Session not started due to onSession callback');
      return this;
    }
    return this._sessionDelegate.startSession(this, session);
  };
  _proto.addOnError = function addOnError(fn, front) {
    if (front === void 0) {
      front = false;
    }
    this._cbs.e[front ? 'unshift' : 'push'](fn);
  };
  _proto.removeOnError = function removeOnError(fn) {
    this._cbs.e = _$filter_12(this._cbs.e, function (f) {
      return f !== fn;
    });
  };
  _proto._addOnSessionPayload = function _addOnSessionPayload(fn) {
    this._cbs.sp.push(fn);
  };
  _proto.addOnSession = function addOnSession(fn) {
    this._cbs.s.push(fn);
  };
  _proto.removeOnSession = function removeOnSession(fn) {
    this._cbs.s = _$filter_12(this._cbs.s, function (f) {
      return f !== fn;
    });
  };
  _proto.addOnBreadcrumb = function addOnBreadcrumb(fn, front) {
    if (front === void 0) {
      front = false;
    }
    this._cbs.b[front ? 'unshift' : 'push'](fn);
  };
  _proto.removeOnBreadcrumb = function removeOnBreadcrumb(fn) {
    this._cbs.b = _$filter_12(this._cbs.b, function (f) {
      return f !== fn;
    });
  };
  _proto.pauseSession = function pauseSession() {
    return this._sessionDelegate.pauseSession(this);
  };
  _proto.resumeSession = function resumeSession() {
    return this._sessionDelegate.resumeSession(this);
  };
  _proto.leaveBreadcrumb = function leaveBreadcrumb(message, metadata, type) {
    // coerce bad values so that the defaults get set
    message = typeof message === 'string' ? message : '';
    type = typeof type === 'string' && _$includes_13(_$breadcrumbTypes_8, type) ? type : 'manual';
    metadata = typeof metadata === 'object' && metadata !== null ? metadata : {};

    // if no message, discard
    if (!message) return;
    var crumb = new _$Breadcrumb_3(message, metadata, type);

    // run onBreadcrumb callbacks
    var ignore = _$syncCallbackRunner_23(this._cbs.b, crumb, 'onBreadcrumb', this._logger);
    if (ignore) {
      this._logger.debug('Breadcrumb not attached due to onBreadcrumb callback');
      return;
    }

    // push the valid crumb onto the queue and maintain the length
    this._breadcrumbs.push(crumb);
    if (this._breadcrumbs.length > this._config.maxBreadcrumbs) {
      this._breadcrumbs = this._breadcrumbs.slice(this._breadcrumbs.length - this._config.maxBreadcrumbs);
    }
  };
  _proto._isBreadcrumbTypeEnabled = function _isBreadcrumbTypeEnabled(type) {
    var types = this._config.enabledBreadcrumbTypes;
    return types === null || _$includes_13(types, type);
  };
  _proto.notify = function notify(maybeError, onError, postReportCallback) {
    if (postReportCallback === void 0) {
      postReportCallback = noop;
    }
    var event = _$Event_6.create(maybeError, true, undefined, 'notify()', this._depth + 1, this._logger);
    this._notify(event, onError, postReportCallback);
  };
  _proto._notify = function _notify(event, onError, postReportCallback) {
    var _this2 = this;
    if (postReportCallback === void 0) {
      postReportCallback = noop;
    }
    event.app = _$assign_11({}, event.app, {
      releaseStage: this._config.releaseStage,
      version: this._config.appVersion,
      type: this._config.appType
    });
    event.context = event.context || this._context;
    event._metadata = _$assign_11({}, event._metadata, this._metadata);
    event._user = _$assign_11({}, event._user, this._user);
    event.breadcrumbs = this._breadcrumbs.slice();
    __merge_4(event._features, this._features, event._featuresIndex);

    // exit early if events should not be sent on the current releaseStage
    if (this._config.enabledReleaseStages !== null && !_$includes_13(this._config.enabledReleaseStages, this._config.releaseStage)) {
      this._logger.warn('Event not sent due to releaseStage/enabledReleaseStages configuration');
      return postReportCallback(null, event);
    }
    var originalSeverity = event.severity;
    var onCallbackError = function (err) {
      // errors in callbacks are tolerated but we want to log them out
      _this2._logger.error('Error occurred in onError callback, continuing anyway…');
      _this2._logger.error(err);
    };
    var callbacks = [].concat(this._cbs.e).concat(onError);
    _$callbackRunner_9(callbacks, event, onCallbackError, function (err, shouldSend) {
      if (err) onCallbackError(err);
      if (!shouldSend) {
        _this2._logger.debug('Event not sent due to onError callback');
        return postReportCallback(null, event);
      }
      if (_this2._isBreadcrumbTypeEnabled('error')) {
        // only leave a crumb for the error if actually got sent
        Client.prototype.leaveBreadcrumb.call(_this2, event.errors[0].errorClass, {
          errorClass: event.errors[0].errorClass,
          errorMessage: event.errors[0].errorMessage,
          severity: event.severity
        }, 'error');
      }
      if (originalSeverity !== event.severity) {
        event._handledState.severityReason = {
          type: 'userCallbackSetSeverity'
        };
      }
      if (event.unhandled !== event._handledState.unhandled) {
        event._handledState.severityReason.unhandledOverridden = true;
        event._handledState.unhandled = event.unhandled;
      }
      if (_this2._session) {
        _this2._session._track(event);
        event._session = _this2._session;
      }
      _this2._delivery.sendEvent({
        apiKey: event.apiKey || _this2._config.apiKey,
        notifier: _this2._notifier,
        events: [event]
      }, function (err) {
        return postReportCallback(err, event);
      });
    });
  };
  return Client;
}();
var generateConfigErrorMessage = function (errors, rawInput) {
  var er = new Error("Invalid configuration\n" + _$map_16(_$keys_15(errors), function (key) {
    return "  - " + key + " " + errors[key] + ", got " + stringify(rawInput[key]);
  }).join('\n\n'));
  return er;
};
var stringify = function (val) {
  switch (typeof val) {
    case 'string':
    case 'number':
    case 'object':
      return JSON.stringify(val);
    default:
      return String(val);
  }
};
var _$Client_4 = Client;

var _$jsonPayload_21 = {};
/* removed: var _$safeJsonStringify_30 = require('@bugsnag/safe-json-stringify'); */;
var EVENT_REDACTION_PATHS = ['events.[].metaData', 'events.[].breadcrumbs.[].metaData', 'events.[].request'];
_$jsonPayload_21.event = function (event, redactedKeys) {
  var payload = _$safeJsonStringify_30(event, null, null, {
    redactedPaths: EVENT_REDACTION_PATHS,
    redactedKeys: redactedKeys
  });
  if (payload.length > 10e5) {
    event.events[0]._metadata = {
      notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetadata was removed"
    };
    payload = _$safeJsonStringify_30(event, null, null, {
      redactedPaths: EVENT_REDACTION_PATHS,
      redactedKeys: redactedKeys
    });
  }
  return payload;
};
_$jsonPayload_21.session = function (session, redactedKeys) {
  var payload = _$safeJsonStringify_30(session, null, null);
  return payload;
};

var _$delivery_36 = {};
/* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */;
_$delivery_36 = function (client, win) {
  if (win === void 0) {
    win = window;
  }
  return {
    sendEvent: function (event, cb) {
      if (cb === void 0) {
        cb = function () {};
      }
      var url = getApiUrl(client._config, 'notify', '4', win);
      var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
      var req = new win.XDomainRequest();
      req.onload = function () {
        cb(null);
      };
      req.onerror = function () {
        var err = new Error('Event failed to send');
        client._logger.error('Event failed to send…', err);
        if (body.length > 10e5) {
          client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
        }
        cb(err);
      };
      req.open('POST', url);
      setTimeout(function () {
        try {
          req.send(body);
        } catch (e) {
          client._logger.error(e);
          cb(e);
        }
      }, 0);
    },
    sendSession: function (session, cb) {
      if (cb === void 0) {
        cb = function () {};
      }
      var url = getApiUrl(client._config, 'sessions', '1', win);
      var req = new win.XDomainRequest();
      req.onload = function () {
        cb(null);
      };
      req.open('POST', url);
      setTimeout(function () {
        try {
          req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
        } catch (e) {
          client._logger.error(e);
          cb(e);
        }
      }, 0);
    }
  };
};
var getApiUrl = function (config, endpoint, version, win) {
  // IE8 doesn't support Date.prototype.toISOstring(), but it does convert a date
  // to an ISO string when you use JSON stringify. Simply parsing the result of
  // JSON.stringify is smaller than using a toISOstring() polyfill.
  var isoDate = JSON.parse(JSON.stringify(new Date()));
  var url = matchPageProtocol(config.endpoints[endpoint], win.location.protocol);
  return url + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(isoDate);
};
var matchPageProtocol = _$delivery_36._matchPageProtocol = function (endpoint, pageProtocol) {
  return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
};

/* removed: var _$jsonPayload_21 = require('@bugsnag/core/lib/json-payload'); */;
var _$delivery_37 = function (client, win) {
  if (win === void 0) {
    win = window;
  }
  return {
    sendEvent: function (event, cb) {
      if (cb === void 0) {
        cb = function () {};
      }
      try {
        var url = client._config.endpoints.notify;
        var req = new win.XMLHttpRequest();
        var body = _$jsonPayload_21.event(event, client._config.redactedKeys);
        req.onreadystatechange = function () {
          if (req.readyState === win.XMLHttpRequest.DONE) {
            var status = req.status;
            if (status === 0 || status >= 400) {
              var err = new Error("Request failed with status " + status);
              client._logger.error('Event failed to send…', err);
              if (body.length > 10e5) {
                client._logger.warn("Event oversized (" + (body.length / 10e5).toFixed(2) + " MB)");
              }
              cb(err);
            } else {
              cb(null);
            }
          }
        };
        req.open('POST', url);
        req.setRequestHeader('Content-Type', 'application/json');
        req.setRequestHeader('Bugsnag-Api-Key', event.apiKey || client._config.apiKey);
        req.setRequestHeader('Bugsnag-Payload-Version', '4');
        req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
        req.send(body);
      } catch (e) {
        client._logger.error(e);
      }
    },
    sendSession: function (session, cb) {
      if (cb === void 0) {
        cb = function () {};
      }
      try {
        var url = client._config.endpoints.sessions;
        var req = new win.XMLHttpRequest();
        req.onreadystatechange = function () {
          if (req.readyState === win.XMLHttpRequest.DONE) {
            var status = req.status;
            if (status === 0 || status >= 400) {
              var err = new Error("Request failed with status " + status);
              client._logger.error('Session failed to send…', err);
              cb(err);
            } else {
              cb(null);
            }
          }
        };
        req.open('POST', url);
        req.setRequestHeader('Content-Type', 'application/json');
        req.setRequestHeader('Bugsnag-Api-Key', client._config.apiKey);
        req.setRequestHeader('Bugsnag-Payload-Version', '1');
        req.setRequestHeader('Bugsnag-Sent-At', new Date().toISOString());
        req.send(_$jsonPayload_21.session(session, client._config.redactedKeys));
      } catch (e) {
        client._logger.error(e);
      }
    }
  };
};

var appStart = new Date();
var reset = function () {
  appStart = new Date();
};
var _$app_38 = {
  name: 'appDuration',
  load: function (client) {
    client.addOnError(function (event) {
      var now = new Date();
      event.app.duration = now - appStart;
    }, true);
    return {
      reset: reset
    };
  }
};

/*
 * Sets the default context to be the current URL
 */
var _$context_39 = function (win) {
  if (win === void 0) {
    win = window;
  }
  return {
    load: function (client) {
      client.addOnError(function (event) {
        if (event.context !== undefined) return;
        event.context = win.location.pathname;
      }, true);
    }
  };
};

var _$pad_43 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_43 = require('./pad.js'); */;
var __env_42 = typeof window === 'object' ? window : self;
var __globalCount_42 = 0;
for (var __prop_42 in __env_42) {
  if (Object.hasOwnProperty.call(__env_42, __prop_42)) __globalCount_42++;
}
var __mimeTypesLength_42 = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
var __clientId_42 = _$pad_43((__mimeTypesLength_42 + navigator.userAgent.length).toString(36) + __globalCount_42.toString(36), 4);
var _$fingerprint_42 = function fingerprint() {
  return __clientId_42;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */

/* removed: var _$fingerprint_42 = require('./lib/fingerprint.js'); */;
/* removed: var _$pad_43 = require('./lib/pad.js'); */;
var __c_41 = 0,
  __blockSize_41 = 4,
  __base_41 = 36,
  __discreteValues_41 = Math.pow(__base_41, __blockSize_41);
function __randomBlock_41() {
  return _$pad_43((Math.random() * __discreteValues_41 << 0).toString(__base_41), __blockSize_41);
}
function __safeCounter_41() {
  __c_41 = __c_41 < __discreteValues_41 ? __c_41 : 0;
  __c_41++; // this is not subliminal
  return __c_41 - 1;
}
function __cuid_41() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
    // hard-coded allows for sequential access

    // timestamp
    // warning: this exposes the exact date and time
    // that the uid was created.
    timestamp = new Date().getTime().toString(__base_41),
    // Prevent same-machine collisions.
    counter = _$pad_43(__safeCounter_41().toString(__base_41), __blockSize_41),
    // A few chars to generate distinct ids for different
    // clients (so different computers are far less
    // likely to generate the same id)
    print = _$fingerprint_42(),
    // Grab some more chars from Math.random()
    random = __randomBlock_41() + __randomBlock_41();
  return letter + timestamp + counter + print + random;
}
__cuid_41.fingerprint = _$fingerprint_42;
var _$cuid_41 = __cuid_41;

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;
var BUGSNAG_ANONYMOUS_ID_KEY = 'bugsnag-anonymous-id';
var getDeviceId = function (win) {
  try {
    var storage = win.localStorage;
    var id = storage.getItem(BUGSNAG_ANONYMOUS_ID_KEY);

    // If we get an ID, make sure it looks like a valid cuid. The length can
    // fluctuate slightly, so some leeway is built in
    if (id && /^c[a-z0-9]{20,32}$/.test(id)) {
      return id;
    }
    /* removed: var _$cuid_41 = require('@bugsnag/cuid'); */;
    id = _$cuid_41();
    storage.setItem(BUGSNAG_ANONYMOUS_ID_KEY, id);
    return id;
  } catch (err) {
    // If localStorage is not available (e.g. because it's disabled) then give up
  }
};

/*
 * Automatically detects browser device details
 */
var _$device_40 = function (nav, win) {
  if (nav === void 0) {
    nav = navigator;
  }
  if (win === void 0) {
    win = window;
  }
  return {
    load: function (client) {
      var device = {
        locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
        userAgent: nav.userAgent
      };
      if (win && win.screen && win.screen.orientation && win.screen.orientation.type) {
        device.orientation = win.screen.orientation.type;
      } else if (win && win.document) {
        device.orientation = win.document.documentElement.clientWidth > win.document.documentElement.clientHeight ? 'landscape' : 'portrait';
      }
      if (client._config.generateAnonymousId) {
        device.id = getDeviceId(win);
      }
      client.addOnSession(function (session) {
        session.device = _$assign_11({}, session.device, device);
        // only set device id if collectUserIp is false
        if (!client._config.collectUserIp) setDefaultUserId(session);
      });

      // add time just as the event is sent
      client.addOnError(function (event) {
        event.device = _$assign_11({}, event.device, device, {
          time: new Date()
        });
        if (!client._config.collectUserIp) setDefaultUserId(event);
      }, true);
    },
    configSchema: {
      generateAnonymousId: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };
};
var setDefaultUserId = function (eventOrSession) {
  // device id is also used to populate the user id field, if it's not already set
  var user = eventOrSession.getUser();
  if (!user || !user.id) {
    eventOrSession.setUser(eventOrSession.device.id);
  }
};

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

/*
 * Sets the event request: { url } to be the current href
 */
var _$request_44 = function (win) {
  if (win === void 0) {
    win = window;
  }
  return {
    load: function (client) {
      client.addOnError(function (event) {
        if (event.request && event.request.url) return;
        event.request = _$assign_11({}, event.request, {
          url: win.location.href
        });
      }, true);
    }
  };
};

/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;
var _$session_45 = {
  load: function (client) {
    client._sessionDelegate = sessionDelegate;
  }
};
var sessionDelegate = {
  startSession: function (client, session) {
    var sessionClient = client;
    sessionClient._session = session;
    sessionClient._pausedSession = null;

    // exit early if the current releaseStage is not enabled
    if (sessionClient._config.enabledReleaseStages !== null && !_$includes_13(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
      sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');
      return sessionClient;
    }
    sessionClient._delivery.sendSession({
      notifier: sessionClient._notifier,
      device: session.device,
      app: session.app,
      sessions: [{
        id: session.id,
        startedAt: session.startedAt,
        user: session._user
      }]
    });
    return sessionClient;
  },
  resumeSession: function (client) {
    // Do nothing if there's already an active session
    if (client._session) {
      return client;
    }

    // If we have a paused session then make it the active session
    if (client._pausedSession) {
      client._session = client._pausedSession;
      client._pausedSession = null;
      return client;
    }

    // Otherwise start a new session
    return client.startSession();
  },
  pauseSession: function (client) {
    client._pausedSession = client._session;
    client._session = null;
  }
};

/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

/*
 * Prevent collection of user IPs
 */
var _$clientIp_46 = {
  load: function (client) {
    if (client._config.collectUserIp) return;
    client.addOnError(function (event) {
      // If user.id is explicitly undefined, it will be missing from the payload. It needs
      // removing so that the following line replaces it
      if (event._user && typeof event._user.id === 'undefined') delete event._user.id;
      event._user = _$assign_11({
        id: '[REDACTED]'
      }, event._user);
      event.request = _$assign_11({
        clientIp: '[REDACTED]'
      }, event.request);
    });
  },
  configSchema: {
    collectUserIp: {
      defaultValue: function () {
        return true;
      },
      message: 'should be true|false',
      validate: function (value) {
        return value === true || value === false;
      }
    }
  }
};

var _$consoleBreadcrumbs_47 = {};
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;
/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;
/* removed: var _$filter_12 = require('@bugsnag/core/lib/es-utils/filter'); */;

/*
 * Leaves breadcrumbs when console log methods are called
 */
_$consoleBreadcrumbs_47.load = function (client) {
  var isDev = /^(local-)?dev(elopment)?$/.test(client._config.releaseStage);
  if (isDev || !client._isBreadcrumbTypeEnabled('log')) return;
  _$map_16(CONSOLE_LOG_METHODS, function (method) {
    var original = console[method];
    console[method] = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      client.leaveBreadcrumb('Console output', _$reduce_17(args, function (accum, arg, i) {
        // do the best/simplest stringification of each argument
        var stringified = '[Unknown value]';
        // this may fail if the input is:
        // - an object whose [[Prototype]] is null (no toString)
        // - an object with a broken toString or @@toPrimitive implementation
        try {
          stringified = String(arg);
        } catch (e) {}
        // if it stringifies to [object Object] attempt to JSON stringify
        if (stringified === '[object Object]') {
          // catch stringify errors and fallback to [object Object]
          try {
            stringified = JSON.stringify(arg);
          } catch (e) {}
        }
        accum["[" + i + "]"] = stringified;
        return accum;
      }, {
        severity: method.indexOf('group') === 0 ? 'log' : method
      }), 'log');
      original.apply(console, args);
    };
    console[method]._restore = function () {
      console[method] = original;
    };
  });
};
if (false) {}
var CONSOLE_LOG_METHODS = _$filter_12(['log', 'debug', 'info', 'warn', 'error'], function (method) {
  return typeof console !== 'undefined' && typeof console[method] === 'function';
});

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;
/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;
/* removed: var _$filter_12 = require('@bugsnag/core/lib/es-utils/filter'); */;
var MAX_LINE_LENGTH = 200;
var MAX_SCRIPT_LENGTH = 500000;
var _$inlineScriptContent_48 = function (doc, win) {
  if (doc === void 0) {
    doc = document;
  }
  if (win === void 0) {
    win = window;
  }
  return {
    load: function (client) {
      if (!client._config.trackInlineScripts) return;
      var originalLocation = win.location.href;
      var html = '';

      // in IE8-10 the 'interactive' state can fire too soon (before scripts have finished executing), so in those
      // we wait for the 'complete' state before assuming that synchronous scripts are no longer executing
      var isOldIe = !!doc.attachEvent;
      var DOMContentLoaded = isOldIe ? doc.readyState === 'complete' : doc.readyState !== 'loading';
      var getHtml = function () {
        return doc.documentElement.outerHTML;
      };

      // get whatever HTML exists at this point in time
      html = getHtml();
      var prev = doc.onreadystatechange;
      // then update it when the DOM content has loaded
      doc.onreadystatechange = function () {
        // IE8 compatible alternative to document#DOMContentLoaded
        if (doc.readyState === 'interactive') {
          html = getHtml();
          DOMContentLoaded = true;
        }
        try {
          prev.apply(this, arguments);
        } catch (e) {}
      };
      var _lastScript = null;
      var updateLastScript = function (script) {
        _lastScript = script;
      };
      var getCurrentScript = function () {
        var script = doc.currentScript || _lastScript;
        if (!script && !DOMContentLoaded) {
          var scripts = doc.scripts || doc.getElementsByTagName('script');
          script = scripts[scripts.length - 1];
        }
        return script;
      };
      var addSurroundingCode = function (lineNumber) {
        // get whatever html has rendered at this point
        if (!DOMContentLoaded || !html) html = getHtml();
        // simulate the raw html
        var htmlLines = ['<!-- DOC START -->'].concat(html.split('\n'));
        var zeroBasedLine = lineNumber - 1;
        var start = Math.max(zeroBasedLine - 3, 0);
        var end = Math.min(zeroBasedLine + 3, htmlLines.length);
        return _$reduce_17(htmlLines.slice(start, end), function (accum, line, i) {
          accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
          return accum;
        }, {});
      };
      client.addOnError(function (event) {
        // remove any of our own frames that may be part the stack this
        // happens before the inline script check as it happens for all errors
        event.errors[0].stacktrace = _$filter_12(event.errors[0].stacktrace, function (f) {
          return !/__trace__$/.test(f.method);
        });
        var frame = event.errors[0].stacktrace[0];

        // remove hash and query string from url
        var cleanUrl = function (url) {
          return url.replace(/#.*$/, '').replace(/\?.*$/, '');
        };

        // if frame.file exists and is not the original location of the page, this can't be an inline script
        if (frame && frame.file && cleanUrl(frame.file) !== cleanUrl(originalLocation)) return;

        // grab the last script known to have run
        var currentScript = getCurrentScript();
        if (currentScript) {
          var content = currentScript.innerHTML;
          event.addMetadata('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));

          // only attempt to grab some surrounding code if we have a line number
          if (frame && frame.lineNumber) {
            frame.code = addSurroundingCode(frame.lineNumber);
          }
        }
      }, true);

      // Proxy all the timer functions whose callback is their 0th argument.
      // Keep a reference to the original setTimeout because we need it later
      var _map = _$map_16(['setTimeout', 'setInterval', 'setImmediate', 'requestAnimationFrame'], function (fn) {
          return __proxy(win, fn, function (original) {
            return __traceOriginalScript(original, function (args) {
              return {
                get: function () {
                  return args[0];
                },
                replace: function (fn) {
                  args[0] = fn;
                }
              };
            });
          });
        }),
        _setTimeout = _map[0];

      // Proxy all the host objects whose prototypes have an addEventListener function
      _$map_16(['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'], function (o) {
        if (!win[o] || !win[o].prototype || !Object.prototype.hasOwnProperty.call(win[o].prototype, 'addEventListener')) return;
        __proxy(win[o].prototype, 'addEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor);
        });
        __proxy(win[o].prototype, 'removeEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
        });
      });
      function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
        if (alsoCallOriginal === void 0) {
          alsoCallOriginal = false;
        }
        return function () {
          // this is required for removeEventListener to remove anything added with
          // addEventListener before the functions started being wrapped by Bugsnag
          var args = [].slice.call(arguments);
          try {
            var cba = callbackAccessor(args);
            var cb = cba.get();
            if (alsoCallOriginal) fn.apply(this, args);
            if (typeof cb !== 'function') return fn.apply(this, args);
            if (cb.__trace__) {
              cba.replace(cb.__trace__);
            } else {
              var script = getCurrentScript();
              // this function mustn't be annonymous due to a bug in the stack
              // generation logic, meaning it gets tripped up
              // see: https://github.com/stacktracejs/stack-generator/issues/6
              cb.__trace__ = function __trace__() {
                // set the script that called this function
                updateLastScript(script);
                // immediately unset the currentScript synchronously below, however
                // if this cb throws an error the line after will not get run so schedule
                // an almost-immediate aysnc update too
                _setTimeout(function () {
                  updateLastScript(null);
                }, 0);
                var ret = cb.apply(this, arguments);
                updateLastScript(null);
                return ret;
              };
              cb.__trace__.__trace__ = cb.__trace__;
              cba.replace(cb.__trace__);
            }
          } catch (e) {
            // swallow these errors on Selenium:
            // Permission denied to access property '__trace__'
            // WebDriverException: Message: Permission denied to access property "handleEvent"
          }
          // IE8 doesn't let you call .apply() on setTimeout/setInterval
          if (fn.apply) return fn.apply(this, args);
          switch (args.length) {
            case 1:
              return fn(args[0]);
            case 2:
              return fn(args[0], args[1]);
            default:
              return fn();
          }
        };
      }
    },
    configSchema: {
      trackInlineScripts: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };
};
function __proxy(host, name, replacer) {
  var original = host[name];
  if (!original) return original;
  var replacement = replacer(original);
  host[name] = replacement;
  return original;
}
function eventTargetCallbackAccessor(args) {
  var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
  return {
    get: function () {
      return isEventHandlerObj ? args[1].handleEvent : args[1];
    },
    replace: function (fn) {
      if (isEventHandlerObj) {
        args[1].handleEvent = fn;
      } else {
        args[1] = fn;
      }
    }
  };
}

/*
 * Leaves breadcrumbs when the user interacts with the DOM
 */
var _$interactionBreadcrumbs_49 = function (win) {
  if (win === void 0) {
    win = window;
  }
  return {
    load: function (client) {
      if (!('addEventListener' in win)) return;
      if (!client._isBreadcrumbTypeEnabled('user')) return;
      win.addEventListener('click', function (event) {
        var targetText, targetSelector;
        try {
          targetText = getNodeText(event.target);
          targetSelector = getNodeSelector(event.target, win);
        } catch (e) {
          targetText = '[hidden]';
          targetSelector = '[hidden]';
          client._logger.error('Cross domain error when tracking click event. See docs: https://tinyurl.com/yy3rn63z');
        }
        client.leaveBreadcrumb('UI click', {
          targetText: targetText,
          targetSelector: targetSelector
        }, 'user');
      }, true);
    }
  };
};
var trim = /^\s*([^\s][\s\S]{0,139}[^\s])?\s*/;
function getNodeText(el) {
  var text = el.textContent || el.innerText || '';
  if (!text && (el.type === 'submit' || el.type === 'button')) {
    text = el.value;
  }
  text = text.replace(trim, '$1');
  if (text.length > 140) {
    return text.slice(0, 135) + '(...)';
  }
  return text;
}

// Create a label from tagname, id and css class of the element
function getNodeSelector(el, win) {
  var parts = [el.tagName];
  if (el.id) parts.push('#' + el.id);
  if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.'));
  // Can't get much more advanced with the current browser
  if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');
  try {
    if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
  } catch (e) {
    // Sometimes the query selector can be invalid just return it as-is
    return parts.join('');
  }
  // try to get a more specific selector if this one matches more than one element
  if (el.parentNode.childNodes.length > 1) {
    var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
    parts.push(":nth-child(" + index + ")");
  }
  if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
  // try prepending the parent node selector
  if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
  return parts.join('');
}

var _$navigationBreadcrumbs_50 = {};
/*
* Leaves breadcrumbs when navigation methods are called or events are emitted
*/
_$navigationBreadcrumbs_50 = function (win) {
  if (win === void 0) {
    win = window;
  }
  var plugin = {
    load: function (client) {
      if (!('addEventListener' in win)) return;
      if (!client._isBreadcrumbTypeEnabled('navigation')) return;

      // returns a function that will drop a breadcrumb with a given name
      var drop = function (name) {
        return function () {
          return client.leaveBreadcrumb(name, {}, 'navigation');
        };
      };

      // simple drops – just names, no meta
      win.addEventListener('pagehide', drop('Page hidden'), true);
      win.addEventListener('pageshow', drop('Page shown'), true);
      win.addEventListener('load', drop('Page loaded'), true);
      win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true);
      // some browsers like to emit popstate when the page loads, so only add the popstate listener after that
      win.addEventListener('load', function () {
        return win.addEventListener('popstate', drop('Navigated back'), true);
      });

      // hashchange has some metadata that we care about
      win.addEventListener('hashchange', function (event) {
        var metadata = event.oldURL ? {
          from: relativeLocation(event.oldURL, win),
          to: relativeLocation(event.newURL, win),
          state: getCurrentState(win)
        } : {
          to: relativeLocation(win.location.href, win)
        };
        client.leaveBreadcrumb('Hash changed', metadata, 'navigation');
      }, true);

      // the only way to know about replaceState/pushState is to wrap them… >_<

      if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
      if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win);
    }
  };
  if (false) {}
  return plugin;
};
if (false) {}

// takes a full url like http://foo.com:1234/pages/01.html?yes=no#section-2 and returns
// just the path and hash parts, e.g. /pages/01.html?yes=no#section-2
var relativeLocation = function (url, win) {
  var a = win.document.createElement('A');
  a.href = url;
  return "" + a.pathname + a.search + a.hash;
};
var stateChangeToMetadata = function (win, state, title, url) {
  var currentPath = relativeLocation(win.location.href, win);
  return {
    title: title,
    state: state,
    prevState: getCurrentState(win),
    to: url || currentPath,
    from: currentPath
  };
};
var wrapHistoryFn = function (client, target, fn, win) {
  var orig = target[fn];
  target[fn] = function (state, title, url) {
    client.leaveBreadcrumb("History " + fn, stateChangeToMetadata(win, state, title, url), 'navigation');
    // if throttle plugin is in use, reset the event sent count
    if (typeof client.resetEventCount === 'function') client.resetEventCount();
    // if the client is operating in auto session-mode, a new route should trigger a new session
    if (client._config.autoTrackSessions) client.startSession();
    // Internet Explorer will convert `undefined` to a string when passed, causing an unintended redirect
    // to '/undefined'. therefore we only pass the url if it's not undefined.
    orig.apply(target, [state, title].concat(url !== undefined ? url : []));
  };
  if (false) {}
};
var getCurrentState = function (win) {
  try {
    return win.history.state;
  } catch (e) {}
};

var BREADCRUMB_TYPE = 'request';
/* removed: var _$includes_13 = require('@bugsnag/core/lib/es-utils/includes'); */;

/*
 * Leaves breadcrumbs when network requests occur
 */
var _$networkBreadcrumbs_51 = function (_ignoredUrls, win) {
  if (_ignoredUrls === void 0) {
    _ignoredUrls = [];
  }
  if (win === void 0) {
    win = window;
  }
  var restoreFunctions = [];
  var plugin = {
    load: function (client) {
      if (!client._isBreadcrumbTypeEnabled('request')) return;
      var ignoredUrls = [client._config.endpoints.notify, client._config.endpoints.sessions].concat(_ignoredUrls);
      monkeyPatchXMLHttpRequest();
      monkeyPatchFetch();

      // XMLHttpRequest monkey patch
      function monkeyPatchXMLHttpRequest() {
        if (!('addEventListener' in win.XMLHttpRequest.prototype)) return;
        var nativeOpen = win.XMLHttpRequest.prototype.open;

        // override native open()
        win.XMLHttpRequest.prototype.open = function open(method, url) {
          var _this = this;
          var requestSetupKey = false;
          var error = function () {
            return handleXHRError(method, url);
          };
          var load = function () {
            return handleXHRLoad(method, url, _this.status);
          };

          // if we have already setup listeners, it means open() was called twice, we need to remove
          // the listeners and recreate them
          if (requestSetupKey) {
            this.removeEventListener('load', load);
            this.removeEventListener('error', error);
          }

          // attach load event listener
          this.addEventListener('load', load);
          // attach error event listener
          this.addEventListener('error', error);
          requestSetupKey = true;
          nativeOpen.apply(this, arguments);
        };
        if (false) {}
      }
      function handleXHRLoad(method, url, status) {
        if (url === undefined) {
          client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
          return;
        }

        // an XMLHttpRequest's URL can be an object as long as its 'toString'
        // returns a URL, e.g. a HTMLAnchorElement
        if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) {
          // don't leave a network breadcrumb from bugsnag notify calls
          return;
        }
        var metadata = {
          status: status,
          request: method + " " + url
        };
        if (status >= 400) {
          // contacted server but got an error response
          client.leaveBreadcrumb('XMLHttpRequest failed', metadata, BREADCRUMB_TYPE);
        } else {
          client.leaveBreadcrumb('XMLHttpRequest succeeded', metadata, BREADCRUMB_TYPE);
        }
      }
      function handleXHRError(method, url) {
        if (url === undefined) {
          client._logger.warn('The request URL is no longer present on this XMLHttpRequest. A breadcrumb cannot be left for this request.');
          return;
        }
        if (typeof url === 'string' && _$includes_13(ignoredUrls, url.replace(/\?.*$/, ''))) {
          // don't leave a network breadcrumb from bugsnag notify calls
          return;
        }

        // failed to contact server
        client.leaveBreadcrumb('XMLHttpRequest error', {
          request: method + " " + url
        }, BREADCRUMB_TYPE);
      }

      // window.fetch monkey patch
      function monkeyPatchFetch() {
        // only patch it if it exists and if it is not a polyfill (patching a polyfilled
        // fetch() results in duplicate breadcrumbs for the same request because the
        // implementation uses XMLHttpRequest which is also patched)
        if (!('fetch' in win) || win.fetch.polyfill) return;
        var oldFetch = win.fetch;
        win.fetch = function fetch() {
          var _arguments = arguments;
          var urlOrRequest = arguments[0];
          var options = arguments[1];
          var method;
          var url = null;
          if (urlOrRequest && typeof urlOrRequest === 'object') {
            url = urlOrRequest.url;
            if (options && 'method' in options) {
              method = options.method;
            } else if (urlOrRequest && 'method' in urlOrRequest) {
              method = urlOrRequest.method;
            }
          } else {
            url = urlOrRequest;
            if (options && 'method' in options) {
              method = options.method;
            }
          }
          if (method === undefined) {
            method = 'GET';
          }
          return new Promise(function (resolve, reject) {
            // pass through to native fetch
            oldFetch.apply(void 0, _arguments).then(function (response) {
              handleFetchSuccess(response, method, url);
              resolve(response);
            })["catch"](function (error) {
              handleFetchError(method, url);
              reject(error);
            });
          });
        };
        if (false) {}
      }
      var handleFetchSuccess = function (response, method, url) {
        var metadata = {
          status: response.status,
          request: method + " " + url
        };
        if (response.status >= 400) {
          // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
          client.leaveBreadcrumb('fetch() failed', metadata, BREADCRUMB_TYPE);
        } else {
          client.leaveBreadcrumb('fetch() succeeded', metadata, BREADCRUMB_TYPE);
        }
      };
      var handleFetchError = function (method, url) {
        client.leaveBreadcrumb('fetch() error', {
          request: method + " " + url
        }, BREADCRUMB_TYPE);
      };
    }
  };
  if (false) {}
  return plugin;
};

/* removed: var _$intRange_24 = require('@bugsnag/core/lib/validators/int-range'); */;

/*
 * Throttles and dedupes events
 */

var _$throttle_52 = {
  load: function (client) {
    // track sent events for each init of the plugin
    var n = 0;

    // add onError hook
    client.addOnError(function (event) {
      // have max events been sent already?
      if (n >= client._config.maxEvents) {
        client._logger.warn("Cancelling event send due to maxEvents per session limit of " + client._config.maxEvents + " being reached");
        return false;
      }
      n++;
    });
    client.resetEventCount = function () {
      n = 0;
    };
  },
  configSchema: {
    maxEvents: {
      defaultValue: function () {
        return 10;
      },
      message: 'should be a positive integer ≤100',
      validate: function (val) {
        return _$intRange_24(1, 100)(val);
      }
    }
  }
};

var _$stripQueryString_53 = {};
/*
 * Remove query strings (and fragments) from stacktraces
 */
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;
/* removed: var _$reduce_17 = require('@bugsnag/core/lib/es-utils/reduce'); */;
_$stripQueryString_53 = {
  load: function (client) {
    client.addOnError(function (event) {
      var allFrames = _$reduce_17(event.errors, function (accum, er) {
        return accum.concat(er.stacktrace);
      }, []);
      _$map_16(allFrames, function (frame) {
        frame.file = strip(frame.file);
      });
    });
  }
};
var strip = _$stripQueryString_53._strip = function (str) {
  return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
};

/*
 * Automatically notifies Bugsnag when window.onerror is called
 */

var _$onerror_54 = function (win, component) {
  if (win === void 0) {
    win = window;
  }
  if (component === void 0) {
    component = 'window onerror';
  }
  return {
    load: function (client) {
      if (!client._config.autoDetectErrors) return;
      if (!client._config.enabledErrorTypes.unhandledExceptions) return;
      function onerror(messageOrEvent, url, lineNo, charNo, error) {
        // Ignore errors with no info due to CORS settings
        if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) {
          client._logger.warn('Ignoring cross-domain or eval script error. See docs: https://tinyurl.com/yy3rn63z');
        } else {
          // any error sent to window.onerror is unhandled and has severity=error
          var handledState = {
            severity: 'error',
            unhandled: true,
            severityReason: {
              type: 'unhandledException'
            }
          };
          var event;

          // window.onerror can be called in a number of ways. This big if-else is how we
          // figure out which arguments were supplied, and what kind of values it received.

          if (error) {
            // if the last parameter (error) was supplied, this is a modern browser's
            // way of saying "this value was thrown and not caught"
            event = client.Event.create(error, true, handledState, component, 1);
            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
          } else if (
          // This complex case detects "error" events that are typically synthesised
          // by jquery's trigger method (although can be created in other ways). In
          // order to detect this:
          // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
          // - the second argument (url) must either not exist or be something other than a string (if it
          //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
          //    function)
          // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
          typeof messageOrEvent === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
            // The jQuery event may have a "type" property, if so use it as part of the error message
            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'Error';
            // attempt to find a message from one of the conventional properties, but
            // default to empty string (the event will fill it with a placeholder)
            var message = messageOrEvent.message || messageOrEvent.detail || '';
            event = client.Event.create({
              name: name,
              message: message
            }, true, handledState, component, 1);

            // provide the original thing onerror received – not our error-like object we passed to _notify
            event.originalError = messageOrEvent;

            // include the raw input as metadata – it might contain more info than we extracted
            event.addMetadata(component, {
              event: messageOrEvent,
              extraParameters: url
            });
          } else {
            // Lastly, if there was no "error" parameter this event was probably from an old
            // browser that doesn't support that. Instead we need to generate a stacktrace.
            event = client.Event.create(messageOrEvent, true, handledState, component, 1);
            decorateStack(event.errors[0].stacktrace, url, lineNo, charNo);
          }
          client._notify(event);
        }
        if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
      }
      var prevOnError = win.onerror;
      win.onerror = onerror;
    }
  };
};

// Sometimes the stacktrace has less information than was passed to window.onerror.
// This function will augment the first stackframe with any useful info that was
// received as arguments to the onerror callback.
var decorateStack = function (stack, url, lineNo, charNo) {
  if (!stack[0]) stack.push({});
  var culprit = stack[0];
  if (!culprit.file && typeof url === 'string') culprit.file = url;
  if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.lineNumber = lineNo;
  if (!culprit.columnNumber) {
    if (isActualNumber(charNo)) {
      culprit.columnNumber = charNo;
    } else if (window.event && isActualNumber(window.event.errorCharacter)) {
      culprit.columnNumber = window.event.errorCharacter;
    }
  }
};
var isActualNumber = function (n) {
  return typeof n === 'number' && String.call(n) !== 'NaN';
};

/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;
/* removed: var _$iserror_20 = require('@bugsnag/core/lib/iserror'); */;
var _listener;
/*
 * Automatically notifies Bugsnag when window.onunhandledrejection is called
 */
var _$unhandledRejection_55 = function (win) {
  if (win === void 0) {
    win = window;
  }
  var plugin = {
    load: function (client) {
      if (!client._config.autoDetectErrors || !client._config.enabledErrorTypes.unhandledRejections) return;
      var listener = function (evt) {
        var error = evt.reason;
        var isBluebird = false;

        // accessing properties on evt.detail can throw errors (see #394)
        try {
          if (evt.detail && evt.detail.reason) {
            error = evt.detail.reason;
            isBluebird = true;
          }
        } catch (e) {}
        var event = client.Event.create(error, false, {
          severity: 'error',
          unhandled: true,
          severityReason: {
            type: 'unhandledPromiseRejection'
          }
        }, 'unhandledrejection handler', 1, client._logger);
        if (isBluebird) {
          _$map_16(event.errors[0].stacktrace, fixBluebirdStacktrace(error));
        }
        client._notify(event, function (event) {
          if (_$iserror_20(event.originalError) && !event.originalError.stack) {
            var _event$addMetadata;
            event.addMetadata('unhandledRejection handler', (_event$addMetadata = {}, _event$addMetadata[Object.prototype.toString.call(event.originalError)] = {
              name: event.originalError.name,
              message: event.originalError.message,
              code: event.originalError.code
            }, _event$addMetadata));
          }
        });
      };
      if ('addEventListener' in win) {
        win.addEventListener('unhandledrejection', listener);
      } else {
        win.onunhandledrejection = function (reason, promise) {
          listener({
            detail: {
              reason: reason,
              promise: promise
            }
          });
        };
      }
      _listener = listener;
    }
  };
  if (false) {}
  return plugin;
};

// The stack parser on bluebird stacks in FF get a suprious first frame:
//
// Error: derp
//   b@http://localhost:5000/bluebird.html:22:24
//   a@http://localhost:5000/bluebird.html:18:9
//   @http://localhost:5000/bluebird.html:14:9
//
// results in
//   […]
//     0: Object { file: "Error: derp", method: undefined, lineNumber: undefined, … }
//     1: Object { file: "http://localhost:5000/bluebird.html", method: "b", lineNumber: 22, … }
//     2: Object { file: "http://localhost:5000/bluebird.html", method: "a", lineNumber: 18, … }
//     3: Object { file: "http://localhost:5000/bluebird.html", lineNumber: 14, columnNumber: 9, … }
//
// so the following reduce/accumulator function removes such frames
//
// Bluebird pads method names with spaces so trim that too…
// https://github.com/petkaantonov/bluebird/blob/b7f21399816d02f979fe434585334ce901dcaf44/src/debuggability.js#L568-L571
var fixBluebirdStacktrace = function (error) {
  return function (frame) {
    if (frame.file === error.toString()) return;
    if (frame.method) {
      frame.method = frame.method.replace(/^\s+/, '');
    }
  };
};

var _$notifier_2 = {};
var name = 'Bugsnag JavaScript';
var version = '7.25.0';
var url = 'https://github.com/bugsnag/bugsnag-js';
/* removed: var _$Client_4 = require('@bugsnag/core/client'); */;
/* removed: var _$Event_6 = require('@bugsnag/core/event'); */;
/* removed: var _$Session_35 = require('@bugsnag/core/session'); */;
/* removed: var _$Breadcrumb_3 = require('@bugsnag/core/breadcrumb'); */;
/* removed: var _$map_16 = require('@bugsnag/core/lib/es-utils/map'); */;
/* removed: var _$keys_15 = require('@bugsnag/core/lib/es-utils/keys'); */;
/* removed: var _$assign_11 = require('@bugsnag/core/lib/es-utils/assign'); */;

// extend the base config schema with some browser-specific options
var __schema_2 = _$assign_11({}, _$config_5.schema, _$config_1);
/* removed: var _$onerror_54 = require('@bugsnag/plugin-window-onerror'); */;
/* removed: var _$unhandledRejection_55 = require('@bugsnag/plugin-window-unhandled-rejection'); */;
/* removed: var _$app_38 = require('@bugsnag/plugin-app-duration'); */;
/* removed: var _$device_40 = require('@bugsnag/plugin-browser-device'); */;
/* removed: var _$context_39 = require('@bugsnag/plugin-browser-context'); */;
/* removed: var _$request_44 = require('@bugsnag/plugin-browser-request'); */;
/* removed: var _$throttle_52 = require('@bugsnag/plugin-simple-throttle'); */;
/* removed: var _$consoleBreadcrumbs_47 = require('@bugsnag/plugin-console-breadcrumbs'); */;
/* removed: var _$networkBreadcrumbs_51 = require('@bugsnag/plugin-network-breadcrumbs'); */;
/* removed: var _$navigationBreadcrumbs_50 = require('@bugsnag/plugin-navigation-breadcrumbs'); */;
/* removed: var _$interactionBreadcrumbs_49 = require('@bugsnag/plugin-interaction-breadcrumbs'); */;
/* removed: var _$inlineScriptContent_48 = require('@bugsnag/plugin-inline-script-content'); */;
/* removed: var _$session_45 = require('@bugsnag/plugin-browser-session'); */;
/* removed: var _$clientIp_46 = require('@bugsnag/plugin-client-ip'); */;
/* removed: var _$stripQueryString_53 = require('@bugsnag/plugin-strip-query-string'); */;

// delivery mechanisms
/* removed: var _$delivery_36 = require('@bugsnag/delivery-x-domain-request'); */;
/* removed: var _$delivery_37 = require('@bugsnag/delivery-xml-http-request'); */;
var Bugsnag = {
  _client: null,
  createClient: function (opts) {
    // handle very simple use case where user supplies just the api key as a string
    if (typeof opts === 'string') opts = {
      apiKey: opts
    };
    if (!opts) opts = {};
    var internalPlugins = [
    // add browser-specific plugins
    _$app_38, _$device_40(), _$context_39(), _$request_44(), _$throttle_52, _$session_45, _$clientIp_46, _$stripQueryString_53, _$onerror_54(), _$unhandledRejection_55(), _$navigationBreadcrumbs_50(), _$interactionBreadcrumbs_49(), _$networkBreadcrumbs_51(), _$consoleBreadcrumbs_47,
    // this one added last to avoid wrapping functionality before bugsnag uses it
    _$inlineScriptContent_48()];

    // configure a client with user supplied options
    var bugsnag = new _$Client_4(opts, __schema_2, internalPlugins, {
      name: name,
      version: version,
      url: url
    });

    // set delivery based on browser capability (IE 8+9 have an XDomainRequest object)
    bugsnag._setDelivery(window.XDomainRequest ? _$delivery_36 : _$delivery_37);
    bugsnag._logger.debug('Loaded!');
    bugsnag.leaveBreadcrumb('Bugsnag loaded', {}, 'state');
    return bugsnag._config.autoTrackSessions ? bugsnag.startSession() : bugsnag;
  },
  start: function (opts) {
    if (Bugsnag._client) {
      Bugsnag._client._logger.warn('Bugsnag.start() was called more than once. Ignoring.');
      return Bugsnag._client;
    }
    Bugsnag._client = Bugsnag.createClient(opts);
    return Bugsnag._client;
  },
  isStarted: function () {
    return Bugsnag._client != null;
  }
};
_$map_16(['resetEventCount'].concat(_$keys_15(_$Client_4.prototype)), function (m) {
  if (/^_/.test(m)) return;
  Bugsnag[m] = function () {
    if (!Bugsnag._client) return console.log("Bugsnag." + m + "() was called before Bugsnag.start()");
    Bugsnag._client._depth += 1;
    var ret = Bugsnag._client[m].apply(Bugsnag._client, arguments);
    Bugsnag._client._depth -= 1;
    return ret;
  };
});
_$notifier_2 = Bugsnag;
_$notifier_2.Client = _$Client_4;
_$notifier_2.Event = _$Event_6;
_$notifier_2.Session = _$Session_35;
_$notifier_2.Breadcrumb = _$Breadcrumb_3;

// Export a "default" property for compatibility with ESM imports
_$notifier_2["default"] = Bugsnag;

return _$notifier_2;

});
//# sourceMappingURL=bugsnag.js.map


/***/ }),

/***/ 64061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(97748)


/***/ }),

/***/ 48711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createCache; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/sheet/dist/emotion-sheet.esm.js
var isDevelopment = false;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/

function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  } // this function should always return with a value
  // TS can't understand it though so we make it stop complaining here


  return undefined;
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  // Using Node instead of HTMLElement since container may be a ShadowRoot
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? !isDevelopment : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.insertionPoint = options.insertionPoint;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    this.tags.forEach(function (tag) {
      var _tag$parentNode;

      return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();



;// CONCATENATED MODULE: ./node_modules/stylis/src/Utility.js
/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs

/**
 * @param {number}
 * @return {string}
 */
var Utility_from = String.fromCharCode

/**
 * @param {object}
 * @return {object}
 */
var Utility_assign = Object.assign

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash (value, length) {
	return Utility_charat(value, 0) ^ 45 ? (((((((length << 2) ^ Utility_charat(value, 0)) << 2) ^ Utility_charat(value, 1)) << 2) ^ Utility_charat(value, 2)) << 2) ^ Utility_charat(value, 3) : 0
}

/**
 * @param {string} value
 * @return {string}
 */
function trim (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function Utility_match (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function Utility_replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} search
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function Utility_charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function Utility_substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function Utility_strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function Utility_sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function Utility_append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function Utility_combine (array, callback) {
	return array.map(callback).join('')
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Tokenizer.js


var line = 1
var column = 1
var Tokenizer_length = 0
var position = 0
var character = 0
var characters = ''

/**
 * @param {string} value
 * @param {object | null} root
 * @param {object | null} parent
 * @param {string} type
 * @param {string[] | string} props
 * @param {object[] | string} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {object} root
 * @param {object} props
 * @return {object}
 */
function Tokenizer_copy (root, props) {
	return Utility_assign(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
}

/**
 * @return {number}
 */
function Tokenizer_char () {
	return character
}

/**
 * @return {number}
 */
function prev () {
	character = position > 0 ? Utility_charat(characters, --position) : 0

	if (column--, character === 10)
		column = 1, line--

	return character
}

/**
 * @return {number}
 */
function next () {
	character = position < Tokenizer_length ? Utility_charat(characters, position++) : 0

	if (column++, character === 10)
		column = 1, line++

	return character
}

/**
 * @return {number}
 */
function peek () {
	return Utility_charat(characters, position)
}

/**
 * @return {number}
 */
function caret () {
	return position
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return Utility_substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, Tokenizer_length = Utility_strlen(characters = value), position = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {string} value
 * @return {string[]}
 */
function Tokenizer_tokenize (value) {
	return dealloc(tokenizer(alloc(value)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next()
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {string[]} children
 * @return {string[]}
 */
function tokenizer (children) {
	while (next())
		switch (token(character)) {
			case 0: append(identifier(position - 1), children)
				break
			case 2: append(delimit(character), children)
				break
			default: append(from(character), children)
		}

	return children
}

/**
 * @param {number} index
 * @param {number} count
 * @return {string}
 */
function escaping (index, count) {
	while (--count && next())
		// not 0-9 A-F a-f
		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
			break

	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position
			// " '
			case 34: case 39:
				if (type !== 34 && type !== 39)
					delimiter(character)
				break
			// (
			case 40:
				if (type === 41)
					delimiter(type)
				break
			// \
			case 92:
				next()
				break
		}

	return position
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position - 1) + '*' + Utility_from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next()

	return slice(index, position)
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Enum.js
var Enum_MS = '-ms-'
var Enum_MOZ = '-moz-'
var Enum_WEBKIT = '-webkit-'

var COMMENT = 'comm'
var Enum_RULESET = 'rule'
var Enum_DECLARATION = 'decl'

var PAGE = '@page'
var MEDIA = '@media'
var IMPORT = '@import'
var CHARSET = '@charset'
var VIEWPORT = '@viewport'
var SUPPORTS = '@supports'
var DOCUMENT = '@document'
var NAMESPACE = '@namespace'
var Enum_KEYFRAMES = '@keyframes'
var FONT_FACE = '@font-face'
var COUNTER_STYLE = '@counter-style'
var FONT_FEATURE_VALUES = '@font-feature-values'
var LAYER = '@layer'

;// CONCATENATED MODULE: ./node_modules/stylis/src/Serializer.js



/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function Serializer_serialize (children, callback) {
	var output = ''
	var length = Utility_sizeof(children)

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || ''

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case LAYER: if (element.children.length) break
		case IMPORT: case Enum_DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case Enum_KEYFRAMES: return element.return = element.value + '{' + Serializer_serialize(element.children, callback) + '}'
		case Enum_RULESET: element.value = element.props.join(',')
	}

	return Utility_strlen(children = Serializer_serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Middleware.js






/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = Utility_sizeof(collection)

	return function (element, index, children, callback) {
		var output = ''

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || ''

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element)
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (element.length > -1)
		if (!element.return)
			switch (element.type) {
				case DECLARATION: element.return = prefix(element.value, element.length, children)
					return
				case KEYFRAMES:
					return serialize([copy(element, {value: replace(element.value, '@', '@' + WEBKIT)})], callback)
				case RULESET:
					if (element.length)
						return combine(element.props, function (value) {
							switch (match(value, /(::plac\w+|:read-\w+)/)) {
								// :read-(only|write)
								case ':read-only': case ':read-write':
									return serialize([copy(element, {props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]})], callback)
								// :placeholder
								case '::placeholder':
									return serialize([
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]}),
										copy(element, {props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]})
									], callback)
							}

							return ''
						})
			}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 */
function namespace (element) {
	switch (element.type) {
		case RULESET:
			element.props = element.props.map(function (value) {
				return combine(tokenize(value), function (value, index, children) {
					switch (charat(value, 0)) {
						// \f
						case 12:
							return substr(value, 1, strlen(value))
						// \0 ( + > ~
						case 0: case 40: case 43: case 62: case 126:
							return value
						// :
						case 58:
							if (children[++index] === 'global')
								children[index] = '', children[++index] = '\f' + substr(children[index], index = 1, -1)
						// \s
						case 32:
							return index === 1 ? '' : value
						default:
							switch (index) {
								case 0: element = value
									return sizeof(children) > 1 ? '' : value
								case index = sizeof(children) - 1: case 2:
									return index === 2 ? value + element + element : value + element
								default:
									return value
							}
					}
				})
			})
	}
}

;// CONCATENATED MODULE: ./node_modules/stylis/src/Parser.js




/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0
	var offset = 0
	var length = pseudo
	var atrule = 0
	var property = 0
	var previous = 0
	var variable = 1
	var scanning = 1
	var ampersand = 1
	var character = 0
	var type = ''
	var props = rules
	var children = rulesets
	var reference = rule
	var characters = type

	while (scanning)
		switch (previous = character, character = next()) {
			// (
			case 40:
				if (previous != 108 && Utility_charat(characters, length - 1) == 58) {
					if (indexof(characters += Utility_replace(delimit(character), '&', '&\f'), '&\f') != -1)
						ampersand = -1
					break
				}
			// " ' [
			case 34: case 39: case 91:
				characters += delimit(character)
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous)
				break
			// \
			case 92:
				characters += escaping(caret() - 1, 7)
				continue
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						Utility_append(comment(commenter(next(), caret()), root, parent), declarations)
						break
					default:
						characters += '/'
				}
				break
			// {
			case 123 * variable:
				points[index++] = Utility_strlen(characters) * ampersand
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0
					// ;
					case 59 + offset: if (ampersand == -1) characters = Utility_replace(characters, /\f/g, '')
						if (property > 0 && (Utility_strlen(characters) - length))
							Utility_append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(Utility_replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations)
						break
					// @ ;
					case 59: characters += ';'
					// { rule/at-rule
					default:
						Utility_append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets)

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children)
							else
								switch (atrule === 99 && Utility_charat(characters, 3) === 110 ? 100 : atrule) {
									// d l m s
									case 100: case 108: case 109: case 115:
										parse(value, reference, reference, rule && Utility_append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children)
										break
									default:
										parse(characters, reference, reference, reference, [''], children, 0, points, children)
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo
				break
			// :
			case 58:
				length = 1 + Utility_strlen(characters), property = previous
			default:
				if (variable < 1)
					if (character == 123)
						--variable
					else if (character == 125 && variable++ == 0 && prev() == 125)
						continue

				switch (characters += Utility_from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1)
						break
					// ,
					case 44:
						points[index++] = (Utility_strlen(characters) - 1) * ampersand, ampersand = 1
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next())

						atrule = peek(), offset = length = Utility_strlen(type = characters += identifier(caret())), character++
						break
					// -
					case 45:
						if (previous === 45 && Utility_strlen(characters) == 2)
							variable = 0
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1
	var rule = offset === 0 ? rules : ['']
	var size = Utility_sizeof(rule)

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = Utility_substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim(j > 0 ? rule[x] + ' ' + y : Utility_replace(y, /&\f/g, rule[x])))
				props[k++] = z

	return node(value, root, parent, offset === 0 ? Enum_RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, Utility_from(Tokenizer_char()), Utility_substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, Enum_DECLARATION, Utility_substr(value, 0, length), Utility_substr(value, length + 1, -1), length)
}

;// CONCATENATED MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js





var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
  var previous = 0;
  var character = 0;

  while (true) {
    previous = character;
    character = peek(); // &\f

    if (previous === 38 && character === 12) {
      points[index] = 1;
    }

    if (token(character)) {
      break;
    }

    next();
  }

  return slice(begin, position);
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifierWithPointTracking(position - 1, points, index);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += Utility_from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }

  var value = element.value;
  var parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

/* eslint-disable no-fallthrough */

function emotion_cache_browser_esm_prefix(value, length) {
  switch (hash(value, length)) {
    // color-adjust
    case 5103:
      return Enum_WEBKIT + 'print-' + value + value;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Enum_WEBKIT + value + value;
    // appearance, user-select, transform, hyphens, text-size-adjust

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Enum_WEBKIT + value + Enum_MOZ + value + Enum_MS + value + value;
    // flex, flex-direction

    case 6828:
    case 4268:
      return Enum_WEBKIT + value + Enum_MS + value + value;
    // order

    case 6165:
      return Enum_WEBKIT + value + Enum_MS + 'flex-' + value + value;
    // align-items

    case 5187:
      return Enum_WEBKIT + value + Utility_replace(value, /(\w+).+(:[^]+)/, Enum_WEBKIT + 'box-$1$2' + Enum_MS + 'flex-$1$2') + value;
    // align-self

    case 5443:
      return Enum_WEBKIT + value + Enum_MS + 'flex-item-' + Utility_replace(value, /flex-|-self/, '') + value;
    // align-content

    case 4675:
      return Enum_WEBKIT + value + Enum_MS + 'flex-line-pack' + Utility_replace(value, /align-content|flex-|-self/, '') + value;
    // flex-shrink

    case 5548:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'shrink', 'negative') + value;
    // flex-basis

    case 5292:
      return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'basis', 'preferred-size') + value;
    // flex-grow

    case 6060:
      return Enum_WEBKIT + 'box-' + Utility_replace(value, '-grow', '') + Enum_WEBKIT + value + Enum_MS + Utility_replace(value, 'grow', 'positive') + value;
    // transition

    case 4554:
      return Enum_WEBKIT + Utility_replace(value, /([^-])(transform)/g, '$1' + Enum_WEBKIT + '$2') + value;
    // cursor

    case 6187:
      return Utility_replace(Utility_replace(Utility_replace(value, /(zoom-|grab)/, Enum_WEBKIT + '$1'), /(image-set)/, Enum_WEBKIT + '$1'), value, '') + value;
    // background, background-image

    case 5495:
    case 3959:
      return Utility_replace(value, /(image-set\([^]*)/, Enum_WEBKIT + '$1' + '$`$1');
    // justify-content

    case 4968:
      return Utility_replace(Utility_replace(value, /(.+:)(flex-)?(.*)/, Enum_WEBKIT + 'box-pack:$3' + Enum_MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + Enum_WEBKIT + value + value;
    // (margin|padding)-inline-(start|end)

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Utility_replace(value, /(.+)-inline(.+)/, Enum_WEBKIT + '$1$2') + value;
    // (min|max)?(width|height|inline-size|block-size)

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      // stretch, max-content, min-content, fill-available
      if (Utility_strlen(value) - 1 - length > 6) switch (Utility_charat(value, length + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          // -
          if (Utility_charat(value, length + 4) !== 45) break;
        // (f)ill-available, (f)it-content

        case 102:
          return Utility_replace(value, /(.+:)(.+)-([^]+)/, '$1' + Enum_WEBKIT + '$2-$3' + '$1' + Enum_MOZ + (Utility_charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
        // (s)tretch

        case 115:
          return ~indexof(value, 'stretch') ? emotion_cache_browser_esm_prefix(Utility_replace(value, 'stretch', 'fill-available'), length) + value : value;
      }
      break;
    // position: sticky

    case 4949:
      // (s)ticky?
      if (Utility_charat(value, length + 1) !== 115) break;
    // display: (flex|inline-flex)

    case 6444:
      switch (Utility_charat(value, Utility_strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
        // stic(k)y
        case 107:
          return Utility_replace(value, ':', ':' + Enum_WEBKIT) + value;
        // (inline-)?fl(e)x

        case 101:
          return Utility_replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + Enum_WEBKIT + (Utility_charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + Enum_WEBKIT + '$2$3' + '$1' + Enum_MS + '$2box$3') + value;
      }

      break;
    // writing-mode

    case 5936:
      switch (Utility_charat(value, length + 11)) {
        // vertical-l(r)
        case 114:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
        // vertical-r(l)

        case 108:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
        // horizontal(-)tb

        case 45:
          return Enum_WEBKIT + value + Enum_MS + Utility_replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
      }

      return Enum_WEBKIT + value + Enum_MS + value + value;
  }

  return value;
}

var emotion_cache_browser_esm_prefixer = function prefixer(element, index, children, callback) {
  if (element.length > -1) if (!element["return"]) switch (element.type) {
    case Enum_DECLARATION:
      element["return"] = emotion_cache_browser_esm_prefix(element.value, element.length);
      break;

    case Enum_KEYFRAMES:
      return Serializer_serialize([Tokenizer_copy(element, {
        value: Utility_replace(element.value, '@', '@' + Enum_WEBKIT)
      })], callback);

    case Enum_RULESET:
      if (element.length) return Utility_combine(element.props, function (value) {
        switch (Utility_match(value, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ':read-only':
          case ':read-write':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(read-\w+)/, ':' + Enum_MOZ + '$1')]
            })], callback);
          // :placeholder

          case '::placeholder':
            return Serializer_serialize([Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_WEBKIT + 'input-$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, ':' + Enum_MOZ + '$1')]
            }), Tokenizer_copy(element, {
              props: [Utility_replace(value, /:(plac\w+)/, Enum_MS + 'input-$1')]
            })], callback);
        }

        return '';
      });
  }
};

var defaultStylisPlugins = [emotion_cache_browser_esm_prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }

      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {};
  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' ');

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return Serializer_serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend,
      insertionPoint: options.insertionPoint
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};




/***/ }),

/***/ 45042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}




/***/ }),

/***/ 87685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ CacheProvider; },
/* harmony export */   "E": function() { return /* binding */ Emotion$1; },
/* harmony export */   "T": function() { return /* binding */ ThemeContext; },
/* harmony export */   "c": function() { return /* binding */ createEmotionProps; },
/* harmony export */   "h": function() { return /* binding */ hasOwn; },
/* harmony export */   "w": function() { return /* binding */ withEmotionCache; }
/* harmony export */ });
/* unused harmony exports _, a, b, i, u */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48711);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70444);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85662);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27278);










var isDevelopment = false;

var EmotionCacheContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */(0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  key: 'css'
}) : null);

var CacheProvider = EmotionCacheContext.Provider;
var __unsafe_useEmotionCache = function useEmotionCache() {
  return useContext(EmotionCacheContext);
};

var withEmotionCache = function withEmotionCache(func) {
  return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (props, ref) {
    // the cache will never be null in the browser
    var cache = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

var ThemeContext = /* #__PURE__ */react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

var useTheme = function useTheme() {
  return React.useContext(ThemeContext);
};

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    return mergedTheme;
  }

  return _extends({}, outerTheme, theme);
};

var createCacheWithTheme = /* #__PURE__ */(/* unused pure expression or super */ null && (weakMemoize(function (outerTheme) {
  return weakMemoize(function (theme) {
    return getTheme(outerTheme, theme);
  });
})));
var ThemeProvider = function ThemeProvider(props) {
  var theme = React.useContext(ThemeContext);

  if (props.theme !== theme) {
    theme = createCacheWithTheme(theme)(props.theme);
  }

  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: theme
  }, props.children);
};
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';
  var WithTheme = /*#__PURE__*/React.forwardRef(function render(props, ref) {
    var theme = React.useContext(ThemeContext);
    return /*#__PURE__*/React.createElement(Component, _extends({
      theme: theme,
      ref: ref
    }, props));
  });
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return hoistNonReactStatics(WithTheme, Component);
}

var hasOwn = {}.hasOwnProperty;

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var createEmotionProps = function createEmotionProps(type, props) {

  var newProps = {};

  for (var _key in props) {
    if (hasOwn.call(props, _key)) {
      newProps[_key] = props[_key];
    }
  }

  newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

  return newProps;
};

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .registerStyles */ .hC)(cache, serialized, isStringTag);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_3__/* .useInsertionEffectAlwaysWithSyncFallback */ .L)(function () {
    return (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .insertStyles */ .My)(cache, serialized, isStringTag);
  });

  return null;
};

var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
  var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var WrappedComponent = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_4__/* .getRegisteredStyles */ .fp)(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(registeredStyles, undefined, react__WEBPACK_IMPORTED_MODULE_0__.useContext(ThemeContext));

  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var _key2 in props) {
    if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && (!isDevelopment )) {
      newProps[_key2] = props[_key2];
    }
  }

  newProps.className = className;

  if (ref) {
    newProps.ref = ref;
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Insertion, {
    cache: cache,
    serialized: serialized,
    isStringTag: typeof WrappedComponent === 'string'
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrappedComponent, newProps));
});

var Emotion$1 = Emotion;




/***/ }),

/***/ 70917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F4": function() { return /* binding */ keyframes; },
/* harmony export */   "iv": function() { return /* binding */ css; },
/* harmony export */   "xB": function() { return /* binding */ Global; }
/* harmony export */ });
/* unused harmony exports ClassNames, createElement, jsx */
/* harmony import */ var _emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87685);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70444);
/* harmony import */ var _emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27278);
/* harmony import */ var _emotion_serialize__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85662);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48711);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_4__);












var jsx = function jsx(type, props) {
  // eslint-disable-next-line prefer-rest-params
  var args = arguments;

  if (props == null || !_emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.h.call(props, 'css')) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(undefined, args);
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = _emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.E;
  createElementArgArray[1] = (0,_emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.c)(type, props);

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  }

  return react__WEBPACK_IMPORTED_MODULE_0__.createElement.apply(null, createElementArgArray);
};

(function (_jsx) {
  var JSX;

  (function (_JSX) {})(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
})(jsx || (jsx = {}));

// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */(0,_emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.w)(function (props, cache) {

  var styles = props.styles;
  var serialized = (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)([styles], undefined, react__WEBPACK_IMPORTED_MODULE_0__.useContext(_emotion_element_f0de968e_browser_esm_js__WEBPACK_IMPORTED_MODULE_5__.T));
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

    var sheet = new cache.sheet.constructor({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false;
    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  (0,_emotion_use_insertion_effect_with_fallbacks__WEBPACK_IMPORTED_MODULE_1__/* .useInsertionEffectWithLayoutFallback */ .j)(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      (0,_emotion_utils__WEBPACK_IMPORTED_MODULE_6__/* .insertStyles */ .My)(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return (0,_emotion_serialize__WEBPACK_IMPORTED_MODULE_2__/* .serializeStyles */ .O)(args);
}

function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name;
  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {

            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serializedArr = _ref.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function () {

    for (var i = 0; i < serializedArr.length; i++) {
      insertStyles(cache, serializedArr[i], false);
    }
  });

  return null;
};

var ClassNames = /* #__PURE__ */(/* unused pure expression or super */ null && (withEmotionCache(function (props, cache) {
  var hasRendered = false;
  var serializedArr = [];

  var css = function css() {
    if (hasRendered && isDevelopment) {
      throw new Error('css can only be used during render');
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serializeStyles(args, cache.registered);
    serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`

    registerStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var cx = function cx() {
    if (hasRendered && isDevelopment) {
      throw new Error('cx can only be used during render');
    }

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return merge(cache.registered, css, classnames(args));
  };

  var content = {
    css: css,
    cx: cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props.children(content);
  hasRendered = true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Insertion, {
    cache: cache,
    serializedArr: serializedArr
  }), ele);
})));




/***/ }),

/***/ 85662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ serializeStyles; }
});

;// CONCATENATED MODULE: ./node_modules/@emotion/hash/dist/emotion-hash.esm.js
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}



;// CONCATENATED MODULE: ./node_modules/@emotion/unitless/dist/emotion-unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};



// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js




var isDevelopment = false;

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

var noComponentSelectorMessage = 'Component selectors can only be used in conjunction with ' + '@emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware ' + 'compiler transform.';

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  var componentSelector = interpolation;

  if (componentSelector.__emotion_styles !== undefined) {

    return componentSelector;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        var keyframes = interpolation;

        if (keyframes.anim === 1) {
          cursor = {
            name: keyframes.name,
            styles: keyframes.styles,
            next: cursor
          };
          return keyframes.name;
        }

        var serializedStyles = interpolation;

        if (serializedStyles.styles !== undefined) {
          var next = serializedStyles.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = serializedStyles.styles + ";";
          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  var asString = interpolation;

  if (registered == null) {
    return asString;
  }

  var cached = registered[asString];
  return cached !== undefined ? cached : asString;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var key in obj) {
      var value = obj[key];

      if (typeof value !== 'object') {
        var asString = value;

        if (registered != null && registered[asString] !== undefined) {
          string += key + "{" + registered[asString] + "}";
        } else if (isProcessableValue(asString)) {
          string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && isDevelopment) {
          throw new Error(noComponentSelectorMessage);
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list

var cursor;
function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    var asTemplateStringsArr = strings;

    styles += asTemplateStringsArr[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      var templateStringsArr = strings;

      styles += templateStringsArr[i];
    }
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
}




/***/ }),

/***/ 27278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useInsertionEffectAlwaysWithSyncFallback; },
/* harmony export */   "j": function() { return /* binding */ useInsertionEffectWithLayoutFallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


var syncFallback = function syncFallback(create) {
  return create();
};

var useInsertionEffect = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] ? /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useInsertion' + 'Effect'] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;




/***/ }),

/***/ 70444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "My": function() { return /* binding */ insertStyles; },
/* harmony export */   "fp": function() { return /* binding */ getRegisteredStyles; },
/* harmony export */   "hC": function() { return /* binding */ registerStyles; }
/* harmony export */ });
var isBrowser = true;

function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else if (className) {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  registerStyles(cache, serialized, isStringTag);
  var className = cache.key + "-" + serialized.name;

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),

/***/ 6949:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ __webpack_exports__["Z"] = (blue);

/***/ }),

/***/ 16115:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ __webpack_exports__["Z"] = (common);

/***/ }),

/***/ 13486:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ __webpack_exports__["Z"] = (green);

/***/ }),

/***/ 47036:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["Z"] = (grey);

/***/ }),

/***/ 5621:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* harmony default export */ __webpack_exports__["Z"] = (lightBlue);

/***/ }),

/***/ 55137:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ __webpack_exports__["Z"] = (orange);

/***/ }),

/***/ 94518:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* harmony default export */ __webpack_exports__["Z"] = (purple);

/***/ }),

/***/ 60265:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ __webpack_exports__["Z"] = (red);

/***/ }),

/***/ 22233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ThemeProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3783);
/* harmony import */ var _identifier__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10606);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';



const _excluded = ["theme"];





function ThemeProvider(_ref) {
  let {
      theme: themeInput
    } = _ref,
    props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);
  const scopedTheme = themeInput[_identifier__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z];
  let finalTheme = scopedTheme || themeInput;
  if (typeof themeInput !== 'function') {
    if (scopedTheme && !scopedTheme.vars) {
      finalTheme = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, scopedTheme, {
        vars: null
      });
    } else if (themeInput && !themeInput.vars) {
      finalTheme = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, themeInput, {
        vars: null
      });
    }
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props, {
    themeId: scopedTheme ? _identifier__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z : undefined,
    theme: finalTheme
  }));
}
 false ? 0 : void 0;

/***/ }),

/***/ 15584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createMixins; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

function createMixins(breakpoints, mixins) {
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    toolbar: {
      minHeight: 56,
      [breakpoints.up('xs')]: {
        '@media (orientation: landscape)': {
          minHeight: 48
        }
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}

/***/ }),

/***/ 95839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ createMuiTheme; },
  "Z": function() { return /* binding */ styles_createTheme; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/formatMuiErrorMessage/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(56535);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge/deepmerge.js
var deepmerge = __webpack_require__(4953);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js + 5 modules
var defaultSxConfig = __webpack_require__(44920);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js + 1 modules
var createTheme = __webpack_require__(88647);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createMixins.js
var createMixins = __webpack_require__(15584);
// EXTERNAL MODULE: ./node_modules/@mui/system/colorManipulator.js
var colorManipulator = __webpack_require__(2101);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/common.js
var common = __webpack_require__(16115);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/grey.js
var grey = __webpack_require__(47036);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/purple.js
var purple = __webpack_require__(94518);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/red.js
var red = __webpack_require__(60265);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/orange.js
var orange = __webpack_require__(55137);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/blue.js
var blue = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/lightBlue.js
var lightBlue = __webpack_require__(5621);
// EXTERNAL MODULE: ./node_modules/@mui/material/colors/green.js
var green = __webpack_require__(13486);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createPalette.js



const _excluded = ["mode", "contrastThreshold", "tonalOffset"];










const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common/* default.white */.Z.white,
    default: common/* default.white */.Z.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common/* default.white */.Z.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: common/* default.white */.Z.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0,colorManipulator/* lighten */.$n)(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = (0,colorManipulator/* darken */._j)(intent.main, tonalOffsetDark);
    }
  }
}
function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: blue/* default.200 */.Z[200],
      light: blue/* default.50 */.Z[50],
      dark: blue/* default.400 */.Z[400]
    };
  }
  return {
    main: blue/* default.700 */.Z[700],
    light: blue/* default.400 */.Z[400],
    dark: blue/* default.800 */.Z[800]
  };
}
function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: purple/* default.200 */.Z[200],
      light: purple/* default.50 */.Z[50],
      dark: purple/* default.400 */.Z[400]
    };
  }
  return {
    main: purple/* default.500 */.Z[500],
    light: purple/* default.300 */.Z[300],
    dark: purple/* default.700 */.Z[700]
  };
}
function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: red/* default.500 */.Z[500],
      light: red/* default.300 */.Z[300],
      dark: red/* default.700 */.Z[700]
    };
  }
  return {
    main: red/* default.700 */.Z[700],
    light: red/* default.400 */.Z[400],
    dark: red/* default.800 */.Z[800]
  };
}
function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: lightBlue/* default.400 */.Z[400],
      light: lightBlue/* default.300 */.Z[300],
      dark: lightBlue/* default.700 */.Z[700]
    };
  }
  return {
    main: lightBlue/* default.700 */.Z[700],
    light: lightBlue/* default.500 */.Z[500],
    dark: lightBlue/* default.900 */.Z[900]
  };
}
function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: green/* default.400 */.Z[400],
      light: green/* default.300 */.Z[300],
      dark: green/* default.700 */.Z[700]
    };
  }
  return {
    main: green/* default.800 */.Z[800],
    light: green/* default.500 */.Z[500],
    dark: green/* default.900 */.Z[900]
  };
}
function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: orange/* default.400 */.Z[400],
      light: orange/* default.300 */.Z[300],
      dark: orange/* default.700 */.Z[700]
    };
  }
  return {
    main: '#ed6c02',
    // closest to orange[800] that pass 3:1.
    light: orange/* default.500 */.Z[500],
    dark: orange/* default.900 */.Z[900]
  };
}
function createPalette(palette) {
  const {
      mode = 'light',
      contrastThreshold = 3,
      tonalOffset = 0.2
    } = palette,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(palette, _excluded);
  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode);

  // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
  function getContrastText(background) {
    const contrastText = (0,colorManipulator/* getContrastRatio */.mi)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (false) {}
    return contrastText;
  }
  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = (0,esm_extends/* default */.Z)({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.hasOwnProperty('main')) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(11, name ? ` (${name})` : '', mainShade));
    }
    if (typeof color.main !== 'string') {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }
    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  const modes = {
    dark,
    light
  };
  if (false) {}
  const paletteOutput = (0,deepmerge/* default */.Z)((0,esm_extends/* default */.Z)({
    // A collection of common colors.
    common: (0,esm_extends/* default */.Z)({}, common/* default */.Z),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: grey/* default */.Z,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTypography.js
var createTypography = __webpack_require__(71445);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/shadows.js
const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;
function createShadow(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
}

// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTransitions.js
var createTransitions = __webpack_require__(96067);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/zIndex.js
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ var styles_zIndex = (zIndex);
;// CONCATENATED MODULE: ./node_modules/@mui/material/styles/createTheme.js



const createTheme_excluded = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];










function createTheme_createTheme(options = {}, ...args) {
  const {
      mixins: mixinsInput = {},
      palette: paletteInput = {},
      transitions: transitionsInput = {},
      typography: typographyInput = {}
    } = options,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, createTheme_excluded);
  if (options.vars &&
  // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  options.generateCssVars === undefined) {
    throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.Z)(18));
  }
  const palette = createPalette(paletteInput);
  const systemTheme = (0,createTheme/* default */.Z)(options);
  let muiTheme = (0,deepmerge/* default */.Z)(systemTheme, {
    mixins: (0,createMixins/* default */.Z)(systemTheme.breakpoints, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: styles_shadows.slice(),
    typography: (0,createTypography/* default */.Z)(palette, typographyInput),
    transitions: (0,createTransitions/* default */.ZP)(transitionsInput),
    zIndex: (0,esm_extends/* default */.Z)({}, styles_zIndex)
  });
  muiTheme = (0,deepmerge/* default */.Z)(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);
  if (false) {}
  muiTheme.unstable_sxConfig = (0,esm_extends/* default */.Z)({}, defaultSxConfig/* default */.Z, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0,styleFunctionSx/* default */.Z)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
let warnedOnce = false;
function createMuiTheme(...args) {
  if (false) {}
  return createTheme_createTheme(...args);
}
/* harmony default export */ var styles_createTheme = (createTheme_createTheme);

/***/ }),

/***/ 96067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ui": function() { return /* binding */ easing; },
/* harmony export */   "ZP": function() { return /* binding */ createTransitions; },
/* harmony export */   "x9": function() { return /* binding */ duration; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


const _excluded = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};

// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}
function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }
  const constant = height / 36;

  // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function createTransitions(inputTransitions) {
  const mergedEasing = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, easing, inputTransitions.easing);
  const mergedDuration = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, duration, inputTransitions.duration);
  const create = (props = ['all'], options = {}) => {
    const {
        duration: durationOption = mergedDuration.standard,
        easing: easingOption = mergedEasing.easeInOut,
        delay = 0
      } = options,
      other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(options, _excluded);
    if (false) {}
    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

/***/ }),

/***/ 71445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createTypography; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63366);
/* harmony import */ var _mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4953);


const _excluded = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';

/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */
function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
    {
      fontFamily = defaultFontFamily,
      // The default font size of the Material Specification.
      fontSize = 14,
      // px
      fontWeightLight = 300,
      fontWeightRegular = 400,
      fontWeightMedium = 500,
      fontWeightBold = 700,
      // Tell MUI what's the font-size on the html element.
      // 16px is the default font-size used by browsers.
      htmlFontSize = 16,
      // Apply the CSS properties to all the variants.
      allVariants,
      pxToRem: pxToRem2
    } = _ref,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref, _excluded);
  if (false) {}
  const coef = fontSize / 14;
  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);
  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily ? {
    letterSpacing: `${round(letterSpacing / size)}em`
  } : {}, casing, allVariants);
  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: 'inherit',
      fontWeight: 'inherit',
      fontSize: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit'
    }
  };
  return (0,_mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep
  });
}

/***/ }),

/***/ 90247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95839);
'use client';


const defaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = (defaultTheme);

/***/ }),

/***/ 10606:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ('$$material');

/***/ }),

/***/ 71657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_system_useThemeProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29628);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90247);
/* harmony import */ var _identifier__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10606);
'use client';




function useThemeProps({
  props,
  name
}) {
  return (0,_mui_system_useThemeProps__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    props,
    name,
    defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    themeId: _identifier__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
  });
}

/***/ }),

/***/ 44819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (ThemeContext);

/***/ }),

/***/ 56760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44819);


function useTheme() {
  const theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
  if (false) {}
  return theme;
}

/***/ }),

/***/ 41234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GlobalStyles; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';





function isEmpty(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function GlobalStyles(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .Global */ .xB, {
    styles: globalStyles
  });
}
 false ? 0 : void 0;

/***/ }),

/***/ 94810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StyledEngineProvider; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87685);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48711);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
'use client';






// prepend: true moves MUI styles to the top of the <head> so they're loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.

function getCache(injectFirst, enableCssLayer) {
  const emotionCache = (0,_emotion_cache__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    key: 'css',
    prepend: injectFirst
  });
  if (enableCssLayer) {
    const prevInsert = emotionCache.insert;
    emotionCache.insert = (...args) => {
      if (!args[1].styles.match(/^@layer\s+[^{]*$/)) {
        // avoid nested @layer
        args[1].styles = `@layer mui {${args[1].styles}}`;
      }
      return prevInsert(...args);
    };
  }
  return emotionCache;
}
const cacheMap = new Map();
function StyledEngineProvider(props) {
  const {
    injectFirst,
    enableCssLayer,
    children
  } = props;
  const cache = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    const cacheKey = `${injectFirst}-${enableCssLayer}`;
    if (typeof document === 'object' && cacheMap.has(cacheKey)) {
      return cacheMap.get(cacheKey);
    }
    const fresh = getCache(injectFirst, enableCssLayer);
    cacheMap.set(cacheKey, fresh);
    return fresh;
  }, [injectFirst, enableCssLayer]);
  if (injectFirst || enableCssLayer) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_emotion_react__WEBPACK_IMPORTED_MODULE_3__.C, {
      value: cache,
      children: children
    });
  }
  return children;
}
 false ? 0 : void 0;

/***/ }),

/***/ 49731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GlobalStyles": function() { return /* reexport */ GlobalStyles/* default */.Z; },
  "StyledEngineProvider": function() { return /* reexport */ StyledEngineProvider/* default */.Z; },
  "ThemeContext": function() { return /* reexport */ emotion_element_f0de968e_browser_esm.T; },
  "css": function() { return /* reexport */ emotion_react_browser_esm/* css */.iv; },
  "default": function() { return /* binding */ styled; },
  "internal_processStyles": function() { return /* binding */ internal_processStyles; },
  "internal_serializeStyles": function() { return /* binding */ internal_serializeStyles; },
  "keyframes": function() { return /* reexport */ emotion_react_browser_esm/* keyframes */.F4; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
var emotion_memoize_esm = __webpack_require__(45042);
;// CONCATENATED MODULE: ./node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */(0,emotion_memoize_esm/* default */.Z)(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js
var emotion_element_f0de968e_browser_esm = __webpack_require__(87685);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(85662);
// EXTERNAL MODULE: ./node_modules/@emotion/use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js
var emotion_use_insertion_effect_with_fallbacks_browser_esm = __webpack_require__(27278);
;// CONCATENATED MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js








var testOmitPropsOnStringTag = isPropValid;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Insertion = function Insertion(_ref) {
  var cache = _ref.cache,
      serialized = _ref.serialized,
      isStringTag = _ref.isStringTag;
  (0,emotion_utils_browser_esm/* registerStyles */.hC)(cache, serialized, isStringTag);
  var rules = (0,emotion_use_insertion_effect_with_fallbacks_browser_esm/* useInsertionEffectAlwaysWithSyncFallback */.L)(function () {
    return (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, isStringTag);
  });

  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {}

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {}

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {}

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = (0,emotion_element_f0de968e_browser_esm.w)(function (props, cache, ref) {
      var FinalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = (0,react.useContext)(emotion_element_f0de968e_browser_esm.T);
      }

      if (typeof props.className === 'string') {
        className = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(styles.concat(classInterpolations), cache.registered, mergedProps);
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      return /*#__PURE__*/(0,react.createElement)(react.Fragment, null, /*#__PURE__*/(0,react.createElement)(Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof FinalTag === 'string'
      }), /*#__PURE__*/(0,react.createElement)(FinalTag, newProps));
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, (0,esm_extends/* default */.Z)({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ var emotion_styled_base_browser_esm = (createStyled);

;// CONCATENATED MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js









var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = emotion_styled_base_browser_esm.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ var emotion_styled_browser_esm = (newStyled);

// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/StyledEngineProvider/StyledEngineProvider.js
var StyledEngineProvider = __webpack_require__(94810);
// EXTERNAL MODULE: ./node_modules/@mui/styled-engine/GlobalStyles/GlobalStyles.js
var GlobalStyles = __webpack_require__(41234);
;// CONCATENATED MODULE: ./node_modules/@mui/styled-engine/index.js
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use client';

/* eslint-disable no-underscore-dangle */


function styled(tag, options) {
  const stylesFactory = emotion_styled_browser_esm(tag, options);
  if (false) {}
  return stylesFactory;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const internal_processStyles = (tag, processor) => {
  // Emotion attaches all the styles as `__emotion_styles`.
  // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
  if (Array.isArray(tag.__emotion_styles)) {
    tag.__emotion_styles = processor(tag.__emotion_styles);
  }
};

// Emotion only accepts an array, but we want to avoid allocations
const wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function internal_serializeStyles(styles) {
  wrapper[0] = styles;
  return (0,emotion_serialize_esm/* serializeStyles */.O)(wrapper);
}




/***/ }),

/***/ 2101:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Fq = alpha;
__webpack_unused_export__ = blend;
__webpack_unused_export__ = void 0;
exports._j = darken;
__webpack_unused_export__ = decomposeColor;
exports._4 = emphasize;
exports.mi = getContrastRatio;
__webpack_unused_export__ = getLuminance;
__webpack_unused_export__ = hexToRgb;
exports.ve = hslToRgb;
exports.$n = lighten;
exports.zp = private_safeAlpha;
exports.LR = void 0;
exports.q8 = private_safeDarken;
exports.fk = private_safeEmphasize;
exports.ux = private_safeLighten;
__webpack_unused_export__ = recomposeColor;
__webpack_unused_export__ = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault(__webpack_require__(55480));
var _clamp = _interopRequireDefault(__webpack_require__(14800));
/* eslint-disable @typescript-eslint/naming-convention */

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clampWrapper(value, min = 0, max = 1) {
  if (false) {}
  return (0, _clamp.default)(value, min, max);
}

/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
  color = color.slice(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }
  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }
  const marker = color.indexOf('(');
  const type = color.substring(0, marker);
  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0, _formatMuiErrorMessage2.default)(9, color));
  }
  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;
  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();
    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].slice(1);
    }
    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error( false ? 0 : (0, _formatMuiErrorMessage2.default)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }
  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}

/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */
const colorChannel = color => {
  const decomposedColor = decomposeColor(color);
  return decomposedColor.values.slice(0, 3).map((val, idx) => decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
__webpack_unused_export__ = colorChannel;
const private_safeColorChannel = (color, warning) => {
  try {
    return colorChannel(color);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
};

/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
exports.LR = private_safeColorChannel;
function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;
  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }
  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }
  return `${type}(${values})`;
}

/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }
  const {
    values
  } = decomposeColor(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}

/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */
function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */
function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' || color.type === 'hsla' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }
    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  });

  // Truncate at 3 digits
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}

/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */
function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}

/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function alpha(color, value) {
  color = decomposeColor(color);
  value = clampWrapper(value);
  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }
  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }
  return recomposeColor(color);
}
function private_safeAlpha(color, value, warning) {
  try {
    return alpha(color, value);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeDarken(color, coefficient, warning) {
  try {
    return darken(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clampWrapper(coefficient);
  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}
function private_safeLighten(color, coefficient, warning) {
  try {
    return lighten(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function emphasize(color, coefficient = 0.15) {
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
function private_safeEmphasize(color, coefficient, warning) {
  try {
    return emphasize(color, coefficient);
  } catch (error) {
    if (warning && "production" !== 'production') {}
    return color;
  }
}

/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */
function blend(background, overlay, opacity, gamma = 1.0) {
  const blendChannel = (b, o) => Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
  const backgroundColor = decomposeColor(background);
  const overlayColor = decomposeColor(overlay);
  const rgb = [blendChannel(backgroundColor.values[0], overlayColor.values[0]), blendChannel(backgroundColor.values[1], overlayColor.values[1]), blendChannel(backgroundColor.values[2], overlayColor.values[2])];
  return recomposeColor({
    type: 'rgb',
    values: rgb
  });
}

/***/ }),

/***/ 32842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useDefaultProps; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35971);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';





const PropsContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
function DefaultPropsProvider({
  value,
  children
}) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PropsContext.Provider, {
    value: value,
    children: children
  });
}
 false ? 0 : void 0;
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name]) {
    return props;
  }
  const config = theme.components[name];
  if (config.defaultProps) {
    // compatible with v5 signature
    return (0,_mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(config.defaultProps, props);
  }
  if (!config.styleOverrides && !config.variants) {
    // v6 signature, no property 'defaultProps'
    return (0,_mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(config, props);
  }
  return props;
}
function useDefaultProps({
  props,
  name
}) {
  const ctx = react__WEBPACK_IMPORTED_MODULE_0__.useContext(PropsContext);
  return getThemeProps({
    props,
    name,
    theme: {
      components: ctx
    }
  });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultPropsProvider);

/***/ }),

/***/ 25723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49731);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41234);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96682);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
'use client';






function wrapGlobalLayer(styles) {
  const serialized = (0,_mui_styled_engine__WEBPACK_IMPORTED_MODULE_2__.internal_serializeStyles)(styles);
  if (styles !== serialized && serialized.styles) {
    if (!serialized.styles.match(/^@layer\s+[^{]*$/)) {
      // If the styles are not already wrapped in a layer, wrap them in a global layer.
      serialized.styles = `@layer global{${serialized.styles}}`;
    }
    return serialized;
  }
  return styles;
}
function GlobalStyles({
  styles,
  themeId,
  defaultTheme = {}
}) {
  const upperTheme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(defaultTheme);
  const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
  let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
  if (resolvedTheme.modularCssLayers) {
    if (Array.isArray(globalStyles)) {
      globalStyles = globalStyles.map(styleArg => {
        if (typeof styleArg === 'function') {
          return wrapGlobalLayer(styleArg(resolvedTheme));
        }
        return wrapGlobalLayer(styleArg);
      });
    } else {
      globalStyles = wrapGlobalLayer(globalStyles);
    }
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_styled_engine__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    styles: globalStyles
  });
}
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (GlobalStyles);

/***/ }),

/***/ 82056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useRtl; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["value"];



const RtlContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext();
function RtlProvider(_ref) {
  let {
      value
    } = _ref,
    props = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RtlContext.Provider, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    value: value != null ? value : true
  }, props));
}
 false ? 0 : void 0;
const useRtl = () => {
  const value = react__WEBPACK_IMPORTED_MODULE_0__.useContext(RtlContext);
  return value != null ? value : false;
};
/* harmony default export */ __webpack_exports__["Z"] = (RtlProvider);

/***/ }),

/***/ 3783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_ThemeProvider_ThemeProvider; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/private-theming/useTheme/useTheme.js
var useTheme = __webpack_require__(56760);
// EXTERNAL MODULE: ./node_modules/@mui/private-theming/useTheme/ThemeContext.js
var ThemeContext = __webpack_require__(44819);
;// CONCATENATED MODULE: ./node_modules/@mui/private-theming/ThemeProvider/nested.js
const hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ var nested = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/private-theming/ThemeProvider/ThemeProvider.js








// To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);
    if (false) {}
    return mergedTheme;
  }
  return (0,esm_extends/* default */.Z)({}, outerTheme, localTheme);
}

/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */
function ThemeProvider(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = (0,useTheme/* default */.Z)();
  if (false) {}
  const theme = react.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[nested] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ThemeContext/* default.Provider */.Z.Provider, {
    value: theme,
    children: children
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ var ThemeProvider_ThemeProvider = (ThemeProvider);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js
var emotion_element_f0de968e_browser_esm = __webpack_require__(87685);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useThemeWithoutDefault.js
var useThemeWithoutDefault = __webpack_require__(34168);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/RtlProvider/index.js
var RtlProvider = __webpack_require__(82056);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/DefaultPropsProvider/DefaultPropsProvider.js
var DefaultPropsProvider = __webpack_require__(32842);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useEnhancedEffect/useEnhancedEffect.js
var useEnhancedEffect = __webpack_require__(73546);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/useId/useId.js
var useId = __webpack_require__(92996);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/GlobalStyles/GlobalStyles.js
var GlobalStyles = __webpack_require__(25723);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/ThemeProvider/useLayerOrder.js
'use client';







/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */

function useLayerOrder(theme) {
  const upperTheme = (0,useThemeWithoutDefault/* default */.Z)();
  const id = (0,useId/* default */.Z)() || '';
  const {
    modularCssLayers
  } = theme;
  let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
  if (!modularCssLayers || upperTheme !== null) {
    // skip this hook if upper theme exists.
    layerOrder = '';
  } else if (typeof modularCssLayers === 'string') {
    layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
  } else {
    layerOrder = `@layer ${layerOrder};`;
  }
  (0,useEnhancedEffect/* default */.Z)(() => {
    const head = document.querySelector('head');
    if (!head) {
      return;
    }
    const firstChild = head.firstChild;
    if (layerOrder) {
      var _firstChild$hasAttrib;
      // Only insert if first child doesn't have data-mui-layer-order attribute
      if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) {
        return;
      }
      const styleElement = document.createElement('style');
      styleElement.setAttribute('data-mui-layer-order', id);
      styleElement.textContent = layerOrder;
      head.prepend(styleElement);
    } else {
      var _head$querySelector;
      (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
    }
  }, [layerOrder, id]);
  if (!layerOrder) {
    return null;
  }
  return /*#__PURE__*/(0,jsx_runtime.jsx)(GlobalStyles/* default */.Z, {
    styles: layerOrder
  });
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/ThemeProvider/ThemeProvider.js
'use client';













const EMPTY_THEME = {};
function useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
  return react.useMemo(() => {
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    if (typeof localTheme === 'function') {
      const mergedTheme = localTheme(resolvedTheme);
      const result = themeId ? (0,esm_extends/* default */.Z)({}, upperTheme, {
        [themeId]: mergedTheme
      }) : mergedTheme;
      // must return a function for the private theme to NOT merge with the upper theme.
      // see the test case "use provided theme from a callback" in ThemeProvider.test.js
      if (isPrivate) {
        return () => result;
      }
      return result;
    }
    return themeId ? (0,esm_extends/* default */.Z)({}, upperTheme, {
      [themeId]: localTheme
    }) : (0,esm_extends/* default */.Z)({}, upperTheme, localTheme);
  }, [themeId, upperTheme, localTheme, isPrivate]);
}

/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */
function ThemeProvider_ThemeProvider_ThemeProvider(props) {
  const {
    children,
    theme: localTheme,
    themeId
  } = props;
  const upperTheme = (0,useThemeWithoutDefault/* default */.Z)(EMPTY_THEME);
  const upperPrivateTheme = (0,useTheme/* default */.Z)() || EMPTY_THEME;
  if (false) {}
  const engineTheme = useThemeScoping(themeId, upperTheme, localTheme);
  const privateTheme = useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
  const rtlValue = engineTheme.direction === 'rtl';
  const layerOrder = useLayerOrder(engineTheme);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ThemeProvider_ThemeProvider, {
    theme: privateTheme,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(emotion_element_f0de968e_browser_esm.T.Provider, {
      value: engineTheme,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RtlProvider/* default */.Z, {
        value: rtlValue,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DefaultPropsProvider/* default */.Z, {
          value: engineTheme == null ? void 0 : engineTheme.components,
          children: [layerOrder, children]
        })
      })
    })
  });
}
 false ? 0 : void 0;
if (false) {}
/* harmony default export */ var esm_ThemeProvider_ThemeProvider = (ThemeProvider_ThemeProvider_ThemeProvider);

/***/ }),

/***/ 95408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L7": function() { return /* binding */ removeUnusedBreakpoints; },
/* harmony export */   "P$": function() { return /* binding */ resolveBreakpointValues; },
/* harmony export */   "VO": function() { return /* binding */ values; },
/* harmony export */   "W8": function() { return /* binding */ createEmptyBreakpointObject; },
/* harmony export */   "dt": function() { return /* binding */ mergeBreakpointsInOrder; },
/* harmony export */   "k9": function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* unused harmony export computeBreakpointsBase */
/* harmony import */ var _mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4953);





// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
const values = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screen
};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};
  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }
      return acc;
    }, {});
  }
  const output = styleFromPropValue(propValue);
  return output;
}
function breakpoints(styleFunction) {
  // false positive
  // eslint-disable-next-line react/function-component-definition
  const newStyleFunction = props => {
    const theme = props.theme || {};
    const base = styleFunction(props);
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    const extended = themeBreakpoints.keys.reduce((acc, key) => {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme
        }, props[key]));
      }
      return acc;
    }, null);
    return merge(base, extended);
  };
  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl', ...styleFunction.filterProps];
  return newStyleFunction;
}
function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;
  const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
    if (isBreakpointUnused) {
      delete acc[key];
    }
    return acc;
  }, style);
}
function mergeBreakpointsInOrder(breakpointsInput, ...styles) {
  const emptyBreakpoints = createEmptyBreakpointObject(breakpointsInput);
  const mergedOutput = [emptyBreakpoints, ...styles].reduce((prev, next) => (0,_mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(prev, next), {});
  return removeUnusedBreakpoints(Object.keys(emptyBreakpoints), mergedOutput);
}

// compute base for responsive values; e.g.,
// [1,2,3] => {xs: true, sm: true, md: true}
// {xs: 1, sm: 2, md: 3} => {xs: true, sm: true, md: true}
function computeBreakpointsBase(breakpointValues, themeBreakpoints) {
  // fixed value
  if (typeof breakpointValues !== 'object') {
    return {};
  }
  const base = {};
  const breakpointsKeys = Object.keys(themeBreakpoints);
  if (Array.isArray(breakpointValues)) {
    breakpointsKeys.forEach((breakpoint, i) => {
      if (i < breakpointValues.length) {
        base[breakpoint] = true;
      }
    });
  } else {
    breakpointsKeys.forEach(breakpoint => {
      if (breakpointValues[breakpoint] != null) {
        base[breakpoint] = true;
      }
    });
  }
  return base;
}
function resolveBreakpointValues({
  values: breakpointValues,
  breakpoints: themeBreakpoints,
  base: customBase
}) {
  const base = customBase || computeBreakpointsBase(breakpointValues, themeBreakpoints);
  const keys = Object.keys(base);
  if (keys.length === 0) {
    return breakpointValues;
  }
  let previous;
  return keys.reduce((acc, breakpoint, i) => {
    if (Array.isArray(breakpointValues)) {
      acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
      previous = i;
    } else if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
      previous = breakpoint;
    } else {
      acc[breakpoint] = breakpointValues;
    }
    return acc;
  }, {});
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));

/***/ }),

/***/ 57064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ applyStyles; }
/* harmony export */ });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */
function applyStyles(key, styles) {
  // @ts-expect-error this is 'any' type
  const theme = this;
  if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
    // If CssVarsProvider is used as a provider,
    // returns '* :where([data-mui-color-scheme="light|dark"]) &'
    const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
    return {
      [selector]: styles
    };
  }
  if (theme.palette.mode === key) {
    return styles;
  }
  return {};
}

/***/ }),

/***/ 41512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createBreakpoints; }
/* harmony export */ });
/* unused harmony export breakpointKeys */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);


const _excluded = ["values", "unit", "step"];
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const breakpointKeys = (/* unused pure expression or super */ null && (['xs', 'sm', 'md', 'lg', 'xl']));
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },
      unit = 'px',
      step = 5
    } = breakpoints,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(breakpoints, _excluded);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

/***/ }),

/***/ 98373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createSpacing; }
/* harmony export */ });
/* harmony import */ var _spacing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98700);


// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.

function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  }

  // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://m2.material.io/design/layout/understanding-layout.html
  const transform = (0,_spacing__WEBPACK_IMPORTED_MODULE_0__/* .createUnarySpacing */ .hB)({
    spacing: spacingInput
  });
  const spacing = (...argsInput) => {
    if (false) {}
    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };
  spacing.mui = true;
  return spacing;
}

/***/ }),

/***/ 88647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createTheme_createTheme; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/deepmerge/deepmerge.js
var deepmerge = __webpack_require__(4953);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createBreakpoints.js
var createBreakpoints = __webpack_require__(41512);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/shape.js
const shape = {
  borderRadius: 4
};
/* harmony default export */ var createTheme_shape = (shape);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/createSpacing.js
var createSpacing = __webpack_require__(98373);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
var styleFunctionSx = __webpack_require__(86523);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js + 5 modules
var defaultSxConfig = __webpack_require__(44920);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/createTheme/applyStyles.js
var applyStyles = __webpack_require__(57064);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/createTheme/createTheme.js


const _excluded = ["breakpoints", "palette", "spacing", "shape"];







function createTheme(options = {}, ...args) {
  const {
      breakpoints: breakpointsInput = {},
      palette: paletteInput = {},
      spacing: spacingInput,
      shape: shapeInput = {}
    } = options,
    other = (0,objectWithoutPropertiesLoose/* default */.Z)(options, _excluded);
  const breakpoints = (0,createBreakpoints/* default */.Z)(breakpointsInput);
  const spacing = (0,createSpacing/* default */.Z)(spacingInput);
  let muiTheme = (0,deepmerge/* default */.Z)({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: (0,esm_extends/* default */.Z)({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: (0,esm_extends/* default */.Z)({}, createTheme_shape, shapeInput)
  }, other);
  muiTheme.applyStyles = applyStyles/* default */.Z;
  muiTheme = args.reduce((acc, argument) => (0,deepmerge/* default */.Z)(acc, argument), muiTheme);
  muiTheme.unstable_sxConfig = (0,esm_extends/* default */.Z)({}, defaultSxConfig/* default */.Z, other == null ? void 0 : other.unstable_sxConfig);
  muiTheme.unstable_sx = function sx(props) {
    return (0,styleFunctionSx/* default */.Z)({
      sx: props,
      theme: this
    });
  };
  return muiTheme;
}
/* harmony default export */ var createTheme_createTheme = (createTheme);

/***/ }),

/***/ 47730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4953);

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return (0,_mui_utils_deepmerge__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(acc, item, {
    clone: false // No need to clone deep, it's way faster.
  });
}
/* harmony default export */ __webpack_exports__["Z"] = (merge);

/***/ }),

/***/ 98700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hB": function() { return /* binding */ createUnarySpacing; },
  "eI": function() { return /* binding */ createUnaryUnit; },
  "NA": function() { return /* binding */ getValue; },
  "e6": function() { return /* binding */ margin; },
  "o3": function() { return /* binding */ padding; }
});

// UNUSED EXPORTS: default, getStyleFromPropValue, marginKeys, paddingKeys

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(95408);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(47730);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/memoize.js
function memoize(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/spacing.js





const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
};

// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const getCssProperties = memoize(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  var _getPath;
  const themeSpacing = (_getPath = (0,style/* getPath */.DW)(theme, themeKey, false)) != null ? _getPath : defaultValue;
  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (false) {}
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }
      if (false) {}
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }
  if (false) {}
  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }
  const abs = Math.abs(propValue);
  const transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === 'number') {
    return -transformed;
  }
  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue(transformer, propValue);
    return acc;
  }, {});
}
function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }
  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return (0,breakpoints/* handleBreakpoints */.k9)(props, propValue, styleFromPropValue);
}
function spacing_style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge/* default */.Z, {});
}
function margin(props) {
  return spacing_style(props, marginKeys);
}
margin.propTypes =  false ? 0 : {};
margin.filterProps = marginKeys;
function padding(props) {
  return spacing_style(props, paddingKeys);
}
padding.propTypes =  false ? 0 : {};
padding.filterProps = paddingKeys;
function spacing(props) {
  return spacing_style(props, spacingKeys);
}
spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = ((/* unused pure expression or super */ null && (spacing)));

/***/ }),

/***/ 54844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DW": function() { return /* binding */ getPath; },
/* harmony export */   "Jq": function() { return /* binding */ getStyleValue; }
/* harmony export */ });
/* harmony import */ var _mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14142);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95408);



function getPath(obj, path, checkVars = true) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  // Check if CSS variables are used
  if (obj && obj.vars && checkVars) {
    const val = `vars.${path}`.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
    if (val != null) {
      return val;
    }
  }
  return path.split('.').reduce((acc, item) => {
    if (acc && acc[item] != null) {
      return acc[item];
    }
    return null;
  }, obj);
}
function getStyleValue(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;
  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }
  if (transform) {
    value = transform(value, userValue, themeMapping);
  }
  return value;
}
function style(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    if (props[prop] == null) {
      return null;
    }
    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};
    const styleFromPropValue = propValueFinal => {
      let value = getStyleValue(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getStyleValue(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .handleBreakpoints */ .k9)(props, propValue, styleFromPropValue);
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = [prop];
  return fn;
}
/* harmony default export */ __webpack_exports__["ZP"] = (style);

/***/ }),

/***/ 44920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ styleFunctionSx_defaultSxConfig; }
});

// EXTERNAL MODULE: ./node_modules/@mui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(98700);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/style.js
var style = __webpack_require__(54844);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/merge.js
var merge = __webpack_require__(47730);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/compose.js

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  // false positive
  // eslint-disable-next-line react/function-component-definition
  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return (0,merge/* default */.Z)(acc, handlers[prop](props));
      }
      return acc;
    }, {});
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}
/* harmony default export */ var esm_compose = (compose);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(95408);
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/borders.js





function borderTransform(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return `${value}px solid`;
}
function createBorderStyle(prop, transform) {
  return (0,style/* default */.ZP)({
    prop,
    themeKey: 'borders',
    transform
  });
}
const border = createBorderStyle('border', borderTransform);
const borderTop = createBorderStyle('borderTop', borderTransform);
const borderRight = createBorderStyle('borderRight', borderTransform);
const borderBottom = createBorderStyle('borderBottom', borderTransform);
const borderLeft = createBorderStyle('borderLeft', borderTransform);
const borderColor = createBorderStyle('borderColor');
const borderTopColor = createBorderStyle('borderTopColor');
const borderRightColor = createBorderStyle('borderRightColor');
const borderBottomColor = createBorderStyle('borderBottomColor');
const borderLeftColor = createBorderStyle('borderLeftColor');
const outline = createBorderStyle('outline', borderTransform);
const outlineColor = createBorderStyle('outlineColor');

// false positive
// eslint-disable-next-line react/function-component-definition
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
    const styleFromPropValue = propValue => ({
      borderRadius: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.borderRadius, styleFromPropValue);
  }
  return null;
};
borderRadius.propTypes =  false ? 0 : {};
borderRadius.filterProps = ['borderRadius'];
const borders = esm_compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
/* harmony default export */ var esm_borders = ((/* unused pure expression or super */ null && (borders)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/cssGrid.js






// false positive
// eslint-disable-next-line react/function-component-definition
const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'gap');
    const styleFromPropValue = propValue => ({
      gap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.gap, styleFromPropValue);
  }
  return null;
};
gap.propTypes =  false ? 0 : {};
gap.filterProps = ['gap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'columnGap');
    const styleFromPropValue = propValue => ({
      columnGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.columnGap, styleFromPropValue);
  }
  return null;
};
columnGap.propTypes =  false ? 0 : {};
columnGap.filterProps = ['columnGap'];

// false positive
// eslint-disable-next-line react/function-component-definition
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = (0,spacing/* createUnaryUnit */.eI)(props.theme, 'spacing', 8, 'rowGap');
    const styleFromPropValue = propValue => ({
      rowGap: (0,spacing/* getValue */.NA)(transformer, propValue)
    });
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.rowGap, styleFromPropValue);
  }
  return null;
};
rowGap.propTypes =  false ? 0 : {};
rowGap.filterProps = ['rowGap'];
const gridColumn = (0,style/* default */.ZP)({
  prop: 'gridColumn'
});
const gridRow = (0,style/* default */.ZP)({
  prop: 'gridRow'
});
const gridAutoFlow = (0,style/* default */.ZP)({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = (0,style/* default */.ZP)({
  prop: 'gridAutoColumns'
});
const gridAutoRows = (0,style/* default */.ZP)({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = (0,style/* default */.ZP)({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = (0,style/* default */.ZP)({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = (0,style/* default */.ZP)({
  prop: 'gridTemplateAreas'
});
const gridArea = (0,style/* default */.ZP)({
  prop: 'gridArea'
});
const grid = esm_compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ var cssGrid = ((/* unused pure expression or super */ null && (grid)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/palette.js


function paletteTransform(value, userValue) {
  if (userValue === 'grey') {
    return userValue;
  }
  return value;
}
const color = (0,style/* default */.ZP)({
  prop: 'color',
  themeKey: 'palette',
  transform: paletteTransform
});
const bgcolor = (0,style/* default */.ZP)({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const backgroundColor = (0,style/* default */.ZP)({
  prop: 'backgroundColor',
  themeKey: 'palette',
  transform: paletteTransform
});
const palette = esm_compose(color, bgcolor, backgroundColor);
/* harmony default export */ var esm_palette = ((/* unused pure expression or super */ null && (palette)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/sizing.js



function sizingTransform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const width = (0,style/* default */.ZP)({
  prop: 'width',
  transform: sizingTransform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme2;
      const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || breakpoints/* values */.VO[propValue];
      if (!breakpoint) {
        return {
          maxWidth: sizingTransform(propValue)
        };
      }
      if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') {
        return {
          maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
        };
      }
      return {
        maxWidth: breakpoint
      };
    };
    return (0,breakpoints/* handleBreakpoints */.k9)(props, props.maxWidth, styleFromPropValue);
  }
  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = (0,style/* default */.ZP)({
  prop: 'minWidth',
  transform: sizingTransform
});
const height = (0,style/* default */.ZP)({
  prop: 'height',
  transform: sizingTransform
});
const maxHeight = (0,style/* default */.ZP)({
  prop: 'maxHeight',
  transform: sizingTransform
});
const minHeight = (0,style/* default */.ZP)({
  prop: 'minHeight',
  transform: sizingTransform
});
const sizeWidth = (0,style/* default */.ZP)({
  prop: 'size',
  cssProperty: 'width',
  transform: sizingTransform
});
const sizeHeight = (0,style/* default */.ZP)({
  prop: 'size',
  cssProperty: 'height',
  transform: sizingTransform
});
const boxSizing = (0,style/* default */.ZP)({
  prop: 'boxSizing'
});
const sizing = esm_compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ var esm_sizing = ((/* unused pure expression or super */ null && (sizing)));
;// CONCATENATED MODULE: ./node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js





const defaultSxConfig = {
  // borders
  border: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderTop: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderRight: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderBottom: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderLeft: {
    themeKey: 'borders',
    transform: borderTransform
  },
  borderColor: {
    themeKey: 'palette'
  },
  borderTopColor: {
    themeKey: 'palette'
  },
  borderRightColor: {
    themeKey: 'palette'
  },
  borderBottomColor: {
    themeKey: 'palette'
  },
  borderLeftColor: {
    themeKey: 'palette'
  },
  outline: {
    themeKey: 'borders',
    transform: borderTransform
  },
  outlineColor: {
    themeKey: 'palette'
  },
  borderRadius: {
    themeKey: 'shape.borderRadius',
    style: borderRadius
  },
  // palette
  color: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: 'palette',
    cssProperty: 'backgroundColor',
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: 'palette',
    transform: paletteTransform
  },
  // spacing
  p: {
    style: spacing/* padding */.o3
  },
  pt: {
    style: spacing/* padding */.o3
  },
  pr: {
    style: spacing/* padding */.o3
  },
  pb: {
    style: spacing/* padding */.o3
  },
  pl: {
    style: spacing/* padding */.o3
  },
  px: {
    style: spacing/* padding */.o3
  },
  py: {
    style: spacing/* padding */.o3
  },
  padding: {
    style: spacing/* padding */.o3
  },
  paddingTop: {
    style: spacing/* padding */.o3
  },
  paddingRight: {
    style: spacing/* padding */.o3
  },
  paddingBottom: {
    style: spacing/* padding */.o3
  },
  paddingLeft: {
    style: spacing/* padding */.o3
  },
  paddingX: {
    style: spacing/* padding */.o3
  },
  paddingY: {
    style: spacing/* padding */.o3
  },
  paddingInline: {
    style: spacing/* padding */.o3
  },
  paddingInlineStart: {
    style: spacing/* padding */.o3
  },
  paddingInlineEnd: {
    style: spacing/* padding */.o3
  },
  paddingBlock: {
    style: spacing/* padding */.o3
  },
  paddingBlockStart: {
    style: spacing/* padding */.o3
  },
  paddingBlockEnd: {
    style: spacing/* padding */.o3
  },
  m: {
    style: spacing/* margin */.e6
  },
  mt: {
    style: spacing/* margin */.e6
  },
  mr: {
    style: spacing/* margin */.e6
  },
  mb: {
    style: spacing/* margin */.e6
  },
  ml: {
    style: spacing/* margin */.e6
  },
  mx: {
    style: spacing/* margin */.e6
  },
  my: {
    style: spacing/* margin */.e6
  },
  margin: {
    style: spacing/* margin */.e6
  },
  marginTop: {
    style: spacing/* margin */.e6
  },
  marginRight: {
    style: spacing/* margin */.e6
  },
  marginBottom: {
    style: spacing/* margin */.e6
  },
  marginLeft: {
    style: spacing/* margin */.e6
  },
  marginX: {
    style: spacing/* margin */.e6
  },
  marginY: {
    style: spacing/* margin */.e6
  },
  marginInline: {
    style: spacing/* margin */.e6
  },
  marginInlineStart: {
    style: spacing/* margin */.e6
  },
  marginInlineEnd: {
    style: spacing/* margin */.e6
  },
  marginBlock: {
    style: spacing/* margin */.e6
  },
  marginBlockStart: {
    style: spacing/* margin */.e6
  },
  marginBlockEnd: {
    style: spacing/* margin */.e6
  },
  // display
  displayPrint: {
    cssProperty: false,
    transform: value => ({
      '@media print': {
        display: value
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: 'zIndex'
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: 'shadows'
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: 'typography'
  },
  fontSize: {
    themeKey: 'typography'
  },
  fontStyle: {
    themeKey: 'typography'
  },
  fontWeight: {
    themeKey: 'typography'
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: false,
    themeKey: 'typography'
  }
};
/* harmony default export */ var styleFunctionSx_defaultSxConfig = (defaultSxConfig);

/***/ }),

/***/ 86523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ unstable_createStyleFunctionSx; }
/* harmony export */ });
/* harmony import */ var _mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14142);
/* harmony import */ var _merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47730);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54844);
/* harmony import */ var _breakpoints__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95408);
/* harmony import */ var _defaultSxConfig__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44920);





function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}
function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
function unstable_createStyleFunctionSx() {
  function getThemeValue(prop, val, theme, config) {
    const props = {
      [prop]: val,
      theme
    };
    const options = config[prop];
    if (!options) {
      return {
        [prop]: val
      };
    }
    const {
      cssProperty = prop,
      themeKey,
      transform,
      style
    } = options;
    if (val == null) {
      return null;
    }

    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && val === 'inherit') {
      return {
        [prop]: val
      };
    }
    const themeMapping = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getPath */ .DW)(theme, themeKey) || {};
    if (style) {
      return style(props);
    }
    const styleFromPropValue = propValueFinal => {
      let value = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getStyleValue */ .Jq)(themeMapping, transform, propValueFinal);
      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = (0,_style__WEBPACK_IMPORTED_MODULE_0__/* .getStyleValue */ .Jq)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0,_mui_utils_capitalize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(propValueFinal)}`, propValueFinal);
      }
      if (cssProperty === false) {
        return value;
      }
      return {
        [cssProperty]: value
      };
    };
    return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .handleBreakpoints */ .k9)(props, val, styleFromPropValue);
  }
  function styleFunctionSx(props) {
    var _theme$unstable_sxCon;
    const {
      sx,
      theme = {},
      nested
    } = props || {};
    if (!sx) {
      return null; // Emotion & styled-components will neglect null
    }
    const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : _defaultSxConfig__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;

    /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */
    function traverse(sxInput) {
      let sxObject = sxInput;
      if (typeof sxInput === 'function') {
        sxObject = sxInput(theme);
      } else if (typeof sxInput !== 'object') {
        // value
        return sxInput;
      }
      if (!sxObject) {
        return null;
      }
      const emptyBreakpoints = (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .createEmptyBreakpointObject */ .W8)(theme.breakpoints);
      const breakpointsKeys = Object.keys(emptyBreakpoints);
      let css = emptyBreakpoints;
      Object.keys(sxObject).forEach(styleKey => {
        const value = callIfFn(sxObject[styleKey], theme);
        if (value !== null && value !== undefined) {
          if (typeof value === 'object') {
            if (config[styleKey]) {
              css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, getThemeValue(styleKey, value, theme, config));
            } else {
              const breakpointsValues = (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .handleBreakpoints */ .k9)({
                theme
              }, value, x => ({
                [styleKey]: x
              }));
              if (objectsHaveSameKeys(breakpointsValues, value)) {
                css[styleKey] = styleFunctionSx({
                  sx: value,
                  theme,
                  nested: true
                });
              } else {
                css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, breakpointsValues);
              }
            }
          } else {
            css = (0,_merge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(css, getThemeValue(styleKey, value, theme, config));
          }
        }
      });
      if (!nested && theme.modularCssLayers) {
        return {
          '@layer sx': (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .removeUnusedBreakpoints */ .L7)(breakpointsKeys, css)
        };
      }
      return (0,_breakpoints__WEBPACK_IMPORTED_MODULE_2__/* .removeUnusedBreakpoints */ .L7)(breakpointsKeys, css);
    }
    return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
  }
  return styleFunctionSx;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ['sx'];
/* harmony default export */ __webpack_exports__["Z"] = (styleFunctionSx);

/***/ }),

/***/ 96682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export systemDefaultTheme */
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88647);
/* harmony import */ var _useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34168);
'use client';



const systemDefaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
function useTheme(defaultTheme = systemDefaultTheme) {
  return (0,_useThemeWithoutDefault__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(defaultTheme);
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getThemeProps; }
/* harmony export */ });
/* harmony import */ var _mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35971);

function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;
  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }
  return (0,_mui_utils_resolveProps__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(theme.components[name].defaultProps, props);
}

/***/ }),

/***/ 29628:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useThemeProps; }
/* harmony export */ });
/* harmony import */ var _getThemeProps__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20539);
/* harmony import */ var _useTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96682);
'use client';



function useThemeProps({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = (0,_useTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = (0,_getThemeProps__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    theme,
    name,
    props
  });
  return mergedProps;
}

/***/ }),

/***/ 34168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87685);
'use client';



function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function useTheme(defaultTheme = null) {
  const contextTheme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_mui_styled_engine__WEBPACK_IMPORTED_MODULE_1__.T);
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
/* harmony default export */ __webpack_exports__["Z"] = (useTheme);

/***/ }),

/***/ 14142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56535);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? 0 : (0,_mui_utils_formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),

/***/ 7610:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
  return Math.max(min, Math.min(val, max));
}
/* harmony default export */ __webpack_exports__["Z"] = (clamp);

/***/ }),

/***/ 14800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _clamp__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _clamp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7610);


/***/ }),

/***/ 4953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ isPlainObject; },
/* harmony export */   "Z": function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function isPlainObject(item) {
  if (typeof item !== 'object' || item === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(item);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function deepClone(source) {
  if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(source) || !isPlainObject(source)) {
    return source;
  }
  const output = {};
  Object.keys(source).forEach(key => {
    output[key] = deepClone(source[key]);
  });
  return output;
}
function deepmerge(target, source, options = {
  clone: true
}) {
  const output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(key => {
      if ( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(source[key])) {
        output[key] = source[key];
      } else if (isPlainObject(source[key]) &&
      // Avoid prototype pollution
      Object.prototype.hasOwnProperty.call(target, key) && isPlainObject(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge(target[key], source[key], options);
      } else if (options.clone) {
        output[key] = isPlainObject(source[key]) ? deepClone(source[key]) : source[key];
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}

/***/ }),

/***/ 56535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe if we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;
  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }
  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),

/***/ 55480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _formatMuiErrorMessage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56535);


/***/ }),

/***/ 35971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ resolveProps; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87462);

/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param {object} defaultProps
 * @param {object} props
 * @returns {object} resolved props
 */
function resolveProps(defaultProps, props) {
  const output = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, props);
  Object.keys(defaultProps).forEach(propName => {
    if (propName.toString().match(/^(components|slots)$/)) {
      output[propName] = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, defaultProps[propName], output[propName]);
    } else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
      const defaultSlotProps = defaultProps[propName] || {};
      const slotProps = props[propName];
      output[propName] = {};
      if (!slotProps || !Object.keys(slotProps)) {
        // Reduce the iteration if the slot props is empty
        output[propName] = defaultSlotProps;
      } else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) {
        // Reduce the iteration if the default slot props is empty
        output[propName] = slotProps;
      } else {
        output[propName] = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, slotProps);
        Object.keys(defaultSlotProps).forEach(slotPropName => {
          output[propName][slotPropName] = resolveProps(defaultSlotProps[slotPropName], slotProps[slotPropName]);
        });
      }
    } else if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  });
  return output;
}

/***/ }),

/***/ 73546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';



/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */
const useEnhancedEffect = typeof window !== 'undefined' ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/* harmony default export */ __webpack_exports__["Z"] = (useEnhancedEffect);

/***/ }),

/***/ 92996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';


let globalId = 0;
function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride);
  const id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
}

// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const maybeReactUseId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useId'.toString()];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */
function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
  return useGlobalId(idOverride);
}

/***/ }),

/***/ 52359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ LocalizationProvider; },
  "y": function() { return /* binding */ MuiPickersAdapterContext; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useThemeProps.js
var useThemeProps = __webpack_require__(71657);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/locales/utils/getPickersLocalization.js

const getPickersLocalization = pickersTranslations => {
  return {
    components: {
      MuiLocalizationProvider: {
        defaultProps: {
          localeText: (0,esm_extends/* default */.Z)({}, pickersTranslations)
        }
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/locales/enUS.js
 // This object is not Partial<PickersLocaleText> because it is the default values

const enUSPickers = {
  // Calendar navigation
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  // View navigation
  openPreviousView: 'open previous view',
  openNextView: 'open next view',
  calendarViewSwitchingButtonAriaLabel: view => view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
  inputModeToggleButtonAriaLabel: (isKeyboardInputOpen, viewType) => isKeyboardInputOpen ? `text input view is open, go to ${viewType} view` : `${viewType} view is open, go to text input view`,
  // DateRange placeholders
  start: 'Start',
  end: 'End',
  // Action bar
  cancelButtonLabel: 'Cancel',
  clearButtonLabel: 'Clear',
  okButtonLabel: 'OK',
  todayButtonLabel: 'Today',
  // Toolbar titles
  datePickerDefaultToolbarTitle: 'Select date',
  dateTimePickerDefaultToolbarTitle: 'Select date & time',
  timePickerDefaultToolbarTitle: 'Select time',
  dateRangePickerDefaultToolbarTitle: 'Select date range',
  // Clock labels
  clockLabelText: (view, time, adapter) => `Select ${view}. ${time === null ? 'No time selected' : `Selected time is ${adapter.format(time, 'fullTime')}`}`,
  hoursClockNumberText: hours => `${hours} hours`,
  minutesClockNumberText: minutes => `${minutes} minutes`,
  secondsClockNumberText: seconds => `${seconds} seconds`,
  // Open picker labels
  openDatePickerDialogue: (rawValue, utils) => rawValue && utils.isValid(utils.date(rawValue)) ? `Choose date, selected date is ${utils.format(utils.date(rawValue), 'fullDate')}` : 'Choose date',
  openTimePickerDialogue: (rawValue, utils) => rawValue && utils.isValid(utils.date(rawValue)) ? `Choose time, selected time is ${utils.format(utils.date(rawValue), 'fullTime')}` : 'Choose time',
  // Table labels
  timeTableLabel: 'pick time',
  dateTableLabel: 'pick date'
};
const DEFAULT_LOCALE = enUSPickers;
const enUS = getPickersLocalization(enUSPickers);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js






const MuiPickersAdapterContext = /*#__PURE__*/react.createContext(null);

if (false) {}

let warnedOnce = false;
/**
 * @ignore - do not document.
 */

function LocalizationProvider(inProps) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiLocalizationProvider'
  });
  const {
    children,
    dateAdapter: Utils,
    dateFormats,
    dateLibInstance,
    locale,
    adapterLocale,
    localeText
  } = props;

  if (false) {}

  const utils = react.useMemo(() => new Utils({
    locale: adapterLocale != null ? adapterLocale : locale,
    formats: dateFormats,
    instance: dateLibInstance
  }), [Utils, locale, adapterLocale, dateFormats, dateLibInstance]);
  const defaultDates = react.useMemo(() => {
    return {
      minDate: utils.date('1900-01-01T00:00:00.000'),
      maxDate: utils.date('2099-12-31T00:00:00.000')
    };
  }, [utils]);
  const contextValue = react.useMemo(() => {
    return {
      utils,
      defaultDates,
      localeText: (0,esm_extends/* default */.Z)({}, DEFAULT_LOCALE, localeText != null ? localeText : {})
    };
  }, [defaultDates, utils, localeText]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MuiPickersAdapterContext.Provider, {
    value: contextValue,
    children: children
  });
}
 false ? 0 : void 0;

/***/ }),

/***/ 4591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FJ": function() { return /* binding */ pTimeout; },
/* harmony export */   "UI": function() { return /* binding */ invokeCallback; }
/* harmony export */ });
/* unused harmony export sleep */
function pTimeout(promise, timeout) {
    return new Promise(function (resolve, reject) {
        var timeoutId = setTimeout(function () {
            reject(Error('Promise timed out'));
        }, timeout);
        promise
            .then(function (val) {
            clearTimeout(timeoutId);
            return resolve(val);
        })
            .catch(reject);
    });
}
function sleep(timeoutInMs) {
    return new Promise(function (resolve) { return setTimeout(resolve, timeoutInMs); });
}
/**
 * @param ctx
 * @param callback - the function to invoke
 * @param delay - aka "timeout". The amount of time in ms to wait before invoking the callback.
 */
function invokeCallback(ctx, callback, delay) {
    var cb = function () {
        try {
            return Promise.resolve(callback(ctx));
        }
        catch (err) {
            return Promise.reject(err);
        }
    };
    return (sleep(delay)
        // pTimeout ensures that the callback can't cause the context to hang
        .then(function () { return pTimeout(cb(), 1000); })
        .catch(function (err) {
        ctx === null || ctx === void 0 ? void 0 : ctx.log('warn', 'Callback Error', { error: err });
        ctx === null || ctx === void 0 ? void 0 : ctx.stats.increment('callback_error');
    })
        .then(function () { return ctx; }));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 98191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ ContextCancelation; },
  "_": function() { return /* binding */ CoreContext; }
});

// EXTERNAL MODULE: ./node_modules/@lukeed/uuid/dist/index.mjs
var dist = __webpack_require__(59108);
// EXTERNAL MODULE: ./node_modules/dset/dist/index.mjs
var dset_dist = __webpack_require__(96475);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/logger/index.js

var CoreLogger = /** @class */ (function () {
    function CoreLogger() {
        this._logs = [];
    }
    CoreLogger.prototype.log = function (level, message, extras) {
        var time = new Date();
        this._logs.push({
            level: level,
            message: message,
            time: time,
            extras: extras,
        });
    };
    Object.defineProperty(CoreLogger.prototype, "logs", {
        get: function () {
            return this._logs;
        },
        enumerable: false,
        configurable: true
    });
    CoreLogger.prototype.flush = function () {
        if (this.logs.length > 1) {
            var formatted = this._logs.reduce(function (logs, log) {
                var _a;
                var _b, _c;
                var line = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, log), { json: JSON.stringify(log.extras, null, ' '), extras: log.extras });
                delete line['time'];
                var key = (_c = (_b = log.time) === null || _b === void 0 ? void 0 : _b.toISOString()) !== null && _c !== void 0 ? _c : '';
                if (logs[key]) {
                    key = "".concat(key, "-").concat(Math.random());
                }
                return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, logs), (_a = {}, _a[key] = line, _a));
            }, {});
            // ie doesn't like console.table
            if (console.table) {
                console.table(formatted);
            }
            else {
                console.log(formatted);
            }
        }
        else {
            this.logs.forEach(function (logEntry) {
                var level = logEntry.level, message = logEntry.message, extras = logEntry.extras;
                if (level === 'info' || level === 'debug') {
                    console.log(message, extras !== null && extras !== void 0 ? extras : '');
                }
                else {
                    console[level](message, extras !== null && extras !== void 0 ? extras : '');
                }
            });
        }
        this._logs = [];
    };
    return CoreLogger;
}());

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-core/dist/esm/stats/index.js
var esm_stats = __webpack_require__(50732);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/context/index.js




var ContextCancelation = /** @class */ (function () {
    function ContextCancelation(options) {
        var _a, _b, _c;
        this.retry = (_a = options.retry) !== null && _a !== void 0 ? _a : true;
        this.type = (_b = options.type) !== null && _b !== void 0 ? _b : 'plugin Error';
        this.reason = (_c = options.reason) !== null && _c !== void 0 ? _c : '';
    }
    return ContextCancelation;
}());

var CoreContext = /** @class */ (function () {
    function CoreContext(event, id, stats, logger) {
        if (id === void 0) { id = (0,dist.v4)(); }
        if (stats === void 0) { stats = new esm_stats/* NullStats */.i(); }
        if (logger === void 0) { logger = new CoreLogger(); }
        this.attempts = 0;
        this.event = event;
        this._id = id;
        this.logger = logger;
        this.stats = stats;
    }
    CoreContext.system = function () {
        // This should be overridden by the subclass to return an instance of the subclass.
    };
    CoreContext.prototype.isSame = function (other) {
        return other.id === this.id;
    };
    CoreContext.prototype.cancel = function (error) {
        if (error) {
            throw error;
        }
        throw new ContextCancelation({ reason: 'Context Cancel' });
    };
    CoreContext.prototype.log = function (level, message, extras) {
        this.logger.log(level, message, extras);
    };
    Object.defineProperty(CoreContext.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: false,
        configurable: true
    });
    CoreContext.prototype.updateEvent = function (path, val) {
        var _a;
        // Don't allow integrations that are set to false to be overwritten with integration settings.
        if (path.split('.')[0] === 'integrations') {
            var integrationName = path.split('.')[1];
            if (((_a = this.event.integrations) === null || _a === void 0 ? void 0 : _a[integrationName]) === false) {
                return this.event;
            }
        }
        (0,dset_dist/* dset */.N)(this.event, path, val);
        return this.event;
    };
    CoreContext.prototype.failedDelivery = function () {
        return this._failedDelivery;
    };
    CoreContext.prototype.setFailedDelivery = function (options) {
        this._failedDelivery = options;
    };
    CoreContext.prototype.logs = function () {
        return this.logger.logs;
    };
    CoreContext.prototype.flush = function () {
        this.logger.flush();
        this.stats.flush();
    };
    CoreContext.prototype.toJSON = function () {
        return {
            id: this._id,
            event: this.event,
            logs: this.logger.logs,
            metrics: this.stats.metrics,
        };
    };
    return CoreContext;
}());

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ ON_REMOVE_FROM_FUTURE; },
  "Z": function() { return /* binding */ PriorityQueue; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-generic-utils/dist/esm/emitter/emitter.js
var emitter = __webpack_require__(38714);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/priority-queue/backoff.js
function backoff(params) {
    var random = Math.random() + 1;
    var _a = params.minTimeout, minTimeout = _a === void 0 ? 500 : _a, _b = params.factor, factor = _b === void 0 ? 2 : _b, attempt = params.attempt, _c = params.maxTimeout, maxTimeout = _c === void 0 ? Infinity : _c;
    return Math.min(random * minTimeout * Math.pow(factor, attempt), maxTimeout);
}
//# sourceMappingURL=backoff.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/priority-queue/index.js



/**
 * @internal
 */
var ON_REMOVE_FROM_FUTURE = 'onRemoveFromFuture';
var PriorityQueue = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(PriorityQueue, _super);
    function PriorityQueue(maxAttempts, queue, seen) {
        var _this = _super.call(this) || this;
        _this.future = [];
        _this.maxAttempts = maxAttempts;
        _this.queue = queue;
        _this.seen = seen !== null && seen !== void 0 ? seen : {};
        return _this;
    }
    PriorityQueue.prototype.push = function () {
        var _this = this;
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var accepted = items.map(function (operation) {
            var attempts = _this.updateAttempts(operation);
            if (attempts > _this.maxAttempts || _this.includes(operation)) {
                return false;
            }
            _this.queue.push(operation);
            return true;
        });
        this.queue = this.queue.sort(function (a, b) { return _this.getAttempts(a) - _this.getAttempts(b); });
        return accepted;
    };
    PriorityQueue.prototype.pushWithBackoff = function (item, minTimeout) {
        if (minTimeout === void 0) { minTimeout = 0; }
        // One immediate retry unless we have a minimum timeout (e.g. for rate limiting)
        if (minTimeout == 0 && this.getAttempts(item) === 0) {
            return this.push(item)[0];
        }
        var timeout = backoff({ attempt: this.getAttempts(item) });
        if (minTimeout > 0 && timeout < minTimeout) {
            timeout = minTimeout;
        }
        return this.scheduleItem(item, timeout);
    };
    PriorityQueue.prototype.pushWithDelay = function (item, delay) {
        return this.scheduleItem(item, delay);
    };
    PriorityQueue.prototype.scheduleItem = function (item, timeout) {
        var _this = this;
        var attempt = this.updateAttempts(item);
        if (attempt > this.maxAttempts || this.includes(item)) {
            return false;
        }
        setTimeout(function () {
            _this.queue.push(item);
            _this.future = _this.future.filter(function (f) { return f.id !== item.id; });
            _this.emit(ON_REMOVE_FROM_FUTURE);
        }, timeout);
        this.future.push(item);
        return true;
    };
    PriorityQueue.prototype.getAttempts = function (item) {
        var _a;
        return (_a = this.seen[item.id]) !== null && _a !== void 0 ? _a : 0;
    };
    PriorityQueue.prototype.updateAttempts = function (item) {
        this.seen[item.id] = this.getAttempts(item) + 1;
        return this.getAttempts(item);
    };
    PriorityQueue.prototype.includes = function (item) {
        return (this.queue.includes(item) ||
            this.future.includes(item) ||
            Boolean(this.queue.find(function (i) { return i.id === item.id; })) ||
            Boolean(this.future.find(function (i) { return i.id === item.id; })));
    };
    PriorityQueue.prototype.pop = function () {
        return this.queue.shift();
    };
    Object.defineProperty(PriorityQueue.prototype, "length", {
        get: function () {
            return this.queue.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriorityQueue.prototype, "todo", {
        get: function () {
            return this.queue.length + this.future.length;
        },
        enumerable: false,
        configurable: true
    });
    return PriorityQueue;
}(emitter/* Emitter */.Q));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 69147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ attempt; },
/* harmony export */   "z": function() { return /* binding */ ensure; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98191);


function tryAsync(fn) {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(this, void 0, void 0, function () {
        var err_1;
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fn()];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(err_1)];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function attempt(ctx, plugin) {
    ctx.log('debug', 'plugin', { plugin: plugin.name });
    var start = new Date().getTime();
    var hook = plugin[ctx.event.type];
    if (hook === undefined) {
        return Promise.resolve(ctx);
    }
    var newCtx = tryAsync(function () { return hook.apply(plugin, [ctx]); })
        .then(function (ctx) {
        var done = new Date().getTime() - start;
        ctx.stats.gauge('plugin_time', done, ["plugin:".concat(plugin.name)]);
        return ctx;
    })
        .catch(function (err) {
        if (err instanceof _context__WEBPACK_IMPORTED_MODULE_1__/* .ContextCancelation */ .Y &&
            err.type === 'middleware_cancellation') {
            throw err;
        }
        if (err instanceof _context__WEBPACK_IMPORTED_MODULE_1__/* .ContextCancelation */ .Y) {
            ctx.log('warn', err.type, {
                plugin: plugin.name,
                error: err,
            });
            return err;
        }
        ctx.log('error', 'plugin Error', {
            plugin: plugin.name,
            error: err,
        });
        ctx.stats.increment('plugin_error', 1, ["plugin:".concat(plugin.name)]);
        return err;
    });
    return newCtx;
}
function ensure(ctx, plugin) {
    return attempt(ctx, plugin).then(function (newContext) {
        if (newContext instanceof _context__WEBPACK_IMPORTED_MODULE_1__/* .CoreContext */ ._) {
            return newContext;
        }
        ctx.log('debug', 'Context canceled');
        ctx.stats.increment('context_canceled');
        ctx.cancel(newContext);
    });
}
//# sourceMappingURL=delivery.js.map

/***/ }),

/***/ 50732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ NullStats; },
/* harmony export */   "s": function() { return /* binding */ CoreStats; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);

var compactMetricType = function (type) {
    var enums = {
        gauge: 'g',
        counter: 'c',
    };
    return enums[type];
};
var CoreStats = /** @class */ (function () {
    function CoreStats() {
        this.metrics = [];
    }
    CoreStats.prototype.increment = function (metric, by, tags) {
        if (by === void 0) { by = 1; }
        this.metrics.push({
            metric: metric,
            value: by,
            tags: tags !== null && tags !== void 0 ? tags : [],
            type: 'counter',
            timestamp: Date.now(),
        });
    };
    CoreStats.prototype.gauge = function (metric, value, tags) {
        this.metrics.push({
            metric: metric,
            value: value,
            tags: tags !== null && tags !== void 0 ? tags : [],
            type: 'gauge',
            timestamp: Date.now(),
        });
    };
    CoreStats.prototype.flush = function () {
        var formatted = this.metrics.map(function (m) { return ((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, m), { tags: m.tags.join(',') })); });
        // ie doesn't like console.table
        if (console.table) {
            console.table(formatted);
        }
        else {
            console.log(formatted);
        }
        this.metrics = [];
    };
    /**
     * compact keys for smaller payload
     */
    CoreStats.prototype.serialize = function () {
        return this.metrics.map(function (m) {
            return {
                m: m.metric,
                v: m.value,
                t: m.tags,
                k: compactMetricType(m.type),
                e: m.timestamp,
            };
        });
    };
    return CoreStats;
}());

var NullStats = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(NullStats, _super);
    function NullStats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NullStats.prototype.gauge = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
    };
    NullStats.prototype.increment = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
    };
    NullStats.prototype.flush = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
    };
    NullStats.prototype.serialize = function () {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
        return [];
    };
    return NullStats;
}(CoreStats));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 55469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gg": function() { return /* binding */ exists; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "mf": function() { return /* binding */ isFunction; }
/* harmony export */ });
function isString(obj) {
    return typeof obj === 'string';
}
function isNumber(obj) {
    return typeof obj === 'number';
}
function isFunction(obj) {
    return typeof obj === 'function';
}
function exists(val) {
    return val !== undefined && val !== null;
}
function isPlainObject(obj) {
    return (Object.prototype.toString.call(obj).slice(8, -1).toLowerCase() === 'object');
}
//# sourceMappingURL=helpers.js.map

/***/ }),

/***/ 15987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ createDeferred; }
/* harmony export */ });
/**
 * Return a promise that can be externally resolved
 */
var createDeferred = function () {
    var resolve;
    var reject;
    var settled = false;
    var promise = new Promise(function (_resolve, _reject) {
        resolve = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            settled = true;
            _resolve.apply(void 0, args);
        };
        reject = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            settled = true;
            _reject.apply(void 0, args);
        };
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise,
        isSettled: function () { return settled; },
    };
};
//# sourceMappingURL=create-deferred.js.map

/***/ }),

/***/ 38714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ Emitter; }
/* harmony export */ });
/**
 * Event Emitter that takes the expected contract as a generic
 * @example
 * ```ts
 *  type Contract = {
 *    delivery_success: [DeliverySuccessResponse, Metrics],
 *    delivery_failure: [DeliveryError]
 * }
 *  new Emitter<Contract>()
 *  .on('delivery_success', (res, metrics) => ...)
 *  .on('delivery_failure', (err) => ...)
 * ```
 */
var Emitter = /** @class */ (function () {
    function Emitter(options) {
        var _a;
        this.callbacks = {};
        this.warned = false;
        this.maxListeners = (_a = options === null || options === void 0 ? void 0 : options.maxListeners) !== null && _a !== void 0 ? _a : 10;
    }
    Emitter.prototype.warnIfPossibleMemoryLeak = function (event) {
        if (this.warned) {
            return;
        }
        if (this.maxListeners &&
            this.callbacks[event].length > this.maxListeners) {
            console.warn("Event Emitter: Possible memory leak detected; ".concat(String(event), " has exceeded ").concat(this.maxListeners, " listeners."));
            this.warned = true;
        }
    };
    Emitter.prototype.on = function (event, callback) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [callback];
        }
        else {
            this.callbacks[event].push(callback);
            this.warnIfPossibleMemoryLeak(event);
        }
        return this;
    };
    Emitter.prototype.once = function (event, callback) {
        var _this = this;
        var on = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.off(event, on);
            callback.apply(_this, args);
        };
        this.on(event, on);
        return this;
    };
    Emitter.prototype.off = function (event, callback) {
        var _a;
        var fns = (_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [];
        var without = fns.filter(function (fn) { return fn !== callback; });
        this.callbacks[event] = without;
        return this;
    };
    Emitter.prototype.emit = function (event) {
        var _this = this;
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var callbacks = (_a = this.callbacks[event]) !== null && _a !== void 0 ? _a : [];
        callbacks.forEach(function (callback) {
            callback.apply(_this, args);
        });
        return this;
    };
    return Emitter;
}());

//# sourceMappingURL=emitter.js.map

/***/ }),

/***/ 65904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ isOnline; },
/* harmony export */   "s": function() { return /* binding */ isOffline; }
/* harmony export */ });
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69699);

function isOnline() {
    if ((0,_environment__WEBPACK_IMPORTED_MODULE_0__/* .isBrowser */ .j)()) {
        return window.navigator.onLine;
    }
    return true;
}
function isOffline() {
    return !isOnline();
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 36514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SEGMENT_API_HOST; }
/* harmony export */ });
var SEGMENT_API_HOST = 'api.segment.io/v1';
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ Context; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);
/* harmony import */ var _segment_analytics_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98191);
/* harmony import */ var _stats__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42718);



var Context = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(Context, _super);
    function Context(event, id) {
        return _super.call(this, event, id, new _stats__WEBPACK_IMPORTED_MODULE_1__/* .Stats */ .j()) || this;
    }
    Context.system = function () {
        return new this({ type: 'track', event: 'system' });
    };
    return Context;
}(_segment_analytics_core__WEBPACK_IMPORTED_MODULE_2__/* .CoreContext */ ._));


//# sourceMappingURL=index.js.map

/***/ }),

/***/ 69699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ isBrowser; },
/* harmony export */   "s": function() { return /* binding */ isServer; }
/* harmony export */ });
function isBrowser() {
    return typeof window !== 'undefined';
}
function isServer() {
    return !isBrowser();
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 67475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ gracefulDecodeURIComponent; }
/* harmony export */ });
/**
 * Tries to gets the unencoded version of an encoded component of a
 * Uniform Resource Identifier (URI). If input string is malformed,
 * returns it back as-is.
 *
 * Note: All occurences of the `+` character become ` ` (spaces).
 **/
function gracefulDecodeURIComponent(encodedURIComponent) {
    try {
        return decodeURIComponent(encodedURIComponent.replace(/\+/g, ' '));
    }
    catch (_a) {
        return encodedURIComponent;
    }
}
//# sourceMappingURL=gracefulDecodeURIComponent.js.map

/***/ }),

/***/ 42718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ Stats; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-core/dist/esm/stats/index.js
var stats = __webpack_require__(50732);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/fetch.js
var fetch = __webpack_require__(55609);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/generated/version.js
var version = __webpack_require__(39821);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/version-type.js
var version_type = __webpack_require__(7227);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/constants/index.js
var constants = __webpack_require__(36514);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/stats/remote-metrics.js





var createRemoteMetric = function (metric, tags, versionType) {
    var formattedTags = tags.reduce(function (acc, t) {
        var _a = t.split(':'), k = _a[0], v = _a[1];
        acc[k] = v;
        return acc;
    }, {});
    return {
        type: 'Counter',
        metric: metric,
        value: 1,
        tags: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, formattedTags), { library: 'analytics.js', library_version: versionType === 'web' ? "next-".concat(version/* version */.i) : "npm:next-".concat(version/* version */.i) }),
    };
};
function logError(err) {
    console.error('Error sending segment performance metrics', err);
}
var RemoteMetrics = /** @class */ (function () {
    function RemoteMetrics(options) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        this.host = (_a = options === null || options === void 0 ? void 0 : options.host) !== null && _a !== void 0 ? _a : constants/* SEGMENT_API_HOST */.U;
        this.sampleRate = (_b = options === null || options === void 0 ? void 0 : options.sampleRate) !== null && _b !== void 0 ? _b : 1;
        this.flushTimer = (_c = options === null || options === void 0 ? void 0 : options.flushTimer) !== null && _c !== void 0 ? _c : 30 * 1000; /* 30s */
        this.maxQueueSize = (_d = options === null || options === void 0 ? void 0 : options.maxQueueSize) !== null && _d !== void 0 ? _d : 20;
        this.protocol = (_e = options === null || options === void 0 ? void 0 : options.protocol) !== null && _e !== void 0 ? _e : 'https';
        this.queue = [];
        if (this.sampleRate > 0) {
            var flushing_1 = false;
            var run_1 = function () {
                if (flushing_1) {
                    return;
                }
                flushing_1 = true;
                _this.flush().catch(logError);
                flushing_1 = false;
                setTimeout(run_1, _this.flushTimer);
            };
            run_1();
        }
    }
    RemoteMetrics.prototype.increment = function (metric, tags) {
        // All metrics are part of an allow list in Tracking API
        if (!metric.includes('analytics_js.')) {
            return;
        }
        // /m doesn't like empty tags
        if (tags.length === 0) {
            return;
        }
        if (Math.random() > this.sampleRate) {
            return;
        }
        if (this.queue.length >= this.maxQueueSize) {
            return;
        }
        var remoteMetric = createRemoteMetric(metric, tags, (0,version_type/* getVersionType */.B)());
        this.queue.push(remoteMetric);
        if (metric.includes('error')) {
            this.flush().catch(logError);
        }
    };
    RemoteMetrics.prototype.flush = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.queue.length <= 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.send().catch(function (error) {
                                logError(error);
                                _this.sampleRate = 0;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemoteMetrics.prototype.send = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var payload, headers, url;
            return (0,tslib_es6.__generator)(this, function (_a) {
                payload = { series: this.queue };
                this.queue = [];
                headers = { 'Content-Type': 'text/plain' };
                url = "".concat(this.protocol, "://").concat(this.host, "/m");
                return [2 /*return*/, (0,fetch/* fetch */.h)(url, {
                        headers: headers,
                        body: JSON.stringify(payload),
                        method: 'POST',
                    })];
            });
        });
    };
    return RemoteMetrics;
}());

//# sourceMappingURL=remote-metrics.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/stats/index.js



var remoteMetrics;
var Stats = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Stats, _super);
    function Stats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Stats.initRemoteMetrics = function (options) {
        remoteMetrics = new RemoteMetrics(options);
    };
    Stats.prototype.increment = function (metric, by, tags) {
        _super.prototype.increment.call(this, metric, by, tags);
        remoteMetrics === null || remoteMetrics === void 0 ? void 0 : remoteMetrics.increment(metric, tags !== null && tags !== void 0 ? tags : []);
    };
    return Stats;
}(stats/* CoreStats */.s));

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 92311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ recordIntegrationMetric; }
/* harmony export */ });
function recordIntegrationMetric(ctx, _a) {
    var methodName = _a.methodName, integrationName = _a.integrationName, type = _a.type, _b = _a.didError, didError = _b === void 0 ? false : _b;
    ctx.stats.increment("analytics_js.integration.invoke".concat(didError ? '.error' : ''), 1, [
        "method:".concat(methodName),
        "integration_name:".concat(integrationName),
        "type:".concat(type),
    ]);
}
//# sourceMappingURL=metric-helpers.js.map

/***/ }),

/***/ 39821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ version; }
/* harmony export */ });
// This file is generated.
var version = '1.84.0';
//# sourceMappingURL=version.js.map

/***/ }),

/***/ 55609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ fetch; }
/* harmony export */ });
/* harmony import */ var unfetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63144);
/* harmony import */ var unfetch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(unfetch__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44083);


/**
 * Wrapper around native `fetch` containing `unfetch` fallback.
 */
var fetch = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var global = (0,_get_global__WEBPACK_IMPORTED_MODULE_1__/* .getGlobal */ .R)();
    return ((global && global.fetch) || (unfetch__WEBPACK_IMPORTED_MODULE_0___default())).apply(void 0, args);
};
//# sourceMappingURL=fetch.js.map

/***/ }),

/***/ 44083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobal; }
/* harmony export */ });
// This an imperfect polyfill for globalThis
var getGlobal = function () {
    if (typeof globalThis !== 'undefined') {
        return globalThis;
    }
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof __webpack_require__.g !== 'undefined') {
        return __webpack_require__.g;
    }
    return null;
};
//# sourceMappingURL=get-global.js.map

/***/ }),

/***/ 74939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jV": function() { return /* binding */ setGlobalAnalyticsKey; },
/* harmony export */   "ql": function() { return /* binding */ setGlobalAnalytics; },
/* harmony export */   "wI": function() { return /* binding */ getGlobalAnalytics; }
/* harmony export */ });
/**
 * Stores the global window analytics key
 */
var _globalAnalyticsKey = 'analytics';
/**
 * Gets the global analytics/buffer
 * @param key name of the window property where the buffer is stored (default: analytics)
 * @returns AnalyticsSnippet
 */
function getGlobalAnalytics() {
    return window[_globalAnalyticsKey];
}
/**
 * Replaces the global window key for the analytics/buffer object
 * @param key key name
 */
function setGlobalAnalyticsKey(key) {
    _globalAnalyticsKey = key;
}
/**
 * Sets the global analytics object
 * @param analytics analytics snippet
 */
function setGlobalAnalytics(analytics) {
    ;
    window[_globalAnalyticsKey] = analytics;
}
//# sourceMappingURL=global-analytics-helper.js.map

/***/ }),

/***/ 66548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ unloadScript; },
/* harmony export */   "v": function() { return /* binding */ loadScript; }
/* harmony export */ });
function findScript(src) {
    var scripts = Array.prototype.slice.call(window.document.querySelectorAll('script'));
    return scripts.find(function (s) { return s.src === src; });
}
/**
 * Load a script from a URL and append it to the document.
 */
function loadScript(src, attributes) {
    var found = findScript(src);
    if (found !== undefined) {
        var status_1 = found === null || found === void 0 ? void 0 : found.getAttribute('status');
        if (status_1 === 'loaded') {
            return Promise.resolve(found);
        }
        if (status_1 === 'loading') {
            return new Promise(function (resolve, reject) {
                found.addEventListener('load', function () { return resolve(found); });
                found.addEventListener('error', function (err) { return reject(err); });
            });
        }
    }
    return new Promise(function (resolve, reject) {
        var _a;
        var script = window.document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.async = true;
        script.setAttribute('status', 'loading');
        for (var _i = 0, _b = Object.entries(attributes !== null && attributes !== void 0 ? attributes : {}); _i < _b.length; _i++) {
            var _c = _b[_i], k = _c[0], v = _c[1];
            script.setAttribute(k, v);
        }
        script.onload = function () {
            script.onerror = script.onload = null;
            script.setAttribute('status', 'loaded');
            resolve(script);
        };
        script.onerror = function () {
            script.onerror = script.onload = null;
            script.setAttribute('status', 'error');
            reject(new Error("Failed to load ".concat(src)));
        };
        var firstExistingScript = window.document.querySelector('script');
        if (!firstExistingScript) {
            window.document.head.appendChild(script);
        }
        else {
            (_a = firstExistingScript.parentElement) === null || _a === void 0 ? void 0 : _a.insertBefore(script, firstExistingScript);
        }
    });
}
function unloadScript(src) {
    var found = findScript(src);
    if (found !== undefined) {
        found.remove();
    }
    return Promise.resolve();
}
//# sourceMappingURL=load-script.js.map

/***/ }),

/***/ 913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ mergedOptions; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);

/**
 * Merge legacy settings and initialized Integration option overrides.
 *
 * This will merge any options that were passed from initialization into
 * overrides for settings that are returned by the Segment CDN.
 *
 * i.e. this allows for passing options directly into destinations from
 * the Analytics constructor.
 */
function mergedOptions(cdnSettings, options) {
    var _a;
    var optionOverrides = Object.entries((_a = options.integrations) !== null && _a !== void 0 ? _a : {}).reduce(function (overrides, _a) {
        var _b, _c;
        var integration = _a[0], options = _a[1];
        if (typeof options === 'object') {
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, overrides), (_b = {}, _b[integration] = options, _b));
        }
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, overrides), (_c = {}, _c[integration] = {}, _c));
    }, {});
    return Object.entries(cdnSettings.integrations).reduce(function (integrationSettings, _a) {
        var _b;
        var integration = _a[0], settings = _a[1];
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, integrationSettings), (_b = {}, _b[integration] = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, settings), optionOverrides[integration]), _b));
    }, {});
}
//# sourceMappingURL=merged-options.js.map

/***/ }),

/***/ 56749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ pWhile; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);

var pWhile = function (condition, action) { return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(void 0, void 0, void 0, function () {
    var loop;
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_a) {
        loop = function (actionResult) { return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(void 0, void 0, void 0, function () {
            var _a;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!condition(actionResult)) return [3 /*break*/, 2];
                        _a = loop;
                        return [4 /*yield*/, action()];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        return [2 /*return*/, loop(undefined)];
    });
}); };
//# sourceMappingURL=p-while.js.map

/***/ }),

/***/ 99382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kg": function() { return /* binding */ getNextIntegrationsURL; },
/* harmony export */   "UH": function() { return /* binding */ setGlobalCDNUrl; },
/* harmony export */   "Vl": function() { return /* binding */ getCDN; }
/* harmony export */ });
/* unused harmony export getLegacyAJSPath */
/* harmony import */ var _global_analytics_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74939);


var analyticsScriptRegex = /(https:\/\/.*)\/analytics\.js\/v1\/(?:.*?)\/(?:platform|analytics.*)?/;
var getCDNUrlFromScriptTag = function () {
    var cdn;
    var scripts = Array.prototype.slice.call(document.querySelectorAll('script'));
    scripts.forEach(function (s) {
        var _a;
        var src = (_a = s.getAttribute('src')) !== null && _a !== void 0 ? _a : '';
        var result = analyticsScriptRegex.exec(src);
        if (result && result[1]) {
            cdn = result[1];
        }
    });
    return cdn;
};
var _globalCDN; // set globalCDN as in-memory singleton
var getGlobalCDNUrl = function () {
    var _a;
    var result = _globalCDN !== null && _globalCDN !== void 0 ? _globalCDN : (_a = (0,_global_analytics_helper__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalAnalytics */ .wI)()) === null || _a === void 0 ? void 0 : _a._cdn;
    return result;
};
var setGlobalCDNUrl = function (cdn) {
    var globalAnalytics = (0,_global_analytics_helper__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalAnalytics */ .wI)();
    if (globalAnalytics) {
        globalAnalytics._cdn = cdn;
    }
    _globalCDN = cdn;
};
var getCDN = function () {
    var globalCdnUrl = getGlobalCDNUrl();
    if (globalCdnUrl)
        return globalCdnUrl;
    var cdnFromScriptTag = getCDNUrlFromScriptTag();
    if (cdnFromScriptTag) {
        return cdnFromScriptTag;
    }
    else {
        // it's possible that the CDN is not found in the page because:
        // - the script is loaded through a proxy
        // - the script is removed after execution
        // in this case, we fall back to the default Segment CDN
        return "https://cdn.segment.com";
    }
};
var getNextIntegrationsURL = function () {
    var cdn = getCDN();
    return "".concat(cdn, "/next-integrations");
};
/**
 * Replaces the CDN URL in the script tag with the one from Analytics.js 1.0
 *
 * @returns the path to Analytics JS 1.0
 **/
function getLegacyAJSPath() {
    var _a, _b, _c;
    var writeKey = (_a = embeddedWriteKey()) !== null && _a !== void 0 ? _a : (_b = getGlobalAnalytics()) === null || _b === void 0 ? void 0 : _b._writeKey;
    var scripts = Array.prototype.slice.call(document.querySelectorAll('script'));
    var path = undefined;
    for (var _i = 0, scripts_1 = scripts; _i < scripts_1.length; _i++) {
        var s = scripts_1[_i];
        var src = (_c = s.getAttribute('src')) !== null && _c !== void 0 ? _c : '';
        var result = analyticsScriptRegex.exec(src);
        if (result && result[1]) {
            path = src;
            break;
        }
    }
    if (path) {
        return path.replace('analytics.min.js', 'analytics.classic.js');
    }
    return "https://cdn.segment.com/analytics.js/v1/".concat(writeKey, "/analytics.classic.js");
}
//# sourceMappingURL=parse-cdn.js.map

/***/ }),

/***/ 65976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PersistedPriorityQueue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51181);
/* harmony import */ var _core_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29784);
/* harmony import */ var _core_environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69699);




var loc = {
    getItem: function () { },
    setItem: function () { },
    removeItem: function () { },
};
try {
    loc = (0,_core_environment__WEBPACK_IMPORTED_MODULE_0__/* .isBrowser */ .j)() && window.localStorage ? window.localStorage : loc;
}
catch (err) {
    console.warn('Unable to access localStorage', err);
}
function persisted(key) {
    var items = loc.getItem(key);
    return (items ? JSON.parse(items) : []).map(function (p) { return new _core_context__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._(p.event, p.id); });
}
function persistItems(key, items) {
    var existing = persisted(key);
    var all = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([], items, true), existing, true);
    var merged = all.reduce(function (acc, item) {
        var _a;
        return (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, acc), (_a = {}, _a[item.id] = item, _a));
    }, {});
    loc.setItem(key, JSON.stringify(Object.values(merged)));
}
function seen(key) {
    var stored = loc.getItem(key);
    return stored ? JSON.parse(stored) : {};
}
function persistSeen(key, memory) {
    var stored = seen(key);
    loc.setItem(key, JSON.stringify((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, stored), memory)));
}
function remove(key) {
    loc.removeItem(key);
}
var now = function () { return new Date().getTime(); };
function mutex(key, onUnlock, attempt) {
    if (attempt === void 0) { attempt = 0; }
    var lockTimeout = 50;
    var lockKey = "persisted-queue:v1:".concat(key, ":lock");
    var expired = function (lock) { return new Date().getTime() > lock; };
    var rawLock = loc.getItem(lockKey);
    var lock = rawLock ? JSON.parse(rawLock) : null;
    var allowed = lock === null || expired(lock);
    if (allowed) {
        loc.setItem(lockKey, JSON.stringify(now() + lockTimeout));
        onUnlock();
        loc.removeItem(lockKey);
        return;
    }
    if (!allowed && attempt < 3) {
        setTimeout(function () {
            mutex(key, onUnlock, attempt + 1);
        }, lockTimeout);
    }
    else {
        console.error('Unable to retrieve lock');
    }
}
var PersistedPriorityQueue = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__extends)(PersistedPriorityQueue, _super);
    function PersistedPriorityQueue(maxAttempts, key) {
        var _this = _super.call(this, maxAttempts, []) || this;
        var itemsKey = "persisted-queue:v1:".concat(key, ":items");
        var seenKey = "persisted-queue:v1:".concat(key, ":seen");
        var saved = [];
        var lastSeen = {};
        mutex(key, function () {
            try {
                saved = persisted(itemsKey);
                lastSeen = seen(seenKey);
                remove(itemsKey);
                remove(seenKey);
                _this.queue = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([], saved, true), _this.queue, true);
                _this.seen = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__assign)({}, lastSeen), _this.seen);
            }
            catch (err) {
                console.error(err);
            }
        });
        window.addEventListener('pagehide', function () {
            // we deliberately want to use the less powerful 'pagehide' API to only persist on events where the analytics instance gets destroyed, and not on tab away.
            if (_this.todo > 0) {
                var items_1 = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)((0,tslib__WEBPACK_IMPORTED_MODULE_2__.__spreadArray)([], _this.queue, true), _this.future, true);
                try {
                    mutex(key, function () {
                        persistItems(itemsKey, items_1);
                        persistSeen(seenKey, _this.seen);
                    });
                }
                catch (err) {
                    console.error(err);
                }
            }
        });
        return _this;
    }
    return PersistedPriorityQueue;
}(___WEBPACK_IMPORTED_MODULE_3__/* .PriorityQueue */ .Z));

//# sourceMappingURL=persisted.js.map

/***/ }),

/***/ 23888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ toFacade; }
/* harmony export */ });
/* harmony import */ var _segment_facade__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49969);
/* harmony import */ var _segment_facade__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_segment_facade__WEBPACK_IMPORTED_MODULE_0__);

function toFacade(evt, options) {
    var fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Facade(evt, options);
    if (evt.type === 'track') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Track(evt, options);
    }
    if (evt.type === 'identify') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Identify(evt, options);
    }
    if (evt.type === 'page') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Page(evt, options);
    }
    if (evt.type === 'alias') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Alias(evt, options);
    }
    if (evt.type === 'group') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Group(evt, options);
    }
    if (evt.type === 'screen') {
        fcd = new _segment_facade__WEBPACK_IMPORTED_MODULE_0__.Screen(evt, options);
    }
    Object.defineProperty(fcd, 'obj', {
        value: evt,
        writable: true,
    });
    return fcd;
}
//# sourceMappingURL=to-facade.js.map

/***/ }),

/***/ 7227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getVersionType; }
/* harmony export */ });
/* unused harmony export setVersionType */
// Default value will be updated to 'web' in `bundle-umd.ts` for web build.
var _version = 'npm';
function setVersionType(version) {
    _version = version;
}
function getVersionType() {
    return _version;
}
//# sourceMappingURL=version-type.js.map

/***/ }),

/***/ 66170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "applyDestinationMiddleware": function() { return /* binding */ applyDestinationMiddleware; },
/* harmony export */   "sourceMiddlewarePlugin": function() { return /* binding */ sourceMiddlewarePlugin; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97582);
/* harmony import */ var _core_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98191);
/* harmony import */ var _lib_to_facade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23888);



function applyDestinationMiddleware(destination, evt, middleware) {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(this, void 0, void 0, function () {
        function applyMiddleware(event, fn) {
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(this, void 0, void 0, function () {
                var nextCalled, returnedEvent;
                var _a;
                return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            nextCalled = false;
                            returnedEvent = null;
                            return [4 /*yield*/, fn({
                                    payload: (0,_lib_to_facade__WEBPACK_IMPORTED_MODULE_1__/* .toFacade */ .D)(event, {
                                        clone: true,
                                        traverse: false,
                                    }),
                                    integration: destination,
                                    next: function (evt) {
                                        nextCalled = true;
                                        if (evt === null) {
                                            returnedEvent = null;
                                        }
                                        if (evt) {
                                            returnedEvent = evt.obj;
                                        }
                                    },
                                })];
                        case 1:
                            _b.sent();
                            if (!nextCalled && returnedEvent !== null) {
                                returnedEvent = returnedEvent;
                                returnedEvent.integrations = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)((0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, event.integrations), (_a = {}, _a[destination] = false, _a));
                            }
                            return [2 /*return*/, returnedEvent];
                    }
                });
            });
        }
        var modifiedEvent, _i, middleware_1, md, result;
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    modifiedEvent = (0,_lib_to_facade__WEBPACK_IMPORTED_MODULE_1__/* .toFacade */ .D)(evt, {
                        clone: true,
                        traverse: false,
                    }).rawEvent();
                    _i = 0, middleware_1 = middleware;
                    _a.label = 1;
                case 1:
                    if (!(_i < middleware_1.length)) return [3 /*break*/, 4];
                    md = middleware_1[_i];
                    return [4 /*yield*/, applyMiddleware(modifiedEvent, md)];
                case 2:
                    result = _a.sent();
                    if (result === null) {
                        return [2 /*return*/, null];
                    }
                    modifiedEvent = result;
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, modifiedEvent];
            }
        });
    });
}
function sourceMiddlewarePlugin(fn, integrations) {
    function apply(ctx) {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__awaiter)(this, void 0, void 0, function () {
            var nextCalled;
            return (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nextCalled = false;
                        return [4 /*yield*/, fn({
                                payload: (0,_lib_to_facade__WEBPACK_IMPORTED_MODULE_1__/* .toFacade */ .D)(ctx.event, {
                                    clone: true,
                                    traverse: false,
                                }),
                                integrations: integrations !== null && integrations !== void 0 ? integrations : {},
                                next: function (evt) {
                                    nextCalled = true;
                                    if (evt) {
                                        ctx.event = evt.obj;
                                    }
                                },
                            })];
                    case 1:
                        _a.sent();
                        if (!nextCalled) {
                            throw new _core_context__WEBPACK_IMPORTED_MODULE_2__/* .ContextCancelation */ .Y({
                                retry: false,
                                type: 'middleware_cancellation',
                                reason: 'Middleware `next` function skipped',
                            });
                        }
                        return [2 /*return*/, ctx];
                }
            });
        });
    }
    return {
        name: "Source Middleware ".concat(fn.name),
        type: 'before',
        version: '0.1.0',
        isLoaded: function () { return true; },
        load: function (ctx) { return Promise.resolve(ctx); },
        track: apply,
        page: apply,
        screen: apply,
        identify: apply,
        alias: apply,
        group: apply,
    };
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 16025:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var obj_case_1 = __importDefault(__webpack_require__(53410));
function trait(a, b) {
    return function () {
        var traits = this.traits();
        var props = this.properties ? this.properties() : {};
        return (obj_case_1.default(traits, "address." + a) ||
            obj_case_1.default(traits, a) ||
            (b ? obj_case_1.default(traits, "address." + b) : null) ||
            (b ? obj_case_1.default(traits, b) : null) ||
            obj_case_1.default(props, "address." + a) ||
            obj_case_1.default(props, a) ||
            (b ? obj_case_1.default(props, "address." + b) : null) ||
            (b ? obj_case_1.default(props, b) : null));
    };
}
function default_1(proto) {
    proto.zip = trait("postalCode", "zip");
    proto.country = trait("country");
    proto.street = trait("street");
    proto.state = trait("state");
    proto.city = trait("city");
    proto.region = trait("region");
}
exports["default"] = default_1;
//# sourceMappingURL=address.js.map

/***/ }),

/***/ 36576:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Alias = void 0;
var inherits_1 = __importDefault(__webpack_require__(35717));
var facade_1 = __webpack_require__(40747);
function Alias(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Alias = Alias;
inherits_1.default(Alias, facade_1.Facade);
Alias.prototype.action = function () {
    return "alias";
};
Alias.prototype.type = Alias.prototype.action;
Alias.prototype.previousId = function () {
    return this.field("previousId") || this.field("from");
};
Alias.prototype.from = Alias.prototype.previousId;
Alias.prototype.userId = function () {
    return this.field("userId") || this.field("to");
};
Alias.prototype.to = Alias.prototype.userId;
//# sourceMappingURL=alias.js.map

/***/ }),

/***/ 83948:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.clone = void 0;
function clone(properties) {
    if (typeof properties !== 'object')
        return properties;
    if (Object.prototype.toString.call(properties) === '[object Object]') {
        var temp = {};
        for (var key in properties) {
            if (Object.prototype.hasOwnProperty.call(properties, key)) {
                temp[key] = clone(properties[key]);
            }
        }
        return temp;
    }
    else if (Array.isArray(properties)) {
        return properties.map(clone);
    }
    else {
        return properties;
    }
}
exports.clone = clone;
//# sourceMappingURL=clone.js.map

/***/ }),

/***/ 85655:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Delete = void 0;
var inherits_1 = __importDefault(__webpack_require__(35717));
var facade_1 = __webpack_require__(40747);
function Delete(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Delete = Delete;
inherits_1.default(Delete, facade_1.Facade);
Delete.prototype.type = function () {
    return "delete";
};
//# sourceMappingURL=delete.js.map

/***/ }),

/***/ 40747:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Facade = void 0;
var address_1 = __importDefault(__webpack_require__(16025));
var clone_1 = __webpack_require__(83948);
var is_enabled_1 = __importDefault(__webpack_require__(2530));
var new_date_1 = __importDefault(__webpack_require__(18013));
var obj_case_1 = __importDefault(__webpack_require__(53410));
var isodate_traverse_1 = __importDefault(__webpack_require__(28595));
function Facade(obj, opts) {
    opts = opts || {};
    this.raw = clone_1.clone(obj);
    if (!("clone" in opts))
        opts.clone = true;
    if (opts.clone)
        obj = clone_1.clone(obj);
    if (!("traverse" in opts))
        opts.traverse = true;
    if (!("timestamp" in obj))
        obj.timestamp = new Date();
    else
        obj.timestamp = new_date_1.default(obj.timestamp);
    if (opts.traverse)
        isodate_traverse_1.default(obj);
    this.opts = opts;
    this.obj = obj;
}
exports.Facade = Facade;
var f = Facade.prototype;
f.proxy = function (field) {
    var fields = field.split(".");
    field = fields.shift();
    var obj = this[field] || this.obj[field];
    if (!obj)
        return obj;
    if (typeof obj === "function")
        obj = obj.call(this) || {};
    if (fields.length === 0)
        return this.opts.clone ? transform(obj) : obj;
    obj = obj_case_1.default(obj, fields.join("."));
    return this.opts.clone ? transform(obj) : obj;
};
f.field = function (field) {
    var obj = this.obj[field];
    return this.opts.clone ? transform(obj) : obj;
};
Facade.proxy = function (field) {
    return function () {
        return this.proxy(field);
    };
};
Facade.field = function (field) {
    return function () {
        return this.field(field);
    };
};
Facade.multi = function (path) {
    return function () {
        var multi = this.proxy(path + "s");
        if (Array.isArray(multi))
            return multi;
        var one = this.proxy(path);
        if (one)
            one = [this.opts.clone ? clone_1.clone(one) : one];
        return one || [];
    };
};
Facade.one = function (path) {
    return function () {
        var one = this.proxy(path);
        if (one)
            return one;
        var multi = this.proxy(path + "s");
        if (Array.isArray(multi))
            return multi[0];
    };
};
f.json = function () {
    var ret = this.opts.clone ? clone_1.clone(this.obj) : this.obj;
    if (this.type)
        ret.type = this.type();
    return ret;
};
f.rawEvent = function () {
    return this.raw;
};
f.options = function (integration) {
    var obj = this.obj.options || this.obj.context || {};
    var options = this.opts.clone ? clone_1.clone(obj) : obj;
    if (!integration)
        return options;
    if (!this.enabled(integration))
        return;
    var integrations = this.integrations();
    var value = integrations[integration] || obj_case_1.default(integrations, integration);
    if (typeof value !== "object")
        value = obj_case_1.default(this.options(), integration);
    return typeof value === "object" ? value : {};
};
f.context = f.options;
f.enabled = function (integration) {
    var allEnabled = this.proxy("options.providers.all");
    if (typeof allEnabled !== "boolean")
        allEnabled = this.proxy("options.all");
    if (typeof allEnabled !== "boolean")
        allEnabled = this.proxy("integrations.all");
    if (typeof allEnabled !== "boolean")
        allEnabled = true;
    var enabled = allEnabled && is_enabled_1.default(integration);
    var options = this.integrations();
    if (options.providers && options.providers.hasOwnProperty(integration)) {
        enabled = options.providers[integration];
    }
    if (options.hasOwnProperty(integration)) {
        var settings = options[integration];
        if (typeof settings === "boolean") {
            enabled = settings;
        }
        else {
            enabled = true;
        }
    }
    return !!enabled;
};
f.integrations = function () {
    return (this.obj.integrations || this.proxy("options.providers") || this.options());
};
f.active = function () {
    var active = this.proxy("options.active");
    if (active === null || active === undefined)
        active = true;
    return active;
};
f.anonymousId = function () {
    return this.field("anonymousId") || this.field("sessionId");
};
f.sessionId = f.anonymousId;
f.groupId = Facade.proxy("options.groupId");
f.traits = function (aliases) {
    var ret = this.proxy("options.traits") || {};
    var id = this.userId();
    aliases = aliases || {};
    if (id)
        ret.id = id;
    for (var alias in aliases) {
        if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
            var value = this[alias] == null
                ? this.proxy("options.traits." + alias)
                : this[alias]();
            if (value == null)
                continue;
            ret[aliases[alias]] = value;
            delete ret[alias];
        }
    }
    return ret;
};
f.library = function () {
    var library = this.proxy("options.library");
    if (!library)
        return { name: "unknown", version: null };
    if (typeof library === "string")
        return { name: library, version: null };
    return library;
};
f.device = function () {
    var device = this.proxy("context.device");
    if (typeof device !== "object" || device === null) {
        device = {};
    }
    var library = this.library().name;
    if (device.type)
        return device;
    if (library.indexOf("ios") > -1)
        device.type = "ios";
    if (library.indexOf("android") > -1)
        device.type = "android";
    return device;
};
f.userAgent = Facade.proxy("context.userAgent");
f.timezone = Facade.proxy("context.timezone");
f.timestamp = Facade.field("timestamp");
f.channel = Facade.field("channel");
f.ip = Facade.proxy("context.ip");
f.userId = Facade.field("userId");
address_1.default(f);
function transform(obj) {
    return clone_1.clone(obj);
}
//# sourceMappingURL=facade.js.map

/***/ }),

/***/ 63789:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Group = void 0;
var inherits_1 = __importDefault(__webpack_require__(35717));
var is_email_1 = __importDefault(__webpack_require__(66243));
var new_date_1 = __importDefault(__webpack_require__(18013));
var facade_1 = __webpack_require__(40747);
function Group(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Group = Group;
inherits_1.default(Group, facade_1.Facade);
var g = Group.prototype;
g.action = function () {
    return "group";
};
g.type = g.action;
g.groupId = facade_1.Facade.field("groupId");
g.created = function () {
    var created = this.proxy("traits.createdAt") ||
        this.proxy("traits.created") ||
        this.proxy("properties.createdAt") ||
        this.proxy("properties.created");
    if (created)
        return new_date_1.default(created);
};
g.email = function () {
    var email = this.proxy("traits.email");
    if (email)
        return email;
    var groupId = this.groupId();
    if (is_email_1.default(groupId))
        return groupId;
};
g.traits = function (aliases) {
    var ret = this.properties();
    var id = this.groupId();
    aliases = aliases || {};
    if (id)
        ret.id = id;
    for (var alias in aliases) {
        if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
            var value = this[alias] == null
                ? this.proxy("traits." + alias)
                : this[alias]();
            if (value == null)
                continue;
            ret[aliases[alias]] = value;
            delete ret[alias];
        }
    }
    return ret;
};
g.name = facade_1.Facade.proxy("traits.name");
g.industry = facade_1.Facade.proxy("traits.industry");
g.employees = facade_1.Facade.proxy("traits.employees");
g.properties = function () {
    return this.field("traits") || this.field("properties") || {};
};
//# sourceMappingURL=group.js.map

/***/ }),

/***/ 98649:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Identify = void 0;
var facade_1 = __webpack_require__(40747);
var obj_case_1 = __importDefault(__webpack_require__(53410));
var inherits_1 = __importDefault(__webpack_require__(35717));
var is_email_1 = __importDefault(__webpack_require__(66243));
var new_date_1 = __importDefault(__webpack_require__(18013));
var trim = function (str) { return str.trim(); };
function Identify(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Identify = Identify;
inherits_1.default(Identify, facade_1.Facade);
var i = Identify.prototype;
i.action = function () {
    return "identify";
};
i.type = i.action;
i.traits = function (aliases) {
    var ret = this.field("traits") || {};
    var id = this.userId();
    aliases = aliases || {};
    if (id)
        ret.id = id;
    for (var alias in aliases) {
        var value = this[alias] == null ? this.proxy("traits." + alias) : this[alias]();
        if (value == null)
            continue;
        ret[aliases[alias]] = value;
        if (alias !== aliases[alias])
            delete ret[alias];
    }
    return ret;
};
i.email = function () {
    var email = this.proxy("traits.email");
    if (email)
        return email;
    var userId = this.userId();
    if (is_email_1.default(userId))
        return userId;
};
i.created = function () {
    var created = this.proxy("traits.created") || this.proxy("traits.createdAt");
    if (created)
        return new_date_1.default(created);
};
i.companyCreated = function () {
    var created = this.proxy("traits.company.created") ||
        this.proxy("traits.company.createdAt");
    if (created) {
        return new_date_1.default(created);
    }
};
i.companyName = function () {
    return this.proxy("traits.company.name");
};
i.name = function () {
    var name = this.proxy("traits.name");
    if (typeof name === "string") {
        return trim(name);
    }
    var firstName = this.firstName();
    var lastName = this.lastName();
    if (firstName && lastName) {
        return trim(firstName + " " + lastName);
    }
};
i.firstName = function () {
    var firstName = this.proxy("traits.firstName");
    if (typeof firstName === "string") {
        return trim(firstName);
    }
    var name = this.proxy("traits.name");
    if (typeof name === "string") {
        return trim(name).split(" ")[0];
    }
};
i.lastName = function () {
    var lastName = this.proxy("traits.lastName");
    if (typeof lastName === "string") {
        return trim(lastName);
    }
    var name = this.proxy("traits.name");
    if (typeof name !== "string") {
        return;
    }
    var space = trim(name).indexOf(" ");
    if (space === -1) {
        return;
    }
    return trim(name.substr(space + 1));
};
i.uid = function () {
    return this.userId() || this.username() || this.email();
};
i.description = function () {
    return this.proxy("traits.description") || this.proxy("traits.background");
};
i.age = function () {
    var date = this.birthday();
    var age = obj_case_1.default(this.traits(), "age");
    if (age != null)
        return age;
    if (!(date instanceof Date))
        return;
    var now = new Date();
    return now.getFullYear() - date.getFullYear();
};
i.avatar = function () {
    var traits = this.traits();
    return (obj_case_1.default(traits, "avatar") || obj_case_1.default(traits, "photoUrl") || obj_case_1.default(traits, "avatarUrl"));
};
i.position = function () {
    var traits = this.traits();
    return obj_case_1.default(traits, "position") || obj_case_1.default(traits, "jobTitle");
};
i.username = facade_1.Facade.proxy("traits.username");
i.website = facade_1.Facade.one("traits.website");
i.websites = facade_1.Facade.multi("traits.website");
i.phone = facade_1.Facade.one("traits.phone");
i.phones = facade_1.Facade.multi("traits.phone");
i.address = facade_1.Facade.proxy("traits.address");
i.gender = facade_1.Facade.proxy("traits.gender");
i.birthday = facade_1.Facade.proxy("traits.birthday");
//# sourceMappingURL=identify.js.map

/***/ }),

/***/ 49969:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Delete = exports.Screen = exports.Page = exports.Track = exports.Identify = exports.Group = exports.Alias = exports.Facade = void 0;
var facade_1 = __webpack_require__(40747);
Object.defineProperty(exports, "Facade", ({ enumerable: true, get: function () { return facade_1.Facade; } }));
var alias_1 = __webpack_require__(36576);
Object.defineProperty(exports, "Alias", ({ enumerable: true, get: function () { return alias_1.Alias; } }));
var group_1 = __webpack_require__(63789);
Object.defineProperty(exports, "Group", ({ enumerable: true, get: function () { return group_1.Group; } }));
var identify_1 = __webpack_require__(98649);
Object.defineProperty(exports, "Identify", ({ enumerable: true, get: function () { return identify_1.Identify; } }));
var track_1 = __webpack_require__(27286);
Object.defineProperty(exports, "Track", ({ enumerable: true, get: function () { return track_1.Track; } }));
var page_1 = __webpack_require__(83070);
Object.defineProperty(exports, "Page", ({ enumerable: true, get: function () { return page_1.Page; } }));
var screen_1 = __webpack_require__(69860);
Object.defineProperty(exports, "Screen", ({ enumerable: true, get: function () { return screen_1.Screen; } }));
var delete_1 = __webpack_require__(85655);
Object.defineProperty(exports, "Delete", ({ enumerable: true, get: function () { return delete_1.Delete; } }));
exports["default"] = __assign(__assign({}, facade_1.Facade), { Alias: alias_1.Alias,
    Group: group_1.Group,
    Identify: identify_1.Identify,
    Track: track_1.Track,
    Page: page_1.Page,
    Screen: screen_1.Screen,
    Delete: delete_1.Delete });
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 66243:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var matcher = /.+\@.+\..+/;
function isEmail(string) {
    return matcher.test(string);
}
exports["default"] = isEmail;
//# sourceMappingURL=is-email.js.map

/***/ }),

/***/ 2530:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var disabled = {
    Salesforce: true,
};
function default_1(integration) {
    return !disabled[integration];
}
exports["default"] = default_1;
//# sourceMappingURL=is-enabled.js.map

/***/ }),

/***/ 83070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Page = void 0;
var inherits_1 = __importDefault(__webpack_require__(35717));
var facade_1 = __webpack_require__(40747);
var track_1 = __webpack_require__(27286);
var is_email_1 = __importDefault(__webpack_require__(66243));
function Page(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Page = Page;
inherits_1.default(Page, facade_1.Facade);
var p = Page.prototype;
p.action = function () {
    return "page";
};
p.type = p.action;
p.category = facade_1.Facade.field("category");
p.name = facade_1.Facade.field("name");
p.title = facade_1.Facade.proxy("properties.title");
p.path = facade_1.Facade.proxy("properties.path");
p.url = facade_1.Facade.proxy("properties.url");
p.referrer = function () {
    return (this.proxy("context.referrer.url") ||
        this.proxy("context.page.referrer") ||
        this.proxy("properties.referrer"));
};
p.properties = function (aliases) {
    var props = this.field("properties") || {};
    var category = this.category();
    var name = this.name();
    aliases = aliases || {};
    if (category)
        props.category = category;
    if (name)
        props.name = name;
    for (var alias in aliases) {
        if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
            var value = this[alias] == null
                ? this.proxy("properties." + alias)
                : this[alias]();
            if (value == null)
                continue;
            props[aliases[alias]] = value;
            if (alias !== aliases[alias])
                delete props[alias];
        }
    }
    return props;
};
p.email = function () {
    var email = this.proxy("context.traits.email") || this.proxy("properties.email");
    if (email)
        return email;
    var userId = this.userId();
    if (is_email_1.default(userId))
        return userId;
};
p.fullName = function () {
    var category = this.category();
    var name = this.name();
    return name && category ? category + " " + name : name;
};
p.event = function (name) {
    return name ? "Viewed " + name + " Page" : "Loaded a Page";
};
p.track = function (name) {
    var json = this.json();
    json.event = this.event(name);
    json.timestamp = this.timestamp();
    json.properties = this.properties();
    return new track_1.Track(json, this.opts);
};
//# sourceMappingURL=page.js.map

/***/ }),

/***/ 69860:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Screen = void 0;
var inherits_1 = __importDefault(__webpack_require__(35717));
var page_1 = __webpack_require__(83070);
var track_1 = __webpack_require__(27286);
function Screen(dictionary, opts) {
    page_1.Page.call(this, dictionary, opts);
}
exports.Screen = Screen;
inherits_1.default(Screen, page_1.Page);
Screen.prototype.action = function () {
    return "screen";
};
Screen.prototype.type = Screen.prototype.action;
Screen.prototype.event = function (name) {
    return name ? "Viewed " + name + " Screen" : "Loaded a Screen";
};
Screen.prototype.track = function (name) {
    var json = this.json();
    json.event = this.event(name);
    json.timestamp = this.timestamp();
    json.properties = this.properties();
    return new track_1.Track(json, this.opts);
};
//# sourceMappingURL=screen.js.map

/***/ }),

/***/ 27286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Track = void 0;
var inherits_1 = __importDefault(__webpack_require__(35717));
var facade_1 = __webpack_require__(40747);
var identify_1 = __webpack_require__(98649);
var is_email_1 = __importDefault(__webpack_require__(66243));
var obj_case_1 = __importDefault(__webpack_require__(53410));
function Track(dictionary, opts) {
    facade_1.Facade.call(this, dictionary, opts);
}
exports.Track = Track;
inherits_1.default(Track, facade_1.Facade);
var t = Track.prototype;
t.action = function () {
    return "track";
};
t.type = t.action;
t.event = facade_1.Facade.field("event");
t.value = facade_1.Facade.proxy("properties.value");
t.category = facade_1.Facade.proxy("properties.category");
t.id = facade_1.Facade.proxy("properties.id");
t.productId = function () {
    return (this.proxy("properties.product_id") || this.proxy("properties.productId"));
};
t.promotionId = function () {
    return (this.proxy("properties.promotion_id") ||
        this.proxy("properties.promotionId"));
};
t.cartId = function () {
    return this.proxy("properties.cart_id") || this.proxy("properties.cartId");
};
t.checkoutId = function () {
    return (this.proxy("properties.checkout_id") || this.proxy("properties.checkoutId"));
};
t.paymentId = function () {
    return (this.proxy("properties.payment_id") || this.proxy("properties.paymentId"));
};
t.couponId = function () {
    return (this.proxy("properties.coupon_id") || this.proxy("properties.couponId"));
};
t.wishlistId = function () {
    return (this.proxy("properties.wishlist_id") || this.proxy("properties.wishlistId"));
};
t.reviewId = function () {
    return (this.proxy("properties.review_id") || this.proxy("properties.reviewId"));
};
t.orderId = function () {
    return (this.proxy("properties.id") ||
        this.proxy("properties.order_id") ||
        this.proxy("properties.orderId"));
};
t.sku = facade_1.Facade.proxy("properties.sku");
t.tax = facade_1.Facade.proxy("properties.tax");
t.name = facade_1.Facade.proxy("properties.name");
t.price = facade_1.Facade.proxy("properties.price");
t.total = facade_1.Facade.proxy("properties.total");
t.repeat = facade_1.Facade.proxy("properties.repeat");
t.coupon = facade_1.Facade.proxy("properties.coupon");
t.shipping = facade_1.Facade.proxy("properties.shipping");
t.discount = facade_1.Facade.proxy("properties.discount");
t.shippingMethod = function () {
    return (this.proxy("properties.shipping_method") ||
        this.proxy("properties.shippingMethod"));
};
t.paymentMethod = function () {
    return (this.proxy("properties.payment_method") ||
        this.proxy("properties.paymentMethod"));
};
t.description = facade_1.Facade.proxy("properties.description");
t.plan = facade_1.Facade.proxy("properties.plan");
t.subtotal = function () {
    var subtotal = obj_case_1.default(this.properties(), "subtotal");
    var total = this.total() || this.revenue();
    if (subtotal)
        return subtotal;
    if (!total)
        return 0;
    if (this.total()) {
        var n = this.tax();
        if (n)
            total -= n;
        n = this.shipping();
        if (n)
            total -= n;
        n = this.discount();
        if (n)
            total += n;
    }
    return total;
};
t.products = function () {
    var props = this.properties();
    var products = obj_case_1.default(props, "products");
    if (Array.isArray(products)) {
        return products.filter(function (item) { return item !== null; });
    }
    return [];
};
t.quantity = function () {
    var props = this.obj.properties || {};
    return props.quantity || 1;
};
t.currency = function () {
    var props = this.obj.properties || {};
    return props.currency || "USD";
};
t.referrer = function () {
    return (this.proxy("context.referrer.url") ||
        this.proxy("context.page.referrer") ||
        this.proxy("properties.referrer"));
};
t.query = facade_1.Facade.proxy("options.query");
t.properties = function (aliases) {
    var ret = this.field("properties") || {};
    aliases = aliases || {};
    for (var alias in aliases) {
        if (Object.prototype.hasOwnProperty.call(aliases, alias)) {
            var value = this[alias] == null
                ? this.proxy("properties." + alias)
                : this[alias]();
            if (value == null)
                continue;
            ret[aliases[alias]] = value;
            delete ret[alias];
        }
    }
    return ret;
};
t.username = function () {
    return (this.proxy("traits.username") ||
        this.proxy("properties.username") ||
        this.userId() ||
        this.sessionId());
};
t.email = function () {
    var email = this.proxy("traits.email") ||
        this.proxy("properties.email") ||
        this.proxy("options.traits.email");
    if (email)
        return email;
    var userId = this.userId();
    if (is_email_1.default(userId))
        return userId;
};
t.revenue = function () {
    var revenue = this.proxy("properties.revenue");
    var event = this.event();
    var orderCompletedRegExp = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
    if (!revenue && event && event.match(orderCompletedRegExp)) {
        revenue = this.proxy("properties.total");
    }
    return currency(revenue);
};
t.cents = function () {
    var revenue = this.revenue();
    return typeof revenue !== "number" ? this.value() || 0 : revenue * 100;
};
t.identify = function () {
    var json = this.json();
    json.traits = this.traits();
    return new identify_1.Identify(json, this.opts);
};
function currency(val) {
    if (!val)
        return;
    if (typeof val === "number") {
        return val;
    }
    if (typeof val !== "string") {
        return;
    }
    val = val.replace(/\$/g, "");
    val = parseFloat(val);
    if (!isNaN(val)) {
        return val;
    }
}
//# sourceMappingURL=track.js.map

/***/ }),

/***/ 28595:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isodate = __webpack_require__(28336);

/**
 * Expose `traverse`.
 */
module.exports = traverse;

/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */
function traverse(input, strict) {
  if (strict === undefined) strict = true;
  if (input && typeof input === 'object') {
    return traverseObject(input, strict);
  } else if (Array.isArray(input)) {
    return traverseArray(input, strict);
  } else if (isodate.is(input, strict)) {
    return isodate.parse(input);
  }
  return input;
}

/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */
function traverseObject(obj, strict) {
  Object.keys(obj).forEach(function(key) {
    obj[key] = traverse(obj[key], strict);
  });
  return obj;
}

/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */
function traverseArray(arr, strict) {
  arr.forEach(function(value, index) {
    arr[index] = traverse(value, strict);
  });
  return arr;
}


/***/ }),

/***/ 28336:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */

var matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;

/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */

exports.parse = function(iso) {
  var numericKeys = [1, 5, 6, 7, 11, 12];
  var arr = matcher.exec(iso);
  var offset = 0;

  // fallback to native parsing
  if (!arr) {
    return new Date(iso);
  }

  /* eslint-disable no-cond-assign */
  // remove undefined values
  for (var i = 0, val; val = numericKeys[i]; i++) {
    arr[val] = parseInt(arr[val], 10) || 0;
  }
  /* eslint-enable no-cond-assign */

  // allow undefined days and months
  arr[2] = parseInt(arr[2], 10) || 1;
  arr[3] = parseInt(arr[3], 10) || 1;

  // month is 0-11
  arr[2]--;

  // allow abitrary sub-second precision
  arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;

  // apply timezone if one exists
  if (arr[4] === ' ') {
    offset = new Date().getTimezoneOffset();
  } else if (arr[9] !== 'Z' && arr[10]) {
    offset = arr[11] * 60 + arr[12];
    if (arr[10] === '+') {
      offset = 0 - offset;
    }
  }

  var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
  return new Date(millis);
};


/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */

exports.is = function(string, strict) {
  if (typeof string !== 'string') {
    return false;
  }
  if (strict && (/^\d{4}-\d{2}-\d{2}/).test(string) === false) {
    return false;
  }
  return matcher.test(string);
};


/***/ }),

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.lW = Buffer
__webpack_unused_export__ = SlowBuffer
exports.h2 = 50

var K_MAX_LENGTH = 0x7fffffff
__webpack_unused_export__ = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.h2
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 35717:
/***/ (function(module) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 30381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                Object(function webpackMissingModule() { var e = new Error("Cannot find module 'undefined'"); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 18013:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isodate = __webpack_require__(28336);
var milliseconds = __webpack_require__(18040);
var seconds = __webpack_require__(24085);

var objProto = Object.prototype;
var toStr = objProto.toString;

function isDate(value) {
  return toStr.call(value) === "[object Date]";
}

function isNumber(value) {
  return toStr.call(value) === "[object Number]";
}

/**
 * Returns a new Javascript Date object, allowing a variety of extra input types
 * over the native Date constructor.
 *
 * @param {Date|string|number} val
 */
module.exports = function newDate(val) {
  if (isDate(val)) return val;
  if (isNumber(val)) return new Date(toMs(val));

  // date strings
  if (isodate.is(val)) {
    return isodate.parse(val);
  }
  if (milliseconds.is(val)) {
    return milliseconds.parse(val);
  }
  if (seconds.is(val)) {
    return seconds.parse(val);
  }

  // fallback to Date.parse
  return new Date(val);
};

/**
 * If the number passed val is seconds from the epoch, turn it into milliseconds.
 * Milliseconds would be greater than 31557600000 (December 31, 1970).
 *
 * @param {number} num
 */
function toMs(num) {
  if (num < 31557600000) return num * 1000;
  return num;
}


/***/ }),

/***/ 18040:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * Matcher.
 */

var matcher = /\d{13}/;

/**
 * Check whether a string is a millisecond date string.
 *
 * @param {string} string
 * @return {boolean}
 */
exports.is = function (string) {
  return matcher.test(string);
};

/**
 * Convert a millisecond string to a date.
 *
 * @param {string} millis
 * @return {Date}
 */
exports.parse = function (millis) {
  millis = parseInt(millis, 10);
  return new Date(millis);
};


/***/ }),

/***/ 24085:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


/**
 * Matcher.
 */

var matcher = /\d{10}/;

/**
 * Check whether a string is a second date string.
 *
 * @param {string} string
 * @return {Boolean}
 */
exports.is = function (string) {
  return matcher.test(string);
};

/**
 * Convert a second string to a date.
 *
 * @param {string} seconds
 * @return {Date}
 */
exports.parse = function (seconds) {
  var millis = parseInt(seconds, 10) * 1000;
  return new Date(millis);
};


/***/ }),

/***/ 31365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(92162)


/***/ }),

/***/ 63144:
/***/ (function(module) {

"use strict";

/* globals self */ var fetch = self.fetch.bind(self);
module.exports = fetch;
module.exports["default"] = module.exports;

//# sourceMappingURL=index.js.map

/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(48803);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92729);
var ref;

var api = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: (ref = "https://api.littleemperors.com/v1") === null || ref === void 0 ? void 0 : ref.replace("v1", "api"),
    headers: {
        "Content-Type": "application/json",
        "App-Version": "Website",
        Authorization: "Bearer ".concat("eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxMCIsImp0aSI6IjIwYjI0NWU4MDBkYzc2NTk2YTI0MjhkMWFiMjQ1ZDgyOTdiYTc4OTk4MThiMmYxZWE1ZGUxYWRhNGU2MjU3NmM5YzgwOTZkZmYzOTUyNWM3IiwiaWF0IjoxNzgxMTAyMDc4LjEwMzQxMSwibmJmIjoxNzgxMTAyMDc4LjEwMzQxNCwiZXhwIjoxODEyNjM4MDc4LjA5ODkxNSwic3ViIjoiIiwic2NvcGVzIjpbXX0.GZgKyVW-aDaH7Z0KqXvHfxqWbtSWssr5v5JlsK3rioVlVRhosnxBOItTtIPIacBioyluTYqsAaUG8VxnMMCWz3DXOAxnBSZGyMCKujwgEOrfM6UNIxVFctj7hZV9yuUsFYqjt31y2nqHC24e1wfenQ_LkV-TwA6VmHMH7laOhIhzz3e65Yl1wm6xVVRUtm_2U-R0jt63EhmNhUqVV_OhQxSDM4OEMk7SLOf_MTqtxuJeM_Z_KOTQRD8PRL3qcfEf2sk1WhAGbFWS5Cs80zPb9uNjAsTimkKOKVqy58NLlVPtUtB4OxskEBY1Mb1i4oa-3BeR10CcT7cujZ1bKtpqVCi62tWddli3iyfiFuIdZISPSVUSkmhfDlgtMMJhxWsobetHfXgLgru_D3hfacyyPlKHrB2P8PsUqW24QHUMeyIzQzhSaKs3b8571jRsjlh-fmREClaFq5gJ6-605c3CUXGzbbXOv2o7sS8L72twr1L4Z-UrtLogzI_MYwmN7Cwb9scNRlGLOgaS4zEMH7HlvDRoByIa2H3Pz5GF3Z6C2DXgJTTy_jQXrJaoJsDArXAuyb10ZXwjtZ8aVjCAiTr2vXu6XGpFux7DRQrcIXe1nfYbln8c2QdzgyEQWgK8cYIGXio4wmLJewSoNst7XiuQyd4w1M4V7poLuZoG61Lu_oA")
    }
});
api.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    var ref, ref1;
    if ((ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
        return Promise.reject(new Error(error.response.data.message));
    }
    return Promise.reject(new Error("An unexpected error occurred. Please try again."));
});
/* harmony default export */ __webpack_exports__["Z"] = (api);


/***/ }),

/***/ 58081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "hi": function() { return /* reexport */ api_api/* default */.Z; },
  "ZP": function() { return /* reexport */ v1Api; },
  "av": function() { return /* reexport */ api_internalApi; }
});

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 50 modules
var axios = __webpack_require__(92729);
;// CONCATENATED MODULE: ./api/v1Api.ts

var api = axios/* default.create */.Z.create({
    baseURL: "https://api.littleemperors.com/v1",
    headers: {
        "Content-Type": "application/json",
        "App-Version": "Website",
        Authorization: "Bearer ".concat("eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxMCIsImp0aSI6IjIwYjI0NWU4MDBkYzc2NTk2YTI0MjhkMWFiMjQ1ZDgyOTdiYTc4OTk4MThiMmYxZWE1ZGUxYWRhNGU2MjU3NmM5YzgwOTZkZmYzOTUyNWM3IiwiaWF0IjoxNzgxMTAyMDc4LjEwMzQxMSwibmJmIjoxNzgxMTAyMDc4LjEwMzQxNCwiZXhwIjoxODEyNjM4MDc4LjA5ODkxNSwic3ViIjoiIiwic2NvcGVzIjpbXX0.GZgKyVW-aDaH7Z0KqXvHfxqWbtSWssr5v5JlsK3rioVlVRhosnxBOItTtIPIacBioyluTYqsAaUG8VxnMMCWz3DXOAxnBSZGyMCKujwgEOrfM6UNIxVFctj7hZV9yuUsFYqjt31y2nqHC24e1wfenQ_LkV-TwA6VmHMH7laOhIhzz3e65Yl1wm6xVVRUtm_2U-R0jt63EhmNhUqVV_OhQxSDM4OEMk7SLOf_MTqtxuJeM_Z_KOTQRD8PRL3qcfEf2sk1WhAGbFWS5Cs80zPb9uNjAsTimkKOKVqy58NLlVPtUtB4OxskEBY1Mb1i4oa-3BeR10CcT7cujZ1bKtpqVCi62tWddli3iyfiFuIdZISPSVUSkmhfDlgtMMJhxWsobetHfXgLgru_D3hfacyyPlKHrB2P8PsUqW24QHUMeyIzQzhSaKs3b8571jRsjlh-fmREClaFq5gJ6-605c3CUXGzbbXOv2o7sS8L72twr1L4Z-UrtLogzI_MYwmN7Cwb9scNRlGLOgaS4zEMH7HlvDRoByIa2H3Pz5GF3Z6C2DXgJTTy_jQXrJaoJsDArXAuyb10ZXwjtZ8aVjCAiTr2vXu6XGpFux7DRQrcIXe1nfYbln8c2QdzgyEQWgK8cYIGXio4wmLJewSoNst7XiuQyd4w1M4V7poLuZoG61Lu_oA")
    }
});
/* harmony default export */ var v1Api = (api);

;// CONCATENATED MODULE: ./api/internalApi.ts

var internalApi = axios/* default.create */.Z.create({
    baseURL: "/api",
    headers: {
        "Content-Type": "application/json"
    }
});
internalApi.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    var ref, ref1;
    if ((ref = error.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) {
        return Promise.reject(new Error(error.response.data.message));
    }
    return Promise.reject(new Error("An unexpected error occurred. Please try again."));
});
/* harmony default export */ var api_internalApi = (internalApi);

// EXTERNAL MODULE: ./api/api.ts
var api_api = __webpack_require__(77907);
;// CONCATENATED MODULE: ./api/index.ts





/***/ }),

/***/ 62643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useSearchBarContext; },
/* harmony export */   "t": function() { return /* binding */ SearchBarProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var SearchBarContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(undefined);
var initialState = {
    searchInputValue: "",
    debouncedSearchInputValue: "",
    searchSuggestionList: [],
    showSearchSuggestions: false,
    selectedSuggestion: null,
    isLoadingSearchSuggestionList: false,
    noResultsFound: false,
    showInspirationCategories: false
};
var SearchBarProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initialState), state = ref[0], setState = ref[1];
    var dispatchSliceOfState = function(newState) {
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prevState, newState);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SearchBarContext.Provider, {
        value: {
            state: state,
            setState: dispatchSliceOfState
        },
        children: children
    });
};
var useSearchBarContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SearchBarContext);
    if (context === undefined) {
        throw new Error("useSearchBarContext must be used within a SearchBarProvider");
    }
    return context;
};



/***/ }),

/***/ 52961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useAuth_AuthProvider; },
  "a": function() { return /* binding */ useAuth; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(58081);
;// CONCATENATED MODULE: ./customHooks/useAuth/AuthContext.ts

var AuthContext = (0,react.createContext)({
    signedIn: false
});
/* harmony default export */ var useAuth_AuthContext = (AuthContext);

;// CONCATENATED MODULE: ./customHooks/useAuth/AuthProvider.tsx




var AuthProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isSignedIn = ref[0], setIsSignedIn = ref[1];
    (0,react.useEffect)(function() {
        var validateToken = function() {
            api/* internalApi.get */.av.get("/me").then(function(param) {
                var data = param.data;
                setIsSignedIn(data.status);
            }).catch(function() {
                setIsSignedIn(false);
            });
        };
        validateToken();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(useAuth_AuthContext.Provider, {
        value: {
            signedIn: isSignedIn
        },
        children: children
    });
};
var useAuth = function() {
    if (!useAuth_AuthContext) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return (0,react.useContext)(useAuth_AuthContext);
};
/* harmony default export */ var useAuth_AuthProvider = (AuthProvider);


/***/ }),

/***/ 82113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ DialogueContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var initialDialogueState = {
    presentedDialogueType: null
};
var useDialogue = function(param) {
    var _onDialogueClose = param.onDialogueClose, onDialogueClose = _onDialogueClose === void 0 ? function() {} : _onDialogueClose;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialDialogueState), dialogueState = ref[0], setDialogueState = ref[1];
    var openDialogue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(dialogueType) {
        setDialogueState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                presentedDialogueType: dialogueType
            });
        });
    }, []);
    var closeDialogue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setDialogueState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                presentedDialogueType: null
            });
        });
        onDialogueClose();
    }, [
        onDialogueClose
    ]);
    return {
        dialogueState: dialogueState,
        openDialogue: openDialogue,
        closeDialogue: closeDialogue
    };
};
var DialogueContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    dialogueState: initialDialogueState,
    openDialogue: function(dialogueType) {},
    closeDialogue: function() {}
});
/* harmony default export */ __webpack_exports__["Z"] = (useDialogue);


/***/ }),

/***/ 1698:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ JoinUsContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var initialJoinUsState = {
    formType: "default",
    isLoading: false,
    memberShipsWithPrices: [],
    currency: "",
    memberShipCategory: "Leisure",
    membershipId: null,
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    city: {
        id: 0,
        name: ""
    },
    countryCode: "",
    dateOfBirth: "",
    referralCode: "",
    instagram: {
        consent: "no",
        username: undefined
    },
    children: {
        shouldAdd: "",
        list: []
    },
    whatsAppConsent: false,
    termsAccept: false,
    price: {
        value: "",
        symbol: "",
        code: ""
    },
    creditCard: {
        brand: "",
        name: "",
        number: "",
        expiry: "",
        cvc: ""
    },
    errorMsgs: {},
    errors: {
        firstName: false,
        lastName: false,
        email: false,
        phoneNumber: false,
        password: false,
        confirmPassword: false,
        city: false,
        countryCode: false,
        dateOfBirth: false,
        referralCode: false,
        instagram: {
            consent: false,
            username: false
        },
        children: {
            shouldAdd: false,
            list: false
        },
        whatsAppConsent: false,
        termsAccept: false,
        creditCard: {
            name: false,
            number: false,
            expiry: {
                month: false,
                year: false
            },
            cvc: false
        }
    }
};
var useJoinUs = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialJoinUsState), state = ref[0], setState = ref[1];
    var handleTextChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        var key = e.target.name;
        var errors = initialJoinUsState.errors;
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                errors: errors
            }, key, e.target.value));
        });
    }, []);
    var handleCheckBoxChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(name, value) {
        var key = name;
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                errors: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialJoinUsState.errors)
            }, key, value));
        });
    }, []);
    var handleSelectChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(name, value) {
        var key = name;
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                errors: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialJoinUsState.errors)
            }, key, value));
        });
    }, []);
    var handleCreditCardChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(key, value) {
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                errors: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state.errors), {
                    creditCard: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialJoinUsState.errors.creditCard)
                }),
                errorMsgs: {},
                creditCard: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state.creditCard), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, value))
            });
        });
    }, []);
    var handleCityChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(name, option) {
        var key = name;
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                errors: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialJoinUsState.errors),
                cityName: option.name
            }, key, option.id));
        });
    }, []);
    var handleResetForm = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialJoinUsState), {
                memberShipsWithPrices: state.memberShipsWithPrices,
                currency: state.currency,
                memberShipCategory: state.memberShipCategory
            });
        });
    }, []);
    return {
        joinUsState: state,
        setState: setState,
        handleTextChange: handleTextChange,
        handleCheckBoxChange: handleCheckBoxChange,
        handleCityChange: handleCityChange,
        handleSelectChange: handleSelectChange,
        handleCreditCardChange: handleCreditCardChange,
        handleResetForm: handleResetForm
    };
};
var JoinUsContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    joinUsState: initialJoinUsState,
    setState: function() {},
    handleTextChange: function() {},
    handleCheckBoxChange: function() {},
    handleSelectChange: function() {},
    handleCreditCardChange: function() {},
    handleResetForm: function() {},
    handleCityChange: function() {}
});
/* harmony default export */ __webpack_exports__["Z"] = (useJoinUs);


/***/ }),

/***/ 37394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ SignInContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var initialSignInDialogueState = {
    email: "",
    password: "",
    keepMeSignedIn: true,
    isLoading: false,
    signInError: false,
    errors: {
        email: false,
        password: false
    }
};
var useSignIn = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialSignInDialogueState), state = ref[0], setState = ref[1];
    var handleTextChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        var key = e.target.name;
        setState(function(state) {
            var _obj;
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, key, e.target.value), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, "errors", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialSignInDialogueState.errors)), _obj));
        });
    }, []);
    var handleCheckBoxChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(name, value) {
        var key = name;
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, value));
        });
    }, []);
    return {
        signInState: state,
        setState: setState,
        handleTextChange: handleTextChange,
        handleCheckBoxChange: handleCheckBoxChange
    };
};
var SignInContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    signInState: initialSignInDialogueState,
    setState: function() {},
    handleTextChange: function() {},
    handleCheckBoxChange: function() {}
});
/* harmony default export */ __webpack_exports__["Z"] = (useSignIn);


/***/ }),

/***/ 39475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ UserContext; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




var initialState = {
    user: {
        accessToken: "",
        name: ""
    }
};
var useUser = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState), state = ref[0], setState = ref[1];
    var setUser = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(key, value) {
        setState(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state), {
                user: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, state.user), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, value))
            });
        });
    }, []);
    return {
        state: state,
        setUser: setUser
    };
};
var UserContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    state: initialState,
    setUser: function() {}
});
/* harmony default export */ __webpack_exports__["Z"] = (useUser);


/***/ }),

/***/ 84749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ HERO_SECTION_TIME_INTERVAL; },
/* harmony export */   "AS": function() { return /* binding */ CARD_BRAND_AMEX; },
/* harmony export */   "AU": function() { return /* binding */ ARTICLE_DATE_FORMAT; },
/* harmony export */   "AV": function() { return /* binding */ breakpoints; },
/* harmony export */   "Ay": function() { return /* binding */ FORGOT_PASSWORD_DIALOGUE; },
/* harmony export */   "B9": function() { return /* binding */ CARD_BRAND_DEFAULT; },
/* harmony export */   "BZ": function() { return /* binding */ CARD_BRAND_JCB; },
/* harmony export */   "Cs": function() { return /* binding */ elementIds; },
/* harmony export */   "Dh": function() { return /* binding */ COOKIE_CONSENT_MODAL; },
/* harmony export */   "Dx": function() { return /* binding */ CARD_BRAND_MASTERCARD; },
/* harmony export */   "EN": function() { return /* binding */ EN; },
/* harmony export */   "Eb": function() { return /* binding */ phoneNumbers; },
/* harmony export */   "El": function() { return /* binding */ CARD_BRAND_DINERS; },
/* harmony export */   "FX": function() { return /* binding */ dateAndCompany; },
/* harmony export */   "Gu": function() { return /* binding */ REGISTRATION_SUCCESS_DIALOGUE; },
/* harmony export */   "Hw": function() { return /* binding */ sessionStorageKeys; },
/* harmony export */   "Ii": function() { return /* binding */ MOBILE_PARTNER_MENU_DIALOGUE; },
/* harmony export */   "Jl": function() { return /* binding */ CREDIT_CARD_DATE_FORMAT; },
/* harmony export */   "LZ": function() { return /* binding */ externalLinkTitles; },
/* harmony export */   "N9": function() { return /* binding */ membershipCategoryOptions; },
/* harmony export */   "Og": function() { return /* binding */ DATE_FORMAT_REQUEST; },
/* harmony export */   "P7": function() { return /* binding */ USER_BIRTH_DAY_DATE_FORMAT; },
/* harmony export */   "Q_": function() { return /* binding */ colorConstants; },
/* harmony export */   "U2": function() { return /* binding */ JOIN_US_DIALOG_STEP_3; },
/* harmony export */   "VI": function() { return /* binding */ supportedCurrencyCodes; },
/* harmony export */   "XN": function() { return /* binding */ CHECK_YOUR_EMAIL_DIALOGUE; },
/* harmony export */   "aG": function() { return /* binding */ TERMS_AND_CONDITIONS_DIALOGUE; },
/* harmony export */   "aY": function() { return /* binding */ navigationPaths; },
/* harmony export */   "dq": function() { return /* binding */ externalNavigationPaths; },
/* harmony export */   "fI": function() { return /* binding */ NEWSLETTER_SUBSCRIPTION_MODAL; },
/* harmony export */   "fX": function() { return /* binding */ webserviceEndpoints; },
/* harmony export */   "gL": function() { return /* binding */ membershipOptions; },
/* harmony export */   "hY": function() { return /* binding */ RESET_PASSWORD_DIALOGUE; },
/* harmony export */   "jt": function() { return /* binding */ SIGN_IN_DIALOG; },
/* harmony export */   "le": function() { return /* binding */ JOIN_US_DIALOG_STEP_1; },
/* harmony export */   "ly": function() { return /* binding */ defaultCurrencyCode; },
/* harmony export */   "mL": function() { return /* binding */ emailAdresses; },
/* harmony export */   "mV": function() { return /* binding */ urlQueryParamKeys; },
/* harmony export */   "pn": function() { return /* binding */ JOIN_US_DIALOG_STEP_2; },
/* harmony export */   "sM": function() { return /* binding */ CARD_BRAND_VISA; },
/* harmony export */   "uN": function() { return /* binding */ MOBILE_MENU_DIALOGUE; },
/* harmony export */   "uR": function() { return /* binding */ CARD_BRAND_CHINA_UNION_PAY; },
/* harmony export */   "y": function() { return /* binding */ CARD_BRAND_DISCOVER; }
/* harmony export */ });
/* unused harmony exports supportedLanguages, currentYear, APRIL_FOOLS_FICTIONAL_HOTEL_ID, supportedNavigationPaths, WEB_APP_ROUTES, supportedDialogues, MAX_PRERENDERED_LIST_ITEMS, PAGE_INVALIDATION_INTERVAL, supportedMemberships, supportedMembershipCategories, supportedCreditCardbrands */
/* provided dependency */ var process = __webpack_require__(83454);
var EN = "en";
var supportedLanguages = [
    EN
];
var currentYear = new Date().getFullYear();
var dateAndCompany = "\xa9 ".concat(currentYear, " Little Emperors");
var navigationPaths = {
    HOMEPAGE: "/",
    MEMBERSHIP: "/luxury-hotels-membership ",
    PRESS: "/press",
    PRESS_DETAIL: "/press/:id",
    PRESS_LIST: "/press/list",
    THE_TEAM: "/the-team",
    CAREERS: "/careers",
    TERMS_AND_CONDITIONS: "/terms-and-conditions",
    FAQ: "/faq",
    OUR_HOTELS: "/our-hotels",
    ABOUT: "/about",
    PRIVACY_POLICY: "/privacy-policy",
    SEARCH_RESULTS: "/search-results",
    INSPIRATIONS: "/inspirations",
    E_GIFT_CARD: "/luxury-hotels-e-gift-card",
    E_GIFT_CARD_REDEEM: "/luxury-hotels-e-gift-card/redeem",
    E_GIFT_CARD_REDEEM_INTERNAL: "".concat("https://app.littleemperors.com", "/ile/account/redeem-your-e-gift-card?redirectTo=/luxury-hotels-e-gift-card/redeem"),
    INDEPENDENT_TRAVEL_AGENT: "/independent-travel-agent",
    INDEPENDENT_TRAVEL_AGENT_ENQUIRE: "/independent-travel-agent#enquire",
    TRAVEL_JOURNAL_ARTICLES: "/travel-journal",
    TRAVEL_JOURNAL_ARTICLE: "/travel-journal/:slug",
    TRAVEL_JOURNAL_ACTIVITIES: "/travel-journal/activities",
    TRAVEL_JOURNAL_BESTOF: "/travel-journal/best-of",
    TRAVEL_JOURNAL_DESTINATIONS: "/travel-journal/destinations",
    TRAVEL_JOURNAL_EXPERIENCES: "/travel-journal/experiences",
    TRAVEL_JOURNAL_FAMILY: "/travel-journal/family",
    TRAVEL_JOURNAL_FOODDRINK: "/travel-journal/food-drink",
    TRAVEL_JOURNAL_INSPIRATION: "/travel-journal/inspiration",
    TRAVEL_JOURNAL_WELLNESS: "/travel-journal/wellness",
    PARTNER_WITH_US: "/partner-with-us",
    HOTEL_PAGE_INTERNAL: "".concat("https://app.littleemperors.com", "/ile/hotel/:id?redirectTo=/our-hotels/:id"),
    MYLER_DIRECTORY: "/myler-directory",
    NOT_FOUND: "/not-found",
    WEB_APP_HOMEPAGE: "".concat("https://app.littleemperors.com", "/ile/travel"),
    /** ILÉ travel search: “The Reset Alternatives” (category 195) with redirect back to marketing inspiration results. */ WEB_APP_RESET_ALTERNATIVES_SEARCH: "".concat("https://app.littleemperors.com", "/ile/travel/search?searchBy=category&searchValue=195&rooms%5B0%5D%5Badults%5D=1&searchText=The+Reset+Alternatives&redirectTo=search-results-inspirations%2F195"),
    /** Post–April Fools campaign landing (fictional property reveal). */ APRIL_FOOLS_RESET: "/april-fools-reset"
};
/** Fictional hotel detail used for the April Fools campaign; traffic should land on {@link navigationPaths.APRIL_FOOLS_RESET}. */ var APRIL_FOOLS_FICTIONAL_HOTEL_ID = "16223";
var supportedNavigationPaths = [
    navigationPaths.HOMEPAGE,
    navigationPaths.MEMBERSHIP,
    navigationPaths.PRESS,
    navigationPaths.THE_TEAM,
    navigationPaths.CAREERS,
    navigationPaths.TERMS_AND_CONDITIONS,
    navigationPaths.FAQ,
    navigationPaths.OUR_HOTELS,
    navigationPaths.ABOUT,
    navigationPaths.PRIVACY_POLICY,
    navigationPaths.SEARCH_RESULTS,
    navigationPaths.INSPIRATIONS,
    navigationPaths.E_GIFT_CARD,
    navigationPaths.E_GIFT_CARD_REDEEM,
    navigationPaths.TRAVEL_JOURNAL_ARTICLES,
    navigationPaths.APRIL_FOOLS_RESET, 
];
var externalNavigationPaths = {
    INSTAGRAM: "https://www.instagram.com/littleemperors/",
    FACEBOOK: "https://www.facebook.com/LittleEmperors/",
    TWITTER: "https://twitter.com/littleemperors",
    WHATSAPP: "https://api.whatsapp.com/send/?phone=442081768552&text&type=phone_number&app_absent=0",
    APP_STORE: "https://apps.apple.com/app/myle/id1060472608",
    PLAY_STORE: "https://play.google.com/store/apps/details?id=com.littleemperors.myle"
};
var phoneNumbers = {
    UK: "+44 020 3950 6561"
};
var emailAdresses = {
    MEMBERSHIP: "membership@littleemperors.com",
    PARTNER_WITH_US: "partnership@littleemperors.com"
};
var externalLinkTitles = {
    INSTAGRAM_TITLE: "Instagram icon",
    FACEBOOK_TITLE: "Facebook icon",
    TWITTER_TITLE: "Twitter icon",
    WHATSAPP_TITLE: "Whatsapp icon",
    APP_STORE_TITLE: "Download on the App Store",
    GOOGLE_PLAY_TITLE: "Get it on Google Play"
};
var SIGN_IN_DIALOG = "SIGN_IN_DIALOG";
var FORGOT_PASSWORD_DIALOGUE = "FORGOT_PASSWORD_DIALOGUE";
var RESET_PASSWORD_DIALOGUE = "RESET_PASSWORD_DIALOGUE";
var CHECK_YOUR_EMAIL_DIALOGUE = "CHECK_YOUR_EMAIL_DIALOGUE";
var JOIN_US_DIALOG_STEP_1 = "JOIN_US_DIALOG_STEP_1";
var JOIN_US_DIALOG_STEP_2 = "JOIN_US_DIALOG_STEP_2";
var JOIN_US_DIALOG_STEP_3 = "JOIN_US_DIALOG_STEP_3";
var REGISTRATION_SUCCESS_DIALOGUE = "REGISTRATION_SUCCESS_DIALOGUE";
var MOBILE_PARTNER_MENU_DIALOGUE = "MOBILE_PARTNER_MENU_DIALOGUE";
var MOBILE_MENU_DIALOGUE = "MOBILE_MENU_DIALOGUE";
var TERMS_AND_CONDITIONS_DIALOGUE = "TERMS_AND_CONDITIONS_DIALOGUE";
var NEWSLETTER_SUBSCRIPTION_MODAL = "NEWSLETTER_SUBSCRIPTION_MODAL";
var COOKIE_CONSENT_MODAL = "COOKIE_CONSENT_MODAL";
var WEB_APP_ROUTES = (/* unused pure expression or super */ null && ([
    "account",
    "account/redeem-your-e-gift-card", 
]));
var supportedDialogues = [
    SIGN_IN_DIALOG,
    FORGOT_PASSWORD_DIALOGUE,
    RESET_PASSWORD_DIALOGUE,
    CHECK_YOUR_EMAIL_DIALOGUE,
    JOIN_US_DIALOG_STEP_1,
    JOIN_US_DIALOG_STEP_2,
    JOIN_US_DIALOG_STEP_3,
    MOBILE_PARTNER_MENU_DIALOGUE,
    MOBILE_MENU_DIALOGUE,
    TERMS_AND_CONDITIONS_DIALOGUE,
    NEWSLETTER_SUBSCRIPTION_MODAL,
    COOKIE_CONSENT_MODAL,
    REGISTRATION_SUCCESS_DIALOGUE, 
];
var breakpoints = {
    xl: "1650px",
    lg: "1280px",
    md: "1024px",
    sm: "450px",
    xs: "375px"
};
var colorConstants = {
    white: "#fff",
    black: "#191919",
    brandColor: "#BAA57E",
    gray: "#505050",
    lightGray: "#B2B2B2"
};
var sessionStorageKeys = {
    NEWSLETTER_MODAL_OPENED: "NEWSLETTER_MODAL_OPENED",
    COOKIE_CONSENT_MODAL_OPENED: "COOKIE_CONSENT_MODAL_OPENED"
};
var urlQueryParamKeys = {
    RESET_PASSWORD_TOKEN: "reset-password-token"
};
var webserviceEndpoints = {
    SUBSCRIBE_TO_NEWSLETTER: "/api/newsletter",
    COUPON: "/api/coupons",
    PRICES: "/api/prices",
    TOKEN: "/api/token",
    FORGOT_PASSWORD: "/api/forgot-password",
    RESET_PASSWORD: "/api/reset-password",
    USER: "/api/user",
    FAKE: "/api/fake",
    HOT: "/hotels/hot",
    LE_COUPON: "/coupons",
    LE_PRESS_SAY: "/homepage/press-quotes",
    LE_TESTIMONIALS: "/homepage/testimonials",
    LE_COUNTRY_CODE: "/countries",
    LE_SUBSCRIBE_TO_NEWSLETTER: "/newsletter",
    LE_PRICES: "/prices",
    LE_HOME_PAGE_OUR_HOTELS: "/homepage/our-hotels",
    LE_HOME_HERO_ELEMENTS: "/homepage/images",
    LE_PRESS_LIST: "/press-releases",
    LE_USERS_LOGIN: "/users/login",
    LE_FORGOT_PASSWORD: "/password/email",
    LE_RESET_PASSWORD: "/password/reset",
    LE_USERS: "/users",
    LE_HOME_PAGE_GET_OUR_PARTNERS: "/homepage/partners",
    LE_THE_TEAM: "/team",
    LE_CAREERS: "/careers",
    LE_HOTELS: "/hotels/",
    LE_INSTAGRAM_DATA: "/instagram-feed",
    LE_INSPIRATIONS: "/hotel-inspirations",
    PARTNERS: "/partners",
    SEARCH_RESULTS: "hotels",
    MYLER_LEADS: "/api/mylers/leads",
    TRAVEL_JOURNAL_ARTICLES: "/travel-journal/articles",
    CUSTOM_GIFT_CARDS: "/custom-gift-cards"
};
var elementIds = {
    WHY_LITTLE_EMPERORS_SECTION_ID: "WHY_LITTLE_EMPERORS_SECTION_ID"
};
var HERO_SECTION_TIME_INTERVAL = 6000; // 6 sec
// Used to get static paths. A limited number of list element pages will be prerendered at build time
var MAX_PRERENDERED_LIST_ITEMS = 10;
// Cache time of the pages. After this intervall the pages will be invalidated and regenerated with updated data
var PAGE_INVALIDATION_INTERVAL = process.env.PAGE_INVALIDATION_INTERVAL ? parseInt(process.env.PAGE_INVALIDATION_INTERVAL) : 60; // 1 min
var membershipOptions = {
    TRAVEL: "travel",
    GOLD: "gold",
    BLACK: "black",
    BLACK_PLUS: "black+",
    DYNASTY: "dynasty",
    DYNASTY_DINING: "dynasty dining"
};
var supportedMemberships = [
    membershipOptions.TRAVEL,
    membershipOptions.GOLD,
    membershipOptions.BLACK,
    membershipOptions.BLACK_PLUS,
    membershipOptions.DYNASTY, 
];
var supportedCurrencyCodes = [
    "GBP",
    "EUR",
    "USD"
];
var membershipCategoryOptions = {
    CORPORATE: "Corporate",
    LEISURE: "Leisure"
};
var supportedMembershipCategories = [
    membershipCategoryOptions.CORPORATE,
    membershipCategoryOptions.LEISURE, 
];
var ARTICLE_DATE_FORMAT = "MMMM DD, YYYY";
var CREDIT_CARD_DATE_FORMAT = "MM-YY";
var USER_BIRTH_DAY_DATE_FORMAT = "DD/MM";
var DATE_FORMAT_REQUEST = "YYYY-MM-DD";
var CARD_BRAND_DEFAULT = "DEFAULT_CARD_BRAND";
var CARD_BRAND_VISA = "VISA";
var CARD_BRAND_AMEX = "AMEX";
var CARD_BRAND_MASTERCARD = "MASTERCARD";
var CARD_BRAND_DISCOVER = "DISCOVER";
var CARD_BRAND_DINERS = "DINERS";
var CARD_BRAND_JCB = "JCB";
var CARD_BRAND_CHINA_UNION_PAY = "CHINA_UNION_PAY";
var supportedCreditCardbrands = [
    CARD_BRAND_DEFAULT,
    CARD_BRAND_VISA,
    CARD_BRAND_AMEX,
    CARD_BRAND_MASTERCARD,
    CARD_BRAND_DISCOVER,
    CARD_BRAND_DINERS,
    CARD_BRAND_JCB,
    CARD_BRAND_CHINA_UNION_PAY, 
];
var defaultCurrencyCode = "GBP";


/***/ }),

/***/ 95233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useConsent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);


var COOKIE_NAME = "cookieConsent";
var EVENT_NAME = "cookieConsentUpdated";
/**
 * Get current consent status
 * @param consent - 'accepted' or 'rejected'
 */ var useConsent = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function() {
        return js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(COOKIE_NAME) === "accepted";
    }), hasConsent = ref[0], setHasConsent = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleEvent = function() {
            var updatedValue = js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get(COOKIE_NAME) === "accepted";
            setHasConsent(updatedValue);
        };
        window.addEventListener(EVENT_NAME, handleEvent);
        return function() {
            window.removeEventListener(EVENT_NAME, handleEvent);
        };
    }, []);
    var updateConsent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(consent) {
        js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set(COOKIE_NAME, consent, {
            expires: 365
        });
        window.dispatchEvent(new Event(EVENT_NAME));
    }, []);
    return {
        hasConsent: hasConsent,
        updateConsent: updateConsent
    };
};


/***/ }),

/***/ 92162:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.EDGE_UNSUPPORTED_NODE_APIS = exports.RSC_MODULE_TYPES = exports.TRACE_OUTPUT_VERSION = exports.STATIC_STATUS_PAGES = exports.DEFAULT_SANS_SERIF_FONT = exports.DEFAULT_SERIF_FONT = exports.OPTIMIZED_FONT_PROVIDERS = exports.GOOGLE_FONT_PROVIDER = exports.SERVER_PROPS_ID = exports.STATIC_PROPS_ID = exports.PERMANENT_REDIRECT_STATUS = exports.TEMPORARY_REDIRECT_STATUS = exports.EDGE_RUNTIME_WEBPACK = exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = exports.CLIENT_STATIC_FILES_RUNTIME_WEBPACK = exports.CLIENT_STATIC_FILES_RUNTIME_AMP = exports.CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = exports.CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = exports.CLIENT_STATIC_FILES_RUNTIME_MAIN = exports.MIDDLEWARE_REACT_LOADABLE_MANIFEST = exports.MIDDLEWARE_BUILD_MANIFEST = exports.FLIGHT_SERVER_CSS_MANIFEST = exports.FLIGHT_MANIFEST = exports.NEXT_CLIENT_SSR_ENTRY_SUFFIX = exports.NEXT_BUILTIN_DOCUMENT = exports.MODERN_BROWSERSLIST_TARGET = exports.STRING_LITERAL_DROP_BUNDLE = exports.CLIENT_STATIC_FILES_RUNTIME = exports.CLIENT_STATIC_FILES_PATH = exports.CLIENT_PUBLIC_FILES_PATH = exports.BLOCKED_PAGES = exports.BUILD_ID_FILE = exports.CONFIG_FILES = exports.SERVERLESS_DIRECTORY = exports.SERVER_DIRECTORY = exports.FONT_MANIFEST = exports.REACT_LOADABLE_MANIFEST = exports.DEV_MIDDLEWARE_MANIFEST = exports.MIDDLEWARE_MANIFEST = exports.DEV_CLIENT_PAGES_MANIFEST = exports.SERVER_FILES_MANIFEST = exports.IMAGES_MANIFEST = exports.ROUTES_MANIFEST = exports.PRERENDER_MANIFEST = exports.EXPORT_DETAIL = exports.EXPORT_MARKER = exports.SUBRESOURCE_INTEGRITY_MANIFEST = exports.APP_BUILD_MANIFEST = exports.BUILD_MANIFEST = exports.APP_PATH_ROUTES_MANIFEST = exports.APP_PATHS_MANIFEST = exports.PAGES_MANIFEST = exports.PHASE_TEST = exports.PHASE_DEVELOPMENT_SERVER = exports.PHASE_PRODUCTION_SERVER = exports.PHASE_PRODUCTION_BUILD = exports.PHASE_EXPORT = exports.COMPILER_INDEXES = exports.COMPILER_NAMES = void 0;
var COMPILER_NAMES = {
    client: "client",
    server: "server",
    edgeServer: "edge-server"
};
exports.COMPILER_NAMES = COMPILER_NAMES;
var _obj;
var COMPILER_INDEXES = (_obj = {}, _defineProperty(_obj, COMPILER_NAMES.client, 0), _defineProperty(_obj, COMPILER_NAMES.server, 1), _defineProperty(_obj, COMPILER_NAMES.edgeServer, 2), _obj);
exports.COMPILER_INDEXES = COMPILER_INDEXES;
var PHASE_EXPORT = "phase-export";
exports.PHASE_EXPORT = PHASE_EXPORT;
var PHASE_PRODUCTION_BUILD = "phase-production-build";
exports.PHASE_PRODUCTION_BUILD = PHASE_PRODUCTION_BUILD;
var PHASE_PRODUCTION_SERVER = "phase-production-server";
exports.PHASE_PRODUCTION_SERVER = PHASE_PRODUCTION_SERVER;
var PHASE_DEVELOPMENT_SERVER = "phase-development-server";
exports.PHASE_DEVELOPMENT_SERVER = PHASE_DEVELOPMENT_SERVER;
var PHASE_TEST = "phase-test";
exports.PHASE_TEST = PHASE_TEST;
var PAGES_MANIFEST = "pages-manifest.json";
exports.PAGES_MANIFEST = PAGES_MANIFEST;
var APP_PATHS_MANIFEST = "app-paths-manifest.json";
exports.APP_PATHS_MANIFEST = APP_PATHS_MANIFEST;
var APP_PATH_ROUTES_MANIFEST = "app-path-routes-manifest.json";
exports.APP_PATH_ROUTES_MANIFEST = APP_PATH_ROUTES_MANIFEST;
var BUILD_MANIFEST = "build-manifest.json";
exports.BUILD_MANIFEST = BUILD_MANIFEST;
var APP_BUILD_MANIFEST = "app-build-manifest.json";
exports.APP_BUILD_MANIFEST = APP_BUILD_MANIFEST;
var SUBRESOURCE_INTEGRITY_MANIFEST = "subresource-integrity-manifest";
exports.SUBRESOURCE_INTEGRITY_MANIFEST = SUBRESOURCE_INTEGRITY_MANIFEST;
var EXPORT_MARKER = "export-marker.json";
exports.EXPORT_MARKER = EXPORT_MARKER;
var EXPORT_DETAIL = "export-detail.json";
exports.EXPORT_DETAIL = EXPORT_DETAIL;
var PRERENDER_MANIFEST = "prerender-manifest.json";
exports.PRERENDER_MANIFEST = PRERENDER_MANIFEST;
var ROUTES_MANIFEST = "routes-manifest.json";
exports.ROUTES_MANIFEST = ROUTES_MANIFEST;
var IMAGES_MANIFEST = "images-manifest.json";
exports.IMAGES_MANIFEST = IMAGES_MANIFEST;
var SERVER_FILES_MANIFEST = "required-server-files.json";
exports.SERVER_FILES_MANIFEST = SERVER_FILES_MANIFEST;
var DEV_CLIENT_PAGES_MANIFEST = "_devPagesManifest.json";
exports.DEV_CLIENT_PAGES_MANIFEST = DEV_CLIENT_PAGES_MANIFEST;
var MIDDLEWARE_MANIFEST = "middleware-manifest.json";
exports.MIDDLEWARE_MANIFEST = MIDDLEWARE_MANIFEST;
var DEV_MIDDLEWARE_MANIFEST = "_devMiddlewareManifest.json";
exports.DEV_MIDDLEWARE_MANIFEST = DEV_MIDDLEWARE_MANIFEST;
var REACT_LOADABLE_MANIFEST = "react-loadable-manifest.json";
exports.REACT_LOADABLE_MANIFEST = REACT_LOADABLE_MANIFEST;
var FONT_MANIFEST = "font-manifest.json";
exports.FONT_MANIFEST = FONT_MANIFEST;
var SERVER_DIRECTORY = "server";
exports.SERVER_DIRECTORY = SERVER_DIRECTORY;
var SERVERLESS_DIRECTORY = "serverless";
exports.SERVERLESS_DIRECTORY = SERVERLESS_DIRECTORY;
var CONFIG_FILES = [
    "next.config.js",
    "next.config.mjs"
];
exports.CONFIG_FILES = CONFIG_FILES;
var BUILD_ID_FILE = "BUILD_ID";
exports.BUILD_ID_FILE = BUILD_ID_FILE;
var BLOCKED_PAGES = [
    "/_document",
    "/_app",
    "/_error"
];
exports.BLOCKED_PAGES = BLOCKED_PAGES;
var CLIENT_PUBLIC_FILES_PATH = "public";
exports.CLIENT_PUBLIC_FILES_PATH = CLIENT_PUBLIC_FILES_PATH;
var CLIENT_STATIC_FILES_PATH = "static";
exports.CLIENT_STATIC_FILES_PATH = CLIENT_STATIC_FILES_PATH;
var CLIENT_STATIC_FILES_RUNTIME = "runtime";
exports.CLIENT_STATIC_FILES_RUNTIME = CLIENT_STATIC_FILES_RUNTIME;
var STRING_LITERAL_DROP_BUNDLE = "__NEXT_DROP_CLIENT_FILE__";
exports.STRING_LITERAL_DROP_BUNDLE = STRING_LITERAL_DROP_BUNDLE;
var MODERN_BROWSERSLIST_TARGET = [
    "chrome 61",
    "edge 16",
    "firefox 60",
    "opera 48",
    "safari 11", 
];
exports.MODERN_BROWSERSLIST_TARGET = MODERN_BROWSERSLIST_TARGET;
var NEXT_BUILTIN_DOCUMENT = "__NEXT_BUILTIN_DOCUMENT__";
exports.NEXT_BUILTIN_DOCUMENT = NEXT_BUILTIN_DOCUMENT;
var NEXT_CLIENT_SSR_ENTRY_SUFFIX = ".__sc_client__";
exports.NEXT_CLIENT_SSR_ENTRY_SUFFIX = NEXT_CLIENT_SSR_ENTRY_SUFFIX;
var FLIGHT_MANIFEST = "flight-manifest";
exports.FLIGHT_MANIFEST = FLIGHT_MANIFEST;
var FLIGHT_SERVER_CSS_MANIFEST = "flight-server-css-manifest";
exports.FLIGHT_SERVER_CSS_MANIFEST = FLIGHT_SERVER_CSS_MANIFEST;
var MIDDLEWARE_BUILD_MANIFEST = "middleware-build-manifest";
exports.MIDDLEWARE_BUILD_MANIFEST = MIDDLEWARE_BUILD_MANIFEST;
var MIDDLEWARE_REACT_LOADABLE_MANIFEST = "middleware-react-loadable-manifest";
exports.MIDDLEWARE_REACT_LOADABLE_MANIFEST = MIDDLEWARE_REACT_LOADABLE_MANIFEST;
var CLIENT_STATIC_FILES_RUNTIME_MAIN = "main";
exports.CLIENT_STATIC_FILES_RUNTIME_MAIN = CLIENT_STATIC_FILES_RUNTIME_MAIN;
var CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = "".concat(CLIENT_STATIC_FILES_RUNTIME_MAIN, "-app");
exports.CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = CLIENT_STATIC_FILES_RUNTIME_MAIN_APP;
var CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = "react-refresh";
exports.CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH;
var CLIENT_STATIC_FILES_RUNTIME_AMP = "amp";
exports.CLIENT_STATIC_FILES_RUNTIME_AMP = CLIENT_STATIC_FILES_RUNTIME_AMP;
var CLIENT_STATIC_FILES_RUNTIME_WEBPACK = "webpack";
exports.CLIENT_STATIC_FILES_RUNTIME_WEBPACK = CLIENT_STATIC_FILES_RUNTIME_WEBPACK;
var CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = "polyfills";
exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = CLIENT_STATIC_FILES_RUNTIME_POLYFILLS;
var CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = Symbol(CLIENT_STATIC_FILES_RUNTIME_POLYFILLS);
exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL;
var EDGE_RUNTIME_WEBPACK = "edge-runtime-webpack";
exports.EDGE_RUNTIME_WEBPACK = EDGE_RUNTIME_WEBPACK;
var TEMPORARY_REDIRECT_STATUS = 307;
exports.TEMPORARY_REDIRECT_STATUS = TEMPORARY_REDIRECT_STATUS;
var PERMANENT_REDIRECT_STATUS = 308;
exports.PERMANENT_REDIRECT_STATUS = PERMANENT_REDIRECT_STATUS;
var STATIC_PROPS_ID = "__N_SSG";
exports.STATIC_PROPS_ID = STATIC_PROPS_ID;
var SERVER_PROPS_ID = "__N_SSP";
exports.SERVER_PROPS_ID = SERVER_PROPS_ID;
var GOOGLE_FONT_PROVIDER = "https://fonts.googleapis.com/";
exports.GOOGLE_FONT_PROVIDER = GOOGLE_FONT_PROVIDER;
var OPTIMIZED_FONT_PROVIDERS = [
    {
        url: GOOGLE_FONT_PROVIDER,
        preconnect: "https://fonts.gstatic.com"
    },
    {
        url: "https://use.typekit.net",
        preconnect: "https://use.typekit.net"
    }, 
];
exports.OPTIMIZED_FONT_PROVIDERS = OPTIMIZED_FONT_PROVIDERS;
var DEFAULT_SERIF_FONT = "Times New Roman";
exports.DEFAULT_SERIF_FONT = DEFAULT_SERIF_FONT;
var DEFAULT_SANS_SERIF_FONT = "Arial";
exports.DEFAULT_SANS_SERIF_FONT = DEFAULT_SANS_SERIF_FONT;
var STATIC_STATUS_PAGES = [
    "/500"
];
exports.STATIC_STATUS_PAGES = STATIC_STATUS_PAGES;
var TRACE_OUTPUT_VERSION = 1;
exports.TRACE_OUTPUT_VERSION = TRACE_OUTPUT_VERSION;
var RSC_MODULE_TYPES = {
    client: "client",
    server: "server"
};
exports.RSC_MODULE_TYPES = RSC_MODULE_TYPES;
var EDGE_UNSUPPORTED_NODE_APIS = [
    "clearImmediate",
    "setImmediate",
    "BroadcastChannel",
    "Buffer",
    "ByteLengthQueuingStrategy",
    "CompressionStream",
    "CountQueuingStrategy",
    "DecompressionStream",
    "DomException",
    "MessageChannel",
    "MessageEvent",
    "MessagePort",
    "ReadableByteStreamController",
    "ReadableStreamBYOBRequest",
    "ReadableStreamDefaultController",
    "TextDecoderStream",
    "TextEncoderStream",
    "TransformStreamDefaultController",
    "WritableStreamDefaultController", 
];
exports.EDGE_UNSUPPORTED_NODE_APIS = EDGE_UNSUPPORTED_NODE_APIS;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=constants.js.map


/***/ }),

/***/ 48803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/ThemeProvider.js
var ThemeProvider = __webpack_require__(22233);
// EXTERNAL MODULE: ./node_modules/@mui/x-date-pickers/LocalizationProvider/LocalizationProvider.js + 2 modules
var LocalizationProvider = __webpack_require__(52359);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./node_modules/@date-io/moment/build/index.esm.js


const defaultFormats = {
    normalDateWithWeekday: "ddd, MMM D",
    normalDate: "D MMMM",
    shortDate: "MMM D",
    monthAndDate: "MMMM D",
    dayOfMonth: "D",
    year: "YYYY",
    month: "MMMM",
    monthShort: "MMM",
    monthAndYear: "MMMM YYYY",
    weekday: "dddd",
    weekdayShort: "ddd",
    minutes: "mm",
    hours12h: "hh",
    hours24h: "HH",
    seconds: "ss",
    fullTime: "LT",
    fullTime12h: "hh:mm A",
    fullTime24h: "HH:mm",
    fullDate: "ll",
    fullDateWithWeekday: "dddd, LL",
    fullDateTime: "lll",
    fullDateTime12h: "ll hh:mm A",
    fullDateTime24h: "ll HH:mm",
    keyboardDate: "L",
    keyboardDateTime: "L LT",
    keyboardDateTime12h: "L hh:mm A",
    keyboardDateTime24h: "L HH:mm",
};
class MomentUtils {
    constructor({ locale, formats, instance } = {}) {
        this.lib = "moment";
        this.is12HourCycleInCurrentLocale = () => {
            return /A|a/.test(this.moment.localeData(this.getCurrentLocaleCode()).longDateFormat("LT"));
        };
        this.getFormatHelperText = (format) => {
            var _a, _b;
            // @see https://github.com/moment/moment/blob/develop/src/lib/format/format.js#L6
            const localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})|./g;
            return ((_b = (_a = format
                .match(localFormattingTokens)) === null || _a === void 0 ? void 0 : _a.map((token) => {
                const firstCharacter = token[0];
                if (firstCharacter === "L" || firstCharacter === ";") {
                    return this.moment
                        .localeData(this.getCurrentLocaleCode())
                        .longDateFormat(token);
                }
                return token;
            }).join("").replace(/a/gi, "(a|p)m").toLocaleLowerCase()) !== null && _b !== void 0 ? _b : format);
        };
        this.getCurrentLocaleCode = () => {
            return this.locale || this.moment.locale();
        };
        this.parseISO = (isoString) => {
            return this.moment(isoString, true);
        };
        this.toISO = (value) => {
            return value.toISOString();
        };
        this.parse = (value, format) => {
            if (value === "") {
                return null;
            }
            if (this.locale) {
                return this.moment(value, format, this.locale, true);
            }
            return this.moment(value, format, true);
        };
        this.date = (value) => {
            if (value === null) {
                return null;
            }
            const moment = this.moment(value);
            if (this.locale) {
                moment.locale(this.locale);
            }
            return moment;
        };
        this.toJsDate = (value) => {
            return value.toDate();
        };
        this.isValid = (value) => {
            return this.moment(value).isValid();
        };
        this.isNull = (date) => {
            return date === null;
        };
        this.getDiff = (date, comparing, unit) => {
            if (!this.moment(comparing).isValid()) {
                return 0;
            }
            return date.diff(comparing, unit);
        };
        this.isAfter = (date, value) => {
            return date.isAfter(value);
        };
        this.isBefore = (date, value) => {
            return date.isBefore(value);
        };
        this.isAfterDay = (date, value) => {
            return date.isAfter(value, "day");
        };
        this.isBeforeDay = (date, value) => {
            return date.isBefore(value, "day");
        };
        this.isBeforeMonth = (date, value) => {
            return date.isBefore(value, "month");
        };
        this.isAfterMonth = (date, value) => {
            return date.isAfter(value, "month");
        };
        this.isBeforeYear = (date, value) => {
            return date.isBefore(value, "year");
        };
        this.isAfterYear = (date, value) => {
            return date.isAfter(value, "year");
        };
        this.startOfDay = (date) => {
            return date.clone().startOf("day");
        };
        this.endOfDay = (date) => {
            return date.clone().endOf("day");
        };
        this.format = (date, formatKey) => {
            return this.formatByString(date, this.formats[formatKey]);
        };
        this.formatByString = (date, formatString) => {
            const clonedDate = date.clone();
            if (this.locale) {
                clonedDate.locale(this.locale);
            }
            return clonedDate.format(formatString);
        };
        this.formatNumber = (numberToFormat) => {
            return numberToFormat;
        };
        this.getHours = (date) => {
            return date.get("hours");
        };
        this.addSeconds = (date, count) => {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "seconds")
                : date.clone().add(count, "seconds");
        };
        this.addMinutes = (date, count) => {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "minutes")
                : date.clone().add(count, "minutes");
        };
        this.addHours = (date, count) => {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "hours")
                : date.clone().add(count, "hours");
        };
        this.addDays = (date, count) => {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "days")
                : date.clone().add(count, "days");
        };
        this.addWeeks = (date, count) => {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "weeks")
                : date.clone().add(count, "weeks");
        };
        this.addMonths = (date, count) => {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "months")
                : date.clone().add(count, "months");
        };
        this.addYears = (date, count) => {
            return count < 0
                ? date.clone().subtract(Math.abs(count), "years")
                : date.clone().add(count, "years");
        };
        this.setHours = (date, count) => {
            return date.clone().hours(count);
        };
        this.getMinutes = (date) => {
            return date.get("minutes");
        };
        this.setMinutes = (date, count) => {
            return date.clone().minutes(count);
        };
        this.getSeconds = (date) => {
            return date.get("seconds");
        };
        this.setSeconds = (date, count) => {
            return date.clone().seconds(count);
        };
        this.getMonth = (date) => {
            return date.get("month");
        };
        this.getDaysInMonth = (date) => {
            return date.daysInMonth();
        };
        this.isSameDay = (date, comparing) => {
            return date.isSame(comparing, "day");
        };
        this.isSameMonth = (date, comparing) => {
            return date.isSame(comparing, "month");
        };
        this.isSameYear = (date, comparing) => {
            return date.isSame(comparing, "year");
        };
        this.isSameHour = (date, comparing) => {
            return date.isSame(comparing, "hour");
        };
        this.setMonth = (date, count) => {
            return date.clone().month(count);
        };
        this.getMeridiemText = (ampm) => {
            if (this.is12HourCycleInCurrentLocale()) {
                // AM/PM translation only possible in those who have 12 hour cycle in locale.
                return this.moment
                    .localeData(this.getCurrentLocaleCode())
                    .meridiem(ampm === "am" ? 0 : 13, 0, false);
            }
            return ampm === "am" ? "AM" : "PM"; // fallback for de, ru, ...etc
        };
        this.startOfYear = (date) => {
            return date.clone().startOf("year");
        };
        this.endOfYear = (date) => {
            return date.clone().endOf("year");
        };
        this.startOfMonth = (date) => {
            return date.clone().startOf("month");
        };
        this.endOfMonth = (date) => {
            return date.clone().endOf("month");
        };
        this.startOfWeek = (date) => {
            return date.clone().startOf("week");
        };
        this.endOfWeek = (date) => {
            return date.clone().endOf("week");
        };
        this.getNextMonth = (date) => {
            return date.clone().add(1, "month");
        };
        this.getPreviousMonth = (date) => {
            return date.clone().subtract(1, "month");
        };
        this.getMonthArray = (date) => {
            const firstMonth = date.clone().startOf("year");
            const monthArray = [firstMonth];
            while (monthArray.length < 12) {
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.getYear = (date) => {
            return date.get("year");
        };
        this.setYear = (date, year) => {
            return date.clone().set("year", year);
        };
        this.getDate = (date) => {
            return date.get("date");
        };
        this.setDate = (date, year) => {
            return date.clone().set("date", year);
        };
        this.mergeDateAndTime = (date, time) => {
            return date.hour(time.hour()).minute(time.minute()).second(time.second());
        };
        this.getWeekdays = () => {
            return this.moment.weekdaysShort(true);
        };
        this.isEqual = (value, comparing) => {
            if (value === null && comparing === null) {
                return true;
            }
            return this.moment(value).isSame(comparing);
        };
        this.getWeekArray = (date) => {
            const start = date.clone().startOf("month").startOf("week");
            const end = date.clone().endOf("month").endOf("week");
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while (current.isBefore(end)) {
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = current.clone().add(1, "day");
                count += 1;
            }
            return nestedWeeks;
        };
        this.getYearRange = (start, end) => {
            const startDate = this.moment(start).startOf("year");
            const endDate = this.moment(end).endOf("year");
            const years = [];
            let current = startDate;
            while (current.isBefore(endDate)) {
                years.push(current);
                current = current.clone().add(1, "year");
            }
            return years;
        };
        this.isWithinRange = (date, [start, end]) => {
            return date.isBetween(start, end, null, "[]");
        };
        this.moment = instance || (moment_default());
        this.locale = locale;
        this.formats = Object.assign({}, defaultFormats, formats);
    }
}



// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-element-f0de968e.browser.esm.js
var emotion_element_f0de968e_browser_esm = __webpack_require__(87685);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/logger.mjs
var logger = __webpack_require__(30819);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(72379);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/removable.mjs
var removable = __webpack_require__(89643);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/query.mjs






// CLASS
class Query extends removable/* Removable */.F {
  constructor(config) {
    super();
    this.abortSignalConsumed = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.logger = config.logger || logger/* defaultLogger */._;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || getDefaultState(this.options);
    this.state = this.initialState;
    this.scheduleGc();
  }

  get meta() {
    return this.options.meta;
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === 'idle') {
      this.cache.remove(this);
    }
  }

  setData(newData, options) {
    const data = (0,utils/* replaceData */.oE)(this.state.data, newData, this.options); // Set data and mark it as cached

    this.dispatch({
      data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }

  setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state,
      setStateOptions
    });
  }

  cancel(options) {
    var _this$retryer;

    const promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  }

  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }

  reset() {
    this.destroy();
    this.setState(this.initialState);
  }

  isActive() {
    return this.observers.some(observer => observer.options.enabled !== false);
  }

  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }

  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(observer => observer.getCurrentResult().isStale);
  }

  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  }

  onFocus() {
    var _this$retryer2;

    const observer = this.observers.find(x => x.shouldFetchOnWindowFocus());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  }

  onOnline() {
    var _this$retryer3;

    const observer = this.observers.find(x => x.shouldFetchOnReconnect());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  }

  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer); // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    if (this.observers.includes(observer)) {
      this.observers = this.observers.filter(x => x !== observer);

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        this.scheduleGc();
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer
      });
    }
  }

  getObserversCount() {
    return this.observers.length;
  }

  invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  }

  fetch(options, fetchOptions) {
    var _this$options$behavio, _context$fetchOptions;

    if (this.state.fetchStatus !== 'idle') {
      if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      const observer = this.observers.find(x => x.options.queryFn);

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    if (false) {}

    const abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    const queryFnContext = {
      queryKey: this.queryKey,
      pageParam: undefined,
      meta: this.meta
    }; // Adds an enumerable signal property to the object that
    // which sets abortSignalConsumed to true when the signal
    // is read.

    const addSignalProperty = object => {
      Object.defineProperty(object, 'signal', {
        enumerable: true,
        get: () => {
          if (abortController) {
            this.abortSignalConsumed = true;
            return abortController.signal;
          }

          return undefined;
        }
      });
    };

    addSignalProperty(queryFnContext); // Create fetch function

    const fetchFn = () => {
      if (!this.options.queryFn) {
        return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
      }

      this.abortSignalConsumed = false;
      return this.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted

    this.revertState = this.state; // Set to fetching state if not already in it

    if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    }

    const onError = error => {
      // Optimistically update state if needed
      if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
        this.dispatch({
          type: 'error',
          error: error
        });
      }

      if (!(0,retryer/* isCancelledError */.DV)(error)) {
        var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;

        // Notify cache callback
        (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, this);
        (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);

        if (false) {}
      }

      if (!this.isFetchingOptimistic) {
        // Schedule query gc after fetching
        this.scheduleGc();
      }

      this.isFetchingOptimistic = false;
    }; // Try to fetch the data


    this.retryer = (0,retryer/* createRetryer */.Mz)({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
      onSuccess: data => {
        var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;

        if (typeof data === 'undefined') {
          if (false) {}

          onError(new Error(this.queryHash + " data is undefined"));
          return;
        }

        this.setData(data); // Notify cache callback

        (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on3.call(_this$cache$config3, data, this);
        (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null ? void 0 : _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);

        if (!this.isFetchingOptimistic) {
          // Schedule query gc after fetching
          this.scheduleGc();
        }

        this.isFetchingOptimistic = false;
      },
      onError,
      onFail: (failureCount, error) => {
        this.dispatch({
          type: 'failed',
          failureCount,
          error
        });
      },
      onPause: () => {
        this.dispatch({
          type: 'pause'
        });
      },
      onContinue: () => {
        this.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode
    });
    this.promise = this.retryer.promise;
    return this.promise;
  }

  dispatch(action) {
    const reducer = state => {
      var _action$meta, _action$dataUpdatedAt;

      switch (action.type) {
        case 'failed':
          return { ...state,
            fetchFailureCount: action.failureCount,
            fetchFailureReason: action.error
          };

        case 'pause':
          return { ...state,
            fetchStatus: 'paused'
          };

        case 'continue':
          return { ...state,
            fetchStatus: 'fetching'
          };

        case 'fetch':
          return { ...state,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
            fetchStatus: (0,retryer/* canFetch */.Kw)(this.options.networkMode) ? 'fetching' : 'paused',
            ...(!state.dataUpdatedAt && {
              error: null,
              status: 'loading'
            })
          };

        case 'success':
          return { ...state,
            data: action.data,
            dataUpdateCount: state.dataUpdateCount + 1,
            dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
            error: null,
            isInvalidated: false,
            status: 'success',
            ...(!action.manual && {
              fetchStatus: 'idle',
              fetchFailureCount: 0,
              fetchFailureReason: null
            })
          };

        case 'error':
          const error = action.error;

          if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
            return { ...this.revertState,
              fetchStatus: 'idle'
            };
          }

          return { ...state,
            error: error,
            errorUpdateCount: state.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: state.fetchFailureCount + 1,
            fetchFailureReason: error,
            fetchStatus: 'idle',
            status: 'error'
          };

        case 'invalidate':
          return { ...state,
            isInvalidated: true
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.observers.forEach(observer => {
        observer.onQueryUpdate(action);
      });
      this.cache.notify({
        query: this,
        type: 'updated',
        action
      });
    });
  }

}

function getDefaultState(options) {
  const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
  const hasData = typeof data !== 'undefined';
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? 'success' : 'loading',
    fetchStatus: 'idle'
  };
}


//# sourceMappingURL=query.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryCache.mjs





// CLASS
class QueryCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.queries = [];
    this.queriesMap = {};
  }

  build(client, options, state) {
    var _options$queryHash;

    const queryKey = options.queryKey;
    const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    let query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        logger: client.getLogger(),
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }

    return query;
  }

  add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'added',
        query
      });
    }
  }

  remove(query) {
    const queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(x => x !== query);

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'removed',
        query
      });
    }
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        this.remove(query);
      });
    });
  }

  get(queryHash) {
    return this.queriesMap[queryHash];
  }

  getAll() {
    return this.queries;
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  find(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(query => (0,utils/* matchQuery */._x)(filters, query));
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  findAll(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    return Object.keys(filters).length > 0 ? this.queries.filter(query => (0,utils/* matchQuery */._x)(filters, query)) : this.queries;
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(({
        listener
      }) => {
        listener(event);
      });
    });
  }

  onFocus() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onFocus();
      });
    });
  }

  onOnline() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onOnline();
      });
    });
  }

}


//# sourceMappingURL=queryCache.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var lib_mutation = __webpack_require__(89886);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationCache.mjs





// CLASS
class MutationCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.mutations = [];
    this.mutationId = 0;
  }

  build(client, options, state) {
    const mutation = new lib_mutation/* Mutation */.m({
      mutationCache: this,
      logger: client.getLogger(),
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
    });
    this.add(mutation);
    return mutation;
  }

  add(mutation) {
    this.mutations.push(mutation);
    this.notify({
      type: 'added',
      mutation
    });
  }

  remove(mutation) {
    this.mutations = this.mutations.filter(x => x !== mutation);
    this.notify({
      type: 'removed',
      mutation
    });
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.mutations.forEach(mutation => {
        this.remove(mutation);
      });
    });
  }

  getAll() {
    return this.mutations;
  }

  find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  findAll(filters) {
    return this.mutations.filter(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(({
        listener
      }) => {
        listener(event);
      });
    });
  }

  resumePausedMutations() {
    var _this$resuming;

    this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(() => {
      const pausedMutations = this.mutations.filter(x => x.state.isPaused);
      return notifyManager/* notifyManager.batch */.V.batch(() => pausedMutations.reduce((promise, mutation) => promise.then(() => mutation.continue().catch(utils/* noop */.ZT)), Promise.resolve()));
    }).then(() => {
      this.resuming = undefined;
    });
    return this.resuming;
  }

}


//# sourceMappingURL=mutationCache.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(15761);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/onlineManager.mjs
var onlineManager = __webpack_require__(96474);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
var infiniteQueryBehavior = __webpack_require__(9499);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/queryClient.mjs









// CLASS
class QueryClient {
  constructor(config = {}) {
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.logger = config.logger || logger/* defaultLogger */._;
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
    this.mountCount = 0;

    if (false) {}
  }

  mount() {
    this.mountCount++;
    if (this.mountCount !== 1) return;
    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(() => {
      if (focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.resumePausedMutations();
        this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(() => {
      if (onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        this.resumePausedMutations();
        this.queryCache.onOnline();
      }
    });
  }

  unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    this.mountCount--;
    if (this.mountCount !== 0) return;
    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    this.unsubscribeFocus = undefined;
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
    this.unsubscribeOnline = undefined;
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  isFetching(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    filters.fetchStatus = 'fetching';
    return this.queryCache.findAll(filters).length;
  }

  isMutating(filters) {
    return this.mutationCache.findAll({ ...filters,
      fetching: true
    }).length;
  }

  /**
   * @deprecated This method will accept only queryKey in the next major version.
   */
  getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  ensureQueryData(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const cachedData = this.getQueryData(parsedOptions.queryKey);
    return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey,
      state
    }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }

  setQueryData(queryKey, updater, options) {
    const query = this.queryCache.find(queryKey);
    const prevData = query == null ? void 0 : query.state.data;
    const data = (0,utils/* functionalUpdate */.SE)(updater, prevData);

    if (typeof data === 'undefined') {
      return undefined;
    }

    const parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(data, { ...options,
      manual: true
    });
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  setQueriesData(queryKeyOrFilters, updater, options) {
    return notifyManager/* notifyManager.batch */.V.batch(() => this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey
    }) => [queryKey, this.setQueryData(queryKey, updater, options)]));
  }

  getQueryState(queryKey,
  /**
   * @deprecated This filters will be removed in the next major version.
   */
  filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  removeQueries(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    const queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        queryCache.remove(query);
      });
    });
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  resetQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const queryCache = this.queryCache;
    const refetchFilters = {
      type: 'active',
      ...filters
    };
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        query.reset();
      });
      return this.refetchQueries(refetchFilters, options);
    });
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  cancelQueries(arg1, arg2, arg3) {
    const [filters, cancelOptions = {}] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).map(query => query.cancel(cancelOptions)));
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  invalidateQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      var _ref, _filters$refetchType;

      this.queryCache.findAll(filters).forEach(query => {
        query.invalidate();
      });

      if (filters.refetchType === 'none') {
        return Promise.resolve();
      }

      const refetchFilters = { ...filters,
        type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
      };
      return this.refetchQueries(refetchFilters, options);
    });
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  refetchQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).filter(query => !query.isDisabled()).map(query => {
      var _options$cancelRefetc;

      return query.fetch(undefined, { ...options,
        cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
        meta: {
          refetchPage: filters.refetchPage
        }
      });
    }));
    let promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options != null && options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  fetchQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    const query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  fetchInfiniteQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = (0,infiniteQueryBehavior/* infiniteQueryBehavior */.Gm)();
    return this.fetchQuery(parsedOptions);
  }

  /**
   * @deprecated This method should be used with only one object argument.
   */
  prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }

  getQueryCache() {
    return this.queryCache;
  }

  getMutationCache() {
    return this.mutationCache;
  }

  getLogger() {
    return this.logger;
  }

  getDefaultOptions() {
    return this.defaultOptions;
  }

  setDefaultOptions(options) {
    this.defaultOptions = options;
  }

  setQueryDefaults(queryKey, options) {
    const result = this.queryDefaults.find(x => (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey,
        defaultOptions: options
      });
    }
  }

  getQueryDefaults(queryKey) {
    if (!queryKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.queryDefaults.find(x => (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  setMutationDefaults(mutationKey, options) {
    const result = this.mutationDefaults.find(x => (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey,
        defaultOptions: options
      });
    }
  }

  getMutationDefaults(mutationKey) {
    if (!mutationKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.mutationDefaults.find(x => (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  defaultQueryOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    const defaultedOptions = { ...this.defaultOptions.queries,
      ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
      ...options,
      _defaulted: true
    };

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    } // dependent default values


    if (typeof defaultedOptions.refetchOnReconnect === 'undefined') {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
    }

    if (typeof defaultedOptions.useErrorBoundary === 'undefined') {
      defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
    }

    return defaultedOptions;
  }

  defaultMutationOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    return { ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
      ...options,
      _defaulted: true
    };
  }

  clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  }

}


//# sourceMappingURL=queryClient.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./customHooks/useDialogue/useDialogue.ts
var useDialogue = __webpack_require__(82113);
// EXTERNAL MODULE: ./customHooks/useUser/useUser.ts
var useUser = __webpack_require__(39475);
// EXTERNAL MODULE: ./customHooks/useJoinUs/useJoinUs.ts
var useJoinUs = __webpack_require__(1698);
// EXTERNAL MODULE: ./blocks/search-bar/context.tsx
var context = __webpack_require__(62643);
// EXTERNAL MODULE: ./services/SessionService/SessionService.ts
var SessionService = __webpack_require__(5401);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/createTheme.js + 3 modules
var createTheme = __webpack_require__(95839);
;// CONCATENATED MODULE: ./styles/MUITheme.ts


var theme = {
    typography: {
        fontFamily: "Avenir Next"
    },
    components: {
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginLeft: 0,
                    fontSize: ".875rem"
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    border: "1px solid lightGray"
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    border: "none",
                    "& fieldset": {
                        borderRadius: "5px",
                        border: "1px solid ".concat(constants/* colorConstants.lightGray */.Q_.lightGray)
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: constants/* colorConstants.gray */.Q_.gray,
                        borderWidth: "1px"
                    }
                }
            }
        },
        MuiList: {
            styleOverrides: {
                root: {
                    border: "1px solid ".concat(constants/* colorConstants.gray */.Q_.gray),
                    borderRadius: "0 0 5px 5px",
                    paddingTop: 0
                }
            }
        },
        MuiMenu: {
            styleOverrides: {
                list: {
                    borderTop: "none"
                }
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    borderRadius: "0 0 5px 5px"
                }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: "0.875rem",
                    padding: ".5rem",
                    "&:hover": {
                        backgroundColor: constants/* colorConstants.lightGray */.Q_.lightGray
                    },
                    "&.Mui-selected": {
                        backgroundColor: constants/* colorConstants.lightGray */.Q_.lightGray
                    },
                    "&.Mui-selected:hover": {
                        backgroundColor: constants/* colorConstants.lightGray */.Q_.lightGray
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: "none"
                }
            }
        }
    }
};
var muiTheme = (0,createTheme/* default */.Z)(theme);
/* harmony default export */ var MUITheme = (muiTheme);

// EXTERNAL MODULE: ./styles/le-components.css
var le_components = __webpack_require__(22496);
// EXTERNAL MODULE: ./styles/main.scss
var main = __webpack_require__(7727);
// EXTERNAL MODULE: ./styles/global.css
var global = __webpack_require__(67284);
// EXTERNAL MODULE: ./styles/fonts.css
var fonts = __webpack_require__(64902);
// EXTERNAL MODULE: ./node_modules/@bugsnag/js/browser/notifier.js
var notifier = __webpack_require__(64061);
var notifier_default = /*#__PURE__*/__webpack_require__.n(notifier);
// EXTERNAL MODULE: ./node_modules/next/constants.js
var next_constants = __webpack_require__(31365);
;// CONCATENATED MODULE: ./utils/bugsnag.ts
/* provided dependency */ var process = __webpack_require__(83454);


var IGNORED_ERRORS = [
    "Failed to load https://www.googletagmanager.com/gtag/", 
];
function startBugsnag() {
    if (process.env.NEXT_PHASE !== next_constants.PHASE_PRODUCTION_BUILD) {
        notifier_default().start({
            apiKey: "e8bc1b26954ca4331158b3fe731fa28d",
            appVersion: "FaS5RUFxbPaTLfQUZO4Ab",
            autoDetectErrors: true,
            onError: function(event) {
                var originalError = event.originalError;
                var ignored = IGNORED_ERRORS.some(function(msg) {
                    return originalError && originalError.message && originalError.message.includes(msg);
                });
                if (ignored) {
                    return false;
                }
            }
        });
    }
}

// EXTERNAL MODULE: ./utils/datadog.ts + 15 modules
var datadog = __webpack_require__(53663);
// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(48711);
;// CONCATENATED MODULE: ./utils/createEmotionCache.ts

var isBrowser = typeof document !== "undefined";
// On the client side, Create a meta tag at the top of the <head> and set it as insertionPoint.
// This assures that MUI styles are loaded first.
// It allows developers to easily override MUI styles with other styling solutions, like CSS modules.
function createEmotionCache() {
    var insertionPoint;
    if (isBrowser) {
        var emotionInsertionPoint = document.querySelector('meta[name="emotion-insertion-point"]');
        insertionPoint = emotionInsertionPoint !== null && emotionInsertionPoint !== void 0 ? emotionInsertionPoint : undefined;
    }
    return (0,emotion_cache_browser_esm/* default */.Z)({
        key: "mui-style",
        insertionPoint: insertionPoint
    });
}

;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query-devtools/build/lib/index.mjs
'use client';


const ReactQueryDevtools =  true ? function () {
  return null;
} : 0;
const ReactQueryDevtoolsPanel = (/* unused pure expression or super */ null && ( true ? function () {
  return null;
} : 0));


//# sourceMappingURL=index.mjs.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./services/MembershipService/MembershipService.ts
var MembershipService = __webpack_require__(44653);
;// CONCATENATED MODULE: ./customHooks/useDefaultCurrency/index.ts






var useDefaultCurrency = function(param) {
    var setState = param.setState, currencies = param.currencies, _shouldFetch = param.shouldFetch, shouldFetch = _shouldFetch === void 0 ? true : _shouldFetch;
    (0,react.useEffect)(function() {
        if (!shouldFetch) {
            return;
        }
        var getDefaultCurrency = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var currency;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                MembershipService/* default.getDefaultCurrency */.Z.getDefaultCurrency(currencies)
                            ];
                        case 1:
                            currency = _state.sent();
                            setState(function(state) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                                    currency: currency.code,
                                    price: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.price), {
                                        symbol: currency.symbol
                                    })
                                });
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function getDefaultCurrency() {
                return _ref.apply(this, arguments);
            };
        }();
        getDefaultCurrency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
/* harmony default export */ var customHooks_useDefaultCurrency = (useDefaultCurrency);

// EXTERNAL MODULE: ./customHooks/useSignIn/useSignIn.ts
var useSignIn = __webpack_require__(37394);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/get-process-env.js
/* provided dependency */ var get_process_env_process = __webpack_require__(83454);
/**
 * Returns `process.env` if it is available in the environment.
 * Always returns an object make it similarly easy to use as `process.env`.
 */
function getProcessEnv() {
    if (typeof get_process_env_process === 'undefined' || !get_process_env_process.env) {
        return {};
    }
    return get_process_env_process.env;
}
//# sourceMappingURL=get-process-env.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/parse-cdn.js
var parse_cdn = __webpack_require__(99382);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-core/dist/esm/validation/helpers.js
var helpers = __webpack_require__(55469);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/arguments-resolver/index.js

/**
 * Helper for the track method
 */
function resolveArguments(eventName, properties, options, callback) {
    var _a;
    var args = [eventName, properties, options, callback];
    var name = (0,helpers/* isPlainObject */.PO)(eventName) ? eventName.event : eventName;
    if (!name || !(0,helpers/* isString */.HD)(name)) {
        throw new Error('Event missing');
    }
    var data = (0,helpers/* isPlainObject */.PO)(eventName)
        ? (_a = eventName.properties) !== null && _a !== void 0 ? _a : {}
        : (0,helpers/* isPlainObject */.PO)(properties)
            ? properties
            : {};
    var opts = {};
    if (!(0,helpers/* isFunction */.mf)(options)) {
        opts = options !== null && options !== void 0 ? options : {};
    }
    if ((0,helpers/* isPlainObject */.PO)(eventName) && !(0,helpers/* isFunction */.mf)(properties)) {
        opts = properties !== null && properties !== void 0 ? properties : {};
    }
    var cb = args.find(helpers/* isFunction */.mf);
    return [name, data, opts, cb];
}
/**
 * Helper for page, screen methods
 */
function resolvePageArguments(category, name, properties, options, callback) {
    var resolvedProperties;
    var resolvedOptions;
    var resolvedCategory = null;
    var resolvedName = null;
    var args = [category, name, properties, options, callback];
    // The legacy logic is basically:
    // - If there is a string, it's the name
    // - If there are two strings, it's category and name
    var strings = args.filter(helpers/* isString */.HD);
    if (strings.length === 1) {
        if ((0,helpers/* isString */.HD)(args[1])) {
            resolvedName = args[1];
            resolvedCategory = null;
        }
        else {
            resolvedName = strings[0];
            resolvedCategory = null;
        }
    }
    else if (strings.length === 2) {
        if (typeof args[0] === 'string') {
            resolvedCategory = args[0];
        }
        if (typeof args[1] === 'string') {
            resolvedName = args[1];
        }
    }
    // handle: analytics.page('category', 'name', properties, options, callback)
    var resolvedCallback = args.find(helpers/* isFunction */.mf);
    // handle:
    // - analytics.page('name')
    // - analytics.page('category', 'name')
    // - analytics.page(properties)
    // - analytics.page(properties, options)
    // - analytics.page('name', properties)
    // - analytics.page('name', properties, options)
    // - analytics.page('category', 'name', properties, options)
    // - analytics.page('category', 'name', properties, options, callback)
    // - analytics.page('category', 'name', callback)
    // - analytics.page(callback), etc
    // The legacy logic is basically:
    // - If there is a plain object, it's the properties
    // - If there are two plain objects, it's properties and options
    var objects = args.filter(helpers/* isPlainObject */.PO);
    if (objects.length === 1) {
        if ((0,helpers/* isPlainObject */.PO)(args[2])) {
            resolvedOptions = {};
            resolvedProperties = args[2];
        }
        else if ((0,helpers/* isPlainObject */.PO)(args[3])) {
            resolvedProperties = {};
            resolvedOptions = args[3];
        }
        else {
            resolvedProperties = objects[0];
            resolvedOptions = {};
        }
    }
    else if (objects.length === 2) {
        resolvedProperties = objects[0];
        resolvedOptions = objects[1];
    }
    return [
        resolvedCategory,
        resolvedName,
        (resolvedProperties !== null && resolvedProperties !== void 0 ? resolvedProperties : (resolvedProperties = {})),
        (resolvedOptions !== null && resolvedOptions !== void 0 ? resolvedOptions : (resolvedOptions = {})),
        resolvedCallback,
    ];
}
/**
 * Helper for group, identify methods
 */
var resolveUserArguments = function (user) {
    return function () {
        var _a, _b, _c;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var values = {};
        // It's a stack so it's reversed so that we go through each of the expected arguments
        var orderStack = [
            'callback',
            'options',
            'traits',
            'id',
        ];
        // Read each argument and eval the possible values here
        for (var _d = 0, args_1 = args; _d < args_1.length; _d++) {
            var arg = args_1[_d];
            var current = orderStack.pop();
            if (current === 'id') {
                if ((0,helpers/* isString */.HD)(arg) || (0,helpers/* isNumber */.hj)(arg)) {
                    values.id = arg.toString();
                    continue;
                }
                if (arg === null || arg === undefined) {
                    continue;
                }
                // First argument should always be the id, if it is not a valid value we can skip it
                current = orderStack.pop();
            }
            // Traits and Options
            if ((current === 'traits' || current === 'options') &&
                (arg === null || arg === undefined || (0,helpers/* isPlainObject */.PO)(arg))) {
                values[current] = arg;
            }
            // Callback
            if ((0,helpers/* isFunction */.mf)(arg)) {
                values.callback = arg;
                break; // This is always the last argument
            }
        }
        return [
            (_a = values.id) !== null && _a !== void 0 ? _a : user.id(),
            ((_b = values.traits) !== null && _b !== void 0 ? _b : {}),
            (_c = values.options) !== null && _c !== void 0 ? _c : {},
            values.callback,
        ];
    };
};
/**
 * Helper for alias method
 */
function resolveAliasArguments(to, from, options, callback) {
    if ((0,helpers/* isNumber */.hj)(to))
        to = to.toString(); // Legacy behaviour - allow integers for alias calls
    if ((0,helpers/* isNumber */.hj)(from))
        from = from.toString();
    var args = [to, from, options, callback];
    var _a = args.filter(helpers/* isString */.HD), _b = _a[0], aliasTo = _b === void 0 ? to : _b, _c = _a[1], aliasFrom = _c === void 0 ? null : _c;
    var _d = args.filter(helpers/* isPlainObject */.PO)[0], opts = _d === void 0 ? {} : _d;
    var resolvedCallback = args.find(helpers/* isFunction */.mf);
    return [aliasTo, aliasFrom, opts, resolvedCallback];
}
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/connection/index.js
var connection = __webpack_require__(65904);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/context/index.js
var core_context = __webpack_require__(29784);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-core/dist/esm/callback/index.js
var callback = __webpack_require__(4591);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/analytics/dispatch.js


/* The amount of time in ms to wait before invoking the callback. */
var getDelay = function (startTimeInEpochMS, timeoutInMS) {
    var elapsedTime = Date.now() - startTimeInEpochMS;
    // increasing the timeout increases the delay by almost the same amount -- this is weird legacy behavior.
    return Math.max((timeoutInMS !== null && timeoutInMS !== void 0 ? timeoutInMS : 300) - elapsedTime, 0);
};
/**
 * Push an event into the dispatch queue and invoke any callbacks.
 *
 * @param event - Segment event to enqueue.
 * @param queue - Queue to dispatch against.
 * @param emitter - This is typically an instance of "Analytics" -- used for metrics / progress information.
 * @param options
 */
function dispatch(ctx, queue, emitter, options) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var startTime, dispatched;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    emitter.emit('dispatch_start', ctx);
                    startTime = Date.now();
                    if (!queue.isEmpty()) return [3 /*break*/, 2];
                    return [4 /*yield*/, queue.dispatchSingle(ctx)];
                case 1:
                    dispatched = _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, queue.dispatch(ctx)];
                case 3:
                    dispatched = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(options === null || options === void 0 ? void 0 : options.callback)) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0,callback/* invokeCallback */.UI)(dispatched, options.callback, getDelay(startTime, options.timeout))];
                case 5:
                    dispatched = _a.sent();
                    _a.label = 6;
                case 6:
                    if (options === null || options === void 0 ? void 0 : options.debug) {
                        dispatched.flush();
                    }
                    return [2 /*return*/, dispatched];
            }
        });
    });
}
//# sourceMappingURL=dispatch.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-generic-utils/dist/esm/emitter/emitter.js
var emitter = __webpack_require__(38714);
// EXTERNAL MODULE: ./node_modules/@lukeed/uuid/dist/index.mjs
var dist = __webpack_require__(59108);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/pick.js

/**
 * @example
 * pick({ 'a': 1, 'b': '2', 'c': 3 }, ['a', 'c'])
 * => { 'a': 1, 'c': 3 }
 */
function pick(object, keys) {
    return Object.assign.apply(Object, (0,tslib_es6.__spreadArray)([{}], keys.map(function (key) {
        var _a;
        if (object && Object.prototype.hasOwnProperty.call(object, key)) {
            return _a = {}, _a[key] = object[key], _a;
        }
    }), false));
}
//# sourceMappingURL=pick.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-page-tools/dist/esm/index.mjs
// src/page-context.ts
function isPlainObject(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase() === "object";
}
var BufferedPageContextDiscriminant = "bpc";
var createBufferedPageContext = function(url, canonicalUrl, search, path, title, referrer) {
    return {
        __t: BufferedPageContextDiscriminant,
        c: canonicalUrl,
        p: path,
        u: url,
        s: search,
        t: title,
        r: referrer
    };
};
var BUFFERED_PAGE_CONTEXT_KEYS = Object.keys(createBufferedPageContext("", "", "", "", "", ""));
function isBufferedPageContext(bufferedPageCtx) {
    if (!isPlainObject(bufferedPageCtx)) return false;
    if (bufferedPageCtx.__t !== BufferedPageContextDiscriminant) return false;
    for(var k in bufferedPageCtx){
        if (!BUFFERED_PAGE_CONTEXT_KEYS.includes(k)) {
            return false;
        }
    }
    return true;
}
var createCanonicalURL = function(canonicalUrl, searchParams) {
    return canonicalUrl.indexOf("?") > -1 ? canonicalUrl : canonicalUrl + searchParams;
};
var removeHash = function(href) {
    var hashIdx = href.indexOf("#");
    return hashIdx === -1 ? href : href.slice(0, hashIdx);
};
var parseCanonicalPath = function(canonicalUrl) {
    try {
        return new URL(canonicalUrl).pathname;
    } catch (_e) {
        return canonicalUrl[0] === "/" ? canonicalUrl : "/" + canonicalUrl;
    }
};
var createPageContext = function(param) {
    var canonicalUrl = param.c, pathname = param.p, search = param.s, url = param.u, referrer = param.r, title = param.t;
    var newPath = canonicalUrl ? parseCanonicalPath(canonicalUrl) : pathname;
    var newUrl = canonicalUrl ? createCanonicalURL(canonicalUrl, search) : removeHash(url);
    return {
        path: newPath,
        referrer: referrer,
        search: search,
        title: title,
        url: newUrl
    };
};
var getDefaultBufferedPageContext = function() {
    var c = document.querySelector("link[rel='canonical']");
    return createBufferedPageContext(location.href, c && c.getAttribute("href") || void 0, location.search, location.pathname, document.title, document.referrer);
};
var getDefaultPageContext = function() {
    return createPageContext(getDefaultBufferedPageContext());
};


;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/page/add-page-context.js



/**
 * Augments a segment event with information about the current page.
 * Page information like URL changes frequently, so this is meant to be captured as close to the event call as possible.
 * Things like `userAgent` do not change, so they can be added later in the flow.
 * We prefer not to add this information to this function, as it increases the main bundle size.
 */
var addPageContext = function (event, pageCtx) {
    if (pageCtx === void 0) { pageCtx = getDefaultPageContext(); }
    var evtCtx = event.context; // Context should be set earlier in the flow
    var pageContextFromEventProps;
    if (event.type === 'page') {
        pageContextFromEventProps =
            event.properties && pick(event.properties, Object.keys(pageCtx));
        event.properties = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, pageCtx), event.properties), (event.name ? { name: event.name } : {}));
    }
    evtCtx.page = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, pageCtx), pageContextFromEventProps), evtCtx.page);
};
//# sourceMappingURL=add-page-context.js.map
// EXTERNAL MODULE: ./node_modules/dset/dist/index.mjs
var dset_dist = __webpack_require__(96475);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/utils/pick.js
var pickBy = function (obj, fn) {
    return Object.keys(obj)
        .filter(function (k) { return fn(k, obj[k]); })
        .reduce(function (acc, key) { return ((acc[key] = obj[key]), acc); }, {});
};
//# sourceMappingURL=pick.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/validation/errors.js

var errors_ValidationError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(ValidationError, _super);
    function ValidationError(field, message) {
        var _this = _super.call(this, "".concat(field, " ").concat(message)) || this;
        _this.field = field;
        return _this;
    }
    return ValidationError;
}(Error));

//# sourceMappingURL=errors.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/validation/assertions.js


var stringError = 'is not a string';
var objError = 'is not an object';
var nilError = 'is nil';
// user identity check could hypothetically could be used in the browser event factory, but not 100% sure -- so this is node only for now
function assertUserIdentity(event) {
    var USER_FIELD_NAME = '.userId/anonymousId/previousId/groupId';
    var getAnyUserId = function (event) { var _a, _b, _c; return (_c = (_b = (_a = event.userId) !== null && _a !== void 0 ? _a : event.anonymousId) !== null && _b !== void 0 ? _b : event.groupId) !== null && _c !== void 0 ? _c : event.previousId; };
    var id = getAnyUserId(event);
    if (!exists(id)) {
        throw new ValidationError(USER_FIELD_NAME, nilError);
    }
    else if (!isString(id)) {
        throw new ValidationError(USER_FIELD_NAME, stringError);
    }
}
function assertEventExists(event) {
    if (!(0,helpers/* exists */.Gg)(event)) {
        throw new errors_ValidationError('Event', nilError);
    }
    if (typeof event !== 'object') {
        throw new errors_ValidationError('Event', objError);
    }
}
function assertEventType(event) {
    if (!(0,helpers/* isString */.HD)(event.type)) {
        throw new errors_ValidationError('.type', stringError);
    }
}
function assertTrackEventName(event) {
    if (!(0,helpers/* isString */.HD)(event.event)) {
        throw new errors_ValidationError('.event', stringError);
    }
}
function assertTrackEventProperties(event) {
    if (!(0,helpers/* isPlainObject */.PO)(event.properties)) {
        throw new errors_ValidationError('.properties', objError);
    }
}
function assertTraits(event) {
    if (!(0,helpers/* isPlainObject */.PO)(event.traits)) {
        throw new errors_ValidationError('.traits', objError);
    }
}
function assertMessageId(event) {
    if (!(0,helpers/* isString */.HD)(event.messageId)) {
        throw new errors_ValidationError('.messageId', stringError);
    }
}
function validateEvent(event) {
    assertEventExists(event);
    assertEventType(event);
    assertMessageId(event);
    if (event.type === 'track') {
        assertTrackEventName(event);
        assertTrackEventProperties(event);
    }
    if (['group', 'identify'].includes(event.type)) {
        assertTraits(event);
    }
}
//# sourceMappingURL=assertions.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/events/index.js





/**
 * Internal settings object that is used internally by the factory
 */
var InternalEventFactorySettings = /** @class */ (function () {
    function InternalEventFactorySettings(settings) {
        var _a, _b;
        this.settings = settings;
        this.createMessageId = settings.createMessageId;
        this.onEventMethodCall = (_a = settings.onEventMethodCall) !== null && _a !== void 0 ? _a : (function () { });
        this.onFinishedEvent = (_b = settings.onFinishedEvent) !== null && _b !== void 0 ? _b : (function () { });
    }
    return InternalEventFactorySettings;
}());
var CoreEventFactory = /** @class */ (function () {
    function CoreEventFactory(settings) {
        this.settings = new InternalEventFactorySettings(settings);
    }
    CoreEventFactory.prototype.track = function (event, properties, options, integrationOptions) {
        this.settings.onEventMethodCall({ type: 'track', options: options });
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), { event: event, type: 'track', properties: properties !== null && properties !== void 0 ? properties : {}, options: (0,tslib_es6.__assign)({}, options), integrations: (0,tslib_es6.__assign)({}, integrationOptions) }));
    };
    CoreEventFactory.prototype.page = function (category, page, properties, options, integrationOptions) {
        var _a;
        this.settings.onEventMethodCall({ type: 'page', options: options });
        var event = {
            type: 'page',
            properties: (0,tslib_es6.__assign)({}, properties),
            options: (0,tslib_es6.__assign)({}, options),
            integrations: (0,tslib_es6.__assign)({}, integrationOptions),
        };
        if (category !== null) {
            event.category = category;
            event.properties = (_a = event.properties) !== null && _a !== void 0 ? _a : {};
            event.properties.category = category;
        }
        if (page !== null) {
            event.name = page;
        }
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), event));
    };
    CoreEventFactory.prototype.screen = function (category, screen, properties, options, integrationOptions) {
        this.settings.onEventMethodCall({ type: 'screen', options: options });
        var event = {
            type: 'screen',
            properties: (0,tslib_es6.__assign)({}, properties),
            options: (0,tslib_es6.__assign)({}, options),
            integrations: (0,tslib_es6.__assign)({}, integrationOptions),
        };
        if (category !== null) {
            event.category = category;
        }
        if (screen !== null) {
            event.name = screen;
        }
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), event));
    };
    CoreEventFactory.prototype.identify = function (userId, traits, options, integrationsOptions) {
        this.settings.onEventMethodCall({ type: 'identify', options: options });
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), { type: 'identify', userId: userId, traits: traits !== null && traits !== void 0 ? traits : {}, options: (0,tslib_es6.__assign)({}, options), integrations: integrationsOptions }));
    };
    CoreEventFactory.prototype.group = function (groupId, traits, options, integrationOptions) {
        this.settings.onEventMethodCall({ type: 'group', options: options });
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), { type: 'group', traits: traits !== null && traits !== void 0 ? traits : {}, options: (0,tslib_es6.__assign)({}, options), integrations: (0,tslib_es6.__assign)({}, integrationOptions), //
            groupId: groupId }));
    };
    CoreEventFactory.prototype.alias = function (to, from, // TODO: can we make this undefined?
    options, integrationOptions) {
        this.settings.onEventMethodCall({ type: 'alias', options: options });
        var base = {
            userId: to,
            type: 'alias',
            options: (0,tslib_es6.__assign)({}, options),
            integrations: (0,tslib_es6.__assign)({}, integrationOptions),
        };
        if (from !== null) {
            base.previousId = from;
        }
        if (to === undefined) {
            return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, base), this.baseEvent()));
        }
        return this.normalize((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.baseEvent()), base));
    };
    CoreEventFactory.prototype.baseEvent = function () {
        return {
            integrations: {},
            options: {},
        };
    };
    /**
     * Builds the context part of an event based on "foreign" keys that
     * are provided in the `Options` parameter for an Event
     */
    CoreEventFactory.prototype.context = function (options) {
        var _a;
        /**
         * If the event options are known keys from this list, we move them to the top level of the event.
         * Any other options are moved to context.
         */
        var eventOverrideKeys = [
            'userId',
            'anonymousId',
            'timestamp',
            'messageId',
        ];
        delete options['integrations'];
        var providedOptionsKeys = Object.keys(options);
        var context = (_a = options.context) !== null && _a !== void 0 ? _a : {};
        var eventOverrides = {};
        providedOptionsKeys.forEach(function (key) {
            if (key === 'context') {
                return;
            }
            if (eventOverrideKeys.includes(key)) {
                (0,dset_dist/* dset */.N)(eventOverrides, key, options[key]);
            }
            else {
                (0,dset_dist/* dset */.N)(context, key, options[key]);
            }
        });
        return [context, eventOverrides];
    };
    CoreEventFactory.prototype.normalize = function (event) {
        var _a, _b;
        var integrationBooleans = Object.keys((_a = event.integrations) !== null && _a !== void 0 ? _a : {}).reduce(function (integrationNames, name) {
            var _a;
            var _b;
            return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, integrationNames), (_a = {}, _a[name] = Boolean((_b = event.integrations) === null || _b === void 0 ? void 0 : _b[name]), _a));
        }, {});
        // filter out any undefined options
        event.options = pickBy(event.options || {}, function (_, value) {
            return value !== undefined;
        });
        // This is pretty trippy, but here's what's going on:
        // - a) We don't pass initial integration options as part of the event, only if they're true or false
        // - b) We do accept per integration overrides (like integrations.Amplitude.sessionId) at the event level
        // Hence the need to convert base integration options to booleans, but maintain per event integration overrides
        var allIntegrations = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, integrationBooleans), (_b = event.options) === null || _b === void 0 ? void 0 : _b.integrations);
        var _c = event.options
            ? this.context(event.options)
            : [], context = _c[0], overrides = _c[1];
        var options = event.options, rest = (0,tslib_es6.__rest)(event, ["options"]);
        var evt = (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({ timestamp: new Date() }, rest), { context: context, integrations: allIntegrations }), overrides), { messageId: options.messageId || this.settings.createMessageId() });
        this.settings.onFinishedEvent(evt);
        validateEvent(evt);
        return evt;
    };
    return CoreEventFactory;
}());

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/events/index.js





var EventFactory = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(EventFactory, _super);
    function EventFactory(user) {
        var _this = _super.call(this, {
            createMessageId: function () { return "ajs-next-".concat(Date.now(), "-").concat((0,dist.v4)()); },
            onEventMethodCall: function (_a) {
                var options = _a.options;
                _this.maybeUpdateAnonId(options);
            },
            onFinishedEvent: function (event) {
                _this.addIdentity(event);
                return event;
            },
        }) || this;
        _this.user = user;
        return _this;
    }
    /**
     * Updates the anonymousId *globally* if it's provided in the options.
     * This should generally be done in the identify method, but some customers rely on this.
     */
    EventFactory.prototype.maybeUpdateAnonId = function (options) {
        (options === null || options === void 0 ? void 0 : options.anonymousId) && this.user.anonymousId(options.anonymousId);
    };
    /**
     * add user id / anonymous id to the event
     */
    EventFactory.prototype.addIdentity = function (event) {
        if (this.user.id()) {
            event.userId = this.user.id();
        }
        if (this.user.anonymousId()) {
            event.anonymousId = this.user.anonymousId();
        }
    };
    EventFactory.prototype.track = function (event, properties, options, integrationsOptions, pageCtx) {
        var ev = _super.prototype.track.call(this, event, properties, options, integrationsOptions);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.page = function (category, page, properties, options, integrationsOptions, pageCtx) {
        var ev = _super.prototype.page.call(this, category, page, properties, options, integrationsOptions);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.screen = function (category, screen, properties, options, integrationsOptions, pageCtx) {
        var ev = _super.prototype.screen.call(this, category, screen, properties, options, integrationsOptions);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.identify = function (userId, traits, options, integrationsOptions, pageCtx) {
        var ev = _super.prototype.identify.call(this, userId, traits, options, integrationsOptions);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.group = function (groupId, traits, options, integrationsOptions, pageCtx) {
        var ev = _super.prototype.group.call(this, groupId, traits, options, integrationsOptions);
        addPageContext(ev, pageCtx);
        return ev;
    };
    EventFactory.prototype.alias = function (to, from, options, integrationsOptions, pageCtx) {
        var ev = _super.prototype.alias.call(this, to, from, options, integrationsOptions);
        addPageContext(ev, pageCtx);
        return ev;
    };
    return EventFactory;
}(CoreEventFactory));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/plugin/index.js
var isDestinationPluginWithAddMiddleware = function (plugin) {
    // FYI: segment's plugin does not currently have an 'addMiddleware' method
    return 'addMiddleware' in plugin && plugin.type === 'destination';
};
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/priority-queue/persisted.js
var persisted = __webpack_require__(65976);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/utils/group-by.js

function groupBy(collection, grouper) {
    var results = {};
    collection.forEach(function (item) {
        var _a;
        var key = undefined;
        if (typeof grouper === 'string') {
            var suggestedKey = item[grouper];
            key =
                typeof suggestedKey !== 'string'
                    ? JSON.stringify(suggestedKey)
                    : suggestedKey;
        }
        else if (grouper instanceof Function) {
            key = grouper(item);
        }
        if (key === undefined) {
            return;
        }
        results[key] = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], ((_a = results[key]) !== null && _a !== void 0 ? _a : []), true), [item], false);
    });
    return results;
}
//# sourceMappingURL=group-by.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-core/dist/esm/priority-queue/index.js + 1 modules
var priority_queue = __webpack_require__(51181);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-core/dist/esm/context/index.js + 1 modules
var esm_context = __webpack_require__(98191);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/utils/is-thenable.js
/**
 *  Check if  thenable
 *  (instanceof Promise doesn't respect realms)
 */
var isThenable = function (value) {
    return typeof value === 'object' &&
        value !== null &&
        'then' in value &&
        typeof value.then === 'function';
};
//# sourceMappingURL=is-thenable.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/task/task-group.js

var createTaskGroup = function () {
    var taskCompletionPromise;
    var resolvePromise;
    var count = 0;
    return {
        done: function () { return taskCompletionPromise; },
        run: function (op) {
            var returnValue = op();
            if (isThenable(returnValue)) {
                if (++count === 1) {
                    taskCompletionPromise = new Promise(function (res) { return (resolvePromise = res); });
                }
                returnValue.finally(function () { return --count === 0 && resolvePromise(); });
            }
            return returnValue;
        },
    };
};
//# sourceMappingURL=task-group.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-core/dist/esm/queue/delivery.js
var delivery = __webpack_require__(69147);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-core/dist/esm/queue/event-queue.js







var CoreEventQueue = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(CoreEventQueue, _super);
    function CoreEventQueue(priorityQueue) {
        var _this = _super.call(this) || this;
        /**
         * All event deliveries get suspended until all the tasks in this task group are complete.
         * For example: a middleware that augments the event object should be loaded safely as a
         * critical task, this way, event queue will wait for it to be ready before sending events.
         *
         * This applies to all the events already in the queue, and the upcoming ones
         */
        _this.criticalTasks = createTaskGroup();
        _this.plugins = [];
        _this.failedInitializations = [];
        _this.flushing = false;
        _this.queue = priorityQueue;
        _this.queue.on(priority_queue/* ON_REMOVE_FROM_FUTURE */.M, function () {
            _this.scheduleFlush(0);
        });
        return _this;
    }
    CoreEventQueue.prototype.register = function (ctx, plugin, instance) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var handleLoadError, err_1;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.plugins.push(plugin);
                        handleLoadError = function (err) {
                            _this.failedInitializations.push(plugin.name);
                            _this.emit('initialization_failure', plugin);
                            console.warn(plugin.name, err);
                            ctx.log('warn', 'Failed to load destination', {
                                plugin: plugin.name,
                                error: err,
                            });
                            // Filter out the failed plugin by excluding it from the list
                            _this.plugins = _this.plugins.filter(function (p) { return p !== plugin; });
                        };
                        if (!(plugin.type === 'destination' && plugin.name !== 'Segment.io')) return [3 /*break*/, 1];
                        plugin.load(ctx, instance).catch(handleLoadError);
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, plugin.load(ctx, instance)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        handleLoadError(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CoreEventQueue.prototype.deregister = function (ctx, plugin, instance) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var e_1;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!plugin.unload) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.resolve(plugin.unload(ctx, instance))];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.plugins = this.plugins.filter(function (p) { return p.name !== plugin.name; });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        ctx.log('warn', 'Failed to unload destination', {
                            plugin: plugin.name,
                            error: e_1,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CoreEventQueue.prototype.dispatch = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var willDeliver;
            return (0,tslib_es6.__generator)(this, function (_a) {
                ctx.log('debug', 'Dispatching');
                ctx.stats.increment('message_dispatched');
                this.queue.push(ctx);
                willDeliver = this.subscribeToDelivery(ctx);
                this.scheduleFlush(0);
                return [2 /*return*/, willDeliver];
            });
        });
    };
    CoreEventQueue.prototype.subscribeToDelivery = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        var onDeliver = function (flushed, delivered) {
                            if (flushed.isSame(ctx)) {
                                _this.off('flush', onDeliver);
                                if (delivered) {
                                    resolve(flushed);
                                }
                                else {
                                    resolve(flushed);
                                }
                            }
                        };
                        _this.on('flush', onDeliver);
                    })];
            });
        });
    };
    CoreEventQueue.prototype.dispatchSingle = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                ctx.log('debug', 'Dispatching');
                ctx.stats.increment('message_dispatched');
                this.queue.updateAttempts(ctx);
                ctx.attempts = 1;
                return [2 /*return*/, this.deliver(ctx).catch(function (err) {
                        var accepted = _this.enqueuRetry(err, ctx);
                        if (!accepted) {
                            ctx.setFailedDelivery({ reason: err });
                            return ctx;
                        }
                        return _this.subscribeToDelivery(ctx);
                    })];
            });
        });
    };
    CoreEventQueue.prototype.isEmpty = function () {
        return this.queue.length === 0;
    };
    CoreEventQueue.prototype.scheduleFlush = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 500; }
        if (this.flushing) {
            return;
        }
        this.flushing = true;
        setTimeout(function () {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            _this.flush().then(function () {
                setTimeout(function () {
                    _this.flushing = false;
                    if (_this.queue.length) {
                        _this.scheduleFlush(0);
                    }
                }, 0);
            });
        }, timeout);
    };
    CoreEventQueue.prototype.deliver = function (ctx) {
        var _a;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var start, done, failure, error, err_2, error;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.criticalTasks.done()];
                    case 1:
                        _b.sent();
                        start = Date.now();
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.flushOne(ctx)];
                    case 3:
                        ctx = _b.sent();
                        done = Date.now() - start;
                        failure = ctx.failedDelivery();
                        if (failure) {
                            error = failure.reason instanceof Error
                                ? failure.reason
                                : new Error(String((_a = failure.reason) !== null && _a !== void 0 ? _a : 'Unknown delivery failure'));
                            ctx.log('error', 'Failed to deliver', error);
                            this.emit('delivery_failure', ctx, error);
                            ctx.stats.increment('delivery_failed');
                            return [2 /*return*/, ctx];
                        }
                        this.emit('delivery_success', ctx);
                        ctx.stats.gauge('delivered', done);
                        ctx.log('debug', 'Delivered', ctx.event);
                        return [2 /*return*/, ctx];
                    case 4:
                        err_2 = _b.sent();
                        error = err_2;
                        ctx.log('error', 'Failed to deliver', error);
                        this.emit('delivery_failure', ctx, error);
                        ctx.stats.increment('delivery_failed');
                        throw err_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CoreEventQueue.prototype.enqueuRetry = function (err, ctx) {
        var retriable = !(err instanceof esm_context/* ContextCancelation */.Y) || err.retry;
        if (!retriable) {
            return false;
        }
        return this.queue.pushWithBackoff(ctx);
    };
    CoreEventQueue.prototype.flush = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var ctx, delivered, err_3, accepted;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.queue.length === 0) {
                            return [2 /*return*/, []];
                        }
                        ctx = this.queue.pop();
                        if (!ctx) {
                            return [2 /*return*/, []];
                        }
                        ctx.attempts = this.queue.getAttempts(ctx);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.deliver(ctx)
                            // deliver() now handles failedDelivery state internally without throwing,
                            // so we check ctx.failedDelivery() to determine the correct flush status
                        ];
                    case 2:
                        ctx = _a.sent();
                        delivered = !ctx.failedDelivery();
                        this.emit('flush', ctx, delivered);
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        accepted = this.enqueuRetry(err_3, ctx);
                        if (!accepted) {
                            ctx.setFailedDelivery({ reason: err_3 });
                            this.emit('flush', ctx, false);
                        }
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/, [ctx]];
                }
            });
        });
    };
    CoreEventQueue.prototype.isReady = function () {
        // return this.plugins.every((p) => p.isLoaded())
        // should we wait for every plugin to load?
        return true;
    };
    CoreEventQueue.prototype.availableExtensions = function (denyList) {
        var available = this.plugins.filter(function (p) {
            var _a, _b, _c;
            // Only filter out destination plugins or the Segment.io plugin
            if (p.type !== 'destination' && p.name !== 'Segment.io') {
                return true;
            }
            var alternativeNameMatch = undefined;
            (_a = p.alternativeNames) === null || _a === void 0 ? void 0 : _a.forEach(function (name) {
                if (denyList[name] !== undefined) {
                    alternativeNameMatch = denyList[name];
                }
            });
            // Explicit integration option takes precedence, `All: false` does not apply to Segment.io
            return ((_c = (_b = denyList[p.name]) !== null && _b !== void 0 ? _b : alternativeNameMatch) !== null && _c !== void 0 ? _c : (p.name === 'Segment.io' ? true : denyList.All) !== false);
        });
        var _a = groupBy(available, 'type'), _b = _a.before, before = _b === void 0 ? [] : _b, _c = _a.enrichment, enrichment = _c === void 0 ? [] : _c, _d = _a.destination, destination = _d === void 0 ? [] : _d, _e = _a.after, after = _e === void 0 ? [] : _e;
        return {
            before: before,
            enrichment: enrichment,
            destinations: destination,
            after: after,
        };
    };
    CoreEventQueue.prototype.flushOne = function (ctx) {
        var _a, _b;
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _c, before, enrichment, _i, before_1, beforeWare, temp, _d, enrichment_1, enrichmentWare, temp, _e, destinations, after, afterCalls;
            return (0,tslib_es6.__generator)(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!this.isReady()) {
                            throw new Error('Not ready');
                        }
                        if (ctx.attempts > 1) {
                            this.emit('delivery_retry', ctx);
                        }
                        _c = this.availableExtensions((_a = ctx.event.integrations) !== null && _a !== void 0 ? _a : {}), before = _c.before, enrichment = _c.enrichment;
                        _i = 0, before_1 = before;
                        _f.label = 1;
                    case 1:
                        if (!(_i < before_1.length)) return [3 /*break*/, 4];
                        beforeWare = before_1[_i];
                        return [4 /*yield*/, (0,delivery/* ensure */.z)(ctx, beforeWare)];
                    case 2:
                        temp = _f.sent();
                        if (temp instanceof esm_context/* CoreContext */._) {
                            ctx = temp;
                        }
                        this.emit('message_enriched', ctx, beforeWare);
                        _f.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        _d = 0, enrichment_1 = enrichment;
                        _f.label = 5;
                    case 5:
                        if (!(_d < enrichment_1.length)) return [3 /*break*/, 8];
                        enrichmentWare = enrichment_1[_d];
                        return [4 /*yield*/, (0,delivery/* attempt */.a)(ctx, enrichmentWare)];
                    case 6:
                        temp = _f.sent();
                        if (temp instanceof esm_context/* CoreContext */._) {
                            ctx = temp;
                        }
                        this.emit('message_enriched', ctx, enrichmentWare);
                        _f.label = 7;
                    case 7:
                        _d++;
                        return [3 /*break*/, 5];
                    case 8:
                        _e = this.availableExtensions((_b = ctx.event.integrations) !== null && _b !== void 0 ? _b : {}), destinations = _e.destinations, after = _e.after;
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                setTimeout(function () {
                                    var attempts = destinations.map(function (destination) {
                                        return (0,delivery/* attempt */.a)(ctx, destination);
                                    });
                                    Promise.all(attempts).then(resolve).catch(reject);
                                }, 0);
                            })];
                    case 9:
                        _f.sent();
                        ctx.stats.increment('message_delivered');
                        this.emit('message_delivered', ctx);
                        afterCalls = after.map(function (after) { return (0,delivery/* attempt */.a)(ctx, after); });
                        return [4 /*yield*/, Promise.all(afterCalls)];
                    case 10:
                        _f.sent();
                        return [2 /*return*/, ctx];
                }
            });
        });
    };
    return CoreEventQueue;
}(emitter/* Emitter */.Q));

//# sourceMappingURL=event-queue.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/queue/event-queue.js




var EventQueue = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(EventQueue, _super);
    function EventQueue(nameOrQueue) {
        return _super.call(this, typeof nameOrQueue === 'string'
            ? new persisted/* PersistedPriorityQueue */.$(4, nameOrQueue)
            : nameOrQueue) || this;
    }
    EventQueue.prototype.flush = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                if ((0,connection/* isOffline */.s)())
                    return [2 /*return*/, []];
                return [2 /*return*/, _super.prototype.flush.call(this)];
            });
        });
    };
    return EventQueue;
}(CoreEventQueue));

//# sourceMappingURL=event-queue.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/bind-all.js
function bindAll(obj) {
    var proto = obj.constructor.prototype;
    for (var _i = 0, _a = Object.getOwnPropertyNames(proto); _i < _a.length; _i++) {
        var key = _a[_i];
        if (key !== 'constructor') {
            var desc = Object.getOwnPropertyDescriptor(obj.constructor.prototype, key);
            if (!!desc && typeof desc.value === 'function') {
                obj[key] = obj[key].bind(obj);
            }
        }
    }
    return obj;
}
//# sourceMappingURL=bind-all.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/storage/types.js
var StoreType = {
    Cookie: 'cookie',
    LocalStorage: 'localStorage',
    Memory: 'memory',
};
//# sourceMappingURL=types.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/storage/universalStorage.js
// not adding to private method because those method names do not get minified atm, and does not use 'this'
var _logStoreKeyError = function (store, action, key, err) {
    console.warn("".concat(store.constructor.name, ": Can't ").concat(action, " key \"").concat(key, "\" | Err: ").concat(err));
};
/**
 * Uses multiple storages in a priority list to get/set values in the order they are specified.
 */
var UniversalStorage = /** @class */ (function () {
    function UniversalStorage(stores) {
        this.stores = stores;
    }
    UniversalStorage.prototype.get = function (key) {
        var val = null;
        for (var _i = 0, _a = this.stores; _i < _a.length; _i++) {
            var store = _a[_i];
            try {
                val = store.get(key);
                if (val !== undefined && val !== null) {
                    return val;
                }
            }
            catch (e) {
                _logStoreKeyError(store, 'get', key, e);
            }
        }
        return null;
    };
    UniversalStorage.prototype.set = function (key, value) {
        this.stores.forEach(function (store) {
            try {
                store.set(key, value);
            }
            catch (e) {
                _logStoreKeyError(store, 'set', key, e);
            }
        });
    };
    UniversalStorage.prototype.clear = function (key) {
        this.stores.forEach(function (store) {
            try {
                store.remove(key);
            }
            catch (e) {
                _logStoreKeyError(store, 'remove', key, e);
            }
        });
    };
    /*
      This is to support few scenarios where:
      - value exist in one of the stores ( as a result of other stores being cleared from browser ) and we want to resync them
      - read values in AJS 1.0 format ( for customers after 1.0 --> 2.0 migration ) and then re-write them in AJS 2.0 format
    */
    UniversalStorage.prototype.getAndSync = function (key) {
        var val = this.get(key);
        // legacy behavior, getAndSync can change the type of a value from number to string (AJS 1.0 stores numerical values as a number)
        var coercedValue = (typeof val === 'number' ? val.toString() : val);
        this.set(key, coercedValue);
        return coercedValue;
    };
    return UniversalStorage;
}());

//# sourceMappingURL=universalStorage.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/storage/memoryStorage.js
/**
 * Data Storage using in memory object
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache = {};
    }
    MemoryStorage.prototype.get = function (key) {
        var _a;
        return ((_a = this.cache[key]) !== null && _a !== void 0 ? _a : null);
    };
    MemoryStorage.prototype.set = function (key, value) {
        this.cache[key] = value;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache[key];
    };
    return MemoryStorage;
}());

//# sourceMappingURL=memoryStorage.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/storage/settings.js

function isArrayOfStoreType(s) {
    return (s &&
        s.stores &&
        Array.isArray(s.stores) &&
        s.stores.every(function (e) { return Object.values(StoreType).includes(e); }));
}
function isStoreTypeWithSettings(s) {
    return typeof s === 'object' && s.name !== undefined;
}
//# sourceMappingURL=settings.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.1 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (key, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      key + '=' + converter.write(value, key) + stringifiedAttributes)
  }

  function get (key) {
    if (typeof document === 'undefined' || (arguments.length && !key)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (key, attributes) {
        set(
          key,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */

/* harmony default export */ var dist_js_cookie = (api);

;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/user/tld.js

/**
 * Levels returns all levels of the given url.
 *
 * @param {string} url
 * @return {Array}
 * @api public
 */
function levels(url) {
    var host = url.hostname;
    var parts = host.split('.');
    var last = parts[parts.length - 1];
    var levels = [];
    // Ip address.
    if (parts.length === 4 && parseInt(last, 10) > 0) {
        return levels;
    }
    // Localhost.
    if (parts.length <= 1) {
        return levels;
    }
    // Create levels.
    for (var i = parts.length - 2; i >= 0; --i) {
        levels.push(parts.slice(i).join('.'));
    }
    return levels;
}
function parseUrl(url) {
    try {
        return new URL(url);
    }
    catch (_a) {
        return;
    }
}
function tld(url) {
    var parsedUrl = parseUrl(url);
    if (!parsedUrl)
        return;
    var lvls = levels(parsedUrl);
    // Lookup the real top level one.
    for (var i = 0; i < lvls.length; ++i) {
        var cname = '__tld__';
        var domain = lvls[i];
        var opts = { domain: '.' + domain };
        try {
            // cookie access throw an error if the library is ran inside a sandboxed environment (e.g. sandboxed iframe)
            dist_js_cookie.set(cname, '1', opts);
            if (dist_js_cookie.get(cname)) {
                dist_js_cookie.remove(cname, opts);
                return domain;
            }
        }
        catch (_) {
            return;
        }
    }
}
//# sourceMappingURL=tld.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/storage/cookieStorage.js



var ONE_YEAR = 365;
/**
 * Data storage using browser cookies
 */
var CookieStorage = /** @class */ (function () {
    function CookieStorage(options) {
        if (options === void 0) { options = CookieStorage.defaults; }
        this.options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, CookieStorage.defaults), options);
    }
    Object.defineProperty(CookieStorage, "defaults", {
        get: function () {
            return {
                maxage: ONE_YEAR,
                domain: tld(window.location.href),
                path: '/',
                sameSite: 'Lax',
            };
        },
        enumerable: false,
        configurable: true
    });
    CookieStorage.prototype.opts = function () {
        return {
            sameSite: this.options.sameSite,
            expires: this.options.maxage,
            domain: this.options.domain,
            path: this.options.path,
            secure: this.options.secure,
        };
    };
    CookieStorage.prototype.get = function (key) {
        var _a;
        try {
            var value = dist_js_cookie.get(key);
            if (value === undefined || value === null) {
                return null;
            }
            try {
                return (_a = JSON.parse(value)) !== null && _a !== void 0 ? _a : null;
            }
            catch (e) {
                return (value !== null && value !== void 0 ? value : null);
            }
        }
        catch (e) {
            return null;
        }
    };
    CookieStorage.prototype.set = function (key, value) {
        if (typeof value === 'string') {
            dist_js_cookie.set(key, value, this.opts());
        }
        else if (value === null) {
            dist_js_cookie.remove(key, this.opts());
        }
        else {
            dist_js_cookie.set(key, JSON.stringify(value), this.opts());
        }
    };
    CookieStorage.prototype.remove = function (key) {
        return dist_js_cookie.remove(key, this.opts());
    };
    return CookieStorage;
}());

//# sourceMappingURL=cookieStorage.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/storage/localStorage.js
/**
 * Data storage using browser's localStorage
 */
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
    }
    LocalStorage.prototype.localStorageWarning = function (key, state) {
        console.warn("Unable to access ".concat(key, ", localStorage may be ").concat(state));
    };
    LocalStorage.prototype.get = function (key) {
        var _a;
        try {
            var val = localStorage.getItem(key);
            if (val === null) {
                return null;
            }
            try {
                return (_a = JSON.parse(val)) !== null && _a !== void 0 ? _a : null;
            }
            catch (e) {
                return (val !== null && val !== void 0 ? val : null);
            }
        }
        catch (err) {
            this.localStorageWarning(key, 'unavailable');
            return null;
        }
    };
    LocalStorage.prototype.set = function (key, value) {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        }
        catch (_a) {
            this.localStorageWarning(key, 'full');
        }
    };
    LocalStorage.prototype.remove = function (key) {
        try {
            return localStorage.removeItem(key);
        }
        catch (err) {
            this.localStorageWarning(key, 'unavailable');
        }
    };
    return LocalStorage;
}());

//# sourceMappingURL=localStorage.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/storage/index.js











/**
 * Creates multiple storage systems from an array of StoreType and options
 * @param args StoreType and options
 * @returns Storage array
 */
function initializeStorages(args) {
    var storages = args.map(function (s) {
        var type;
        var settings;
        if (isStoreTypeWithSettings(s)) {
            type = s.name;
            settings = s.settings;
        }
        else {
            type = s;
        }
        switch (type) {
            case StoreType.Cookie:
                return new CookieStorage(settings);
            case StoreType.LocalStorage:
                return new LocalStorage();
            case StoreType.Memory:
                return new MemoryStorage();
            default:
                throw new Error("Unknown Store Type: ".concat(s));
        }
    });
    return storages;
}
/**
 * Injects the CookieOptions into a the arguments for initializeStorage
 * @param storeTypes list of storeType
 * @param cookieOptions cookie Options
 * @returns arguments for initializeStorage
 */
function applyCookieOptions(storeTypes, cookieOptions) {
    return storeTypes.map(function (s) {
        if (cookieOptions && s === StoreType.Cookie) {
            return {
                name: s,
                settings: cookieOptions,
            };
        }
        return s;
    });
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/user/index.js




var defaults = {
    persist: true,
    cookie: {
        key: 'ajs_user_id',
        oldKey: 'ajs_user',
    },
    localStorage: {
        key: 'ajs_user_traits',
    },
};
var User = /** @class */ (function () {
    function User(options, cookieOptions) {
        if (options === void 0) { options = defaults; }
        var _this = this;
        var _a, _b, _c, _d;
        this.options = {};
        this.id = function (id) {
            if (_this.options.disable) {
                return null;
            }
            var prevId = _this.identityStore.getAndSync(_this.idKey);
            if (id !== undefined) {
                _this.identityStore.set(_this.idKey, id);
                var changingIdentity = id !== prevId && prevId !== null && id !== null;
                if (changingIdentity) {
                    _this.anonymousId(null);
                }
            }
            var retId = _this.identityStore.getAndSync(_this.idKey);
            if (retId)
                return retId;
            var retLeg = _this.legacyUserStore.get(defaults.cookie.oldKey);
            return retLeg ? (typeof retLeg === 'object' ? retLeg.id : retLeg) : null;
        };
        this.anonymousId = function (id) {
            var _a, _b;
            if (_this.options.disable) {
                return null;
            }
            if (id === undefined) {
                var val = (_a = _this.identityStore.getAndSync(_this.anonKey)) !== null && _a !== void 0 ? _a : (_b = _this.legacySIO()) === null || _b === void 0 ? void 0 : _b[0];
                if (val) {
                    return val;
                }
            }
            if (id === null) {
                _this.identityStore.set(_this.anonKey, null);
                return _this.identityStore.getAndSync(_this.anonKey);
            }
            _this.identityStore.set(_this.anonKey, id !== null && id !== void 0 ? id : (0,dist.v4)());
            return _this.identityStore.getAndSync(_this.anonKey);
        };
        this.traits = function (traits) {
            var _a;
            if (_this.options.disable) {
                return;
            }
            if (traits === null) {
                traits = {};
            }
            if (traits) {
                _this.traitsStore.set(_this.traitsKey, traits !== null && traits !== void 0 ? traits : {});
            }
            return (_a = _this.traitsStore.get(_this.traitsKey)) !== null && _a !== void 0 ? _a : {};
        };
        this.options = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, defaults), options);
        this.cookieOptions = cookieOptions;
        this.idKey = (_b = (_a = options.cookie) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : defaults.cookie.key;
        this.traitsKey = (_d = (_c = options.localStorage) === null || _c === void 0 ? void 0 : _c.key) !== null && _d !== void 0 ? _d : defaults.localStorage.key;
        this.anonKey = 'ajs_anonymous_id';
        this.identityStore = this.createStorage(this.options, cookieOptions);
        // using only cookies for legacy user store
        this.legacyUserStore = this.createStorage(this.options, cookieOptions, function (s) { return s === StoreType.Cookie; });
        // using only localStorage / memory for traits store
        this.traitsStore = this.createStorage(this.options, cookieOptions, function (s) { return s !== StoreType.Cookie; });
        var legacyUser = this.legacyUserStore.get(defaults.cookie.oldKey);
        if (legacyUser && typeof legacyUser === 'object') {
            legacyUser.id && this.id(legacyUser.id);
            legacyUser.traits && this.traits(legacyUser.traits);
        }
        bindAll(this);
    }
    User.prototype.legacySIO = function () {
        var val = this.legacyUserStore.get('_sio');
        if (!val) {
            return null;
        }
        var _a = val.split('----'), anon = _a[0], user = _a[1];
        return [anon, user];
    };
    User.prototype.identify = function (id, traits) {
        if (this.options.disable) {
            return;
        }
        traits = traits !== null && traits !== void 0 ? traits : {};
        var currentId = this.id();
        if (currentId === null || currentId === id) {
            traits = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, this.traits()), traits);
        }
        if (id) {
            this.id(id);
        }
        this.traits(traits);
    };
    User.prototype.logout = function () {
        this.anonymousId(null);
        this.id(null);
        this.traits({});
    };
    User.prototype.reset = function () {
        this.logout();
        this.identityStore.clear(this.idKey);
        this.identityStore.clear(this.anonKey);
        this.traitsStore.clear(this.traitsKey);
    };
    User.prototype.load = function () {
        return new User(this.options, this.cookieOptions);
    };
    User.prototype.save = function () {
        return true;
    };
    /**
     * Creates the right storage system applying all the user options, cookie options and particular filters
     * @param options UserOptions
     * @param cookieOpts CookieOptions
     * @param filterStores filter function to apply to any StoreTypes (skipped if options specify using a custom storage)
     * @returns a Storage object
     */
    User.prototype.createStorage = function (options, cookieOpts, filterStores) {
        var stores = [
            StoreType.LocalStorage,
            StoreType.Cookie,
            StoreType.Memory,
        ];
        // If disabled we won't have any storage functionality
        if (options.disable) {
            return new UniversalStorage([]);
        }
        // If persistance is disabled we will always fallback to Memory Storage
        if (!options.persist) {
            return new UniversalStorage([new MemoryStorage()]);
        }
        if (options.storage !== undefined && options.storage !== null) {
            if (isArrayOfStoreType(options.storage)) {
                // If the user only specified order of stores we will still apply filters and transformations e.g. not using localStorage if localStorageFallbackDisabled
                stores = options.storage.stores;
            }
        }
        // Disable LocalStorage
        if (options.localStorageFallbackDisabled) {
            stores = stores.filter(function (s) { return s !== StoreType.LocalStorage; });
        }
        // Apply Additional filters
        if (filterStores) {
            stores = stores.filter(filterStores);
        }
        return new UniversalStorage(initializeStorages(applyCookieOptions(stores, cookieOpts)));
    };
    User.defaults = defaults;
    return User;
}());

var groupDefaults = {
    persist: true,
    cookie: {
        key: 'ajs_group_id',
    },
    localStorage: {
        key: 'ajs_group_properties',
    },
};
var Group = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Group, _super);
    function Group(options, cookie) {
        if (options === void 0) { options = groupDefaults; }
        var _this = _super.call(this, (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, groupDefaults), options), cookie) || this;
        _this.anonymousId = function (_id) {
            return undefined;
        };
        bindAll(_this);
        return _this;
    }
    return Group;
}(User));

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/generated/version.js
var version = __webpack_require__(39821);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/get-global.js
var get_global = __webpack_require__(44083);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/global-analytics-helper.js
var global_analytics_helper = __webpack_require__(74939);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/is-thenable.js
/**
 *  Check if  thenable
 *  (instanceof Promise doesn't respect realms)
 */
var is_thenable_isThenable = function (value) {
    return typeof value === 'object' &&
        value !== null &&
        'then' in value &&
        typeof value.then === 'function';
};
//# sourceMappingURL=is-thenable.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/version-type.js
var version_type = __webpack_require__(7227);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/buffer/index.js






var flushSyncAnalyticsCalls = function (name, analytics, buffer) {
    buffer.getAndRemove(name).forEach(function (c) {
        // While the underlying methods are synchronous, the callAnalyticsMethod returns a promise,
        // which normalizes success and error states between async and non-async methods, with no perf penalty.
        callAnalyticsMethod(analytics, c).catch(console.error);
    });
};
var flushAddSourceMiddleware = function (analytics, buffer) { return (0,tslib_es6.__awaiter)(void 0, void 0, void 0, function () {
    var _i, _a, c;
    return (0,tslib_es6.__generator)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _i = 0, _a = buffer.getAndRemove('addSourceMiddleware');
                _b.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 4];
                c = _a[_i];
                return [4 /*yield*/, callAnalyticsMethod(analytics, c).catch(console.error)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 *  Flush register plugin
 */
var flushRegister = function (analytics, buffer) { return (0,tslib_es6.__awaiter)(void 0, void 0, void 0, function () {
    var _i, _a, c;
    return (0,tslib_es6.__generator)(this, function (_b) {
        switch (_b.label) {
            case 0:
                _i = 0, _a = buffer.getAndRemove('register');
                _b.label = 1;
            case 1:
                if (!(_i < _a.length)) return [3 /*break*/, 4];
                c = _a[_i];
                return [4 /*yield*/, callAnalyticsMethod(analytics, c).catch(console.error)];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/];
        }
    });
}); };
var flushOn = flushSyncAnalyticsCalls.bind(undefined, 'on');
var flushSetAnonymousID = flushSyncAnalyticsCalls.bind(undefined, 'setAnonymousId');
var flushAnalyticsCallsInNewTask = function (analytics, buffer) {
    ;
    Object.keys(buffer.calls).forEach(function (m) {
        buffer.getAndRemove(m).forEach(function (c) {
            // No one remembers why this event loop optimization is/was neccessary. Lost to history.
            setTimeout(function () {
                callAnalyticsMethod(analytics, c).catch(console.error);
            }, 0);
        });
    });
};
var popPageContext = function (args) {
    if (hasBufferedPageContextAsLastArg(args)) {
        var ctx = args.pop();
        return createPageContext(ctx);
    }
};
var hasBufferedPageContextAsLastArg = function (args) {
    var lastArg = args[args.length - 1];
    return isBufferedPageContext(lastArg);
};
/**
 *  Represents a buffered method call that occurred before initialization.
 */
var PreInitMethodCall = /** @class */ (function () {
    function PreInitMethodCall(method, args, resolve, reject) {
        if (resolve === void 0) { resolve = function () { }; }
        if (reject === void 0) { reject = console.error; }
        this.method = method;
        this.resolve = resolve;
        this.reject = reject;
        this.called = false;
        this.args = args;
    }
    return PreInitMethodCall;
}());

/**
 *  Represents any and all the buffered method calls that occurred before initialization.
 */
var PreInitMethodCallBuffer = /** @class */ (function () {
    function PreInitMethodCallBuffer() {
        var calls = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            calls[_i] = arguments[_i];
        }
        this._callMap = {};
        this.add.apply(this, calls);
    }
    Object.defineProperty(PreInitMethodCallBuffer.prototype, "calls", {
        /**
         * Pull any buffered method calls from the window object, and use them to hydrate the instance buffer.
         */
        get: function () {
            this._pushSnippetWindowBuffer();
            return this._callMap;
        },
        set: function (calls) {
            this._callMap = calls;
        },
        enumerable: false,
        configurable: true
    });
    PreInitMethodCallBuffer.prototype.get = function (methodName) {
        var _a;
        return ((_a = this.calls[methodName]) !== null && _a !== void 0 ? _a : []);
    };
    /**
     * Get all buffered method calls for a given method name, and clear them from the buffer.
     */
    PreInitMethodCallBuffer.prototype.getAndRemove = function (methodName) {
        var calls = this.get(methodName);
        this.calls[methodName] = [];
        return calls;
    };
    PreInitMethodCallBuffer.prototype.add = function () {
        var _this = this;
        var calls = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            calls[_i] = arguments[_i];
        }
        calls.forEach(function (call) {
            var eventsExpectingPageContext = [
                'track',
                'screen',
                'alias',
                'group',
                'page',
                'identify',
            ];
            if (eventsExpectingPageContext.includes(call.method) &&
                !hasBufferedPageContextAsLastArg(call.args)) {
                call.args = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], call.args, true), [getDefaultBufferedPageContext()], false);
            }
            if (_this.calls[call.method]) {
                _this.calls[call.method].push(call);
            }
            else {
                _this.calls[call.method] = [call];
            }
        });
    };
    PreInitMethodCallBuffer.prototype.clear = function () {
        // clear calls in the global snippet buffered array.
        this._pushSnippetWindowBuffer();
        // clear calls in this instance
        this.calls = {};
    };
    PreInitMethodCallBuffer.prototype.toArray = function () {
        var _a;
        return (_a = []).concat.apply(_a, Object.values(this.calls));
    };
    /**
     * Fetch the buffered method calls from the window object,
     * normalize them, and use them to hydrate the buffer.
     * This removes existing buffered calls from the window object.
     */
    PreInitMethodCallBuffer.prototype._pushSnippetWindowBuffer = function () {
        // if this is the npm version, we don't want to read from the window object.
        // This avoids namespace conflicts if there is a seperate analytics library on the page.
        if ((0,version_type/* getVersionType */.B)() === 'npm') {
            return undefined;
        }
        var wa = (0,global_analytics_helper/* getGlobalAnalytics */.wI)();
        if (!Array.isArray(wa))
            return undefined;
        var buffered = wa.splice(0, wa.length);
        var calls = buffered.map(function (_a) {
            var methodName = _a[0], args = _a.slice(1);
            return new PreInitMethodCall(methodName, args);
        });
        this.add.apply(this, calls);
    };
    return PreInitMethodCallBuffer;
}());

/**
 *  Call method and mark as "called"
 *  This function should never throw an error
 */
function callAnalyticsMethod(analytics, call) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var result, err_1;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (call.called) {
                        return [2 /*return*/, undefined];
                    }
                    call.called = true;
                    result = analytics[call.method].apply(analytics, call.args);
                    if (!is_thenable_isThenable(result)) return [3 /*break*/, 2];
                    // do not defer for non-async methods
                    return [4 /*yield*/, result];
                case 1:
                    // do not defer for non-async methods
                    _a.sent();
                    _a.label = 2;
                case 2:
                    call.resolve(result);
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    call.reject(err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
var AnalyticsBuffered = /** @class */ (function () {
    function AnalyticsBuffered(loader) {
        var _this = this;
        this.trackSubmit = this._createMethod('trackSubmit');
        this.trackClick = this._createMethod('trackClick');
        this.trackLink = this._createMethod('trackLink');
        this.pageView = this._createMethod('pageview');
        this.identify = this._createMethod('identify');
        this.reset = this._createMethod('reset');
        this.group = this._createMethod('group');
        this.track = this._createMethod('track');
        this.ready = this._createMethod('ready');
        this.alias = this._createMethod('alias');
        this.debug = this._createChainableMethod('debug');
        this.page = this._createMethod('page');
        this.once = this._createChainableMethod('once');
        this.off = this._createChainableMethod('off');
        this.on = this._createChainableMethod('on');
        this.addSourceMiddleware = this._createMethod('addSourceMiddleware');
        this.setAnonymousId = this._createMethod('setAnonymousId');
        this.addDestinationMiddleware = this._createMethod('addDestinationMiddleware');
        this.screen = this._createMethod('screen');
        this.register = this._createMethod('register');
        this.deregister = this._createMethod('deregister');
        this.user = this._createMethod('user');
        this.VERSION = version/* version */.i;
        this._preInitBuffer = new PreInitMethodCallBuffer();
        this._promise = loader(this._preInitBuffer);
        this._promise
            .then(function (_a) {
            var ajs = _a[0], ctx = _a[1];
            _this.instance = ajs;
            _this.ctx = ctx;
        })
            .catch(function () {
            // intentionally do nothing...
            // this result of this promise will be caught by the 'catch' block on this class.
        });
    }
    AnalyticsBuffered.prototype.then = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._promise).then.apply(_a, args);
    };
    AnalyticsBuffered.prototype.catch = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._promise).catch.apply(_a, args);
    };
    AnalyticsBuffered.prototype.finally = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = this._promise).finally.apply(_a, args);
    };
    AnalyticsBuffered.prototype._createMethod = function (methodName) {
        var _this = this;
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.instance) {
                var result = (_a = _this.instance)[methodName].apply(_a, args);
                return Promise.resolve(result);
            }
            return new Promise(function (resolve, reject) {
                _this._preInitBuffer.add(new PreInitMethodCall(methodName, args, resolve, reject));
            });
        };
    };
    /**
     *  These are for methods that where determining when the method gets "flushed" is not important.
     *  These methods will resolve when analytics is fully initialized, and return type (other than Analytics)will not be available.
     */
    AnalyticsBuffered.prototype._createChainableMethod = function (methodName) {
        var _this = this;
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.instance) {
                void (_a = _this.instance)[methodName].apply(_a, args);
                return _this;
            }
            else {
                _this._preInitBuffer.add(new PreInitMethodCall(methodName, args));
            }
            return _this;
        };
    };
    return AnalyticsBuffered;
}());

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/to-facade.js
var to_facade = __webpack_require__(23888);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/fetch.js
var fetch = __webpack_require__(55609);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/on-page-change.js
/**
 * Register event listener on document that fires when:
 * * tab change or tab close (in mobile or desktop)
 * * click back / forward button
 * * click any link or perform any other navigation action
 * * soft refresh / hard refresh
 *
 * adapted from https://stackoverflow.com/questions/3239834/window-onbeforeunload-not-working-on-the-ipad/52864508#52864508,
 */
var onPageChange = function (cb) {
    var unloaded = false; // prevents double firing if both are supported
    window.addEventListener('pagehide', function () {
        if (unloaded)
            return;
        unloaded = true;
        cb(unloaded);
    });
    // using document instead of window because of bug affecting browsers before safari 14 (detail in footnotes https://caniuse.com/?search=visibilitychange)
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState == 'hidden') {
            if (unloaded)
                return;
            unloaded = true;
        }
        else {
            unloaded = false;
        }
        cb(unloaded);
    });
};
//# sourceMappingURL=on-page-change.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/ratelimit-error.js

var RateLimitError = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(RateLimitError, _super);
    function RateLimitError(message, retryTimeout, isRetryableWithoutCount) {
        if (isRetryableWithoutCount === void 0) { isRetryableWithoutCount = false; }
        var _this = _super.call(this, message) || this;
        _this.retryTimeout = retryTimeout;
        _this.isRetryableWithoutCount = isRetryableWithoutCount;
        _this.name = 'RateLimitError';
        return _this;
    }
    return RateLimitError;
}(Error));

//# sourceMappingURL=ratelimit-error.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/shared-dispatcher.js

var createHeaders = function (headerSettings) {
    return (0,tslib_es6.__assign)({ 'Content-Type': 'text/plain' }, (typeof headerSettings === 'function'
        ? headerSettings()
        : headerSettings));
};
// --- Default values ---
var DEFAULT_STATUS_CODE_OVERRIDES = {
    '408': 'retry',
    '410': 'retry',
    '429': 'retry',
    '460': 'retry',
    '501': 'drop',
    '505': 'drop',
    '511': 'drop',
};
/** Clamp a number to a range, returning the default if the value is undefined. */
function clamp(value, defaultValue, min, max) {
    var v = value !== null && value !== void 0 ? value : defaultValue;
    return Math.min(Math.max(v, min), max);
}
/**
 * Parse the Retry-After header from a response, if present and applicable.
 * Returns `{ retryAfterMs, fromHeader }` when a valid delay is found, or `null` otherwise.
 */
function parseRetryAfter(res, rateLimitConfig) {
    var _a;
    if (res.status !== 429) {
        return null;
    }
    var raw = (_a = res.headers) === null || _a === void 0 ? void 0 : _a.get('Retry-After');
    if (!raw) {
        return null;
    }
    var parsed = parseInt(raw, 10);
    if (Number.isNaN(parsed)) {
        return null;
    }
    var cappedSeconds = Math.max(0, Math.min(parsed, rateLimitConfig.maxRetryInterval));
    return { retryAfterMs: cappedSeconds * 1000, fromHeader: true };
}
/**
 * Determine whether a given HTTP status code should cause a retry or a drop,
 * based on the resolved backoff configuration.
 */
function getStatusBehavior(status, backoffConfig) {
    var override = backoffConfig.statusCodeOverrides[String(status)];
    if (override) {
        return override;
    }
    if (status >= 500)
        return backoffConfig.default5xxBehavior;
    if (status >= 400)
        return backoffConfig.default4xxBehavior;
    return 'drop';
}
/**
 * Compute an exponential backoff delay in milliseconds for the given attempt.
 * Attempt is 1-based (first retry = 1).
 */
function computeBackoff(attempt, config) {
    var baseMs = config.baseBackoffInterval * 1000;
    var maxMs = config.maxBackoffInterval * 1000;
    var exponential = baseMs * Math.pow(2, attempt - 1);
    var capped = Math.min(exponential, maxMs);
    var jitter = 1 + (Math.random() - 0.5) * 2 * (config.jitterPercent / 100);
    return Math.max(0, capped * jitter);
}
/**
 * Resolve an optional HttpConfig from CDN/user settings into a fully-populated
 * config object with defaults applied and values clamped to safe ranges.
 */
function resolveHttpConfig(config, cdnConfig) {
    var _a, _b, _c, _d;
    // Merge order and precedence:
    // 1) `config` is the init-time base.
    // 2) `cdnConfig` is applied second and wins on overlapping fields.
    //    The CDN will only be populated as an override when necessary to address
    //    issues so takes precedence over init config to ensure it can do so effectively.
    // 3) `statusCodeOverrides` is deep-merged so CDN can override specific
    //    init-provided codes without replacing the whole map.
    // This keeps precedence centralized here instead of repeating merge logic
    // in each caller.
    var mergedConfig = config || cdnConfig
        ? {
            rateLimitConfig: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, config === null || config === void 0 ? void 0 : config.rateLimitConfig), cdnConfig === null || cdnConfig === void 0 ? void 0 : cdnConfig.rateLimitConfig),
            backoffConfig: (0,tslib_es6.__assign)((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, config === null || config === void 0 ? void 0 : config.backoffConfig), cdnConfig === null || cdnConfig === void 0 ? void 0 : cdnConfig.backoffConfig), { statusCodeOverrides: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, (_a = config === null || config === void 0 ? void 0 : config.backoffConfig) === null || _a === void 0 ? void 0 : _a.statusCodeOverrides), (_b = cdnConfig === null || cdnConfig === void 0 ? void 0 : cdnConfig.backoffConfig) === null || _b === void 0 ? void 0 : _b.statusCodeOverrides) }),
        }
        : undefined;
    var rate = mergedConfig === null || mergedConfig === void 0 ? void 0 : mergedConfig.rateLimitConfig;
    var backoff = mergedConfig === null || mergedConfig === void 0 ? void 0 : mergedConfig.backoffConfig;
    return {
        rateLimitConfig: {
            maxRetryCount: clamp(rate === null || rate === void 0 ? void 0 : rate.maxRetryCount, 10, 0, 100),
            maxRetryInterval: clamp(rate === null || rate === void 0 ? void 0 : rate.maxRetryInterval, 300, 0.1, 86400),
            maxRateLimitDuration: clamp(rate === null || rate === void 0 ? void 0 : rate.maxRateLimitDuration, 43200, 10, 86400),
        },
        backoffConfig: {
            maxRetryCount: clamp(backoff === null || backoff === void 0 ? void 0 : backoff.maxRetryCount, 10, 0, 100),
            baseBackoffInterval: clamp(backoff === null || backoff === void 0 ? void 0 : backoff.baseBackoffInterval, 0.5, 0.1, 300),
            maxBackoffInterval: clamp(backoff === null || backoff === void 0 ? void 0 : backoff.maxBackoffInterval, 60, 0.1, 86400),
            maxTotalBackoffDuration: clamp(backoff === null || backoff === void 0 ? void 0 : backoff.maxTotalBackoffDuration, 43200, 60, 604800),
            jitterPercent: clamp(backoff === null || backoff === void 0 ? void 0 : backoff.jitterPercent, 10, 0, 100),
            default4xxBehavior: (_c = backoff === null || backoff === void 0 ? void 0 : backoff.default4xxBehavior) !== null && _c !== void 0 ? _c : 'drop',
            default5xxBehavior: (_d = backoff === null || backoff === void 0 ? void 0 : backoff.default5xxBehavior) !== null && _d !== void 0 ? _d : 'retry',
            statusCodeOverrides: (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, DEFAULT_STATUS_CODE_OVERRIDES), backoff === null || backoff === void 0 ? void 0 : backoff.statusCodeOverrides),
        },
    };
}
//# sourceMappingURL=shared-dispatcher.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/batched-dispatcher.js






var MAX_PAYLOAD_SIZE = 500;
var MAX_KEEPALIVE_SIZE = 64;
function kilobytes(buffer) {
    var size = encodeURI(JSON.stringify(buffer)).split(/%..|./).length - 1;
    return size / 1024;
}
/**
 * Checks if the payload is over or close to
 * the maximum payload size allowed by tracking
 * API.
 */
function approachingTrackingAPILimit(buffer) {
    return kilobytes(buffer) >= MAX_PAYLOAD_SIZE - 50;
}
/**
 * Checks if payload is over or approaching the limit for keepalive
 * requests. If keepalive is enabled we want to avoid
 * going over this to prevent data loss.
 */
function passedKeepaliveLimit(buffer) {
    return kilobytes(buffer) >= MAX_KEEPALIVE_SIZE - 10;
}
function chunks(batch) {
    var result = [];
    var index = 0;
    batch.forEach(function (item) {
        var size = kilobytes(result[index]);
        if (size >= 64) {
            index++;
        }
        if (result[index]) {
            result[index].push(item);
        }
        else {
            result[index] = [item];
        }
    });
    return result;
}
function buildBatch(buffer) {
    var batch = [];
    for (var i = 0; i < buffer.length; i++) {
        var event_1 = buffer[i];
        var candidate = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], batch, true), [event_1], false);
        if (batch.length > 0 && approachingTrackingAPILimit(candidate)) {
            return { batch: batch, remaining: buffer.slice(i) };
        }
        batch.push(event_1);
    }
    return { batch: batch, remaining: [] };
}
function batch(apiHost, config, httpConfig, protocol) {
    var _a, _b;
    if (protocol === void 0) { protocol = 'https'; }
    var buffer = [];
    var pageUnloaded = false;
    var limit = (_a = config === null || config === void 0 ? void 0 : config.size) !== null && _a !== void 0 ? _a : 10;
    var timeout = (_b = config === null || config === void 0 ? void 0 : config.timeout) !== null && _b !== void 0 ? _b : 5000;
    var resolved = httpConfig !== null && httpConfig !== void 0 ? httpConfig : resolveHttpConfig();
    var rateLimitTimeout = 0;
    var requestCount = 0; // Tracks actual network requests for X-Retry-Count header
    var isRetrying = false;
    var isFlushing = false;
    var retryAfterRetries = 0;
    var totalBackoffTime = 0;
    var totalRateLimitTime = 0;
    function sendBatch(batch, retryCount) {
        var _a;
        if (batch.length === 0) {
            return;
        }
        var writeKey = (_a = batch[0]) === null || _a === void 0 ? void 0 : _a.writeKey;
        // Remove sentAt from every event as batching only needs a single timestamp
        var updatedBatch = batch.map(function (event) {
            var _a = event, sentAt = _a.sentAt, newEvent = (0,tslib_es6.__rest)(_a, ["sentAt"]);
            return newEvent;
        });
        var headers = createHeaders(config === null || config === void 0 ? void 0 : config.headers);
        if (retryCount > 0) {
            headers['X-Retry-Count'] = String(retryCount);
        }
        if (writeKey) {
            var authtoken = btoa(writeKey + ':');
            headers['Authorization'] = "Basic ".concat(authtoken);
        }
        var scheme = apiHost.startsWith('http://') || apiHost.startsWith('https://')
            ? ''
            : "".concat(protocol, "://");
        return (0,fetch/* fetch */.h)("".concat(scheme).concat(apiHost, "/b"), {
            credentials: config === null || config === void 0 ? void 0 : config.credentials,
            keepalive: (config === null || config === void 0 ? void 0 : config.keepalive) || pageUnloaded,
            headers: headers,
            method: 'post',
            body: JSON.stringify({
                writeKey: writeKey,
                batch: updatedBatch,
                sentAt: new Date().toISOString(),
            }),
            // @ts-ignore - not in the ts lib yet
            priority: config === null || config === void 0 ? void 0 : config.priority,
        }).then(function (res) {
            var status = res.status;
            // Treat <400 as success (2xx/3xx)
            if (status < 400) {
                return;
            }
            // Determine retry/drop behavior from config (checks statusCodeOverrides first).
            var behavior = getStatusBehavior(status, resolved.backoffConfig);
            // Honor Retry-After for rate limiting, unless the status is explicitly
            // overridden to 'drop' via statusCodeOverrides.
            if (behavior !== 'drop') {
                var retryAfter = parseRetryAfter(res, resolved.rateLimitConfig);
                if (retryAfter) {
                    throw new RateLimitError("Rate limit exceeded: ".concat(status), retryAfter.retryAfterMs, retryAfter.fromHeader);
                }
            }
            // Retry via backoff when the status is retryable.
            if (behavior === 'retry') {
                throw new Error("Retryable error: ".concat(status));
            }
            // Non-retryable: silently drop
        });
    }
    function dropAndContinue() {
        if (buffer.length > 0) {
            scheduleFlush(1);
        }
    }
    function flush(attempt) {
        var _a;
        if (attempt === void 0) { attempt = 1; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _b, batch_1, remaining, currentRetryCount;
            return (0,tslib_es6.__generator)(this, function (_c) {
                if (!isRetrying) {
                    requestCount = 0;
                    retryAfterRetries = 0;
                    totalBackoffTime = 0;
                    totalRateLimitTime = 0;
                }
                isRetrying = false;
                isFlushing = true;
                if (buffer.length) {
                    _b = buildBatch(buffer), batch_1 = _b.batch, remaining = _b.remaining;
                    if (batch_1.length === 0) {
                        isFlushing = false;
                        return [2 /*return*/];
                    }
                    buffer = remaining;
                    currentRetryCount = requestCount;
                    requestCount += 1;
                    return [2 /*return*/, (_a = sendBatch(batch_1, currentRetryCount)) === null || _a === void 0 ? void 0 : _a.then(function (result) {
                            // If buildBatch left events due to payload size limits, schedule another flush
                            if (buffer.length > 0) {
                                scheduleFlush(1);
                            }
                            return result;
                        }).catch(function (error) {
                            var _a;
                            var ctx = core_context/* Context.system */._.system();
                            ctx.log('error', 'Error sending batch', error);
                            var maxRetries = (_a = config === null || config === void 0 ? void 0 : config.maxRetries) !== null && _a !== void 0 ? _a : resolved.backoffConfig.maxRetryCount;
                            var isRateLimitError = error.name === 'RateLimitError';
                            var isRetryableWithoutCount = isRateLimitError && error.isRetryableWithoutCount;
                            var canRetry = isRetryableWithoutCount || attempt <= maxRetries;
                            if (!canRetry) {
                                return dropAndContinue();
                            }
                            // Rate-limit retries: enforce count cap and total duration cap
                            if (isRetryableWithoutCount) {
                                retryAfterRetries++;
                                if (retryAfterRetries > resolved.rateLimitConfig.maxRetryCount) {
                                    return dropAndContinue();
                                }
                                var delay = error.retryTimeout;
                                totalRateLimitTime += delay;
                                var maxRateLimitMs = resolved.rateLimitConfig.maxRateLimitDuration * 1000;
                                if (totalRateLimitTime > maxRateLimitMs) {
                                    return dropAndContinue();
                                }
                                rateLimitTimeout = delay;
                            }
                            // Backoff retries: compute delay, enforce total duration cap
                            var retryDelay;
                            if (!isRateLimitError) {
                                retryDelay = computeBackoff(attempt, resolved.backoffConfig);
                                totalBackoffTime += retryDelay;
                                var maxBackoffMs = resolved.backoffConfig.maxTotalBackoffDuration * 1000;
                                if (totalBackoffTime > maxBackoffMs) {
                                    return dropAndContinue();
                                }
                            }
                            buffer = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], batch_1, true), buffer, true);
                            batch_1.forEach(function (event) {
                                if ('_metadata' in event) {
                                    var segmentEvent = event;
                                    segmentEvent._metadata = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, segmentEvent._metadata), { retryCount: attempt });
                                }
                            });
                            var nextAttempt = isRetryableWithoutCount ? attempt : attempt + 1;
                            isRetrying = true;
                            scheduleFlush(nextAttempt, retryDelay);
                        }).finally(function () {
                            isFlushing = false;
                        })];
                }
                else {
                    isFlushing = false;
                }
                return [2 /*return*/];
            });
        });
    }
    var schedule;
    function scheduleFlush(attempt, retryDelay) {
        if (attempt === void 0) { attempt = 1; }
        if (schedule) {
            return;
        }
        var delay = rateLimitTimeout || retryDelay || timeout;
        schedule = setTimeout(function () {
            schedule = undefined;
            flush(attempt).catch(console.error);
        }, delay);
        rateLimitTimeout = 0;
    }
    onPageChange(function (unloaded) {
        pageUnloaded = unloaded;
        if (pageUnloaded && buffer.length) {
            var reqs = chunks(buffer).map(function (b) { return sendBatch(b, 0); });
            Promise.all(reqs).catch(console.error);
        }
    });
    function dispatch(_url, body, _retryCountHeader) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var bufferOverflow;
            return (0,tslib_es6.__generator)(this, function (_a) {
                buffer.push(body);
                // If a retry is pending (e.g., 429 rate-limit), don't bypass the scheduled retry.
                // A 429 blocks the entire flush iteration until the Retry-After period elapses.
                if (isRetrying) {
                    return [2 /*return*/];
                }
                bufferOverflow = buffer.length >= limit ||
                    approachingTrackingAPILimit(buffer) ||
                    ((config === null || config === void 0 ? void 0 : config.keepalive) && passedKeepaliveLimit(buffer));
                if (!bufferOverflow && !pageUnloaded) {
                    return [2 /*return*/, scheduleFlush()];
                }
                // If a flush is already in-flight, avoid concurrent flushes that would
                // corrupt shared mutable state (requestCount, totalBackoffTime, etc.).
                // Schedule instead so events are picked up after the current flush settles.
                return [2 /*return*/, isFlushing ? scheduleFlush() : flush()];
            });
        });
    }
    return {
        dispatch: dispatch,
    };
}
//# sourceMappingURL=batched-dispatcher.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/fetch-dispatcher.js



/* harmony default export */ function fetch_dispatcher(config, httpConfig) {
    function dispatch(url, body, retryCountHeader) {
        var headers = createHeaders(config === null || config === void 0 ? void 0 : config.headers);
        var writeKey = body === null || body === void 0 ? void 0 : body.writeKey;
        if (writeKey) {
            var authtoken = btoa(writeKey + ':');
            headers['Authorization'] = "Basic ".concat(authtoken);
        }
        if (retryCountHeader) {
            headers['X-Retry-Count'] = String(retryCountHeader);
        }
        return (0,fetch/* fetch */.h)(url, {
            credentials: config === null || config === void 0 ? void 0 : config.credentials,
            keepalive: config === null || config === void 0 ? void 0 : config.keepalive,
            headers: headers,
            method: 'post',
            body: JSON.stringify(body),
            // @ts-ignore - not in the ts lib yet
            priority: config === null || config === void 0 ? void 0 : config.priority,
        }).then(function (res) {
            var status = res.status;
            // Treat <400 as success (2xx/3xx)
            if (status < 400) {
                return;
            }
            // Resolve config once (uses caller-supplied or built-in defaults).
            var resolved = httpConfig !== null && httpConfig !== void 0 ? httpConfig : resolveHttpConfig();
            // Determine retry/drop behavior from config (checks statusCodeOverrides first).
            var behavior = getStatusBehavior(status, resolved.backoffConfig);
            // Honor Retry-After for rate limiting, unless the status is explicitly
            // overridden to 'drop' via statusCodeOverrides.
            if (behavior !== 'drop') {
                var retryAfter = parseRetryAfter(res, resolved.rateLimitConfig);
                if (retryAfter) {
                    throw new RateLimitError("Rate limit exceeded: ".concat(status), retryAfter.retryAfterMs, retryAfter.fromHeader);
                }
            }
            // Retry via backoff when the status is retryable.
            if (behavior === 'retry') {
                throw new Error("Retryable error: ".concat(status));
            }
            var err = new Error("Non-retryable error: ".concat(status));
            err.name = 'NonRetryableError';
            throw err;
        });
    }
    return {
        dispatch: dispatch,
    };
}
//# sourceMappingURL=fetch-dispatcher.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/normalize.js

function normalize(analytics, json, settings, integrations, ctx) {
    var _a;
    var user = analytics.user();
    delete json.options;
    json.writeKey = settings === null || settings === void 0 ? void 0 : settings.apiKey;
    json.userId = json.userId || user.id();
    json.anonymousId = json.anonymousId || user.anonymousId();
    json.sentAt = new Date();
    var failed = analytics.queue.failedInitializations || [];
    if (failed.length > 0) {
        json._metadata = { failedInitializations: failed };
    }
    if (ctx != null) {
        if (ctx.attempts > 1) {
            json._metadata = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, json._metadata), { retryCount: ctx.attempts });
        }
        ctx.attempts++;
    }
    var bundled = [];
    var unbundled = [];
    for (var key in integrations) {
        var integration = integrations[key];
        if (key === 'Segment.io') {
            bundled.push(key);
        }
        if (integration.bundlingStatus === 'bundled') {
            bundled.push(key);
        }
        if (integration.bundlingStatus === 'unbundled') {
            unbundled.push(key);
        }
    }
    // This will make sure that the disabled cloud mode destinations will be
    // included in the unbundled list.
    for (var _i = 0, _b = (settings === null || settings === void 0 ? void 0 : settings.unbundledIntegrations) || []; _i < _b.length; _i++) {
        var settingsUnbundled = _b[_i];
        if (!unbundled.includes(settingsUnbundled)) {
            unbundled.push(settingsUnbundled);
        }
    }
    var configIds = (_a = settings === null || settings === void 0 ? void 0 : settings.maybeBundledConfigIds) !== null && _a !== void 0 ? _a : {};
    var bundledConfigIds = [];
    bundled.sort().forEach(function (name) {
        var _a;
        ;
        ((_a = configIds[name]) !== null && _a !== void 0 ? _a : []).forEach(function (id) {
            bundledConfigIds.push(id);
        });
    });
    if ((settings === null || settings === void 0 ? void 0 : settings.addBundledMetadata) !== false) {
        json._metadata = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, json._metadata), { bundled: bundled.sort(), unbundled: unbundled.sort(), bundledIds: bundledConfigIds });
    }
    return json;
}
//# sourceMappingURL=normalize.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/p-while.js
var p_while = __webpack_require__(56749);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/schedule-flush.js





function flushQueue(xt, queue) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var failedQueue;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    failedQueue = [];
                    if ((0,connection/* isOffline */.s)()) {
                        return [2 /*return*/, queue];
                    }
                    return [4 /*yield*/, (0,p_while/* pWhile */.x)(function () { return queue.length > 0 && !(0,connection/* isOffline */.s)(); }, function () { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                            var ctx, result, success;
                            return (0,tslib_es6.__generator)(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        ctx = queue.pop();
                                        if (!ctx) {
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, (0,delivery/* attempt */.a)(ctx, xt)];
                                    case 1:
                                        result = _a.sent();
                                        success = result instanceof core_context/* Context */._;
                                        if (!success) {
                                            failedQueue.push(ctx);
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); })
                        // re-add failed tasks
                    ];
                case 1:
                    _a.sent();
                    // re-add failed tasks
                    failedQueue.map(function (failed) { return queue.pushWithBackoff(failed); });
                    return [2 /*return*/, queue];
            }
        });
    });
}
function scheduleFlush(flushing, buffer, xt, scheduleFlush) {
    var _this = this;
    if (flushing) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    setTimeout(function () { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
        var isFlushing, newBuffer;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isFlushing = true;
                    return [4 /*yield*/, flushQueue(xt, buffer)];
                case 1:
                    newBuffer = _a.sent();
                    isFlushing = false;
                    if (buffer.todo > 0) {
                        scheduleFlush(isFlushing, newBuffer, xt, scheduleFlush);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, Math.random() * 500 + 100);
}
//# sourceMappingURL=schedule-flush.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/constants/index.js
var core_constants = __webpack_require__(36514);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/segmentio/index.js











function onAlias(analytics, json) {
    var _a, _b, _c, _d;
    var user = analytics.user();
    json.previousId =
        (_c = (_b = (_a = json.previousId) !== null && _a !== void 0 ? _a : json.from) !== null && _b !== void 0 ? _b : user.id()) !== null && _c !== void 0 ? _c : user.anonymousId();
    json.userId = (_d = json.userId) !== null && _d !== void 0 ? _d : json.to;
    delete json.from;
    delete json.to;
    return json;
}
var isSegmentPlugin = function (plugin) {
    return plugin.name === 'Segment.io';
};
function segmentio(analytics, settings, integrations) {
    var _a, _b, _c, _d;
    // Attach `pagehide` before buffer is created so that inflight events are added
    // to the buffer before the buffer persists events in its own `pagehide` handler.
    window.addEventListener('pagehide', function () {
        buffer.push.apply(buffer, Array.from(inflightEvents));
        inflightEvents.clear();
    });
    var writeKey = (_a = settings === null || settings === void 0 ? void 0 : settings.apiKey) !== null && _a !== void 0 ? _a : '';
    var buffer = analytics.options.disableClientPersistence
        ? new priority_queue/* PriorityQueue */.Z(analytics.queue.queue.maxAttempts, [])
        : new persisted/* PersistedPriorityQueue */.$(analytics.queue.queue.maxAttempts, "".concat(writeKey, ":dest-Segment.io"));
    var inflightEvents = new Set();
    var rateLimitAttempts = new WeakMap();
    var flushing = false;
    var apiHost = (_b = settings === null || settings === void 0 ? void 0 : settings.apiHost) !== null && _b !== void 0 ? _b : core_constants/* SEGMENT_API_HOST */.U;
    var protocol = (_c = settings === null || settings === void 0 ? void 0 : settings.protocol) !== null && _c !== void 0 ? _c : 'https';
    var remote = "".concat(protocol, "://").concat(apiHost);
    var cdnHttpConfig = (_d = integrations === null || integrations === void 0 ? void 0 : integrations['Segment.io']) === null || _d === void 0 ? void 0 : _d.httpConfig;
    var initHttpConfig = settings === null || settings === void 0 ? void 0 : settings.httpConfig;
    var resolvedHttpConfig = resolveHttpConfig(initHttpConfig, cdnHttpConfig);
    // Wire the CDN/user-configured maxRetryCount to the plugin's internal buffer.
    // For fetch-dispatcher (standard mode), this is the only retry control —
    // retries are managed by the plugin's PriorityQueue, not the dispatcher.
    // For batched-dispatcher, retries are handled internally by the dispatcher
    // (which also reads maxRetryCount), so this mainly serves as a safety net.
    // retryQueue controls whether retries are allowed at all.
    // When enabled, keep buffer attempts aligned with resolved httpConfig.
    if (analytics.options.retryQueue !== false) {
        buffer.maxAttempts = resolvedHttpConfig.backoffConfig.maxRetryCount;
    }
    var deliveryStrategy = settings === null || settings === void 0 ? void 0 : settings.deliveryStrategy;
    var client = deliveryStrategy &&
        'strategy' in deliveryStrategy &&
        deliveryStrategy.strategy === 'batching'
        ? batch(apiHost, deliveryStrategy.config, resolvedHttpConfig, protocol)
        : fetch_dispatcher(deliveryStrategy === null || deliveryStrategy === void 0 ? void 0 : deliveryStrategy.config, resolvedHttpConfig);
    function send(ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var path, json, attempts, error;
            return (0,tslib_es6.__generator)(this, function (_a) {
                if ((0,connection/* isOffline */.s)()) {
                    buffer.push(ctx);
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    scheduleFlush(flushing, buffer, segmentio, scheduleFlush);
                    return [2 /*return*/, ctx];
                }
                inflightEvents.add(ctx);
                path = ctx.event.type.charAt(0);
                json = (0,to_facade/* toFacade */.D)(ctx.event).json();
                if (ctx.event.type === 'track') {
                    delete json.traits;
                }
                if (ctx.event.type === 'alias') {
                    json = onAlias(analytics, json);
                }
                attempts = buffer.getAttempts(ctx);
                if (attempts >= buffer.maxAttempts) {
                    inflightEvents.delete(ctx);
                    error = new Error("Retry attempts exhausted (".concat(attempts, "/").concat(buffer.maxAttempts, ")"));
                    ctx.setFailedDelivery({ reason: error });
                    analytics.emit('error', {
                        code: 'delivery_failure',
                        reason: error,
                        ctx: ctx,
                    });
                    return [2 /*return*/, ctx];
                }
                return [2 /*return*/, client
                        .dispatch("".concat(remote, "/").concat(path), normalize(analytics, json, settings, integrations, ctx), attempts)
                        .then(function () { return ctx; })
                        .catch(function (error) {
                        var _a;
                        ctx.log('error', 'Error sending event', error);
                        if (error.name === 'RateLimitError') {
                            var rlAttempts = ((_a = rateLimitAttempts.get(ctx)) !== null && _a !== void 0 ? _a : 0) + 1;
                            rateLimitAttempts.set(ctx, rlAttempts);
                            if (rlAttempts > resolvedHttpConfig.rateLimitConfig.maxRetryCount) {
                                ctx.setFailedDelivery({ reason: error });
                                analytics.emit('error', {
                                    code: 'delivery_failure',
                                    reason: error,
                                    ctx: ctx,
                                });
                            }
                            else {
                                var timeout = error.retryTimeout;
                                buffer.pushWithDelay(ctx, timeout);
                            }
                        }
                        else if (error.name === 'NonRetryableError') {
                            // Do not requeue non-retryable HTTP failures; drop the event.
                            ctx.setFailedDelivery({ reason: error });
                            analytics.emit('error', {
                                code: 'delivery_failure',
                                reason: error,
                                ctx: ctx,
                            });
                        }
                        else {
                            buffer.pushWithBackoff(ctx);
                        }
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        scheduleFlush(flushing, buffer, segmentio, scheduleFlush);
                        return ctx;
                    })
                        .finally(function () {
                        inflightEvents.delete(ctx);
                    })];
            });
        });
    }
    var segmentio = {
        metadata: {
            writeKey: writeKey,
            apiHost: apiHost,
            protocol: protocol,
        },
        name: 'Segment.io',
        type: 'destination',
        version: '0.1.0',
        isLoaded: function () { return true; },
        load: function () { return Promise.resolve(); },
        track: send,
        identify: send,
        page: send,
        alias: send,
        group: send,
        screen: send,
    };
    // Buffer may already have items if they were previously stored in localStorage.
    // Start flushing them immediately.
    if (buffer.todo) {
        scheduleFlush(flushing, buffer, segmentio, scheduleFlush);
    }
    return segmentio;
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/analytics/index.js



















var deprecationWarning = 'This is being deprecated and will be not be available in future releases of Analytics JS';
// reference any pre-existing "analytics" object so a user can restore the reference
var analytics_global = (0,get_global/* getGlobal */.R)();
var _analytics = analytics_global === null || analytics_global === void 0 ? void 0 : analytics_global.analytics;
function createDefaultQueue(name, retryQueue, disablePersistance) {
    if (retryQueue === void 0) { retryQueue = false; }
    if (disablePersistance === void 0) { disablePersistance = false; }
    var maxAttempts = retryQueue ? 10 : 1;
    var priorityQueue = disablePersistance
        ? new priority_queue/* PriorityQueue */.Z(maxAttempts, [])
        : new persisted/* PersistedPriorityQueue */.$(maxAttempts, name);
    return new EventQueue(priorityQueue);
}
/**
 * The public settings that are set on the analytics instance
 */
var AnalyticsInstanceSettings = /** @class */ (function () {
    function AnalyticsInstanceSettings(settings, queue) {
        var _a;
        /**
         * Auto-track specific timeout setting for legacy purposes.
         */
        this.timeout = 300;
        this._getSegmentPluginMetadata = function () { var _a; return (_a = queue.plugins.find(isSegmentPlugin)) === null || _a === void 0 ? void 0 : _a.metadata; };
        this.writeKey = settings.writeKey;
        // this is basically just to satisfy typescript / so we don't need to change the function sig of every test.
        // when loadAnalytics is called, cdnSettings will always be available.
        var emptyCDNSettings = {
            integrations: {
                'Segment.io': {
                    apiKey: '',
                },
            },
        };
        this.cdnSettings = (_a = settings.cdnSettings) !== null && _a !== void 0 ? _a : emptyCDNSettings;
        this.cdnURL = settings.cdnURL;
    }
    Object.defineProperty(AnalyticsInstanceSettings.prototype, "apiHost", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this._getSegmentPluginMetadata) === null || _a === void 0 ? void 0 : _a.call(this)) === null || _b === void 0 ? void 0 : _b.apiHost;
        },
        enumerable: false,
        configurable: true
    });
    return AnalyticsInstanceSettings;
}());

/* analytics-classic stubs */
function _stub() {
    console.warn(deprecationWarning);
}
var Analytics = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(Analytics, _super);
    function Analytics(settings, options, queue, user, group) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this) || this;
        _this._debug = false;
        _this.initialized = false;
        _this.user = function () {
            return _this._user;
        };
        _this.init = _this.initialize.bind(_this);
        _this.log = _stub;
        _this.addIntegrationMiddleware = _stub;
        _this.listeners = _stub;
        _this.addEventListener = _stub;
        _this.removeAllListeners = _stub;
        _this.removeListener = _stub;
        _this.removeEventListener = _stub;
        _this.hasListeners = _stub;
        _this.add = _stub;
        _this.addIntegration = _stub;
        var cookieOptions = options === null || options === void 0 ? void 0 : options.cookie;
        var disablePersistance = (_a = options === null || options === void 0 ? void 0 : options.disableClientPersistence) !== null && _a !== void 0 ? _a : false;
        _this.queue =
            queue !== null && queue !== void 0 ? queue : createDefaultQueue("".concat(settings.writeKey, ":event-queue"), options === null || options === void 0 ? void 0 : options.retryQueue, disablePersistance);
        _this.settings = new AnalyticsInstanceSettings(settings, _this.queue);
        var storageSetting = options === null || options === void 0 ? void 0 : options.storage;
        _this._universalStorage = _this.createStore(disablePersistance, storageSetting, cookieOptions);
        _this._user =
            user !== null && user !== void 0 ? user : new User((0,tslib_es6.__assign)({ persist: !disablePersistance, storage: options === null || options === void 0 ? void 0 : options.storage }, options === null || options === void 0 ? void 0 : options.user), cookieOptions).load();
        _this._group =
            group !== null && group !== void 0 ? group : new Group((0,tslib_es6.__assign)({ persist: !disablePersistance, storage: options === null || options === void 0 ? void 0 : options.storage }, options === null || options === void 0 ? void 0 : options.group), cookieOptions).load();
        _this.eventFactory = new EventFactory(_this._user);
        _this.integrations = (_b = options === null || options === void 0 ? void 0 : options.integrations) !== null && _b !== void 0 ? _b : {};
        _this.options = options !== null && options !== void 0 ? options : {};
        bindAll(_this);
        return _this;
    }
    /**
     * Creates the storage system based on the settings received
     * @returns Storage
     */
    Analytics.prototype.createStore = function (disablePersistance, storageSetting, cookieOptions) {
        // DisablePersistance option overrides all, no storage will be used outside of memory even if specified
        if (disablePersistance) {
            return new UniversalStorage([new MemoryStorage()]);
        }
        else {
            if (storageSetting) {
                if (isArrayOfStoreType(storageSetting)) {
                    // We will create the store with the priority for customer settings
                    return new UniversalStorage(initializeStorages(applyCookieOptions(storageSetting.stores, cookieOptions)));
                }
            }
        }
        // We default to our multi storage with priority
        return new UniversalStorage(initializeStorages([
            StoreType.LocalStorage,
            {
                name: StoreType.Cookie,
                settings: cookieOptions,
            },
            StoreType.Memory,
        ]));
    };
    Object.defineProperty(Analytics.prototype, "storage", {
        get: function () {
            return this._universalStorage;
        },
        enumerable: false,
        configurable: true
    });
    Analytics.prototype.track = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, name, data, opts, cb, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolveArguments.apply(void 0, args), name = _a[0], data = _a[1], opts = _a[2], cb = _a[3];
                segmentEvent = this.eventFactory.track(name, data, opts, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, cb).then(function (ctx) {
                        _this.emit('track', name, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.page = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, category, page, properties, options, callback, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolvePageArguments.apply(void 0, args), category = _a[0], page = _a[1], properties = _a[2], options = _a[3], callback = _a[4];
                segmentEvent = this.eventFactory.page(category, page, properties, options, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, callback).then(function (ctx) {
                        _this.emit('page', category, page, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.identify = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, id, _traits, options, callback, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolveUserArguments(this._user).apply(void 0, args), id = _a[0], _traits = _a[1], options = _a[2], callback = _a[3];
                this._user.identify(id, _traits);
                segmentEvent = this.eventFactory.identify(this._user.id(), this._user.traits(), options, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, callback).then(function (ctx) {
                        _this.emit('identify', ctx.event.userId, ctx.event.traits, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.group = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var pageCtx = popPageContext(args);
        if (args.length === 0) {
            return this._group;
        }
        var _a = resolveUserArguments(this._group).apply(void 0, args), id = _a[0], _traits = _a[1], options = _a[2], callback = _a[3];
        this._group.identify(id, _traits);
        var groupId = this._group.id();
        var groupTraits = this._group.traits();
        var segmentEvent = this.eventFactory.group(groupId, groupTraits, options, this.integrations, pageCtx);
        return this._dispatch(segmentEvent, callback).then(function (ctx) {
            _this.emit('group', ctx.event.groupId, ctx.event.traits, ctx.event.options);
            return ctx;
        });
    };
    Analytics.prototype.alias = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, to, from, options, callback, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolveAliasArguments.apply(void 0, args), to = _a[0], from = _a[1], options = _a[2], callback = _a[3];
                segmentEvent = this.eventFactory.alias(to, from, options, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, callback).then(function (ctx) {
                        _this.emit('alias', to, from, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.screen = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var pageCtx, _a, category, page, properties, options, callback, segmentEvent;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_b) {
                pageCtx = popPageContext(args);
                _a = resolvePageArguments.apply(void 0, args), category = _a[0], page = _a[1], properties = _a[2], options = _a[3], callback = _a[4];
                segmentEvent = this.eventFactory.screen(category, page, properties, options, this.integrations, pageCtx);
                return [2 /*return*/, this._dispatch(segmentEvent, callback).then(function (ctx) {
                        _this.emit('screen', category, page, ctx.event.properties, ctx.event.options);
                        return ctx;
                    })];
            });
        });
    };
    Analytics.prototype.trackClick = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var autotrack;
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __webpack_require__.e(/* import() | auto-track */ 8119).then(__webpack_require__.bind(__webpack_require__, 4802))];
                    case 1:
                        autotrack = _b.sent();
                        return [2 /*return*/, (_a = autotrack.link).call.apply(_a, (0,tslib_es6.__spreadArray)([this], args, false))];
                }
            });
        });
    };
    Analytics.prototype.trackLink = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var autotrack;
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __webpack_require__.e(/* import() | auto-track */ 8119).then(__webpack_require__.bind(__webpack_require__, 4802))];
                    case 1:
                        autotrack = _b.sent();
                        return [2 /*return*/, (_a = autotrack.link).call.apply(_a, (0,tslib_es6.__spreadArray)([this], args, false))];
                }
            });
        });
    };
    Analytics.prototype.trackSubmit = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var autotrack;
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __webpack_require__.e(/* import() | auto-track */ 8119).then(__webpack_require__.bind(__webpack_require__, 4802))];
                    case 1:
                        autotrack = _b.sent();
                        return [2 /*return*/, (_a = autotrack.form).call.apply(_a, (0,tslib_es6.__spreadArray)([this], args, false))];
                }
            });
        });
    };
    Analytics.prototype.trackForm = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var autotrack;
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __webpack_require__.e(/* import() | auto-track */ 8119).then(__webpack_require__.bind(__webpack_require__, 4802))];
                    case 1:
                        autotrack = _b.sent();
                        return [2 /*return*/, (_a = autotrack.form).call.apply(_a, (0,tslib_es6.__spreadArray)([this], args, false))];
                }
            });
        });
    };
    Analytics.prototype.register = function () {
        var plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            plugins[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var ctx, registrations;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = core_context/* Context.system */._.system();
                        registrations = plugins.map(function (xt) {
                            return _this.queue.register(ctx, xt, _this);
                        });
                        return [4 /*yield*/, Promise.all(registrations)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, ctx];
                }
            });
        });
    };
    Analytics.prototype.deregister = function () {
        var plugins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            plugins[_i] = arguments[_i];
        }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var ctx, deregistrations;
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ctx = core_context/* Context.system */._.system();
                        deregistrations = plugins.map(function (pl) {
                            var plugin = _this.queue.plugins.find(function (p) { return p.name === pl; });
                            if (plugin) {
                                return _this.queue.deregister(ctx, plugin, _this);
                            }
                            else {
                                ctx.log('warn', "plugin ".concat(pl, " not found"));
                            }
                        });
                        return [4 /*yield*/, Promise.all(deregistrations)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, ctx];
                }
            });
        });
    };
    Analytics.prototype.debug = function (toggle) {
        // Make sure legacy ajs debug gets turned off if it was enabled before upgrading.
        if (toggle === false && localStorage.getItem('debug')) {
            localStorage.removeItem('debug');
        }
        this._debug = toggle;
        return this;
    };
    Analytics.prototype.reset = function () {
        this._user.reset();
        this._group.reset();
        this.emit('reset');
    };
    Analytics.prototype.timeout = function (timeout) {
        this.settings.timeout = timeout;
    };
    Analytics.prototype._dispatch = function (event, callback) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var ctx;
            return (0,tslib_es6.__generator)(this, function (_a) {
                ctx = new core_context/* Context */._(event);
                ctx.stats.increment('analytics_js.invoke', 1, [event.type]);
                if ((0,connection/* isOffline */.s)() && !this.options.retryQueue) {
                    return [2 /*return*/, ctx];
                }
                return [2 /*return*/, dispatch(ctx, this.queue, this, {
                        callback: callback,
                        debug: this._debug,
                        timeout: this.settings.timeout,
                    })];
            });
        });
    };
    Analytics.prototype.addSourceMiddleware = function (fn) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _this = this;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queue.criticalTasks.run(function () { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                            var sourceMiddlewarePlugin, integrations, plugin;
                            return (0,tslib_es6.__generator)(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 66170))];
                                    case 1:
                                        sourceMiddlewarePlugin = (_a.sent()).sourceMiddlewarePlugin;
                                        integrations = {};
                                        this.queue.plugins.forEach(function (plugin) {
                                            if (plugin.type === 'destination') {
                                                return (integrations[plugin.name] = true);
                                            }
                                        });
                                        plugin = sourceMiddlewarePlugin(fn, integrations);
                                        return [4 /*yield*/, this.register(plugin)];
                                    case 2:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    /* TODO: This does not have to return a promise? */
    Analytics.prototype.addDestinationMiddleware = function (integrationName) {
        var middlewares = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            middlewares[_i - 1] = arguments[_i];
        }
        this.queue.plugins
            .filter(isDestinationPluginWithAddMiddleware)
            .forEach(function (p) {
            if (integrationName === '*' ||
                p.name.toLowerCase() === integrationName.toLowerCase()) {
                p.addMiddleware.apply(p, middlewares);
            }
        });
        return Promise.resolve(this);
    };
    Analytics.prototype.setAnonymousId = function (id) {
        return this._user.anonymousId(id);
    };
    Analytics.prototype.queryString = function (query) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var queryString;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.options.useQueryString === false) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, __webpack_require__.e(/* import() | queryString */ 3096).then(__webpack_require__.bind(__webpack_require__, 46167))];
                    case 1:
                        queryString = (_a.sent()).queryString;
                        return [2 /*return*/, queryString(this, query)];
                }
            });
        });
    };
    /**
     * @deprecated This function does not register a destination plugin.
     *
     * Instantiates a legacy Analytics.js destination.
     *
     * This function does not register the destination as an Analytics.JS plugin,
     * all the it does it to invoke the factory function back.
     */
    Analytics.prototype.use = function (legacyPluginFactory) {
        legacyPluginFactory(this);
        return this;
    };
    Analytics.prototype.ready = function (callback) {
        if (callback === void 0) { callback = function (res) { return res; }; }
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                return [2 /*return*/, Promise.all(this.queue.plugins.map(function (i) { return (i.ready ? i.ready() : Promise.resolve()); })).then(function (res) {
                        callback(res);
                        return res;
                    })];
            });
        });
    };
    // analytics-classic api
    Analytics.prototype.noConflict = function () {
        console.warn(deprecationWarning);
        (0,global_analytics_helper/* setGlobalAnalytics */.ql)(_analytics !== null && _analytics !== void 0 ? _analytics : this);
        return this;
    };
    Analytics.prototype.normalize = function (msg) {
        console.warn(deprecationWarning);
        return this.eventFactory['normalize'](msg);
    };
    Object.defineProperty(Analytics.prototype, "failedInitializations", {
        get: function () {
            console.warn(deprecationWarning);
            return this.queue.failedInitializations;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Analytics.prototype, "VERSION", {
        get: function () {
            return version/* version */.i;
        },
        enumerable: false,
        configurable: true
    });
    /* @deprecated - noop */
    Analytics.prototype.initialize = function (_settings, _options) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                console.warn(deprecationWarning);
                return [2 /*return*/, Promise.resolve(this)];
            });
        });
    };
    Analytics.prototype.pageview = function (url) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.warn(deprecationWarning);
                        return [4 /*yield*/, this.page({ path: url })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, this];
                }
            });
        });
    };
    Object.defineProperty(Analytics.prototype, "plugins", {
        get: function () {
            var _a;
            console.warn(deprecationWarning);
            // @ts-expect-error
            return (_a = this._plugins) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Analytics.prototype, "Integrations", {
        get: function () {
            console.warn(deprecationWarning);
            var integrations = this.queue.plugins
                .filter(function (plugin) { return plugin.type === 'destination'; })
                .reduce(function (acc, plugin) {
                var name = "".concat(plugin.name
                    .toLowerCase()
                    .replace('.', '')
                    .split(' ')
                    .join('-'), "Integration");
                // @ts-expect-error
                var integration = window[name];
                if (!integration) {
                    return acc;
                }
                var nested = integration.Integration; // hack - Google Analytics function resides in the "Integration" field
                if (nested) {
                    acc[plugin.name] = nested;
                    return acc;
                }
                acc[plugin.name] = integration;
                return acc;
            }, {});
            return integrations;
        },
        enumerable: false,
        configurable: true
    });
    // snippet function
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Analytics.prototype.push = function (args) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var an = this;
        var method = args.shift();
        if (method) {
            if (!an[method])
                return;
        }
        an[method].apply(this, args);
    };
    return Analytics;
}(emitter/* Emitter */.Q));

/**
 * @returns a no-op analytics instance that does not create cookies or localstorage, or send any events to segment.
 */
var NullAnalytics = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(NullAnalytics, _super);
    function NullAnalytics() {
        var _this = _super.call(this, { writeKey: '' }, { disableClientPersistence: true }) || this;
        _this.initialized = true;
        return _this;
    }
    return NullAnalytics;
}(Analytics));

//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/merged-options.js
var merged_options = __webpack_require__(913);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-generic-utils/dist/esm/create-deferred/create-deferred.js
var create_deferred = __webpack_require__(15987);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/query-string/gracefulDecodeURIComponent.js
var gracefulDecodeURIComponent = __webpack_require__(67475);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/client-hints/index.js

function clientHints(hints) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var userAgentData;
        return (0,tslib_es6.__generator)(this, function (_a) {
            userAgentData = navigator.userAgentData;
            if (!userAgentData)
                return [2 /*return*/, undefined];
            if (!hints)
                return [2 /*return*/, userAgentData.toJSON()];
            return [2 /*return*/, userAgentData
                    .getHighEntropyValues(hints)
                    .catch(function () { return userAgentData.toJSON(); })];
        });
    });
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/env-enrichment/index.js








var cookieOptions;
function getCookieOptions() {
    if (cookieOptions) {
        return cookieOptions;
    }
    var domain = tld(window.location.href);
    cookieOptions = {
        expires: 31536000000,
        secure: false,
        path: '/',
    };
    if (domain) {
        cookieOptions.domain = domain;
    }
    return cookieOptions;
}
function ads(query) {
    var queryIds = {
        btid: 'dataxu',
        urid: 'millennial-media',
    };
    if (query.startsWith('?')) {
        query = query.substring(1);
    }
    query = query.replace(/\?/g, '&');
    var parts = query.split('&');
    for (var _i = 0, parts_1 = parts; _i < parts_1.length; _i++) {
        var part = parts_1[_i];
        var _a = part.split('='), k = _a[0], v = _a[1];
        if (queryIds[k]) {
            return {
                id: v,
                type: queryIds[k],
            };
        }
    }
}
function utm(query) {
    if (query.startsWith('?')) {
        query = query.substring(1);
    }
    query = query.replace(/\?/g, '&');
    return query.split('&').reduce(function (acc, str) {
        var _a = str.split('='), k = _a[0], _b = _a[1], v = _b === void 0 ? '' : _b;
        if (k.includes('utm_') && k.length > 4) {
            var utmParam = k.slice(4);
            if (utmParam === 'campaign') {
                utmParam = 'name';
            }
            acc[utmParam] = (0,gracefulDecodeURIComponent/* gracefulDecodeURIComponent */.a)(v);
        }
        return acc;
    }, {});
}
function ampId() {
    var ampId = dist_js_cookie.get('_ga');
    if (ampId && ampId.startsWith('amp')) {
        return ampId;
    }
}
function referrerId(query, ctx, disablePersistance) {
    var _a;
    var storage = new UniversalStorage(disablePersistance ? [] : [new CookieStorage(getCookieOptions())]);
    var stored = storage.get('s:context.referrer');
    var ad = (_a = ads(query)) !== null && _a !== void 0 ? _a : stored;
    if (!ad) {
        return;
    }
    if (ctx) {
        ctx.referrer = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ctx.referrer), ad);
    }
    storage.set('s:context.referrer', ad);
}
/**
 *
 * @param obj e.g. { foo: 'b', bar: 'd', baz: ['123', '456']}
 * @returns e.g. 'foo=b&bar=d&baz=123&baz=456'
 */
var objectToQueryString = function (obj) {
    try {
        var searchParams_1 = new URLSearchParams();
        Object.entries(obj).forEach(function (_a) {
            var k = _a[0], v = _a[1];
            if (Array.isArray(v)) {
                v.forEach(function (value) { return searchParams_1.append(k, value); });
            }
            else {
                searchParams_1.append(k, v);
            }
        });
        return searchParams_1.toString();
    }
    catch (_a) {
        return '';
    }
};
var EnvironmentEnrichmentPlugin = /** @class */ (function () {
    function EnvironmentEnrichmentPlugin() {
        var _this = this;
        this.name = 'Page Enrichment';
        this.type = 'before';
        this.version = '0.1.0';
        this.isLoaded = function () { return true; };
        this.load = function (_ctx, instance) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
            var _a, _1;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.instance = instance;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, clientHints(this.instance.options.highEntropyValuesClientHints)];
                    case 2:
                        _a.userAgentData = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _1 = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, Promise.resolve()];
                }
            });
        }); };
        this.enrich = function (ctx) {
            var _a, _b;
            // Note: Types are off - context should never be undefined here, since it is set as part of event creation.
            var evtCtx = ctx.event.context;
            var search = evtCtx.page.search || '';
            var query = typeof search === 'object' ? objectToQueryString(search) : search;
            evtCtx.userAgent = navigator.userAgent;
            evtCtx.userAgentData = _this.userAgentData;
            // @ts-ignore
            var locale = navigator.userLanguage || navigator.language;
            if (typeof evtCtx.locale === 'undefined' && typeof locale !== 'undefined') {
                evtCtx.locale = locale;
            }
            (_a = evtCtx.library) !== null && _a !== void 0 ? _a : (evtCtx.library = {
                name: 'analytics.js',
                version: "".concat((0,version_type/* getVersionType */.B)() === 'web' ? 'next' : 'npm:next', "-").concat(version/* version */.i),
            });
            if (query && !evtCtx.campaign) {
                evtCtx.campaign = utm(query);
            }
            var amp = ampId();
            if (amp) {
                evtCtx.amp = { id: amp };
            }
            referrerId(query, evtCtx, (_b = _this.instance.options.disableClientPersistence) !== null && _b !== void 0 ? _b : false);
            try {
                evtCtx.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
            catch (_) {
                // If browser doesn't have support leave timezone undefined
            }
            return ctx;
        };
        this.track = this.enrich;
        this.identify = this.enrich;
        this.page = this.enrich;
        this.group = this.enrich;
        this.alias = this.enrich;
        this.screen = this.enrich;
    }
    return EnvironmentEnrichmentPlugin;
}());
var envEnrichment = new EnvironmentEnrichmentPlugin();
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/lib/load-script.js
var load_script = __webpack_require__(66548);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/middleware/index.js
var middleware = __webpack_require__(66170);
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/stats/metric-helpers.js
var metric_helpers = __webpack_require__(92311);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/plugins/remote-loader/index.js







var ActionDestination = /** @class */ (function () {
    function ActionDestination(name, action) {
        this.version = '1.0.0';
        this.alternativeNames = [];
        this.loadPromise = (0,create_deferred/* createDeferred */.d)();
        this.middleware = [];
        this.alias = this._createMethod('alias');
        this.group = this._createMethod('group');
        this.identify = this._createMethod('identify');
        this.page = this._createMethod('page');
        this.screen = this._createMethod('screen');
        this.track = this._createMethod('track');
        this.action = action;
        this.name = name;
        this.type = action.type;
        this.alternativeNames.push(action.name);
    }
    ActionDestination.prototype.addMiddleware = function () {
        var _a;
        var fn = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fn[_i] = arguments[_i];
        }
        /** Make sure we only apply destination filters to actions of the "destination" type to avoid causing issues for hybrid destinations */
        if (this.type === 'destination') {
            (_a = this.middleware).push.apply(_a, fn);
        }
    };
    ActionDestination.prototype.transform = function (ctx) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var modifiedEvent;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0,middleware.applyDestinationMiddleware)(this.name, ctx.event, this.middleware)];
                    case 1:
                        modifiedEvent = _a.sent();
                        if (modifiedEvent === null) {
                            ctx.cancel(new esm_context/* ContextCancelation */.Y({
                                retry: false,
                                reason: 'dropped by destination middleware',
                            }));
                        }
                        return [2 /*return*/, new core_context/* Context */._(modifiedEvent)];
                }
            });
        });
    };
    ActionDestination.prototype._createMethod = function (methodName) {
        var _this = this;
        return function (ctx) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
            var transformedContext, error_1;
            return (0,tslib_es6.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.action[methodName])
                            return [2 /*return*/, ctx];
                        transformedContext = ctx;
                        if (!(this.type === 'destination')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.transform(ctx)];
                    case 1:
                        transformedContext = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        return [4 /*yield*/, this.ready()];
                    case 3:
                        if (!(_a.sent())) {
                            throw new Error('Something prevented the destination from getting ready');
                        }
                        (0,metric_helpers/* recordIntegrationMetric */.z)(ctx, {
                            integrationName: this.action.name,
                            methodName: methodName,
                            type: 'action',
                        });
                        return [4 /*yield*/, this.action[methodName](transformedContext)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _a.sent();
                        (0,metric_helpers/* recordIntegrationMetric */.z)(ctx, {
                            integrationName: this.action.name,
                            methodName: methodName,
                            type: 'action',
                            didError: true,
                        });
                        throw error_1;
                    case 6: return [2 /*return*/, ctx];
                }
            });
        }); };
    };
    /* --- PASSTHROUGH METHODS --- */
    ActionDestination.prototype.isLoaded = function () {
        return this.action.isLoaded();
    };
    ActionDestination.prototype.ready = function () {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var _a;
            return (0,tslib_es6.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.loadPromise.promise];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, true];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ActionDestination.prototype.load = function (ctx, analytics) {
        return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
            var loadP, _a, _b, error_2;
            return (0,tslib_es6.__generator)(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.loadPromise.isSettled()) {
                            return [2 /*return*/, this.loadPromise.promise];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        (0,metric_helpers/* recordIntegrationMetric */.z)(ctx, {
                            integrationName: this.action.name,
                            methodName: 'load',
                            type: 'action',
                        });
                        loadP = this.action.load(ctx, analytics);
                        _b = (_a = this.loadPromise).resolve;
                        return [4 /*yield*/, loadP];
                    case 2:
                        _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/, loadP];
                    case 3:
                        error_2 = _c.sent();
                        (0,metric_helpers/* recordIntegrationMetric */.z)(ctx, {
                            integrationName: this.action.name,
                            methodName: 'load',
                            type: 'action',
                            didError: true,
                        });
                        this.loadPromise.reject(error_2);
                        throw error_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ActionDestination.prototype.unload = function (ctx, analytics) {
        var _a, _b;
        return (_b = (_a = this.action).unload) === null || _b === void 0 ? void 0 : _b.call(_a, ctx, analytics);
    };
    return ActionDestination;
}());

function validate(pluginLike) {
    if (!Array.isArray(pluginLike)) {
        throw new Error('Not a valid list of plugins');
    }
    var required = ['load', 'isLoaded', 'name', 'version', 'type'];
    pluginLike.forEach(function (plugin) {
        required.forEach(function (method) {
            var _a;
            if (plugin[method] === undefined) {
                throw new Error("Plugin: ".concat((_a = plugin.name) !== null && _a !== void 0 ? _a : 'unknown', " missing required function ").concat(method));
            }
        });
    });
    return true;
}
function isPluginDisabled(userIntegrations, remotePlugin) {
    var creationNameEnabled = userIntegrations[remotePlugin.creationName];
    var currentNameEnabled = userIntegrations[remotePlugin.name];
    // Check that the plugin isn't explicitly enabled when All: false
    if (userIntegrations.All === false &&
        !creationNameEnabled &&
        !currentNameEnabled) {
        return true;
    }
    // Check that the plugin isn't explicitly disabled
    if (creationNameEnabled === false || currentNameEnabled === false) {
        return true;
    }
    return false;
}
function loadPluginFactory(remotePlugin, obfuscate) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var defaultCdn, cdn, urlSplit, name_1, obfuscatedURL, error_3, err_1;
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 9, , 10]);
                    defaultCdn = new RegExp('https://cdn.segment.(com|build)');
                    cdn = (0,parse_cdn/* getCDN */.Vl)();
                    if (!obfuscate) return [3 /*break*/, 6];
                    urlSplit = remotePlugin.url.split('/');
                    name_1 = urlSplit[urlSplit.length - 2];
                    obfuscatedURL = remotePlugin.url.replace(name_1, btoa(name_1).replace(/=/g, ''));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 5]);
                    return [4 /*yield*/, (0,load_script/* loadScript */.v)(obfuscatedURL.replace(defaultCdn, cdn))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    // Due to syncing concerns it is possible that the obfuscated action destination (or requested version) might not exist.
                    // We should use the unobfuscated version as a fallback.
                    return [4 /*yield*/, (0,load_script/* loadScript */.v)(remotePlugin.url.replace(defaultCdn, cdn))];
                case 4:
                    // Due to syncing concerns it is possible that the obfuscated action destination (or requested version) might not exist.
                    // We should use the unobfuscated version as a fallback.
                    _a.sent();
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, (0,load_script/* loadScript */.v)(remotePlugin.url.replace(defaultCdn, cdn))];
                case 7:
                    _a.sent();
                    _a.label = 8;
                case 8:
                    // @ts-expect-error
                    if (typeof window[remotePlugin.libraryName] === 'function') {
                        // @ts-expect-error
                        return [2 /*return*/, window[remotePlugin.libraryName]];
                    }
                    return [3 /*break*/, 10];
                case 9:
                    err_1 = _a.sent();
                    console.error('Failed to create PluginFactory', remotePlugin);
                    throw err_1;
                case 10: return [2 /*return*/];
            }
        });
    });
}
function remoteLoader(settings, integrations, mergedIntegrations, options, routingMiddleware, pluginSources) {
    var _a, _b, _c;
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var allPlugins, routingRules, pluginPromises;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_d) {
            switch (_d.label) {
                case 0:
                    allPlugins = [];
                    routingRules = (_b = (_a = settings.middlewareSettings) === null || _a === void 0 ? void 0 : _a.routingRules) !== null && _b !== void 0 ? _b : [];
                    pluginPromises = ((_c = settings.remotePlugins) !== null && _c !== void 0 ? _c : []).map(function (remotePlugin) { return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                        var pluginFactory, _a, intg, plugin, plugins, routing_1, error_4;
                        return (0,tslib_es6.__generator)(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    if (isPluginDisabled(integrations, remotePlugin))
                                        return [2 /*return*/];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 6, , 7]);
                                    _a = (pluginSources === null || pluginSources === void 0 ? void 0 : pluginSources.find(function (_a) {
                                        var pluginName = _a.pluginName;
                                        return pluginName === remotePlugin.name;
                                    }));
                                    if (_a) return [3 /*break*/, 3];
                                    return [4 /*yield*/, loadPluginFactory(remotePlugin, options === null || options === void 0 ? void 0 : options.obfuscate)];
                                case 2:
                                    _a = (_b.sent());
                                    _b.label = 3;
                                case 3:
                                    pluginFactory = _a;
                                    if (!pluginFactory) return [3 /*break*/, 5];
                                    intg = mergedIntegrations[remotePlugin.name];
                                    return [4 /*yield*/, pluginFactory((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, remotePlugin.settings), intg))];
                                case 4:
                                    plugin = _b.sent();
                                    plugins = Array.isArray(plugin) ? plugin : [plugin];
                                    validate(plugins);
                                    routing_1 = routingRules.filter(function (rule) { return rule.destinationName === remotePlugin.creationName; });
                                    plugins.forEach(function (plugin) {
                                        var wrapper = new ActionDestination(remotePlugin.creationName, plugin);
                                        if (routing_1.length && routingMiddleware) {
                                            wrapper.addMiddleware(routingMiddleware);
                                        }
                                        allPlugins.push(wrapper);
                                    });
                                    _b.label = 5;
                                case 5: return [3 /*break*/, 7];
                                case 6:
                                    error_4 = _b.sent();
                                    console.warn('Failed to load Remote Plugin', error_4);
                                    (0,metric_helpers/* recordIntegrationMetric */.z)(core_context/* Context.system */._.system(), {
                                        integrationName: remotePlugin.name,
                                        methodName: 'load',
                                        type: 'action',
                                        didError: true,
                                    });
                                    return [3 /*break*/, 7];
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(pluginPromises)];
                case 1:
                    _d.sent();
                    return [2 /*return*/, allPlugins.filter(Boolean)];
            }
        });
    });
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/inspector/index.js
var _a;
var _b;

var env = (0,get_global/* getGlobal */.R)();
// The code below assumes the inspector extension will use Object.assign
// to add the inspect interface on to this object reference (unless the
// extension code ran first and has already set up the variable)
var inspectorHost = ((_a = (_b = env)['__SEGMENT_INSPECTOR__']) !== null && _a !== void 0 ? _a : (_b['__SEGMENT_INSPECTOR__'] = {}));
var attachInspector = function (analytics) { var _a; return (_a = inspectorHost.attach) === null || _a === void 0 ? void 0 : _a.call(inspectorHost, analytics); };
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ./node_modules/@segment/analytics-next/dist/pkg/core/stats/index.js + 1 modules
var stats = __webpack_require__(42718);
;// CONCATENATED MODULE: ./node_modules/@segment/analytics-next/dist/pkg/browser/index.js















function loadCDNSettings(writeKey, baseUrl) {
    return (0,fetch/* fetch */.h)("".concat(baseUrl, "/v1/projects/").concat(writeKey, "/settings"))
        .then(function (res) {
        if (!res.ok) {
            return res.text().then(function (errorResponseMessage) {
                throw new Error(errorResponseMessage);
            });
        }
        return res.json();
    })
        .catch(function (err) {
        console.error(err.message);
        throw err;
    });
}
function hasLegacyDestinations(settings) {
    return (getProcessEnv().NODE_ENV !== 'test' &&
        // just one integration means segmentio
        Object.keys(settings.integrations).length > 1);
}
function hasTsubMiddleware(settings) {
    var _a, _b, _c;
    return (getProcessEnv().NODE_ENV !== 'test' &&
        ((_c = (_b = (_a = settings.middlewareSettings) === null || _a === void 0 ? void 0 : _a.routingRules) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0);
}
/**
 * With AJS classic, we allow users to call setAnonymousId before the library initialization.
 * This is important because some of the destinations will use the anonymousId during the initialization,
 * and if we set anonId afterwards, that wouldn’t impact the destination.
 *
 * Also Ensures events can be registered before library initialization.
 * This is important so users can register to 'initialize' and any events that may fire early during setup.
 */
function flushPreBuffer(analytics, buffer) {
    flushSetAnonymousID(analytics, buffer);
    flushOn(analytics, buffer);
}
/**
 * Finish flushing buffer and cleanup.
 */
function flushFinalBuffer(analytics, queryString, buffer) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        return (0,tslib_es6.__generator)(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, flushQueryString(analytics, queryString)];
                case 1:
                    _a.sent();
                    flushAnalyticsCallsInNewTask(analytics, buffer);
                    return [2 /*return*/];
            }
        });
    });
}
var getQueryString = function () {
    var _a, _b;
    var hash = (_a = window.location.hash) !== null && _a !== void 0 ? _a : '';
    var search = (_b = window.location.search) !== null && _b !== void 0 ? _b : '';
    var term = search.length ? search : hash.replace(/(?=#).*(?=\?)/, '');
    return term;
};
var flushQueryString = function (analytics, queryString) { return (0,tslib_es6.__awaiter)(void 0, void 0, void 0, function () {
    return (0,tslib_es6.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!queryString.includes('ajs_')) return [3 /*break*/, 2];
                return [4 /*yield*/, analytics.queryString(queryString).catch(console.error)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
function registerPlugins(writeKey, cdnSettings, analytics, options, pluginLikes, legacyIntegrationSources, preInitBuffer) {
    var _a, _b, _c;
    if (pluginLikes === void 0) { pluginLikes = []; }
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var pluginsFromSettings, pluginSources, tsubMiddleware, _d, legacyDestinations, _e, schemaFilter, _f, mergedSettings, remotePlugins, basePlugins, shouldIgnoreSegmentio, _g, _h, ctx;
        var _this = this;
        return (0,tslib_es6.__generator)(this, function (_j) {
            switch (_j.label) {
                case 0:
                    flushPreBuffer(analytics, preInitBuffer);
                    pluginsFromSettings = pluginLikes === null || pluginLikes === void 0 ? void 0 : pluginLikes.filter(function (pluginLike) { return typeof pluginLike === 'object'; });
                    pluginSources = pluginLikes === null || pluginLikes === void 0 ? void 0 : pluginLikes.filter(function (pluginLike) {
                        return typeof pluginLike === 'function' &&
                            typeof pluginLike.pluginName === 'string';
                    });
                    if (!hasTsubMiddleware(cdnSettings)) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | tsub-middleware */ 4604).then(__webpack_require__.bind(__webpack_require__, 37122)).then(function (mod) {
                            return mod.tsubMiddleware(cdnSettings.middlewareSettings.routingRules);
                        })];
                case 1:
                    _d = _j.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _d = undefined;
                    _j.label = 3;
                case 3:
                    tsubMiddleware = _d;
                    if (!(hasLegacyDestinations(cdnSettings) || legacyIntegrationSources.length > 0)) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | ajs-destination */ 9464).then(__webpack_require__.bind(__webpack_require__, 92631)).then(function (mod) {
                            return mod.ajsDestinations(writeKey, cdnSettings, analytics.integrations, options, tsubMiddleware, legacyIntegrationSources);
                        })];
                case 4:
                    _e = _j.sent();
                    return [3 /*break*/, 6];
                case 5:
                    _e = [];
                    _j.label = 6;
                case 6:
                    legacyDestinations = _e;
                    if (!cdnSettings.legacyVideoPluginsEnabled) return [3 /*break*/, 8];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | legacyVideos */ 8150).then(__webpack_require__.bind(__webpack_require__, 66352)).then(function (mod) {
                            return mod.loadLegacyVideoPlugins(analytics);
                        })];
                case 7:
                    _j.sent();
                    _j.label = 8;
                case 8:
                    if (!((_a = options.plan) === null || _a === void 0 ? void 0 : _a.track)) return [3 /*break*/, 10];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | schemaFilter */ 7493).then(__webpack_require__.bind(__webpack_require__, 70527)).then(function (mod) {
                            var _a;
                            return mod.schemaFilter((_a = options.plan) === null || _a === void 0 ? void 0 : _a.track, cdnSettings);
                        })];
                case 9:
                    _f = _j.sent();
                    return [3 /*break*/, 11];
                case 10:
                    _f = undefined;
                    _j.label = 11;
                case 11:
                    schemaFilter = _f;
                    mergedSettings = (0,merged_options/* mergedOptions */.o)(cdnSettings, options);
                    return [4 /*yield*/, remoteLoader(cdnSettings, analytics.integrations, mergedSettings, options, tsubMiddleware, pluginSources).catch(function (err) {
                            console.error('Failed to load remote plugins', err);
                            return [];
                        })];
                case 12:
                    remotePlugins = _j.sent();
                    basePlugins = (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([envEnrichment], legacyDestinations, true), remotePlugins, true);
                    if (schemaFilter) {
                        basePlugins.push(schemaFilter);
                    }
                    shouldIgnoreSegmentio = (((_b = options.integrations) === null || _b === void 0 ? void 0 : _b.All) === false &&
                        !options.integrations['Segment.io']) ||
                        (options.integrations && options.integrations['Segment.io'] === false);
                    if (!!shouldIgnoreSegmentio) return [3 /*break*/, 14];
                    _h = (_g = basePlugins).push;
                    return [4 /*yield*/, segmentio(analytics, mergedSettings['Segment.io'], cdnSettings.integrations)];
                case 13:
                    _h.apply(_g, [_j.sent()]);
                    _j.label = 14;
                case 14: return [4 /*yield*/, analytics.register.apply(analytics, (0,tslib_es6.__spreadArray)((0,tslib_es6.__spreadArray)([], basePlugins, false), pluginsFromSettings, false))];
                case 15:
                    ctx = _j.sent();
                    // register user-defined plugins registered via analytics.register()
                    return [4 /*yield*/, flushRegister(analytics, preInitBuffer)];
                case 16:
                    // register user-defined plugins registered via analytics.register()
                    _j.sent();
                    if (!Object.entries((_c = cdnSettings.enabledMiddleware) !== null && _c !== void 0 ? _c : {}).some(function (_a) {
                        var enabled = _a[1];
                        return enabled;
                    })) return [3 /*break*/, 18];
                    return [4 /*yield*/, __webpack_require__.e(/* import() | remoteMiddleware */ 9214).then(__webpack_require__.bind(__webpack_require__, 14783)).then(function (_a) {
                            var remoteMiddlewares = _a.remoteMiddlewares;
                            return (0,tslib_es6.__awaiter)(_this, void 0, void 0, function () {
                                var middleware, promises;
                                return (0,tslib_es6.__generator)(this, function (_b) {
                                    switch (_b.label) {
                                        case 0: return [4 /*yield*/, remoteMiddlewares(ctx, cdnSettings, options.obfuscate)];
                                        case 1:
                                            middleware = _b.sent();
                                            promises = middleware.map(function (mdw) {
                                                return analytics.addSourceMiddleware(mdw);
                                            });
                                            return [2 /*return*/, Promise.all(promises)];
                                    }
                                });
                            });
                        })];
                case 17:
                    _j.sent();
                    _j.label = 18;
                case 18: 
                // register any user-defined plugins added via analytics.addSourceMiddleware()
                return [4 /*yield*/, flushAddSourceMiddleware(analytics, preInitBuffer)];
                case 19:
                    // register any user-defined plugins added via analytics.addSourceMiddleware()
                    _j.sent();
                    return [2 /*return*/, ctx];
            }
        });
    });
}
function loadAnalytics(settings, options, preInitBuffer) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (options === void 0) { options = {}; }
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function () {
        var queryString, cdnURL, cdnSettings, _k, disabled, retryQueue, analytics, plugins, classicIntegrations, segmentLoadOptions, ctx;
        return (0,tslib_es6.__generator)(this, function (_l) {
            switch (_l.label) {
                case 0:
                    // return no-op analytics instance if disabled
                    if (options.disable === true) {
                        return [2 /*return*/, [new NullAnalytics(), core_context/* Context.system */._.system()]];
                    }
                    if (options.globalAnalyticsKey)
                        (0,global_analytics_helper/* setGlobalAnalyticsKey */.jV)(options.globalAnalyticsKey);
                    // this is an ugly side-effect, but it's for the benefits of the plugins that get their cdn via getCDN()
                    if (settings.cdnURL)
                        (0,parse_cdn/* setGlobalCDNUrl */.UH)(settings.cdnURL);
                    if (options.initialPageview) {
                        // capture the page context early, so it's always up-to-date
                        preInitBuffer.add(new PreInitMethodCall('page', []));
                    }
                    queryString = getQueryString();
                    cdnURL = (_a = settings.cdnURL) !== null && _a !== void 0 ? _a : (0,parse_cdn/* getCDN */.Vl)();
                    if (!((_b = settings.cdnSettings) !== null && _b !== void 0)) return [3 /*break*/, 1];
                    _k = _b;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, loadCDNSettings(settings.writeKey, cdnURL)];
                case 2:
                    _k = (_l.sent());
                    _l.label = 3;
                case 3:
                    cdnSettings = _k;
                    if (options.updateCDNSettings) {
                        cdnSettings = options.updateCDNSettings(cdnSettings);
                    }
                    if (!(typeof options.disable === 'function')) return [3 /*break*/, 5];
                    return [4 /*yield*/, options.disable(cdnSettings)];
                case 4:
                    disabled = _l.sent();
                    if (disabled) {
                        return [2 /*return*/, [new NullAnalytics(), core_context/* Context.system */._.system()]];
                    }
                    _l.label = 5;
                case 5:
                    retryQueue = (_d = (_c = cdnSettings.integrations['Segment.io']) === null || _c === void 0 ? void 0 : _c.retryQueue) !== null && _d !== void 0 ? _d : true;
                    options = (0,tslib_es6.__assign)({ retryQueue: retryQueue }, options);
                    analytics = new Analytics((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, settings), { cdnSettings: cdnSettings, cdnURL: cdnURL }), options);
                    attachInspector(analytics);
                    plugins = (_e = settings.plugins) !== null && _e !== void 0 ? _e : [];
                    classicIntegrations = (_f = settings.classicIntegrations) !== null && _f !== void 0 ? _f : [];
                    segmentLoadOptions = (_g = options.integrations) === null || _g === void 0 ? void 0 : _g['Segment.io'];
                    stats/* Stats.initRemoteMetrics */.j.initRemoteMetrics((0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, cdnSettings.metrics), { host: (_h = segmentLoadOptions === null || segmentLoadOptions === void 0 ? void 0 : segmentLoadOptions.apiHost) !== null && _h !== void 0 ? _h : (_j = cdnSettings.metrics) === null || _j === void 0 ? void 0 : _j.host, protocol: segmentLoadOptions === null || segmentLoadOptions === void 0 ? void 0 : segmentLoadOptions.protocol }));
                    return [4 /*yield*/, registerPlugins(settings.writeKey, cdnSettings, analytics, options, plugins, classicIntegrations, preInitBuffer)];
                case 6:
                    ctx = _l.sent();
                    analytics.initialized = true;
                    analytics.emit('initialize', settings, options);
                    return [4 /*yield*/, flushFinalBuffer(analytics, queryString, preInitBuffer)];
                case 7:
                    _l.sent();
                    return [2 /*return*/, [analytics, ctx]];
            }
        });
    });
}
/**
 * The public browser interface for Segment Analytics
 *
 * @example
 * ```ts
 *  export const analytics = new AnalyticsBrowser()
 *  analytics.load({ writeKey: 'foo' })
 * ```
 * @link https://github.com/segmentio/analytics-next/#readme
 */
var AnalyticsBrowser = /** @class */ (function (_super) {
    (0,tslib_es6.__extends)(AnalyticsBrowser, _super);
    function AnalyticsBrowser() {
        var _this = this;
        var _a = (0,create_deferred/* createDeferred */.d)(), loadStart = _a.promise, resolveLoadStart = _a.resolve;
        _this = _super.call(this, function (buffer) {
            return loadStart.then(function (_a) {
                var settings = _a[0], options = _a[1];
                return loadAnalytics(settings, options, buffer);
            });
        }) || this;
        _this._resolveLoadStart = function (settings, options) {
            return resolveLoadStart([settings, options]);
        };
        return _this;
    }
    /**
     * Fully initialize an analytics instance, including:
     *
     * * Fetching settings from the segment CDN (by default).
     * * Fetching all remote destinations configured by the user (if applicable).
     * * Flushing buffered analytics events.
     * * Loading all middleware.
     *
     * Note:️  This method should only be called *once* in your application.
     *
     * @example
     * ```ts
     * export const analytics = new AnalyticsBrowser()
     * analytics.load({ writeKey: 'foo' })
     * ```
     */
    AnalyticsBrowser.prototype.load = function (settings, options) {
        if (options === void 0) { options = {}; }
        this._resolveLoadStart(settings, options);
        return this;
    };
    /**
     * Instantiates an object exposing Analytics methods.
     *
     * @example
     * ```ts
     * const ajs = AnalyticsBrowser.load({ writeKey: '<YOUR_WRITE_KEY>' })
     *
     * ajs.track("foo")
     * ...
     * ```
     */
    AnalyticsBrowser.load = function (settings, options) {
        if (options === void 0) { options = {}; }
        return new AnalyticsBrowser().load(settings, options);
    };
    AnalyticsBrowser.standalone = function (writeKey, options) {
        return AnalyticsBrowser.load({ writeKey: writeKey }, options).then(function (res) { return res[0]; });
    };
    return AnalyticsBrowser;
}(AnalyticsBuffered));

//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./lib/segment.ts




/**
 * Custom Segment plugin to add traffic source information based on cookies.
 */ var traffickTypePlugin = {
    name: "traffickTypePlugin",
    version: "1.0.0",
    type: "before",
    isLoaded: function() {
        return true;
    },
    load: function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(ctx) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    ctx
                ];
            });
        });
        return function(ctx) {
            return _ref.apply(this, arguments);
        };
    }(),
    page: function(ctx) {
        var trafficSource = js_cookie/* default.get */.Z.get("le_internal_user");
        if (!ctx.event.properties || !trafficSource) {
            return ctx;
        }
        ctx.event.properties.trafficSource = "internal";
        return ctx;
    }
};
var analytics = new AnalyticsBrowser();
var initializeAnalytics = function() {
    var writeKey = "VW3RN5EkE6tyv5jWbACVGsiyPDZpZO12";
    if (!writeKey) {
        return;
    }
    analytics.load({
        writeKey: writeKey,
        plugins: [
            traffickTypePlugin
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useConsent.ts
var useConsent = __webpack_require__(95233);
;// CONCATENATED MODULE: ./components/analytics/Analytics.tsx




function Analytics_Analytics() {
    var router = (0,next_router.useRouter)();
    var hasConsent = (0,useConsent/* useConsent */.C)().hasConsent;
    var isInitialized = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        if (!router.isReady || !hasConsent || isInitialized.current) {
            return;
        }
        initializeAnalytics();
        isInitialized.current = true;
        var handleRouteChange = function() {
            if (!isInitialized.current) return;
            try {
                analytics.page();
            } catch (error) {
                console.error("Error tracking page view:", error); // fail silently if analytics is not available or fails for some reason
            }
        };
        handleRouteChange();
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.isReady,
        hasConsent
    ]);
    return null;
}

;// CONCATENATED MODULE: ./components/analytics/index.ts


// EXTERNAL MODULE: ./customHooks/useAuth/AuthProvider.tsx + 1 modules
var AuthProvider = __webpack_require__(52961);
;// CONCATENATED MODULE: ./pages/_app.tsx
// React and third-party libraries




//Providers









//Components


//styles





//utils








startBugsnag();
(0,datadog/* initDatadog */.U9)();
// Emotion~MaterialUI Client-side cache, shared for the whole session of the user in the browser.
var clientSideEmotionCache = createEmotionCache();
function MyApp(param) {
    var Component = param.Component, _emotionCache = param.emotionCache, emotionCache = _emotionCache === void 0 ? clientSideEmotionCache : _emotionCache, pageProps = param.pageProps;
    var ref;
    var ref1 = (0,useJoinUs/* default */.Z)(), joinUsState = ref1.joinUsState, setStateInJoinUsContext = ref1.setState, handleTextChangeInJoinUsContext = ref1.handleTextChange, handleCheckBoxChangeInJoinUsContext = ref1.handleCheckBoxChange, handleSelectChange = ref1.handleSelectChange, handleCreditCardChange = ref1.handleCreditCardChange, handleCityChange = ref1.handleCityChange, handleResetForm = ref1.handleResetForm;
    var ref2 = (0,useSignIn/* default */.Z)(), signInState = ref2.signInState, setStateInSignInContext = ref2.setState, handleTextChangeInSignInContext = ref2.handleTextChange, handleCheckBoxChangeInSignInContext = ref2.handleCheckBoxChange;
    var ref3 = (0,useDialogue/* default */.Z)({
        onDialogueClose: handleResetForm
    }), dialogueState = ref3.dialogueState, openDialogue = ref3.openDialogue, closeDialogue = ref3.closeDialogue;
    var ref4 = (0,useUser/* default */.Z)(), userState = ref4.state, setUser = ref4.setUser;
    (0,react.useEffect)(function() {
        if (SessionService/* default.getItemFromSession */.Z.getItemFromSession(constants/* sessionStorageKeys.NEWSLETTER_MODAL_OPENED */.Hw.NEWSLETTER_MODAL_OPENED) === "true") {
            return;
        }
        var consentCookie = js_cookie/* default.get */.Z.get("cookieConsent");
        if (!consentCookie) {
            SessionService/* default.setItemToSession */.Z.setItemToSession(constants/* sessionStorageKeys.COOKIE_CONSENT_MODAL_OPENED */.Hw.COOKIE_CONSENT_MODAL_OPENED, "true");
            openDialogue(constants/* COOKIE_CONSENT_MODAL */.Dh);
        } else {
            openDialogue(constants/* NEWSLETTER_SUBSCRIPTION_MODAL */.fI);
            SessionService/* default.setItemToSession */.Z.setItemToSession(constants/* sessionStorageKeys.NEWSLETTER_MODAL_OPENED */.Hw.NEWSLETTER_MODAL_OPENED, "true");
        }
    }, [
        openDialogue
    ]);
    var currencies = pageProps === null || pageProps === void 0 ? void 0 : (ref = pageProps.globalLayoutProps) === null || ref === void 0 ? void 0 : ref.currencies;
    customHooks_useDefaultCurrency({
        setState: setStateInJoinUsContext,
        currencies: currencies !== null && currencies !== void 0 ? currencies : [],
        shouldFetch: !!currencies && !joinUsState.currency
    });
    var queryClient = new QueryClient();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryClientProvider/* QueryClientProvider */.aH, {
                client: queryClient,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(emotion_element_f0de968e_browser_esm.C, {
                    value: emotionCache,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeProvider/* default */.Z, {
                        theme: MUITheme,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* SearchBarProvider */.t, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactQueryDevtools, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalizationProvider/* LocalizationProvider */._, {
                                    dateAdapter: MomentUtils,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthProvider/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useUser/* UserContext.Provider */.S.Provider, {
                                            value: {
                                                state: userState,
                                                setUser: setUser
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useDialogue/* DialogueContext.Provider */.$.Provider, {
                                                value: {
                                                    dialogueState: dialogueState,
                                                    openDialogue: openDialogue,
                                                    closeDialogue: closeDialogue
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useJoinUs/* JoinUsContext.Provider */.L.Provider, {
                                                    value: {
                                                        joinUsState: joinUsState,
                                                        setState: setStateInJoinUsContext,
                                                        handleTextChange: handleTextChangeInJoinUsContext,
                                                        handleCheckBoxChange: handleCheckBoxChangeInJoinUsContext,
                                                        handleSelectChange: handleSelectChange,
                                                        handleCreditCardChange: handleCreditCardChange,
                                                        handleCityChange: handleCityChange,
                                                        handleResetForm: handleResetForm
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useSignIn/* SignInContext.Provider */.f.Provider, {
                                                        value: {
                                                            signInState: signInState,
                                                            setState: setStateInSignInContext,
                                                            handleTextChange: handleTextChangeInSignInContext,
                                                            handleCheckBoxChange: handleCheckBoxChangeInSignInContext
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Analytics_Analytics, {})
        ]
    });
}
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 44653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var data_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84749);
/* harmony import */ var services_WebService_WebService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55840);







var currencySearchArray = [
    {
        currencyCode: "GBP",
        countryCodes: [
            "UK"
        ]
    },
    {
        currencyCode: "EUR",
        countryCodes: [
            "AT",
            "BE",
            "CY",
            "EE",
            "FI",
            "FR",
            "DE",
            "GR",
            "IE",
            "IT",
            "LV",
            "LT",
            "LU",
            "MT",
            "NL",
            "PT",
            "SK",
            "SI",
            "ES"
        ]
    },
    {
        currencyCode: "USD",
        countryCodes: [
            "AI",
            "AG",
            "AW",
            "BS",
            "BB",
            "BZ",
            "BM",
            "BQ",
            "VG",
            "CA",
            "KY",
            "CR",
            "CU",
            "CW",
            "DM",
            "DO",
            "SV",
            "GL",
            "GD",
            "GP",
            "GT",
            "HT",
            "HN",
            "JM",
            "MQ",
            "MX",
            "PM",
            "MS",
            "CW",
            "KN",
            "NI",
            "PA",
            "PR",
            "BQ",
            "BQ",
            "SX",
            "KN",
            "LC",
            "PM",
            "VC",
            "TT",
            "TC",
            "US",
            "VI",
            "AR",
            "BO",
            "BR",
            "CL",
            "CO",
            "EC",
            "FK",
            "GF",
            "GY",
            "GY",
            "PY",
            "PE",
            "SR",
            "UY",
            "VE",
            "AF",
            "AM",
            "AZ",
            "BH",
            "BD",
            "BT",
            "BN",
            "KH",
            "CN",
            "CX",
            "CC",
            "IO",
            "GE",
            "IN",
            "ID",
            "IR",
            "IQ",
            "IL",
            "JP",
            "JO",
            "KZ",
            "KW",
            "KG",
            "LA",
            "LB",
            "MO",
            "MY",
            "MV",
            "MN",
            "MM",
            "NP",
            "KP",
            "OM",
            "PK",
            "PS",
            "PH",
            "QA",
            "SA",
            "SG",
            "KR",
            "LK",
            "SY",
            "TW",
            "TJ",
            "TH",
            "TR",
            "TM",
            "AE",
            "UZ",
            "VN",
            "YE"
        ]
    },
    {
        currencyCode: "HKD",
        countryCodes: [
            "HK"
        ]
    }, 
];
var MembershipService = /*#__PURE__*/ function() {
    "use strict";
    function MembershipService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, MembershipService);
    }
    MembershipService.getPricesFromAPI = function getPricesFromAPI() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var option, prices, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        option = new services_WebService_WebService__WEBPACK_IMPORTED_MODULE_1__/* .ApiServerWebServiceOption */ .DM("GET", data_constants__WEBPACK_IMPORTED_MODULE_0__/* .webserviceEndpoints.LE_PRICES */ .fX.LE_PRICES);
                        return [
                            4,
                            services_WebService_WebService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].shared */ .ZP.shared().callWebService(option)
                        ];
                    case 1:
                        prices = _state.sent();
                        return [
                            2,
                            prices
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            2,
                            []
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    MembershipService.getPrices = function getPrices() {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var option, prices, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        option = new services_WebService_WebService__WEBPACK_IMPORTED_MODULE_1__/* .ClientWebServiceOption */ .J_("GET", data_constants__WEBPACK_IMPORTED_MODULE_0__/* .webserviceEndpoints.PRICES */ .fX.PRICES);
                        return [
                            4,
                            services_WebService_WebService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].shared */ .ZP.shared().callWebService(option)
                        ];
                    case 1:
                        prices = _state.sent();
                        return [
                            2,
                            prices
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            2,
                            []
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    MembershipService.getDefaultCurrency = function getDefaultCurrency(currecies) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var getCountryNotAvailableDefaultCurrency, cloudFareResponse, cloudFareResponseBlob, text, countryCode, searchedCurrencyCode, i, searchedCurrency, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        getCountryNotAvailableDefaultCurrency = function() {
                            var defaultCurrency = currecies.find(function(param) {
                                var code = param.code;
                                return code === data_constants__WEBPACK_IMPORTED_MODULE_0__/* .defaultCurrencyCode */ .ly;
                            });
                            if (defaultCurrency) {
                                return defaultCurrency;
                            }
                            return currecies[0];
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            fetch("https://www.cloudflare.com/cdn-cgi/trace")
                        ];
                    case 2:
                        cloudFareResponse = _state.sent();
                        return [
                            4,
                            cloudFareResponse.blob()
                        ];
                    case 3:
                        cloudFareResponseBlob = _state.sent();
                        return [
                            4,
                            cloudFareResponseBlob.text()
                        ];
                    case 4:
                        text = _state.sent();
                        countryCode = null;
                        text.split("\n").forEach(function(keyValueElement) {
                            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(keyValueElement.split("="), 2), key = ref[0], value = ref[1];
                            if (key === "loc") {
                                countryCode = value;
                            }
                        });
                        if (countryCode === null) {
                            return [
                                2,
                                getCountryNotAvailableDefaultCurrency()
                            ];
                        }
                        searchedCurrencyCode = null;
                        i = 0;
                        while(searchedCurrencyCode === null && i < currencySearchArray.length){
                            var _i = currencySearchArray[i], currencyCode = _i.currencyCode, countryCodes = _i.countryCodes;
                            if (countryCodes.includes(countryCode)) {
                                searchedCurrencyCode = currencyCode;
                            }
                            i += 1;
                        }
                        if (searchedCurrencyCode === null) {
                            return [
                                2,
                                getCountryNotAvailableDefaultCurrency()
                            ];
                        }
                        searchedCurrency = currecies.find(function(param) {
                            var code = param.code;
                            return code === searchedCurrencyCode;
                        });
                        if (!searchedCurrency) {
                            return [
                                2,
                                getCountryNotAvailableDefaultCurrency()
                            ];
                        }
                        return [
                            2,
                            searchedCurrency
                        ];
                    case 5:
                        error = _state.sent();
                        return [
                            2,
                            getCountryNotAvailableDefaultCurrency()
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    MembershipService.subscribeToNewsLetter = function subscribeToNewsLetter(email) {
        return new Promise(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(resolve, reject) {
                var option, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            option = new services_WebService_WebService__WEBPACK_IMPORTED_MODULE_1__/* .ClientWebServiceOption */ .J_("POST", data_constants__WEBPACK_IMPORTED_MODULE_0__/* .webserviceEndpoints.SUBSCRIBE_TO_NEWSLETTER */ .fX.SUBSCRIBE_TO_NEWSLETTER, {
                                email: email
                            });
                            return [
                                4,
                                services_WebService_WebService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].shared */ .ZP.shared().callWebService(option)
                            ];
                        case 1:
                            _state.sent();
                            resolve();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            reject();
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(resolve, reject) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    MembershipService.getCategoryForMemberShipId = function getCategoryForMemberShipId(id) {
        var _obj;
        var memberShipIdCategoryDictionary = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipOptions.TRAVEL */ .gL.TRAVEL, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipCategoryOptions.LEISURE */ .N9.LEISURE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipOptions.BLACK */ .gL.BLACK, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipCategoryOptions.LEISURE */ .N9.LEISURE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipOptions.GOLD */ .gL.GOLD, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipCategoryOptions.LEISURE */ .N9.LEISURE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipOptions.BLACK_PLUS */ .gL.BLACK_PLUS, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipCategoryOptions.LEISURE */ .N9.LEISURE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipOptions.DYNASTY */ .gL.DYNASTY, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipCategoryOptions.CORPORATE */ .N9.CORPORATE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipOptions.DYNASTY_DINING */ .gL.DYNASTY_DINING, data_constants__WEBPACK_IMPORTED_MODULE_0__/* .membershipCategoryOptions.CORPORATE */ .N9.CORPORATE), _obj);
        return memberShipIdCategoryDictionary[id];
    };
    return MembershipService;
}();
/* harmony default export */ __webpack_exports__["Z"] = (MembershipService);


/***/ }),

/***/ 5401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);

var SessionService = /*#__PURE__*/ function() {
    "use strict";
    function SessionService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SessionService);
    }
    SessionService.setItemToSession = function setItemToSession(key, value) {
        window.sessionStorage.setItem(key, value);
    };
    SessionService.getItemFromSession = function getItemFromSession(key) {
        return window.sessionStorage.getItem(key);
    };
    return SessionService;
}();
/* harmony default export */ __webpack_exports__["Z"] = (SessionService);


/***/ }),

/***/ 55840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ ApiServerWebServiceOption; },
/* harmony export */   "J_": function() { return /* binding */ ClientWebServiceOption; },
/* harmony export */   "iO": function() { return /* binding */ ServerWebServiceOption; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* provided dependency */ var process = __webpack_require__(83454);



var supportedMethods = (/* unused pure expression or super */ null && ([
    "GET",
    "POST"
]));
// It is called during build time and runtime from the server, it calls the Little Emperors API
var ServerWebServiceOption = function ServerWebServiceOption(method, path, body) {
    "use strict";
    var contentType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "application/json";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ServerWebServiceOption);
    this.method = method;
    this.path = "".concat(process.env.LITTLE_EMPERORS_API_ENDPOINT).concat(path);
    if (body) {
        this.body = JSON.stringify(body);
    }
    var headers = new Headers();
    headers.append("Content-Type", contentType);
    headers.append("Authorization", "Bearer ".concat(process.env.LITTLE_EMPERORS_API_KEY));
    this.headers = headers;
};
// It is called during build time and runtime from the server, it calls the Little Emperors API (api endpoint)
var ApiServerWebServiceOption = function ApiServerWebServiceOption(method, path, body) {
    "use strict";
    var contentType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "application/json";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ApiServerWebServiceOption);
    var ref;
    this.method = method;
    this.path = "".concat((ref = process.env.LITTLE_EMPERORS_API_ENDPOINT) === null || ref === void 0 ? void 0 : ref.replace("v1", "api")).concat(path);
    if (body) {
        this.body = JSON.stringify(body);
    }
    var headers = new Headers();
    headers.append("Content-Type", contentType);
    headers.append("App-Version", "Website");
    headers.append("Authorization", "Bearer ".concat(process.env.LITTLE_EMPERORS_API_KEY));
    this.headers = headers;
};
// It is used directly from the browser, it calls endpoints at the NextJs internal API
var ClientWebServiceOption = function ClientWebServiceOption(method, path, body) {
    "use strict";
    var contentType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "application/json";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, ClientWebServiceOption);
    this.method = method;
    this.path = "".concat("https://littleemperors.com").concat(path);
    if (body) {
        this.body = JSON.stringify(body);
    }
    var headers = new Headers();
    headers.append("Content-Type", contentType);
    this.headers = headers;
};
var WebService = /*#__PURE__*/ function() {
    "use strict";
    function WebService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, WebService);
    }
    var _proto = WebService.prototype;
    _proto.callWebService = function callWebService(option) {
        return new Promise(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(resolve, reject) {
                var response, _$error, jsonResponse, error;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                5,
                                ,
                                6
                            ]);
                            return [
                                4,
                                fetch(option.path, option)
                            ];
                        case 1:
                            response = _state.sent();
                            if (!!response.ok) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                response.json()
                            ];
                        case 2:
                            _$error = _state.sent();
                            reject(_$error);
                            _state.label = 3;
                        case 3:
                            if (response.status === 204) {
                                resolve();
                                return [
                                    2
                                ];
                            }
                            return [
                                4,
                                response.json()
                            ];
                        case 4:
                            jsonResponse = _state.sent();
                            resolve(jsonResponse);
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            reject(error);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(resolve, reject) {
                return _ref.apply(this, arguments);
            };
        }());
    };
    WebService.shared = function shared() {
        if (!this.sharedInstance) {
            this.sharedInstance = new WebService();
        }
        return this.sharedInstance;
    };
    return WebService;
}();
/* harmony default export */ __webpack_exports__["ZP"] = (WebService);


/***/ }),

/***/ 53663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U9": function() { return /* binding */ initDatadog; },
  "JN": function() { return /* binding */ trackCustomAction; }
});

// UNUSED EXPORTS: isDatadogEnabled, setDatadogUser

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.mjs
var addEventListener = __webpack_require__(54265);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.mjs
var byteUtils = __webpack_require__(88332);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/deflateEncoder.mjs

//#region src/domain/deflate/deflateEncoder.ts
function createDeflateEncoder(worker, streamId) {
	let rawBytesCount = 0;
	let compressedData = [];
	let compressedDataTrailer;
	let isEmpty = true;
	let nextWriteActionId = 0;
	const pendingWriteActions = [];
	const expectedStreamId = streamId;
	const { stop: removeMessageListener } = (0,addEventListener/* addEventListener */.Oo)(worker, "message", ({ data: workerResponse }) => {
		if (workerResponse.type !== "wrote" || workerResponse.streamId !== expectedStreamId) return;
		const nextPendingAction = pendingWriteActions[0];
		if (nextPendingAction) {
			if (nextPendingAction.id === workerResponse.id) {
				pendingWriteActions.shift();
				rawBytesCount += workerResponse.additionalBytesCount;
				compressedData.push(workerResponse.result);
				compressedDataTrailer = workerResponse.trailer;
				if (nextPendingAction.writeCallback) nextPendingAction.writeCallback(workerResponse.result.byteLength);
				else if (nextPendingAction.finishCallback) nextPendingAction.finishCallback();
			} else if (nextPendingAction.id < workerResponse.id) removeMessageListener();
		}
	});
	function consumeResult() {
		const output = compressedData.length === 0 ? /* @__PURE__ */ new Uint8Array(0) : (0,byteUtils/* concatBuffers */.Kb)(compressedData.concat(compressedDataTrailer));
		const result = {
			rawBytesCount,
			output,
			outputBytesCount: output.byteLength,
			encoding: "deflate"
		};
		rawBytesCount = 0;
		compressedData = [];
		return result;
	}
	function sendResetIfNeeded() {
		if (!isEmpty) {
			worker.postMessage({
				action: "reset",
				streamId
			});
			isEmpty = true;
		}
	}
	return {
		isAsync: true,
		get isEmpty() {
			return isEmpty;
		},
		write(data, callback) {
			worker.postMessage({
				action: "write",
				id: nextWriteActionId,
				data,
				streamId
			});
			pendingWriteActions.push({
				id: nextWriteActionId,
				writeCallback: callback,
				data
			});
			isEmpty = false;
			nextWriteActionId += 1;
		},
		finish(callback) {
			sendResetIfNeeded();
			if (!pendingWriteActions.length) callback(consumeResult());
			else {
				pendingWriteActions.forEach((pendingWriteAction) => {
					delete pendingWriteAction.writeCallback;
				});
				pendingWriteActions[pendingWriteActions.length - 1].finishCallback = () => callback(consumeResult());
			}
		},
		finishSync() {
			sendResetIfNeeded();
			const pendingData = pendingWriteActions.map((pendingWriteAction) => pendingWriteAction.data).join("");
			pendingWriteActions.length = 0;
			return {
				...consumeResult(),
				pendingData
			};
		},
		estimateEncodedBytesCount(data) {
			return data.length / 8;
		},
		stop() {
			removeMessageListener();
		}
	};
}
//#endregion


//# sourceMappingURL=deflateEncoder.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.mjs
var display = __webpack_require__(71930);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/display.mjs
var util_display = __webpack_require__(95323);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.mjs + 1 modules
var telemetry_telemetry = __webpack_require__(51034);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/scriptLoadingError.mjs

//#region src/domain/scriptLoadingError.ts
function reportScriptLoadingError({ configuredUrl, error, source, scriptType }) {
	display/* display.error */.jf.error(`${source} failed to start: an error occurred while initializing the ${scriptType}:`, error);
	if (error instanceof Event || error instanceof Error && isMessageCspRelated(error.message)) {
		let baseMessage;
		if (configuredUrl) baseMessage = `Please make sure the ${scriptType} URL ${configuredUrl} is correct and CSP is correctly configured.`;
		else baseMessage = "Please make sure CSP is correctly configured.";
		display/* display.error */.jf.error(`${baseMessage} See documentation at ${util_display/* DOCS_ORIGIN */.aA}/integrations/content_security_policy_logs/#use-csp-with-real-user-monitoring-and-session-replay`);
	} else if (scriptType === "worker") (0,telemetry_telemetry/* addTelemetryError */.Sz)(error);
}
function isMessageCspRelated(message) {
	return message.includes("Content Security Policy") || message.includes("requires 'TrustedScriptURL'");
}
//#endregion


//# sourceMappingURL=scriptLoadingError.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/mockable.mjs
var mockable = __webpack_require__(62318);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.mjs
var timer = __webpack_require__(39449);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/entries/time.mjs
var time = __webpack_require__(18907);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/deflateWorker.mjs



//#region src/domain/deflate/deflateWorker.ts
const INITIALIZATION_TIME_OUT_DELAY = 30 * time/* ONE_SECOND */.WT;
function createDeflateWorker(configuration) {
	return new Worker(configuration.workerUrl || URL.createObjectURL(new Blob(["(()=>{function t(t){if(1===t.length)return t[0];const e=t.reduce((t,e)=>t+e.length,0),a=new Uint8Array(e);let n=0;for(const e of t)a.set(e,n),n+=e.length;return a}function e(t){for(var e=t.length;--e>=0;)t[e]=0}var a=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),n=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),r=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),i=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=Array(576);e(s);var h=Array(60);e(h);var l=Array(512);e(l);var _=Array(256);e(_);var o=Array(29);e(o);var d,u,f,c=Array(30);function p(t,e,a,n,r){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=n,this.max_length=r,this.has_stree=t?.length}function g(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}e(c);var v=function(t){return t<256?l[t]:l[256+(t>>>7)]},w=function(t,e){t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},m=function(t,e,a){t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,w(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},b=function(t,e,a){m(t,a[2*e],a[2*e+1])},y=function(t,e){var a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},z=function(t,e,a){var n,r,i=Array(16),s=0;for(n=1;n<=15;n++)i[n]=s=s+a[n-1]<<1;for(r=0;r<=e;r++){var h=t[2*r+1];0!==h&&(t[2*r]=y(i[h]++,h))}},k=function(t){var e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.last_lit=t.matches=0},x=function(t){t.bi_valid>8?w(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},A=function(t,e,a,n){var r=2*e,i=2*a;return t[r]<t[i]||t[r]===t[i]&&n[e]<=n[a]},U=function(t,e,a){for(var n=t.heap[a],r=a<<1;r<=t.heap_len&&(r<t.heap_len&&A(e,t.heap[r+1],t.heap[r],t.depth)&&r++,!A(e,n,t.heap[r],t.depth));)t.heap[a]=t.heap[r],a=r,r<<=1;t.heap[a]=n},B=function(t,e,r){var i,s,h,l,d=0;if(0!==t.last_lit)do{i=t.pending_buf[t.d_buf+2*d]<<8|t.pending_buf[t.d_buf+2*d+1],s=t.pending_buf[t.l_buf+d],d++,0===i?b(t,s,e):(h=_[s],b(t,h+256+1,e),0!==(l=a[h])&&(s-=o[h],m(t,s,l)),i--,h=v(i),b(t,h,r),0!==(l=n[h])&&(i-=c[h],m(t,i,l)))}while(d<t.last_lit);b(t,256,e)},I=function(t,e){var a,n,r,i=e.dyn_tree,s=e.stat_desc.static_tree,h=e.stat_desc.has_stree,l=e.stat_desc.elems,_=-1;for(t.heap_len=0,t.heap_max=573,a=0;a<l;a++)0!==i[2*a]?(t.heap[++t.heap_len]=_=a,t.depth[a]=0):i[2*a+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=_<2?++_:0)]=1,t.depth[r]=0,t.opt_len--,h&&(t.static_len-=s[2*r+1]);for(e.max_code=_,a=t.heap_len>>1;a>=1;a--)U(t,i,a);r=l;do{a=t.heap[1],t.heap[1]=t.heap[t.heap_len--],U(t,i,1),n=t.heap[1],t.heap[--t.heap_max]=a,t.heap[--t.heap_max]=n,i[2*r]=i[2*a]+i[2*n],t.depth[r]=(t.depth[a]>=t.depth[n]?t.depth[a]:t.depth[n])+1,i[2*a+1]=i[2*n+1]=r,t.heap[1]=r++,U(t,i,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],function(t,e){var a,n,r,i,s,h,l=e.dyn_tree,_=e.max_code,o=e.stat_desc.static_tree,d=e.stat_desc.has_stree,u=e.stat_desc.extra_bits,f=e.stat_desc.extra_base,c=e.stat_desc.max_length,p=0;for(i=0;i<=15;i++)t.bl_count[i]=0;for(l[2*t.heap[t.heap_max]+1]=0,a=t.heap_max+1;a<573;a++)(i=l[2*l[2*(n=t.heap[a])+1]+1]+1)>c&&(i=c,p++),l[2*n+1]=i,n>_||(t.bl_count[i]++,s=0,n>=f&&(s=u[n-f]),h=l[2*n],t.opt_len+=h*(i+s),d&&(t.static_len+=h*(o[2*n+1]+s)));if(0!==p){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,p-=2}while(p>0);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--a])>_||(l[2*r+1]!==i&&(t.opt_len+=(i-l[2*r+1])*l[2*r],l[2*r+1]=i),n--)}}(t,e),z(i,_,t.bl_count)},E=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),e[2*(a+1)+1]=65535,n=0;n<=a;n++)r=s,s=e[2*(n+1)+1],++h<l&&r===s||(h<_?t.bl_tree[2*r]+=h:0!==r?(r!==i&&t.bl_tree[2*r]++,t.bl_tree[32]++):h<=10?t.bl_tree[34]++:t.bl_tree[36]++,h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4))},D=function(t,e,a){var n,r,i=-1,s=e[1],h=0,l=7,_=4;for(0===s&&(l=138,_=3),n=0;n<=a;n++)if(r=s,s=e[2*(n+1)+1],!(++h<l&&r===s)){if(h<_)do{b(t,r,t.bl_tree)}while(0!==--h);else 0!==r?(r!==i&&(b(t,r,t.bl_tree),h--),b(t,16,t.bl_tree),m(t,h-3,2)):h<=10?(b(t,17,t.bl_tree),m(t,h-3,3)):(b(t,18,t.bl_tree),m(t,h-11,7));h=0,i=r,0===s?(l=138,_=3):r===s?(l=6,_=3):(l=7,_=4)}},M=!1,j=function(t,e,a,n){m(t,0+(n?1:0),3),function(t,e,a){x(t),w(t,a),w(t,~a),t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a}(t,e,a)},C=j,L=function(t,e,a,n){for(var r=65535&t,i=t>>>16&65535,s=0;0!==a;){a-=s=a>2e3?2e3:a;do{i=i+(r=r+e[n++]|0)|0}while(--s);r%=65521,i%=65521}return r|i<<16},S=new Uint32Array(function(){for(var t,e=[],a=0;a<256;a++){t=a;for(var n=0;n<8;n++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e}()),O=function(t,e,a,n){var r=S,i=n+a;t^=-1;for(var s=n;s<i;s++)t=t>>>8^r[255&(t^e[s])];return-1^t},T={2:\"need dictionary\",1:\"stream end\",0:\"\",\"-1\":\"file error\",\"-2\":\"stream error\",\"-3\":\"data error\",\"-4\":\"insufficient memory\",\"-5\":\"buffer error\",\"-6\":\"incompatible version\"},q=C,F=function(t,e,a){return t.pending_buf[t.d_buf+2*t.last_lit]=e>>>8&255,t.pending_buf[t.d_buf+2*t.last_lit+1]=255&e,t.pending_buf[t.l_buf+t.last_lit]=255&a,t.last_lit++,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(_[a]+256+1)]++,t.dyn_dtree[2*v(e)]++),t.last_lit===t.lit_bufsize-1},G=-2,H=258,J=262,K=103,N=113,P=666,Q=function(t,e){return t.msg=T[e],e},R=function(t){return(t<<1)-(t>4?9:0)},V=function(t){for(var e=t.length;--e>=0;)t[e]=0},W=function(t,e,a){return(e<<t.hash_shift^a)&t.hash_mask},X=function(t){var e=t.state,a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},Y=function(t,e){(function(t,e,a,n){var r,l,_=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=function(t){var e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0}(t)),I(t,t.l_desc),I(t,t.d_desc),_=function(t){var e;for(E(t,t.dyn_ltree,t.l_desc.max_code),E(t,t.dyn_dtree,t.d_desc.max_code),I(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*i[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e}(t),r=t.opt_len+3+7>>>3,(l=t.static_len+3+7>>>3)<=r&&(r=l)):r=l=a+5,a+4<=r&&-1!==e?j(t,e,a,n):4===t.strategy||l===r?(m(t,2+(n?1:0),3),B(t,s,h)):(m(t,4+(n?1:0),3),function(t,e,a,n){var r;for(m(t,e-257,5),m(t,a-1,5),m(t,n-4,4),r=0;r<n;r++)m(t,t.bl_tree[2*i[r]+1],3);D(t,t.dyn_ltree,e-1),D(t,t.dyn_dtree,a-1)}(t,t.l_desc.max_code+1,t.d_desc.max_code+1,_+1),B(t,t.dyn_ltree,t.dyn_dtree)),k(t),n&&x(t)})(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,X(t.strm)},Z=function(t,e){t.pending_buf[t.pending++]=e},$=function(t,e){t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},tt=function(t,e,a,n){var r=t.avail_in;return r>n&&(r=n),0===r?0:(t.avail_in-=r,e.set(t.input.subarray(t.next_in,t.next_in+r),a),1===t.state.wrap?t.adler=L(t.adler,e,r,a):2===t.state.wrap&&(t.adler=O(t.adler,e,r,a)),t.next_in+=r,t.total_in+=r,r)},et=function(t,e){var a,n,r=t.max_chain_length,i=t.strstart,s=t.prev_length,h=t.nice_match,l=t.strstart>t.w_size-J?t.strstart-(t.w_size-J):0,_=t.window,o=t.w_mask,d=t.prev,u=t.strstart+H,f=_[i+s-1],c=_[i+s];t.prev_length>=t.good_match&&(r>>=2),h>t.lookahead&&(h=t.lookahead);do{if(_[(a=e)+s]===c&&_[a+s-1]===f&&_[a]===_[i]&&_[++a]===_[i+1]){i+=2,a++;do{}while(_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&_[++i]===_[++a]&&i<u);if(n=H-(u-i),i=u-H,n>s){if(t.match_start=e,s=n,n>=h)break;f=_[i+s-1],c=_[i+s]}}}while((e=d[e&o])>l&&0!==--r);return s<=t.lookahead?s:t.lookahead},at=function(t){var e,a,n,r,i,s=t.w_size;do{if(r=t.window_size-t.lookahead-t.strstart,t.strstart>=s+(s-J)){t.window.set(t.window.subarray(s,s+s),0),t.match_start-=s,t.strstart-=s,t.block_start-=s,e=a=t.hash_size;do{n=t.head[--e],t.head[e]=n>=s?n-s:0}while(--a);e=a=s;do{n=t.prev[--e],t.prev[e]=n>=s?n-s:0}while(--a);r+=s}if(0===t.strm.avail_in)break;if(a=tt(t.strm,t.window,t.strstart+t.lookahead,r),t.lookahead+=a,t.lookahead+t.insert>=3)for(i=t.strstart-t.insert,t.ins_h=t.window[i],t.ins_h=W(t,t.ins_h,t.window[i+1]);t.insert&&(t.ins_h=W(t,t.ins_h,t.window[i+3-1]),t.prev[i&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=i,i++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<J&&0!==t.strm.avail_in)},nt=function(t,e){for(var a,n;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a)),t.match_length>=3)if(n=F(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!==--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=W(t,t.ins_h,t.window[t.strstart+1]);else n=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(n&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2},rt=function(t,e){for(var a,n,r;;){if(t.lookahead<J){if(at(t),t.lookahead<J&&0===e)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-J&&(t.match_length=et(t,a),t.match_length<=5&&(1===t.strategy||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){r=t.strstart+t.lookahead-3,n=F(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=r&&(t.ins_h=W(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!==--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,n&&(Y(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if((n=F(t,0,t.window[t.strstart-1]))&&Y(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(n=F(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2};function it(t,e,a,n,r){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=n,this.func=r}var st=[new it(0,0,0,0,function(t,e){var a=65535;for(a>t.pending_buf_size-5&&(a=t.pending_buf_size-5);;){if(t.lookahead<=1){if(at(t),0===t.lookahead&&0===e)return 1;if(0===t.lookahead)break}t.strstart+=t.lookahead,t.lookahead=0;var n=t.block_start+a;if((0===t.strstart||t.strstart>=n)&&(t.lookahead=t.strstart-n,t.strstart=n,Y(t,!1),0===t.strm.avail_out))return 1;if(t.strstart-t.block_start>=t.w_size-J&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):(t.strstart>t.block_start&&(Y(t,!1),t.strm.avail_out),1)}),new it(4,4,8,4,nt),new it(4,5,16,8,nt),new it(4,6,32,32,nt),new it(4,4,16,16,rt),new it(8,16,32,32,rt),new it(8,16,128,128,rt),new it(8,32,128,256,rt),new it(32,128,258,1024,rt),new it(32,258,258,4096,rt)];function ht(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=8,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),V(this.dyn_ltree),V(this.dyn_dtree),V(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),V(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),V(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}for(var lt=function(t){var e,i=function(t){if(!t?.state)return Q(t,G);t.total_in=t.total_out=0,t.data_type=2;var e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=e.wrap?42:N,t.adler=2===e.wrap?0:1,e.last_flush=0,function(t){M||(function(){var t,e,i,g,v,w=Array(16);for(i=0,g=0;g<28;g++)for(o[g]=i,t=0;t<1<<a[g];t++)_[i++]=g;for(_[i-1]=g,v=0,g=0;g<16;g++)for(c[g]=v,t=0;t<1<<n[g];t++)l[v++]=g;for(v>>=7;g<30;g++)for(c[g]=v<<7,t=0;t<1<<n[g]-7;t++)l[256+v++]=g;for(e=0;e<=15;e++)w[e]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,w[8]++;for(;t<=255;)s[2*t+1]=9,t++,w[9]++;for(;t<=279;)s[2*t+1]=7,t++,w[7]++;for(;t<=287;)s[2*t+1]=8,t++,w[8]++;for(z(s,287,w),t=0;t<30;t++)h[2*t+1]=5,h[2*t]=y(t,5);d=new p(s,a,257,286,15),u=new p(h,n,0,30,15),f=new p([],r,0,19,7)}(),M=!0),t.l_desc=new g(t.dyn_ltree,d),t.d_desc=new g(t.dyn_dtree,u),t.bl_desc=new g(t.bl_tree,f),t.bi_buf=0,t.bi_valid=0,k(t)}(e),0}(t);return 0===i&&((e=t.state).window_size=2*e.w_size,V(e.head),e.max_lazy_match=st[e.level].max_lazy,e.good_match=st[e.level].good_length,e.nice_match=st[e.level].nice_length,e.max_chain_length=st[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=2,e.match_available=0,e.ins_h=0),i},_t=function(t,e){var a,n;if(!t?.state||e>5||e<0)return t?Q(t,G):G;var r=t.state;if(!t.output||!t.input&&0!==t.avail_in||r.status===P&&4!==e)return Q(t,0===t.avail_out?-5:G);r.strm=t;var i=r.last_flush;if(r.last_flush=e,42===r.status)if(2===r.wrap)t.adler=0,Z(r,31),Z(r,139),Z(r,8),r.gzhead?(Z(r,(r.gzhead.text?1:0)+(r.gzhead.hcrc?2:0)+(r.gzhead.extra?4:0)+(r.gzhead.name?8:0)+(r.gzhead.comment?16:0)),Z(r,255&r.gzhead.time),Z(r,r.gzhead.time>>8&255),Z(r,r.gzhead.time>>16&255),Z(r,r.gzhead.time>>24&255),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,255&r.gzhead.os),r.gzhead.extra?.length&&(Z(r,255&r.gzhead.extra.length),Z(r,r.gzhead.extra.length>>8&255)),r.gzhead.hcrc&&(t.adler=O(t.adler,r.pending_buf,r.pending,0)),r.gzindex=0,r.status=69):(Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,0),Z(r,9===r.level?2:r.strategy>=2||r.level<2?4:0),Z(r,3),r.status=N);else{var h=8+(r.w_bits-8<<4)<<8;h|=(r.strategy>=2||r.level<2?0:r.level<6?1:6===r.level?2:3)<<6,0!==r.strstart&&(h|=32),h+=31-h%31,r.status=N,$(r,h),0!==r.strstart&&($(r,t.adler>>>16),$(r,65535&t.adler)),t.adler=1}if(69===r.status)if(r.gzhead.extra){for(a=r.pending;r.gzindex<(65535&r.gzhead.extra.length)&&(r.pending!==r.pending_buf_size||(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending!==r.pending_buf_size));)Z(r,255&r.gzhead.extra[r.gzindex]),r.gzindex++;r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),r.gzindex===r.gzhead.extra.length&&(r.gzindex=0,r.status=73)}else r.status=73;if(73===r.status)if(r.gzhead.name){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.name.length?255&r.gzhead.name.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.gzindex=0,r.status=91)}else r.status=91;if(91===r.status)if(r.gzhead.comment){a=r.pending;do{if(r.pending===r.pending_buf_size&&(r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),X(t),a=r.pending,r.pending===r.pending_buf_size)){n=1;break}n=r.gzindex<r.gzhead.comment.length?255&r.gzhead.comment.charCodeAt(r.gzindex++):0,Z(r,n)}while(0!==n);r.gzhead.hcrc&&r.pending>a&&(t.adler=O(t.adler,r.pending_buf,r.pending-a,a)),0===n&&(r.status=K)}else r.status=K;if(r.status===K&&(r.gzhead.hcrc?(r.pending+2>r.pending_buf_size&&X(t),r.pending+2<=r.pending_buf_size&&(Z(r,255&t.adler),Z(r,t.adler>>8&255),t.adler=0,r.status=N)):r.status=N),0!==r.pending){if(X(t),0===t.avail_out)return r.last_flush=-1,0}else if(0===t.avail_in&&R(e)<=R(i)&&4!==e)return Q(t,-5);if(r.status===P&&0!==t.avail_in)return Q(t,-5);if(0!==t.avail_in||0!==r.lookahead||0!==e&&r.status!==P){var l=2===r.strategy?function(t,e){for(var a;;){if(0===t.lookahead&&(at(t),0===t.lookahead)){if(0===e)return 1;break}if(t.match_length=0,a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):3===r.strategy?function(t,e){for(var a,n,r,i,s=t.window;;){if(t.lookahead<=H){if(at(t),t.lookahead<=H&&0===e)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=s[r=t.strstart-1])===s[++r]&&n===s[++r]&&n===s[++r]){i=t.strstart+H;do{}while(n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&n===s[++r]&&r<i);t.match_length=H-(i-r),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=F(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=F(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(Y(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,4===e?(Y(t,!0),0===t.strm.avail_out?3:4):t.last_lit&&(Y(t,!1),0===t.strm.avail_out)?1:2}(r,e):st[r.level].func(r,e);if(3!==l&&4!==l||(r.status=P),1===l||3===l)return 0===t.avail_out&&(r.last_flush=-1),0;if(2===l&&(1===e?function(t){m(t,2,3),b(t,256,s),function(t){16===t.bi_valid?(w(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)}(t)}(r):5!==e&&(q(r,0,0,!1),3===e&&(V(r.head),0===r.lookahead&&(r.strstart=0,r.block_start=0,r.insert=0))),X(t),0===t.avail_out))return r.last_flush=-1,0}return 4!==e?0:r.wrap<=0?1:(2===r.wrap?(Z(r,255&t.adler),Z(r,t.adler>>8&255),Z(r,t.adler>>16&255),Z(r,t.adler>>24&255),Z(r,255&t.total_in),Z(r,t.total_in>>8&255),Z(r,t.total_in>>16&255),Z(r,t.total_in>>24&255)):($(r,t.adler>>>16),$(r,65535&t.adler)),X(t),r.wrap>0&&(r.wrap=-r.wrap),0!==r.pending?0:1)},ot=function(t){if(!t?.state)return G;var e=t.state.status;return 42!==e&&69!==e&&73!==e&&91!==e&&e!==K&&e!==N&&e!==P?Q(t,G):(t.state=null,e===N?Q(t,-3):0)},dt=new Uint8Array(256),ut=0;ut<256;ut++)dt[ut]=ut>=252?6:ut>=248?5:ut>=240?4:ut>=224?3:ut>=192?2:1;dt[254]=dt[254]=1;var ft=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg=\"\",this.state=null,this.data_type=2,this.adler=0},ct=Object.prototype.toString;function pt(){this.options={level:-1,method:8,chunkSize:16384,windowBits:15,memLevel:8,strategy:0};var t=this.options;t.raw&&t.windowBits>0?t.windowBits=-t.windowBits:t.gzip&&t.windowBits>0&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg=\"\",this.ended=!1,this.chunks=[],this.strm=new ft,this.strm.avail_out=0;var e,a,n=function(t,e,a,n,r,i){if(!t)return G;var s=1;if(-1===e&&(e=6),n<0?(s=0,n=-n):n>15&&(s=2,n-=16),r<1||r>9||8!==a||n<8||n>15||e<0||e>9||i<0||i>4)return Q(t,G);8===n&&(n=9);var h=new ht;return t.state=h,h.strm=t,h.wrap=s,h.gzhead=null,h.w_bits=n,h.w_size=1<<h.w_bits,h.w_mask=h.w_size-1,h.hash_bits=r+7,h.hash_size=1<<h.hash_bits,h.hash_mask=h.hash_size-1,h.hash_shift=~~((h.hash_bits+3-1)/3),h.window=new Uint8Array(2*h.w_size),h.head=new Uint16Array(h.hash_size),h.prev=new Uint16Array(h.w_size),h.lit_bufsize=1<<r+6,h.pending_buf_size=4*h.lit_bufsize,h.pending_buf=new Uint8Array(h.pending_buf_size),h.d_buf=1*h.lit_bufsize,h.l_buf=3*h.lit_bufsize,h.level=e,h.strategy=i,h.method=a,lt(t)}(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(0!==n)throw Error(T[n]);if(t.header&&(e=this.strm,a=t.header,e?.state&&(2!==e.state.wrap||(e.state.gzhead=a))),t.dictionary){var r;if(r=\"[object ArrayBuffer]\"===ct.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,0!==(n=function(t,e){var a=e.length;if(!t?.state)return G;var n=t.state,r=n.wrap;if(2===r||1===r&&42!==n.status||n.lookahead)return G;if(1===r&&(t.adler=L(t.adler,e,a,0)),n.wrap=0,a>=n.w_size){0===r&&(V(n.head),n.strstart=0,n.block_start=0,n.insert=0);var i=new Uint8Array(n.w_size);i.set(e.subarray(a-n.w_size,a),0),e=i,a=n.w_size}var s=t.avail_in,h=t.next_in,l=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,at(n);n.lookahead>=3;){var _=n.strstart,o=n.lookahead-2;do{n.ins_h=W(n,n.ins_h,n.window[_+3-1]),n.prev[_&n.w_mask]=n.head[n.ins_h],n.head[n.ins_h]=_,_++}while(--o);n.strstart=_,n.lookahead=2,at(n)}return n.strstart+=n.lookahead,n.block_start=n.strstart,n.insert=n.lookahead,n.lookahead=0,n.match_length=n.prev_length=2,n.match_available=0,t.next_in=h,t.input=l,t.avail_in=s,n.wrap=r,0}(this.strm,r)))throw Error(T[n]);this._dict_set=!0}}function gt(t,e,a){try{t.postMessage({type:\"errored\",error:e,streamId:a})}catch{t.postMessage({type:\"errored\",error:e+\"\",streamId:a})}}function vt(t){const e=t.strm.adler;return new Uint8Array([3,0,e>>>24&255,e>>>16&255,e>>>8&255,255&e])}pt.prototype.push=function(t,e){var a,n,r=this.strm,i=this.options.chunkSize;if(this.ended)return!1;for(n=e===~~e?e:!0===e?4:0,\"[object ArrayBuffer]\"===ct.call(t)?r.input=new Uint8Array(t):r.input=t,r.next_in=0,r.avail_in=r.input.length;;)if(0===r.avail_out&&(r.output=new Uint8Array(i),r.next_out=0,r.avail_out=i),(2===n||3===n)&&r.avail_out<=6)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else{if(1===(a=_t(r,n)))return r.next_out>0&&this.onData(r.output.subarray(0,r.next_out)),a=ot(this.strm),this.onEnd(a),this.ended=!0,0===a;if(0!==r.avail_out){if(n>0&&r.next_out>0)this.onData(r.output.subarray(0,r.next_out)),r.avail_out=0;else if(0===r.avail_in)break}else this.onData(r.output)}return!0},pt.prototype.onData=function(t){this.chunks.push(t)},pt.prototype.onEnd=function(t){0===t&&(this.result=function(t){for(var e=0,a=0,n=t.length;a<n;a++)e+=t[a].length;for(var r=new Uint8Array(e),i=0,s=0,h=t.length;i<h;i++){var l=t[i];r.set(l,s),s+=l.length}return r}(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg},function(e=self){try{const a=new Map;e.addEventListener(\"message\",n=>{try{const r=function(e,a){switch(a.action){case\"init\":return{type:\"initialized\",version:\"7.7.0\"};case\"write\":{let n=e.get(a.streamId);n||(n=new pt,e.set(a.streamId,n));const r=n.chunks.length,i=(new TextEncoder).encode(a.data);return n.push(i,2),{type:\"wrote\",id:a.id,streamId:a.streamId,result:t(n.chunks.slice(r)),trailer:vt(n),additionalBytesCount:i.length}}case\"reset\":e.delete(a.streamId)}}(a,n.data);r&&e.postMessage(r)}catch(t){gt(e,t,n.data&&\"streamId\"in n.data?n.data.streamId:void 0)}})}catch(t){gt(e,t)}}()})();"])));
}
let state = { status: 0 };
function startDeflateWorker(configuration, source, onInitializationFailure) {
	if (state.status === 0) doStartDeflateWorker(configuration, source);
	switch (state.status) {
		case 1:
			state.initializationFailureCallbacks.push(onInitializationFailure);
			return state.worker;
		case 3: return state.worker;
	}
}
function getDeflateWorkerStatus() {
	return state.status;
}
/**
* Starts the deflate worker and handle messages and errors
*
* The spec allow browsers to handle worker errors differently:
* - Chromium throws an exception
* - Firefox fires an error event
*
* more details: https://bugzilla.mozilla.org/show_bug.cgi?id=1736865#c2
*/
function doStartDeflateWorker(configuration, source) {
	try {
		const worker = (0,mockable/* mockable */.C)(createDeflateWorker)(configuration);
		const { stop: removeErrorListener } = (0,addEventListener/* addEventListener */.Oo)(worker, "error", (error) => {
			onError(configuration, source, error);
		});
		const { stop: removeMessageListener } = (0,addEventListener/* addEventListener */.Oo)(worker, "message", ({ data }) => {
			if (data.type === "errored") onError(configuration, source, data.error, data.streamId);
			else if (data.type === "initialized") onInitialized(data.version);
		});
		worker.postMessage({ action: "init" });
		(0,timer/* setTimeout */.iK)(() => onTimeout(source), INITIALIZATION_TIME_OUT_DELAY);
		const stop = () => {
			removeErrorListener();
			removeMessageListener();
		};
		state = {
			status: 1,
			worker,
			stop,
			initializationFailureCallbacks: []
		};
	} catch (error) {
		onError(configuration, source, error);
	}
}
function onTimeout(source) {
	if (state.status === 1) {
		display/* display.error */.jf.error(`${source} failed to start: a timeout occurred while initializing the Worker`);
		state.initializationFailureCallbacks.forEach((callback) => callback());
		state = { status: 2 };
	}
}
function onInitialized(version) {
	if (state.status === 1) state = {
		status: 3,
		worker: state.worker,
		stop: state.stop,
		version
	};
}
function onError(configuration, source, error, streamId) {
	if (state.status === 1 || state.status === 0) {
		reportScriptLoadingError({
			configuredUrl: configuration.workerUrl,
			error,
			source,
			scriptType: "worker"
		});
		if (state.status === 1) state.initializationFailureCallbacks.forEach((callback) => callback());
		state = { status: 2 };
	} else (0,telemetry_telemetry/* addTelemetryError */.Sz)(error, {
		worker_version: state.status === 3 && state.version,
		stream_id: streamId
	});
}
//#endregion


//# sourceMappingURL=deflateWorker.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/deflate/index.mjs




// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum/esm/domain/replayStats.mjs
var replayStats = __webpack_require__(83417);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.mjs + 138 modules
var esm = __webpack_require__(41305);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/getSessionReplayLink.mjs

//#region src/domain/getSessionReplayLink.ts
function getSessionReplayLink(configuration, sessionManager, viewHistory, isRecordingStarted) {
	const session = sessionManager.findTrackedSession();
	const errorType = getErrorType(configuration, session, isRecordingStarted);
	return (0,esm/* getSessionReplayUrl */.Gm)(configuration, {
		viewContext: viewHistory.findView(),
		errorType,
		session
	});
}
function getErrorType(configuration, session, isRecordingStarted) {
	if (!session) return "rum-not-tracked";
	if ((0,esm/* computeSessionReplayState */.nu)(session, configuration) === esm/* SessionReplayState.OFF */.$S.OFF) return "incorrect-session-plan";
	if (!isRecordingStarted) return "replay-not-started";
}
//#endregion


//# sourceMappingURL=getSessionReplayLink.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.mjs
var functionUtils = __webpack_require__(68272);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/startRecorderInitTelemetry.mjs


//#region src/domain/startRecorderInitTelemetry.ts
function startRecorderInitTelemetry(telemetry, observable) {
	if (!telemetry.metricsEnabled) return { stop: functionUtils/* noop */.Z };
	let startContext;
	let documentReadyDuration;
	let recorderSettledDuration;
	const { unsubscribe } = observable.subscribe((event) => {
		switch (event.type) {
			case "start":
				startContext = {
					forced: event.forced,
					timestamp: (0,time/* timeStampNow */.n$)()
				};
				documentReadyDuration = void 0;
				recorderSettledDuration = void 0;
				break;
			case "document-ready":
				if (startContext) documentReadyDuration = (0,time/* elapsed */._J)(startContext.timestamp, (0,time/* timeStampNow */.n$)());
				break;
			case "recorder-settled":
				if (startContext) recorderSettledDuration = (0,time/* elapsed */._J)(startContext.timestamp, (0,time/* timeStampNow */.n$)());
				break;
			case "aborted":
			case "deflate-encoder-load-failed":
			case "recorder-load-failed":
			case "succeeded":
				unsubscribe();
				if (startContext) (0,telemetry_telemetry/* addTelemetryMetrics */.qZ)(telemetry_telemetry/* TelemetryMetrics.RECORDER_INIT_METRICS_TELEMETRY_NAME */.T.RECORDER_INIT_METRICS_TELEMETRY_NAME, { metrics: createRecorderInitMetrics(startContext.forced, recorderSettledDuration, (0,time/* elapsed */._J)(startContext.timestamp, (0,time/* timeStampNow */.n$)()), event.type, documentReadyDuration) });
				break;
		}
	});
	return { stop: unsubscribe };
}
function createRecorderInitMetrics(forced, loadRecorderModuleDuration, recorderInitDuration, result, waitForDocReadyDuration) {
	return {
		forced,
		loadRecorderModuleDuration,
		recorderInitDuration,
		result,
		waitForDocReadyDuration
	};
}
//#endregion


//# sourceMappingURL=startRecorderInitTelemetry.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/lazyLoadRecorder.mjs


//#region src/boot/lazyLoadRecorder.ts
async function lazyLoadRecorder() {
	try {
		return await (0,mockable/* mockable */.C)(importRecorder)();
	} catch (error) {
		reportScriptLoadingError({
			error,
			source: "Recorder",
			scriptType: "module"
		});
	}
}
async function importRecorder() {
	return (await __webpack_require__.e(/* import() | datadogRecorder */ 1133).then(__webpack_require__.bind(__webpack_require__, 86645))).startRecording;
}
//#endregion


//# sourceMappingURL=lazyLoadRecorder.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.mjs + 1 modules
var tools_observable = __webpack_require__(5741);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/runOnReadyState.mjs
var runOnReadyState = __webpack_require__(9227);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.mjs + 1 modules
var monitor = __webpack_require__(59430);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/postStartStrategy.mjs





//#region src/boot/postStartStrategy.ts
function createPostStartStrategy(configuration, lifeCycle, sessionManager, viewHistory, getOrCreateDeflateEncoder, telemetry) {
	let status = 0;
	let stopRecording;
	lifeCycle.subscribe(esm/* LifeCycleEventType.SESSION_EXPIRED */.Y5.SESSION_EXPIRED, () => {
		if (status === 2 || status === 3) {
			stop();
			status = 1;
		}
	});
	lifeCycle.subscribe(esm/* LifeCycleEventType.SESSION_RENEWED */.Y5.SESSION_RENEWED, () => {
		if (status === 1) start();
	});
	const observable = new tools_observable/* Observable */.y$();
	startRecorderInitTelemetry(telemetry, observable);
	const doStart = async (forced) => {
		observable.notify({
			type: "start",
			forced
		});
		const [startRecordingImpl] = await Promise.all([notifyWhenSettled(observable, { type: "recorder-settled" }, lazyLoadRecorder()), notifyWhenSettled(observable, { type: "document-ready" }, (0,runOnReadyState/* asyncRunOnReadyState */._)("interactive"))]);
		if (status !== 2) {
			observable.notify({ type: "aborted" });
			return;
		}
		if (!startRecordingImpl) {
			status = 0;
			observable.notify({ type: "recorder-load-failed" });
			return;
		}
		const deflateEncoder = getOrCreateDeflateEncoder();
		if (!deflateEncoder) {
			status = 0;
			observable.notify({ type: "deflate-encoder-load-failed" });
			return;
		}
		({stop: stopRecording} = startRecordingImpl(lifeCycle, configuration, sessionManager, viewHistory, deflateEncoder, telemetry));
		status = 3;
		observable.notify({ type: "succeeded" });
	};
	function start(options) {
		const session = sessionManager.findTrackedSession();
		const replayState = session ? (0,esm/* computeSessionReplayState */.nu)(session, configuration) : void 0;
		if (!canStartRecording(replayState, options)) {
			status = 1;
			return;
		}
		if (isRecordingInProgress(status)) return;
		status = 2;
		const forced = shouldForceReplay(replayState, options) || false;
		doStart(forced).catch(monitor/* monitorError */.$y);
		if (forced) sessionManager.updateSessionState({ forcedReplay: "1" });
	}
	function stop() {
		if (status === 3) stopRecording?.();
		status = 0;
	}
	return {
		start,
		stop,
		getSessionReplayLink() {
			return getSessionReplayLink(configuration, sessionManager, viewHistory, status !== 0);
		},
		isRecording: () => status === 3
	};
}
function canStartRecording(replayState, options) {
	return replayState !== void 0 && (replayState !== esm/* SessionReplayState.OFF */.$S.OFF || options?.force);
}
function isRecordingInProgress(status) {
	return status === 2 || status === 3;
}
function shouldForceReplay(replayState, options) {
	return options && options.force && replayState === esm/* SessionReplayState.OFF */.$S.OFF;
}
async function notifyWhenSettled(observable, event, promise) {
	try {
		return await promise;
	} finally {
		observable.notify(event);
	}
}
//#endregion


//# sourceMappingURL=postStartStrategy.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/preStartStrategy.mjs

//#region src/boot/preStartStrategy.ts
function createPreStartStrategy() {
	let status = 0;
	return {
		strategy: {
			start() {
				status = 1;
			},
			stop() {
				status = 2;
			},
			isRecording: () => false,
			getSessionReplayLink: functionUtils/* noop */.Z
		},
		shouldStartImmediately(configuration) {
			return status === 1 || status === 0 && !configuration.startSessionReplayRecordingManually;
		}
	};
}
//#endregion


//# sourceMappingURL=preStartStrategy.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.mjs
var eventBridge = __webpack_require__(71394);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/deflate/deflate.types.mjs
var deflate_types = __webpack_require__(37182);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/recorderApi.mjs







//#region src/boot/recorderApi.ts
function makeRecorderApi() {
	if ((0,eventBridge/* canUseEventBridge */.xT)() && !(0,eventBridge/* bridgeSupports */.ke)(eventBridge/* BridgeCapability.RECORDS */.BP.RECORDS)) return {
		start: functionUtils/* noop */.Z,
		stop: functionUtils/* noop */.Z,
		getReplayStats: () => void 0,
		onRumStart: functionUtils/* noop */.Z,
		isRecording: () => false,
		getSessionReplayLink: () => void 0
	};
	let { strategy, shouldStartImmediately } = createPreStartStrategy();
	return {
		start: (options) => strategy.start(options),
		stop: () => strategy.stop(),
		getSessionReplayLink: () => strategy.getSessionReplayLink(),
		onRumStart,
		isRecording: () => getDeflateWorkerStatus() === 3 && strategy.isRecording(),
		getReplayStats: (viewId) => getDeflateWorkerStatus() === 3 ? (0,replayStats/* getReplayStats */.MA)(viewId) : void 0
	};
	function onRumStart(lifeCycle, configuration, sessionManager, viewHistory, worker, telemetry) {
		let cachedDeflateEncoder;
		function getOrCreateDeflateEncoder() {
			if (!cachedDeflateEncoder) {
				worker ??= startDeflateWorker(configuration, "Datadog Session Replay", () => strategy.stop());
				if (worker) cachedDeflateEncoder = createDeflateEncoder(worker, deflate_types/* DeflateEncoderStreamId.REPLAY */.C.REPLAY);
			}
			return cachedDeflateEncoder;
		}
		strategy = createPostStartStrategy(configuration, lifeCycle, sessionManager, viewHistory, getOrCreateDeflateEncoder, telemetry);
		if (shouldStartImmediately(configuration)) strategy.start();
	}
}
//#endregion


//# sourceMappingURL=recorderApi.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/globalObject.mjs
var globalObject = __webpack_require__(35262);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/profiling/profilingSupported.mjs

//#region src/domain/profiling/profilingSupported.ts
function isProfilingSupported() {
	return globalObject/* globalObject.Profiler */.Z.Profiler !== void 0;
}
//#endregion


//# sourceMappingURL=profilingSupported.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/assembly/hook.mjs
var hook = __webpack_require__(99731);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/domain/profiling/profilingContext.mjs


//#region src/domain/profiling/profilingContext.ts
function startProfilingContext(hooks) {
	let currentContext = { status: "starting" };
	hooks.assemble.register(({ eventType }) => {
		if (eventType !== esm/* RumEventType.VIEW */.D$.VIEW && eventType !== esm/* RumEventType.LONG_TASK */.D$.LONG_TASK && eventType !== esm/* RumEventType.ACTION */.D$.ACTION && eventType !== esm/* RumEventType.VITAL */.D$.VITAL) return hook/* SKIPPED */.kb;
		return {
			type: eventType,
			_dd: { profiling: currentContext }
		};
	});
	return {
		get: () => currentContext,
		set: (newContext) => {
			currentContext = newContext;
		}
	};
}
//#endregion


//# sourceMappingURL=profilingContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/lazyLoadProfiler.mjs


//#region src/boot/lazyLoadProfiler.ts
async function lazyLoadProfiler() {
	try {
		return await (0,mockable/* mockable */.C)(importProfiler)();
	} catch (error) {
		reportScriptLoadingError({
			error,
			source: "Profiler",
			scriptType: "module"
		});
	}
}
async function importProfiler() {
	return (await __webpack_require__.e(/* import() | datadogProfiler */ 9050).then(__webpack_require__.bind(__webpack_require__, 23612))).createRumProfiler;
}
//#endregion


//# sourceMappingURL=lazyLoadProfiler.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/sampler.mjs
var sampler = __webpack_require__(15250);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/boot/profilerApi.mjs




//#region src/boot/profilerApi.ts
function makeProfilerApi() {
	let profiler;
	function onRumStart(lifeCycle, hooks, configuration, sessionManager, viewHistory, createEncoder) {
		const session = sessionManager.findTrackedSession();
		if (!session) return;
		if (!isProfilingSampled(configuration, session)) return;
		const profilingContextManager = startProfilingContext(hooks);
		if (!(0,mockable/* mockable */.C)(isProfilingSupported)()) {
			profilingContextManager.set({
				status: "error",
				error_reason: "not-supported-by-browser"
			});
			return;
		}
		(0,mockable/* mockable */.C)(lazyLoadProfiler)().then((createRumProfiler) => {
			if (!createRumProfiler) {
				profilingContextManager.set({
					status: "error",
					error_reason: "failed-to-lazy-load"
				});
				return;
			}
			profiler = createRumProfiler(configuration, lifeCycle, sessionManager, profilingContextManager, createEncoder, viewHistory, void 0);
			profiler.start();
		}).catch(monitor/* monitorError */.$y);
	}
	return {
		onRumStart,
		stop: () => {
			profiler?.stop();
		}
	};
}
function isProfilingSampled(configuration, session) {
	if ((0,eventBridge/* canUseEventBridge */.xT)()) return (0,eventBridge/* bridgeSupports */.ke)(eventBridge/* BridgeCapability.PROFILES */.BP.PROFILES);
	return (0,sampler/* isSampled */.HR)(session.id, (0,sampler/* correctedChildSampleRate */.HQ)(configuration.sessionSampleRate, configuration.profilingSampleRate));
}
//#endregion


//# sourceMappingURL=profilerApi.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.mjs
var init = __webpack_require__(77089);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum/esm/entries/main.mjs







/**
* The global RUM instance. Use this to call RUM methods.
*
* @category Main
* @see {@link DatadogRum}
* @see [RUM Browser Monitoring Setup](https://docs.datadoghq.com/real_user_monitoring/browser/)
*/
const main_datadogRum = (0,esm/* makeRumPublicApi */._r)(makeRecorderApi(), makeProfilerApi(), {
	startDeflateWorker: startDeflateWorker,
	createDeflateEncoder: createDeflateEncoder,
	sdkName: "rum"
});
(0,init/* defineGlobal */.y)(globalObject/* globalObject */.Z, "DD_RUM", main_datadogRum);
//#endregion


//# sourceMappingURL=main.mjs.map
;// CONCATENATED MODULE: ./utils/datadog.ts

var DATADOG_APPLICATION_ID = "4d63f83c-244b-42bb-ac09-a6ad96346526";
var DATADOG_CLIENT_TOKEN = "pub9a5660ffbee2be65ac563d787d32f553";
var getReleaseStage = function() {
    if (false) {}
    var hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
        return "development";
    }
    if (hostname.includes("-test") || hostname.includes("staging")) {
        return "staging";
    }
    return "production";
};
var isDatadogEnabled = function() {
    return Boolean(DATADOG_APPLICATION_ID) && Boolean(DATADOG_CLIENT_TOKEN);
};
var initDatadog = function() {
    if ( false || !isDatadogEnabled()) {
        return;
    }
    var _NEXT_BUILD_ID;
    main_datadogRum.init({
        applicationId: DATADOG_APPLICATION_ID,
        clientToken: DATADOG_CLIENT_TOKEN,
        site: "datadoghq.eu",
        service: "le-website",
        env: getReleaseStage(),
        version: (_NEXT_BUILD_ID = "FaS5RUFxbPaTLfQUZO4Ab") !== null && _NEXT_BUILD_ID !== void 0 ? _NEXT_BUILD_ID : "development",
        sessionSampleRate: 50,
        sessionReplaySampleRate: 10,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: "mask-user-input"
    });
};
var setDatadogUser = function(user) {
    if (!isDatadogEnabled()) {
        return;
    }
    datadogRum.setUser({
        id: user.id,
        name: user.name,
        email: user.email
    });
};
var trackCustomAction = function(name, attributes) {
    if (!isDatadogEnabled()) {
        return;
    }
    main_datadogRum.addAction(name, attributes !== null && attributes !== void 0 ? attributes : {});
};


/***/ }),

/***/ 64902:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 67284:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 22496:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7727:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 53410:
/***/ (function(module) {


var identity = function(_){ return _; };


/**
 * Module exports, export
 */

module.exports = multiple(find);
module.exports.find = module.exports;


/**
 * Export the replacement function, return the modified object
 */

module.exports.replace = function (obj, key, val, options) {
  multiple(replace).call(this, obj, key, val, options);
  return obj;
};


/**
 * Export the delete function, return the modified object
 */

module.exports.del = function (obj, key, options) {
  multiple(del).call(this, obj, key, null, options);
  return obj;
};


/**
 * Compose applying the function to a nested key
 */

function multiple (fn) {
  return function (obj, path, val, options) {
    var normalize = options && isFunction(options.normalizer) ? options.normalizer : defaultNormalize;
    path = normalize(path);

    var key;
    var finished = false;

    while (!finished) loop();

    function loop() {
      for (key in obj) {
        var normalizedKey = normalize(key);
        if (0 === path.indexOf(normalizedKey)) {
          var temp = path.substr(normalizedKey.length);
          if (temp.charAt(0) === '.' || temp.length === 0) {
            path = temp.substr(1);
            var child = obj[key];

            // we're at the end and there is nothing.
            if (null == child) {
              finished = true;
              return;
            }

            // we're at the end and there is something.
            if (!path.length) {
              finished = true;
              return;
            }

            // step into child
            obj = child;

            // but we're done here
            return;
          }
        }
      }

      key = undefined;
      // if we found no matching properties
      // on the current object, there's no match.
      finished = true;
    }

    if (!key) return;
    if (null == obj) return obj;

    // the `obj` and `key` is one above the leaf object and key, so
    // start object: { a: { 'b.c': 10 } }
    // end object: { 'b.c': 10 }
    // end key: 'b.c'
    // this way, you can do `obj[key]` and get `10`.
    return fn(obj, key, val);
  };
}


/**
 * Find an object by its key
 *
 * find({ first_name : 'Calvin' }, 'firstName')
 */

function find (obj, key) {
  if (obj.hasOwnProperty(key)) return obj[key];
}


/**
 * Delete a value for a given key
 *
 * del({ a : 'b', x : 'y' }, 'X' }) -> { a : 'b' }
 */

function del (obj, key) {
  if (obj.hasOwnProperty(key)) delete obj[key];
  return obj;
}


/**
 * Replace an objects existing value with a new one
 *
 * replace({ a : 'b' }, 'a', 'c') -> { a : 'c' }
 */

function replace (obj, key, val) {
  if (obj.hasOwnProperty(key)) obj[key] = val;
  return obj;
}

/**
 * Normalize a `dot.separated.path`.
 *
 * A.HELL(!*&#(!)O_WOR   LD.bar => ahelloworldbar
 *
 * @param {String} path
 * @return {String}
 */

function defaultNormalize(path) {
  return path.replace(/[^a-zA-Z0-9\.]+/g, '').toLowerCase();
}

/**
 * Check if a value is a function.
 *
 * @param {*} val
 * @return {boolean} Returns `true` if `val` is a function, otherwise `false`.
 */

function isFunction(val) {
  return typeof val === 'function';
}


/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 77089:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ makePublicApi; },
/* harmony export */   "y": function() { return /* binding */ defineGlobal; }
/* harmony export */ });
/* harmony import */ var _tools_display_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71930);
/* harmony import */ var _tools_catchUserErrors_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84124);
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61846);



//#region src/boot/init.ts
function makePublicApi(stub) {
	const publicApi = {
		version: "7.7.0",
		onReady(callback) {
			callback();
		},
		...stub
	};
	Object.defineProperty(publicApi, "_setDebug", {
		get() {
			return _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .setDebugMode */ .y;
		},
		enumerable: false
	});
	return publicApi;
}
function defineGlobal(global, name, api) {
	const existingGlobalVariable = global[name];
	if (existingGlobalVariable && !existingGlobalVariable.q && existingGlobalVariable.version) _tools_display_mjs__WEBPACK_IMPORTED_MODULE_1__/* .display.warn */ .jf.warn("SDK is loaded more than once. This is unsupported and might have unexpected behavior.");
	global[name] = api;
	if (existingGlobalVariable?.q) existingGlobalVariable.q.forEach((fn) => (0,_tools_catchUserErrors_mjs__WEBPACK_IMPORTED_MODULE_2__/* .catchUserErrors */ .Z)(fn, "onReady callback threw an error:")());
}
//#endregion


//# sourceMappingURL=init.mjs.map

/***/ }),

/***/ 54265:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ setAllowUntrustedEvents; },
/* harmony export */   "EZ": function() { return /* binding */ DOM_EVENT; },
/* harmony export */   "Oo": function() { return /* binding */ addEventListener; },
/* harmony export */   "jO": function() { return /* binding */ isEventSupported; },
/* harmony export */   "yw": function() { return /* binding */ addEventListeners; }
/* harmony export */ });
/* unused harmony export resetAllowUntrustedEvents */
/* harmony import */ var _tools_monitor_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59430);
/* harmony import */ var _tools_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23820);
/* harmony import */ var _tools_utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68272);



//#region src/browser/addEventListener.ts
let DOM_EVENT = /* @__PURE__ */ function(DOM_EVENT) {
	DOM_EVENT["BEFORE_UNLOAD"] = "beforeunload";
	DOM_EVENT["CLICK"] = "click";
	DOM_EVENT["DBL_CLICK"] = "dblclick";
	DOM_EVENT["KEY_DOWN"] = "keydown";
	DOM_EVENT["LOAD"] = "load";
	DOM_EVENT["POP_STATE"] = "popstate";
	DOM_EVENT["SCROLL"] = "scroll";
	DOM_EVENT["TOUCH_START"] = "touchstart";
	DOM_EVENT["TOUCH_END"] = "touchend";
	DOM_EVENT["TOUCH_MOVE"] = "touchmove";
	DOM_EVENT["VISIBILITY_CHANGE"] = "visibilitychange";
	DOM_EVENT["PAGE_SHOW"] = "pageshow";
	DOM_EVENT["FREEZE"] = "freeze";
	DOM_EVENT["RESUME"] = "resume";
	DOM_EVENT["DOM_CONTENT_LOADED"] = "DOMContentLoaded";
	DOM_EVENT["POINTER_DOWN"] = "pointerdown";
	DOM_EVENT["POINTER_UP"] = "pointerup";
	DOM_EVENT["POINTER_CANCEL"] = "pointercancel";
	DOM_EVENT["HASH_CHANGE"] = "hashchange";
	DOM_EVENT["PAGE_HIDE"] = "pagehide";
	DOM_EVENT["MOUSE_DOWN"] = "mousedown";
	DOM_EVENT["MOUSE_UP"] = "mouseup";
	DOM_EVENT["MOUSE_MOVE"] = "mousemove";
	DOM_EVENT["FOCUS"] = "focus";
	DOM_EVENT["BLUR"] = "blur";
	DOM_EVENT["CONTEXT_MENU"] = "contextmenu";
	DOM_EVENT["RESIZE"] = "resize";
	DOM_EVENT["CHANGE"] = "change";
	DOM_EVENT["INPUT"] = "input";
	DOM_EVENT["PLAY"] = "play";
	DOM_EVENT["PAUSE"] = "pause";
	DOM_EVENT["SECURITY_POLICY_VIOLATION"] = "securitypolicyviolation";
	DOM_EVENT["SELECTION_CHANGE"] = "selectionchange";
	DOM_EVENT["STORAGE"] = "storage";
	DOM_EVENT["UNHANDLED_REJECTION"] = "unhandledrejection";
	return DOM_EVENT;
}({});
/**
* Add an event listener to an event target object (Window, Element, mock object...).  This provides
* a few conveniences compared to using `element.addEventListener` directly:
*
* * supports IE11 by: using an option object only if needed and emulating the `once` option
*
* * wraps the listener with a `monitor` function
*
* * returns a `stop` function to remove the listener
*/
function addEventListener(eventTarget, eventName, listener, options) {
	return addEventListeners(eventTarget, [eventName], listener, options);
}
/**
* Add event listeners to an event target object (Window, Element, mock object...).  This provides
* a few conveniences compared to using `element.addEventListener` directly:
*
* * supports IE11 by: using an option object only if needed and emulating the `once` option
*
* * wraps the listener with a `monitor` function
*
* * returns a `stop` function to remove the listener
*
* * with `once: true`, the listener will be called at most once, even if different events are listened
*/
function addEventListeners(eventTarget, eventNames, listener, { once, capture, passive } = {}) {
	const listenerWithMonitor = (0,_tools_monitor_mjs__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)((event) => {
		if (!event.isTrusted && !event.__ddIsTrusted && allowUntrustedEventsFromConfiguration === false) return;
		if (once) stop();
		listener(event);
	});
	const options = passive ? {
		capture,
		passive
	} : capture;
	const listenerTarget = window.EventTarget && eventTarget instanceof EventTarget ? window.EventTarget.prototype : eventTarget;
	const add = (0,_tools_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(listenerTarget, "addEventListener");
	eventNames.forEach((eventName) => add.call(eventTarget, eventName, listenerWithMonitor, options));
	function stop() {
		const remove = (0,_tools_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_1__/* .getZoneJsOriginalValue */ .I)(listenerTarget, "removeEventListener");
		eventNames.forEach((eventName) => remove.call(eventTarget, eventName, listenerWithMonitor, options));
	}
	return { stop };
}
function isEventSupported(eventTarget, eventName) {
	if (!eventTarget) return false;
	try {
		addEventListener(eventTarget, eventName, _tools_utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .noop */ .Z).stop();
		return true;
	} catch {
		return false;
	}
}
let allowUntrustedEventsFromConfiguration;
function setAllowUntrustedEvents(value) {
	if (allowUntrustedEventsFromConfiguration === true) return;
	allowUntrustedEventsFromConfiguration = value ?? false;
}
function resetAllowUntrustedEvents() {
	allowUntrustedEventsFromConfiguration = void 0;
}
//#endregion


//# sourceMappingURL=addEventListener.mjs.map

/***/ }),

/***/ 88481:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ fetch; }
/* harmony export */ });
/* harmony import */ var _tools_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23820);
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35262);


//#region src/browser/fetch.ts
/**
* Make a fetch request using the native implementation, bypassing Zone.js patching.
* This prevents unnecessary Angular change detection cycles.
*
* @param input - The resource to fetch (URL or Request object)
* @param init - Optional fetch options
* @returns A Promise that resolves to the Response
*/
function fetch(input, init) {
	return (0,_tools_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)(_datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__/* .globalObject */ .Z, "fetch")(input, init);
}
//#endregion


//# sourceMappingURL=fetch.mjs.map

/***/ }),

/***/ 61636:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FP": function() { return /* binding */ createPageMayExitObservable; },
/* harmony export */   "PT": function() { return /* binding */ isPageExitReason; },
/* harmony export */   "k$": function() { return /* binding */ PageExitReason; }
/* harmony export */ });
/* harmony import */ var _tools_observable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5741);
/* harmony import */ var _addEventListener_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54265);
/* harmony import */ var _tools_utils_polyfills_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59343);
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35262);




//#region src/browser/pageMayExitObservable.ts
const PageExitReason = {
	HIDDEN: "visibility_hidden",
	UNLOADING: "before_unload",
	PAGEHIDE: "page_hide",
	FROZEN: "page_frozen"
};
function createPageMayExitObservable() {
	return new _tools_observable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Observable */ .y$((observable) => {
		const window = _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__/* .globalObject.window */ .Z.window;
		if (!window) return;
		const { stop: stopListeners } = (0,_addEventListener_mjs__WEBPACK_IMPORTED_MODULE_2__/* .addEventListeners */ .yw)(window, ["visibilitychange", "freeze"], (event) => {
			if (event.type === "visibilitychange" && document.visibilityState === "hidden")
 /**
			* Only event that guarantee to fire on mobile devices when the page transitions to background state
			* (e.g. when user switches to a different application, goes to homescreen, etc), or is being unloaded.
			*/
			observable.notify({ reason: PageExitReason.HIDDEN });
			else if (event.type === "freeze")
 /**
			* After transitioning in background a tab can be freezed to preserve resources. (cf: https://developer.chrome.com/blog/page-lifecycle-api)
			* Allow to collect events happening between hidden and frozen state.
			*/
			observable.notify({ reason: PageExitReason.FROZEN });
		}, { capture: true });
		const stopBeforeUnloadListener = (0,_addEventListener_mjs__WEBPACK_IMPORTED_MODULE_2__/* .addEventListener */ .Oo)(window, "beforeunload", () => {
			observable.notify({ reason: PageExitReason.UNLOADING });
		}).stop;
		return () => {
			stopListeners();
			stopBeforeUnloadListener();
		};
	});
}
function isPageExitReason(reason) {
	return (0,_tools_utils_polyfills_mjs__WEBPACK_IMPORTED_MODULE_3__/* .objectValues */ .TT)(PageExitReason).includes(reason);
}
//#endregion


//# sourceMappingURL=pageMayExitObservable.mjs.map

/***/ }),

/***/ 9227:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ runOnReadyState; },
/* harmony export */   "_": function() { return /* binding */ asyncRunOnReadyState; }
/* harmony export */ });
/* harmony import */ var _tools_utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68272);
/* harmony import */ var _addEventListener_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54265);


//#region src/browser/runOnReadyState.ts
function runOnReadyState(expectedReadyState, callback) {
	if (document.readyState === expectedReadyState || document.readyState === "complete") {
		callback();
		return { stop: _tools_utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z };
	}
	return (0,_addEventListener_mjs__WEBPACK_IMPORTED_MODULE_1__/* .addEventListener */ .Oo)(window, expectedReadyState === "complete" ? "load" : "DOMContentLoaded", callback, { once: true });
}
function asyncRunOnReadyState(expectedReadyState) {
	return new Promise((resolve) => {
		runOnReadyState(expectedReadyState, resolve);
	});
}
//#endregion


//# sourceMappingURL=runOnReadyState.mjs.map

/***/ }),

/***/ 2770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ getConnectivity; }
/* harmony export */ });
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35262);

//#region src/domain/connectivity/connectivity.ts
function getConnectivity() {
	const { navigator } = _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .globalObject */ .Z;
	return {
		status: navigator?.onLine ? "connected" : "not_connected",
		interfaces: navigator?.connection?.type ? [navigator.connection.type] : void 0,
		effective_type: navigator?.connection?.effectiveType
	};
}
//#endregion


//# sourceMappingURL=connectivity.mjs.map

/***/ }),

/***/ 37182:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ DeflateEncoderStreamId; }
/* harmony export */ });
//#region src/domain/deflate/deflate.types.ts
let DeflateEncoderStreamId = /* @__PURE__ */ function(DeflateEncoderStreamId) {
	DeflateEncoderStreamId[DeflateEncoderStreamId["REPLAY"] = 1] = "REPLAY";
	DeflateEncoderStreamId[DeflateEncoderStreamId["RUM"] = 2] = "RUM";
	DeflateEncoderStreamId[DeflateEncoderStreamId["TELEMETRY"] = 4] = "TELEMETRY";
	DeflateEncoderStreamId[DeflateEncoderStreamId["PROFILING"] = 6] = "PROFILING";
	return DeflateEncoderStreamId;
}({});
//#endregion


//# sourceMappingURL=deflate.types.mjs.map

/***/ }),

/***/ 8183:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xw": function() { return /* binding */ ErrorHandling; },
/* harmony export */   "j9": function() { return /* binding */ NonErrorPrefix; },
/* harmony export */   "zH": function() { return /* binding */ ErrorSource; }
/* harmony export */ });
//#region src/domain/error/error.types.ts
const ErrorSource = {
	AGENT: "agent",
	CONSOLE: "console",
	CUSTOM: "custom",
	LOGGER: "logger",
	NETWORK: "network",
	SOURCE: "source",
	REPORT: "report"
};
let NonErrorPrefix = /* @__PURE__ */ function(NonErrorPrefix) {
	NonErrorPrefix["UNCAUGHT"] = "Uncaught";
	NonErrorPrefix["PROVIDED"] = "Provided";
	return NonErrorPrefix;
}({});
let ErrorHandling = /* @__PURE__ */ function(ErrorHandling) {
	ErrorHandling["HANDLED"] = "handled";
	ErrorHandling["UNHANDLED"] = "unhandled";
	return ErrorHandling;
}({});
//#endregion


//# sourceMappingURL=error.types.mjs.map

/***/ }),

/***/ 41199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ NO_ERROR_STACK_PRESENT_MESSAGE; },
/* harmony export */   "V": function() { return /* binding */ isError; }
/* harmony export */ });
//#region src/domain/error/isError.ts
const NO_ERROR_STACK_PRESENT_MESSAGE = "No stack, consider using an instance of Error";
function isError(error) {
	try {
		return error instanceof Error || Object.prototype.toString.call(error) === "[object Error]";
	} catch {
		return false;
	}
}
//#endregion


//# sourceMappingURL=isError.mjs.map

/***/ }),

/***/ 15250:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HQ": function() { return /* binding */ correctedChildSampleRate; },
/* harmony export */   "HR": function() { return /* binding */ isSampled; }
/* harmony export */ });
/* unused harmony exports resetSampleDecisionCache, sampleUsingKnuthFactor */
//#region src/domain/sampler.ts
function correctedChildSampleRate(parentRate, childRate) {
	return parentRate * childRate / 100;
}
const sampleDecisionCache = /* @__PURE__ */ new Map();
function isSampled(sessionId, sampleRate) {
	if (sampleRate === 100) return true;
	if (sampleRate === 0) return false;
	const cachedDecision = sampleDecisionCache.get(sampleRate);
	if (sessionId === cachedDecision?.sessionId) return cachedDecision.decision;
	const decision = sampleUsingKnuthFactor(BigInt(`0x${sessionId.split("-")[4]}`), sampleRate);
	sampleDecisionCache.set(sampleRate, {
		sessionId,
		decision
	});
	return decision;
}
function resetSampleDecisionCache() {
	sampleDecisionCache.clear();
}
/**
* Perform sampling using the Knuth factor method. This method offer consistent sampling result
* based on the provided identifier.
*
* @param identifier - The identifier to use for sampling.
* @param sampleRate - The sample rate in percentage between 0 and 100.
*/
function sampleUsingKnuthFactor(identifier, sampleRate) {
	const knuthFactor = 1111111111111111111n;
	const twoPow64 = 1n << 64n;
	const hash = identifier * knuthFactor % twoPow64;
	return Number(hash) <= sampleRate / 100 * Number(twoPow64);
}
//#endregion


//# sourceMappingURL=sampler.mjs.map

/***/ }),

/***/ 78532:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TN": function() { return /* binding */ SESSION_TIME_OUT_DELAY; },
/* harmony export */   "_q": function() { return /* binding */ SessionPersistence; },
/* harmony export */   "sr": function() { return /* binding */ SESSION_EXPIRATION_DELAY; },
/* harmony export */   "uY": function() { return /* binding */ SESSION_COOKIE_EXPIRATION_DELAY; }
/* harmony export */ });
/* unused harmony export SESSION_NOT_TRACKED */
/* harmony import */ var _datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18907);

//#region src/domain/session/sessionConstants.ts
const SESSION_TIME_OUT_DELAY = 4 * _datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__/* .ONE_HOUR */ .dV;
const SESSION_EXPIRATION_DELAY = 15 * _datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
const SESSION_COOKIE_EXPIRATION_DELAY = _datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__/* .ONE_YEAR */ .P5;
const SESSION_NOT_TRACKED = "0";
/**
* @internal
*/
const SessionPersistence = {
	COOKIE: "cookie",
	MEMORY: "memory",
	LOCAL_STORAGE: "local-storage"
};
//#endregion


//# sourceMappingURL=sessionConstants.mjs.map

/***/ }),

/***/ 8365:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ buildDebugIdByUrl; },
/* harmony export */   "q": function() { return /* binding */ getSourceCodeContext; }
/* harmony export */ });
/* harmony import */ var _tools_stackTrace_computeStackTrace_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);
/* harmony import */ var _telemetry_telemetry_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51034);
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35262);



//#region src/domain/sourceCodeContext.ts
const contextByUrl = /* @__PURE__ */ new Map();
const processedStacks = /* @__PURE__ */ new Set();
let hasFiredTelemetry = false;
function syncSourceCodeContext() {
	const sourceCodeContext = _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .globalObject.window */ .Z.window?.DD_SOURCE_CODE_CONTEXT;
	if (!sourceCodeContext) return;
	let useDebugId = false;
	let useService = false;
	let useVersion = false;
	for (const [stack, entry] of Object.entries(sourceCodeContext)) {
		useDebugId = useDebugId || entry.ddDebugId !== void 0;
		useService = useService || entry.service !== void 0;
		useVersion = useVersion || entry.version !== void 0;
		if (processedStacks.has(stack)) continue;
		processedStacks.add(stack);
		const url = (0,_tools_stackTrace_computeStackTrace_mjs__WEBPACK_IMPORTED_MODULE_1__/* .computeStackTrace */ ._)({ stack }).stack[0]?.url;
		if (url && !contextByUrl.has(url)) contextByUrl.set(url, entry);
	}
	if (!hasFiredTelemetry) {
		hasFiredTelemetry = true;
		(0,_telemetry_telemetry_mjs__WEBPACK_IMPORTED_MODULE_2__/* .addTelemetryUsage */ .eG)({
			feature: "source-code-context",
			use_debug_id: useDebugId,
			use_service: useService,
			use_version: useVersion
		});
	}
}
function buildDebugIdByUrl(urls) {
	syncSourceCodeContext();
	const seenUrls = /* @__PURE__ */ new Set();
	const debugIds = [];
	for (const url of urls) {
		if (seenUrls.has(url)) continue;
		seenUrls.add(url);
		const debugId = contextByUrl.get(url)?.ddDebugId;
		if (debugId !== void 0) debugIds.push({
			url,
			id: debugId
		});
	}
	return debugIds.length ? debugIds : void 0;
}
function getSourceCodeContext(url) {
	syncSourceCodeContext();
	return contextByUrl.get(url);
}
//#endregion


//# sourceMappingURL=sourceCodeContext.mjs.map

/***/ }),

/***/ 19783:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MS": function() { return /* binding */ buildTags; }
/* harmony export */ });
/* unused harmony exports TAG_SIZE_LIMIT, buildTag, sanitizeTag */
/* harmony import */ var _tools_display_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71930);
/* harmony import */ var _tools_display_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95323);

//#region src/domain/tags.ts
const TAG_SIZE_LIMIT = 200;
function buildTags(configuration) {
	const { env, service, version, datacenter, sdkVersion, variant } = configuration;
	const tags = [buildTag("sdk_version", sdkVersion ?? "7.7.0")];
	if (env) tags.push(buildTag("env", env));
	if (service) tags.push(buildTag("service", service));
	if (version) tags.push(buildTag("version", version));
	if (datacenter) tags.push(buildTag("datacenter", datacenter));
	if (variant) tags.push(buildTag("variant", variant));
	return tags;
}
function buildTag(key, rawValue) {
	const tag = rawValue ? `${key}:${rawValue}` : key;
	if (tag.length > 200 || hasForbiddenCharacters(tag)) _tools_display_mjs__WEBPACK_IMPORTED_MODULE_0__/* .display.warn */ .jf.warn(`Tag ${tag} doesn't meet tag requirements and will be sanitized. ${_tools_display_mjs__WEBPACK_IMPORTED_MODULE_1__/* .MORE_DETAILS */ .IA} ${_tools_display_mjs__WEBPACK_IMPORTED_MODULE_1__/* .DOCS_ORIGIN */ .aA}/getting_started/tagging/#defining-tags`);
	return sanitizeTag(tag);
}
function sanitizeTag(tag) {
	return tag.replace(/,/g, "_");
}
function hasForbiddenCharacters(rawValue) {
	return (/* @__PURE__ */ new RegExp("[^\\p{Ll}\\p{Lo}0-9_:./-]", "u")).test(rawValue);
}
//#endregion


//# sourceMappingURL=tags.mjs.map

/***/ }),

/***/ 51034:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ TelemetryMetrics; },
  "y0": function() { return /* binding */ TelemetryService; },
  "Uo": function() { return /* binding */ addTelemetryConfiguration; },
  "eJ": function() { return /* binding */ addTelemetryDebug; },
  "Sz": function() { return /* binding */ addTelemetryError; },
  "qZ": function() { return /* binding */ addTelemetryMetrics; },
  "eG": function() { return /* binding */ addTelemetryUsage; },
  "VL": function() { return /* binding */ startTelemetry; }
});

// UNUSED EXPORTS: formatError, getTelemetryObservable, scrubCustomerFrames, startTelemetryCollection, startTelemetryTransport

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.mjs
var display = __webpack_require__(71930);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.mjs + 1 modules
var monitor = __webpack_require__(59430);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.mjs + 1 modules
var tools_observable = __webpack_require__(5741);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.mjs
var experimentalFeatures = __webpack_require__(70234);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.mjs
var functionUtils = __webpack_require__(68272);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/stackTrace/computeStackTrace.mjs
var computeStackTrace = __webpack_require__(91635);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/stackTrace/handlingStack.mjs
var handlingStack = __webpack_require__(41410);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.mjs
var jsonStringify = __webpack_require__(21084);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/isError.mjs
var isError = __webpack_require__(41199);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/tags.mjs
var tags = __webpack_require__(19783);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.mjs
var sendToExtension = __webpack_require__(86834);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.mjs
var numberUtils = __webpack_require__(73368);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.mjs
var connectivity = __webpack_require__(2770);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.mjs
var eventBridge = __webpack_require__(71394);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.mjs + 1 modules
var batch = __webpack_require__(57242);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/rawTelemetryEvent.types.mjs
//#region src/domain/telemetry/rawTelemetryEvent.types.ts
const TelemetryType = {
	LOG: "log",
	CONFIGURATION: "configuration",
	USAGE: "usage"
};
//#endregion


//# sourceMappingURL=rawTelemetryEvent.types.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/transport/intakeSites.mjs
var intakeSites = __webpack_require__(94174);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/transport/endpointBuilder.mjs
var endpointBuilder = __webpack_require__(39464);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/mergeInto.mjs
var mergeInto = __webpack_require__(91303);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/globalObject.mjs
var globalObject = __webpack_require__(35262);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/debug.mjs
var debug = __webpack_require__(61846);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/entries/time.mjs
var time = __webpack_require__(18907);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/assembly/hook.mjs
var assembly_hook = __webpack_require__(99731);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.mjs





















//#region src/domain/telemetry/telemetry.ts
const ALLOWED_FRAME_URLS = [
	"https://www.datadoghq-browser-agent.com",
	"https://www.datad0g-browser-agent.com",
	"https://d3uc069fcn7uxw.cloudfront.net",
	"https://d20xtzwzcl0ceb.cloudfront.net",
	"http://localhost",
	"<anonymous>"
];
let TelemetryService = /* @__PURE__ */ function(TelemetryService) {
	TelemetryService["LOGS"] = "browser-logs-sdk";
	TelemetryService["RUM"] = "browser-rum-sdk";
	return TelemetryService;
}({});
let TelemetryMetrics = /* @__PURE__ */ function(TelemetryMetrics) {
	TelemetryMetrics["CUSTOMER_DATA_METRIC_NAME"] = "Customer data measures";
	TelemetryMetrics["REMOTE_CONFIGURATION_METRIC_NAME"] = "remote configuration metrics";
	TelemetryMetrics["RECORDER_INIT_METRICS_TELEMETRY_NAME"] = "Recorder init metrics";
	TelemetryMetrics["SEGMENT_METRICS_TELEMETRY_NAME"] = "Segment network request metrics";
	TelemetryMetrics["SESSION_MANAGER_INIT_METRICS_TELEMETRY_NAME"] = "Session manager init metrics";
	return TelemetryMetrics;
}({});
const METRIC_SAMPLE_RATE = 1;
const TELEMETRY_EXCLUDED_SITES = [intakeSites/* INTAKE_SITE_US1_FED */.y7, intakeSites/* INTAKE_SITE_US2_FED */.tx];
const MAX_TELEMETRY_EVENTS_PER_PAGE = 15;
let telemetryObservable;
function getTelemetryObservable() {
	if (!telemetryObservable) telemetryObservable = new tools_observable/* BufferedObservable */.fk(100);
	return telemetryObservable;
}
function startTelemetry(telemetryService, configuration, hook, sdkName) {
	const observable = new tools_observable/* Observable */.y$();
	const { enabled, metricsEnabled } = startTelemetryCollection(telemetryService, configuration, hook, observable, sdkName);
	const { stop } = startTelemetryTransport(configuration, observable);
	return {
		stop,
		enabled,
		metricsEnabled
	};
}
function startTelemetryCollection(telemetryService, configuration, hook, observable, sdkName, metricSampleRate = METRIC_SAMPLE_RATE, maxTelemetryEventsPerPage = MAX_TELEMETRY_EVENTS_PER_PAGE) {
	const alreadySentEventsByKind = {};
	const telemetryEnabled = !TELEMETRY_EXCLUDED_SITES.includes(configuration.site) && (0,numberUtils/* performDraw */.y7)(configuration.telemetrySampleRate);
	const telemetryEnabledPerType = {
		[TelemetryType.LOG]: telemetryEnabled,
		[TelemetryType.CONFIGURATION]: telemetryEnabled && (0,numberUtils/* performDraw */.y7)(configuration.telemetryConfigurationSampleRate),
		[TelemetryType.USAGE]: telemetryEnabled && (0,numberUtils/* performDraw */.y7)(configuration.telemetryUsageSampleRate),
		metric: telemetryEnabled && (0,numberUtils/* performDraw */.y7)(metricSampleRate)
	};
	const runtimeEnvInfo = getRuntimeEnvInfo();
	const telemetryObservable = getTelemetryObservable();
	telemetryObservable.subscribe(({ rawEvent, metricName }) => {
		if (metricName && !telemetryEnabledPerType["metric"] || !telemetryEnabledPerType[rawEvent.type]) return;
		const kind = metricName || rawEvent.status || rawEvent.type;
		let alreadySentEvents = alreadySentEventsByKind[kind];
		if (!alreadySentEvents) alreadySentEvents = alreadySentEventsByKind[kind] = /* @__PURE__ */ new Set();
		if (alreadySentEvents.size >= maxTelemetryEventsPerPage) return;
		const stringifiedEvent = (0,jsonStringify/* jsonStringify */.l)(rawEvent);
		if (alreadySentEvents.has(stringifiedEvent)) return;
		const defaultTelemetryEventAttributes = hook.trigger({ startTime: (0,time/* clocksNow */.$I)().relative });
		if (defaultTelemetryEventAttributes === assembly_hook/* DISCARDED */.C_) return;
		const event = toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo);
		observable.notify(event);
		(0,sendToExtension/* sendToExtension */.j)("telemetry", event);
		alreadySentEvents.add(stringifiedEvent);
	});
	telemetryObservable.unbuffer();
	(0,monitor/* startMonitorErrorCollection */.P_)(addTelemetryError);
	return {
		enabled: telemetryEnabled,
		metricsEnabled: telemetryEnabledPerType["metric"]
	};
	function toTelemetryEvent(defaultTelemetryEventAttributes, telemetryService, rawEvent, runtimeEnvInfo) {
		return (0,mergeInto/* combine */.$e)({
			type: "telemetry",
			date: (0,time/* clocksNow */.$I)().timeStamp,
			service: telemetryService,
			version: "7.7.0",
			source: "browser",
			_dd: { format_version: 2 },
			telemetry: (0,mergeInto/* combine */.$e)(rawEvent, {
				runtime_env: runtimeEnvInfo,
				connectivity: (0,connectivity/* getConnectivity */.T)(),
				sdk_setup: "npm",
				sdk_name: sdkName
			}),
			ddtags: (0,tags/* buildTags */.MS)(configuration).join(","),
			experimental_features: Array.from((0,experimentalFeatures/* getExperimentalFeatures */.u0)())
		}, defaultTelemetryEventAttributes);
	}
}
function startTelemetryTransport(configuration, telemetryObservable) {
	const cleanupTasks = [];
	if ((0,eventBridge/* canUseEventBridge */.xT)()) {
		const bridge = (0,eventBridge/* getEventBridge */.Ad)();
		const telemetrySubscription = telemetryObservable.subscribe((event) => bridge.send("internal_telemetry", event));
		cleanupTasks.push(telemetrySubscription.unsubscribe);
	} else {
		const endpoints = [(0,endpointBuilder/* createEndpointBuilder */.Ez)(configuration, "rum")];
		const replicaEndpoint = (0,endpointBuilder/* createReplicaEndpointBuilder */.ji)(configuration, "rum");
		if (replicaEndpoint && isTelemetryReplicationAllowed(configuration)) endpoints.push(replicaEndpoint);
		const telemetryBatch = (0,batch/* createBatch */.n)({
			endpoints,
			reportError: functionUtils/* noop */.Z
		});
		cleanupTasks.push(telemetryBatch.stop);
		const telemetrySubscription = telemetryObservable.subscribe(telemetryBatch.add);
		cleanupTasks.push(telemetrySubscription.unsubscribe);
	}
	return { stop: () => cleanupTasks.forEach((task) => task()) };
}
function getRuntimeEnvInfo() {
	return {
		is_local_file: globalObject/* globalObject.location */.Z.location?.protocol === "file:",
		is_worker: globalObject/* isWorkerEnvironment */.j
	};
}
/**
* Avoid mixing telemetry events from different data centers
* but keep replicating staging events for reliability
*/
function isTelemetryReplicationAllowed(configuration) {
	return configuration.site === intakeSites/* INTAKE_SITE_STAGING */.DZ;
}
function addTelemetryDebug(message, context) {
	if ((0,debug/* getDebugMode */.K)()) display/* display.debug */.jf.debug("[Telemetry]", message, context);
	getTelemetryObservable().notify({ rawEvent: {
		type: TelemetryType.LOG,
		message,
		status: "debug",
		...context
	} });
}
function addTelemetryError(e, context) {
	getTelemetryObservable().notify({ rawEvent: {
		type: TelemetryType.LOG,
		status: "error",
		...formatError(e),
		...context
	} });
}
function addTelemetryConfiguration(configuration) {
	getTelemetryObservable().notify({ rawEvent: {
		type: TelemetryType.CONFIGURATION,
		configuration
	} });
}
function addTelemetryMetrics(metricName, context) {
	getTelemetryObservable().notify({
		rawEvent: {
			type: TelemetryType.LOG,
			message: metricName,
			status: "debug",
			...context
		},
		metricName
	});
}
function addTelemetryUsage(usage) {
	getTelemetryObservable().notify({ rawEvent: {
		type: TelemetryType.USAGE,
		usage
	} });
}
function formatError(e) {
	if ((0,isError/* isError */.V)(e)) {
		const stackTrace = (0,computeStackTrace/* computeStackTrace */._)(e);
		return {
			error: {
				kind: stackTrace.name,
				stack: (0,handlingStack/* toStackTraceString */.P3)(scrubCustomerFrames(stackTrace))
			},
			message: stackTrace.message
		};
	}
	return {
		error: { stack: isError/* NO_ERROR_STACK_PRESENT_MESSAGE */.K },
		message: `Uncaught ${(0,jsonStringify/* jsonStringify */.l)(e)}`
	};
}
function scrubCustomerFrames(stackTrace) {
	stackTrace.stack = stackTrace.stack.filter((frame) => !frame.url || ALLOWED_FRAME_URLS.some((allowedFrameUrl) => frame.url.startsWith(allowedFrameUrl)));
	return stackTrace;
}
//#endregion


//# sourceMappingURL=telemetry.mjs.map

/***/ }),

/***/ 84124:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ catchUserErrors; }
/* harmony export */ });
/* harmony import */ var _display_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71930);

//#region src/tools/catchUserErrors.ts
function catchUserErrors(fn, errorMsg) {
	return (...args) => {
		try {
			return fn(...args);
		} catch (err) {
			_display_mjs__WEBPACK_IMPORTED_MODULE_0__/* .display.error */ .jf.error(errorMsg, err);
		}
	};
}
//#endregion


//# sourceMappingURL=catchUserErrors.mjs.map

/***/ }),

/***/ 71930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qo": function() { return /* binding */ DOCS_TROUBLESHOOTING; },
/* harmony export */   "jf": function() { return /* binding */ display; }
/* harmony export */ });
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95323);

//#region src/tools/display.ts
const display = (0,_datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .createDisplay */ .fT)("Datadog Browser SDK:");
const DOCS_TROUBLESHOOTING = `${_datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .DOCS_ORIGIN */ .aA}/real_user_monitoring/browser/troubleshooting`;
//#endregion


//# sourceMappingURL=display.mjs.map

/***/ }),

/***/ 65010:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ createIdentityEncoder; }
/* harmony export */ });
/* harmony import */ var _utils_byteUtils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88332);

//#region src/tools/encoder.ts
function createIdentityEncoder() {
	let output = "";
	let outputBytesCount = 0;
	return {
		isAsync: false,
		get isEmpty() {
			return !output;
		},
		write(data, callback) {
			const additionalEncodedBytesCount = (0,_utils_byteUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .computeBytesCount */ .qt)(data);
			outputBytesCount += additionalEncodedBytesCount;
			output += data;
			if (callback) callback(additionalEncodedBytesCount);
		},
		finish(callback) {
			callback(this.finishSync());
		},
		finishSync() {
			const result = {
				output,
				outputBytesCount,
				rawBytesCount: outputBytesCount,
				pendingData: ""
			};
			output = "";
			outputBytesCount = 0;
			return result;
		},
		estimateEncodedBytesCount(data) {
			return data.length;
		}
	};
}
//#endregion


//# sourceMappingURL=encoder.mjs.map

/***/ }),

/***/ 70234:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W_": function() { return /* binding */ isExperimentalFeatureEnabled; },
/* harmony export */   "fG": function() { return /* binding */ initFeatureFlags; },
/* harmony export */   "u0": function() { return /* binding */ getExperimentalFeatures; },
/* harmony export */   "uh": function() { return /* binding */ ExperimentalFeature; }
/* harmony export */ });
/* unused harmony export addExperimentalFeatures */
/* harmony import */ var _utils_objectUtils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73047);

//#region src/tools/experimentalFeatures.ts
/**
* LIMITATION:
* For NPM setup, this feature flag singleton is shared between RUM and Logs product.
* This means that an experimental flag set on the RUM product will be set on the Logs product.
* So keep in mind that in certain configurations, your experimental feature flag may affect other products.
*
* FORMAT:
* All feature flags should be snake_cased
*/
let ExperimentalFeature = /* @__PURE__ */ function(ExperimentalFeature) {
	ExperimentalFeature["TRACK_INTAKE_REQUESTS"] = "track_intake_requests";
	ExperimentalFeature["TRACK_WEBSOCKETS"] = "track_websockets";
	return ExperimentalFeature;
}({});
const enabledExperimentalFeatures = /* @__PURE__ */ new Set();
function initFeatureFlags(enableExperimentalFeatures) {
	if (Array.isArray(enableExperimentalFeatures)) addExperimentalFeatures(enableExperimentalFeatures.filter((flag) => (0,_utils_objectUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .objectHasValue */ .E5)(ExperimentalFeature, flag)));
}
function addExperimentalFeatures(enabledFeatures) {
	enabledFeatures.forEach((flag) => {
		enabledExperimentalFeatures.add(flag);
	});
}
function isExperimentalFeatureEnabled(featureName) {
	return enabledExperimentalFeatures.has(featureName);
}
function getExperimentalFeatures() {
	return enabledExperimentalFeatures;
}
//#endregion


//# sourceMappingURL=experimentalFeatures.mjs.map

/***/ }),

/***/ 23820:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getZoneJsOriginalValue; }
/* harmony export */ });
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35262);

//#region src/tools/getZoneJsOriginalValue.ts
/**
* Gets the original value for a DOM API that was potentially patched by Zone.js.
*
* Zone.js[1] is a library that patches a bunch of JS and DOM APIs. It usually stores the original
* value of the patched functions/constructors/methods in a hidden property prefixed by
* __zone_symbol__.
*
* In multiple occasions, we observed that Zone.js is the culprit of important issues leading to
* browser resource exhaustion (memory leak, high CPU usage). This method is used as a workaround to
* use the original DOM API instead of the one patched by Zone.js.
*
* [1]: https://github.com/angular/angular/tree/main/packages/zone.js
*/
function getZoneJsOriginalValue(target, name) {
	const browserWindow = _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .globalObject */ .Z;
	let original;
	if (browserWindow.Zone && typeof browserWindow.Zone.__symbol__ === "function") original = target[browserWindow.Zone.__symbol__(name)];
	if (!original) original = target[name];
	return original;
}
//#endregion


//# sourceMappingURL=getZoneJsOriginalValue.mjs.map

/***/ }),

/***/ 19353:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Su": function() { return /* binding */ instrumentMethod; },
/* harmony export */   "Xk": function() { return /* binding */ instrumentSetter; },
/* harmony export */   "t1": function() { return /* binding */ instrumentConstructor; }
/* harmony export */ });
/* harmony import */ var _monitor_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59430);
/* harmony import */ var _timer_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39449);
/* harmony import */ var _utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68272);
/* harmony import */ var _stackTrace_handlingStack_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41410);




//#region src/tools/instrumentMethod.ts
/**
* Instruments a method on a object, calling the given callback before the original method is
* invoked. The callback receives an object with information about the method call.
*
* This function makes sure that we are "good citizens" regarding third party instrumentations: when
* removing the instrumentation, the original method is usually restored, but if a third party
* instrumentation was set after ours, we keep it in place and just replace our instrumentation with
* a noop.
*
* Note: it is generally better to instrument methods that are "owned" by the object instead of ones
* that are inherited from the prototype chain. Example:
* * do:    `instrumentMethod(Array.prototype, 'push', ...)`
* * don't: `instrumentMethod([], 'push', ...)`
*
* This method is also used to set event handler properties (ex: window.onerror = ...), as it has
* the same requirements as instrumenting a method:
* * if the event handler is already set by a third party, we need to call it and not just blindly
* override it.
* * if the event handler is set by a third party after us, we need to keep it in place when
* removing ours.
*
* To instrument a constructor @see {@link instrumentConstructor}.
*
* @example
*
*  instrumentMethod(window, 'fetch', ({ target, parameters, onPostCall }) => {
*    console.log('Before calling fetch on', target, 'with parameters', parameters)
*
*    onPostCall((result) => {
*      console.log('After fetch calling on', target, 'with parameters', parameters, 'and result', result)
*    })
*  })
*/
function instrumentMethod(targetPrototype, method, onPreCall, { computeHandlingStack } = {}) {
	let original = targetPrototype[method];
	if (typeof original !== "function") if (method in targetPrototype && typeof method === "string" && method.startsWith("on")) original = _utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
	else return { stop: _utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z };
	let stopped = false;
	const instrumentation = function() {
		if (stopped) return original.apply(this, arguments);
		const parameters = Array.from(arguments);
		return notifyInstrumentation(onPreCall, {
			target: this,
			parameters,
			handlingStack: computeHandlingStack ? (0,_stackTrace_handlingStack_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createHandlingStack */ .Xp)("instrumented method") : void 0
		}, () => original.apply(this, parameters));
	};
	const { stop: restoreOriginal } = replaceWithInstrumentation(targetPrototype, method, original, instrumentation);
	return { stop: () => {
		stopped = true;
		restoreOriginal();
	} };
}
/**
* Instruments a constructor on an object (typically a global, e.g. `window.WebSocket`), calling the
* given callback before the original constructor is invoked. The callback receives an object with
* information about the constructor call, and can register an `onPostCall` callback to be notified
* with the constructed instance.
*
* Like `instrumentMethod`, this is a "good citizen" regarding third party instrumentations: stopping
* restores the original constructor unless a third party replaced it afterwards.
*
* The wrapper preserves the original prototype (so `instanceof` keeps working), the original
* `new.target` (so constructors that inspect it behave as if not instrumented), the original
* static members (e.g. `WebSocket.OPEN`), and `instance.constructor ===` so checks like
* `new WebSocket(url).constructor === WebSocket` stay true.
*
* @see {@link preserveConstructorShape} for limitations on static members preservation.
* @example
*
*  instrumentConstructor(window, 'WebSocket', ({ parameters, onPostCall }) => {
*    console.log('Before constructing WebSocket with parameters', parameters)
*
*    onPostCall((instance) => {
*      console.log('Constructed WebSocket instance', instance)
*    })
*  })
*/
function instrumentConstructor(container, constructor, onPreCall, { computeHandlingStack } = {}) {
	const original = container[constructor];
	if (typeof original !== "function") return { stop: _utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z };
	let stopped = false;
	const instrumentation = function() {
		if (!new.target) return Reflect.apply(original, this, Array.from(arguments));
		const newTarget = new.target === instrumentation ? original : new.target;
		if (stopped) return Reflect.construct(original, arguments, newTarget);
		const parameters = Array.from(arguments);
		return notifyInstrumentation(onPreCall, {
			parameters,
			handlingStack: computeHandlingStack ? (0,_stackTrace_handlingStack_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createHandlingStack */ .Xp)("instrumented constructor") : void 0
		}, () => Reflect.construct(original, parameters, newTarget));
	};
	const restorePrototypeConstructor = preserveConstructorShape(instrumentation, original);
	const { stop: restoreOriginal } = replaceWithInstrumentation(container, constructor, original, instrumentation);
	return { stop: () => {
		stopped = true;
		restorePrototypeConstructor();
		restoreOriginal();
	} };
}
/**
* Replaces `targetPrototype[method]` with the provided instrumentation and
* returns a `stop` function restoring the original (unless a third party replaced us afterwards).
*/
function replaceWithInstrumentation(targetPrototype, method, original, instrumentation) {
	targetPrototype[method] = instrumentation;
	return { stop: () => {
		if (targetPrototype[method] === instrumentation) targetPrototype[method] = original;
	} };
}
/**
* Runs the pre-call callback (injecting the `onPostCall` registration), invokes the original
* method/constructor, then runs the registered post-call callback with the result.
*
* Note: the handling stack must be computed by the caller (at the topmost position of the call
* stack), so it is part of `baseCallInfo` rather than computed here.
*/
function notifyInstrumentation(onPreCall, baseCallInfo, invokeOriginal) {
	let postCallCallback;
	(0,_monitor_mjs__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(onPreCall, null, [{
		...baseCallInfo,
		onPostCall: (callback) => {
			postCallCallback = callback;
		}
	}]);
	const result = invokeOriginal();
	if (postCallCallback) (0,_monitor_mjs__WEBPACK_IMPORTED_MODULE_2__/* .callMonitored */ .L6)(postCallCallback, null, [result]);
	return result;
}
/**
* Copies the original constructor prototype and other static members onto the instrumentation, so that
* `instanceof` checks keep working and statics such as `WebSocket.OPEN` remain available while
* instrumented.
*
* Returns a function that restores `prototype.constructor` to its prior descriptor; call it
* before restoring the global property in `stop()`.
*/
function preserveConstructorShape(instrumentation, original) {
	/**
	* Limitation: Only the original's *own* static members are copied. Statics inherited through the
	* constructor's prototype chain (e.g. `class Child extends Parent` where `Parent` defines statics)
	* are not preserved, since the instrumentation still inherits from `Function.prototype`. This is
	* acceptable for the globals we instrument (e.g. `WebSocket`, whose own statics are the only ones
	* that matter), but we would need to delegate the static prototype chain to support subclassed
	* constructors with meaningful inherited statics.
	*/
	for (const key of [].concat(Object.getOwnPropertyNames(original), Object.getOwnPropertySymbols(original))) {
		const descriptor = Object.getOwnPropertyDescriptor(original, key);
		Object.defineProperty(instrumentation, key, descriptor);
	}
	const { stop: restoreOriginalConstructor } = replaceWithInstrumentation(original.prototype, "constructor", original.prototype.constructor, instrumentation);
	return restoreOriginalConstructor;
}
function instrumentSetter(targetPrototype, property, after) {
	const originalDescriptor = Object.getOwnPropertyDescriptor(targetPrototype, property);
	if (!originalDescriptor?.set || !originalDescriptor.configurable) return { stop: _utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z };
	const stoppedInstrumentation = _utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
	let instrumentation = (target, value) => {
		(0,_timer_mjs__WEBPACK_IMPORTED_MODULE_3__/* .setTimeout */ .iK)(() => {
			if (instrumentation !== stoppedInstrumentation) after(target, value);
		}, 0);
	};
	const instrumentationWrapper = function(value) {
		originalDescriptor.set.call(this, value);
		instrumentation(this, value);
	};
	Object.defineProperty(targetPrototype, property, { set: instrumentationWrapper });
	return { stop: () => {
		if (Object.getOwnPropertyDescriptor(targetPrototype, property)?.set === instrumentationWrapper) Object.defineProperty(targetPrototype, property, originalDescriptor);
		instrumentation = stoppedInstrumentation;
	} };
}
//#endregion


//# sourceMappingURL=instrumentMethod.mjs.map

/***/ }),

/***/ 62318:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ mockable; }
/* harmony export */ });
//#region src/tools/mockable.ts
/**
* Wraps a value to make it mockable in tests. In production builds, this is a no-op
* that returns the value as-is. In test builds, it checks if a mock replacement has
* been registered and returns that instead.
*
* @example
* // In source file:
* import { mockable } from '../tools/mockable'
* export function formatNavigationEntry(): string {
*   const navigationEntry = mockable(getNavigationEntry)()
*   ...
* }
*
* // In test file:
* import { replaceMockable } from '@datadog/browser-core/test'
* it('...', () => {
*   replaceMockable(getNavigationEntry, () => FAKE_NAVIGATION_ENTRY)
*   expect(formatNavigationEntry()).toEqual(...)
* })
*/
function mockable(value) {
	return value;
}
//#endregion


//# sourceMappingURL=mockable.mjs.map

/***/ }),

/***/ 59430:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L6": function() { return /* binding */ callMonitored; },
  "zk": function() { return /* binding */ monitor; },
  "$y": function() { return /* binding */ monitorError; },
  "P_": function() { return /* binding */ startMonitorErrorCollection; }
});

// UNUSED EXPORTS: monitored

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.mjs
var display = __webpack_require__(71930);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/debug.mjs
var debug = __webpack_require__(61846);
;// CONCATENATED MODULE: ./node_modules/@datadog/js-core/esm/entries/monitor.mjs

//#region src/entries/monitor.ts
/**
* Creates an isolated monitor with its own error-collection callback and display.
*
* Each consumer (SDK) should create its own monitor so that error-collection callbacks do not
* clobber each other when several SDKs share the same `@datadog/js-core/monitor` module instance.
*
* @param display - {@link Display} used for debug logging (see `createDisplay` in
* `@datadog/js-core/util`). Lets the consumer control the log prefix and console binding. Debug
* output is only emitted when debug mode is enabled (see `setDebugMode`/`getDebugMode`).
* @param onMonitorErrorCollected - Callback invoked with each error caught by the monitor (e.g. to
* forward it to telemetry). Fixed for the lifetime of the monitor.
* @returns A {@link Monitor}.
*/
function createMonitor(display, onMonitorErrorCollected) {
	function monitored(_, __, descriptor) {
		descriptor.value = monitor(descriptor.value);
	}
	function monitor(fn) {
		return function(...args) {
			return callMonitored(fn, this, args);
		};
	}
	function callMonitored(fn, context, args) {
		try {
			return fn.apply(context, args);
		} catch (e) {
			monitorError(e);
		}
	}
	function monitorError(e) {
		const displayIfDebugEnabled = (e) => {
			if ((0,debug/* getDebugMode */.K)()) display.error("[MONITOR]", e);
		};
		displayIfDebugEnabled(e);
		try {
			onMonitorErrorCollected(e);
		} catch (e) {
			displayIfDebugEnabled(e);
		}
	}
	return {
		monitored,
		monitor,
		callMonitored,
		monitorError
	};
}
//#endregion


//# sourceMappingURL=monitor.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.mjs



//#region src/tools/monitor.ts
let onMonitorErrorCollected;
const { monitored, monitor, callMonitored, monitorError } = createMonitor(display/* display */.jf, (error) => onMonitorErrorCollected?.(error));
function startMonitorErrorCollection(newOnMonitorErrorCollected) {
	onMonitorErrorCollected = newOnMonitorErrorCollected;
}
//#endregion


//# sourceMappingURL=monitor.mjs.map

/***/ }),

/***/ 5741:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fk": function() { return /* binding */ BufferedObservable; },
  "y$": function() { return /* binding */ Observable; },
  "$Z": function() { return /* binding */ mergeObservables; }
});

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.mjs + 1 modules
var monitor = __webpack_require__(59430);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/globalObject.mjs
var globalObject = __webpack_require__(35262);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/queueMicrotask.mjs


//#region src/tools/queueMicrotask.ts
function queueMicrotask(callback) {
	const nativeImplementation = globalObject/* globalObject.queueMicrotask */.Z.queueMicrotask;
	if (typeof nativeImplementation === "function") nativeImplementation((0,monitor/* monitor */.zk)(callback));
	else Promise.resolve().then((0,monitor/* monitor */.zk)(callback));
}
//#endregion


//# sourceMappingURL=queueMicrotask.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.mjs

//#region src/tools/observable.ts
var Observable = class {
	constructor(onFirstSubscribe) {
		this.onFirstSubscribe = onFirstSubscribe;
		this.observers = [];
	}
	subscribe(observer) {
		this.addObserver(observer);
		return { unsubscribe: () => this.removeObserver(observer) };
	}
	notify(data) {
		this.observers.forEach((observer) => observer(data));
	}
	addObserver(observer) {
		this.observers.push(observer);
		if (this.observers.length === 1 && this.onFirstSubscribe) this.onLastUnsubscribe = this.onFirstSubscribe(this) || void 0;
	}
	removeObserver(observer) {
		this.observers = this.observers.filter((other) => observer !== other);
		if (!this.observers.length && this.onLastUnsubscribe) this.onLastUnsubscribe();
	}
};
function mergeObservables(...observables) {
	return new Observable((globalObservable) => {
		const subscriptions = observables.map((observable) => observable.subscribe((data) => globalObservable.notify(data)));
		return () => subscriptions.forEach((subscription) => subscription.unsubscribe());
	});
}
var BufferedObservable = class extends Observable {
	constructor(maxBufferSize, onDrop) {
		super();
		this.maxBufferSize = maxBufferSize;
		this.onDrop = onDrop;
		this.buffer = [];
		this.droppedCount = 0;
	}
	notify(data) {
		this.buffer.push(data);
		if (this.buffer.length > this.maxBufferSize) {
			this.buffer.shift();
			this.droppedCount++;
		}
		super.notify(data);
	}
	subscribe(observer) {
		let closed = false;
		const subscription = { unsubscribe: () => {
			closed = true;
			this.removeObserver(observer);
		} };
		queueMicrotask(() => {
			for (const data of this.buffer) {
				if (closed) return;
				observer(data);
			}
			if (!closed) this.addObserver(observer);
		});
		return subscription;
	}
	/**
	* Drop buffered data and don't buffer future data. This is to avoid leaking memory when it's not
	* needed anymore. This can be seen as a performance optimization, and things will work probably
	* even if this method isn't called, but still useful to clarify our intent and lowering our
	* memory impact.
	*/
	unbuffer() {
		queueMicrotask(() => {
			if (this.droppedCount > 0 && this.onDrop) this.onDrop(this.droppedCount);
			this.maxBufferSize = this.buffer.length = 0;
		});
	}
};
//#endregion


//# sourceMappingURL=observable.mjs.map

/***/ }),

/***/ 18199:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ requestIdleCallback; }
/* harmony export */ });
/* unused harmony export requestIdleCallbackShim */
/* harmony import */ var _monitor_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59430);
/* harmony import */ var _timer_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39449);
/* harmony import */ var _datadog_js_core_time__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18907);



//#region src/tools/requestIdleCallback.ts
/**
* 'requestIdleCallback' with a shim.
*/
function requestIdleCallback(callback, opts) {
	if (window.requestIdleCallback && window.cancelIdleCallback) {
		const id = window.requestIdleCallback((0,_monitor_mjs__WEBPACK_IMPORTED_MODULE_0__/* .monitor */ .zk)(callback), opts);
		return () => window.cancelIdleCallback(id);
	}
	return requestIdleCallbackShim(callback);
}
function requestIdleCallbackShim(callback) {
	const start = (0,_datadog_js_core_time__WEBPACK_IMPORTED_MODULE_1__/* .dateNow */ .m6)();
	const timeoutId = (0,_timer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .setTimeout */ .iK)(() => {
		callback({
			didTimeout: false,
			timeRemaining: () => Math.max(0, 50 - ((0,_datadog_js_core_time__WEBPACK_IMPORTED_MODULE_1__/* .dateNow */ .m6)() - start))
		});
	}, 0);
	return () => (0,_timer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .clearTimeout */ .gr)(timeoutId);
}
//#endregion


//# sourceMappingURL=requestIdleCallback.mjs.map

/***/ }),

/***/ 86834:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ sendToExtension; }
/* harmony export */ });
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35262);

//#region src/tools/sendToExtension.ts
function sendToExtension(type, payload) {
	const callback = _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .globalObject.__ddBrowserSdkExtensionCallback */ .Z.__ddBrowserSdkExtensionCallback;
	if (callback) callback({
		type,
		payload
	});
}
//#endregion


//# sourceMappingURL=sendToExtension.mjs.map

/***/ }),

/***/ 21084:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ jsonStringify; },
/* harmony export */   "y": function() { return /* binding */ detachToJsonMethod; }
/* harmony export */ });
/* harmony import */ var _utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68272);

//#region src/tools/serialisation/jsonStringify.ts
/**
* Custom implementation of JSON.stringify that ignores some toJSON methods. We need to do that
* because some sites badly override toJSON on certain objects. Removing all toJSON methods from
* nested values would be too costly, so we just detach them from the root value, and native classes
* used to build JSON values (Array and Object).
*
* Note: this still assumes that JSON.stringify is correct.
*/
function jsonStringify(value, replacer, space) {
	if (typeof value !== "object" || value === null) return JSON.stringify(value);
	const restoreObjectPrototypeToJson = detachToJsonMethod(Object.prototype);
	const restoreArrayPrototypeToJson = detachToJsonMethod(Array.prototype);
	const restoreValuePrototypeToJson = detachToJsonMethod(Object.getPrototypeOf(value));
	const restoreValueToJson = detachToJsonMethod(value);
	try {
		return JSON.stringify(value, replacer, space);
	} catch {
		return "<error: unable to serialize object>";
	} finally {
		restoreObjectPrototypeToJson();
		restoreArrayPrototypeToJson();
		restoreValuePrototypeToJson();
		restoreValueToJson();
	}
}
function detachToJsonMethod(value) {
	const object = value;
	const objectToJson = object.toJSON;
	if (objectToJson) {
		delete object.toJSON;
		return () => {
			object.toJSON = objectToJson;
		};
	}
	return _utils_functionUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .noop */ .Z;
}
//#endregion


//# sourceMappingURL=jsonStringify.mjs.map

/***/ }),

/***/ 91635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ computeStackTrace; },
/* harmony export */   "f": function() { return /* binding */ computeStackTraceFromOnErrorMessage; }
/* harmony export */ });
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45880);

//#region src/tools/stackTrace/computeStackTrace.ts
/**
* Cross-browser stack trace computation.
*
* Reference implementation: https://github.com/csnover/TraceKit/blob/04530298073c3823de72deb0b97e7b38ca7bcb59/tracekit.js
*/
const UNKNOWN_FUNCTION = "?";
function computeStackTrace(ex) {
	const stack = [];
	let stackProperty = tryToGetString(ex, "stack");
	const exString = String(ex);
	if (stackProperty?.startsWith(exString)) stackProperty = stackProperty.slice(exString.length);
	if (stackProperty) stackProperty.split("\n").forEach((line) => {
		const stackFrame = parseChromeLine(line) || parseChromeAnonymousLine(line) || parseWinLine(line) || parseGeckoLine(line);
		if (stackFrame) {
			if (!stackFrame.func && stackFrame.line) stackFrame.func = UNKNOWN_FUNCTION;
			stack.push(stackFrame);
		}
	});
	if (stack.length > 0 && isWronglyReportingCustomErrors() && ex instanceof Error) {
		const constructors = [];
		let currentPrototype = ex;
		while ((currentPrototype = Object.getPrototypeOf(currentPrototype)) && isNonNativeClassPrototype(currentPrototype)) {
			const constructorName = currentPrototype.constructor?.name || UNKNOWN_FUNCTION;
			constructors.push(constructorName);
		}
		for (let i = constructors.length - 1; i >= 0 && stack[0]?.func === constructors[i]; i--) stack.shift();
	}
	return {
		message: tryToGetString(ex, "message"),
		name: tryToGetString(ex, "name"),
		stack
	};
}
const fileUrl = "((?:file|https?|blob|chrome-extension|electron|native|eval|webpack|snippet|<anonymous>|\\w+\\.|\\/).*?)";
const filePosition = "(?::(\\d+))";
const CHROME_LINE_RE = new RegExp(`^\\s*at (.*?) ?\\(${fileUrl}${filePosition}?${filePosition}?\\)?\\s*$`, "i");
const CHROME_EVAL_RE = new RegExp(`\\((\\S*)${filePosition}${filePosition}\\)`);
function parseChromeLine(line) {
	const parts = CHROME_LINE_RE.exec(line);
	if (!parts) return;
	const isNative = parts[2]?.indexOf("native") === 0;
	const isEval = parts[2]?.indexOf("eval") === 0;
	const submatch = CHROME_EVAL_RE.exec(parts[2]);
	if (isEval && submatch) {
		parts[2] = submatch[1];
		parts[3] = submatch[2];
		parts[4] = submatch[3];
	}
	return {
		args: isNative ? [parts[2]] : [],
		column: parts[4] ? +parts[4] : void 0,
		func: parts[1] || UNKNOWN_FUNCTION,
		line: parts[3] ? +parts[3] : void 0,
		url: !isNative ? parts[2] : void 0
	};
}
const CHROME_ANONYMOUS_FUNCTION_RE = new RegExp(`^\\s*at\\s*(?:(.*)?(?: @))?\\s*${fileUrl}${filePosition}?${filePosition}??\\s*$`, "i");
function parseChromeAnonymousLine(line) {
	const parts = CHROME_ANONYMOUS_FUNCTION_RE.exec(line);
	if (!parts) return;
	return {
		args: [],
		column: parts[4] ? +parts[4] : void 0,
		func: parts[1] || UNKNOWN_FUNCTION,
		line: parts[3] ? +parts[3] : void 0,
		url: parts[2]
	};
}
const WINJS_LINE_RE = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
function parseWinLine(line) {
	const parts = WINJS_LINE_RE.exec(line);
	if (!parts) return;
	return {
		args: [],
		column: parts[4] ? +parts[4] : void 0,
		func: parts[1] || UNKNOWN_FUNCTION,
		line: +parts[3],
		url: parts[2]
	};
}
const GECKO_LINE_RE = /^\s*(.*?)(?:\((.*?)\))?(?:(?:(?:^|@)((?:file|https?|blob|chrome|webpack|resource|capacitor|\[native).*?|[^@]*bundle|\[wasm code\])(?::(\d+))?(?::(\d+))?)|@)\s*$/i;
const GECKO_EVAL_RE = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
function parseGeckoLine(line) {
	const parts = GECKO_LINE_RE.exec(line);
	if (!parts) return;
	const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
	const submatch = GECKO_EVAL_RE.exec(parts[3]);
	if (isEval && submatch) {
		parts[3] = submatch[1];
		parts[4] = submatch[2];
		parts[5] = void 0;
	}
	return {
		args: parts[2] ? parts[2].split(",") : [],
		column: parts[5] ? +parts[5] : void 0,
		func: parts[1] || UNKNOWN_FUNCTION,
		line: parts[4] ? +parts[4] : void 0,
		url: parts[3]
	};
}
function tryToGetString(candidate, property) {
	return (0,_datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .isIndexableObject */ .sK)(candidate) && typeof candidate[property] === "string" ? candidate[property] : void 0;
}
function computeStackTraceFromOnErrorMessage(messageObj, url, line, column) {
	if (url === void 0) return;
	const { name, message } = tryToParseMessage(messageObj);
	return {
		name,
		message,
		stack: [{
			url,
			column,
			line
		}]
	};
}
const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?([\s\S]*)$/;
function tryToParseMessage(messageObj) {
	let name;
	let message;
	if ({}.toString.call(messageObj) === "[object String]") [, name, message] = ERROR_TYPES_RE.exec(messageObj);
	return {
		name,
		message
	};
}
function isNonNativeClassPrototype(prototype) {
	return String(prototype.constructor).startsWith("class ");
}
let isWronglyReportingCustomErrorsCache;
function isWronglyReportingCustomErrors() {
	if (isWronglyReportingCustomErrorsCache !== void 0) return isWronglyReportingCustomErrorsCache;
	class DatadogTestCustomError extends Error {
		constructor() {
			super();
			this.name = "Error";
		}
	}
	const [customError, nativeError] = [DatadogTestCustomError, Error].map((errConstructor) => new errConstructor());
	isWronglyReportingCustomErrorsCache = isNonNativeClassPrototype(Object.getPrototypeOf(customError)) && nativeError.stack !== customError.stack;
	return isWronglyReportingCustomErrorsCache;
}
//#endregion


//# sourceMappingURL=computeStackTrace.mjs.map

/***/ }),

/***/ 41410:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P3": function() { return /* binding */ toStackTraceString; },
/* harmony export */   "Xp": function() { return /* binding */ createHandlingStack; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; }
/* harmony export */ });
/* harmony import */ var _monitor_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59430);
/* harmony import */ var _computeStackTrace_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91635);


//#region src/tools/stackTrace/handlingStack.ts
/**
* Creates a stacktrace without SDK internal frames.
* Constraints:
* - Has to be called at the utmost position of the call stack.
* - No monitored function should encapsulate it, that is why we need to use callMonitored inside it.
*/
function createHandlingStack(type) {
	/**
	* Skip the two internal frames:
	* - SDK API (console.error, ...)
	* - this function
	* in order to keep only the user calls
	*/
	const internalFramesToSkip = 2;
	const error = new Error(type);
	error.name = "HandlingStack";
	let formattedStack;
	(0,_monitor_mjs__WEBPACK_IMPORTED_MODULE_0__/* .callMonitored */ .L6)(() => {
		const stackTrace = (0,_computeStackTrace_mjs__WEBPACK_IMPORTED_MODULE_1__/* .computeStackTrace */ ._)(error);
		stackTrace.stack = stackTrace.stack.slice(internalFramesToSkip);
		formattedStack = toStackTraceString(stackTrace);
	});
	return formattedStack;
}
function toStackTraceString(stack) {
	let result = formatErrorMessage(stack);
	stack.stack.forEach((frame) => {
		const func = frame.func === "?" ? "<anonymous>" : frame.func;
		const args = frame.args && frame.args.length > 0 ? `(${frame.args.join(", ")})` : "";
		const line = frame.line ? `:${frame.line}` : "";
		const column = frame.line && frame.column ? `:${frame.column}` : "";
		result += `\n  at ${func}${args} @ ${frame.url}${line}${column}`;
	});
	return result;
}
function formatErrorMessage(stack) {
	return `${stack.name || "Error"}: ${stack.message}`;
}
//#endregion


//# sourceMappingURL=handlingStack.mjs.map

/***/ }),

/***/ 39449:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zi": function() { return /* binding */ setInterval; },
/* harmony export */   "cv": function() { return /* binding */ clearInterval; },
/* harmony export */   "gr": function() { return /* binding */ clearTimeout; },
/* harmony export */   "iK": function() { return /* binding */ setTimeout; }
/* harmony export */ });
/* harmony import */ var _monitor_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59430);
/* harmony import */ var _getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23820);
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35262);



//#region src/tools/timer.ts
function setTimeout(callback, delay) {
	return (0,_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)(_datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__/* .globalObject */ .Z, "setTimeout")((0,_monitor_mjs__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearTimeout(timeoutId) {
	(0,_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)(_datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__/* .globalObject */ .Z, "clearTimeout")(timeoutId);
}
function setInterval(callback, delay) {
	return (0,_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)(_datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__/* .globalObject */ .Z, "setInterval")((0,_monitor_mjs__WEBPACK_IMPORTED_MODULE_2__/* .monitor */ .zk)(callback), delay);
}
function clearInterval(timeoutId) {
	(0,_getZoneJsOriginalValue_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getZoneJsOriginalValue */ .I)(_datadog_js_core_util__WEBPACK_IMPORTED_MODULE_1__/* .globalObject */ .Z, "clearInterval")(timeoutId);
}
//#endregion


//# sourceMappingURL=timer.mjs.map

/***/ }),

/***/ 71076:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Of": function() { return /* binding */ isNonEmptyArray; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; }
/* harmony export */ });
/* unused harmony exports mergeArrays, removeDuplicates */
//#region src/tools/utils/arrayUtils.ts
function removeDuplicates(array) {
	const set = /* @__PURE__ */ new Set();
	array.forEach((item) => set.add(item));
	return Array.from(set);
}
function removeItem(array, item) {
	const index = array.indexOf(item);
	if (index >= 0) array.splice(index, 1);
}
function isNonEmptyArray(value) {
	return Array.isArray(value) && value.length > 0;
}
function mergeArrays(current, next) {
	if (!next?.length) return current;
	return current ? current.concat(next) : next;
}
//#endregion


//# sourceMappingURL=arrayUtils.mjs.map

/***/ }),

/***/ 88332:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hi": function() { return /* binding */ ONE_KIBI_BYTE; },
/* harmony export */   "Kb": function() { return /* binding */ concatBuffers; },
/* harmony export */   "X9": function() { return /* binding */ ONE_MEBI_BYTE; },
/* harmony export */   "qt": function() { return /* binding */ computeBytesCount; }
/* harmony export */ });
//#region src/tools/utils/byteUtils.ts
const ONE_KIBI_BYTE = 1024;
const ONE_MEBI_BYTE = 1024 * ONE_KIBI_BYTE;
const HAS_MULTI_BYTES_CHARACTERS = /[^\u0000-\u007F]/;
function computeBytesCount(candidate) {
	if (!HAS_MULTI_BYTES_CHARACTERS.test(candidate)) return candidate.length;
	return new TextEncoder().encode(candidate).length;
}
function concatBuffers(buffers) {
	if (buffers.length === 1) return buffers[0];
	const length = buffers.reduce((total, buffer) => total + buffer.length, 0);
	const result = new Uint8Array(length);
	let offset = 0;
	for (const buffer of buffers) {
		result.set(buffer, offset);
		offset += buffer.length;
	}
	return result;
}
//#endregion


//# sourceMappingURL=byteUtils.mjs.map

/***/ }),

/***/ 68272:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ throttle; },
/* harmony export */   "Z": function() { return /* binding */ noop; }
/* harmony export */ });
/* harmony import */ var _timer_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39449);

//#region src/tools/utils/functionUtils.ts
function throttle(fn, wait, options) {
	const needLeadingExecution = options?.leading !== void 0 ? options.leading : true;
	const needTrailingExecution = options?.trailing !== void 0 ? options.trailing : true;
	let inWaitPeriod = false;
	let pendingExecutionWithParameters;
	let pendingTimeoutId;
	return {
		throttled: (...parameters) => {
			if (inWaitPeriod) {
				pendingExecutionWithParameters = parameters;
				return;
			}
			if (needLeadingExecution) fn(...parameters);
			else pendingExecutionWithParameters = parameters;
			inWaitPeriod = true;
			pendingTimeoutId = (0,_timer_mjs__WEBPACK_IMPORTED_MODULE_0__/* .setTimeout */ .iK)(() => {
				if (needTrailingExecution && pendingExecutionWithParameters) fn(...pendingExecutionWithParameters);
				inWaitPeriod = false;
				pendingExecutionWithParameters = void 0;
			}, wait);
		},
		cancel: () => {
			(0,_timer_mjs__WEBPACK_IMPORTED_MODULE_0__/* .clearTimeout */ .gr)(pendingTimeoutId);
			inWaitPeriod = false;
			pendingExecutionWithParameters = void 0;
		}
	};
}
function noop() {}
//#endregion


//# sourceMappingURL=functionUtils.mjs.map

/***/ }),

/***/ 73368:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NM": function() { return /* binding */ round; },
/* harmony export */   "hj": function() { return /* binding */ isNumber; },
/* harmony export */   "y7": function() { return /* binding */ performDraw; }
/* harmony export */ });
//#region src/tools/utils/numberUtils.ts
/**
* Return true if the draw is successful
*
* @param threshold - Threshold between 0 and 100
*/
function performDraw(threshold) {
	return threshold !== 0 && Math.random() * 100 <= threshold;
}
function round(num, decimals) {
	return +num.toFixed(decimals);
}
function isNumber(value) {
	return typeof value === "number";
}
//#endregion


//# sourceMappingURL=numberUtils.mjs.map

/***/ }),

/***/ 73047:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ tryJsonParse; },
/* harmony export */   "E5": function() { return /* binding */ objectHasValue; },
/* harmony export */   "Q8": function() { return /* binding */ mapValues; },
/* harmony export */   "Qr": function() { return /* binding */ isEmptyObject; },
/* harmony export */   "mv": function() { return /* binding */ shallowClone; }
/* harmony export */ });
/* unused harmony export getConstructorName */
//#region src/tools/utils/objectUtils.ts
const stripDangerousKeys = (key, value) => key === "__proto__" ? void 0 : value;
function tryJsonParse(text) {
	try {
		return JSON.parse(text, stripDangerousKeys);
	} catch {}
}
function shallowClone(object) {
	return { ...object };
}
function objectHasValue(object, value) {
	return Object.keys(object).some((key) => object[key] === value);
}
function isEmptyObject(object) {
	return Object.keys(object).length === 0;
}
function mapValues(object, fn) {
	const newObject = {};
	for (const key of Object.keys(object)) newObject[key] = fn(object[key]);
	return newObject;
}
function getConstructorName(value) {
	try {
		const name = value?.constructor?.name;
		return typeof name === "string" && name ? name : void 0;
	} catch {}
}
//#endregion


//# sourceMappingURL=objectUtils.mjs.map

/***/ }),

/***/ 59343:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TT": function() { return /* binding */ objectValues; },
/* harmony export */   "dF": function() { return /* binding */ findLast; },
/* harmony export */   "qP": function() { return /* binding */ objectEntries; }
/* harmony export */ });
//#region src/tools/utils/polyfills.ts
function findLast(array, predicate) {
	for (let i = array.length - 1; i >= 0; i -= 1) {
		const item = array[i];
		if (predicate(item, i, array)) return item;
	}
}
function objectValues(object) {
	return Object.values(object);
}
function objectEntries(object) {
	return Object.entries(object);
}
//#endregion


//# sourceMappingURL=polyfills.mjs.map

/***/ }),

/***/ 8708:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isServerError; },
/* harmony export */   "u": function() { return /* binding */ tryToClone; }
/* harmony export */ });
//#region src/tools/utils/responseUtils.ts
function isServerError(status) {
	return status >= 500;
}
function tryToClone(response) {
	try {
		return response.clone();
	} catch {
		return;
	}
}
//#endregion


//# sourceMappingURL=responseUtils.mjs.map

/***/ }),

/***/ 25557:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ createValueHistory; }
/* harmony export */ });
/* unused harmony export CLEAR_OLD_VALUES_INTERVAL */
/* harmony import */ var _timer_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39449);
/* harmony import */ var _utils_arrayUtils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71076);
/* harmony import */ var _datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18907);



//#region src/tools/valueHistory.ts
const END_OF_TIMES = Infinity;
const CLEAR_OLD_VALUES_INTERVAL = _datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__/* .ONE_MINUTE */ .yR;
let cleanupHistoriesInterval;
const cleanupTasks = /* @__PURE__ */ new Set();
function cleanupHistories() {
	cleanupTasks.forEach((task) => task());
}
function createValueHistory({ expireDelay, maxEntries }) {
	let entries = [];
	const clearExpiredValues = () => {
		if (!expireDelay) return;
		const oldTimeThreshold = (0,_datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__/* .relativeNow */ ._q)() - expireDelay;
		while (entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold) entries.pop();
	};
	if (expireDelay) {
		if (!cleanupHistoriesInterval) cleanupHistoriesInterval = (0,_timer_mjs__WEBPACK_IMPORTED_MODULE_1__/* .setInterval */ .Zi)(() => cleanupHistories(), CLEAR_OLD_VALUES_INTERVAL);
		cleanupTasks.add(clearExpiredValues);
	}
	/**
	* Add a value to the history associated with a start time. Returns a reference to this newly
	* added entry that can be removed or closed.
	*/
	function add(value, startTime) {
		const entry = {
			value,
			startTime,
			endTime: END_OF_TIMES,
			remove: () => {
				(0,_utils_arrayUtils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .removeItem */ .cl)(entries, entry);
			},
			close: (endTime) => {
				entry.endTime = endTime;
			}
		};
		if (maxEntries && entries.length >= maxEntries) entries.pop();
		entries.unshift(entry);
		return entry;
	}
	/**
	* Return the latest value that was active during `startTime`, or the currently active value
	* if no `startTime` is provided. This method assumes that entries are not overlapping.
	*
	* If `option.returnInactive` is true, returns the value at `startTime` (active or not).
	*/
	function find(startTime = END_OF_TIMES, options = { returnInactive: false }) {
		for (const entry of entries) if (entry.startTime <= startTime) {
			if (options.returnInactive || startTime <= entry.endTime) return entry.value;
			break;
		}
	}
	/**
	* Helper function to close the currently active value, if any. This method assumes that entries
	* are not overlapping.
	*/
	function closeActive(endTime) {
		const latestEntry = entries[0];
		if (latestEntry?.endTime === END_OF_TIMES) latestEntry.close(endTime);
	}
	/**
	* Return all values with an active period overlapping with the duration,
	* or all values that were active during `startTime` if no duration is provided,
	* or all currently active values if no `startTime` is provided.
	*/
	function findAll(startTime = END_OF_TIMES, duration = 0) {
		const endTime = (0,_datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__/* .addDuration */ .WK)(startTime, duration);
		return entries.filter((entry) => entry.startTime <= endTime && startTime <= entry.endTime).map((entry) => entry.value);
	}
	/**
	* Return all entries with an active period overlapping with the duration,
	* or all entries that were active during `startTime` if no duration is provided,
	* or all currently active entries if no `startTime` is provided.
	*/
	function findAllEntries(startTime = END_OF_TIMES, duration = 0) {
		const endTime = (0,_datadog_js_core_time__WEBPACK_IMPORTED_MODULE_0__/* .addDuration */ .WK)(startTime, duration);
		return entries.filter((entry) => entry.startTime <= endTime && startTime <= entry.endTime);
	}
	/**
	* Return all the entries whose start time is equal to the given startTime.
	*/
	function getEntries(startTime) {
		return entries.filter((entry) => entry.startTime === startTime);
	}
	/**
	* Remove all entries from this collection.
	*/
	function reset() {
		entries = [];
	}
	/**
	* Stop internal garbage collection of past entries.
	*/
	function stop() {
		cleanupTasks.delete(clearExpiredValues);
		if (cleanupTasks.size === 0 && cleanupHistoriesInterval) {
			(0,_timer_mjs__WEBPACK_IMPORTED_MODULE_1__/* .clearInterval */ .cv)(cleanupHistoriesInterval);
			cleanupHistoriesInterval = void 0;
		}
	}
	return {
		add,
		find,
		closeActive,
		findAll,
		findAllEntries,
		getEntries,
		reset,
		stop
	};
}
//#endregion


//# sourceMappingURL=valueHistory.mjs.map

/***/ }),

/***/ 57242:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ createBatch; }
});

// UNUSED EXPORTS: MESSAGE_BYTES_LIMIT

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.mjs
var display = __webpack_require__(71930);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/display.mjs
var util_display = __webpack_require__(95323);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/mockable.mjs
var mockable = __webpack_require__(62318);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.mjs
var byteUtils = __webpack_require__(88332);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.mjs
var jsonStringify = __webpack_require__(21084);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.mjs + 1 modules
var httpRequest = __webpack_require__(50434);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.mjs
var polyfills = __webpack_require__(59343);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageMayExitObservable.mjs
var browser_pageMayExitObservable = __webpack_require__(61636);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/encoder.mjs
var tools_encoder = __webpack_require__(65010);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.mjs + 1 modules
var observable = __webpack_require__(5741);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.mjs
var timer = __webpack_require__(39449);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/globalObject.mjs
var globalObject = __webpack_require__(35262);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/entries/time.mjs
var time = __webpack_require__(18907);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/flushController.mjs





//#region src/transport/flushController.ts
/**
* flush automatically, aim to be lower than ALB connection timeout
* to maximize connection reuse.
*/
const FLUSH_DURATION_LIMIT = 30 * time/* ONE_SECOND */.WT;
/**
* When using the SDK in a Worker Environment, we limit the batch size to 1 to ensure it can be sent
* in a single event.
*/
const MESSAGES_LIMIT = globalObject/* isWorkerEnvironment */.j ? 1 : 50;
/**
* Returns a "flush controller", responsible of notifying when flushing a pool of pending data needs
* to happen. The implementation is designed to support both synchronous and asynchronous usages,
* but relies on invariants described in each method documentation to keep a coherent state.
*/
function createFlushController({ pageMayExitObservable }) {
	let forcedFlushReason;
	const prepareUrgentFlushObservable = new observable/* Observable */.y$();
	const pageMayExitSubscription = pageMayExitObservable.subscribe((event) => {
		forcedFlushReason = event.reason;
		try {
			prepareUrgentFlushObservable.notify(event.reason);
		} finally {
			forcedFlushReason = void 0;
		}
		flush(event.reason);
	});
	const flushObservable = new observable/* Observable */.y$(() => () => {
		pageMayExitSubscription.unsubscribe();
	});
	let currentBytesCount = 0;
	let currentMessagesCount = 0;
	function flush(flushReason) {
		if (currentMessagesCount === 0) return;
		const messagesCount = currentMessagesCount;
		const bytesCount = currentBytesCount;
		currentMessagesCount = 0;
		currentBytesCount = 0;
		cancelDurationLimitTimeout();
		flushObservable.notify({
			reason: flushReason,
			messagesCount,
			bytesCount
		});
	}
	let durationLimitTimeoutId;
	function scheduleDurationLimitTimeout() {
		if (durationLimitTimeoutId === void 0) durationLimitTimeoutId = (0,timer/* setTimeout */.iK)(() => {
			flush("duration_limit");
		}, FLUSH_DURATION_LIMIT);
	}
	function cancelDurationLimitTimeout() {
		(0,timer/* clearTimeout */.gr)(durationLimitTimeoutId);
		durationLimitTimeoutId = void 0;
	}
	return {
		flushObservable,
		prepareUrgentFlushObservable,
		forceFlush: flush,
		get messagesCount() {
			return currentMessagesCount;
		},
		/**
		* Notifies that a message will be added to a pool of pending messages waiting to be flushed.
		*
		* This function needs to be called synchronously, right before adding the message, so no flush
		* event can happen after `notifyBeforeAddMessage` and before adding the message.
		*
		* @param estimatedMessageBytesCount - an estimation of the message bytes count once it is
		* actually added.
		*/
		notifyBeforeAddMessage(estimatedMessageBytesCount) {
			if (currentBytesCount + estimatedMessageBytesCount >= httpRequest/* RECOMMENDED_REQUEST_BYTES_LIMIT */.Wj) flush(forcedFlushReason ?? "bytes_limit");
			currentMessagesCount += 1;
			currentBytesCount += estimatedMessageBytesCount;
			scheduleDurationLimitTimeout();
		},
		/**
		* Notifies that a message *was* added to a pool of pending messages waiting to be flushed.
		*
		* This function can be called asynchronously after the message was added, but in this case it
		* should not be called if a flush event occurred in between.
		*
		* @param messageBytesCountDiff - the difference between the estimated message bytes count and
		* its actual bytes count once added to the pool.
		*/
		notifyAfterAddMessage(messageBytesCountDiff = 0) {
			currentBytesCount += messageBytesCountDiff;
			if (currentMessagesCount >= MESSAGES_LIMIT) flush(forcedFlushReason ?? "messages_limit");
			else if (currentBytesCount >= httpRequest/* RECOMMENDED_REQUEST_BYTES_LIMIT */.Wj) flush(forcedFlushReason ?? "bytes_limit");
		}
	};
}
//#endregion


//# sourceMappingURL=flushController.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.mjs









//#region src/transport/batch.ts
const MESSAGE_BYTES_LIMIT = 256 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function createBatch({ encoder = (0,tools_encoder/* createIdentityEncoder */.G)(), endpoints, reportError }) {
	const request = (0,mockable/* mockable */.C)(httpRequest/* createHttpRequest */.UF)(endpoints, reportError);
	const pageMayExitObservable = (0,mockable/* mockable */.C)(browser_pageMayExitObservable/* createPageMayExitObservable */.FP)();
	const flushController = (0,mockable/* mockable */.C)(createFlushController)({ pageMayExitObservable });
	let upsertBuffer = {};
	const flushSubscription = flushController.flushObservable.subscribe((event) => flush(event));
	function push(serializedMessage, estimatedMessageBytesCount, key) {
		if (key !== void 0) {
			let bytesDiff;
			if (upsertBuffer[key] !== void 0) bytesDiff = estimatedMessageBytesCount - encoder.estimateEncodedBytesCount(upsertBuffer[key]);
			else {
				flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
				bytesDiff = 0;
			}
			upsertBuffer[key] = serializedMessage;
			flushController.notifyAfterAddMessage(bytesDiff);
		} else {
			flushController.notifyBeforeAddMessage(estimatedMessageBytesCount);
			encoder.write(encoder.isEmpty ? serializedMessage : `\n${serializedMessage}`, (realMessageBytesCount) => {
				flushController.notifyAfterAddMessage(realMessageBytesCount - estimatedMessageBytesCount);
			});
		}
	}
	function addOrUpdate(message, key) {
		const serializedMessage = (0,jsonStringify/* jsonStringify */.l)(message);
		const estimatedMessageBytesCount = encoder.estimateEncodedBytesCount(serializedMessage);
		if (estimatedMessageBytesCount >= MESSAGE_BYTES_LIMIT) {
			display/* display.warn */.jf.warn(`Discarded a message whose size was bigger than the maximum allowed size ${MESSAGE_BYTES_LIMIT / byteUtils/* ONE_KIBI_BYTE */.Hi}KiB. ${util_display/* MORE_DETAILS */.IA} ${display/* DOCS_TROUBLESHOOTING */.Qo}/#technical-limitations`);
			return;
		}
		push(serializedMessage, estimatedMessageBytesCount, key);
	}
	function flush(event) {
		const upsertMessages = (0,polyfills/* objectValues */.TT)(upsertBuffer).join("\n");
		upsertBuffer = {};
		const pageMightExit = (0,browser_pageMayExitObservable/* isPageExitReason */.PT)(event.reason);
		const send = pageMightExit ? request.sendOnExit : request.send;
		if (pageMightExit && encoder.isAsync) {
			const encoderResult = encoder.finishSync();
			if (encoderResult.outputBytesCount) send(formatPayloadFromEncoder(encoderResult));
			const pendingMessages = [encoderResult.pendingData, upsertMessages].filter(Boolean).join("\n");
			if (pendingMessages) send({
				data: pendingMessages,
				bytesCount: (0,byteUtils/* computeBytesCount */.qt)(pendingMessages)
			});
		} else {
			if (upsertMessages) encoder.write(encoder.isEmpty ? upsertMessages : `\n${upsertMessages}`);
			encoder.finish((encoderResult) => {
				send(formatPayloadFromEncoder(encoderResult));
			});
		}
	}
	return {
		get isEmpty() {
			return flushController.messagesCount === 0;
		},
		add: addOrUpdate,
		upsert: addOrUpdate,
		prepareUrgentFlushObservable: flushController.prepareUrgentFlushObservable,
		forceFlush: flushController.forceFlush,
		flushObservable: flushController.flushObservable,
		stop: flushSubscription.unsubscribe
	};
}
function formatPayloadFromEncoder(encoderResult) {
	let data;
	if (typeof encoderResult.output === "string") data = encoderResult.output;
	else data = new Blob([encoderResult.output], { type: "text/plain" });
	return {
		data,
		bytesCount: encoderResult.outputBytesCount,
		encoding: encoderResult.encoding
	};
}
//#endregion


//# sourceMappingURL=batch.mjs.map

/***/ }),

/***/ 71394:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ad": function() { return /* binding */ getEventBridge; },
/* harmony export */   "BP": function() { return /* binding */ BridgeCapability; },
/* harmony export */   "ke": function() { return /* binding */ bridgeSupports; },
/* harmony export */   "xT": function() { return /* binding */ canUseEventBridge; }
/* harmony export */ });
/* unused harmony export matchesHostEntry */
/* harmony import */ var _tools_display_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71930);
/* harmony import */ var _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35262);


//#region src/transport/eventBridge.ts
let BridgeCapability = /* @__PURE__ */ function(BridgeCapability) {
	BridgeCapability["RECORDS"] = "records";
	BridgeCapability["PROFILES"] = "profiles";
	return BridgeCapability;
}({});
function getEventBridge() {
	const eventBridgeGlobal = getEventBridgeGlobal();
	if (!eventBridgeGlobal) return;
	return {
		getCapabilities() {
			return JSON.parse(eventBridgeGlobal.getCapabilities?.() || "[]");
		},
		getPrivacyLevel() {
			return eventBridgeGlobal.getPrivacyLevel?.();
		},
		getIsTraceSampled() {
			return JSON.parse(eventBridgeGlobal.getIsTraceSampled?.() || "null");
		},
		getAllowedWebViewHosts() {
			return JSON.parse(eventBridgeGlobal.getAllowedWebViewHosts());
		},
		send(eventType, event, viewId) {
			const view = viewId ? { id: viewId } : void 0;
			eventBridgeGlobal.send(JSON.stringify({
				eventType,
				event,
				view
			}));
		}
	};
}
function bridgeSupports(capability) {
	const bridge = getEventBridge();
	return !!bridge && bridge.getCapabilities().includes(capability);
}
function canUseEventBridge(currentHost = _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .globalObject.location */ .Z.location?.hostname) {
	return getEventBridge()?.getAllowedWebViewHosts().some((entry) => matchesHostEntry(currentHost, entry)) ?? false;
}
function matchesHostEntry(host, entry) {
	if (!entry.includes("*")) return host === entry || host.endsWith(`.${entry}`);
	const parts = entry.split("*");
	if (parts.length !== 2) {
		_tools_display_mjs__WEBPACK_IMPORTED_MODULE_1__/* .display.error */ .jf.error(`Invalid WebView host pattern "${entry}": only one wildcard (*) is supported.`);
		return false;
	}
	const [prefix, suffix] = parts;
	return host.length > prefix.length + suffix.length && host.startsWith(prefix) && host.endsWith(suffix);
}
function getEventBridgeGlobal() {
	return _datadog_js_core_util__WEBPACK_IMPORTED_MODULE_0__/* .globalObject.DatadogEventBridge */ .Z.DatadogEventBridge;
}
//#endregion


//# sourceMappingURL=eventBridge.mjs.map

/***/ }),

/***/ 50434:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Wj": function() { return /* binding */ RECOMMENDED_REQUEST_BYTES_LIMIT; },
  "UF": function() { return /* binding */ createHttpRequest; }
});

// UNUSED EXPORTS: fetchStrategy

// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.mjs + 1 modules
var monitor = __webpack_require__(59430);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.mjs + 1 modules
var tools_observable = __webpack_require__(5741);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.mjs
var byteUtils = __webpack_require__(88332);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetch.mjs
var fetch = __webpack_require__(88481);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.mjs
var timer = __webpack_require__(39449);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.mjs
var responseUtils = __webpack_require__(8708);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/entries/time.mjs
var time = __webpack_require__(18907);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/sendWithRetryStrategy.mjs




//#region src/transport/sendWithRetryStrategy.ts
const MAX_ONGOING_BYTES_COUNT = 80 * byteUtils/* ONE_KIBI_BYTE */.Hi;
const MAX_QUEUE_BYTES_COUNT = 20 * byteUtils/* ONE_MEBI_BYTE */.X9;
const MAX_BACKOFF_TIME = time/* ONE_MINUTE */.yR;
const INITIAL_BACKOFF_TIME = time/* ONE_SECOND */.WT;
function sendWithRetryStrategy(payload, state, sendStrategy, trackType, reportError, requestObservable) {
	if (state.transportStatus === 0 && state.queuedPayloads.size() === 0 && state.bandwidthMonitor.canHandle(payload)) send(payload, state, sendStrategy, requestObservable, {
		onSuccess: () => retryQueuedPayloads(0, state, sendStrategy, trackType, reportError, requestObservable),
		onFailure: () => {
			if (!state.queuedPayloads.enqueue(payload)) requestObservable.notify({
				type: "queue-full",
				bandwidth: state.bandwidthMonitor.stats(),
				payload
			});
			scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
		}
	});
	else if (!state.queuedPayloads.enqueue(payload)) requestObservable.notify({
		type: "queue-full",
		bandwidth: state.bandwidthMonitor.stats(),
		payload
	});
}
function scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable) {
	if (state.transportStatus !== 2) return;
	(0,timer/* setTimeout */.iK)(() => {
		send(state.queuedPayloads.first(), state, sendStrategy, requestObservable, {
			onSuccess: () => {
				state.queuedPayloads.dequeue();
				state.currentBackoffTime = INITIAL_BACKOFF_TIME;
				retryQueuedPayloads(1, state, sendStrategy, trackType, reportError, requestObservable);
			},
			onFailure: () => {
				state.currentBackoffTime = Math.min(MAX_BACKOFF_TIME, state.currentBackoffTime * 2);
				scheduleRetry(state, sendStrategy, trackType, reportError, requestObservable);
			}
		});
	}, state.currentBackoffTime);
}
function send(payload, state, sendStrategy, requestObservable, { onSuccess, onFailure }) {
	state.bandwidthMonitor.add(payload);
	sendStrategy(payload, (response) => {
		state.bandwidthMonitor.remove(payload);
		if (!shouldRetryRequest(response)) {
			state.transportStatus = 0;
			requestObservable.notify({
				type: "success",
				bandwidth: state.bandwidthMonitor.stats(),
				payload
			});
			onSuccess();
		} else {
			state.transportStatus = state.bandwidthMonitor.ongoingRequestCount > 0 ? 1 : 2;
			payload.retry = {
				count: payload.retry ? payload.retry.count + 1 : 1,
				lastFailureStatus: response.status
			};
			requestObservable.notify({
				type: "failure",
				bandwidth: state.bandwidthMonitor.stats(),
				payload
			});
			onFailure();
		}
	});
}
function retryQueuedPayloads(reason, state, sendStrategy, trackType, reportError, requestObservable) {
	if (reason === 0 && state.queuedPayloads.isFull() && !state.queueFullReported) {
		reportError(`Reached max ${trackType} events size queued for upload: ${MAX_QUEUE_BYTES_COUNT / byteUtils/* ONE_MEBI_BYTE */.X9}MiB`);
		state.queueFullReported = true;
	}
	const previousQueue = state.queuedPayloads;
	state.queuedPayloads = newPayloadQueue();
	while (previousQueue.size() > 0) sendWithRetryStrategy(previousQueue.dequeue(), state, sendStrategy, trackType, reportError, requestObservable);
}
function shouldRetryRequest(response) {
	return response.type !== "opaque" && (response.status === 0 && !navigator.onLine || response.status === 408 || response.status === 429 || (0,responseUtils/* isServerError */.o)(response.status));
}
function newRetryState() {
	return {
		transportStatus: 0,
		currentBackoffTime: INITIAL_BACKOFF_TIME,
		bandwidthMonitor: newBandwidthMonitor(),
		queuedPayloads: newPayloadQueue(),
		queueFullReported: false
	};
}
function newPayloadQueue() {
	const queue = [];
	return {
		bytesCount: 0,
		enqueue(payload) {
			if (this.isFull()) return false;
			queue.push(payload);
			this.bytesCount += payload.bytesCount;
			return true;
		},
		first() {
			return queue[0];
		},
		dequeue() {
			const payload = queue.shift();
			if (payload) this.bytesCount -= payload.bytesCount;
			return payload;
		},
		size() {
			return queue.length;
		},
		isFull() {
			return this.bytesCount >= MAX_QUEUE_BYTES_COUNT;
		}
	};
}
function newBandwidthMonitor() {
	return {
		ongoingRequestCount: 0,
		ongoingByteCount: 0,
		canHandle(payload) {
			return this.ongoingRequestCount === 0 || this.ongoingByteCount + payload.bytesCount <= MAX_ONGOING_BYTES_COUNT && this.ongoingRequestCount < 32;
		},
		add(payload) {
			this.ongoingRequestCount += 1;
			this.ongoingByteCount += payload.bytesCount;
		},
		remove(payload) {
			this.ongoingRequestCount -= 1;
			this.ongoingByteCount -= payload.bytesCount;
		},
		stats() {
			return {
				ongoingByteCount: this.ongoingByteCount,
				ongoingRequestCount: this.ongoingRequestCount
			};
		}
	};
}
//#endregion


//# sourceMappingURL=sendWithRetryStrategy.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.mjs





//#region src/transport/httpRequest.ts
/**
* beacon payload max queue size implementation is 64kb
* ensure that we leave room for logs, rum and potential other users
*/
const RECOMMENDED_REQUEST_BYTES_LIMIT = 16 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function createHttpRequest(endpointBuilders, reportError, bytesLimit = RECOMMENDED_REQUEST_BYTES_LIMIT) {
	const observable = new tools_observable/* Observable */.y$();
	const retryState = newRetryState();
	return {
		observable,
		send: (payload) => {
			for (const endpointBuilder of endpointBuilders) sendWithRetryStrategy(payload, retryState, (payload, onResponse) => {
				fetchStrategy(endpointBuilder, payload, onResponse);
			}, endpointBuilder.trackType, reportError, observable);
		},
		/**
		* Since fetch keepalive behaves like regular fetch on Firefox,
		* keep using sendBeaconStrategy on exit
		*/
		sendOnExit: (payload) => {
			for (const endpointBuilder of endpointBuilders) sendBeaconStrategy(endpointBuilder, bytesLimit, payload);
		}
	};
}
function sendBeaconStrategy(endpointBuilder, bytesLimit, payload) {
	if (payload.bytesCount < bytesLimit) try {
		const beaconUrl = endpointBuilder.build("beacon", payload);
		if (navigator.sendBeacon(beaconUrl, payload.data)) return;
	} catch (e) {
		reportBeaconError(e);
	}
	fetchStrategy(endpointBuilder, payload);
}
let hasReportedBeaconError = false;
function reportBeaconError(e) {
	if (!hasReportedBeaconError) {
		hasReportedBeaconError = true;
		(0,monitor/* monitorError */.$y)(e);
	}
}
function fetchStrategy(endpointBuilder, payload, onResponse) {
	(0,fetch/* fetch */.h)(endpointBuilder.build("fetch", payload), {
		method: "POST",
		body: payload.data,
		mode: "cors"
	}).then((0,monitor/* monitor */.zk)((response) => onResponse?.({
		status: response.status,
		type: response.type
	}))).catch((0,monitor/* monitor */.zk)(() => onResponse?.({ status: 0 })));
}
//#endregion


//# sourceMappingURL=httpRequest.mjs.map

/***/ }),

/***/ 41305:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xn": function() { return /* reexport */ CENSORED_IMG_MARK; },
  "k6": function() { return /* reexport */ CENSORED_STRING_MARK; },
  "Y5": function() { return /* reexport */ LifeCycleEventType; },
  "zx": function() { return /* reexport */ NodePrivacyLevel; },
  "$n": function() { return /* reexport */ PRIVACY_ATTR_NAME; },
  "nw": function() { return /* reexport */ PRIVACY_ATTR_VALUE_HIDDEN; },
  "D$": function() { return /* reexport */ RumEventType; },
  "wE": function() { return /* reexport */ RumLongTaskEntryType; },
  "uo": function() { return /* reexport */ RumPerformanceEntryType; },
  "$S": function() { return /* reexport */ SessionReplayState; },
  "o8": function() { return /* reexport */ VitalType; },
  "nu": function() { return /* reexport */ computeSessionReplayState; },
  "QB": function() { return /* reexport */ createFormDataTransport; },
  "Uo": function() { return /* reexport */ forEachChildNodes; },
  "q5": function() { return /* reexport */ getMutationObserverConstructor; },
  "IE": function() { return /* reexport */ getNodePrivacyLevel; },
  "SZ": function() { return /* reexport */ getNodeSelfPrivacyLevel; },
  "Ow": function() { return /* reexport */ getParentNode; },
  "$1": function() { return /* reexport */ getScrollX; },
  "X_": function() { return /* reexport */ getScrollY; },
  "Gm": function() { return /* reexport */ getSessionReplayUrl; },
  "FB": function() { return /* reexport */ getTextContent; },
  "PA": function() { return /* reexport */ getViewportDimension; },
  "AX": function() { return /* reexport */ initViewportObservable; },
  "Tv": function() { return /* reexport */ isElementNode; },
  "aT": function() { return /* reexport */ isNodeShadowHost; },
  "VO": function() { return /* reexport */ isNodeShadowRoot; },
  "_r": function() { return /* reexport */ makeRumPublicApi; },
  "Ch": function() { return /* reexport */ reducePrivacyLevel; },
  "Pu": function() { return /* reexport */ sanitizeIfLongDataUrl; },
  "vv": function() { return /* reexport */ shouldMaskAttribute; },
  "gR": function() { return /* reexport */ shouldMaskNode; }
});

// UNUSED EXPORTS: ActionType, DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE, DEFAULT_TRACKED_RESOURCE_HEADERS, FORM_PRIVATE_TAG_NAMES, FrustrationType, LifeCycle, PRIVACY_ATTR_VALUE_ALLOW, PRIVACY_ATTR_VALUE_MASK, PRIVACY_ATTR_VALUE_MASK_UNLESS_ALLOWLISTED, PRIVACY_ATTR_VALUE_MASK_USER_INPUT, PRIVACY_CLASS_PREFIX, STABLE_ATTRIBUTES, TEXT_MASKING_CHAR, censorText, createHooks, getParentElement, getPrivacySelector, hasChildNodes, isAllowlisted, isCommentNode, isTextNode, maskDisallowedTextContent, shouldIgnoreElement, startRum, startViewHistory, supportPerformanceTimingEvent

;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/rawRumEvent.types.mjs
//#region src/rawRumEvent.types.ts
const RumEventType = {
	ACTION: "action",
	ERROR: "error",
	LONG_TASK: "long_task",
	VIEW: "view",
	VIEW_UPDATE: "view_update",
	RESOURCE: "resource",
	VITAL: "vital"
};
const RumLongTaskEntryType = {
	LONG_TASK: "long-task",
	LONG_ANIMATION_FRAME: "long-animation-frame"
};
const ViewLoadingType = {
	INITIAL_LOAD: "initial_load",
	ROUTE_CHANGE: "route_change",
	SESSION_RENEWAL: "session_renewal",
	BF_CACHE: "bf_cache"
};
const ActionType = {
	CLICK: "click",
	CUSTOM: "custom",
	TAP: "tap",
	SCROLL: "scroll",
	SWIPE: "swipe",
	APPLICATION_START: "application_start",
	BACK: "back"
};
const FrustrationType = {
	RAGE_CLICK: "rage_click",
	ERROR_CLICK: "error_click",
	DEAD_CLICK: "dead_click"
};
const VitalType = {
	DURATION: "duration",
	OPERATION_STEP: "operation_step"
};
//#endregion


//# sourceMappingURL=rawRumEvent.types.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/extractRegexMatch.mjs
//#region src/domain/extractRegexMatch.ts
/**
* Executes a RegExp against a string and returns the first capture group, or the full match if
* there is no capture group. Returns undefined when the pattern does not match.
*/
function extractRegexMatch(candidate, extractor) {
	extractor.lastIndex = 0;
	const regexResult = extractor.exec(candidate);
	if (!regexResult) return;
	const [match, capture] = regexResult;
	return capture ? capture : match;
}
//#endregion


//# sourceMappingURL=extractRegexMatch.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/jsonPathParser.mjs
//#region src/domain/configuration/jsonPathParser.ts
/**
* Extract selectors from a simple JSON path expression, return [] for an invalid path
*
* Supports:
* - Dot notation: `foo.bar.baz`
* - Bracket notation: `['foo']["bar"]`
* - Array indices: `items[0]`, `data['users'][1]`
*
* Examples:
* parseJsonPath("['foo'].bar[12]")
* => ['foo', 'bar', '12']
*
* parseJsonPath("['foo")
* => []
*/
function parseJsonPath(path) {
	const selectors = [];
	let previousToken = 0;
	let currentToken;
	const parsingContext = {
		quote: void 0,
		escapeSequence: void 0
	};
	let currentSelector = "";
	for (const char of path) {
		currentToken = ALLOWED_NEXT_TOKENS[previousToken].find((token) => TOKEN_PREDICATE[token](char, parsingContext));
		if (!currentToken) return [];
		if (parsingContext.escapeSequence !== void 0 && currentToken !== 12) {
			if (!isValidEscapeSequence(parsingContext.escapeSequence)) return [];
			currentSelector += resolveEscapeSequence(parsingContext.escapeSequence);
			parsingContext.escapeSequence = void 0;
		}
		if (ALLOWED_SELECTOR_TOKENS.includes(currentToken)) currentSelector += char;
		else if (ALLOWED_SELECTOR_DELIMITER_TOKENS.includes(currentToken) && currentSelector !== "") {
			selectors.push(currentSelector);
			currentSelector = "";
		} else if (currentToken === 12) parsingContext.escapeSequence = parsingContext.escapeSequence ? `${parsingContext.escapeSequence}${char}` : char;
		else if (currentToken === 8) parsingContext.quote = char;
		else if (currentToken === 9) parsingContext.quote = void 0;
		previousToken = currentToken;
	}
	if (!ALLOWED_NEXT_TOKENS[previousToken].includes(1)) return [];
	if (currentSelector !== "") selectors.push(currentSelector);
	return selectors;
}
const NAME_SHORTHAND_FIRST_CHAR_REGEX = /[a-zA-Z_$]/;
const NAME_SHORTHAND_CHAR_REGEX = /[a-zA-Z0-9_$]/;
const DIGIT_REGEX = /[0-9]/;
const UNICODE_CHAR_REGEX = /[a-fA-F0-9]/;
const QUOTE_CHARS = "'\"";
const TOKEN_PREDICATE = {
	[0]: () => false,
	[1]: () => false,
	[2]: (char) => NAME_SHORTHAND_FIRST_CHAR_REGEX.test(char),
	[3]: (char) => NAME_SHORTHAND_CHAR_REGEX.test(char),
	[4]: (char) => char === ".",
	[5]: (char) => char === "[",
	[6]: (char) => char === "]",
	[7]: (char) => DIGIT_REGEX.test(char),
	[8]: (char) => QUOTE_CHARS.includes(char),
	[9]: (char, parsingContext) => char === parsingContext.quote,
	[10]: () => true,
	[11]: (char) => char === "\\",
	[12]: (char, parsingContext) => {
		if (parsingContext.escapeSequence === void 0) return `${parsingContext.quote}/\\bfnrtu`.includes(char);
		else if (parsingContext.escapeSequence.startsWith("u") && parsingContext.escapeSequence.length < 5) return UNICODE_CHAR_REGEX.test(char);
		return false;
	}
};
const ALLOWED_NEXT_TOKENS = {
	[0]: [2, 5],
	[1]: [],
	[2]: [
		3,
		4,
		5,
		1
	],
	[3]: [
		3,
		4,
		5,
		1
	],
	[4]: [2],
	[5]: [8, 7],
	[6]: [
		4,
		5,
		1
	],
	[7]: [7, 6],
	[8]: [
		11,
		9,
		10
	],
	[9]: [6],
	[10]: [
		11,
		9,
		10
	],
	[11]: [12],
	[12]: [
		12,
		11,
		9,
		10
	]
};
const ALLOWED_SELECTOR_TOKENS = [
	2,
	3,
	7,
	10
];
const ALLOWED_SELECTOR_DELIMITER_TOKENS = [
	4,
	5,
	6
];
function isValidEscapeSequence(escapeSequence) {
	return "\"'/\\bfnrt".includes(escapeSequence) || escapeSequence.startsWith("u") && escapeSequence.length === 5;
}
const ESCAPED_CHARS = {
	"\"": "\"",
	"'": "'",
	"/": "/",
	"\\": "\\",
	b: "\b",
	f: "\f",
	n: "\n",
	r: "\r",
	t: "	"
};
function resolveEscapeSequence(escapeSequence) {
	if (escapeSequence.startsWith("u")) return String.fromCharCode(parseInt(escapeSequence.slice(1), 16));
	return ESCAPED_CHARS[escapeSequence];
}
//#endregion


//# sourceMappingURL=jsonPathParser.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/entries/time.mjs
var entries_time = __webpack_require__(18907);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/objectUtils.mjs
var objectUtils = __webpack_require__(73047);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/remoteConfigurationCache.mjs


const CACHE_KEY_PREFIX = "dd_rc_";
const CACHE_STATUS_TO_METRIC_MAP = {
	hit: "success",
	miss: "missing",
	error: "failure"
};
function buildCacheKey(remoteConfigurationId) {
	return `${CACHE_KEY_PREFIX}${remoteConfigurationId}`;
}
function isValidCacheEntry(value) {
	if (typeof value !== "object" || value === null) return false;
	const hasVersion = "version" in value && value.version === 2;
	const hasConfig = "config" in value && typeof value.config === "object" && value.config !== null;
	return hasVersion && hasConfig;
}
function createConfigurationCache({ remoteConfigurationId }) {
	const key = buildCacheKey(remoteConfigurationId);
	return {
		read() {
			let raw;
			try {
				raw = localStorage.getItem(key);
			} catch {
				return { status: "error" };
			}
			if (raw === null) return { status: "miss" };
			const parsed = (0,objectUtils/* tryJsonParse */.Cy)(raw);
			if (parsed === void 0) {
				this.remove();
				return { status: "error" };
			}
			if (!isValidCacheEntry(parsed)) {
				this.remove();
				return { status: "error" };
			}
			return {
				status: "hit",
				config: parsed.config
			};
		},
		remove() {
			try {
				localStorage.removeItem(key);
			} catch {}
		},
		write(config) {
			const entry = {
				version: 2,
				config,
				fetchedAt: (0,entries_time/* timeStampNow */.n$)()
			};
			try {
				localStorage.setItem(key, JSON.stringify(entry));
			} catch {}
		}
	};
}
//#endregion


//# sourceMappingURL=remoteConfigurationCache.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/typeUtils.mjs
var typeUtils = __webpack_require__(45880);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/display.mjs
var display = __webpack_require__(71930);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/telemetry/telemetry.mjs + 1 modules
var telemetry_telemetry = __webpack_require__(51034);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/stringUtils.mjs
//#region src/tools/utils/stringUtils.ts
/**
* UUID v4
* from https://gist.github.com/jed/982883
*/
function generateUUID(placeholder) {
	return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : `10000000-1000-4000-8000-100000000000`.replace(/[018]/g, generateUUID);
}
const COMMA_SEPARATED_KEY_VALUE = /(\S+?)\s*=\s*(.*?)(?:;|$)/g;
/**
* Returns the value of the key with the given name
* If there are multiple values with the same key, returns the first one
*/
function findCommaSeparatedValue(rawString, name) {
	COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
	while (true) {
		const match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
		if (match) {
			if (match[1] === name) return match[2];
		} else break;
	}
}
/**
* Returns a map of all the values with the given key
* If there are multiple values with the same key, returns all the values
*/
function findAllCommaSeparatedValues(rawString) {
	const result = /* @__PURE__ */ new Map();
	COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
	while (true) {
		const match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
		if (match) {
			const key = match[1];
			const value = match[2];
			if (result.has(key)) result.get(key).push(value);
			else result.set(key, [value]);
		} else break;
	}
	return result;
}
/**
* Returns a map of the values with the given key
* ⚠️ If there are multiple values with the same key, returns the LAST one
*
* @deprecated use `findAllCommaSeparatedValues()` instead
*/
function findCommaSeparatedValues(rawString) {
	const result = /* @__PURE__ */ new Map();
	COMMA_SEPARATED_KEY_VALUE.lastIndex = 0;
	while (true) {
		const match = COMMA_SEPARATED_KEY_VALUE.exec(rawString);
		if (match) result.set(match[1], match[2]);
		else break;
	}
	return result;
}
function safeTruncate(candidate, length, suffix = "") {
	const lastChar = candidate.charCodeAt(length - 1);
	const correctedLength = lastChar >= 55296 && lastChar <= 56319 ? length + 1 : length;
	if (candidate.length <= correctedLength) return candidate;
	return `${candidate.slice(0, correctedLength)}${suffix}`;
}
//#endregion


//# sourceMappingURL=stringUtils.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/globalObject.mjs
var globalObject = __webpack_require__(35262);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/urlPolyfill.mjs
var urlPolyfill = __webpack_require__(56140);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookie.mjs



//#region src/browser/cookie.ts
function setCookie(name, value, expireDelay = 0, options) {
	const date = /* @__PURE__ */ new Date();
	date.setTime(date.getTime() + expireDelay);
	const expires = `expires=${date.toUTCString()}`;
	const sameSite = options?.crossSite ? "none" : "strict";
	const domain = options?.domain ? `;domain=${options.domain}` : "";
	const secure = options?.secure ? ";secure" : "";
	const partitioned = options?.partitioned ? ";partitioned" : "";
	document.cookie = `${name}=${value};${expires};path=/;samesite=${sameSite}${domain}${secure}${partitioned}`;
}
/**
* Returns the value of the cookie with the given name
* If there are multiple cookies with the same name, returns the first one
*/
function getCookie(name) {
	const value = findCommaSeparatedValue(document.cookie, name);
	if (value === "") return;
	return value;
}
/**
* Returns all the values of the cookies with the given name
*/
function getCookies(name) {
	return findAllCommaSeparatedValues(document.cookie).get(name) || [];
}
let initCookieParsed;
/**
* Returns a cached value of the cookie. Use this during SDK initialization (and whenever possible)
* to avoid accessing document.cookie multiple times.
*
* ⚠️ If there are multiple cookies with the same name, returns the LAST one (unlike `getCookie()`)
*/
function getInitCookie(name) {
	if (!initCookieParsed) initCookieParsed = findCommaSeparatedValues(document.cookie);
	return initCookieParsed.get(name);
}
function resetInitCookies() {
	initCookieParsed = void 0;
}
function deleteCookie(name, options) {
	setCookie(name, "", 0, options);
}
/**
* No API to retrieve it, number of levels for subdomain and suffix are unknown
* strategy: find the minimal domain on which cookies are allowed to be set
* https://web.dev/same-site-same-origin/#site
*/
let getCurrentSiteCache;
function getCurrentSite(hostname = globalObject/* globalObject.location */.Z.location?.hostname ?? "", referrer = typeof document !== "undefined" ? document.referrer : "") {
	if (typeof document === "undefined") return;
	if (getCurrentSiteCache === void 0) {
		const defaultHostName = getCookieDefaultHostName(hostname, referrer);
		if (defaultHostName) {
			const testCookieName = `dd_site_test_${generateUUID()}`;
			const testCookieValue = "test";
			const domainLevels = defaultHostName.split(".");
			let candidateDomain = domainLevels.pop();
			while (domainLevels.length && !getCookie(testCookieName)) {
				candidateDomain = `${domainLevels.pop()}.${candidateDomain}`;
				setCookie(testCookieName, testCookieValue, entries_time/* ONE_SECOND */.WT, { domain: candidateDomain });
			}
			deleteCookie(testCookieName, { domain: candidateDomain });
			getCurrentSiteCache = candidateDomain;
		}
	}
	return getCurrentSiteCache;
}
function getCookieDefaultHostName(hostname, referrer) {
	try {
		return hostname || (0,urlPolyfill/* buildUrl */.Q2)(referrer).hostname;
	} catch {}
}
function buildCookieOptions(configuration) {
	const cookieOptions = {};
	cookieOptions.secure = configuration.useSecureSessionCookie || configuration.usePartitionedCrossSiteSessionCookie;
	cookieOptions.crossSite = configuration.usePartitionedCrossSiteSessionCookie;
	cookieOptions.partitioned = configuration.usePartitionedCrossSiteSessionCookie;
	if (configuration.trackSessionAcrossSubdomains) {
		const currentSite = getCurrentSite();
		if (!currentSite) return;
		cookieOptions.domain = currentSite;
	}
	return cookieOptions;
}
//#endregion


//# sourceMappingURL=cookie.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetch.mjs
var fetch = __webpack_require__(88481);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/monitor.mjs + 1 modules
var monitor = __webpack_require__(59430);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/transport/endpointBuilder.mjs
var endpointBuilder = __webpack_require__(39464);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/remoteConfiguration.mjs






//#region src/domain/configuration/remoteConfiguration.ts
const REMOTE_CONFIGURATION_VERSION = "v1";
const SUPPORTED_RUM_FIELDS = [
	"applicationId",
	"service",
	"env",
	"version",
	"sessionSampleRate",
	"sessionReplaySampleRate",
	"telemetrySampleRate",
	"trackAnonymousUser",
	"trackUserInteractions",
	"trackResources",
	"trackLongTasks",
	"traceContextInjection",
	"actionNameAttribute",
	"defaultPrivacyLevel",
	"enablePrivacyForActionName",
	"traceSampleRate",
	"trackSessionAcrossSubdomains",
	"allowedTracingUrls",
	"allowedTrackingOrigins"
];
async function fetchAndApplyRemoteConfiguration(initConfiguration, supportedContextManagers) {
	let rumInitConfiguration;
	const metrics = initMetrics();
	const fetchResult = await fetchRemoteConfiguration(initConfiguration);
	if (!fetchResult.ok) {
		metrics.increment("fetch", "failure");
		display/* display.error */.jf.error(fetchResult.error);
	} else {
		metrics.increment("fetch", "success");
		rumInitConfiguration = applyRemoteConfiguration(initConfiguration, fetchResult.value, supportedContextManagers, metrics);
	}
	(0,telemetry_telemetry/* addTelemetryMetrics */.qZ)(telemetry_telemetry/* TelemetryMetrics.REMOTE_CONFIGURATION_METRIC_NAME */.T.REMOTE_CONFIGURATION_METRIC_NAME, { metrics: metrics.get() });
	return rumInitConfiguration;
}
function applyRemoteConfiguration(initConfiguration, remoteConfiguration, supportedContextManagers, metrics) {
	const appliedConfiguration = { ...initConfiguration };
	if (remoteConfiguration.rum) {
		const rumRemoteConfiguration = remoteConfiguration.rum;
		SUPPORTED_RUM_FIELDS.forEach((option) => {
			if (option in rumRemoteConfiguration) appliedConfiguration[option] = resolveConfigurationProperty(rumRemoteConfiguration[option]);
		});
		Object.keys(supportedContextManagers).forEach((context) => {
			if (rumRemoteConfiguration[context] !== void 0) resolveContextProperty(supportedContextManagers[context], rumRemoteConfiguration[context]);
		});
	}
	if (remoteConfiguration.profiling?.sampleRate !== void 0) appliedConfiguration.profilingSampleRate = remoteConfiguration.profiling.sampleRate;
	return appliedConfiguration;
	function resolveConfigurationProperty(property) {
		if (Array.isArray(property)) return property.map(resolveConfigurationProperty);
		if ((0,typeUtils/* isIndexableObject */.sK)(property)) {
			if (isSerializedOption(property)) {
				const type = property.rcSerializedType;
				switch (type) {
					case "string": return property.value;
					case "regex": return resolveRegex(property.value);
					case "dynamic": return resolveDynamicOption(property);
					default:
						display/* display.error */.jf.error(`Unsupported remote configuration: "rcSerializedType": "${type}"`);
						return;
				}
			}
			return (0,objectUtils/* mapValues */.Q8)(property, resolveConfigurationProperty);
		}
		return property;
	}
	function resolveContextProperty(contextManager, contextItems) {
		contextItems.forEach(({ key, value }) => {
			contextManager.setContextProperty(key, resolveConfigurationProperty(value));
		});
	}
	function resolveDynamicOption(property) {
		const strategy = property.strategy;
		let resolvedValue;
		switch (strategy) {
			case "cookie":
				resolvedValue = resolveCookieValue(property);
				break;
			case "dom":
				resolvedValue = resolveDomValue(property);
				break;
			case "js":
				resolvedValue = resolveJsValue(property);
				break;
			case "localStorage":
				resolvedValue = resolveLocalStorageValue(property);
				break;
			default:
				display/* display.error */.jf.error(`Unsupported remote configuration: "strategy": "${strategy}"`);
				return;
		}
		const extractor = property.extractor;
		if (extractor !== void 0 && typeof resolvedValue === "string") return extractValue(extractor, resolvedValue);
		return resolvedValue;
	}
	function resolveCookieValue({ name }) {
		const value = getCookie(name);
		metrics.increment("cookie", value !== void 0 ? "success" : "missing");
		return value;
	}
	function resolveLocalStorageValue({ key }) {
		let value;
		try {
			value = localStorage.getItem(key);
		} catch {
			metrics.increment("localStorage", "failure");
			return;
		}
		metrics.increment("localStorage", value !== null ? "success" : "missing");
		return value ?? void 0;
	}
	function resolveDomValue({ selector, attribute }) {
		let element;
		try {
			element = document.querySelector(selector);
		} catch {
			display/* display.error */.jf.error(`Invalid selector in the remote configuration: '${selector}'`);
			metrics.increment("dom", "failure");
			return;
		}
		if (!element) {
			metrics.increment("dom", "missing");
			return;
		}
		if (isForbidden(element, attribute)) {
			display/* display.error */.jf.error(`Forbidden element selected by the remote configuration: '${selector}'`);
			metrics.increment("dom", "failure");
			return;
		}
		const domValue = attribute !== void 0 ? element.getAttribute(attribute) : element.textContent;
		if (domValue === null) {
			metrics.increment("dom", "missing");
			return;
		}
		metrics.increment("dom", "success");
		return domValue;
	}
	function isForbidden(element, attribute) {
		return element.getAttribute("type") === "password" && attribute === "value";
	}
	function resolveJsValue({ path }) {
		let current = window;
		const pathParts = parseJsonPath(path);
		if (pathParts.length === 0) {
			display/* display.error */.jf.error(`Invalid JSON path in the remote configuration: '${path}'`);
			metrics.increment("js", "failure");
			return;
		}
		for (const pathPart of pathParts) {
			if (!(pathPart in current)) {
				metrics.increment("js", "missing");
				return;
			}
			try {
				current = current[pathPart];
			} catch (e) {
				display/* display.error */.jf.error(`Error accessing: '${path}'`, e);
				metrics.increment("js", "failure");
				return;
			}
		}
		metrics.increment("js", "success");
		return current;
	}
}
function initMetrics() {
	const metrics = { fetch: {} };
	return {
		get: () => metrics,
		increment: (metricName, type) => {
			if (!metrics[metricName]) metrics[metricName] = {};
			if (!metrics[metricName][type]) metrics[metricName][type] = 0;
			metrics[metricName][type] = metrics[metricName][type] + 1;
		}
	};
}
function isSerializedOption(value) {
	return "rcSerializedType" in value;
}
function resolveRegex(pattern) {
	try {
		return new RegExp(pattern);
	} catch {
		display/* display.error */.jf.error(`Invalid regex in the remote configuration: '${pattern}'`);
	}
}
function extractValue(extractor, candidate) {
	const resolvedExtractor = resolveRegex(extractor.value);
	if (resolvedExtractor === void 0) return;
	return extractRegexMatch(candidate, resolvedExtractor);
}
async function fetchRemoteConfiguration(configuration) {
	let response;
	try {
		response = await (0,fetch/* fetch */.h)(buildEndpoint(configuration));
	} catch {
		response = void 0;
	}
	if (!response?.ok) return {
		ok: false,
		error: /* @__PURE__ */ new Error("Error fetching the remote configuration.")
	};
	const remoteConfiguration = await response.json();
	if (remoteConfiguration.rum || remoteConfiguration.profiling) return {
		ok: true,
		value: remoteConfiguration
	};
	return {
		ok: false,
		error: /* @__PURE__ */ new Error("No remote configuration for RUM.")
	};
}
function getRemoteConfigurationId(configuration) {
	return configuration.remoteConfiguration?.id ?? configuration.remoteConfigurationId;
}
function buildEndpoint(configuration) {
	if (configuration.remoteConfigurationProxy) return configuration.remoteConfigurationProxy;
	const id = getRemoteConfigurationId(configuration);
	return (0,endpointBuilder/* buildEndpointUrl */.lp)({
		site: configuration.site,
		path: `/${REMOTE_CONFIGURATION_VERSION}/${encodeURIComponent(id)}.json`,
		subdomain: "sdk-configuration"
	});
}
function doBackgroundCacheSync(initConfiguration, cache, metrics) {
	fetchRemoteConfiguration(initConfiguration).then((fetchResult) => {
		if (!fetchResult.ok) {
			metrics.increment("fetch", "failure");
			display/* display.error */.jf.error(fetchResult.error);
		} else {
			metrics.increment("fetch", "success");
			cache.write(fetchResult.value);
		}
	}).catch(monitor/* monitorError */.$y).finally(() => {
		(0,telemetry_telemetry/* addTelemetryMetrics */.qZ)(telemetry_telemetry/* TelemetryMetrics.REMOTE_CONFIGURATION_METRIC_NAME */.T.REMOTE_CONFIGURATION_METRIC_NAME, { metrics: metrics.get() });
	});
}
function getRemoteConfiguration(initConfiguration, supportedContextManagers) {
	const configurationCache = createConfigurationCache({ remoteConfigurationId: getRemoteConfigurationId(initConfiguration) });
	const metrics = initMetrics();
	const cacheResult = configurationCache.read();
	metrics.increment("cache", CACHE_STATUS_TO_METRIC_MAP[cacheResult.status]);
	doBackgroundCacheSync(initConfiguration, configurationCache, metrics);
	if (cacheResult.status === "hit") return applyRemoteConfiguration(initConfiguration, cacheResult.config, supportedContextManagers, metrics);
	if (initConfiguration.remoteConfiguration?.required) return;
	return initConfiguration;
}
//#endregion


//# sourceMappingURL=remoteConfiguration.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/observable.mjs + 1 modules
var tools_observable = __webpack_require__(5741);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/trackingConsent.mjs

//#region src/domain/trackingConsent.ts
const TrackingConsent = {
	GRANTED: "granted",
	NOT_GRANTED: "not-granted"
};
function createTrackingConsentState(currentConsent) {
	const observable = new tools_observable/* Observable */.y$();
	function isGranted() {
		return currentConsent === TrackingConsent.GRANTED;
	}
	return {
		tryToInit(trackingConsent) {
			if (!currentConsent) currentConsent = trackingConsent;
		},
		onGrantedOnce(fn) {
			if (isGranted()) fn();
			else {
				const subscription = observable.subscribe(() => {
					if (isGranted()) {
						fn();
						subscription.unsubscribe();
					}
				});
			}
		},
		update(trackingConsent) {
			currentConsent = trackingConsent;
			observable.notify();
		},
		isGranted,
		observable
	};
}
//#endregion


//# sourceMappingURL=trackingConsent.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/transport/intakeSites.mjs
var intakeSites = __webpack_require__(94174);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/configuration/configuration.mjs


//#region src/domain/configuration/configuration.ts
/**
* Default privacy level for the browser SDK.
*
* [Replay Privacy Options](https://docs.datadoghq.com/real_user_monitoring/session_replay/browser/privacy_options) for further information.
*/
const DefaultPrivacyLevel = {
	ALLOW: "allow",
	MASK: "mask",
	MASK_USER_INPUT: "mask-user-input",
	MASK_UNLESS_ALLOWLISTED: "mask-unless-allowlisted"
};
/**
* Trace context injection option.
*
* See [Connect RUM and Traces](https://docs.datadoghq.com/real_user_monitoring/platform/connect_rum_and_traces/?tab=browserrum) for further information.
*/
const TraceContextInjection = {
	ALL: "all",
	SAMPLED: "sampled"
};
const BROWSER_CORE_SCHEMA = {
	clientToken: {
		type: "string",
		required: true
	},
	service: { type: "string" },
	env: { type: "string" },
	version: { type: "string" },
	site: {
		type: "site",
		default: intakeSites/* INTAKE_SITE_US1 */.D_
	},
	proxy: {
		type: "union",
		variants: [{ type: "string" }, {
			type: "function",
			signature: void 0
		}]
	},
	sessionSampleRate: {
		type: "percentage",
		default: 100
	},
	telemetrySampleRate: {
		type: "percentage",
		default: 20
	},
	telemetryConfigurationSampleRate: {
		type: "percentage",
		default: 5
	},
	telemetryUsageSampleRate: {
		type: "percentage",
		default: 5
	},
	silentMultipleInit: {
		type: "boolean",
		default: false,
		strict: false
	},
	storeContextsAcrossPages: {
		type: "boolean",
		default: false,
		strict: false
	},
	trackAnonymousUser: {
		type: "boolean",
		default: true,
		strict: false
	},
	useSecureSessionCookie: {
		type: "boolean",
		default: false,
		strict: false
	},
	usePartitionedCrossSiteSessionCookie: {
		type: "boolean",
		default: false,
		strict: false
	},
	trackSessionAcrossSubdomains: {
		type: "boolean",
		default: false,
		strict: false
	},
	allowedTrackingOrigins: {
		type: "match-option",
		multiple: true,
		strict: false
	},
	trackingConsent: {
		type: "enum",
		values: TrackingConsent,
		default: TrackingConsent.GRANTED
	},
	beforeSend: {
		type: "function",
		signature: void 0
	},
	source: {
		type: "enum",
		values: [
			"browser",
			"flutter",
			"unity"
		],
		default: "browser",
		strict: false
	},
	sessionPersistence: {
		type: "enum",
		values: [
			"cookie",
			"local-storage",
			"memory"
		],
		multiple: true,
		strict: false
	},
	replica: {
		type: "schema",
		schema: {
			clientToken: {
				type: "string",
				required: true
			},
			applicationId: { type: "string" }
		}
	},
	datacenter: { type: "string" },
	sdkVersion: { type: "string" },
	variant: { type: "string" }
};
function serializeConfiguration(initConfiguration) {
	return {
		session_sample_rate: initConfiguration.sessionSampleRate,
		telemetry_sample_rate: initConfiguration.telemetrySampleRate,
		telemetry_configuration_sample_rate: initConfiguration.telemetryConfigurationSampleRate,
		telemetry_usage_sample_rate: initConfiguration.telemetryUsageSampleRate,
		use_before_send: !!initConfiguration.beforeSend,
		use_partitioned_cross_site_session_cookie: initConfiguration.usePartitionedCrossSiteSessionCookie,
		use_secure_session_cookie: initConfiguration.useSecureSessionCookie,
		use_proxy: !!initConfiguration.proxy,
		silent_multiple_init: initConfiguration.silentMultipleInit,
		track_session_across_subdomains: initConfiguration.trackSessionAcrossSubdomains,
		track_anonymous_user: initConfiguration.trackAnonymousUser,
		session_persistence: Array.isArray(initConfiguration.sessionPersistence) ? initConfiguration.sessionPersistence[0] : initConfiguration.sessionPersistence,
		store_contexts_across_pages: !!initConfiguration.storeContextsAcrossPages,
		allow_untrusted_events: !!initConfiguration.allowUntrustedEvents,
		tracking_consent: initConfiguration.trackingConsent,
		use_allowed_tracking_origins: Array.isArray(initConfiguration.allowedTrackingOrigins),
		source: initConfiguration.source,
		sdk_version: initConfiguration.sdkVersion,
		variant: initConfiguration.variant
	};
}
//#endregion


//# sourceMappingURL=configuration.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/catchUserErrors.mjs
var catchUserErrors = __webpack_require__(84124);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/numberUtils.mjs
var numberUtils = __webpack_require__(73368);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/arrayUtils.mjs
var arrayUtils = __webpack_require__(71076);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/mergeInto.mjs
var mergeInto = __webpack_require__(91303);
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/util/display.mjs
var util_display = __webpack_require__(95323);
;// CONCATENATED MODULE: ./node_modules/@datadog/js-core/esm/entries/configuration.mjs



//#region src/entries/configuration.ts
function buildErrorMessage(key, field) {
	switch (field.type) {
		case "string": return `"${key}" must be a non-empty string`;
		case "percentage": return `"${key}" must be a number between 0 and 100`;
		case "boolean": return `"${key}" must be a boolean`;
		case "site": return `"${key}" must be a valid Datadog site. ${util_display/* MORE_DETAILS */.IA} ${util_display/* DOCS_ORIGIN */.aA}/getting_started/site/.`;
		case "match-option": return `"${key}" must be a string, RegExp, or function`;
		case "enum": return `"${key}" must be one of: "${getEnumValues(field.values).join("\", \"")}"`;
		case "union": return `"${key}" does not match any expected type`;
		case "schema": return `"${key}" is not a valid object`;
		case "function": return `"${key}" must be a function`;
	}
}
/**
* Validates a raw init configuration object against a {@link ConfigurationSchema} and builds
* the corresponding {@link InferredConfig}. Use this to derive a schema-driven configuration
* builder for a package (e.g. `validateAndBuildRumConfiguration`) instead of writing
* per-field validation by hand.
*
* @param initConfig - The raw, untrusted configuration object provided by the SDK consumer.
* @param schema - The {@link ConfigurationSchema} describing every field to validate.
* @param display - Optional error reporter; when provided, validation failures are reported
* through `display.error` with a message naming the offending field.
* @returns The validated, defaulted configuration, or `undefined` if `initConfig` is missing
* or a required/strict field failed validation.
*/
function validateAndBuildConfiguration(initConfig, schema, display) {
	if (!initConfig || typeof initConfig !== "object") {
		display.error("Configuration must be an object");
		return;
	}
	return validateSchemaFields(schema, initConfig, display);
}
/**
* Validates every field of `schema` against `rawConfig`. Shared by {@link validateAndBuildConfiguration}
* and nested `type: 'schema'` field validation. `display` is threaded down into nested fields
* (`type: 'schema'`, `type: 'union'`, `multiple: true`) so a nested validation failure reports
* its own specific message, in addition to the outer field's generic message.
*/
function validateSchemaFields(schema, rawConfig, display) {
	const result = {};
	for (const [key, field] of Object.entries(schema)) {
		const rawValue = rawConfig[key];
		const validated = field.multiple ? validateArrayField(field, rawValue, display) : validateField(field, rawValue, display);
		if (validated === void 0) {
			if (rawValue !== void 0 && rawValue !== null && rawValue !== "") {
				display.error(buildErrorMessage(key, field));
				if (field.required || field.strict !== false) return;
			} else if (field.required) {
				display.error(`"${key}" is required`);
				return;
			}
			result[key] = "default" in field ? (0,mergeInto/* deepClone */.I8)(field.default) : void 0;
		} else result[key] = validated;
	}
	return result;
}
function validateArrayField(field, value, display) {
	if (value === void 0 || value === null) return;
	if (field.type === "enum" && field.allowAll && value === "all") return getEnumValues(field.values).slice();
	const items = Array.isArray(value) ? value : [value];
	const results = [];
	for (const item of items) {
		const validated = validateField(field, item, display);
		if (validated === void 0) {
			if (field.strict !== false) return;
		} else results.push(validated);
	}
	if (field.strict === false && results.length === 0 && items.length > 0) return;
	return results;
}
const DATADOG_SITE_REGEX = /(datadog|ddog|datad0g|dd0g)/;
function validateField(field, value, display) {
	if (field.type === "schema") {
		if (typeof value !== "object" || value === null) return;
		return validateSchemaFields(field.schema, value, display);
	}
	if (field.type === "union") {
		if (value === void 0 || value === null) return;
		for (const variant of field.variants) {
			const result = validateField(variant, value, display);
			if (result !== void 0) return result;
		}
		return;
	}
	if (value === void 0 || value === null) return;
	switch (field.type) {
		case "function": return typeof value === "function" ? value : void 0;
		case "string": return typeof value === "string" && value.length > 0 ? value : void 0;
		case "percentage": return (0,typeUtils/* isPercentage */.zz)(value) ? value : void 0;
		case "boolean": return typeof value === "boolean" ? value : field.strict === false ? !!value : void 0;
		case "site":
			if (typeof value !== "string" || !DATADOG_SITE_REGEX.test(value)) return;
			return value;
		case "match-option": return (0,typeUtils/* isMatchOption */.o)(value) ? value : void 0;
		case "enum": return typeof value === "string" && getEnumValues(field.values).includes(value) ? value : void 0;
	}
}
function getEnumValues(values) {
	return isReadonlyStringArray(values) ? values : Object.values(values);
}
function isReadonlyStringArray(value) {
	return Array.isArray(value);
}
//#endregion


//# sourceMappingURL=configuration.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/configuration.mjs




//#region src/domain/configuration/configuration.ts
const DEFAULT_PROPAGATOR_TYPES = ["tracecontext", "datadog"];
/**
* Default list of headers collected on resource events when {@link RumInitConfiguration.trackResourceHeaders | trackResourceHeaders}
* is set to `true`. Re-exported by the `@datadog/browser-rum` and `@datadog/browser-rum-slim` packages, and exposed on the
* `DD_RUM` global object when the SDK is loaded via the CDN, so it can be referenced when building a custom matcher list.
*
* @example NPM
* ```ts
* import { datadogRum, DEFAULT_TRACKED_RESOURCE_HEADERS } from '@datadog/browser-rum'
*
* datadogRum.init({
*   // ...
*   trackResourceHeaders: [
*     ...DEFAULT_TRACKED_RESOURCE_HEADERS.map((name) => ({ name })),
*     { name: 'x-request-id' },
*   ],
* })
* ```
* @example CDN
* ```ts
* DD_RUM.init({
*   // ...
*   trackResourceHeaders: [
*     ...DD_RUM.DEFAULT_TRACKED_RESOURCE_HEADERS.map((name) => ({ name })),
*     { name: 'x-request-id' },
*   ],
* })
* ```
*/
const DEFAULT_TRACKED_RESOURCE_HEADERS = [
	"cache-control",
	"etag",
	"age",
	"expires",
	"content-type",
	"content-encoding",
	"vary",
	"content-length",
	"server-timing",
	"x-cache",
	"cf-cache-status",
	"x-vercel-cache"
];
const RUM_SCHEMA = {
	...BROWSER_CORE_SCHEMA,
	applicationId: {
		type: "string",
		required: true
	},
	actionNameAttribute: { type: "string" },
	workerUrl: { type: "string" },
	subdomain: { type: "string" },
	sessionReplaySampleRate: {
		type: "percentage",
		default: 0
	},
	traceSampleRate: {
		type: "percentage",
		default: 100
	},
	profilingSampleRate: {
		type: "percentage",
		default: 0
	},
	compressIntakeRequests: {
		type: "boolean",
		default: false
	},
	trackUserInteractions: {
		type: "boolean",
		default: true,
		strict: false
	},
	trackResources: {
		type: "boolean",
		default: true,
		strict: false
	},
	trackLongTasks: {
		type: "boolean",
		default: true,
		strict: false
	},
	trackViewsManually: {
		type: "boolean",
		default: false,
		strict: false
	},
	betaEnableViewUpdates: {
		type: "boolean",
		default: false
	},
	betaTrackWebSockets: {
		type: "boolean",
		default: false,
		strict: false
	},
	enablePrivacyForActionName: {
		type: "boolean",
		default: true
	},
	propagateTraceBaggage: {
		type: "boolean",
		default: true
	},
	startSessionReplayRecordingManually: {
		type: "boolean",
		default: false,
		strict: false
	},
	defaultPrivacyLevel: {
		type: "enum",
		values: DefaultPrivacyLevel,
		default: DefaultPrivacyLevel.MASK_USER_INPUT,
		strict: false
	},
	traceContextInjection: {
		type: "enum",
		values: TraceContextInjection,
		default: TraceContextInjection.SAMPLED,
		strict: false
	},
	excludedActivityUrls: {
		type: "match-option",
		multiple: true,
		default: []
	},
	allowedTracingUrls: {
		type: "union",
		multiple: true,
		strict: false,
		default: [],
		variants: [{ type: "match-option" }, {
			type: "schema",
			schema: {
				match: {
					type: "match-option",
					required: true
				},
				propagatorTypes: {
					type: "enum",
					values: [
						"datadog",
						"b3",
						"b3multi",
						"tracecontext"
					],
					multiple: true,
					strict: false,
					default: DEFAULT_PROPAGATOR_TYPES
				}
			}
		}]
	},
	plugins: {
		type: "schema",
		multiple: true,
		strict: false,
		default: [],
		schema: {
			name: {
				type: "string",
				required: true
			},
			getConfigurationTelemetry: {
				type: "function",
				strict: false,
				signature: void 0
			},
			onInit: {
				type: "function",
				strict: false,
				signature: void 0
			},
			onRumStart: {
				type: "function",
				strict: false,
				signature: void 0
			}
		}
	},
	trackFeatureFlagsForEvents: {
		type: "enum",
		values: [
			"vital",
			"action",
			"long_task",
			"resource"
		],
		multiple: true,
		strict: false,
		default: []
	}
};
function validateAndBuildRumConfiguration(initConfiguration) {
	const config = validateAndBuildConfiguration(initConfiguration, RUM_SCHEMA, display/* display */.jf);
	if (!config) return;
	const allowedTracingUrls = config.allowedTracingUrls.map(normalizeTracingOption).filter(Boolean);
	if (allowedTracingUrls.length > 0 && !config.service) {
		display/* display.error */.jf.error("Service needs to be configured when tracing is enabled");
		return;
	}
	return {
		...config,
		allowedTracingUrls,
		beforeSend: config.beforeSend ? (0,catchUserErrors/* catchUserErrors */.Z)(config.beforeSend, "beforeSend threw an error:") : void 0,
		rulePsr: (0,numberUtils/* isNumber */.hj)(initConfiguration.traceSampleRate) ? initConfiguration.traceSampleRate / 100 : void 0,
		trackResourceHeaders: validateAndBuildTrackResourceHeaders(initConfiguration),
		allowedGraphQlUrls: validateAndBuildGraphQlOptions(initConfiguration),
		remoteConfigurationId: getRemoteConfigurationId(initConfiguration)
	};
}
/**
* Combines the selected tracing propagators from the different options in allowedTracingUrls
*/
function getSelectedTracingPropagators(configuration) {
	const usedTracingPropagators = /* @__PURE__ */ new Set();
	if ((0,arrayUtils/* isNonEmptyArray */.Of)(configuration.allowedTracingUrls)) configuration.allowedTracingUrls.forEach((option) => {
		normalizeTracingOption(option)?.propagatorTypes.forEach((propagatorType) => usedTracingPropagators.add(propagatorType));
	});
	return Array.from(usedTracingPropagators);
}
function normalizeTracingOption(option) {
	if ((0,typeUtils/* isMatchOption */.o)(option)) return {
		match: option,
		propagatorTypes: DEFAULT_PROPAGATOR_TYPES
	};
	if ((0,typeUtils/* isIndexableObject */.sK)(option) && (0,typeUtils/* isMatchOption */.o)(option.match) && (option.propagatorTypes === null || option.propagatorTypes === void 0 || Array.isArray(option.propagatorTypes))) return {
		match: option.match,
		propagatorTypes: option.propagatorTypes || DEFAULT_PROPAGATOR_TYPES
	};
}
/**
* Build GraphQL options from configuration
*/
function validateAndBuildGraphQlOptions(initConfiguration) {
	if (!initConfiguration.allowedGraphQlUrls) return [];
	if (!Array.isArray(initConfiguration.allowedGraphQlUrls)) {
		display/* display.warn */.jf.warn("allowedGraphQlUrls should be an array");
		return [];
	}
	const graphQlOptions = [];
	initConfiguration.allowedGraphQlUrls.forEach((option) => {
		if ((0,typeUtils/* isMatchOption */.o)(option)) graphQlOptions.push({
			match: option,
			trackPayload: false,
			trackResponseErrors: false
		});
		else if ((0,typeUtils/* isIndexableObject */.sK)(option) && (0,typeUtils/* isMatchOption */.o)(option.match)) graphQlOptions.push({
			match: option.match,
			trackPayload: !!option.trackPayload,
			trackResponseErrors: !!option.trackResponseErrors
		});
	});
	return graphQlOptions;
}
const VALID_HEADER_LOCATIONS = [
	"request",
	"response",
	"any"
];
function validateAndBuildTrackResourceHeaders(initConfiguration) {
	const option = initConfiguration.trackResourceHeaders;
	if (option === void 0 || option === false) return [];
	if (option === true) return DEFAULT_TRACKED_RESOURCE_HEADERS.map((name) => ({ name }));
	if (!Array.isArray(option)) {
		display/* display.warn */.jf.warn("trackResourceHeaders should be true or an array of MatchHeader");
		return [];
	}
	if (option.length === 0) {
		display/* display.warn */.jf.warn("trackResourceHeaders is an empty array, no headers will be captured");
		return [];
	}
	const result = [];
	option.forEach((item, index) => {
		if (!(0,typeUtils/* isIndexableObject */.sK)(item) || !(0,typeUtils/* isMatchOption */.o)(item.name)) {
			display/* display.warn */.jf.warn(`trackResourceHeaders[${index}] should be a MatchHeader object with a 'name' property`);
			return;
		}
		if (item.url !== void 0 && !(0,typeUtils/* isMatchOption */.o)(item.url)) {
			display/* display.warn */.jf.warn(`trackResourceHeaders[${index}].url should be a MatchOption`);
			return;
		}
		if (item.extractor !== void 0 && !(item.extractor instanceof RegExp)) {
			display/* display.warn */.jf.warn(`trackResourceHeaders[${index}].extractor should be a RegExp`);
			return;
		}
		if (item.location !== void 0 && !VALID_HEADER_LOCATIONS.includes(item.location)) {
			display/* display.warn */.jf.warn(`trackResourceHeaders[${index}].location should be 'request', 'response', or 'any'`);
			return;
		}
		result.push({
			...item,
			name: typeof item.name === "string" ? item.name.toLowerCase() : item.name
		});
	});
	return result;
}
function hasGraphQlPayloadTracking(allowedGraphQlUrls) {
	return (0,arrayUtils/* isNonEmptyArray */.Of)(allowedGraphQlUrls) && allowedGraphQlUrls.some((option) => (0,typeUtils/* isIndexableObject */.sK)(option) && option.trackPayload);
}
function hasGraphQlResponseErrorsTracking(allowedGraphQlUrls) {
	return (0,arrayUtils/* isNonEmptyArray */.Of)(allowedGraphQlUrls) && allowedGraphQlUrls.some((option) => (0,typeUtils/* isIndexableObject */.sK)(option) && option.trackResponseErrors);
}
function getTrackResourceHeadersTelemetryValue(trackResourceHeaders) {
	if (trackResourceHeaders === true) return "default_headers";
	if (Array.isArray(trackResourceHeaders)) return "custom";
}
function serializeRumConfiguration(configuration) {
	const baseSerializedConfiguration = serializeConfiguration(configuration);
	return {
		session_replay_sample_rate: configuration.sessionReplaySampleRate,
		start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
		trace_sample_rate: configuration.traceSampleRate,
		trace_context_injection: configuration.traceContextInjection,
		propagate_trace_baggage: configuration.propagateTraceBaggage,
		action_name_attribute: configuration.actionNameAttribute,
		use_allowed_tracing_urls: (0,arrayUtils/* isNonEmptyArray */.Of)(configuration.allowedTracingUrls),
		use_allowed_graph_ql_urls: (0,arrayUtils/* isNonEmptyArray */.Of)(configuration.allowedGraphQlUrls),
		use_track_graph_ql_payload: hasGraphQlPayloadTracking(configuration.allowedGraphQlUrls),
		use_track_graph_ql_response_errors: hasGraphQlResponseErrorsTracking(configuration.allowedGraphQlUrls),
		selected_tracing_propagators: getSelectedTracingPropagators(configuration),
		default_privacy_level: configuration.defaultPrivacyLevel,
		enable_privacy_for_action_name: configuration.enablePrivacyForActionName,
		use_excluded_activity_urls: (0,arrayUtils/* isNonEmptyArray */.Of)(configuration.excludedActivityUrls),
		use_worker_url: !!configuration.workerUrl,
		compress_intake_requests: configuration.compressIntakeRequests,
		track_views_manually: configuration.trackViewsManually,
		track_user_interactions: configuration.trackUserInteractions,
		track_resources: configuration.trackResources,
		track_long_task: configuration.trackLongTasks,
		plugins: configuration.plugins?.map((plugin) => ({
			name: plugin.name,
			...plugin.getConfigurationTelemetry?.()
		})),
		track_feature_flags_for_events: configuration.trackFeatureFlagsForEvents,
		remote_configuration_id: getRemoteConfigurationId(configuration),
		profiling_sample_rate: configuration.profilingSampleRate,
		use_remote_configuration_proxy: !!configuration.remoteConfigurationProxy,
		track_resource_headers: getTrackResourceHeadersTelemetryValue(configuration.trackResourceHeaders),
		beta_enable_view_updates: configuration.betaEnableViewUpdates,
		beta_track_web_sockets: configuration.betaTrackWebSockets,
		...baseSerializedConfiguration
	};
}
//#endregion


//# sourceMappingURL=configuration.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/configuration/index.mjs





// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/getZoneJsOriginalValue.mjs
var getZoneJsOriginalValue = __webpack_require__(23820);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/functionUtils.mjs
var functionUtils = __webpack_require__(68272);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/domMutationObservable.mjs

//#region src/browser/domMutationObservable.ts
function createDOMMutationObservable() {
	const MutationObserver = getMutationObserverConstructor();
	return new tools_observable/* Observable */.y$((observable) => {
		const observer = new MutationObserver((0,monitor/* monitor */.zk)((records) => observable.notify(records)));
		observer.observe(document, {
			attributes: true,
			characterData: true,
			childList: true,
			subtree: true
		});
		return () => observer.disconnect();
	});
}
function getMutationObserverConstructor() {
	let constructor;
	const browserWindow = window;
	if (browserWindow.Zone) {
		constructor = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(browserWindow, "MutationObserver");
		if (browserWindow.MutationObserver && constructor === browserWindow.MutationObserver) constructor = (0,getZoneJsOriginalValue/* getZoneJsOriginalValue */.I)(new browserWindow.MutationObserver(functionUtils/* noop */.Z), "originalInstance")?.constructor;
	}
	if (!constructor) constructor = browserWindow.MutationObserver;
	return constructor;
}
//#endregion


//# sourceMappingURL=domMutationObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/abstractLifeCycle.mjs
//#region src/tools/abstractLifeCycle.ts
var AbstractLifeCycle = class {
	constructor() {
		this.callbacks = {};
	}
	notify(eventType, data) {
		const eventCallbacks = this.callbacks[eventType];
		if (eventCallbacks) eventCallbacks.forEach((callback) => callback(data));
	}
	subscribe(eventType, callback) {
		if (!this.callbacks[eventType]) this.callbacks[eventType] = [];
		this.callbacks[eventType].push(callback);
		return { unsubscribe: () => {
			this.callbacks[eventType] = this.callbacks[eventType].filter((other) => callback !== other);
		} };
	}
};
//#endregion


//# sourceMappingURL=abstractLifeCycle.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/lifeCycle.mjs

//#region src/domain/lifeCycle.ts
let LifeCycleEventType = /* @__PURE__ */ function(LifeCycleEventType) {
	LifeCycleEventType[LifeCycleEventType["AUTO_ACTION_COMPLETED"] = 0] = "AUTO_ACTION_COMPLETED";
	LifeCycleEventType[LifeCycleEventType["BEFORE_VIEW_CREATED"] = 1] = "BEFORE_VIEW_CREATED";
	LifeCycleEventType[LifeCycleEventType["VIEW_CREATED"] = 2] = "VIEW_CREATED";
	LifeCycleEventType[LifeCycleEventType["BEFORE_VIEW_UPDATED"] = 3] = "BEFORE_VIEW_UPDATED";
	LifeCycleEventType[LifeCycleEventType["VIEW_UPDATED"] = 4] = "VIEW_UPDATED";
	LifeCycleEventType[LifeCycleEventType["VIEW_ENDED"] = 5] = "VIEW_ENDED";
	LifeCycleEventType[LifeCycleEventType["AFTER_VIEW_ENDED"] = 6] = "AFTER_VIEW_ENDED";
	LifeCycleEventType[LifeCycleEventType["REQUEST_STARTED"] = 7] = "REQUEST_STARTED";
	LifeCycleEventType[LifeCycleEventType["REQUEST_COMPLETED"] = 8] = "REQUEST_COMPLETED";
	LifeCycleEventType[LifeCycleEventType["WEBSOCKET_COMPLETED"] = 9] = "WEBSOCKET_COMPLETED";
	LifeCycleEventType[LifeCycleEventType["SESSION_EXPIRED"] = 10] = "SESSION_EXPIRED";
	LifeCycleEventType[LifeCycleEventType["SESSION_RENEWED"] = 11] = "SESSION_RENEWED";
	LifeCycleEventType[LifeCycleEventType["PREPARE_URGENT_FLUSH"] = 12] = "PREPARE_URGENT_FLUSH";
	LifeCycleEventType[LifeCycleEventType["RAW_RUM_EVENT_COLLECTED"] = 13] = "RAW_RUM_EVENT_COLLECTED";
	LifeCycleEventType[LifeCycleEventType["RUM_EVENT_COLLECTED"] = 14] = "RUM_EVENT_COLLECTED";
	LifeCycleEventType[LifeCycleEventType["RAW_ERROR_COLLECTED"] = 15] = "RAW_ERROR_COLLECTED";
	LifeCycleEventType[LifeCycleEventType["ACTION_STARTED"] = 16] = "ACTION_STARTED";
	LifeCycleEventType[LifeCycleEventType["DURATION_VITAL_STARTED"] = 17] = "DURATION_VITAL_STARTED";
	return LifeCycleEventType;
}({});
const LifeCycle = AbstractLifeCycle;
//#endregion


//# sourceMappingURL=lifeCycle.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionConstants.mjs
var sessionConstants = __webpack_require__(78532);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/valueHistory.mjs
var valueHistory = __webpack_require__(25557);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/viewHistory.mjs


//#region src/domain/contexts/viewHistory.ts
const VIEW_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
function startViewHistory(lifeCycle) {
	const viewValueHistory = (0,valueHistory/* createValueHistory */.p)({ expireDelay: VIEW_CONTEXT_TIME_OUT_DELAY });
	lifeCycle.subscribe(1, (view) => {
		viewValueHistory.add(buildViewHistoryEntry(view), view.startClocks.relative);
	});
	lifeCycle.subscribe(6, ({ endClocks }) => {
		viewValueHistory.closeActive(endClocks.relative);
	});
	lifeCycle.subscribe(3, (viewUpdate) => {
		const currentView = viewValueHistory.find(viewUpdate.startClocks.relative);
		if (!currentView) return;
		if (viewUpdate.name) currentView.name = viewUpdate.name;
		if (viewUpdate.context) currentView.context = viewUpdate.context;
		currentView.sessionIsActive = viewUpdate.sessionIsActive;
	});
	lifeCycle.subscribe(11, () => {
		viewValueHistory.reset();
	});
	function buildViewHistoryEntry(view) {
		return {
			service: view.service,
			version: view.version,
			context: view.context,
			id: view.id,
			name: view.name,
			startClocks: view.startClocks
		};
	}
	return {
		findView: (startTime, options) => viewValueHistory.find(startTime, options),
		stop: () => {
			viewValueHistory.stop();
		}
	};
}
//#endregion


//# sourceMappingURL=viewHistory.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/resourceUtils.mjs
//#region src/domain/resourceUtils.ts
const ResourceType = {
	DOCUMENT: "document",
	XHR: "xhr",
	BEACON: "beacon",
	FETCH: "fetch",
	CSS: "css",
	JS: "js",
	IMAGE: "image",
	FONT: "font",
	MEDIA: "media",
	WEBSOCKET: "websocket",
	OTHER: "other"
};
const RequestType = {
	FETCH: ResourceType.FETCH,
	XHR: ResourceType.XHR
};
//#endregion


//# sourceMappingURL=resourceUtils.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/experimentalFeatures.mjs
var experimentalFeatures = __webpack_require__(70234);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceUtils.mjs




//#region src/domain/resource/resourceUtils.ts
const RESOURCE_TYPES = [
	[ResourceType.DOCUMENT, (initiatorType) => "navigation" === initiatorType],
	[ResourceType.XHR, (initiatorType) => "xmlhttprequest" === initiatorType],
	[ResourceType.FETCH, (initiatorType) => "fetch" === initiatorType],
	[ResourceType.BEACON, (initiatorType) => "beacon" === initiatorType],
	[ResourceType.CSS, (_, path) => /\.css$/i.test(path)],
	[ResourceType.JS, (_, path) => /\.js$/i.test(path)],
	[ResourceType.IMAGE, (initiatorType, path) => [
		"image",
		"img",
		"icon"
	].includes(initiatorType) || /\.(gif|jpg|jpeg|tiff|png|svg|ico)$/i.exec(path) !== null],
	[ResourceType.FONT, (_, path) => /\.(woff|eot|woff2|ttf)$/i.exec(path) !== null],
	[ResourceType.MEDIA, (initiatorType, path) => ["audio", "video"].includes(initiatorType) || /\.(mp3|mp4)$/i.exec(path) !== null]
];
function computeResourceEntryType(entry) {
	const url = entry.name;
	if (!(0,urlPolyfill/* isValidUrl */.jv)(url)) return ResourceType.OTHER;
	const path = (0,urlPolyfill/* getPathName */.ye)(url);
	for (const [type, isType] of RESOURCE_TYPES) if (isType(entry.initiatorType, path)) return type;
	return ResourceType.OTHER;
}
function areInOrder(...numbers) {
	for (let i = 1; i < numbers.length; i += 1) if (numbers[i - 1] > numbers[i]) return false;
	return true;
}
function isResourceEntryRequestType(entry) {
	return entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch";
}
function computeResourceEntryDuration(entry) {
	const { duration, startTime, responseEnd } = entry;
	if (entry.initiatorType === "navigation" || duration === 0 && startTime < responseEnd) return (0,entries_time/* elapsed */._J)(startTime, responseEnd);
	return duration;
}
function computeResourceEntryDetails(entry) {
	if (!hasValidResourceEntryTimings(entry)) return;
	const { startTime, fetchStart, workerStart, redirectStart, redirectEnd, domainLookupStart, domainLookupEnd, connectStart, secureConnectionStart, connectEnd, requestStart, responseStart, responseEnd } = entry;
	const details = {
		download: formatTiming(startTime, responseStart, responseEnd),
		first_byte: formatTiming(startTime, requestStart, responseStart)
	};
	if (0 < workerStart && workerStart < fetchStart) details.worker = formatTiming(startTime, workerStart, fetchStart);
	if (fetchStart < connectEnd) {
		details.connect = formatTiming(startTime, connectStart, connectEnd);
		if (connectStart <= secureConnectionStart && secureConnectionStart <= connectEnd) details.ssl = formatTiming(startTime, secureConnectionStart, connectEnd);
	}
	if (fetchStart < domainLookupEnd) details.dns = formatTiming(startTime, domainLookupStart, domainLookupEnd);
	if (startTime < redirectEnd) details.redirect = formatTiming(startTime, redirectStart, redirectEnd);
	return details;
}
/**
* Entries with negative duration are unexpected and should be dismissed. The intake will ignore RUM
* Resource events with negative durations anyway.
* Since Chromium 128, more entries have unexpected negative durations, see
* https://issues.chromium.org/issues/363031537
*/
function hasValidResourceEntryDuration(entry) {
	return entry.duration >= 0;
}
function hasValidResourceEntryTimings(entry) {
	const areCommonTimingsInOrder = areInOrder(entry.startTime, entry.fetchStart, entry.domainLookupStart, entry.domainLookupEnd, entry.connectStart, entry.connectEnd, entry.requestStart, entry.responseStart, entry.responseEnd);
	const areRedirectionTimingsInOrder = hasRedirection(entry) ? areInOrder(entry.startTime, entry.redirectStart, entry.redirectEnd, entry.fetchStart) : true;
	return areCommonTimingsInOrder && areRedirectionTimingsInOrder;
}
function hasRedirection(entry) {
	return entry.redirectEnd > entry.startTime;
}
function formatTiming(origin, start, end) {
	if (origin <= start && start <= end) return {
		duration: (0,entries_time/* toServerDuration */.dg)((0,entries_time/* elapsed */._J)(start, end)),
		start: (0,entries_time/* toServerDuration */.dg)((0,entries_time/* elapsed */._J)(origin, start))
	};
}
/**
* The 'nextHopProtocol' is an empty string for cross-origin resources without CORS headers,
* meaning the protocol is unknown, and we shouldn't report it.
* https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/nextHopProtocol#cross-origin_resources
*/
function computeResourceEntryProtocol(entry) {
	return entry.nextHopProtocol === "" ? void 0 : entry.nextHopProtocol;
}
/**
* Handles the 'deliveryType' property to distinguish between supported values ('cache', 'navigational-prefetch'),
* undefined (unsupported in some browsers), and other cases ('other' for unknown or unrecognized values).
* see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
*/
function computeResourceEntryDeliveryType(entry) {
	return entry.deliveryType === "" ? "other" : entry.deliveryType;
}
function computeResourceEntrySize(entry) {
	if (entry.startTime < entry.responseStart) {
		const { encodedBodySize, decodedBodySize, transferSize } = entry;
		return {
			size: decodedBodySize,
			encoded_body_size: encodedBodySize,
			decoded_body_size: decodedBodySize,
			transfer_size: transferSize
		};
	}
	return {
		size: void 0,
		encoded_body_size: void 0,
		decoded_body_size: void 0,
		transfer_size: void 0
	};
}
function isAllowedRequestUrl(url) {
	return url && (!(0,intakeSites/* isIntakeUrl */.iU)(url) || (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.TRACK_INTAKE_REQUESTS */.uh.TRACK_INTAKE_REQUESTS));
}
const DATA_URL_REGEX = /data:(.+)?(;base64)?,/g;
const MAX_RESOURCE_VALUE_CHAR_LENGTH = 24e3;
function sanitizeIfLongDataUrl(url, lengthLimit = MAX_RESOURCE_VALUE_CHAR_LENGTH) {
	if (url.length <= lengthLimit || !url.startsWith("data:")) return url;
	const dataUrlMatchArray = url.substring(0, 100).match(DATA_URL_REGEX);
	if (!dataUrlMatchArray) return url;
	return `${dataUrlMatchArray[0]}[...]`;
}
//#endregion


//# sourceMappingURL=resourceUtils.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/htmlDomUtils.mjs
//#region src/browser/htmlDomUtils.ts
function isTextNode(node) {
	return node.nodeType === Node.TEXT_NODE;
}
function isCommentNode(node) {
	return node.nodeType === Node.COMMENT_NODE;
}
function isElementNode(node) {
	return node.nodeType === Node.ELEMENT_NODE;
}
function isNodeShadowHost(node) {
	return isElementNode(node) && Boolean(node.shadowRoot);
}
function isNodeShadowRoot(node) {
	const shadowRoot = node;
	return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
function hasChildNodes(node) {
	return node.childNodes.length > 0 || isNodeShadowHost(node);
}
function forEachChildNodes(node, callback) {
	let child = node.firstChild;
	while (child) {
		callback(child);
		child = child.nextSibling;
	}
	if (isNodeShadowHost(node)) callback(node.shadowRoot);
}
/**
* Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
*/
function getParentNode(node) {
	return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
/**
* Return the parent element, crossing shadow DOM boundaries.
* If the element is a direct child of a shadow root, returns the shadow host.
*/
function getParentElement(element) {
	if (element.parentElement) return element.parentElement;
	const parentNode = element.parentNode;
	if (parentNode && isNodeShadowRoot(parentNode)) return parentNode.host;
	return null;
}
//#endregion


//# sourceMappingURL=htmlDomUtils.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/timer.mjs
var timer = __webpack_require__(39449);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/addEventListener.mjs
var addEventListener = __webpack_require__(54265);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/performanceObservable.mjs


//#region src/browser/performanceObservable.ts
let RumPerformanceEntryType = /* @__PURE__ */ function(RumPerformanceEntryType) {
	RumPerformanceEntryType["EVENT"] = "event";
	RumPerformanceEntryType["FIRST_INPUT"] = "first-input";
	RumPerformanceEntryType["LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
	RumPerformanceEntryType["LAYOUT_SHIFT"] = "layout-shift";
	RumPerformanceEntryType["LONG_TASK"] = "longtask";
	RumPerformanceEntryType["LONG_ANIMATION_FRAME"] = "long-animation-frame";
	RumPerformanceEntryType["NAVIGATION"] = "navigation";
	RumPerformanceEntryType["PAINT"] = "paint";
	RumPerformanceEntryType["RESOURCE"] = "resource";
	RumPerformanceEntryType["VISIBILITY_STATE"] = "visibility-state";
	return RumPerformanceEntryType;
}({});
function createPerformanceObservable(options) {
	return new tools_observable/* Observable */.y$((observable) => {
		const handlePerformanceEntries = (entries) => {
			const rumPerformanceEntries = filterRumPerformanceEntries(entries);
			if (rumPerformanceEntries.length > 0) observable.notify(rumPerformanceEntries);
		};
		let timeoutId;
		let isObserverInitializing = true;
		const observer = new PerformanceObserver((0,monitor/* monitor */.zk)((entries) => {
			if (isObserverInitializing) timeoutId = (0,timer/* setTimeout */.iK)(() => handlePerformanceEntries(entries.getEntries()));
			else handlePerformanceEntries(entries.getEntries());
		}));
		observer.observe(options);
		isObserverInitializing = false;
		manageResourceTimingBufferFull();
		return () => {
			observer.disconnect();
			(0,timer/* clearTimeout */.gr)(timeoutId);
		};
	});
}
let resourceTimingBufferFullListener;
function manageResourceTimingBufferFull() {
	if (!resourceTimingBufferFullListener && supportPerformanceObject() && "addEventListener" in performance) resourceTimingBufferFullListener = (0,addEventListener/* addEventListener */.Oo)(performance, "resourcetimingbufferfull", () => {
		performance.clearResourceTimings();
	});
}
function supportPerformanceObject() {
	return window.performance !== void 0 && "getEntries" in performance;
}
function supportPerformanceTimingEvent(entryType) {
	return PerformanceObserver.supportedEntryTypes.includes(entryType);
}
function filterRumPerformanceEntries(entries) {
	return entries.filter((entry) => !isForbiddenResource(entry));
}
function isForbiddenResource(entry) {
	return entry.entryType === "resource" && (!isAllowedRequestUrl(entry.name) || !hasValidResourceEntryDuration(entry));
}
//#endregion


//# sourceMappingURL=performanceObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/actionNameConstants.mjs
//#region src/domain/action/actionNameConstants.ts
/**
* Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
* It can also be retrieved from a user defined attribute.
*/
const DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = "data-dd-action-name";
const ACTION_NAME_PLACEHOLDER = "Masked Element";
//#endregion


//# sourceMappingURL=actionNameConstants.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/getSelectorFromElement.mjs


//#region src/domain/getSelectorFromElement.ts
/**
* Marker used to indicate shadow DOM boundaries in selectors.
* Named after the deprecated Shadow DOM v0 '::shadow' pseudo-element which served the same
* purpose of marking entry into a shadow root.
* Note: This is NOT a valid CSS selector, it's an internal marker that requires custom
* parsing logic.
*/
const SHADOW_DOM_MARKER = "::shadow ";
/**
* Stable attributes are attributes that are commonly used to identify parts of a UI (ex:
* component). Those attribute values should not be generated randomly (hardcoded most of the time)
* and stay the same across deploys. They are not necessarily unique across the document.
*/
const STABLE_ATTRIBUTES = [
	DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE,
	"data-testid",
	"data-test",
	"data-qa",
	"data-cy",
	"data-test-id",
	"data-qa-id",
	"data-testing",
	"data-component",
	"data-element",
	"data-source-file"
];
const GLOBALLY_UNIQUE_SELECTOR_GETTERS = [getStableAttributeSelector, getIDSelector];
const UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS = [
	getStableAttributeSelector,
	getClassSelector,
	getTagNameSelector
];
function getSelectorFromElement(targetElement, actionNameAttribute) {
	if (!targetElement.isConnected) return;
	const subtrees = getAllSubtreeTargets(targetElement);
	const selectorParts = [];
	for (const { rootNode, target } of subtrees) {
		const selector = getSelectorFromElementWithinSubtree(target, rootNode, actionNameAttribute);
		if (!selector) return;
		selectorParts.push(selector);
	}
	return selectorParts.join(SHADOW_DOM_MARKER);
}
/**
* Returns all (rootNode, target) pairs from the document down to the element.
*/
function getAllSubtreeTargets(element) {
	const result = [];
	let currentTarget = element;
	while (currentTarget) {
		const rootNode = currentTarget.getRootNode();
		result.push({
			rootNode,
			target: currentTarget
		});
		if (isNodeShadowRoot(rootNode)) currentTarget = rootNode.host;
		else break;
	}
	return result.reverse();
}
/**
* Computes a CSS selector for an element within a specific subtree (document or shadow root).
*/
function getSelectorFromElementWithinSubtree(targetElement, rootNode, actionNameAttribute) {
	let currentSelector;
	let currentElement = targetElement;
	while (currentElement && currentElement.nodeName !== "HTML") {
		const globallyUniqueSelector = findSelector(currentElement, rootNode, GLOBALLY_UNIQUE_SELECTOR_GETTERS, isSelectorUniqueWithinRoot, actionNameAttribute, currentSelector);
		if (globallyUniqueSelector) return combineSelector(globallyUniqueSelector, currentSelector);
		currentSelector = combineSelector(findSelector(currentElement, rootNode, UNIQUE_AMONG_CHILDREN_SELECTOR_GETTERS, isSelectorUniqueAmongSiblings, actionNameAttribute, currentSelector) || getPositionSelector(currentElement), currentSelector);
		currentElement = currentElement.parentElement;
	}
	return currentSelector;
}
function isGeneratedValue(value) {
	return /[0-9]/.test(value);
}
function getIDSelector(element) {
	if (element.id && !isGeneratedValue(element.id)) return `#${CSS.escape(element.id)}`;
}
function getClassSelector(element) {
	if (element.tagName === "BODY") return;
	const classList = element.classList;
	for (let i = 0; i < classList.length; i += 1) {
		const className = classList[i];
		if (isGeneratedValue(className)) continue;
		return `${CSS.escape(element.tagName)}.${CSS.escape(className)}`;
	}
}
function getTagNameSelector(element) {
	return CSS.escape(element.tagName);
}
function getStableAttributeSelector(element, actionNameAttribute) {
	if (actionNameAttribute) {
		const selector = getAttributeSelector(actionNameAttribute);
		if (selector) return selector;
	}
	for (const attributeName of STABLE_ATTRIBUTES) {
		const selector = getAttributeSelector(attributeName);
		if (selector) return selector;
	}
	function getAttributeSelector(attributeName) {
		if (element.hasAttribute(attributeName)) return `${CSS.escape(element.tagName)}${getAttributeValueSelector(attributeName, element.getAttribute(attributeName))}`;
	}
}
function getAttributeValueSelector(attributeName, attributeValue) {
	return `[${attributeName}="${CSS.escape(attributeValue)}"]`;
}
function getPositionSelector(element) {
	const nthOfType = getNthOfTypeSelector(element);
	return `${CSS.escape(element.tagName)}:nth-of-type(${nthOfType})`;
}
function getNthOfTypeSelector(element) {
	let sibling = element.parentNode.firstElementChild;
	let nthOfType = 1;
	while (sibling && sibling !== element) {
		if (sibling.tagName === element.tagName) nthOfType += 1;
		sibling = sibling.nextElementSibling;
	}
	return nthOfType;
}
function findSelector(element, rootNode, selectorGetters, predicate, actionNameAttribute, childSelector) {
	for (const selectorGetter of selectorGetters) {
		const elementSelector = selectorGetter(element, actionNameAttribute);
		if (!elementSelector) continue;
		if (predicate(element, rootNode, elementSelector, childSelector)) return elementSelector;
	}
}
/**
* Check whether the selector is unique within the root node (document or shadow root).
*/
function isSelectorUniqueWithinRoot(_element, rootNode, elementSelector, childSelector) {
	return rootNode.querySelectorAll(combineSelector(elementSelector, childSelector)).length === 1;
}
/**
* Check whether the selector is unique among the element siblings. In other words, it returns true
* if "ELEMENT_PARENT > CHILD_SELECTOR" returns a single element.
*
* @param currentElement - the element being considered while iterating over the target
* element ancestors.
* @param _rootNode - the root node (document or shadow root) - unused but required for predicate signature.
* @param currentElementSelector - a selector that matches the current element. That
* selector is not a composed selector (i.e. it might be a single tag name, class name...).
* @param childSelector - child selector is a selector that targets a descendant
* of the current element. When undefined, the current element is the target element.
*
* # Scope selector usage
*
* When composed together, the final selector will be joined with `>` operators to make sure we
* target direct descendants at each level. In this function, we'll use `querySelector` to check if
* a selector matches descendants of the current element. But by default, the query selector match
* elements at any level. Example:
*
* ```html
* <main>
*   <div>
*     <span></span>
*   </div>
*   <marquee>
*     <div>
*       <span></span>
*     </div>
*   </marquee>
* </main>
* ```
*
* `sibling.querySelector('DIV > SPAN')` will match both span elements, so we would consider the
* selector to be not unique, even if it is unique when we'll compose it with the parent with a `>`
* operator (`MAIN > DIV > SPAN`).
*
* To avoid this, we can use the `:scope` selector to make sure the selector starts from the current
* sibling (i.e. `sibling.querySelector('DIV:scope > SPAN')` will only match the first span).
*
* [1]: https://developer.mozilla.org/fr/docs/Web/CSS/:scope
*
* # Performance considerations
*
* We compute selectors in performance-critical operations (ex: during a click), so we need to make
* sure the function is as fast as possible. We observed that naively using `querySelectorAll` to
* check if the selector matches more than 1 element is quite expensive, so we want to avoid it.
*
* Because we are iterating the DOM upward and we use that function at every level, we know the
* child selector is already unique among the current element children, so we don't need to check
* for the current element subtree.
*
* Instead, we can focus on the current element siblings. If we find a single element matching the
* selector within a sibling, we know that it's not unique. This allows us to use `querySelector`
* (or `matches`, when the current element is the target element) instead of `querySelectorAll`.
*/
function isSelectorUniqueAmongSiblings(currentElement, _rootNode, currentElementSelector, childSelector) {
	let isSiblingMatching;
	if (childSelector === void 0) isSiblingMatching = (sibling) => sibling.matches(currentElementSelector);
	else {
		const scopedSelector = combineSelector(`${currentElementSelector}:scope`, childSelector);
		isSiblingMatching = (sibling) => sibling.querySelector(scopedSelector) !== null;
	}
	let sibling = currentElement.previousElementSibling;
	while (sibling) {
		if (isSiblingMatching(sibling)) return false;
		sibling = sibling.previousElementSibling;
	}
	sibling = currentElement.nextElementSibling;
	while (sibling) {
		if (isSiblingMatching(sibling)) return false;
		sibling = sibling.nextElementSibling;
	}
	return true;
}
function combineSelector(parent, child) {
	return child ? `${parent}>${child}` : parent;
}
//#endregion


//# sourceMappingURL=getSelectorFromElement.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/privacyConstants.mjs

//#region src/domain/privacyConstants.ts
const NodePrivacyLevel = {
	IGNORE: "ignore",
	HIDDEN: "hidden",
	ALLOW: DefaultPrivacyLevel.ALLOW,
	MASK: DefaultPrivacyLevel.MASK,
	MASK_USER_INPUT: DefaultPrivacyLevel.MASK_USER_INPUT,
	MASK_UNLESS_ALLOWLISTED: DefaultPrivacyLevel.MASK_UNLESS_ALLOWLISTED
};
const PRIVACY_ATTR_NAME = "data-dd-privacy";
const PRIVACY_ATTR_VALUE_ALLOW = "allow";
const PRIVACY_ATTR_VALUE_MASK = "mask";
const PRIVACY_ATTR_VALUE_MASK_USER_INPUT = "mask-user-input";
const PRIVACY_ATTR_VALUE_MASK_UNLESS_ALLOWLISTED = "mask-unless-allowlisted";
const PRIVACY_ATTR_VALUE_HIDDEN = "hidden";
const PRIVACY_CLASS_PREFIX = "dd-privacy-";
const CENSORED_STRING_MARK = "***";
const CENSORED_IMG_MARK = "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==";
const FORM_PRIVATE_TAG_NAMES = {
	INPUT: true,
	OUTPUT: true,
	TEXTAREA: true,
	SELECT: true,
	OPTION: true,
	DATALIST: true,
	OPTGROUP: true
};
const TEXT_MASKING_CHAR = "x";
function getPrivacySelector(privacyLevel) {
	return `[${PRIVACY_ATTR_NAME}="${privacyLevel}"], .${PRIVACY_CLASS_PREFIX}${privacyLevel}`;
}
//#endregion


//# sourceMappingURL=privacyConstants.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/privacy.mjs



//#region src/domain/privacy.ts
/**
* Get node privacy level by iterating over its ancestors. When the direct parent privacy level is
* know, it is best to use something like:
*
* derivePrivacyLevelGivenParent(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel)
*/
function getNodePrivacyLevel(node, defaultPrivacyLevel, cache) {
	if (cache?.has(node)) return cache.get(node);
	const parentNode = getParentNode(node);
	const parentNodePrivacyLevel = parentNode ? getNodePrivacyLevel(parentNode, defaultPrivacyLevel, cache) : defaultPrivacyLevel;
	const nodePrivacyLevel = reducePrivacyLevel(getNodeSelfPrivacyLevel(node), parentNodePrivacyLevel);
	if (cache) cache.set(node, nodePrivacyLevel);
	return nodePrivacyLevel;
}
/**
* Reduces the next privacy level based on self + parent privacy levels
*/
function reducePrivacyLevel(childPrivacyLevel, parentNodePrivacyLevel) {
	switch (parentNodePrivacyLevel) {
		case NodePrivacyLevel.HIDDEN:
		case NodePrivacyLevel.IGNORE: return parentNodePrivacyLevel;
	}
	switch (childPrivacyLevel) {
		case NodePrivacyLevel.ALLOW:
		case NodePrivacyLevel.MASK:
		case NodePrivacyLevel.MASK_USER_INPUT:
		case NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED:
		case NodePrivacyLevel.HIDDEN:
		case NodePrivacyLevel.IGNORE: return childPrivacyLevel;
		default: return parentNodePrivacyLevel;
	}
}
/**
* Determines the node's own privacy level without checking for ancestors.
*/
function getNodeSelfPrivacyLevel(node) {
	if (!isElementNode(node)) return;
	if (node.tagName === "BASE") return NodePrivacyLevel.ALLOW;
	if (node.tagName === "INPUT") {
		const inputElement = node;
		if (inputElement.type === "password" || inputElement.type === "email" || inputElement.type === "tel") return NodePrivacyLevel.MASK;
		if (inputElement.type === "hidden") return NodePrivacyLevel.MASK;
		const autocomplete = inputElement.getAttribute("autocomplete");
		if (autocomplete && (autocomplete.startsWith("cc-") || autocomplete.endsWith("-password"))) return NodePrivacyLevel.MASK;
	}
	if (node.matches(getPrivacySelector(NodePrivacyLevel.HIDDEN))) return NodePrivacyLevel.HIDDEN;
	if (node.matches(getPrivacySelector(NodePrivacyLevel.MASK))) return NodePrivacyLevel.MASK;
	if (node.matches(getPrivacySelector(NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED))) return NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED;
	if (node.matches(getPrivacySelector(NodePrivacyLevel.MASK_USER_INPUT))) return NodePrivacyLevel.MASK_USER_INPUT;
	if (node.matches(getPrivacySelector(NodePrivacyLevel.ALLOW))) return NodePrivacyLevel.ALLOW;
	if (shouldIgnoreElement(node)) return NodePrivacyLevel.IGNORE;
}
/**
* Helper aiming to unify `mask` and `mask-user-input` privacy levels:
*
* In the `mask` case, it is trivial: we should mask the element.
*
* In the `mask-user-input` case, we should mask the element only if it is a "form" element or the
* direct parent is a form element for text nodes).
*
* Other `shouldMaskNode` cases are edge cases that should not matter too much (ex: should we mask a
* node if it is ignored or hidden? it doesn't matter since it won't be serialized).
*/
function shouldMaskNode(node, privacyLevel) {
	switch (privacyLevel) {
		case NodePrivacyLevel.MASK:
		case NodePrivacyLevel.HIDDEN:
		case NodePrivacyLevel.IGNORE: return true;
		case NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED:
			if (isTextNode(node)) return isFormElement(node.parentNode) ? true : !isAllowlisted(node.textContent || "");
			return isFormElement(node);
		case NodePrivacyLevel.MASK_USER_INPUT: return isTextNode(node) ? isFormElement(node.parentNode) : isFormElement(node);
		default: return false;
	}
}
function shouldMaskAttribute(tagName, attributeName, attributeValue, nodePrivacyLevel, configuration) {
	if (nodePrivacyLevel !== NodePrivacyLevel.MASK && nodePrivacyLevel !== NodePrivacyLevel.MASK_UNLESS_ALLOWLISTED) return false;
	if (attributeName === "data-dd-privacy" || STABLE_ATTRIBUTES.includes(attributeName) || attributeName === configuration.actionNameAttribute) return false;
	switch (attributeName) {
		case "title":
		case "alt":
		case "placeholder":
		case "aria-label":
		case "name": return true;
	}
	if (tagName === "A" && attributeName === "href") return true;
	if (tagName === "IFRAME" && attributeName === "srcdoc") return true;
	if (attributeValue && attributeName.startsWith("data-")) return true;
	if ((tagName === "IMG" || tagName === "SOURCE") && (attributeName === "src" || attributeName === "srcset")) return true;
	return false;
}
function isFormElement(node) {
	if (!node || node.nodeType !== node.ELEMENT_NODE) return false;
	const element = node;
	if (element.tagName === "INPUT") switch (element.type) {
		case "button":
		case "color":
		case "reset":
		case "submit": return false;
	}
	return !!FORM_PRIVATE_TAG_NAMES[element.tagName];
}
/**
* Text censoring non-destructively maintains whitespace characters in order to preserve text shape
* during replay.
*/
function censorText(text) {
	return text.replace(/\S/g, "x");
}
function getTextContent(textNode, parentNodePrivacyLevel) {
	const parentTagName = textNode.parentElement?.tagName;
	let textContent = textNode.textContent || "";
	const nodePrivacyLevel = parentNodePrivacyLevel;
	if (parentTagName === "SCRIPT") textContent = "***";
	else if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) textContent = "***";
	else if (shouldMaskNode(textNode, nodePrivacyLevel)) if (parentTagName === "DATALIST" || parentTagName === "SELECT" || parentTagName === "OPTGROUP") {} else if (parentTagName === "OPTION") textContent = "***";
	else textContent = censorText(textContent);
	if (parentTagName === "HEAD" && !textContent.trim()) return "";
	return textContent;
}
/**
* TODO: Preserve CSS element order, and record the presence of the tag, just don't render
* We don't need this logic on the recorder side.
* For security related meta's, customer can mask themmanually given they
* are easy to identify in the HEAD tag.
*/
function shouldIgnoreElement(element) {
	if (element.nodeName === "SCRIPT") return true;
	if (element.nodeName === "LINK") {
		const relAttribute = getLowerCaseAttribute("rel");
		return /preload|prefetch/i.test(relAttribute) && getLowerCaseAttribute("as") === "script" || relAttribute === "shortcut icon" || relAttribute === "icon";
	}
	if (element.nodeName === "META") {
		const nameAttribute = getLowerCaseAttribute("name");
		const relAttribute = getLowerCaseAttribute("rel");
		const propertyAttribute = getLowerCaseAttribute("property");
		return /^msapplication-tile(image|color)$/.test(nameAttribute) || nameAttribute === "application-name" || relAttribute === "icon" || relAttribute === "apple-touch-icon" || relAttribute === "shortcut icon" || nameAttribute === "keywords" || nameAttribute === "description" || /^(og|twitter|fb):/.test(propertyAttribute) || /^(og|twitter):/.test(nameAttribute) || nameAttribute === "pinterest" || nameAttribute === "robots" || nameAttribute === "googlebot" || nameAttribute === "bingbot" || element.hasAttribute("http-equiv") || nameAttribute === "author" || nameAttribute === "generator" || nameAttribute === "framework" || nameAttribute === "publisher" || nameAttribute === "progid" || /^article:/.test(propertyAttribute) || /^product:/.test(propertyAttribute) || nameAttribute === "google-site-verification" || nameAttribute === "yandex-verification" || nameAttribute === "csrf-token" || nameAttribute === "p:domain_verify" || nameAttribute === "verify-v1" || nameAttribute === "verification" || nameAttribute === "shopify-checkout-api-token";
	}
	function getLowerCaseAttribute(name) {
		return (element.getAttribute(name) || "").toLowerCase();
	}
	return false;
}
function isAllowlisted(text) {
	if (!text?.trim()) return true;
	return window.$DD_ALLOW?.has(text.toLocaleLowerCase()) || false;
}
function maskDisallowedTextContent(text, fixedMask) {
	if (isAllowlisted(text)) return text;
	return fixedMask || censorText(text);
}
//#endregion


//# sourceMappingURL=privacy.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/scroll.mjs
//#region src/browser/scroll.ts
function getScrollX() {
	let scrollX;
	const visual = window.visualViewport;
	if (visual) scrollX = visual.pageLeft - visual.offsetLeft;
	else if (window.scrollX !== void 0) scrollX = window.scrollX;
	else scrollX = window.pageXOffset || 0;
	return Math.round(scrollX);
}
function getScrollY() {
	let scrollY;
	const visual = window.visualViewport;
	if (visual) scrollY = visual.pageTop - visual.offsetTop;
	else if (window.scrollY !== void 0) scrollY = window.scrollY;
	else scrollY = window.pageYOffset || 0;
	return Math.round(scrollY);
}
//#endregion


//# sourceMappingURL=scroll.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/viewportObservable.mjs

//#region src/browser/viewportObservable.ts
let viewportObservable;
function initViewportObservable() {
	if (!viewportObservable) viewportObservable = createViewportObservable();
	return viewportObservable;
}
function createViewportObservable() {
	return new tools_observable/* Observable */.y$((observable) => {
		const { throttled: updateDimension } = (0,functionUtils/* throttle */.P)(() => {
			observable.notify(getViewportDimension());
		}, 200);
		return (0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.RESIZE */.EZ.RESIZE, updateDimension, {
			capture: true,
			passive: true
		}).stop;
	});
}
function getViewportDimension() {
	const visual = window.visualViewport;
	if (visual) return {
		width: Number(visual.width * visual.scale),
		height: Number(visual.height * visual.scale)
	};
	return {
		width: Number(window.innerWidth || 0),
		height: Number(window.innerHeight || 0)
	};
}
//#endregion


//# sourceMappingURL=viewportObservable.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/eventBridge.mjs
var eventBridge = __webpack_require__(71394);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/sampler.mjs
var sampler = __webpack_require__(15250);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/sessionReplayState.mjs

//#region src/domain/sessionReplayState.ts
let SessionReplayState = /* @__PURE__ */ function(SessionReplayState) {
	SessionReplayState[SessionReplayState["OFF"] = 0] = "OFF";
	SessionReplayState[SessionReplayState["SAMPLED"] = 1] = "SAMPLED";
	SessionReplayState[SessionReplayState["FORCED"] = 2] = "FORCED";
	return SessionReplayState;
}({});
function computeSessionReplayState(session, configuration) {
	if ((0,eventBridge/* canUseEventBridge */.xT)()) return (0,eventBridge/* bridgeSupports */.ke)(eventBridge/* BridgeCapability.RECORDS */.BP.RECORDS) ? 1 : 0;
	if ((0,sampler/* isSampled */.HR)(session.id, (0,sampler/* correctedChildSampleRate */.HQ)(configuration.sessionSampleRate, configuration.sessionReplaySampleRate))) return 1;
	if (session.isReplayForced) return 2;
	return 0;
}
//#endregion


//# sourceMappingURL=sessionReplayState.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/instrumentMethod.mjs
var instrumentMethod = __webpack_require__(19353);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/windowOpenObservable.mjs

//#region src/browser/windowOpenObservable.ts
function createWindowOpenObservable() {
	const observable = new tools_observable/* Observable */.y$();
	const { stop } = (0,instrumentMethod/* instrumentMethod */.Su)(window, "open", () => observable.notify());
	return {
		observable,
		stop
	};
}
//#endregion


//# sourceMappingURL=windowOpenObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/internalContext.mjs
//#region src/domain/contexts/internalContext.ts
/**
* Internal context keep returning v1 format
* to not break compatibility with logs data format
*/
function startInternalContext(applicationId, sessionManager, viewHistory, actionContexts, urlContexts) {
	return { get: (startTime) => {
		const viewContext = viewHistory.findView(startTime);
		const urlContext = urlContexts.findUrl(startTime);
		const session = sessionManager.findTrackedSession(startTime);
		if (session && viewContext && urlContext) {
			const actionId = actionContexts.findActionId(startTime);
			return {
				application_id: applicationId,
				session_id: session.id,
				user_action: actionId ? { id: actionId } : void 0,
				view: {
					id: viewContext.id,
					name: viewContext.name,
					referrer: urlContext.referrer,
					url: urlContext.url
				}
			};
		}
	} };
}
//#endregion


//# sourceMappingURL=internalContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/identifier.mjs
//#region src/domain/tracing/identifier.ts
function createTraceIdentifier() {
	return createIdentifier(64);
}
function createSpanIdentifier() {
	return createIdentifier(63);
}
function createIdentifier(bits) {
	const buffer = crypto.getRandomValues(/* @__PURE__ */ new Uint32Array(2));
	let value = BigInt(buffer[0]) + (BigInt(buffer[1]) << 32n);
	if (bits === 63) value &= 9223372036854775807n;
	return value;
}
function toPaddedHexadecimalString(id) {
	return id.toString(16).padStart(16, "0");
}
//#endregion


//# sourceMappingURL=identifier.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/polyfills.mjs
var polyfills = __webpack_require__(59343);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/matchOption.mjs

//#region src/tools/matchOption.ts
/**
* Returns true if value can be matched by at least one of the provided MatchOptions.
* When comparing strings, setting useStartsWith to true will compare the value with the start of
* the option, instead of requiring an exact match.
*/
function matchList(list, value, useStartsWith = false) {
	return list.some((item) => {
		try {
			if (typeof item === "function") return item(value);
			else if (item instanceof RegExp) {
				item.lastIndex = 0;
				return item.test(value);
			} else if (typeof item === "string") return useStartsWith ? value.startsWith(item) : item === value;
		} catch (e) {
			display/* display.error */.jf.error(e);
		}
		return false;
	});
}
//#endregion


//# sourceMappingURL=matchOption.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/tracer.mjs


//#region src/domain/tracing/tracer.ts
/**
* Clear tracing information to avoid incomplete traces. Ideally, we should do it when the
* request did not reach the server, but the browser does not expose this. So, we clear tracing
* information if the request ended with status 0 without being aborted by the application.
*
* Reasoning:
*
* * Applications are usually aborting requests after a bit of time, for example when the user is
* typing (autocompletion) or navigating away (in a SPA). With a performant device and good
* network conditions, the request is likely to reach the server before being canceled.
*
* * Requests aborted otherwise (ex: lack of internet, CORS issue, blocked by a privacy extension)
* are likely to finish quickly and without reaching the server.
*
* Of course, it might not be the case every time, but it should limit having incomplete traces a
* bit.
* */
function clearTracingIfNeeded(context) {
	if (context.status === 0 && !context.isAborted) {
		context.traceId = void 0;
		context.spanId = void 0;
		context.traceSampled = void 0;
	}
}
function startTracer(configuration, sessionManager, userContext, accountContext) {
	return {
		clearTracingIfNeeded,
		traceFetch: (context) => injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders) => {
			if (context.input instanceof Request && !context.init?.headers) {
				context.input = new Request(context.input);
				Object.keys(tracingHeaders).forEach((key) => {
					context.input.headers.append(key, tracingHeaders[key]);
				});
			} else {
				context.init = (0,objectUtils/* shallowClone */.mv)(context.init);
				const headers = [];
				if (context.init.headers instanceof Headers) context.init.headers.forEach((value, key) => {
					headers.push([key, value]);
				});
				else if (Array.isArray(context.init.headers)) context.init.headers.forEach((header) => {
					headers.push(header);
				});
				else if (context.init.headers) Object.keys(context.init.headers).forEach((key) => {
					headers.push([key, context.init.headers[key]]);
				});
				context.init.headers = headers.concat((0,polyfills/* objectEntries */.qP)(tracingHeaders));
			}
		}),
		traceXhr: (context, xhr) => injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, (tracingHeaders) => {
			try {
				Object.keys(tracingHeaders).forEach((name) => {
					xhr.setRequestHeader(name, tracingHeaders[name]);
				});
			} catch {}
		})
	};
}
function injectHeadersIfTracingAllowed(configuration, context, sessionManager, userContext, accountContext, inject) {
	const session = sessionManager.findTrackedSession();
	if (!session) return;
	const tracingOption = configuration.allowedTracingUrls.find((tracingOption) => matchList([tracingOption.match], context.url, true));
	if (!tracingOption) return;
	const fallbackTraceSampled = (0,sampler/* isSampled */.HR)(session.id, (0,sampler/* correctedChildSampleRate */.HQ)(configuration.sessionSampleRate, configuration.traceSampleRate));
	const traceSampled = (0,eventBridge/* canUseEventBridge */.xT)() ? (0,eventBridge/* getEventBridge */.Ad)()?.getIsTraceSampled() ?? fallbackTraceSampled : fallbackTraceSampled;
	if (!(traceSampled || configuration.traceContextInjection === TraceContextInjection.ALL)) return;
	context.traceSampled = traceSampled;
	context.traceId = createTraceIdentifier();
	context.spanId = createSpanIdentifier();
	inject(makeTracingHeaders(context.traceId, context.spanId, context.traceSampled, session.id, tracingOption.propagatorTypes, userContext, accountContext, configuration));
}
/**
* When trace is not sampled, set priority to '0' instead of not adding the tracing headers
* to prepare the implementation for sampling delegation.
*/
function makeTracingHeaders(traceId, spanId, traceSampled, sessionId, propagatorTypes, userContext, accountContext, configuration) {
	const tracingHeaders = {};
	propagatorTypes.forEach((propagatorType) => {
		switch (propagatorType) {
			case "datadog":
				Object.assign(tracingHeaders, {
					"x-datadog-origin": "rum",
					"x-datadog-parent-id": spanId.toString(),
					"x-datadog-sampling-priority": traceSampled ? "1" : "0",
					"x-datadog-trace-id": traceId.toString()
				});
				break;
			case "tracecontext":
				Object.assign(tracingHeaders, {
					traceparent: `00-0000000000000000${toPaddedHexadecimalString(traceId)}-${toPaddedHexadecimalString(spanId)}-0${traceSampled ? "1" : "0"}`,
					tracestate: `dd=s:${traceSampled ? "1" : "0"};o:rum`
				});
				break;
			case "b3":
				Object.assign(tracingHeaders, { b3: `${toPaddedHexadecimalString(traceId)}-${toPaddedHexadecimalString(spanId)}-${traceSampled ? "1" : "0"}` });
				break;
			case "b3multi":
				Object.assign(tracingHeaders, {
					"X-B3-TraceId": toPaddedHexadecimalString(traceId),
					"X-B3-SpanId": toPaddedHexadecimalString(spanId),
					"X-B3-Sampled": traceSampled ? "1" : "0"
				});
				break;
		}
	});
	if (configuration.propagateTraceBaggage) {
		const baggageItems = { "session.id": sessionId };
		const userId = userContext.getContext().id;
		if (typeof userId === "string") baggageItems["user.id"] = userId;
		const accountId = accountContext.getContext().id;
		if (typeof accountId === "string") baggageItems["account.id"] = accountId;
		const baggageHeader = Object.entries(baggageItems).map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join(",");
		if (baggageHeader) tracingHeaders["baggage"] = baggageHeader;
	}
	return tracingHeaders;
}
//#endregion


//# sourceMappingURL=tracer.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/byteUtils.mjs
var byteUtils = __webpack_require__(88332);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/graphql.mjs


//#region src/domain/resource/graphql.ts
/**
* arbitrary value, byte precision not needed
*/
const GRAPHQL_PAYLOAD_LIMIT = 32 * byteUtils/* ONE_KIBI_BYTE */.Hi;
function extractGraphQlMetadata(request, graphQlConfig) {
	const metadata = extractGraphQlRequestMetadata(request, graphQlConfig.trackPayload);
	if (!metadata) return;
	if (graphQlConfig.trackResponseErrors && request.responseBody) {
		const responseErrors = parseGraphQlResponse(request.responseBody);
		if (responseErrors) {
			metadata.error_count = responseErrors.length;
			metadata.errors = responseErrors;
		}
	}
	return metadata;
}
function parseGraphQlResponse(responseText) {
	const response = (0,objectUtils/* tryJsonParse */.Cy)(responseText);
	if (!response || typeof response !== "object") return;
	const responseObj = response;
	if (!(0,arrayUtils/* isNonEmptyArray */.Of)(responseObj.errors)) return;
	return responseObj.errors.map((error) => {
		return {
			message: error.message,
			path: error.path,
			locations: error.locations,
			code: error.extensions?.code
		};
	});
}
function findGraphQlConfiguration(url, configuration) {
	return configuration.allowedGraphQlUrls.find((graphQlOption) => matchList([graphQlOption.match], url));
}
function extractGraphQlRequestMetadata(request, trackPayload = false) {
	let rawMetadata;
	if (request.method === "POST") rawMetadata = extractFromBody(request.requestBody);
	else if (request.method === "GET") rawMetadata = extractFromUrlQueryParams(request.url);
	if (!rawMetadata) return;
	return sanitizeGraphQlMetadata(rawMetadata, trackPayload);
}
function extractFromBody(requestBody) {
	if (!requestBody || typeof requestBody !== "string") return;
	const graphqlBody = (0,objectUtils/* tryJsonParse */.Cy)(requestBody);
	if (!graphqlBody) return;
	return {
		query: graphqlBody.query,
		operationName: graphqlBody.operationName,
		variables: graphqlBody.variables ? JSON.stringify(graphqlBody.variables) : void 0,
		operationType: graphqlBody.operationType
	};
}
function extractFromUrlQueryParams(url) {
	const searchParams = (0,urlPolyfill/* buildUrl */.Q2)(url).searchParams;
	const variablesParam = searchParams.get("variables");
	const variables = variablesParam && (0,objectUtils/* tryJsonParse */.Cy)(variablesParam) !== void 0 ? variablesParam : void 0;
	return {
		query: searchParams.get("query") || void 0,
		operationName: searchParams.get("operationName") || void 0,
		variables,
		operationType: searchParams.get("operationType") || void 0
	};
}
function sanitizeGraphQlMetadata(rawMetadata, trackPayload) {
	let operationType;
	let payload;
	let variables;
	if (rawMetadata.query) {
		const trimmedQuery = rawMetadata.query.trim();
		operationType = getOperationType(trimmedQuery);
		if (trackPayload) payload = safeTruncate(trimmedQuery, GRAPHQL_PAYLOAD_LIMIT, "...");
	}
	if (!operationType) {
		const bodyType = rawMetadata.operationType;
		if (bodyType === "query" || bodyType === "mutation" || bodyType === "subscription") operationType = bodyType;
	}
	if (rawMetadata.variables) variables = rawMetadata.variables;
	return {
		operationType,
		operationName: rawMetadata.operationName,
		variables,
		payload
	};
}
function getOperationType(query) {
	return query.match(/^\s*(query|mutation|subscription)\b/i)?.[1];
}
//#endregion


//# sourceMappingURL=graphql.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/xhrObservable.mjs





//#region src/browser/xhrObservable.ts
let xhrObservable;
const xhrContexts = /* @__PURE__ */ new WeakMap();
function initXhrObservable() {
	if (!xhrObservable) xhrObservable = createXhrObservable();
	return xhrObservable;
}
function createXhrObservable() {
	if (!("XMLHttpRequest" in globalObject/* globalObject */.Z)) return new tools_observable/* Observable */.y$();
	return new tools_observable/* Observable */.y$((observable) => {
		const { stop: stopInstrumentingStart } = (0,instrumentMethod/* instrumentMethod */.Su)(XMLHttpRequest.prototype, "open", openXhr);
		const { stop: stopInstrumentingSend } = (0,instrumentMethod/* instrumentMethod */.Su)(XMLHttpRequest.prototype, "send", (call) => {
			sendXhr(call, observable);
		}, { computeHandlingStack: true });
		const { stop: stopInstrumentingAbort } = (0,instrumentMethod/* instrumentMethod */.Su)(XMLHttpRequest.prototype, "abort", abortXhr);
		return () => {
			stopInstrumentingStart();
			stopInstrumentingSend();
			stopInstrumentingAbort();
		};
	});
}
function openXhr({ target: xhr, parameters: [method, url] }) {
	xhrContexts.set(xhr, {
		state: "open",
		method: String(method).toUpperCase(),
		url: (0,urlPolyfill/* normalizeUrl */.D5)(String(url))
	});
}
function sendXhr({ target: xhr, parameters: [body], handlingStack }, observable) {
	const context = xhrContexts.get(xhr);
	if (!context) return;
	const startContext = context;
	startContext.state = "start";
	startContext.startClocks = (0,entries_time/* clocksNow */.$I)();
	startContext.isAborted = false;
	startContext.xhr = xhr;
	startContext.handlingStack = handlingStack;
	startContext.requestBody = body;
	let hasBeenReported = false;
	const { stop: stopInstrumentingOnReadyStateChange } = (0,instrumentMethod/* instrumentMethod */.Su)(xhr, "onreadystatechange", () => {
		if (xhr.readyState === XMLHttpRequest.DONE) onEnd();
	});
	const onEnd = () => {
		unsubscribeLoadEndListener();
		stopInstrumentingOnReadyStateChange();
		if (hasBeenReported) return;
		hasBeenReported = true;
		const completeContext = context;
		completeContext.duration = (0,entries_time/* elapsed */._J)(startContext.startClocks.timeStamp, (0,entries_time/* timeStampNow */.n$)());
		completeContext.status = xhr.status;
		if (typeof xhr.response === "string") completeContext.responseBody = xhr.response;
		observable.notify({
			...completeContext,
			state: "complete"
		});
	};
	const { stop: unsubscribeLoadEndListener } = (0,addEventListener/* addEventListener */.Oo)(xhr, "loadend", onEnd);
	observable.notify(startContext);
}
function abortXhr({ target: xhr }) {
	const context = xhrContexts.get(xhr);
	if (context) context.isAborted = true;
}
//#endregion


//# sourceMappingURL=xhrObservable.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/mockable.mjs
var mockable = __webpack_require__(62318);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/stackTrace/computeStackTrace.mjs
var computeStackTrace = __webpack_require__(91635);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/isError.mjs
var isError = __webpack_require__(41199);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.types.mjs
var error_types = __webpack_require__(8183);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/stackTrace/handlingStack.mjs
var stackTrace_handlingStack = __webpack_require__(41410);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/jsonStringify.mjs
var jsonStringify = __webpack_require__(21084);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/serialisation/sanitize.mjs



//#region src/tools/serialisation/sanitize.ts
const SANITIZE_DEFAULT_MAX_CHARACTER_COUNT = 220 * byteUtils/* ONE_KIBI_BYTE */.Hi;
const JSON_PATH_ROOT_ELEMENT = "$";
const KEY_DECORATION_LENGTH = 3;
function sanitize(source, maxCharacterCount = SANITIZE_DEFAULT_MAX_CHARACTER_COUNT) {
	const restoreObjectPrototypeToJson = (0,jsonStringify/* detachToJsonMethod */.y)(Object.prototype);
	const restoreArrayPrototypeToJson = (0,jsonStringify/* detachToJsonMethod */.y)(Array.prototype);
	try {
		const containerQueue = [];
		const visitedObjectsWithPath = /* @__PURE__ */ new WeakMap();
		const sanitizedData = sanitizeProcessor(source, JSON_PATH_ROOT_ELEMENT, void 0, containerQueue, visitedObjectsWithPath);
		const serializedSanitizedData = JSON.stringify(sanitizedData);
		let accumulatedCharacterCount = serializedSanitizedData ? serializedSanitizedData.length : 0;
		if (accumulatedCharacterCount > maxCharacterCount) {
			warnOverCharacterLimit(maxCharacterCount, "discarded", source);
			return;
		}
		while (containerQueue.length > 0 && accumulatedCharacterCount < maxCharacterCount) {
			const containerToProcess = containerQueue.shift();
			let separatorLength = 0;
			if (Array.isArray(containerToProcess.source)) for (let key = 0; key < containerToProcess.source.length; key++) {
				const targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
				if (targetData !== void 0) accumulatedCharacterCount += JSON.stringify(targetData).length;
				else accumulatedCharacterCount += 4;
				accumulatedCharacterCount += separatorLength;
				separatorLength = 1;
				if (accumulatedCharacterCount > maxCharacterCount) {
					warnOverCharacterLimit(maxCharacterCount, "truncated", source);
					break;
				}
				containerToProcess.target[key] = targetData;
			}
			else for (const key in containerToProcess.source) if (Object.prototype.hasOwnProperty.call(containerToProcess.source, key)) {
				const targetData = sanitizeProcessor(containerToProcess.source[key], containerToProcess.path, key, containerQueue, visitedObjectsWithPath);
				if (targetData !== void 0) {
					accumulatedCharacterCount += JSON.stringify(targetData).length + separatorLength + key.length + KEY_DECORATION_LENGTH;
					separatorLength = 1;
				}
				if (accumulatedCharacterCount > maxCharacterCount) {
					warnOverCharacterLimit(maxCharacterCount, "truncated", source);
					break;
				}
				containerToProcess.target[key] = targetData;
			}
		}
		return sanitizedData;
	} finally {
		restoreObjectPrototypeToJson();
		restoreArrayPrototypeToJson();
	}
}
/**
* Internal function to factorize the process common to the
* initial call to sanitize, and iterations for Arrays and Objects
*
*/
function sanitizeProcessor(source, parentPath, key, queue, visitedObjectsWithPath) {
	const sourceToSanitize = tryToApplyToJSON(source);
	if (!sourceToSanitize || typeof sourceToSanitize !== "object") return sanitizePrimitivesAndFunctions(sourceToSanitize);
	const sanitizedSource = sanitizeObjects(sourceToSanitize);
	if (sanitizedSource !== "[Object]" && sanitizedSource !== "[Array]" && sanitizedSource !== "[Error]") return sanitizedSource;
	const sourceAsObject = source;
	if (visitedObjectsWithPath.has(sourceAsObject)) return `[Reference seen at ${visitedObjectsWithPath.get(sourceAsObject)}]`;
	const currentPath = key !== void 0 ? `${parentPath}.${key}` : parentPath;
	const target = Array.isArray(sourceToSanitize) ? [] : {};
	visitedObjectsWithPath.set(sourceAsObject, currentPath);
	queue.push({
		source: sourceToSanitize,
		target,
		path: currentPath
	});
	return target;
}
/**
* Handles sanitization of simple, non-object types
*
*/
function sanitizePrimitivesAndFunctions(value) {
	if (typeof value === "bigint") return `[BigInt] ${value.toString()}`;
	if (typeof value === "function") return `[Function] ${value.name || "unknown"}`;
	if (typeof value === "symbol") return `[Symbol] ${value.description || value.toString()}`;
	return value;
}
/**
* Handles sanitization of object types
*
* LIMITATIONS
* - If a class defines a toStringTag Symbol, it will fall in the catch-all method and prevent enumeration of properties.
* To avoid this, a toJSON method can be defined.
*/
function sanitizeObjects(value) {
	try {
		if (value instanceof Event) return sanitizeEvent(value);
		if (value instanceof RegExp) return `[RegExp] ${value.toString()}`;
		const match = Object.prototype.toString.call(value).match(/\[object (.*)\]/);
		if (match?.[1]) return `[${match[1]}]`;
	} catch {}
	return "[Unserializable]";
}
function sanitizeEvent(event) {
	return {
		type: event.type,
		isTrusted: event.isTrusted,
		currentTarget: event.currentTarget ? sanitizeObjects(event.currentTarget) : null,
		target: event.target ? sanitizeObjects(event.target) : null
	};
}
/**
* Checks if a toJSON function exists and tries to execute it
*
*/
function tryToApplyToJSON(value) {
	if ((typeof value !== "object" || value === null) && typeof value !== "function") return value;
	const object = value;
	if (typeof object.toJSON === "function") try {
		return object.toJSON();
	} catch {}
	return value;
}
/**
* Helper function to display the warning when the accumulated character count is over the limit
*/
function warnOverCharacterLimit(maxCharacterCount, changeType, source) {
	display/* display.warn */.jf.warn(`The data provided has been ${changeType} as it is over the limit of ${maxCharacterCount} characters:`, source);
}
//#endregion


//# sourceMappingURL=sanitize.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/sourceCodeContext.mjs
var sourceCodeContext = __webpack_require__(8365);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/error.mjs







//#region src/domain/error/error.ts
function computeErrorBase({ originalError, stackTrace, source, useFallbackStack = true, nonErrorPrefix }) {
	const isErrorInstance = (0,isError/* isError */.V)(originalError);
	return {
		source,
		type: stackTrace ? stackTrace.name : void 0,
		message: computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError),
		stack: stackTrace ? (0,stackTrace_handlingStack/* toStackTraceString */.P3)(stackTrace) : useFallbackStack ? isError/* NO_ERROR_STACK_PRESENT_MESSAGE */.K : void 0
	};
}
function getStackTraceUrls(stackTrace) {
	return stackTrace?.stack.map((frame) => frame.url).filter((url) => !!url) ?? [];
}
function getErrorDebugIds(stackTrace, errorCauses) {
	const errorCausesUrls = errorCauses.flatMap(({ stackTrace }) => getStackTraceUrls(stackTrace));
	return (0,sourceCodeContext/* buildDebugIdByUrl */.J)(getStackTraceUrls(stackTrace).concat(errorCausesUrls));
}
function flattenErrorCauses(error) {
	const chain = [];
	let current = error.cause;
	while (current !== void 0 && current !== null && chain.length < 10) {
		const isCurrentError = (0,isError/* isError */.V)(current);
		const stackTrace = isCurrentError ? (0,computeStackTrace/* computeStackTrace */._)(current) : void 0;
		chain.push({
			originalError: current,
			stackTrace
		});
		current = isCurrentError ? current.cause : void 0;
	}
	return chain;
}
function computeRawError({ stackTrace, originalError, handlingStack, componentStack, startClocks, nonErrorPrefix, useFallbackStack = true, source, handling }) {
	const errorStackTrace = stackTrace ?? ((0,isError/* isError */.V)(originalError) ? (0,computeStackTrace/* computeStackTrace */._)(originalError) : void 0);
	const errorCauses = (0,isError/* isError */.V)(originalError) ? flattenErrorCauses(originalError) : [];
	const errorBase = computeErrorBase({
		originalError,
		stackTrace: errorStackTrace,
		source,
		useFallbackStack,
		nonErrorPrefix
	});
	const rawErrorCauses = errorCauses.map(({ originalError, stackTrace }) => computeErrorBase({
		originalError,
		stackTrace,
		source,
		useFallbackStack: false
	}));
	return {
		startClocks,
		handling,
		handlingStack,
		componentStack,
		originalError,
		...errorBase,
		debugIds: getErrorDebugIds(errorStackTrace, errorCauses),
		causes: rawErrorCauses.length ? rawErrorCauses : void 0,
		fingerprint: tryToGetFingerprint(originalError),
		context: tryToGetErrorContext(originalError)
	};
}
function computeMessage(stackTrace, isErrorInstance, nonErrorPrefix, originalError) {
	return stackTrace?.message && stackTrace?.name ? stackTrace.message : !isErrorInstance ? nonErrorPrefix ? `${nonErrorPrefix} ${(0,jsonStringify/* jsonStringify */.l)(sanitize(originalError))}` : (0,jsonStringify/* jsonStringify */.l)(sanitize(originalError)) : "Empty message";
}
function tryToGetFingerprint(originalError) {
	return (0,isError/* isError */.V)(originalError) && "dd_fingerprint" in originalError ? String(originalError.dd_fingerprint) : void 0;
}
function tryToGetErrorContext(originalError) {
	if ((0,typeUtils/* isIndexableObject */.sK)(originalError)) return originalError.dd_context;
}
function getFileFromStackTraceString(stack) {
	return /@ (.+)/.exec(stack)?.[1];
}
//#endregion


//# sourceMappingURL=error.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/error/trackRuntimeError.mjs










//#region src/domain/error/trackRuntimeError.ts
function trackRuntimeError() {
	return new tools_observable/* Observable */.y$((observer) => {
		const handleRuntimeError = (originalError, stackTrace) => {
			const rawError = computeRawError({
				stackTrace,
				originalError,
				startClocks: (0,entries_time/* clocksNow */.$I)(),
				nonErrorPrefix: "Uncaught",
				source: error_types/* ErrorSource.SOURCE */.zH.SOURCE,
				handling: "unhandled"
			});
			observer.notify(rawError);
		};
		const { stop: stopInstrumentingOnError } = instrumentOnError(handleRuntimeError);
		const { stop: stopInstrumentingOnUnhandledRejection } = instrumentUnhandledRejection(handleRuntimeError);
		return () => {
			stopInstrumentingOnError();
			stopInstrumentingOnUnhandledRejection();
		};
	});
}
function instrumentOnError(callback) {
	return (0,instrumentMethod/* instrumentMethod */.Su)(globalObject/* globalObject */.Z, "onerror", ({ parameters: [messageObj, url, line, column, errorObj] }) => {
		let stackTrace;
		if (!(0,isError/* isError */.V)(errorObj)) stackTrace = (0,computeStackTrace/* computeStackTraceFromOnErrorMessage */.f)(messageObj, url, line, column);
		callback(errorObj ?? messageObj, stackTrace);
	});
}
function instrumentUnhandledRejection(callback) {
	if (!(0,addEventListener/* isEventSupported */.jO)(globalObject/* globalObject.window */.Z.window, "unhandledrejection")) return { stop: functionUtils/* noop */.Z };
	return (0,instrumentMethod/* instrumentMethod */.Su)(globalObject/* globalObject */.Z, "onunhandledrejection", ({ parameters: [e] }) => {
		callback(e.reason || "Empty reason");
	});
}
//#endregion


//# sourceMappingURL=trackRuntimeError.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/responseUtils.mjs
var responseUtils = __webpack_require__(8708);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/readBytesFromStream.mjs


//#region src/tools/readBytesFromStream.ts
/**
* Read bytes from a ReadableStream until the end of the stream.
*/
async function readBytesFromStream(stream) {
	const reader = stream.getReader();
	const chunks = [];
	while (true) {
		const result = await reader.read();
		if (result.done) break;
		chunks.push(result.value);
	}
	reader.cancel().catch(functionUtils/* noop */.Z);
	return (0,byteUtils/* concatBuffers */.Kb)(chunks);
}
//#endregion


//# sourceMappingURL=readBytesFromStream.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/fetchObservable.mjs







//#region src/browser/fetchObservable.ts
/**
* Action to take with the response body of a fetch request.
* Values are ordered by priority: higher values take precedence when multiple actions are requested.
*/
let ResponseBodyAction = /* @__PURE__ */ function(ResponseBodyAction) {
	ResponseBodyAction[ResponseBodyAction["IGNORE"] = 0] = "IGNORE";
	ResponseBodyAction[ResponseBodyAction["COLLECT"] = 1] = "COLLECT";
	return ResponseBodyAction;
}({});
let fetchObservable;
const responseBodyActionGetters = [];
function initFetchObservable({ responseBodyAction } = {}) {
	if (responseBodyAction) responseBodyActionGetters.push(responseBodyAction);
	if (!fetchObservable) fetchObservable = createFetchObservable();
	return fetchObservable;
}
function createFetchObservable() {
	return new tools_observable/* Observable */.y$((observable) => {
		if (!globalObject/* globalObject.fetch */.Z.fetch) return;
		const { stop } = (0,instrumentMethod/* instrumentMethod */.Su)(globalObject/* globalObject */.Z, "fetch", (call) => beforeSend(call, observable), { computeHandlingStack: true });
		return stop;
	});
}
function beforeSend({ parameters, onPostCall, handlingStack }, observable) {
	const [input, init] = parameters;
	let methodFromParams = init?.method;
	if (methodFromParams === void 0 && input instanceof Request) methodFromParams = input.method;
	const method = methodFromParams !== void 0 ? String(methodFromParams).toUpperCase() : "GET";
	const url = input instanceof Request ? input.url : (0,urlPolyfill/* normalizeUrl */.D5)(String(input));
	const context = {
		state: "start",
		init,
		input,
		method,
		startClocks: (0,entries_time/* clocksNow */.$I)(),
		url,
		handlingStack,
		isAbortedOnStart: input instanceof Request && input.signal?.aborted || init?.signal?.aborted || false
	};
	observable.notify(context);
	parameters[0] = context.input;
	parameters[1] = context.init;
	onPostCall((responsePromise) => {
		afterSend(observable, responsePromise, context).catch(monitor/* monitorError */.$y);
	});
}
async function afterSend(observable, responsePromise, startContext) {
	const context = startContext;
	let response;
	try {
		response = await responsePromise;
	} catch (error) {
		observable.notify({
			...context,
			state: "resolve",
			status: 0,
			isAborted: context.init?.signal?.aborted || error instanceof DOMException && error.code === DOMException.ABORT_ERR,
			error
		});
		return;
	}
	context.response = response;
	context.status = response.status;
	context.responseType = response.type;
	context.isAborted = false;
	if (responseBodyActionGetters.reduce((action, getter) => Math.max(action, getter(context)), 0) === 1) {
		const clonedResponse = (0,responseUtils/* tryToClone */.u)(response);
		if (clonedResponse?.body) try {
			const bytes = await readBytesFromStream(clonedResponse.body);
			context.responseBody = new TextDecoder().decode(bytes);
		} catch {}
	}
	observable.notify({
		...context,
		state: "resolve"
	});
}
//#endregion


//# sourceMappingURL=fetchObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/console/consoleObservable.mjs











//#region src/domain/console/consoleObservable.ts
let consoleObservablesByApi = {};
function initConsoleObservable(apis) {
	return (0,tools_observable/* mergeObservables */.$Z)(...apis.map((api) => {
		if (!consoleObservablesByApi[api]) consoleObservablesByApi[api] = createConsoleObservable(api);
		return consoleObservablesByApi[api];
	}));
}
function createConsoleObservable(api) {
	return new tools_observable/* Observable */.y$((observable) => {
		const originalConsoleApi = util_display/* globalConsole */.jG[api];
		util_display/* globalConsole */.jG[api] = (...params) => {
			originalConsoleApi.apply(console, params);
			const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)("console error");
			(0,monitor/* callMonitored */.L6)(() => {
				observable.notify(buildConsoleLog(params, api, handlingStack));
			});
		};
		return () => {
			util_display/* globalConsole */.jG[api] = originalConsoleApi;
		};
	});
}
function buildConsoleLog(params, api, handlingStack) {
	const message = params.map((param) => formatConsoleParameters(param)).join(" ");
	if (api === util_display/* ConsoleApiName.error */.vA.error) {
		const rawError = computeRawError({
			originalError: params.find(isError/* isError */.V),
			handlingStack,
			startClocks: (0,entries_time/* clocksNow */.$I)(),
			source: error_types/* ErrorSource.CONSOLE */.zH.CONSOLE,
			handling: "handled",
			nonErrorPrefix: "Provided",
			useFallbackStack: false
		});
		rawError.message = message;
		return {
			api,
			message,
			handlingStack,
			error: rawError
		};
	}
	return {
		api,
		message,
		error: void 0,
		handlingStack
	};
}
function formatConsoleParameters(param) {
	if (typeof param === "string") return sanitize(param);
	if ((0,isError/* isError */.V)(param)) return (0,stackTrace_handlingStack/* formatErrorMessage */.jN)((0,computeStackTrace/* computeStackTrace */._)(param));
	return (0,jsonStringify/* jsonStringify */.l)(sanitize(param), void 0, 2);
}
//#endregion


//# sourceMappingURL=consoleObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/bufferedData.mjs








//#region src/domain/bufferedData.ts
const BUFFER_LIMIT = 500;
let BufferedDataType = /* @__PURE__ */ function(BufferedDataType) {
	BufferedDataType[BufferedDataType["RUNTIME_ERROR"] = 0] = "RUNTIME_ERROR";
	BufferedDataType[BufferedDataType["FETCH"] = 1] = "FETCH";
	BufferedDataType[BufferedDataType["XHR"] = 2] = "XHR";
	BufferedDataType[BufferedDataType["CONSOLE"] = 3] = "CONSOLE";
	return BufferedDataType;
}({});
function startBufferingData() {
	const observable = new tools_observable/* BufferedObservable */.fk(BUFFER_LIMIT, (count) => {
		(0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Early data collection dropped data on unbuffer", { count });
	});
	const subscriptions = [];
	function subscribe(type, source) {
		subscriptions.push(source.subscribe((data) => {
			observable.notify({
				type,
				data
			});
		}));
	}
	subscribe(0, (0,mockable/* mockable */.C)(trackRuntimeError)());
	subscribe(1, initFetchObservable());
	subscribe(2, initXhrObservable());
	subscribe(3, initConsoleObservable(Object.values(util_display/* ConsoleApiName */.vA)));
	return {
		observable,
		stop: () => subscriptions.forEach((subscription) => subscription.unsubscribe())
	};
}
//#endregion


//# sourceMappingURL=bufferedData.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/requestCollection.mjs






//#region src/domain/requestCollection.ts
let nextRequestIndex = 1;
function startRequestCollection(lifeCycle, configuration, sessionManager, userContext, accountContext, bufferedDataObservable) {
	const tracer = startTracer(configuration, sessionManager, userContext, accountContext);
	trackXhr(lifeCycle, tracer, bufferedDataObservable);
	trackFetch(lifeCycle, configuration, tracer, bufferedDataObservable);
}
function trackXhr(lifeCycle, tracer, bufferedDataObservable) {
	const subscriptions = [];
	subscriptions.push(initXhrObservable().subscribe((context) => {
		if (context.state === "start" && isAllowedRequestUrl(context.url)) {
			tracer.traceXhr(context, context.xhr);
			assignRequestIndex(context);
		}
	}));
	subscriptions.push(bufferedDataObservable.subscribe(({ data, type }) => {
		if (type !== BufferedDataType.XHR) return;
		const context = data;
		if (!isAllowedRequestUrl(context.url)) return;
		switch (context.state) {
			case "start":
				assignRequestIndex(context);
				lifeCycle.notify(7, {
					requestIndex: context.requestIndex,
					url: context.url
				});
				break;
			case "complete":
				tracer.clearTracingIfNeeded(context);
				lifeCycle.notify(8, {
					...context,
					type: RequestType.XHR,
					isAbortedOnStart: false
				});
				break;
		}
	}));
	return { stop: () => subscriptions.forEach((subscription) => subscription.unsubscribe()) };
}
function trackFetch(lifeCycle, configuration, tracer, bufferedDataObservable) {
	const subscriptions = [];
	subscriptions.push(initFetchObservable({ responseBodyAction: (context) => {
		if (findGraphQlConfiguration(context.url, configuration)?.trackResponseErrors) return ResponseBodyAction.COLLECT;
		return ResponseBodyAction.IGNORE;
	} }).subscribe((context) => {
		if (context.state === "start" && isAllowedRequestUrl(context.url)) {
			tracer.traceFetch(context);
			assignRequestIndex(context);
		}
	}));
	subscriptions.push(bufferedDataObservable.subscribe(({ data, type }) => {
		if (type !== BufferedDataType.FETCH) return;
		const context = data;
		if (!isAllowedRequestUrl(context.url)) return;
		switch (context.state) {
			case "start":
				assignRequestIndex(context);
				lifeCycle.notify(7, {
					requestIndex: context.requestIndex,
					url: context.url
				});
				break;
			case "resolve":
				tracer.clearTracingIfNeeded(context);
				lifeCycle.notify(8, {
					...context,
					duration: (0,entries_time/* elapsed */._J)(context.startClocks.timeStamp, (0,entries_time/* timeStampNow */.n$)()),
					type: RequestType.FETCH,
					requestBody: context.init?.body
				});
				break;
		}
	}));
	return { stop: () => subscriptions.forEach((subscription) => subscription.unsubscribe()) };
}
function assignRequestIndex(context) {
	if (!context.requestIndex) context.requestIndex = nextRequestIndex++;
}
//#endregion


//# sourceMappingURL=requestCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/webSocketObservable.mjs






//#region src/browser/webSocketObservable.ts
function isGlobalWithWebSocket(global) {
	return typeof global.WebSocket === "function";
}
let webSocketObservable;
function initWebSocketObservable() {
	if (!webSocketObservable) webSocketObservable = createWebSocketObservable();
	return webSocketObservable;
}
function createWebSocketObservable() {
	return new tools_observable/* Observable */.y$((observable) => {
		if (!isGlobalWithWebSocket(globalObject/* globalObject */.Z)) return;
		const { stop: stopInstrumentingConstructor } = (0,instrumentMethod/* instrumentConstructor */.t1)(globalObject/* globalObject */.Z, "WebSocket", ({ parameters, onPostCall }) => {
			const protocols = Array.isArray(parameters[1]) ? [].concat(parameters[1]) : parameters[1];
			const startClocks = (0,entries_time/* clocksNow */.$I)();
			onPostCall((instance) => {
				observable.notify({
					state: "connecting",
					instance,
					url: instance.url,
					protocols,
					startClocks
				});
				attachInstanceListeners(instance, observable);
			});
		});
		const { stop: stopInstrumentingSend } = (0,instrumentMethod/* instrumentMethod */.Su)(globalObject/* globalObject.WebSocket.prototype */.Z.WebSocket.prototype, "send", ({ target: instance, parameters: [data], onPostCall }) => {
			const size = computePayloadSize(data);
			const bufferedAmountPreSend = instance.bufferedAmount;
			onPostCall(() => {
				observable.notify({
					state: "message-out",
					instance,
					size,
					bufferedAmountPreSend,
					at: (0,entries_time/* clocksNow */.$I)()
				});
			});
		});
		return () => {
			stopInstrumentingConstructor();
			stopInstrumentingSend();
		};
	});
}
function attachInstanceListeners(instance, observable) {
	const { stop: stopOpen } = (0,addEventListener/* addEventListener */.Oo)(instance, "open", () => {
		observable.notify({
			state: "open",
			instance,
			openClocks: (0,entries_time/* clocksNow */.$I)(),
			protocol: instance.protocol || ""
		});
		stopOpen();
	});
	const { stop: stopMessage } = (0,addEventListener/* addEventListener */.Oo)(instance, "message", (event) => {
		observable.notify({
			state: "message-in",
			instance,
			size: computePayloadSize(event.data),
			at: (0,entries_time/* clocksNow */.$I)()
		});
	});
	const { stop: stopClose } = (0,addEventListener/* addEventListener */.Oo)(instance, "close", (event) => {
		observable.notify({
			state: "closed",
			instance,
			code: event.code,
			reason: event.reason,
			wasClean: event.wasClean,
			at: (0,entries_time/* clocksNow */.$I)()
		});
		stopMessage();
		stopClose();
	});
}
function computePayloadSize(data) {
	if (typeof data === "string") return (0,byteUtils/* computeBytesCount */.qt)(data);
	if (data instanceof ArrayBuffer || ArrayBuffer.isView(data)) return data.byteLength;
	if (typeof Blob !== "undefined" && data instanceof Blob) return data.size;
	return 0;
}
//#endregion


//# sourceMappingURL=webSocketObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/webSocketCollection.mjs





//#region src/domain/resource/webSocketCollection.ts
const WEBSOCKET_CONNECTING_VITAL_NAME = "websocket-connecting";
const WEBSOCKET_CLOSED_VITAL_NAME = "websocket-closed";
function startWebSocketCollection(lifeCycle, viewHistory, addDurationVital) {
	const tracker = trackWebSocket(lifeCycle, initWebSocketObservable(), viewHistory, addDurationVital);
	const sessionExpiredSubscription = lifeCycle.subscribe(10, () => {
		tracker.flushOpenConnections("session_end");
	});
	return { stop: () => {
		sessionExpiredSubscription.unsubscribe();
		tracker.flushOpenConnections("session_end");
		tracker.stop();
	} };
}
function trackWebSocket(lifeCycle, webSocketContextObservable, viewHistory, addDurationVital) {
	const webSocketRegistry = /* @__PURE__ */ new Map();
	function completeConnection(webSocket, endInfo, reason) {
		const completedEvent = buildCompletedEvent(webSocket, endInfo, reason, viewHistory);
		lifeCycle.notify(9, completedEvent);
		addDurationVital({
			id: generateUUID(),
			name: WEBSOCKET_CLOSED_VITAL_NAME,
			type: VitalType.DURATION,
			startClocks: completedEvent.endClocks,
			duration: 0,
			context: sanitize({
				url: completedEvent.url,
				connection_id: completedEvent.connectionId
			})
		});
	}
	const subscription = webSocketContextObservable.subscribe((context) => {
		switch (context.state) {
			case "connecting": {
				const connectionId = generateUUID();
				const startViewId = viewHistory.findView(context.startClocks.relative)?.id;
				const url = sanitizeWebSocketUrl(context.url);
				const webSocket = {
					webSocket: context.instance,
					connectionId,
					url,
					startClocks: context.startClocks,
					startViewId,
					messagesIn: {
						count: 0,
						size: 0
					},
					messagesOut: {
						count: 0,
						size: 0
					},
					longestInboundSilence: 0,
					bufferedAmountMax: 0
				};
				webSocketRegistry.set(context.instance, webSocket);
				addDurationVital({
					id: generateUUID(),
					name: WEBSOCKET_CONNECTING_VITAL_NAME,
					type: VitalType.DURATION,
					startClocks: context.startClocks,
					duration: 0,
					context: sanitize({
						url,
						connection_id: connectionId
					})
				});
				return;
			}
			case "open": {
				const webSocket = webSocketRegistry.get(context.instance);
				if (!webSocket) return;
				webSocket.openClocks = context.openClocks;
				webSocket.protocol = context.protocol;
				webSocket.setupDuration = (0,entries_time/* elapsed */._J)(webSocket.startClocks.timeStamp, context.openClocks.timeStamp);
				return;
			}
			case "message-in": {
				const webSocket = webSocketRegistry.get(context.instance);
				if (!webSocket) return;
				webSocket.messagesIn.count += 1;
				webSocket.messagesIn.size += context.size;
				recordMessageTiming(webSocket, context.at, "in");
				return;
			}
			case "message-out": {
				const webSocket = webSocketRegistry.get(context.instance);
				if (!webSocket) return;
				if (context.bufferedAmountPreSend > webSocket.bufferedAmountMax) webSocket.bufferedAmountMax = context.bufferedAmountPreSend;
				webSocket.messagesOut.count += 1;
				webSocket.messagesOut.size += context.size;
				recordMessageTiming(webSocket, context.at, "out");
				return;
			}
			case "closed": {
				const webSocket = webSocketRegistry.get(context.instance);
				if (!webSocket) return;
				webSocketRegistry.delete(context.instance);
				completeConnection(webSocket, context, "close_event");
				return;
			}
		}
	});
	return {
		flushOpenConnections: (reason) => {
			const at = (0,entries_time/* clocksNow */.$I)();
			webSocketRegistry.forEach((webSocket) => {
				completeConnection(webSocket, { at }, reason);
			});
			webSocketRegistry.clear();
		},
		stop: () => {
			subscription.unsubscribe();
			webSocketRegistry.clear();
		}
	};
}
function sanitizeWebSocketUrl(url) {
	const sanitizedUrl = (0,urlPolyfill/* buildUrl */.Q2)(url);
	sanitizedUrl.search = "";
	return sanitizedUrl.href;
}
function recordMessageTiming(webSocket, at, direction) {
	if (webSocket.openClocks === void 0) return;
	const offset = (0,entries_time/* elapsed */._J)(webSocket.openClocks.timeStamp, at.timeStamp);
	if (direction === "in" && webSocket.firstMessageInOffset === void 0) webSocket.firstMessageInOffset = offset;
	else if (direction === "out" && webSocket.firstMessageOutOffset === void 0) webSocket.firstMessageOutOffset = offset;
	if (direction === "in") {
		if (webSocket.lastMessageInAt !== void 0) {
			const gap = (0,entries_time/* elapsed */._J)(webSocket.lastMessageInAt, at.timeStamp);
			if (gap > webSocket.longestInboundSilence) webSocket.longestInboundSilence = gap;
		}
		webSocket.lastMessageInAt = at.timeStamp;
	}
}
function buildCompletedEvent(webSocket, endInfo, trackingEndReason, viewHistory) {
	const endClocks = endInfo.at;
	const endViewId = trackingEndReason === "session_end" ? viewHistory.findView(endClocks.relative, { returnInactive: true })?.id : viewHistory.findView(endClocks.relative)?.id;
	const inboundIdleDurationBeforeClose = webSocket.lastMessageInAt !== void 0 ? (0,entries_time/* elapsed */._J)(webSocket.lastMessageInAt, endClocks.timeStamp) : void 0;
	const { openClocks, ...rest } = webSocket;
	return {
		...rest,
		endClocks,
		endViewId,
		inboundIdleDurationBeforeClose,
		trackingEndReason,
		handshakeSucceeded: openClocks !== void 0,
		setupDuration: webSocket.setupDuration ?? (0,entries_time/* elapsed */._J)(webSocket.startClocks.timeStamp, endClocks.timeStamp),
		closeCode: endInfo.code,
		closeReason: endInfo.reason,
		wasClean: endInfo.wasClean
	};
}
//#endregion


//# sourceMappingURL=webSocketCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/discardNegativeDuration.mjs

//#region src/domain/discardNegativeDuration.ts
function discardNegativeDuration(duration) {
	return (0,numberUtils/* isNumber */.hj)(duration) && duration < 0 ? void 0 : duration;
}
//#endregion


//# sourceMappingURL=discardNegativeDuration.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/waitPageActivityEnd.mjs





const EXCLUDED_MUTATIONS_ATTRIBUTE = "data-dd-excluded-activity-mutations";
/**
* Wait for the page activity end
*
* Detection lifecycle:
* ```
*                        Wait page activity end
*              .-------------------'--------------------.
*              v                                        v
*     [Wait for a page activity ]          [Wait for a maximum duration]
*     [timeout: VALIDATION_DELAY]          [  timeout: maxDuration     ]
*          /                  \                           |
*         v                    v                          |
*  [No page activity]   [Page activity]                   |
*         |                   |,----------------------.   |
*         v                   v                       |   |
*     (Discard)     [Wait for a page activity]        |   |
*                   [   timeout: END_DELAY   ]        |   |
*                       /                \            |   |
*                      v                  v           |   |
*             [No page activity]    [Page activity]   |   |
*                      |                 |            |   |
*                      |                 '------------'   |
*                      '-----------. ,--------------------'
*                                   v
*                                 (End)
* ```
*
* Note: by assuming that maxDuration is greater than VALIDATION_DELAY, we are sure that if the
* process is still alive after maxDuration, it has been validated.
*/
function waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, pageActivityEndCallback, maxDuration) {
	const pageActivityObservable = (0,mockable/* mockable */.C)(createPageActivityObservable)(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
	let pageActivityEndTimeoutId;
	let hasCompleted = false;
	const validationTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(() => complete({ hadActivity: false })), 100);
	const maxDurationTimeoutId = maxDuration !== void 0 ? (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(() => complete({
		hadActivity: true,
		end: (0,entries_time/* timeStampNow */.n$)()
	})), maxDuration) : void 0;
	const pageActivitySubscription = pageActivityObservable.subscribe(({ isBusy }) => {
		(0,timer/* clearTimeout */.gr)(validationTimeoutId);
		(0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
		const lastChangeTime = (0,entries_time/* timeStampNow */.n$)();
		if (!isBusy) pageActivityEndTimeoutId = (0,timer/* setTimeout */.iK)((0,monitor/* monitor */.zk)(() => complete({
			hadActivity: true,
			end: lastChangeTime
		})), 100);
	});
	const stop = () => {
		hasCompleted = true;
		(0,timer/* clearTimeout */.gr)(validationTimeoutId);
		(0,timer/* clearTimeout */.gr)(pageActivityEndTimeoutId);
		(0,timer/* clearTimeout */.gr)(maxDurationTimeoutId);
		pageActivitySubscription.unsubscribe();
	};
	function complete(event) {
		if (hasCompleted) return;
		stop();
		pageActivityEndCallback(event);
	}
	return { stop };
}
function createPageActivityObservable(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
	return new tools_observable/* Observable */.y$((observable) => {
		const subscriptions = [];
		let firstRequestIndex;
		let pendingRequestsCount = 0;
		subscriptions.push(domMutationObservable.subscribe((mutations) => {
			if (!mutations.every(isExcludedMutation)) notifyPageActivity();
		}), windowOpenObservable.subscribe(notifyPageActivity), createPerformanceObservable({ type: "resource" }).subscribe((entries) => {
			if (entries.some((entry) => !isExcludedUrl(configuration, entry.name))) notifyPageActivity();
		}), lifeCycle.subscribe(7, (startEvent) => {
			if (isExcludedUrl(configuration, startEvent.url)) return;
			if (firstRequestIndex === void 0) firstRequestIndex = startEvent.requestIndex;
			pendingRequestsCount += 1;
			notifyPageActivity();
		}), lifeCycle.subscribe(8, (request) => {
			if (isExcludedUrl(configuration, request.url) || firstRequestIndex === void 0 || request.requestIndex < firstRequestIndex) return;
			pendingRequestsCount -= 1;
			notifyPageActivity();
		}));
		return () => {
			subscriptions.forEach((s) => s.unsubscribe());
		};
		function notifyPageActivity() {
			observable.notify({ isBusy: pendingRequestsCount > 0 });
		}
	});
}
function isExcludedUrl(configuration, requestUrl) {
	return matchList(configuration.excludedActivityUrls, requestUrl);
}
function isExcludedMutation(mutation) {
	const targetElement = mutation.type === "characterData" ? mutation.target.parentElement : mutation.target;
	return Boolean(targetElement && isElementNode(targetElement) && targetElement.matches(`[data-dd-excluded-activity-mutations], [data-dd-excluded-activity-mutations] *`));
}
//#endregion


//# sourceMappingURL=waitPageActivityEnd.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/trackEventCounts.mjs



//#region src/domain/trackEventCounts.ts
function trackEventCounts({ lifeCycle, isChildEvent, onChange: callback = functionUtils/* noop */.Z }) {
	const eventCounts = {
		errorCount: 0,
		longTaskCount: 0,
		resourceCount: 0,
		actionCount: 0,
		frustrationCount: 0
	};
	const subscription = lifeCycle.subscribe(14, (event) => {
		if (event.type === "view" || event.type === "vital" || !isChildEvent(event)) return;
		switch (event.type) {
			case RumEventType.ERROR:
				eventCounts.errorCount += 1;
				callback();
				break;
			case RumEventType.ACTION:
				eventCounts.actionCount += 1;
				if (event.action.frustration) eventCounts.frustrationCount += event.action.frustration.type.length;
				callback();
				break;
			case RumEventType.LONG_TASK:
				eventCounts.longTaskCount += 1;
				callback();
				break;
			case RumEventType.RESOURCE:
				if (!event._dd?.discarded) {
					eventCounts.resourceCount += 1;
					callback();
				}
				break;
		}
	});
	return {
		stop: () => {
			subscription.unsubscribe();
		},
		eventCounts
	};
}
//#endregion


//# sourceMappingURL=trackEventCounts.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/eventTracker.mjs





//#region src/domain/eventTracker.ts
const EVENT_CONTEXT_TIME_OUT_DELAY = 5 * entries_time/* ONE_MINUTE */.yR;
function startEventTracker(lifeCycle) {
	const history = (0,valueHistory/* createValueHistory */.p)({ expireDelay: EVENT_CONTEXT_TIME_OUT_DELAY });
	const keyedEvents = /* @__PURE__ */ new Map();
	function cleanUpEvent(event) {
		keyedEvents.delete(event.key);
		event.eventCounts?.stop();
	}
	function discardAll() {
		keyedEvents.forEach((event) => {
			cleanUpEvent(event);
		});
		history.reset();
	}
	const sessionRenewalSubscription = lifeCycle.subscribe(11, discardAll);
	function start(key, startClocks, data, options) {
		const id = generateUUID();
		const historyEntry = history.add(id, startClocks.relative);
		const existing = keyedEvents.get(key);
		if (existing) cleanUpEvent(existing);
		const trackedEventData = {
			id,
			key,
			startClocks,
			data,
			historyEntry,
			eventCounts: options?.isChildEvent ? trackEventCounts({
				lifeCycle,
				isChildEvent: options.isChildEvent(id)
			}) : void 0
		};
		keyedEvents.set(key, trackedEventData);
		return trackedEventData;
	}
	function stop(key, stopClocks, extraData) {
		const event = keyedEvents.get(key);
		if (!event) return;
		const finalData = extraData ? (0,mergeInto/* combine */.$e)(event.data, extraData) : event.data;
		event.historyEntry.close(stopClocks.relative);
		const duration = (0,entries_time/* elapsed */._J)(event.startClocks.timeStamp, stopClocks.timeStamp);
		const counts = event.eventCounts?.eventCounts;
		cleanUpEvent(event);
		return {
			...finalData,
			id: event.id,
			startClocks: event.startClocks,
			duration,
			counts
		};
	}
	function discard(key) {
		const event = keyedEvents.get(key);
		if (!event) return;
		const counts = event.eventCounts?.eventCounts;
		cleanUpEvent(event);
		event.historyEntry.remove();
		return {
			...event.data,
			id: event.id,
			startClocks: event.startClocks,
			counts
		};
	}
	function findId(startTime) {
		return history.findAll(startTime);
	}
	function getCounts(key) {
		return keyedEvents.get(key)?.eventCounts?.eventCounts;
	}
	function stopTracker() {
		sessionRenewalSubscription.unsubscribe();
		discardAll();
		history.stop();
	}
	return {
		start,
		stop,
		discard,
		getCounts,
		findId,
		stopAll: stopTracker
	};
}
//#endregion


//# sourceMappingURL=eventTracker.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/getComposedPathSelector.mjs


//#region src/domain/getComposedPathSelector.ts
const FILTERED_TAGNAMES = ["HTML", "BODY"];
/**
* arbitrary value, we want to truncate the selector if it exceeds the limit
*/
const CHARACTER_LIMIT = 2 * byteUtils/* ONE_KIBI_BYTE */.Hi;
/**
* Safe attributes that can be collected without PII concerns.
* These are commonly used for testing, accessibility, and UI identification.
*/
const SAFE_ATTRIBUTES = STABLE_ATTRIBUTES.concat([
	"role",
	"type",
	"disabled",
	"readonly",
	"tabindex",
	"draggable",
	"target",
	"rel",
	"download",
	"method",
	"action",
	"enctype",
	"autocomplete"
]);
/**
* Extracts a selector string from a MouseEvent composedPath.
*
* This function:
* 1. Filters out non-Element items (Document, Window, ShadowRoot)
* 2. Extracts a selector string from each element
* 3. Truncates the selector string if it exceeds the character limit
* 4. Returns the selector string
*
* @param composedPath - The composedPath from a MouseEvent
* @returns A selector string
*/
function getComposedPathSelector(composedPath, actionNameAttribute) {
	const elements = composedPath.filter((el) => el instanceof Element && !FILTERED_TAGNAMES.includes(el.tagName));
	if (elements.length === 0) return "";
	const allowedAttributes = actionNameAttribute ? [actionNameAttribute].concat(SAFE_ATTRIBUTES) : SAFE_ATTRIBUTES;
	let result = "";
	for (const element of elements) {
		const part = getSelectorStringFromElement(element, allowedAttributes);
		result += part;
		if (result.length >= CHARACTER_LIMIT) return safeTruncate(result, CHARACTER_LIMIT);
	}
	return result;
}
/**
* Extracts a selector string from an element.
*/
function getSelectorStringFromElement(element, allowedAttributes) {
	const tagName = getTagNameSelector(element);
	const id = getIDSelector(element);
	const classes = getElementClassesString(element);
	const attributes = extractSafeAttributesString(element, allowedAttributes);
	const positionData = computePositionDataString(element);
	return `${tagName}${id || ""}${attributes}${classes}${positionData};`;
}
function getElementClassesString(element) {
	return Array.from(element.classList).filter((c) => !isGeneratedValue(c)).sort().map((c) => `.${CSS.escape(c)}`).join("");
}
/**
* Computes the nthChild and nthOfType positions for an element.
*
* @param element - The element to compute the position data for
* @returns A string of the form ":nth-child(1):nth-of-type(1)"
*/
function computePositionDataString(element) {
	const siblings = Array.from(element.parentNode.children);
	if (siblings.length <= 1) return "";
	const sameTypeSiblings = siblings.filter((sibling) => sibling.tagName === element.tagName);
	const nthChild = siblings.indexOf(element);
	const nthOfType = getNthOfTypeSelector(element);
	return `:nth-child(${nthChild + 1})${sameTypeSiblings.length > 1 ? `:nth-of-type(${nthOfType})` : ""}`;
}
/**
* Extracts only the safe (allowlisted) attributes from an element.
* The attributes are sorted alphabetically by name.
*/
function extractSafeAttributesString(element, allowedAttributes) {
	const result = [];
	const attributes = Array.from(element.attributes);
	for (const attribute of attributes) if (allowedAttributes.includes(attribute.name)) result.push(getAttributeValueSelector(attribute.name, attribute.value));
	return result.sort().join("");
}
//#endregion


//# sourceMappingURL=getComposedPathSelector.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/clickChain.mjs


//#region src/domain/action/clickChain.ts
const MAX_DURATION_BETWEEN_CLICKS = entries_time/* ONE_SECOND */.WT;
function createClickChain(firstClick, onFinalize) {
	const bufferedClicks = [];
	let status = 0;
	let maxDurationBetweenClicksTimeoutId;
	appendClick(firstClick);
	function appendClick(click) {
		click.stopObservable.subscribe(tryFinalize);
		bufferedClicks.push(click);
		(0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
		maxDurationBetweenClicksTimeoutId = (0,timer/* setTimeout */.iK)(dontAcceptMoreClick, MAX_DURATION_BETWEEN_CLICKS);
	}
	function tryFinalize() {
		if (status === 1 && bufferedClicks.every((click) => click.isStopped())) {
			status = 2;
			onFinalize(bufferedClicks);
		}
	}
	function dontAcceptMoreClick() {
		(0,timer/* clearTimeout */.gr)(maxDurationBetweenClicksTimeoutId);
		if (status === 0) {
			status = 1;
			tryFinalize();
		}
	}
	return {
		tryAppend: (click) => {
			if (status !== 0) return false;
			if (bufferedClicks.length > 0 && !areEventsSimilar(bufferedClicks[bufferedClicks.length - 1].event, click.event)) {
				dontAcceptMoreClick();
				return false;
			}
			appendClick(click);
			return true;
		},
		stop: () => {
			dontAcceptMoreClick();
		}
	};
}
/**
* Checks whether two events are similar by comparing their target, position and timestamp
*/
function areEventsSimilar(first, second) {
	return first.target === second.target && mouseEventDistance(first, second) <= 100 && first.timeStamp - second.timeStamp <= MAX_DURATION_BETWEEN_CLICKS;
}
function mouseEventDistance(origin, other) {
	return Math.sqrt(Math.pow(origin.clientX - other.clientX, 2) + Math.pow(origin.clientY - other.clientY, 2));
}
//#endregion


//# sourceMappingURL=clickChain.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/getActionNameFromElement.mjs





//#region src/domain/action/getActionNameFromElement.ts
function getActionNameFromElement(element, rumConfiguration, nodePrivacyLevel = NodePrivacyLevel.ALLOW) {
	const nodePrivacyLevelCache = /* @__PURE__ */ new Map();
	const { actionNameAttribute: userProgrammaticAttribute } = rumConfiguration;
	const defaultActionName = getActionNameFromElementProgrammatically(element, "data-dd-action-name") || userProgrammaticAttribute && getActionNameFromElementProgrammatically(element, userProgrammaticAttribute);
	if (defaultActionName) return {
		name: defaultActionName,
		nameSource: "custom_attribute"
	};
	else if (nodePrivacyLevel === NodePrivacyLevel.MASK) return {
		name: ACTION_NAME_PLACEHOLDER,
		nameSource: "mask_placeholder"
	};
	return getActionNameFromElementForStrategies(element, priorityStrategies, rumConfiguration, nodePrivacyLevelCache) || getActionNameFromElementForStrategies(element, fallbackStrategies, rumConfiguration, nodePrivacyLevelCache) || {
		name: "",
		nameSource: "blank"
	};
}
function getActionNameFromElementProgrammatically(targetElement, programmaticAttribute) {
	const elementWithAttribute = closestShadowAware(targetElement, `[${programmaticAttribute}]`);
	if (!elementWithAttribute) return;
	return truncate(normalizeWhitespace(elementWithAttribute.getAttribute(programmaticAttribute).trim()));
}
function closestShadowAware(element, selector) {
	let current = element;
	while (current) {
		if (current.matches(selector)) return current;
		current = getParentElement(current);
	}
	return null;
}
const priorityStrategies = [
	(element, rumConfiguration, nodePrivacyLevelCache) => {
		if ("labels" in element && element.labels && element.labels.length > 0) return getActionNameFromTextualContent(element.labels[0], rumConfiguration, nodePrivacyLevelCache);
	},
	(element) => {
		if (element.nodeName === "INPUT") {
			const input = element;
			const type = input.getAttribute("type");
			if (type === "button" || type === "submit" || type === "reset") return {
				name: input.value,
				nameSource: "text_content"
			};
		}
	},
	(element, rumConfiguration, nodePrivacyLevelCache) => {
		if (element.nodeName === "BUTTON" || element.nodeName === "LABEL" || element.getAttribute("role") === "button") return getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache);
	},
	(element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, "aria-label", rumConfiguration, nodePrivacyLevelCache),
	(element, rumConfiguration, nodePrivacyLevelCache) => {
		const labelledByAttribute = element.getAttribute("aria-labelledby");
		if (labelledByAttribute) return {
			name: labelledByAttribute.split(/\s+/).map((id) => getElementById(element, id)).filter((label) => Boolean(label)).map((element) => getTextualContent(element, rumConfiguration, nodePrivacyLevelCache)).join(" "),
			nameSource: "text_content"
		};
	},
	(element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, "alt", rumConfiguration, nodePrivacyLevelCache),
	(element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, "name", rumConfiguration, nodePrivacyLevelCache),
	(element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, "title", rumConfiguration, nodePrivacyLevelCache),
	(element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromStandardAttribute(element, "placeholder", rumConfiguration, nodePrivacyLevelCache),
	(element, rumConfiguration, nodePrivacyLevelCache) => {
		if ("options" in element && element.options.length > 0) return getActionNameFromTextualContent(element.options[0], rumConfiguration, nodePrivacyLevelCache);
	}
];
const fallbackStrategies = [(element, rumConfiguration, nodePrivacyLevelCache) => getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache)];
/**
* Iterates over the target element and its parent, using the strategies list to get an action name.
* Each strategies are applied on each element, stopping as soon as a non-empty value is returned.
*/
const MAX_PARENTS_TO_CONSIDER = 10;
function getActionNameFromElementForStrategies(targetElement, strategies, rumConfiguration, nodePrivacyLevelCache) {
	let element = targetElement;
	let recursionCounter = 0;
	while (recursionCounter <= MAX_PARENTS_TO_CONSIDER && element && element.nodeName !== "BODY" && element.nodeName !== "HTML" && element.nodeName !== "HEAD") {
		for (const strategy of strategies) {
			const actionName = strategy(element, rumConfiguration, nodePrivacyLevelCache);
			if (actionName) {
				const { name, nameSource } = actionName;
				const trimmedName = name?.trim();
				if (trimmedName) return {
					name: truncate(normalizeWhitespace(trimmedName)),
					nameSource
				};
			}
		}
		if (element.nodeName === "FORM") break;
		element = getParentElement(element);
		recursionCounter += 1;
	}
}
function normalizeWhitespace(s) {
	return s.replace(/\s+/g, " ");
}
function truncate(s) {
	return s.length > 100 ? `${safeTruncate(s, 100)} [...]` : s;
}
function getElementById(refElement, id) {
	const rootNode = refElement.getRootNode();
	if (rootNode instanceof ShadowRoot) {
		const shadowElement = rootNode.getElementById(id);
		if (shadowElement) return shadowElement;
	}
	return refElement.ownerDocument ? refElement.ownerDocument.getElementById(id) : null;
}
function getActionNameFromStandardAttribute(element, attribute, rumConfiguration, nodePrivacyLevelCache) {
	const { enablePrivacyForActionName, defaultPrivacyLevel } = rumConfiguration;
	let attributeValue = element.getAttribute(attribute);
	if (attributeValue && enablePrivacyForActionName) {
		const nodePrivacyLevel = getNodePrivacyLevel(element, defaultPrivacyLevel, nodePrivacyLevelCache);
		if (shouldMaskAttribute(element.tagName, attribute, attributeValue, nodePrivacyLevel, rumConfiguration)) attributeValue = maskDisallowedTextContent(attributeValue, ACTION_NAME_PLACEHOLDER);
	} else if (!attributeValue) attributeValue = "";
	return {
		name: attributeValue,
		nameSource: "standard_attribute"
	};
}
function getActionNameFromTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
	return {
		name: getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) || "",
		nameSource: "text_content"
	};
}
function getTextualContent(element, rumConfiguration, nodePrivacyLevelCache) {
	if (element.isContentEditable) return;
	const { enablePrivacyForActionName, actionNameAttribute: userProgrammaticAttribute, defaultPrivacyLevel } = rumConfiguration;
	const walker = document.createTreeWalker(element, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, rejectInvisibleOrMaskedElementsFilter);
	let text = "";
	while (walker.nextNode()) {
		const node = walker.currentNode;
		if (isElementNode(node)) {
			if (node.nodeName === "BR" || node.nodeName === "P" || [
				"block",
				"flex",
				"grid",
				"list-item",
				"table",
				"table-caption"
			].includes(getComputedStyle(node).display)) text += " ";
			continue;
		}
		text += node.textContent || "";
	}
	return text.replace(/\s+/g, " ").trim();
	function rejectInvisibleOrMaskedElementsFilter(node) {
		const nodeSelfPrivacyLevel = getNodePrivacyLevel(node, defaultPrivacyLevel, nodePrivacyLevelCache);
		if (enablePrivacyForActionName && nodeSelfPrivacyLevel && shouldMaskNode(node, nodeSelfPrivacyLevel)) return NodeFilter.FILTER_REJECT;
		if (isElementNode(node)) {
			if (node.hasAttribute("data-dd-action-name") || userProgrammaticAttribute && node.hasAttribute(userProgrammaticAttribute)) return NodeFilter.FILTER_REJECT;
			const style = getComputedStyle(node);
			if (style.visibility !== "visible" || style.display === "none" || style.contentVisibility && style.contentVisibility !== "visible") return NodeFilter.FILTER_REJECT;
		}
		return NodeFilter.FILTER_ACCEPT;
	}
}
//#endregion


//# sourceMappingURL=getActionNameFromElement.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/listenActionEvents.mjs

//#region src/domain/action/listenActionEvents.ts
function listenActionEvents({ onPointerDown, onPointerUp }) {
	let selectionEmptyAtPointerDown;
	let userActivity = {
		selection: false,
		input: false,
		scroll: false
	};
	let clickContext;
	const listeners = [
		(0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN, (event) => {
			if (isValidPointerEvent(event)) {
				selectionEmptyAtPointerDown = isSelectionEmpty();
				userActivity = {
					selection: false,
					input: false,
					scroll: false
				};
				clickContext = onPointerDown(event);
			}
		}, { capture: true }),
		(0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.SELECTION_CHANGE */.EZ.SELECTION_CHANGE, () => {
			if (!selectionEmptyAtPointerDown || !isSelectionEmpty()) userActivity.selection = true;
		}, { capture: true }),
		(0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.SCROLL */.EZ.SCROLL, () => {
			userActivity.scroll = true;
		}, {
			capture: true,
			passive: true
		}),
		(0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.POINTER_UP */.EZ.POINTER_UP, (event) => {
			if (isValidPointerEvent(event) && clickContext) {
				const localUserActivity = userActivity;
				onPointerUp(clickContext, event, () => localUserActivity);
				clickContext = void 0;
			}
		}, { capture: true }),
		(0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.INPUT */.EZ.INPUT, () => {
			userActivity.input = true;
		}, { capture: true })
	];
	return { stop: () => {
		listeners.forEach((listener) => listener.stop());
	} };
}
function isSelectionEmpty() {
	const selection = window.getSelection();
	return !selection || selection.isCollapsed;
}
function isValidPointerEvent(event) {
	return event.target instanceof Element && event.isPrimary !== false;
}
//#endregion


//# sourceMappingURL=listenActionEvents.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/computeFrustration.mjs


//#region src/domain/action/computeFrustration.ts
const MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE = 3;
function computeFrustration(clicks, rageClick) {
	if (isRage(clicks)) {
		rageClick.addFrustration(FrustrationType.RAGE_CLICK);
		if (clicks.some(isDead)) rageClick.addFrustration(FrustrationType.DEAD_CLICK);
		if (rageClick.hasError) rageClick.addFrustration(FrustrationType.ERROR_CLICK);
		return { isRage: true };
	}
	const hasSelectionChanged = clicks.some((click) => click.getUserActivity().selection);
	clicks.forEach((click) => {
		if (click.hasError) click.addFrustration(FrustrationType.ERROR_CLICK);
		if (isDead(click) && !hasSelectionChanged) click.addFrustration(FrustrationType.DEAD_CLICK);
	});
	return { isRage: false };
}
function isRage(clicks) {
	if (clicks.some((click) => click.getUserActivity().selection || click.getUserActivity().scroll)) return false;
	for (let i = 0; i < clicks.length - (MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1); i += 1) if (clicks[i + MIN_CLICKS_PER_SECOND_TO_CONSIDER_RAGE - 1].event.timeStamp - clicks[i].event.timeStamp <= entries_time/* ONE_SECOND */.WT) return true;
	return false;
}
const DEAD_CLICK_EXCLUDE_SELECTOR = "input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"button\"]):not([type=\"submit\"]):not([type=\"reset\"]):not([type=\"range\"]),textarea,select,[contenteditable],[contenteditable] *,canvas,a[href],a[href] *";
function isDead(click) {
	if (click.hasPageActivity || click.getUserActivity().input || click.getUserActivity().scroll) return false;
	let target = click.event.target;
	if (target.tagName === "LABEL" && target.hasAttribute("for")) target = document.getElementById(target.getAttribute("for"));
	return !target?.matches(DEAD_CLICK_EXCLUDE_SELECTOR);
}
//#endregion


//# sourceMappingURL=computeFrustration.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/interactionSelectorCache.mjs

//#region src/domain/action/interactionSelectorCache.ts
const CLICK_ACTION_MAX_DURATION = 10 * entries_time/* ONE_SECOND */.WT;
const interactionSelectorCache = /* @__PURE__ */ new Map();
function getInteractionSelector(relativeTimestamp) {
	const selector = interactionSelectorCache.get(relativeTimestamp);
	interactionSelectorCache.delete(relativeTimestamp);
	return selector;
}
function updateInteractionSelector(relativeTimestamp, selector) {
	interactionSelectorCache.set(relativeTimestamp, selector);
	interactionSelectorCache.forEach((_, relativeTimestamp) => {
		if ((0,entries_time/* elapsed */._J)(relativeTimestamp, (0,entries_time/* relativeNow */._q)()) > CLICK_ACTION_MAX_DURATION) interactionSelectorCache.delete(relativeTimestamp);
	});
}
//#endregion


//# sourceMappingURL=interactionSelectorCache.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/isActionChildEvent.mjs
//#region src/domain/action/isActionChildEvent.ts
function isActionChildEvent(id) {
	return (event) => event.action?.id?.includes(id) ?? false;
}
//#endregion


//# sourceMappingURL=isActionChildEvent.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/trackClickActions.mjs

















//#region src/domain/action/trackClickActions.ts
function trackClickActions(lifeCycle, domMutationObservable, windowOpenObservable, configuration) {
	const actionTracker = startEventTracker(lifeCycle);
	const stopObservable = new tools_observable/* Observable */.y$();
	let currentClickChain;
	lifeCycle.subscribe(5, stopClickChain);
	lifeCycle.subscribe(12, stopClickChain);
	const { stop: stopActionEventsListener } = listenActionEvents({
		onPointerDown: (pointerDownEvent) => processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable),
		onPointerUp: ({ clickActionBase, hadActivityOnPointerDown }, startEvent, getUserActivity) => {
			startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, actionTracker, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown);
		}
	});
	return {
		stop: () => {
			stopClickChain();
			stopObservable.notify();
			stopActionEventsListener();
			actionTracker.stopAll();
		},
		findActionId: actionTracker.findId
	};
	function appendClickToClickChain(click) {
		if (!currentClickChain?.tryAppend(click)) {
			const rageClick = click.clone();
			currentClickChain = createClickChain(click, (clicks) => {
				finalizeClicks(clicks, rageClick);
				currentClickChain = void 0;
			});
		}
	}
	function stopClickChain() {
		if (currentClickChain) currentClickChain.stop();
	}
}
function processPointerDown(configuration, lifeCycle, domMutationObservable, pointerDownEvent, windowOpenObservable) {
	let nodePrivacyLevel;
	if (configuration.enablePrivacyForActionName) nodePrivacyLevel = getNodePrivacyLevel(getEventTarget(pointerDownEvent), configuration.defaultPrivacyLevel);
	else nodePrivacyLevel = NodePrivacyLevel.ALLOW;
	if (nodePrivacyLevel === NodePrivacyLevel.HIDDEN) return;
	const clickActionBase = computeClickActionBase(pointerDownEvent, nodePrivacyLevel, configuration);
	let hadActivityOnPointerDown = false;
	waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent) => {
		hadActivityOnPointerDown = pageActivityEndEvent.hadActivity;
	}, 100);
	return {
		clickActionBase,
		hadActivityOnPointerDown: () => hadActivityOnPointerDown
	};
}
function startClickAction(configuration, lifeCycle, domMutationObservable, windowOpenObservable, actionTracker, stopObservable, appendClickToClickChain, clickActionBase, startEvent, getUserActivity, hadActivityOnPointerDown) {
	const click = newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent);
	appendClickToClickChain(click);
	const selector = clickActionBase?.target?.selector;
	if (selector) updateInteractionSelector(startEvent.timeStamp, selector);
	const { stop: stopWaitPageActivityEnd } = waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (pageActivityEndEvent) => {
		if (pageActivityEndEvent.hadActivity && pageActivityEndEvent.end < click.startClocks.timeStamp) click.discard();
		else if (pageActivityEndEvent.hadActivity) click.stop(pageActivityEndEvent.end);
		else if (hadActivityOnPointerDown()) click.stop(click.startClocks.timeStamp);
		else click.stop();
	}, CLICK_ACTION_MAX_DURATION);
	const viewEndedSubscription = lifeCycle.subscribe(5, ({ endClocks }) => {
		click.stop(endClocks.timeStamp);
	});
	const pageMayExitSubscription = lifeCycle.subscribe(12, () => {
		click.stop((0,entries_time/* timeStampNow */.n$)());
	});
	const stopSubscription = stopObservable.subscribe(() => {
		click.stop();
	});
	click.stopObservable.subscribe(() => {
		pageMayExitSubscription.unsubscribe();
		viewEndedSubscription.unsubscribe();
		stopWaitPageActivityEnd();
		stopSubscription.unsubscribe();
	});
}
function computeClickActionBase(event, nodePrivacyLevel, configuration) {
	const target = getEventTarget(event);
	const rect = target.getBoundingClientRect();
	const selector = getSelectorFromElement(target, configuration.actionNameAttribute);
	const composedPathSelector = getComposedPathSelector(event.composedPath(), configuration.actionNameAttribute);
	if (selector) updateInteractionSelector(event.timeStamp, selector);
	const { name, nameSource } = getActionNameFromElement(target, configuration, nodePrivacyLevel);
	return {
		type: ActionType.CLICK,
		target: {
			width: Math.round(rect.width),
			height: Math.round(rect.height),
			selector,
			composedPathSelector: composedPathSelector || void 0
		},
		position: {
			x: Math.round(event.clientX - rect.left),
			y: Math.round(event.clientY - rect.top)
		},
		name,
		nameSource
	};
}
function getEventTarget(event) {
	if (event.composed && isNodeShadowHost(event.target) && typeof event.composedPath === "function") {
		const composedPath = event.composedPath();
		if (composedPath.length > 0 && composedPath[0] instanceof Element) return composedPath[0];
	}
	return event.target;
}
function newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent) {
	const clickKey = generateUUID();
	const startClocks = (0,entries_time/* relativeToClocks */.DY)(startEvent.timeStamp);
	const startedClickAction = actionTracker.start(clickKey, startClocks, clickActionBase, { isChildEvent: isActionChildEvent });
	lifeCycle.notify(16, startedClickAction);
	let status = 0;
	let actionTrackerFinishedEvent;
	const frustrationTypes = [];
	const stopObservable = new tools_observable/* Observable */.y$();
	function stop(activityEndTime) {
		if (status !== 0) return;
		status = 1;
		actionTrackerFinishedEvent = activityEndTime ? actionTracker.stop(clickKey, (0,entries_time/* timeStampToClocks */.lO)(activityEndTime)) : actionTracker.discard(clickKey);
		stopObservable.notify();
	}
	return {
		event: startEvent,
		stop,
		stopObservable,
		get hasError() {
			const currentCounts = actionTrackerFinishedEvent?.counts ?? actionTracker.getCounts(clickKey);
			return currentCounts ? currentCounts.errorCount > 0 : false;
		},
		get hasPageActivity() {
			return actionTrackerFinishedEvent && "duration" in actionTrackerFinishedEvent;
		},
		getUserActivity,
		addFrustration: (frustrationType) => {
			frustrationTypes.push(frustrationType);
		},
		get startClocks() {
			return startClocks;
		},
		isStopped: () => status === 1 || status === 2,
		clone: () => newClick(lifeCycle, actionTracker, getUserActivity, clickActionBase, startEvent),
		validate: (domEvents) => {
			stop();
			if (status !== 1) return;
			if (!actionTrackerFinishedEvent) return;
			const clickAction = {
				frustrationTypes,
				events: domEvents ?? [startEvent],
				event: startEvent,
				...actionTrackerFinishedEvent,
				counts: actionTrackerFinishedEvent.counts
			};
			lifeCycle.notify(0, clickAction);
			status = 2;
		},
		discard: () => {
			stop();
			status = 2;
		}
	};
}
function finalizeClicks(clicks, rageClick) {
	const { isRage } = computeFrustration(clicks, rageClick);
	if (isRage) {
		clicks.forEach((click) => click.discard());
		rageClick.stop((0,entries_time/* timeStampNow */.n$)());
		rageClick.validate(clicks.map((click) => click.event));
	} else {
		rageClick.discard();
		clicks.forEach((click) => click.validate());
	}
}
//#endregion


//# sourceMappingURL=trackClickActions.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/trackManualActions.mjs






//#region src/domain/action/trackManualActions.ts
function trackManualActions(lifeCycle, onManualActionCompleted) {
	const actionTracker = startEventTracker(lifeCycle);
	function startManualAction(name, options = {}, startClocks = (0,entries_time/* clocksNow */.$I)()) {
		const lookupKey = options.actionKey ?? name;
		const startedManualAction = actionTracker.start(lookupKey, startClocks, {
			name,
			...options
		}, { isChildEvent: isActionChildEvent });
		lifeCycle.notify(16, startedManualAction);
	}
	function stopManualAction(name, options = {}, stopClocks = (0,entries_time/* clocksNow */.$I)()) {
		const lookupKey = options.actionKey ?? name;
		const stopped = actionTracker.stop(lookupKey, stopClocks, options);
		if (!stopped) return;
		const frustrationTypes = [];
		if (stopped.counts && stopped.counts.errorCount > 0) frustrationTypes.push(FrustrationType.ERROR_CLICK);
		onManualActionCompleted({
			...stopped,
			type: stopped.type || ActionType.CUSTOM,
			frustrationTypes
		});
	}
	function addInstantAction(action) {
		onManualActionCompleted({
			id: generateUUID(),
			frustrationTypes: [],
			...action
		});
	}
	return {
		addAction: addInstantAction,
		startAction: startManualAction,
		stopAction: stopManualAction,
		findActionId: actionTracker.findId,
		stop: actionTracker.stopAll
	};
}
//#endregion


//# sourceMappingURL=trackManualActions.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/js-core/esm/assembly/hook.mjs
var assembly_hook = __webpack_require__(99731);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/action/actionCollection.mjs








function startActionCollection(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration) {
	const { unsubscribe: unsubscribeAutoAction } = lifeCycle.subscribe(0, (action) => {
		lifeCycle.notify(13, processAction(action));
	});
	const stopClickActions = functionUtils/* noop */.Z;
	let clickActions;
	if (configuration.trackUserInteractions) clickActions = trackClickActions(lifeCycle, domMutationObservable, windowOpenObservable, configuration);
	const manualActions = trackManualActions(lifeCycle, (action) => {
		lifeCycle.notify(13, processAction(action));
	});
	const actionContexts = { findActionId: (startTime) => {
		const manualActionId = manualActions.findActionId(startTime);
		const clickActionId = clickActions?.findActionId(startTime) ?? [];
		return manualActionId.concat(clickActionId);
	} };
	hooks.assemble.register(({ startTime, eventType }) => {
		if (eventType !== RumEventType.ERROR && eventType !== RumEventType.RESOURCE && eventType !== RumEventType.LONG_TASK) return assembly_hook/* SKIPPED */.kb;
		const correctedStartTime = eventType === RumEventType.LONG_TASK ? (0,entries_time/* addDuration */.WK)(startTime, 1) : startTime;
		const actionId = actionContexts.findActionId(correctedStartTime);
		if (!actionId.length) return assembly_hook/* SKIPPED */.kb;
		return {
			type: eventType,
			action: { id: actionId }
		};
	});
	hooks.assembleTelemetry.register(({ startTime }) => ({ action: { id: actionContexts.findActionId(startTime) } }));
	return {
		addAction: manualActions.addAction,
		startAction: manualActions.startAction,
		stopAction: manualActions.stopAction,
		actionContexts,
		stop: () => {
			unsubscribeAutoAction();
			stopClickActions();
			manualActions.stop();
			clickActions?.stop();
		}
	};
}
function processAction(action) {
	const isAuto = isAutoAction(action);
	const loadingTime = discardNegativeDuration((0,entries_time/* toServerDuration */.dg)(action.duration));
	return {
		rawRumEvent: {
			type: RumEventType.ACTION,
			date: action.startClocks.timeStamp,
			action: {
				id: action.id,
				target: { name: action.name },
				type: action.type,
				...loadingTime !== void 0 && { loading_time: loadingTime },
				...action.counts && {
					error: { count: action.counts.errorCount },
					long_task: { count: action.counts.longTaskCount },
					resource: { count: action.counts.resourceCount }
				},
				frustration: { type: action.frustrationTypes }
			},
			...isAuto ? { _dd: { action: {
				target: {
					selector: action.target?.selector || void 0,
					width: action.target?.width || void 0,
					height: action.target?.height || void 0,
					composed_path_selector: action.target?.composedPathSelector
				},
				position: action.position,
				name_source: action.nameSource
			} } } : { context: action.context }
		},
		duration: action.duration,
		startClocks: action.startClocks,
		domainContext: isAuto ? { events: action.events } : { handlingStack: action.handlingStack }
	};
}
function isAutoAction(action) {
	return "events" in action;
}
//#endregion


//# sourceMappingURL=actionCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/report/reportObservable.mjs







//#region src/domain/report/reportObservable.ts
const RawReportType = {
	intervention: "intervention",
	deprecation: "deprecation",
	cspViolation: "csp_violation"
};
function initReportObservable(apis) {
	const observables = [];
	if (apis.includes(RawReportType.cspViolation)) observables.push(createCspViolationReportObservable());
	const reportTypes = apis.filter((api) => api !== RawReportType.cspViolation);
	if (reportTypes.length) observables.push(createReportObservable(reportTypes));
	return (0,tools_observable/* mergeObservables */.$Z)(...observables);
}
function createReportObservable(reportTypes) {
	return new tools_observable/* Observable */.y$((observable) => {
		if (!window.ReportingObserver) return;
		const handleReports = (0,monitor/* monitor */.zk)((reports, _) => reports.forEach((report) => observable.notify(buildRawReportErrorFromReport(report))));
		const observer = new window.ReportingObserver(handleReports, {
			types: reportTypes,
			buffered: true
		});
		observer.observe();
		return () => {
			observer.disconnect();
		};
	});
}
function createCspViolationReportObservable() {
	return new tools_observable/* Observable */.y$((observable) => {
		if (!(0,addEventListener/* isEventSupported */.jO)(document, "securitypolicyviolation")) return;
		const { stop } = (0,addEventListener/* addEventListener */.Oo)(document, "securitypolicyviolation", (event) => {
			observable.notify(buildRawReportErrorFromCspViolation(event));
		});
		return stop;
	});
}
function buildRawReportErrorFromReport(report) {
	const { type, body } = report;
	return buildRawReportError({
		type: body.id,
		message: `${type}: ${body.message}`,
		originalError: report,
		stack: buildStack(body.id, body.message, body.sourceFile, body.lineNumber, body.columnNumber)
	});
}
function buildRawReportErrorFromCspViolation(event) {
	const message = `'${event.blockedURI}' blocked by '${event.effectiveDirective}' directive`;
	return buildRawReportError({
		type: event.effectiveDirective,
		message: `${RawReportType.cspViolation}: ${message}`,
		originalError: event,
		csp: { disposition: event.disposition },
		stack: buildStack(event.effectiveDirective, event.originalPolicy ? `${message} of the policy "${safeTruncate(event.originalPolicy, 100, "...")}"` : "no policy", event.sourceFile, event.lineNumber, event.columnNumber)
	});
}
function buildRawReportError(partial) {
	return {
		startClocks: (0,entries_time/* clocksNow */.$I)(),
		source: error_types/* ErrorSource.REPORT */.zH.REPORT,
		handling: "unhandled",
		...partial
	};
}
function buildStack(name, message, sourceFile, lineNumber, columnNumber) {
	return sourceFile ? (0,stackTrace_handlingStack/* toStackTraceString */.P3)({
		name,
		message,
		stack: [{
			func: "?",
			url: sourceFile,
			line: lineNumber ?? void 0,
			column: columnNumber ?? void 0
		}]
	}) : void 0;
}
//#endregion


//# sourceMappingURL=reportObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/error/trackReportError.mjs

//#region src/domain/error/trackReportError.ts
function trackReportError(errorObservable) {
	const subscription = initReportObservable([RawReportType.cspViolation, RawReportType.intervention]).subscribe((rawError) => errorObservable.notify(rawError));
	return { stop: () => {
		subscription.unsubscribe();
	} };
}
//#endregion


//# sourceMappingURL=trackReportError.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/error/errorCollection.mjs





//#region src/domain/error/errorCollection.ts
function startErrorCollection(lifeCycle, bufferedDataObservable) {
	const errorObservable = new tools_observable/* Observable */.y$();
	bufferedDataObservable.subscribe(({ data, type }) => {
		if (type === BufferedDataType.RUNTIME_ERROR) errorObservable.notify(data);
		else if (type === BufferedDataType.CONSOLE && data.api === util_display/* ConsoleApiName.error */.vA.error) errorObservable.notify(data.error);
	});
	trackReportError(errorObservable);
	errorObservable.subscribe((error) => lifeCycle.notify(15, { error }));
	return doStartErrorCollection(lifeCycle);
}
function doStartErrorCollection(lifeCycle) {
	lifeCycle.subscribe(15, ({ error }) => {
		lifeCycle.notify(13, processError(error));
	});
	return { addError: ({ error, handlingStack, componentStack, startClocks, context }) => {
		const rawError = computeRawError({
			originalError: error,
			handlingStack,
			componentStack,
			startClocks,
			nonErrorPrefix: error_types/* NonErrorPrefix.PROVIDED */.j9.PROVIDED,
			source: error_types/* ErrorSource.CUSTOM */.zH.CUSTOM,
			handling: error_types/* ErrorHandling.HANDLED */.Xw.HANDLED
		});
		rawError.context = (0,mergeInto/* combine */.$e)(rawError.context, context);
		lifeCycle.notify(15, { error: rawError });
	} };
}
function processError(error) {
	const rawRumEvent = {
		date: error.startClocks.timeStamp,
		error: {
			id: generateUUID(),
			message: error.message,
			source: error.source,
			stack: error.stack,
			handling_stack: error.handlingStack,
			component_stack: error.componentStack,
			type: error.type,
			handling: error.handling,
			causes: error.causes,
			source_type: "browser",
			fingerprint: error.fingerprint,
			csp: error.csp
		},
		_dd: { debug_ids: error.debugIds },
		type: RumEventType.ERROR,
		context: error.context
	};
	const domainContext = {
		error: error.originalError,
		handlingStack: error.handlingStack
	};
	return {
		rawRumEvent,
		startClocks: error.startClocks,
		domainContext
	};
}
//#endregion


//# sourceMappingURL=errorCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/performanceUtils.mjs



//#region src/browser/performanceUtils.ts
function isValidNavigationEntry(entry) {
	return !(entry.loadEventEnd > 0 && entry.domComplete <= 0);
}
function getNavigationEntry() {
	if (supportPerformanceTimingEvent("navigation")) {
		const navigationEntry = performance.getEntriesByType("navigation")[0];
		if (navigationEntry && isValidNavigationEntry(navigationEntry)) return navigationEntry;
	}
	const timings = computeTimingsFromDeprecatedPerformanceTiming();
	const entry = {
		entryType: "navigation",
		initiatorType: "navigation",
		name: window.location.href,
		startTime: 0,
		duration: timings.loadEventEnd,
		decodedBodySize: 0,
		encodedBodySize: 0,
		transferSize: 0,
		workerStart: 0,
		toJSON: () => ({
			...entry,
			toJSON: void 0
		}),
		...timings
	};
	return entry;
}
function computeTimingsFromDeprecatedPerformanceTiming() {
	const result = {};
	const timing = performance.timing;
	for (const key in timing) if ((0,numberUtils/* isNumber */.hj)(timing[key])) {
		const numberKey = key;
		const timingElement = timing[numberKey];
		result[numberKey] = timingElement === 0 ? 0 : (0,entries_time/* toRelativeTime */.zj)(timingElement);
	}
	return result;
}
function sanitizeFirstByte(entry) {
	return entry.responseStart >= 0 && entry.responseStart <= (0,entries_time/* relativeNow */._q)() ? entry.responseStart : void 0;
}
function getResourceEntries() {
	if (supportPerformanceTimingEvent("resource")) return performance.getEntriesByType("resource");
}
/**
* Find the most relevant resource entry for an LCP element.
*
* Resource entries persist for the entire page lifetime and can include multiple requests
* for the same URL (preloads, cache-busting reloads, SPA route changes, etc.).
* This function returns the most recent matching entry that started before the LCP time,
* which is most likely the one that triggered the LCP paint.
*/
function findLcpResourceEntry(resourceUrl, lcpStartTime) {
	const entries = getResourceEntries();
	if (!entries) return;
	return (0,polyfills/* findLast */.dF)(entries, (entry) => entry.name === resourceUrl && entry.startTime <= lcpStartTime);
}
//#endregion


//# sourceMappingURL=performanceUtils.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/tracing/getDocumentTraceId.mjs



//#region src/domain/tracing/getDocumentTraceId.ts
const INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD = 2 * entries_time/* ONE_MINUTE */.yR;
function getDocumentTraceId(document) {
	const data = getDocumentTraceDataFromMeta(document) || getDocumentTraceDataFromComment(document);
	if (!data || data.traceTime <= (0,entries_time/* getTimeOrigin */.U)() - INITIAL_DOCUMENT_OUTDATED_TRACE_ID_THRESHOLD) return;
	return data.traceId;
}
function getDocumentTraceDataFromMeta(document) {
	const traceIdMeta = document.querySelector("meta[name=dd-trace-id]");
	const traceTimeMeta = document.querySelector("meta[name=dd-trace-time]");
	return createDocumentTraceData(traceIdMeta?.content, traceTimeMeta?.content);
}
function getDocumentTraceDataFromComment(document) {
	const comment = findTraceComment(document);
	if (!comment) return;
	return createDocumentTraceData(findCommaSeparatedValue(comment, "trace-id"), findCommaSeparatedValue(comment, "trace-time"));
}
function createDocumentTraceData(traceId, rawTraceTime) {
	const traceTime = rawTraceTime && Number(rawTraceTime);
	if (!traceId || !traceTime) return;
	return {
		traceId,
		traceTime
	};
}
function findTraceComment(document) {
	for (let i = 0; i < document.childNodes.length; i += 1) {
		const comment = getTraceCommentFromNode(document.childNodes[i]);
		if (comment) return comment;
	}
	if (document.body) for (let i = document.body.childNodes.length - 1; i >= 0; i -= 1) {
		const node = document.body.childNodes[i];
		const comment = getTraceCommentFromNode(node);
		if (comment) return comment;
		if (!isTextNode(node)) break;
	}
}
function getTraceCommentFromNode(node) {
	if (node && isCommentNode(node)) {
		const match = /^\s*DATADOG;(.*?)\s*$/.exec(node.data);
		if (match) return match[1];
	}
}
//#endregion


//# sourceMappingURL=getDocumentTraceId.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/requestRegistry.mjs

//#region src/domain/resource/requestRegistry.ts
const MAX_REQUESTS = 1e3;
function createRequestRegistry(lifeCycle) {
	const requests = /* @__PURE__ */ new Set();
	const subscription = lifeCycle.subscribe(8, (request) => {
		requests.add(request);
		if (requests.size > 1e3) requests.delete(requests.values().next().value);
	});
	return {
		getMatchingRequest(entry) {
			let minTimeDifference = Infinity;
			let closestRequest;
			for (const request of requests) {
				const timeDifference = entry.startTime - request.startClocks.relative;
				if (0 <= timeDifference && timeDifference < minTimeDifference && request.url === entry.name) {
					minTimeDifference = Math.abs(timeDifference);
					closestRequest = request;
				}
			}
			if (closestRequest) requests.delete(closestRequest);
			return closestRequest;
		},
		stop() {
			subscription.unsubscribe();
		}
	};
}
//#endregion


//# sourceMappingURL=requestRegistry.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/trackManualResources.mjs





//#region src/domain/resource/trackManualResources.ts
function trackManualResources(lifeCycle, resourceTracker) {
	function startManualResource(url, options = {}, startClocks = (0,entries_time/* clocksNow */.$I)()) {
		const lookupKey = options.resourceKey ?? url;
		resourceTracker.start(lookupKey, startClocks, {
			url,
			...options
		});
	}
	function stopManualResource(url, options = {}, stopClocks = (0,entries_time/* clocksNow */.$I)()) {
		const lookupKey = options.resourceKey ?? url;
		const stopped = resourceTracker.stop(lookupKey, stopClocks, {
			context: options.context,
			type: options.type
		});
		if (!stopped) return;
		const duration = (0,entries_time/* elapsed */._J)(stopped.startClocks.relative, stopClocks.relative);
		const rawRumEvent = {
			date: stopped.startClocks.timeStamp,
			type: RumEventType.RESOURCE,
			resource: {
				id: stopped.id,
				type: stopped.type || ResourceType.OTHER,
				url: sanitizeIfLongDataUrl(stopped.url),
				duration: (0,entries_time/* toServerDuration */.dg)(duration),
				method: stopped.method,
				status_code: options.statusCode,
				size: options.size
			},
			_dd: {},
			context: stopped.context
		};
		lifeCycle.notify(13, {
			rawRumEvent,
			startClocks: stopped.startClocks,
			duration,
			domainContext: { isManual: true }
		});
	}
	return {
		startResource: startManualResource,
		stopResource: stopManualResource
	};
}
//#endregion


//# sourceMappingURL=trackManualResources.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/requestIdleCallback.mjs
var requestIdleCallback = __webpack_require__(18199);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/taskQueue.mjs


//#region src/tools/taskQueue.ts
/**
* Maximum delay before starting to execute tasks in the queue. We don't want to wait too long
* before running tasks, as it might hurt reliability (ex: if the user navigates away, we might lose
* the opportunity to send some data). We also don't want to run tasks too often, as it might hurt
* performance.
*/
const IDLE_CALLBACK_TIMEOUT = entries_time/* ONE_SECOND */.WT;
/**
* Maximum amount of time allocated to running tasks when a timeout (`IDLE_CALLBACK_TIMEOUT`) is
* reached. We should not run tasks for too long as it will hurt performance, but we should still
* run some tasks to avoid postponing them forever.
*
* Rational: Running tasks for 30ms every second (IDLE_CALLBACK_TIMEOUT) should be acceptable.
*/
const MAX_EXECUTION_TIME_ON_TIMEOUT = 30;
function createTaskQueue() {
	const pendingTasks = [];
	function run(deadline) {
		let executionTimeRemaining;
		if (!deadline || deadline.didTimeout) {
			const start = performance.now();
			executionTimeRemaining = () => 30 - (performance.now() - start);
		} else executionTimeRemaining = deadline.timeRemaining.bind(deadline);
		while (executionTimeRemaining() > 0 && pendingTasks.length) pendingTasks.shift()();
		if (pendingTasks.length) scheduleNextRun();
	}
	function scheduleNextRun() {
		(0,requestIdleCallback/* requestIdleCallback */.K)(run, { timeout: IDLE_CALLBACK_TIMEOUT });
	}
	return {
		push(task) {
			if (pendingTasks.push(task) === 1) scheduleNextRun();
		},
		stop() {
			pendingTasks.length = 0;
		}
	};
}
//#endregion


//# sourceMappingURL=taskQueue.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/runOnReadyState.mjs
var runOnReadyState = __webpack_require__(9227);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/resource/resourceCollection.mjs















function startResourceCollection(lifeCycle, configuration) {
	const taskQueue = (0,mockable/* mockable */.C)(createTaskQueue)();
	const requestRegistry = createRequestRegistry(lifeCycle);
	lifeCycle.subscribe(9, (event) => {
		const rawEvent = assembleWebSocketResource(event, configuration);
		if (rawEvent) lifeCycle.notify(13, rawEvent);
	});
	const performanceResourceSubscription = createPerformanceObservable({
		type: "resource",
		buffered: true
	}).subscribe((entries) => {
		for (const entry of entries) if (isResourceEntryRequestType(entry)) (0,timer/* setTimeout */.iK)(() => {
			const rawEvent = assembleResource(entry, requestRegistry.getMatchingRequest(entry), configuration);
			if (rawEvent) lifeCycle.notify(13, rawEvent);
		}, 50);
		else handleResource(() => assembleResource(entry, void 0, configuration));
	});
	const { stop: stopRunOnReadyState } = (0,runOnReadyState/* runOnReadyState */.T)("interactive", () => {
		handleResource(() => assembleResource(getNavigationEntry(), void 0, configuration));
	});
	function handleResource(computeRawEvent) {
		taskQueue.push(() => {
			const rawEvent = computeRawEvent();
			if (rawEvent) lifeCycle.notify(13, rawEvent);
		});
	}
	const resourceTracker = startEventTracker(lifeCycle);
	const manualResources = trackManualResources(lifeCycle, resourceTracker);
	return {
		startResource: manualResources.startResource,
		stopResource: manualResources.stopResource,
		stop: () => {
			stopRunOnReadyState();
			taskQueue.stop();
			performanceResourceSubscription.unsubscribe();
			resourceTracker.stopAll();
		}
	};
}
function assembleWebSocketResource(event, configuration) {
	const duration = (0,entries_time/* elapsed */._J)(event.startClocks.timeStamp, event.endClocks.timeStamp);
	const rawRumEvent = {
		date: event.startClocks.timeStamp,
		type: RumEventType.RESOURCE,
		resource: {
			id: generateUUID(),
			type: ResourceType.WEBSOCKET,
			url: event.url,
			duration: (0,entries_time/* toServerDuration */.dg)(duration),
			websocket: {
				connection_id: event.connectionId,
				handshake_succeeded: event.handshakeSucceeded,
				start_time: event.startClocks.timeStamp,
				end_time: event.endClocks.timeStamp,
				start_view_id: event.startViewId,
				end_view_id: event.endViewId,
				tracking_end_reason: event.trackingEndReason,
				close_code: event.closeCode,
				close_reason: event.closeReason,
				was_clean: event.wasClean,
				messages_in: event.messagesIn,
				messages_out: event.messagesOut,
				time_to_first_message_in: (0,entries_time/* toServerDuration */.dg)(event.firstMessageInOffset),
				time_to_first_message_out: (0,entries_time/* toServerDuration */.dg)(event.firstMessageOutOffset),
				last_message_in_at: event.lastMessageInAt,
				longest_inbound_silence: (0,entries_time/* toServerDuration */.dg)(event.longestInboundSilence),
				inbound_idle_duration_before_close: (0,entries_time/* toServerDuration */.dg)(event.inboundIdleDurationBeforeClose),
				buffered_amount_max: event.bufferedAmountMax,
				protocol: event.protocol,
				setup_duration: (0,entries_time/* toServerDuration */.dg)(event.setupDuration)
			}
		},
		_dd: { discarded: !configuration.trackResources }
	};
	return {
		startClocks: event.startClocks,
		duration,
		rawRumEvent,
		domainContext: {
			isWebSocket: true,
			isManual: false,
			webSocket: event.webSocket
		}
	};
}
function assembleResource(entry, request, configuration) {
	const tracingInfo = request ? computeRequestTracingInfo(request, configuration) : computeResourceEntryTracingInfo(entry, configuration);
	if (!configuration.trackResources && !tracingInfo) return;
	const startClocks = (0,entries_time/* relativeToClocks */.DY)(entry.startTime);
	const duration = computeResourceEntryDuration(entry);
	const networkHeaders = computeNetworkHeaders(request, configuration);
	return {
		startClocks,
		duration,
		rawRumEvent: (0,mergeInto/* combine */.$e)({
			date: startClocks.timeStamp,
			resource: {
				id: generateUUID(),
				duration: (0,entries_time/* toServerDuration */.dg)(duration),
				type: computeResourceEntryType(entry),
				method: request?.method,
				status_code: request ? request.status : discardZeroStatus(entry.responseStatus),
				url: request ? sanitizeIfLongDataUrl(request.url) : entry.name,
				protocol: computeResourceEntryProtocol(entry),
				delivery_type: computeResourceEntryDeliveryType(entry),
				graphql: request && computeGraphQlMetaData(request, configuration),
				render_blocking_status: entry.renderBlockingStatus,
				...computeResourceEntrySize(entry),
				...computeResourceEntryDetails(entry)
			},
			type: RumEventType.RESOURCE,
			_dd: { discarded: !configuration.trackResources }
		}, tracingInfo, computeContentTypeFromPerformanceEntry(entry), networkHeaders),
		domainContext: getResourceDomainContext(entry, request)
	};
}
function computeGraphQlMetaData(request, configuration) {
	const graphQlConfig = findGraphQlConfiguration(request.url, configuration);
	if (!graphQlConfig) return;
	return extractGraphQlMetadata(request, graphQlConfig);
}
function computeContentTypeFromPerformanceEntry(entry) {
	const contentType = entry.contentType;
	if (contentType) return { resource: { response: { headers: { "content-type": contentType } } } };
}
function getResourceDomainContext(entry, request) {
	return {
		performanceEntry: entry,
		isManual: false,
		isAborted: request ? request.isAborted : false,
		isWebSocket: false,
		handlingStack: request?.handlingStack,
		requestInit: request?.init,
		requestInput: request?.input,
		response: request?.response,
		error: request?.error,
		xhr: request?.xhr
	};
}
function computeRequestTracingInfo(request, configuration) {
	if (!(request.traceSampled && request.traceId && request.spanId)) return;
	return { _dd: {
		span_id: request.spanId.toString(),
		trace_id: request.traceId.toString(),
		rule_psr: configuration.rulePsr
	} };
}
function computeResourceEntryTracingInfo(entry, configuration) {
	if (entry.initiatorType !== "navigation") return;
	const traceId = (0,mockable/* mockable */.C)(getDocumentTraceId)(document);
	if (!traceId) return;
	return { _dd: {
		trace_id: traceId,
		span_id: createSpanIdentifier().toString(),
		rule_psr: configuration.rulePsr
	} };
}
/**
* The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
* https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
*/
function discardZeroStatus(statusCode) {
	return statusCode === 0 ? void 0 : statusCode;
}
function computeNetworkHeaders(request, configuration) {
	const matchers = configuration.trackResourceHeaders;
	if (matchers.length === 0 || !request) return;
	const urlMatchers = matchers.filter((m) => m.url !== void 0 ? matchList([m.url], request.url, true) : true);
	if (urlMatchers.length === 0) return;
	const responseMatchers = urlMatchers.filter((m) => m.location === void 0 || m.location === "any" || m.location === "response");
	const requestMatchers = urlMatchers.filter((m) => m.location === void 0 || m.location === "any" || m.location === "request");
	const responseHeaders = responseMatchers.length > 0 ? getResponseHeaders(request, responseMatchers) : void 0;
	const requestHeaders = requestMatchers.length > 0 ? getRequestHeaders(request, requestMatchers) : void 0;
	if (!responseHeaders && !requestHeaders) return;
	return { resource: {
		request: requestHeaders ? { headers: requestHeaders } : void 0,
		response: responseHeaders ? { headers: responseHeaders } : void 0
	} };
}
function getResponseHeaders(request, matchers) {
	if (request.type === RequestType.FETCH && request.response) return filterHeaders(request.response.headers, matchers);
	if (request.type === RequestType.XHR && request.xhr) {
		const rawXhrHeaders = request.xhr.getAllResponseHeaders();
		if (rawXhrHeaders) try {
			return filterHeaders(new Headers(parseRawXhrHeaders(rawXhrHeaders)), matchers);
		} catch {}
	}
}
function getRequestHeaders(request, matchers) {
	if (request.type !== RequestType.FETCH) return;
	let headers;
	if (request.init?.headers) headers = new Headers(request.init.headers);
	else if (request.input instanceof Request) headers = request.input.headers;
	return headers ? filterHeaders(headers, matchers) : void 0;
}
const FORBIDDEN_HEADER_PATTERN = /(token|cookie|secret|authorization|(api|secret|access|app).?key|(client|connecting|real).?ip|forwarded)/;
const MAX_HEADER_COUNT = 100;
const MAX_HEADER_VALUE_LENGTH = 128;
function filterHeaders(headers, matchers) {
	const result = {};
	let collectedHeaderCount = 0;
	let totalHeaderCount = 0;
	let hasReachedMaxHeaderCount = false;
	headers.forEach((value, name) => {
		totalHeaderCount++;
		if (collectedHeaderCount >= MAX_HEADER_COUNT) {
			if (!hasReachedMaxHeaderCount) {
				display/* display.warn */.jf.warn(`Maximum number of headers (${MAX_HEADER_COUNT}) has been reached. Further headers are dropped.`);
				hasReachedMaxHeaderCount = true;
			}
			return;
		}
		const lowerName = name.toLowerCase();
		if (FORBIDDEN_HEADER_PATTERN.test(lowerName)) return;
		const matchHeader = matchers.find((m) => matchList([m.name], lowerName));
		if (!matchHeader) return;
		const { extractor } = matchHeader;
		const capturedValue = extractor ? extractRegexMatch(value, extractor) : value;
		if (capturedValue === void 0) return;
		if (capturedValue.length > MAX_HEADER_VALUE_LENGTH) {
			display/* display.warn */.jf.warn(`Header "${lowerName}" value was truncated from ${capturedValue.length} to ${MAX_HEADER_VALUE_LENGTH} characters.`);
			(0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Resource header value was truncated", {
				header_name: lowerName,
				original_length: capturedValue.length,
				limit: MAX_HEADER_VALUE_LENGTH
			});
		}
		result[lowerName] = safeTruncate(capturedValue, MAX_HEADER_VALUE_LENGTH);
		collectedHeaderCount++;
	});
	if (hasReachedMaxHeaderCount) (0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Maximum number of resource headers reached", {
		collectedHeaderCount,
		totalHeaderCount
	});
	return collectedHeaderCount > 0 ? result : void 0;
}
function parseRawXhrHeaders(rawXhrheaders) {
	const pairs = [];
	const lines = rawXhrheaders.trim().split(/\r\n/);
	for (const line of lines) {
		const colonIndex = line.indexOf(":");
		if (colonIndex > 0) pairs.push([line.substring(0, colonIndex).trim(), line.substring(colonIndex + 1).trim()]);
	}
	return pairs;
}
//#endregion


//# sourceMappingURL=resourceCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/trackViewEventCounts.mjs

//#region src/domain/view/trackViewEventCounts.ts
function trackViewEventCounts(lifeCycle, viewId, onChange) {
	const { stop, eventCounts } = trackEventCounts({
		lifeCycle,
		isChildEvent: (event) => event.view.id === viewId,
		onChange
	});
	return {
		stop,
		eventCounts
	};
}
//#endregion


//# sourceMappingURL=trackViewEventCounts.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstContentfulPaint.mjs


//#region src/domain/view/viewMetrics/trackFirstContentfulPaint.ts
const FCP_MAXIMUM_DELAY = 10 * entries_time/* ONE_MINUTE */.yR;
function trackFirstContentfulPaint(firstHidden, callback) {
	return { stop: createPerformanceObservable({
		type: "paint",
		buffered: true
	}).subscribe((entries) => {
		const fcpEntry = entries.find((entry) => entry.name === "first-contentful-paint" && entry.startTime < firstHidden.timeStamp && entry.startTime < FCP_MAXIMUM_DELAY);
		if (fcpEntry) callback(fcpEntry.startTime);
	}).unsubscribe };
}
/**
* Measure the First Contentful Paint after a BFCache restoration.
* The DOM is restored synchronously, so we approximate the FCP with the first frame
* rendered just after the pageshow event, using two nested requestAnimationFrame calls.
*/
function trackRestoredFirstContentfulPaint(viewStartRelative, callback) {
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			callback((0,entries_time/* elapsed */._J)(viewStartRelative, (0,entries_time/* relativeNow */._q)()));
		});
	});
}
//#endregion


//# sourceMappingURL=trackFirstContentfulPaint.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackNavigationTimings.mjs


//#region src/domain/view/viewMetrics/trackNavigationTimings.ts
function trackNavigationTimings(callback) {
	return waitAfterLoadEvent(() => {
		const entry = (0,mockable/* mockable */.C)(getNavigationEntry)();
		if (!isIncompleteNavigation(entry)) callback(processNavigationEntry(entry));
	});
}
function processNavigationEntry(entry) {
	return {
		domComplete: entry.domComplete,
		domContentLoaded: entry.domContentLoadedEventEnd,
		domInteractive: entry.domInteractive,
		loadEvent: entry.loadEventEnd,
		firstByte: sanitizeFirstByte(entry)
	};
}
function isIncompleteNavigation(entry) {
	return entry.loadEventEnd <= 0;
}
function waitAfterLoadEvent(callback) {
	let timeoutId;
	const { stop: stopOnReadyState } = (0,runOnReadyState/* runOnReadyState */.T)("complete", () => {
		timeoutId = (0,timer/* setTimeout */.iK)(() => callback());
	});
	return { stop: () => {
		stopOnReadyState();
		(0,timer/* clearTimeout */.gr)(timeoutId);
	} };
}
//#endregion


//# sourceMappingURL=trackNavigationTimings.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLargestContentfulPaint.mjs





//#region src/domain/view/viewMetrics/trackLargestContentfulPaint.ts
const LCP_MAXIMUM_DELAY = 10 * entries_time/* ONE_MINUTE */.yR;
/**
* Track the largest contentful paint (LCP) occurring during the initial View.  This can yield
* multiple values, only the most recent one should be used.
* Documentation: https://web.dev/lcp/
* Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/onLCP.ts
*/
function trackLargestContentfulPaint(configuration, firstHidden, eventTarget, callback) {
	let firstInteractionTimestamp = Infinity;
	const { stop: stopEventListener } = (0,addEventListener/* addEventListeners */.yw)(eventTarget, [addEventListener/* DOM_EVENT.POINTER_DOWN */.EZ.POINTER_DOWN, addEventListener/* DOM_EVENT.KEY_DOWN */.EZ.KEY_DOWN], (event) => {
		firstInteractionTimestamp = event.timeStamp;
	}, {
		capture: true,
		once: true
	});
	let biggestLcpSize = 0;
	const performanceLcpSubscription = createPerformanceObservable({
		type: "largest-contentful-paint",
		buffered: true
	}).subscribe((entries) => {
		const lcpEntry = (0,polyfills/* findLast */.dF)(entries, (entry) => entry.entryType === "largest-contentful-paint" && entry.startTime < firstInteractionTimestamp && entry.startTime < firstHidden.timeStamp && entry.startTime < LCP_MAXIMUM_DELAY && entry.size > biggestLcpSize);
		if (lcpEntry) {
			let lcpTargetSelector;
			if (lcpEntry.element) lcpTargetSelector = getSelectorFromElement(lcpEntry.element, configuration.actionNameAttribute);
			const resourceUrl = computeLcpEntryUrl(lcpEntry);
			const lcpValue = lcpEntry.startTime;
			const subParts = computeLcpSubParts(resourceUrl, lcpValue);
			callback({
				value: lcpValue,
				targetSelector: lcpTargetSelector,
				resourceUrl,
				subParts
			});
			biggestLcpSize = lcpEntry.size;
		}
	});
	return { stop: () => {
		stopEventListener();
		performanceLcpSubscription.unsubscribe();
	} };
}
function computeLcpEntryUrl(entry) {
	return entry.url === "" ? void 0 : entry.url;
}
/**
* Compute the LCP sub-parts breakdown (loadDelay, loadTime, renderDelay).
* Returns undefined if navigation timing data or TTFB is unavailable.
*/
function computeLcpSubParts(resourceUrl, lcpValue) {
	const firstByte = sanitizeFirstByte(getNavigationEntry());
	if (firstByte === void 0) return;
	const lcpResourceEntry = resourceUrl ? findLcpResourceEntry(resourceUrl, lcpValue) : void 0;
	const lcpRequestStart = lcpResourceEntry ? Math.max(firstByte, lcpResourceEntry.requestStart || lcpResourceEntry.startTime) : firstByte;
	const lcpResponseEnd = Math.min(lcpValue, Math.max(lcpRequestStart, lcpResourceEntry?.responseEnd || 0));
	return {
		loadDelay: lcpRequestStart - firstByte,
		loadTime: lcpResponseEnd - lcpRequestStart,
		renderDelay: lcpValue - lcpResponseEnd
	};
}
//#endregion


//# sourceMappingURL=trackLargestContentfulPaint.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackFirstHidden.mjs


//#region src/domain/view/viewMetrics/trackFirstHidden.ts
function trackFirstHidden(viewStart, eventTarget = window) {
	if (document.visibilityState === "hidden") return {
		timeStamp: 0,
		stop: functionUtils/* noop */.Z
	};
	if (supportPerformanceTimingEvent("visibility-state")) {
		const firstHiddenEntry = performance.getEntriesByType("visibility-state").filter((entry) => entry.name === "hidden").find((entry) => entry.startTime >= viewStart.relative);
		if (firstHiddenEntry) return {
			timeStamp: firstHiddenEntry.startTime,
			stop: functionUtils/* noop */.Z
		};
	}
	let timeStamp = Infinity;
	const { stop } = (0,addEventListener/* addEventListeners */.yw)(eventTarget, [addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE, addEventListener/* DOM_EVENT.VISIBILITY_CHANGE */.EZ.VISIBILITY_CHANGE], (event) => {
		if (event.type === addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE || document.visibilityState === "hidden") {
			timeStamp = event.timeStamp;
			stop();
		}
	}, { capture: true });
	return {
		get timeStamp() {
			return timeStamp;
		},
		stop
	};
}
//#endregion


//# sourceMappingURL=trackFirstHidden.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInitialViewMetrics.mjs




//#region src/domain/view/viewMetrics/trackInitialViewMetrics.ts
function trackInitialViewMetrics(configuration, viewStart, setLoadEvent, scheduleViewUpdate) {
	const initialViewMetrics = {};
	const { stop: stopNavigationTracking } = trackNavigationTimings((navigationTimings) => {
		setLoadEvent(navigationTimings.loadEvent);
		initialViewMetrics.navigationTimings = navigationTimings;
		scheduleViewUpdate();
	});
	const firstHidden = trackFirstHidden(viewStart);
	const { stop: stopFCPTracking } = trackFirstContentfulPaint(firstHidden, (firstContentfulPaint) => {
		initialViewMetrics.firstContentfulPaint = firstContentfulPaint;
		scheduleViewUpdate();
	});
	const { stop: stopLCPTracking } = trackLargestContentfulPaint(configuration, firstHidden, window, (largestContentfulPaint) => {
		initialViewMetrics.largestContentfulPaint = largestContentfulPaint;
		scheduleViewUpdate();
	});
	function stop() {
		stopNavigationTracking();
		stopFCPTracking();
		stopLCPTracking();
		firstHidden.stop();
	}
	return {
		stop,
		initialViewMetrics
	};
}
//#endregion


//# sourceMappingURL=trackInitialViewMetrics.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/getClsAttributionImpactedArea.mjs
//#region src/domain/view/viewMetrics/getClsAttributionImpactedArea.ts
/**
* Calculates the area of a rectangle given its width and height
*/
const calculateArea = (width, height) => width * height;
/**
* Calculates the intersection area between two rectangles
*/
const calculateIntersectionArea = (rect1, rect2) => {
	const left = Math.max(rect1.left, rect2.left);
	const top = Math.max(rect1.top, rect2.top);
	const right = Math.min(rect1.right, rect2.right);
	const bottom = Math.min(rect1.bottom, rect2.bottom);
	if (left >= right || top >= bottom) return 0;
	return calculateArea(right - left, bottom - top);
};
/**
* Calculates the total impacted area of a layout shift source
* This is the sum of the previous and current areas minus their intersection
*/
const getClsAttributionImpactedArea = (source) => {
	const previousArea = calculateArea(source.previousRect.width, source.previousRect.height);
	const currentArea = calculateArea(source.currentRect.width, source.currentRect.height);
	const intersectionArea = calculateIntersectionArea(source.previousRect, source.currentRect);
	return previousArea + currentArea - intersectionArea;
};
//#endregion


//# sourceMappingURL=getClsAttributionImpactedArea.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCumulativeLayoutShift.mjs






//#region src/domain/view/viewMetrics/trackCumulativeLayoutShift.ts
/**
* Track the cumulative layout shifts (CLS).
* Layout shifts are grouped into session windows.
* The minimum gap between session windows is 1 second.
* The maximum duration of a session window is 5 second.
* The session window layout shift value is the sum of layout shifts inside it.
* The CLS value is the max of session windows values.
*
* This yields a new value whenever the CLS value is updated (a higher session window value is computed).
*
* See isLayoutShiftSupported to check for browser support.
*
* Documentation:
* https://web.dev/cls/
* https://web.dev/evolving-cls/
* Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/master/src/getCLS.ts
*/
function trackCumulativeLayoutShift(configuration, viewStart, callback) {
	if (!isLayoutShiftSupported()) return { stop: functionUtils/* noop */.Z };
	let maxClsValue = 0;
	let biggestShift;
	callback({ value: 0 });
	const slidingWindow = slidingSessionWindow();
	const performanceSubscription = createPerformanceObservable({
		type: "layout-shift",
		buffered: true
	}).subscribe((entries) => {
		for (const entry of entries) {
			if (entry.hadRecentInput || entry.startTime < viewStart) continue;
			const { cumulatedValue, isMaxValue } = slidingWindow.update(entry);
			if (isMaxValue) {
				const attribution = getTopImpactedElement(entry.sources);
				biggestShift = {
					target: attribution?.node ? new WeakRef(attribution.node) : void 0,
					time: (0,entries_time/* elapsed */._J)(viewStart, entry.startTime),
					previousRect: attribution?.previousRect,
					currentRect: attribution?.currentRect,
					devicePixelRatio: window.devicePixelRatio
				};
			}
			if (cumulatedValue > maxClsValue) {
				maxClsValue = cumulatedValue;
				const target = biggestShift?.target?.deref();
				callback({
					value: (0,numberUtils/* round */.NM)(maxClsValue, 4),
					targetSelector: target && getSelectorFromElement(target, configuration.actionNameAttribute),
					time: biggestShift?.time,
					previousRect: biggestShift?.previousRect ? asRumRect(biggestShift.previousRect) : void 0,
					currentRect: biggestShift?.currentRect ? asRumRect(biggestShift.currentRect) : void 0,
					devicePixelRatio: biggestShift?.devicePixelRatio
				});
			}
		}
	});
	return { stop: () => {
		performanceSubscription.unsubscribe();
	} };
}
function getTopImpactedElement(sources) {
	let topImpactedSource;
	for (const source of sources) if (source.node && isElementNode(source.node)) {
		const currentImpactedArea = getClsAttributionImpactedArea(source);
		if (!topImpactedSource || getClsAttributionImpactedArea(topImpactedSource) < currentImpactedArea) topImpactedSource = source;
	}
	return topImpactedSource;
}
function asRumRect({ x, y, width, height }) {
	return {
		x,
		y,
		width,
		height
	};
}
const MAX_WINDOW_DURATION = 5 * entries_time/* ONE_SECOND */.WT;
const MAX_UPDATE_GAP = entries_time/* ONE_SECOND */.WT;
function slidingSessionWindow() {
	let cumulatedValue = 0;
	let startTime;
	let endTime;
	let maxValue = 0;
	return { update: (entry) => {
		const shouldCreateNewWindow = startTime === void 0 || entry.startTime - endTime >= MAX_UPDATE_GAP || entry.startTime - startTime >= MAX_WINDOW_DURATION;
		let isMaxValue;
		if (shouldCreateNewWindow) {
			startTime = endTime = entry.startTime;
			maxValue = cumulatedValue = entry.value;
			isMaxValue = true;
		} else {
			cumulatedValue += entry.value;
			endTime = entry.startTime;
			isMaxValue = entry.value > maxValue;
			if (isMaxValue) maxValue = entry.value;
		}
		return {
			cumulatedValue,
			isMaxValue
		};
	} };
}
/**
* Check whether `layout-shift` is supported by the browser.
*/
function isLayoutShiftSupported() {
	return supportPerformanceTimingEvent("layout-shift") && "WeakRef" in window;
}
//#endregion


//# sourceMappingURL=trackCumulativeLayoutShift.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/interactionCountPolyfill.mjs

//#region src/domain/view/viewMetrics/interactionCountPolyfill.ts
/**
* performance.interactionCount polyfill
*
* The interactionCount is an integer which counts the total number of distinct user interactions,
* for which there was a unique interactionId.
*
* The interactionCount polyfill is an estimate based on a convention specific to Chrome. Cf: https://github.com/GoogleChrome/web-vitals/pull/213
* This is currently not an issue as the polyfill is only used for INP which is currently only supported on Chrome.
* Hopefully when/if other browsers will support INP, they will also implement performance.interactionCount at the same time, so we won't need that polyfill.
*
* Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/lib/polyfills/interactionCountPolyfill.ts
*/
let observer;
let interactionCountEstimate = 0;
let minKnownInteractionId = Infinity;
let maxKnownInteractionId = 0;
function initInteractionCountPolyfill() {
	if ("interactionCount" in performance || observer) return;
	observer = new window.PerformanceObserver((0,monitor/* monitor */.zk)((entries) => {
		entries.getEntries().forEach((e) => {
			const entry = e;
			if (entry.interactionId) {
				minKnownInteractionId = Math.min(minKnownInteractionId, entry.interactionId);
				maxKnownInteractionId = Math.max(maxKnownInteractionId, entry.interactionId);
				interactionCountEstimate = (maxKnownInteractionId - minKnownInteractionId) / 7 + 1;
			}
		});
	}));
	observer.observe({
		type: "event",
		buffered: true,
		durationThreshold: 0
	});
}
/**
* Returns the `interactionCount` value using the native API (if available)
* or the polyfill estimate in this module.
*/
const getInteractionCount = () => observer ? interactionCountEstimate : window.performance.interactionCount || 0;
//#endregion


//# sourceMappingURL=interactionCountPolyfill.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackInteractionToNextPaint.mjs








//#region src/domain/view/viewMetrics/trackInteractionToNextPaint.ts
const MAX_INTERACTION_ENTRIES = 10;
const MAX_INP_VALUE = 1 * entries_time/* ONE_MINUTE */.yR;
const RENDER_TIME_GROUPING_THRESHOLD = 8;
/**
* Track the interaction to next paint (INP).
* To avoid outliers, return the p98 worst interaction of the view.
* Documentation: https://web.dev/inp/
* Reference implementation: https://github.com/GoogleChrome/web-vitals/blob/main/src/onINP.ts
*/
function trackInteractionToNextPaint(configuration, viewStart, viewLoadingType) {
	if (!isInteractionToNextPaintSupported()) return {
		getInteractionToNextPaint: () => void 0,
		setViewEnd: functionUtils/* noop */.Z,
		stop: functionUtils/* noop */.Z
	};
	let viewEnd = Infinity;
	let currentInp;
	const { getViewInteractionCount, stopViewInteractionCount } = trackViewInteractionCount(viewLoadingType);
	const longestInteractions = trackLongestInteractions(getViewInteractionCount);
	const subPartsTracker = createSubPartsTracker(longestInteractions);
	const firstInputSubscription = createPerformanceObservable({
		type: "first-input",
		buffered: true
	}).subscribe(handleEntries);
	const eventSubscription = createPerformanceObservable({
		type: "event",
		durationThreshold: 40,
		buffered: true
	}).subscribe(handleEntries);
	function handleEntries(entries) {
		for (const entry of entries) if (entry.interactionId && entry.startTime >= viewStart && entry.startTime <= viewEnd) {
			longestInteractions.process(entry);
			subPartsTracker.process(entry);
		}
		subPartsTracker.pruneUntracked();
		const candidate = longestInteractions.estimateP98Interaction();
		if (candidate) updateCurrentInp(candidate);
	}
	function updateCurrentInp(candidate) {
		const newStartTime = (0,entries_time/* elapsed */._J)(viewStart, candidate.startTime);
		if (candidate.duration !== currentInp?.duration || newStartTime !== currentInp.startTime) {
			let targetSelector = getInteractionSelector(candidate.startTime);
			if (!targetSelector && candidate.target && isElementNode(candidate.target)) targetSelector = getSelectorFromElement(candidate.target, configuration.actionNameAttribute);
			currentInp = {
				duration: candidate.duration,
				startTime: newStartTime,
				targetSelector
			};
		}
		currentInp.subParts = subPartsTracker.computeSubParts(candidate, sanitizeInpValue(currentInp.duration));
	}
	return {
		getInteractionToNextPaint: () => {
			if (currentInp) return {
				value: sanitizeInpValue(currentInp.duration),
				targetSelector: currentInp.targetSelector,
				time: currentInp.startTime,
				subParts: currentInp.subParts
			};
			else if (getViewInteractionCount()) return { value: 0 };
		},
		setViewEnd: (viewEndTime) => {
			viewEnd = viewEndTime;
			stopViewInteractionCount();
		},
		stop: () => {
			eventSubscription.unsubscribe();
			firstInputSubscription.unsubscribe();
			subPartsTracker.stop();
		}
	};
}
/**
* Maintains a bounded list of the slowest interactions seen so far, used to estimate the p98
* interaction duration without keeping every entry in memory.
*/
function trackLongestInteractions(getViewInteractionCount) {
	const longestInteractions = [];
	function sortAndTrimLongestInteractions() {
		longestInteractions.sort((a, b) => b.duration - a.duration).splice(MAX_INTERACTION_ENTRIES);
	}
	return {
		/**
		* Process the performance entry:
		* - if its duration is long enough, add the performance entry to the list of worst interactions
		* - if an entry with the same interaction id exists and its duration is lower than the new one, then replace it in the list of worst interactions
		*/
		process(entry) {
			const interactionIndex = longestInteractions.findIndex((interaction) => entry.interactionId === interaction.interactionId);
			const minLongestInteraction = longestInteractions[longestInteractions.length - 1];
			if (interactionIndex !== -1) {
				if (entry.duration > longestInteractions[interactionIndex].duration) {
					longestInteractions[interactionIndex] = entry;
					sortAndTrimLongestInteractions();
				}
			} else if (longestInteractions.length < MAX_INTERACTION_ENTRIES || entry.duration > minLongestInteraction.duration) {
				longestInteractions.push(entry);
				sortAndTrimLongestInteractions();
			}
		},
		/**
		* Compute the p98 longest interaction.
		* For better performance the computation is based on 10 longest interactions and the interaction count of the current view.
		*/
		estimateP98Interaction() {
			const interactionIndex = Math.min(longestInteractions.length - 1, Math.floor(getViewInteractionCount() / 50));
			return longestInteractions[interactionIndex];
		},
		isTracked(interactionId) {
			return longestInteractions.some((i) => i.interactionId === interactionId);
		}
	};
}
/**
* Tracks the number of interactions that occurred during the current view. Freezes the count
* when the view ends so that the p98 estimate remains stable after `setViewEnd` is called.
*/
function trackViewInteractionCount(viewLoadingType) {
	initInteractionCountPolyfill();
	const previousInteractionCount = viewLoadingType === ViewLoadingType.INITIAL_LOAD ? 0 : getInteractionCount();
	let state = { stopped: false };
	function computeViewInteractionCount() {
		return getInteractionCount() - previousInteractionCount;
	}
	return {
		getViewInteractionCount: () => {
			if (state.stopped) return state.interactionCount;
			return computeViewInteractionCount();
		},
		stopViewInteractionCount: () => {
			state = {
				stopped: true,
				interactionCount: computeViewInteractionCount()
			};
		}
	};
}
/**
* Groups performance entries by interaction and render time to compute INP subparts
* (input delay, processing duration, presentation delay). Entries sharing the same
* interactionId, or whose render time falls within the 8 ms Event Timing rounding window,
* are merged into a single group so that subparts always sum to the reported INP duration.
*/
function createSubPartsTracker(longestInteractions) {
	const groupsByInteractionId = /* @__PURE__ */ new Map();
	function updateGroupWithEntry(group, entry) {
		group.startTime = Math.min(entry.startTime, group.startTime);
		group.processingStart = Math.min(entry.processingStart, group.processingStart);
		group.processingEnd = Math.max(entry.processingEnd, group.processingEnd);
	}
	return {
		process(entry) {
			if (entry.interactionId === void 0 || !entry.processingStart || !entry.processingEnd) return;
			const renderTime = entry.startTime + entry.duration;
			const existingGroup = groupsByInteractionId.get(entry.interactionId);
			if (existingGroup) {
				updateGroupWithEntry(existingGroup, entry);
				return;
			}
			for (const [, group] of groupsByInteractionId.entries()) if (Math.abs(renderTime - group.referenceRenderTime) <= RENDER_TIME_GROUPING_THRESHOLD) {
				updateGroupWithEntry(group, entry);
				groupsByInteractionId.set(entry.interactionId, group);
				return;
			}
			groupsByInteractionId.set(entry.interactionId, {
				startTime: entry.startTime,
				processingStart: entry.processingStart,
				processingEnd: entry.processingEnd,
				referenceRenderTime: renderTime
			});
		},
		pruneUntracked() {
			for (const [interactionId] of groupsByInteractionId) if (!longestInteractions.isTracked(interactionId)) groupsByInteractionId.delete(interactionId);
		},
		computeSubParts(entry, inpDuration) {
			if (!entry.processingStart || !entry.processingEnd || entry.interactionId === void 0) return;
			const group = groupsByInteractionId.get(entry.interactionId);
			if (!group) return;
			const nextPaintTime = Math.max(group.startTime + inpDuration, group.processingStart);
			const processingEnd = Math.min(group.processingEnd, nextPaintTime);
			return {
				inputDelay: (0,entries_time/* elapsed */._J)(group.startTime, group.processingStart),
				processingDuration: (0,entries_time/* elapsed */._J)(group.processingStart, processingEnd),
				presentationDelay: (0,entries_time/* elapsed */._J)(processingEnd, nextPaintTime)
			};
		},
		stop() {
			groupsByInteractionId.clear();
		}
	};
}
function isInteractionToNextPaintSupported() {
	return supportPerformanceTimingEvent("event") && window.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype;
}
function sanitizeInpValue(inpValue) {
	return Math.min(inpValue, MAX_INP_VALUE);
}
//#endregion


//# sourceMappingURL=trackInteractionToNextPaint.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackLoadingTime.mjs




//#region src/domain/view/viewMetrics/trackLoadingTime.ts
/**
* For non-initial views (such as route changes or BFCache restores), the regular load event does not fire
* In these cases, trackLoadingTime can only emit a loadingTime  if waitPageActivityEnd detects some post-restore activity.
* If nothing happens after the view starts,no candidate is recorded and loadingTime stays undefined.
*/
function trackLoadingTime(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadType, viewStart, callback) {
	let isWaitingForLoadEvent = loadType === ViewLoadingType.INITIAL_LOAD;
	let isWaitingForActivityLoadingTime = true;
	const loadingTimeCandidates = [];
	const firstHidden = trackFirstHidden(viewStart);
	function invokeCallbackIfAllCandidatesAreReceived() {
		if (!isWaitingForActivityLoadingTime && !isWaitingForLoadEvent && loadingTimeCandidates.length > 0) {
			const loadingTime = Math.max(...loadingTimeCandidates);
			if (loadingTime < firstHidden.timeStamp - viewStart.relative) callback(loadingTime);
		}
	}
	const { stop } = waitPageActivityEnd(lifeCycle, domMutationObservable, windowOpenObservable, configuration, (event) => {
		if (isWaitingForActivityLoadingTime) {
			isWaitingForActivityLoadingTime = false;
			if (event.hadActivity) loadingTimeCandidates.push((0,entries_time/* elapsed */._J)(viewStart.timeStamp, event.end));
			invokeCallbackIfAllCandidatesAreReceived();
		}
	});
	return {
		stop: () => {
			stop();
			firstHidden.stop();
		},
		setLoadEvent: (loadEvent) => {
			if (isWaitingForLoadEvent) {
				isWaitingForLoadEvent = false;
				loadingTimeCandidates.push(loadEvent);
				invokeCallbackIfAllCandidatesAreReceived();
			}
		}
	};
}
//#endregion


//# sourceMappingURL=trackLoadingTime.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackScrollMetrics.mjs




//#region src/domain/view/viewMetrics/trackScrollMetrics.ts
/** Arbitrary scroll throttle duration */
const THROTTLE_SCROLL_DURATION = entries_time/* ONE_SECOND */.WT;
function trackScrollMetrics(viewStart, callback, scrollValues = createScrollValuesObservable()) {
	let maxScrollDepth = 0;
	let maxScrollHeight = 0;
	let maxScrollHeightTime = 0;
	const subscription = scrollValues.subscribe(({ scrollDepth, scrollTop, scrollHeight }) => {
		let shouldUpdate = false;
		if (scrollDepth > maxScrollDepth) {
			maxScrollDepth = scrollDepth;
			shouldUpdate = true;
		}
		if (scrollHeight > maxScrollHeight) {
			maxScrollHeight = scrollHeight;
			const now = (0,entries_time/* relativeNow */._q)();
			maxScrollHeightTime = (0,entries_time/* elapsed */._J)(viewStart.relative, now);
			shouldUpdate = true;
		}
		if (shouldUpdate) callback({
			maxDepth: Math.min(maxScrollDepth, maxScrollHeight),
			maxDepthScrollTop: scrollTop,
			maxScrollHeight,
			maxScrollHeightTime
		});
	});
	return { stop: () => subscription.unsubscribe() };
}
function computeScrollValues() {
	const scrollTop = getScrollY();
	const { height } = getViewportDimension();
	return {
		scrollHeight: Math.round((document.scrollingElement || document.documentElement).scrollHeight),
		scrollDepth: Math.round(height + scrollTop),
		scrollTop
	};
}
function createScrollValuesObservable(throttleDuration = THROTTLE_SCROLL_DURATION) {
	return new tools_observable/* Observable */.y$((observable) => {
		function notify() {
			observable.notify(computeScrollValues());
		}
		const throttledNotify = (0,functionUtils/* throttle */.P)(notify, throttleDuration, {
			leading: false,
			trailing: true
		});
		const observerTarget = document.scrollingElement || document.documentElement;
		const resizeObserver = new ResizeObserver((0,monitor/* monitor */.zk)(throttledNotify.throttled));
		if (observerTarget) resizeObserver.observe(observerTarget);
		const eventListener = (0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.SCROLL */.EZ.SCROLL, throttledNotify.throttled, { passive: true });
		return () => {
			throttledNotify.cancel();
			resizeObserver.disconnect();
			eventListener.stop();
		};
	});
}
//#endregion


//# sourceMappingURL=trackScrollMetrics.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackCommonViewMetrics.mjs





//#region src/domain/view/viewMetrics/trackCommonViewMetrics.ts
function trackCommonViewMetrics(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, viewStart) {
	const commonViewMetrics = {};
	let hasManualLoadingTime = false;
	let viewEnded = false;
	const { stop: stopLoadingTimeTracking, setLoadEvent } = trackLoadingTime(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, viewStart, (newLoadingTime) => {
		if (!hasManualLoadingTime) {
			commonViewMetrics.loadingTime = newLoadingTime;
			scheduleViewUpdate();
		}
	});
	const { stop: stopScrollMetricsTracking } = trackScrollMetrics(viewStart, (newScrollMetrics) => {
		commonViewMetrics.scroll = newScrollMetrics;
	});
	const { stop: stopCLSTracking } = trackCumulativeLayoutShift(configuration, viewStart.relative, (cumulativeLayoutShift) => {
		commonViewMetrics.cumulativeLayoutShift = cumulativeLayoutShift;
		scheduleViewUpdate();
	});
	const { stop: stopINPTracking, getInteractionToNextPaint, setViewEnd: setINPViewEnd } = trackInteractionToNextPaint(configuration, viewStart.relative, loadingType);
	return {
		stop: () => {
			stopLoadingTimeTracking();
			stopCLSTracking();
			stopScrollMetricsTracking();
		},
		stopINPTracking,
		setLoadEvent,
		setViewEnd: (viewEndTime) => {
			viewEnded = true;
			setINPViewEnd(viewEndTime);
		},
		getCommonViewMetrics: () => {
			commonViewMetrics.interactionToNextPaint = getInteractionToNextPaint();
			return commonViewMetrics;
		},
		setLoadingTime: (callTimestamp) => {
			if (viewEnded) return;
			const loadingTime = (0,entries_time/* elapsed */._J)(viewStart.timeStamp, callTimestamp ?? (0,entries_time/* timeStampNow */.n$)());
			if (!hasManualLoadingTime) stopLoadingTimeTracking();
			hasManualLoadingTime = true;
			commonViewMetrics.loadingTime = loadingTime;
			scheduleViewUpdate();
		}
	};
}
//#endregion


//# sourceMappingURL=trackCommonViewMetrics.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/bfCacheSupport.mjs

//#region src/domain/view/bfCacheSupport.ts
function onBFCacheRestore(callback) {
	const { stop } = (0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.PAGE_SHOW */.EZ.PAGE_SHOW, (event) => {
		if (event.persisted) callback(event);
	}, { capture: true });
	return stop;
}
//#endregion


//# sourceMappingURL=bfCacheSupport.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewMetrics/trackBfcacheMetrics.mjs

//#region src/domain/view/viewMetrics/trackBfcacheMetrics.ts
/**
* BFCache keeps a full in-memory snapshot of the DOM. When the page is restored, nothing needs to be fetched, so the whole
* viewport repaints in a single frame. Consequently, LCP almost always equals FCP.
* (See: https://github.com/GoogleChrome/web-vitals/pull/87)
*/
function trackBfcacheMetrics(viewStart, metrics, scheduleViewUpdate) {
	trackRestoredFirstContentfulPaint(viewStart.relative, (paintTime) => {
		metrics.firstContentfulPaint = paintTime;
		metrics.largestContentfulPaint = { value: paintTime };
		scheduleViewUpdate();
	});
}
//#endregion


//# sourceMappingURL=trackBfcacheMetrics.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/contextUtils.mjs


//#region src/domain/context/contextUtils.ts
/**
* Simple check to ensure an object is a valid context
*/
function checkContext(maybeContext) {
	const isValid = (0,typeUtils/* getType */.oL)(maybeContext) === "object";
	if (!isValid) display/* display.error */.jf.error("Unsupported context:", maybeContext);
	return isValid;
}
//#endregion


//# sourceMappingURL=contextUtils.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/contextManager.mjs





//#region src/domain/context/contextManager.ts
function ensureProperties(context, propertiesConfig, name) {
	const newContext = { ...context };
	for (const [key, { required, type }] of Object.entries(propertiesConfig)) {
		/**
		* Ensure specified properties are strings as defined here:
		* https://docs.datadoghq.com/logs/log_configuration/attributes_naming_convention/#user-related-attributes
		*/
		if (type === "string" && !isDefined(newContext[key])) newContext[key] = String(newContext[key]);
		if (required && isDefined(newContext[key])) display/* display.warn */.jf.warn(`The property ${key} of ${name} is required; context will not be sent to the intake.`);
	}
	return newContext;
}
function isDefined(value) {
	return value === void 0 || value === null || value === "";
}
function createContextManager(name = "", { propertiesConfig = {} } = {}) {
	let context = {};
	const changeObservable = new tools_observable/* Observable */.y$();
	const contextManager = {
		getContext: () => (0,mergeInto/* deepClone */.I8)(context),
		setContext: (newContext) => {
			if (checkContext(newContext)) context = sanitize(ensureProperties(newContext, propertiesConfig, name));
			else contextManager.clearContext();
			changeObservable.notify();
		},
		setContextProperty: (key, property) => {
			context = sanitize(ensureProperties({
				...context,
				[key]: property
			}, propertiesConfig, name));
			changeObservable.notify();
		},
		removeContextProperty: (key) => {
			delete context[key];
			ensureProperties(context, propertiesConfig, name);
			changeObservable.notify();
		},
		clearContext: () => {
			context = {};
			changeObservable.notify();
		},
		changeObservable
	};
	return contextManager;
}
//#endregion


//# sourceMappingURL=contextManager.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/browser/pageMayExitObservable.mjs
var pageMayExitObservable = __webpack_require__(61636);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/trackViews.mjs









//#region src/domain/view/trackViews.ts
const THROTTLE_VIEW_UPDATE_PERIOD = 3e3;
const SESSION_KEEP_ALIVE_INTERVAL = 5 * entries_time/* ONE_MINUTE */.yR;
const KEEP_TRACKING_AFTER_VIEW_DELAY = 5 * entries_time/* ONE_MINUTE */.yR;
function trackViews(lifeCycle, domMutationObservable, windowOpenObservable, configuration, locationChangeObservable, areViewsTrackedAutomatically, initialViewOptions) {
	const activeViews = /* @__PURE__ */ new Set();
	let currentView = startNewView(ViewLoadingType.INITIAL_LOAD, (0,entries_time/* clocksOrigin */.cQ)(), initialViewOptions);
	let stopOnBFCacheRestore;
	startViewLifeCycle();
	let locationChangeSubscription;
	if (areViewsTrackedAutomatically) {
		locationChangeSubscription = renewViewOnLocationChange(locationChangeObservable);
		stopOnBFCacheRestore = onBFCacheRestore((pageshowEvent) => {
			currentView.end();
			const startClocks = (0,entries_time/* relativeToClocks */.DY)(pageshowEvent.timeStamp);
			currentView = startNewView(ViewLoadingType.BF_CACHE, startClocks, void 0);
		});
	}
	function startNewView(loadingType, startClocks, viewOptions) {
		const newlyCreatedView = newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, startClocks, viewOptions);
		activeViews.add(newlyCreatedView);
		newlyCreatedView.stopObservable.subscribe(() => {
			activeViews.delete(newlyCreatedView);
		});
		return newlyCreatedView;
	}
	function startViewLifeCycle() {
		lifeCycle.subscribe(11, () => {
			currentView = startNewView(ViewLoadingType.SESSION_RENEWAL, void 0, {
				name: currentView.name,
				service: currentView.service,
				version: currentView.version,
				context: currentView.contextManager.getContext()
			});
		});
		lifeCycle.subscribe(10, () => {
			currentView.end({ sessionIsActive: false });
		});
	}
	function renewViewOnLocationChange(locationChangeObservable) {
		return locationChangeObservable.subscribe(({ oldLocation, newLocation }) => {
			if (areDifferentLocation(oldLocation, newLocation)) {
				currentView.end();
				currentView = startNewView(ViewLoadingType.ROUTE_CHANGE);
			}
		});
	}
	return {
		addTiming: (name, time = (0,entries_time/* timeStampNow */.n$)()) => {
			currentView.addTiming(name, time);
		},
		setLoadingTime: (callTimestamp) => currentView.setLoadingTime(callTimestamp),
		startView: (options, startClocks) => {
			currentView.end({ endClocks: startClocks });
			currentView = startNewView(ViewLoadingType.ROUTE_CHANGE, startClocks, options);
		},
		setViewContext: (context) => {
			currentView.contextManager.setContext(context);
		},
		setViewContextProperty: (key, value) => {
			currentView.contextManager.setContextProperty(key, value);
		},
		setViewName: (name) => {
			currentView.setViewName(name);
		},
		getViewContext: () => currentView.contextManager.getContext(),
		stop: () => {
			if (locationChangeSubscription) locationChangeSubscription.unsubscribe();
			if (stopOnBFCacheRestore) stopOnBFCacheRestore();
			currentView.end();
			activeViews.forEach((view) => view.stop());
		}
	};
}
function newView(lifeCycle, domMutationObservable, windowOpenObservable, configuration, loadingType, startClocks = (0,entries_time/* clocksNow */.$I)(), viewOptions) {
	const id = generateUUID();
	const stopObservable = new tools_observable/* Observable */.y$();
	const customTimings = {};
	let documentVersion = 0;
	let endClocks;
	const location = (0,objectUtils/* shallowClone */.mv)((0,mockable/* mockable */.C)(window.location));
	const contextManager = createContextManager();
	let sessionIsActive = true;
	let name = viewOptions?.name;
	const service = viewOptions?.service || configuration.service;
	const version = viewOptions?.version || configuration.version;
	const context = viewOptions?.context;
	const handlingStack = viewOptions?.handlingStack;
	if (context) contextManager.setContext(context);
	const viewCreatedEvent = {
		id,
		name,
		startClocks,
		service,
		version,
		context,
		url: viewOptions?.url
	};
	lifeCycle.notify(1, viewCreatedEvent);
	lifeCycle.notify(2, viewCreatedEvent);
	const { throttled, cancel: cancelScheduleViewUpdate } = (0,functionUtils/* throttle */.P)(triggerViewUpdate, THROTTLE_VIEW_UPDATE_PERIOD, { leading: false });
	const { setLoadEvent, setViewEnd, stop: stopCommonViewMetricsTracking, stopINPTracking, getCommonViewMetrics, setLoadingTime } = trackCommonViewMetrics(lifeCycle, domMutationObservable, windowOpenObservable, configuration, scheduleViewUpdate, loadingType, startClocks);
	const { stop: stopInitialViewMetricsTracking, initialViewMetrics } = loadingType === ViewLoadingType.INITIAL_LOAD ? trackInitialViewMetrics(configuration, startClocks, setLoadEvent, scheduleViewUpdate) : {
		stop: functionUtils/* noop */.Z,
		initialViewMetrics: {}
	};
	if (loadingType === ViewLoadingType.BF_CACHE) trackBfcacheMetrics(startClocks, initialViewMetrics, scheduleViewUpdate);
	const { stop: stopEventCountsTracking, eventCounts } = trackViewEventCounts(lifeCycle, id, scheduleViewUpdate);
	const keepAliveIntervalId = (0,timer/* setInterval */.Zi)(triggerViewUpdate, SESSION_KEEP_ALIVE_INTERVAL);
	const pageMayExitSubscription = lifeCycle.subscribe(12, (reason) => {
		if (reason === pageMayExitObservable/* PageExitReason.UNLOADING */.k$.UNLOADING) triggerViewUpdate();
	});
	triggerViewUpdate();
	contextManager.changeObservable.subscribe(scheduleViewUpdate);
	function triggerBeforeViewUpdate() {
		lifeCycle.notify(3, {
			id,
			name,
			context: contextManager.getContext(),
			startClocks,
			sessionIsActive
		});
	}
	function scheduleViewUpdate() {
		triggerBeforeViewUpdate();
		throttled();
	}
	function triggerViewUpdate() {
		cancelScheduleViewUpdate();
		triggerBeforeViewUpdate();
		documentVersion += 1;
		const currentEnd = endClocks === void 0 ? (0,entries_time/* timeStampNow */.n$)() : endClocks.timeStamp;
		lifeCycle.notify(4, {
			customTimings,
			documentVersion,
			id,
			name,
			service,
			version,
			context: contextManager.getContext(),
			loadingType,
			location,
			handlingStack,
			startClocks,
			commonViewMetrics: getCommonViewMetrics(),
			initialViewMetrics,
			duration: (0,entries_time/* elapsed */._J)(startClocks.timeStamp, currentEnd),
			isActive: endClocks === void 0,
			sessionIsActive,
			eventCounts
		});
	}
	return {
		get name() {
			return name;
		},
		service,
		version,
		contextManager,
		stopObservable,
		end(options = {}) {
			if (endClocks) return;
			endClocks = options.endClocks ?? (0,entries_time/* clocksNow */.$I)();
			sessionIsActive = options.sessionIsActive ?? true;
			lifeCycle.notify(5, { endClocks });
			lifeCycle.notify(6, { endClocks });
			(0,timer/* clearInterval */.cv)(keepAliveIntervalId);
			setViewEnd(endClocks.relative);
			stopCommonViewMetricsTracking();
			pageMayExitSubscription.unsubscribe();
			triggerViewUpdate();
			(0,timer/* setTimeout */.iK)(() => {
				this.stop();
			}, KEEP_TRACKING_AFTER_VIEW_DELAY);
		},
		stop() {
			stopInitialViewMetricsTracking();
			stopEventCountsTracking();
			stopINPTracking();
			stopObservable.notify();
		},
		addTiming(name, time) {
			if (endClocks) return;
			const relativeTime = (0,entries_time/* isRelativeTime */.MN)(time) ? time : (0,entries_time/* elapsed */._J)(startClocks.timeStamp, time);
			customTimings[sanitizeTiming(name)] = relativeTime;
			scheduleViewUpdate();
		},
		setLoadingTime,
		setViewName(updatedName) {
			name = updatedName;
			triggerViewUpdate();
		}
	};
}
/**
* Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
*/
function sanitizeTiming(name) {
	const sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, "_");
	if (sanitized !== name) display/* display.warn */.jf.warn(`Invalid timing name: ${name}, sanitized to: ${sanitized}`);
	return sanitized;
}
function areDifferentLocation(currentLocation, otherLocation) {
	return currentLocation.pathname !== otherLocation.pathname || !isHashAnAnchor(otherLocation.hash) && getPathFromHash(otherLocation.hash) !== getPathFromHash(currentLocation.hash);
}
function isHashAnAnchor(hash) {
	const correspondingId = hash.substring(1);
	return correspondingId !== "" && !!document.getElementById(correspondingId);
}
function getPathFromHash(hash) {
	const index = hash.indexOf("?");
	return index < 0 ? hash : hash.slice(0, index);
}
//#endregion


//# sourceMappingURL=trackViews.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/tools/utils/timezone.mjs
//#region src/tools/utils/timezone.ts
function getTimeZone() {
	try {
		return new Intl.DateTimeFormat().resolvedOptions().timeZone;
	} catch {
		return;
	}
}
//#endregion


//# sourceMappingURL=timezone.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewCollection.mjs







//#region src/domain/view/viewCollection.ts
function startViewCollection(lifeCycle, hooks, configuration, domMutationObservable, pageOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions) {
	lifeCycle.subscribe(4, (view) => lifeCycle.notify(13, processViewUpdate(view, configuration, recorderApi)));
	hooks.assemble.register(({ startTime, eventType }) => {
		const view = viewHistory.findView(startTime);
		if (!view) return assembly_hook/* DISCARDED */.C_;
		return {
			type: eventType,
			service: view.service,
			version: view.version,
			context: view.context,
			view: {
				id: view.id,
				name: view.name
			}
		};
	});
	hooks.assembleTelemetry.register(({ startTime }) => ({ view: { id: viewHistory.findView(startTime)?.id } }));
	return trackViews(lifeCycle, domMutationObservable, pageOpenObservable, configuration, locationChangeObservable, !configuration.trackViewsManually, initialViewOptions);
}
function processViewUpdate(view, configuration, recorderApi) {
	const replayStats = recorderApi.getReplayStats(view.id);
	const clsDevicePixelRatio = view.commonViewMetrics?.cumulativeLayoutShift?.devicePixelRatio;
	const viewEvent = {
		_dd: {
			document_version: view.documentVersion,
			replay_stats: replayStats,
			cls: clsDevicePixelRatio ? { device_pixel_ratio: clsDevicePixelRatio } : void 0,
			configuration: {
				start_session_replay_recording_manually: configuration.startSessionReplayRecordingManually,
				remote_configuration_id: configuration.remoteConfigurationId
			}
		},
		date: view.startClocks.timeStamp,
		type: RumEventType.VIEW,
		view: {
			action: { count: view.eventCounts.actionCount },
			frustration: { count: view.eventCounts.frustrationCount },
			cumulative_layout_shift: view.commonViewMetrics.cumulativeLayoutShift?.value,
			cumulative_layout_shift_time: (0,entries_time/* toServerDuration */.dg)(view.commonViewMetrics.cumulativeLayoutShift?.time),
			cumulative_layout_shift_target_selector: view.commonViewMetrics.cumulativeLayoutShift?.targetSelector,
			first_byte: (0,entries_time/* toServerDuration */.dg)(view.initialViewMetrics.navigationTimings?.firstByte),
			dom_complete: (0,entries_time/* toServerDuration */.dg)(view.initialViewMetrics.navigationTimings?.domComplete),
			dom_content_loaded: (0,entries_time/* toServerDuration */.dg)(view.initialViewMetrics.navigationTimings?.domContentLoaded),
			dom_interactive: (0,entries_time/* toServerDuration */.dg)(view.initialViewMetrics.navigationTimings?.domInteractive),
			error: { count: view.eventCounts.errorCount },
			first_contentful_paint: (0,entries_time/* toServerDuration */.dg)(view.initialViewMetrics.firstContentfulPaint),
			interaction_to_next_paint: (0,entries_time/* toServerDuration */.dg)(view.commonViewMetrics.interactionToNextPaint?.value),
			interaction_to_next_paint_time: (0,entries_time/* toServerDuration */.dg)(view.commonViewMetrics.interactionToNextPaint?.time),
			interaction_to_next_paint_target_selector: view.commonViewMetrics.interactionToNextPaint?.targetSelector,
			is_active: view.isActive,
			name: view.name,
			largest_contentful_paint: (0,entries_time/* toServerDuration */.dg)(view.initialViewMetrics.largestContentfulPaint?.value),
			largest_contentful_paint_target_selector: view.initialViewMetrics.largestContentfulPaint?.targetSelector,
			load_event: (0,entries_time/* toServerDuration */.dg)(view.initialViewMetrics.navigationTimings?.loadEvent),
			loading_time: discardNegativeDuration((0,entries_time/* toServerDuration */.dg)(view.commonViewMetrics.loadingTime)),
			loading_type: view.loadingType,
			long_task: { count: view.eventCounts.longTaskCount },
			performance: computeViewPerformanceData(view.commonViewMetrics, view.initialViewMetrics),
			resource: { count: view.eventCounts.resourceCount },
			time_spent: (0,entries_time/* toServerDuration */.dg)(view.duration)
		},
		display: view.commonViewMetrics.scroll ? { scroll: {
			max_depth: view.commonViewMetrics.scroll.maxDepth,
			max_depth_scroll_top: view.commonViewMetrics.scroll.maxDepthScrollTop,
			max_scroll_height: view.commonViewMetrics.scroll.maxScrollHeight,
			max_scroll_height_time: (0,entries_time/* toServerDuration */.dg)(view.commonViewMetrics.scroll.maxScrollHeightTime)
		} } : void 0,
		privacy: { replay_level: configuration.defaultPrivacyLevel },
		device: {
			locale: navigator.language,
			locales: navigator.languages,
			time_zone: getTimeZone()
		}
	};
	if (!(0,objectUtils/* isEmptyObject */.Qr)(view.customTimings)) viewEvent.view.custom_timings = (0,objectUtils/* mapValues */.Q8)(view.customTimings, entries_time/* toServerDuration */.dg);
	return {
		rawRumEvent: viewEvent,
		startClocks: view.startClocks,
		duration: view.duration,
		domainContext: {
			location: view.location,
			handlingStack: view.handlingStack
		}
	};
}
function computeViewPerformanceData({ cumulativeLayoutShift, interactionToNextPaint }, { firstContentfulPaint, largestContentfulPaint }) {
	return {
		cls: cumulativeLayoutShift && {
			score: cumulativeLayoutShift.value,
			timestamp: (0,entries_time/* toServerDuration */.dg)(cumulativeLayoutShift.time),
			target_selector: cumulativeLayoutShift.targetSelector,
			previous_rect: cumulativeLayoutShift.previousRect,
			current_rect: cumulativeLayoutShift.currentRect
		},
		fcp: firstContentfulPaint && { timestamp: (0,entries_time/* toServerDuration */.dg)(firstContentfulPaint) },
		inp: interactionToNextPaint && {
			duration: (0,entries_time/* toServerDuration */.dg)(interactionToNextPaint.value),
			timestamp: (0,entries_time/* toServerDuration */.dg)(interactionToNextPaint.time),
			target_selector: interactionToNextPaint.targetSelector,
			sub_parts: interactionToNextPaint.subParts ? {
				input_delay: (0,entries_time/* toServerDuration */.dg)(interactionToNextPaint.subParts.inputDelay),
				processing_duration: (0,entries_time/* toServerDuration */.dg)(interactionToNextPaint.subParts.processingDuration),
				presentation_delay: (0,entries_time/* toServerDuration */.dg)(interactionToNextPaint.subParts.presentationDelay)
			} : void 0
		},
		lcp: largestContentfulPaint && {
			timestamp: (0,entries_time/* toServerDuration */.dg)(largestContentfulPaint.value),
			target_selector: largestContentfulPaint.targetSelector,
			resource_url: largestContentfulPaint.resourceUrl,
			sub_parts: largestContentfulPaint.subParts ? {
				load_delay: (0,entries_time/* toServerDuration */.dg)(largestContentfulPaint.subParts.loadDelay),
				load_time: (0,entries_time/* toServerDuration */.dg)(largestContentfulPaint.subParts.loadTime),
				render_delay: (0,entries_time/* toServerDuration */.dg)(largestContentfulPaint.subParts.renderDelay)
			} : void 0
		}
	};
}
//#endregion


//# sourceMappingURL=viewCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/view/viewDiff.mjs

//#region src/domain/view/viewDiff.ts
/**
* Compare two values for deep equality
*/
function isEqual(a, b) {
	if (a === b) return true;
	if (a === null || typeof a !== "object" || b === null || typeof b !== "object") return a === b;
	if (Array.isArray(a) && Array.isArray(b)) {
		if (a.length !== b.length) return false;
		return a.every((val, idx) => isEqual(val, b[idx]));
	}
	if (Array.isArray(a) || Array.isArray(b)) return false;
	const aObj = a;
	const bObj = b;
	const aKeys = Object.keys(aObj);
	const bKeys = Object.keys(bObj);
	if (aKeys.length !== bKeys.length) return false;
	return aKeys.every((key) => bKeys.includes(key) && isEqual(aObj[key], bObj[key]));
}
/**
* MERGE strategy: compare two objects and return an object with only changed fields.
* Returns undefined if no changes.
*
* Default strategy is REPLACE (isEqual check). Exceptions:
* - Both values are plain objects and key is not in replaceKeys: recurse (MERGE), sub-paths
* (e.g. 'view.custom_timings') are propagated to the recursive call.
* - Both values are arrays and key is in appendKeys: include only new trailing elements (APPEND)
*/
function diffMerge(current, lastSent, options) {
	const result = {};
	const replaceKeys = options?.replaceKeys ?? /* @__PURE__ */ new Set();
	const appendKeys = options?.appendKeys ?? /* @__PURE__ */ new Set();
	const ignoreKeys = options?.ignoreKeys ?? /* @__PURE__ */ new Set();
	for (const key of Object.keys(current)) {
		if (ignoreKeys.has(key)) continue;
		const currentVal = current[key];
		const lastSentVal = lastSent[key];
		if (!replaceKeys.has(key) && (0,typeUtils/* isIndexableObject */.sK)(currentVal) && (0,typeUtils/* isIndexableObject */.sK)(lastSentVal)) {
			const nestedDiff = diffMerge(currentVal, lastSentVal, {
				replaceKeys: extractSubPaths(replaceKeys, key),
				appendKeys: extractSubPaths(appendKeys, key),
				ignoreKeys: extractSubPaths(ignoreKeys, key)
			});
			if (nestedDiff) result[key] = nestedDiff;
		} else if (appendKeys.has(key) && Array.isArray(currentVal) && Array.isArray(lastSentVal)) {
			if (currentVal.length > lastSentVal.length) result[key] = currentVal.slice(lastSentVal.length);
		} else if (!isEqual(currentVal, lastSentVal)) result[key] = currentVal;
	}
	for (const key of Object.keys(lastSent)) if (!(key in current)) result[key] = null;
	return Object.keys(result).length > 0 ? result : void 0;
}
function extractSubPaths(keys, prefix) {
	const result = /* @__PURE__ */ new Set();
	for (const key of keys) if (key.startsWith(`${prefix}.`)) result.add(key.slice(prefix.length + 1));
	return result;
}
//#endregion


//# sourceMappingURL=viewDiff.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/sendToExtension.mjs
var sendToExtension = __webpack_require__(86834);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/batch.mjs + 1 modules
var transport_batch = __webpack_require__(57242);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/deflate/deflate.types.mjs
var deflate_types = __webpack_require__(37182);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumBatch.mjs






function computeAssembledViewDiff(current, last) {
	const diff = diffMerge(current, last, {
		replaceKeys: /* @__PURE__ */ new Set([
			"view.custom_timings",
			"context",
			"connectivity",
			"usr",
			"device",
			"privacy"
		]),
		appendKeys: /* @__PURE__ */ new Set(["_dd.page_states"]),
		ignoreKeys: /* @__PURE__ */ new Set([
			"date",
			"type",
			"application",
			"session",
			"view.id",
			"view.url",
			"_dd.document_version",
			"_dd.format_version"
		])
	});
	if (!diff) return;
	return (0,mergeInto/* combine */.$e)(diff, {
		type: RumEventType.VIEW_UPDATE,
		date: current.date,
		application: current.application,
		session: current.session,
		view: {
			id: current.view.id,
			url: current.view.url
		},
		_dd: {
			document_version: current._dd.document_version,
			format_version: current._dd.format_version
		}
	});
}
/**
* Dispatches assembled RUM events to the batch. VIEW events are handled specially:
* intermediate updates either replace the full VIEW already in the batch, or are
* aggregated into a single view_update diff against the last flushed state.
*/
function createBatchDispatcher(batch, enableViewUpdates) {
	let lastSentView;
	let batchBase;
	let batchHasFullView = false;
	let viewUpdatesSinceCheckpoint = 0;
	const { unsubscribe } = batch.flushObservable.subscribe(() => {
		batchHasFullView = false;
		batchBase = lastSentView;
	});
	return {
		dispatch: (serverRumEvent) => {
			if (serverRumEvent.type !== RumEventType.VIEW) {
				batch.add(serverRumEvent);
				return;
			}
			if (!enableViewUpdates) {
				batch.upsert(serverRumEvent, serverRumEvent.view.id);
				return;
			}
			const viewId = serverRumEvent.view.id;
			if (!serverRumEvent.view.is_active) {
				if (viewId === lastSentView?.view.id) {
					lastSentView = void 0;
					batchBase = void 0;
					batchHasFullView = false;
					viewUpdatesSinceCheckpoint = 0;
				}
				batch.upsert(serverRumEvent, viewId);
				return;
			}
			if (viewId !== lastSentView?.view.id) {
				viewUpdatesSinceCheckpoint = 0;
				batch.upsert(serverRumEvent, viewId);
				lastSentView = serverRumEvent;
				batchHasFullView = !batch.isEmpty;
				return;
			}
			lastSentView = serverRumEvent;
			if (batchHasFullView) {
				batch.upsert(serverRumEvent, viewId);
				return;
			}
			viewUpdatesSinceCheckpoint += 1;
			if (viewUpdatesSinceCheckpoint >= 100) {
				viewUpdatesSinceCheckpoint = 0;
				batch.upsert(serverRumEvent, viewId);
				batchHasFullView = !batch.isEmpty;
				return;
			}
			if (batchBase) {
				const diff = computeAssembledViewDiff(serverRumEvent, batchBase);
				if (diff) {
					(0,sendToExtension/* sendToExtension */.j)("rum", diff);
					batch.upsert(diff, viewId);
				}
			}
		},
		stop: unsubscribe
	};
}
function startRumBatch(configuration, lifeCycle, reportError, sessionExpireObservable, createEncoder) {
	const endpoints = [(0,endpointBuilder/* createEndpointBuilder */.Ez)(configuration, "rum")];
	const replicaEndpoint = (0,endpointBuilder/* createReplicaEndpointBuilder */.ji)(configuration, "rum");
	if (replicaEndpoint) endpoints.push(replicaEndpoint);
	const batch = (0,transport_batch/* createBatch */.n)({
		encoder: createEncoder(deflate_types/* DeflateEncoderStreamId.RUM */.C.RUM),
		endpoints,
		reportError
	});
	sessionExpireObservable.subscribe(() => batch.forceFlush("session_expire"));
	const { dispatch, stop: stopDispatcher } = createBatchDispatcher(batch, configuration.betaEnableViewUpdates);
	lifeCycle.subscribe(14, dispatch);
	const stopBatch = batch.stop.bind(batch);
	batch.stop = () => {
		stopDispatcher();
		stopBatch();
	};
	return batch;
}
//#endregion


//# sourceMappingURL=startRumBatch.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/startRumEventBridge.mjs


//#region src/transport/startRumEventBridge.ts
function startRumEventBridge(lifeCycle) {
	const bridge = (0,eventBridge/* getEventBridge */.Ad)();
	lifeCycle.subscribe(14, (serverRumEvent) => {
		bridge.send("rum", serverRumEvent);
	});
}
//#endregion


//# sourceMappingURL=startRumEventBridge.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/urlContexts.mjs





//#region src/domain/contexts/urlContexts.ts
/**
* We want to attach to an event:
* - the url corresponding to its start
* - the referrer corresponding to the previous view url (or document referrer for initial view)
*/
const URL_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
function startUrlContexts(lifeCycle, assembleHook, locationChangeObservable) {
	const urlContextHistory = (0,valueHistory/* createValueHistory */.p)({ expireDelay: URL_CONTEXT_TIME_OUT_DELAY });
	let previousViewUrl;
	lifeCycle.subscribe(1, ({ startClocks, url }) => {
		const locationHref = (0,mockable/* mockable */.C)(globalObject/* globalObject.location */.Z.location).href;
		const viewUrl = url !== void 0 ? (0,urlPolyfill/* buildUrl */.Q2)(url, locationHref).href : locationHref;
		urlContextHistory.add(buildUrlContext({
			url: viewUrl,
			referrer: !previousViewUrl ? document.referrer : previousViewUrl
		}), startClocks.relative);
		previousViewUrl = viewUrl;
	});
	lifeCycle.subscribe(6, ({ endClocks }) => {
		urlContextHistory.closeActive(endClocks.relative);
	});
	const locationChangeSubscription = locationChangeObservable.subscribe(({ newLocation }) => {
		const current = urlContextHistory.find();
		if (current) {
			const changeTime = (0,entries_time/* relativeNow */._q)();
			urlContextHistory.closeActive(changeTime);
			urlContextHistory.add(buildUrlContext({
				url: newLocation.href,
				referrer: current.referrer
			}), changeTime);
		}
	});
	function buildUrlContext({ url, referrer }) {
		return {
			url,
			referrer
		};
	}
	assembleHook.register(({ startTime, eventType }) => {
		const urlContext = urlContextHistory.find(startTime);
		if (!urlContext) return assembly_hook/* DISCARDED */.C_;
		return {
			type: eventType,
			view: {
				url: urlContext.url,
				referrer: urlContext.referrer
			}
		};
	});
	return {
		findUrl: (startTime) => urlContextHistory.find(startTime),
		stop: () => {
			locationChangeSubscription.unsubscribe();
			urlContextHistory.stop();
		}
	};
}
//#endregion


//# sourceMappingURL=urlContexts.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/locationChangeObservable.mjs

//#region src/browser/locationChangeObservable.ts
function createLocationChangeObservable() {
	let currentLocation = (0,objectUtils/* shallowClone */.mv)(getLocation());
	return new tools_observable/* Observable */.y$((observable) => {
		const { stop: stopHistoryTracking } = trackHistory(onLocationChange);
		const { stop: stopHashTracking } = trackHash(onLocationChange);
		function onLocationChange() {
			if (currentLocation.href === getLocation().href) return;
			const newLocation = (0,objectUtils/* shallowClone */.mv)(getLocation());
			observable.notify({
				newLocation,
				oldLocation: currentLocation
			});
			currentLocation = newLocation;
		}
		return () => {
			stopHistoryTracking();
			stopHashTracking();
		};
	});
}
function getLocation() {
	return (0,mockable/* mockable */.C)(globalObject/* globalObject.location */.Z.location);
}
function trackHistory(onHistoryChange) {
	const { stop: stopInstrumentingPushState } = (0,instrumentMethod/* instrumentMethod */.Su)(getHistoryInstrumentationTarget("pushState"), "pushState", ({ onPostCall }) => {
		onPostCall(onHistoryChange);
	});
	const { stop: stopInstrumentingReplaceState } = (0,instrumentMethod/* instrumentMethod */.Su)(getHistoryInstrumentationTarget("replaceState"), "replaceState", ({ onPostCall }) => {
		onPostCall(onHistoryChange);
	});
	const { stop: removeListener } = (0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.POP_STATE */.EZ.POP_STATE, onHistoryChange);
	return { stop: () => {
		stopInstrumentingPushState();
		stopInstrumentingReplaceState();
		removeListener();
	} };
}
function trackHash(onHashChange) {
	return (0,addEventListener/* addEventListener */.Oo)(window, addEventListener/* DOM_EVENT.HASH_CHANGE */.EZ.HASH_CHANGE, onHashChange);
}
function getHistoryInstrumentationTarget(methodName) {
	return Object.prototype.hasOwnProperty.call(history, methodName) ? history : History.prototype;
}
//#endregion


//# sourceMappingURL=locationChangeObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/featureFlagContext.mjs




//#region src/domain/contexts/featureFlagContext.ts
const FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
/**
* Start feature flag contexts
*
* Feature flag contexts follow the life of views.
* A new context is added when a view is created and ended when the view is ended
*
* Note: we choose not to add a new context at each evaluation to save memory
*/
function startFeatureFlagContexts(lifeCycle, assembleHook, configuration) {
	const featureFlagContexts = (0,valueHistory/* createValueHistory */.p)({ expireDelay: FEATURE_FLAG_CONTEXT_TIME_OUT_DELAY });
	lifeCycle.subscribe(1, ({ startClocks }) => {
		featureFlagContexts.add({}, startClocks.relative);
	});
	lifeCycle.subscribe(6, ({ endClocks }) => {
		featureFlagContexts.closeActive(endClocks.relative);
	});
	assembleHook.register(({ startTime, eventType }) => {
		if (!configuration.trackFeatureFlagsForEvents.concat([RumEventType.VIEW, RumEventType.ERROR]).includes(eventType)) return assembly_hook/* SKIPPED */.kb;
		const featureFlagContext = featureFlagContexts.find(startTime);
		if (!featureFlagContext || (0,objectUtils/* isEmptyObject */.Qr)(featureFlagContext)) return assembly_hook/* SKIPPED */.kb;
		return {
			type: eventType,
			feature_flags: featureFlagContext
		};
	});
	return { addFeatureFlagEvaluation: (key, value) => {
		const currentContext = featureFlagContexts.find();
		if (currentContext) currentContext[key] = value;
	} };
}
//#endregion


//# sourceMappingURL=featureFlagContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/startCustomerDataTelemetry.mjs



//#region src/domain/startCustomerDataTelemetry.ts
const MEASURES_PERIOD_DURATION = 10 * entries_time/* ONE_SECOND */.WT;
let currentPeriodMeasures;
let batchHasRumEvent;
function startCustomerDataTelemetry(telemetry, lifeCycle, batchFlushObservable) {
	if (!telemetry.metricsEnabled) return;
	initCurrentPeriodMeasures();
	batchHasRumEvent = false;
	lifeCycle.subscribe(14, () => {
		batchHasRumEvent = true;
	});
	batchFlushObservable.subscribe(({ bytesCount, messagesCount }) => {
		if (!batchHasRumEvent) return;
		batchHasRumEvent = false;
		currentPeriodMeasures.batchCount += 1;
		updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
		updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
	});
	(0,timer/* setInterval */.Zi)(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}
function sendCurrentPeriodMeasures() {
	if (currentPeriodMeasures.batchCount === 0) return;
	(0,telemetry_telemetry/* addTelemetryMetrics */.qZ)(telemetry_telemetry/* TelemetryMetrics.CUSTOMER_DATA_METRIC_NAME */.T.CUSTOMER_DATA_METRIC_NAME, currentPeriodMeasures);
	initCurrentPeriodMeasures();
}
function createMeasure() {
	return {
		min: Infinity,
		max: 0,
		sum: 0
	};
}
function updateMeasure(measure, value) {
	measure.sum += value;
	measure.min = Math.min(measure.min, value);
	measure.max = Math.max(measure.max, value);
}
function initCurrentPeriodMeasures() {
	currentPeriodMeasures = {
		batchCount: 0,
		batchBytesCount: createMeasure(),
		batchMessagesCount: createMeasure()
	};
}
//#endregion


//# sourceMappingURL=startCustomerDataTelemetry.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/pageStateHistory.mjs





//#region src/domain/contexts/pageStateHistory.ts
const MAX_PAGE_STATE_ENTRIES = 4e3;
const PAGE_STATE_CONTEXT_TIME_OUT_DELAY = sessionConstants/* SESSION_TIME_OUT_DELAY */.TN;
function startPageStateHistory(assembleHook, maxPageStateEntriesSelectable = 500) {
	const pageStateEntryHistory = (0,valueHistory/* createValueHistory */.p)({
		expireDelay: PAGE_STATE_CONTEXT_TIME_OUT_DELAY,
		maxEntries: MAX_PAGE_STATE_ENTRIES
	});
	let currentPageState;
	if (supportPerformanceTimingEvent("visibility-state")) performance.getEntriesByType("visibility-state").forEach((entry) => {
		addPageState(entry.name === "hidden" ? "hidden" : "active", entry.startTime);
	});
	addPageState(getPageState(), (0,entries_time/* relativeNow */._q)());
	const { stop: stopEventListeners } = (0,addEventListener/* addEventListeners */.yw)(window, [
		addEventListener/* DOM_EVENT.PAGE_SHOW */.EZ.PAGE_SHOW,
		addEventListener/* DOM_EVENT.FOCUS */.EZ.FOCUS,
		addEventListener/* DOM_EVENT.BLUR */.EZ.BLUR,
		addEventListener/* DOM_EVENT.VISIBILITY_CHANGE */.EZ.VISIBILITY_CHANGE,
		addEventListener/* DOM_EVENT.RESUME */.EZ.RESUME,
		addEventListener/* DOM_EVENT.FREEZE */.EZ.FREEZE,
		addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE
	], (event) => {
		addPageState(computePageState(event), event.timeStamp);
	}, { capture: true });
	function addPageState(nextPageState, startTime = (0,entries_time/* relativeNow */._q)()) {
		if (nextPageState === currentPageState) return;
		currentPageState = nextPageState;
		pageStateEntryHistory.closeActive(startTime);
		pageStateEntryHistory.add({
			state: currentPageState,
			startTime
		}, startTime);
	}
	function wasInPageStateDuringPeriod(state, startTime, duration) {
		return pageStateEntryHistory.findAll(startTime, duration).some((pageState) => pageState.state === state);
	}
	assembleHook.register(({ startTime, duration = 0, eventType }) => {
		if (eventType === RumEventType.VIEW) return {
			type: eventType,
			_dd: { page_states: processPageStates(pageStateEntryHistory.findAll(startTime, duration), startTime, maxPageStateEntriesSelectable) }
		};
		if (eventType === RumEventType.ACTION || eventType === RumEventType.ERROR) return {
			type: eventType,
			view: { in_foreground: wasInPageStateDuringPeriod("active", startTime, 0) }
		};
		return assembly_hook/* SKIPPED */.kb;
	});
	return {
		wasInPageStateDuringPeriod,
		addPageState,
		stop: () => {
			stopEventListeners();
			pageStateEntryHistory.stop();
		}
	};
}
function processPageStates(pageStateEntries, eventStartTime, maxPageStateEntriesSelectable) {
	if (pageStateEntries.length === 0) return;
	return pageStateEntries.slice(-maxPageStateEntriesSelectable).reverse().map(({ state, startTime }) => ({
		state,
		start: (0,entries_time/* toServerDuration */.dg)((0,entries_time/* elapsed */._J)(eventStartTime, startTime))
	}));
}
function computePageState(event) {
	if (event.type === addEventListener/* DOM_EVENT.FREEZE */.EZ.FREEZE) return "frozen";
	else if (event.type === addEventListener/* DOM_EVENT.PAGE_HIDE */.EZ.PAGE_HIDE) return event.persisted ? "frozen" : "terminated";
	return getPageState();
}
function getPageState() {
	if (document.visibilityState === "hidden") return "hidden";
	if (document.hasFocus()) return "active";
	return "passive";
}
//#endregion


//# sourceMappingURL=pageStateHistory.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/displayContext.mjs


//#region src/domain/contexts/displayContext.ts
function startDisplayContext(assembleHook) {
	let viewport;
	const animationFrameId = requestAnimationFrame((0,monitor/* monitor */.zk)(() => {
		viewport = getViewportDimension();
	}));
	const unsubscribeViewport = initViewportObservable().subscribe((viewportDimension) => {
		viewport = viewportDimension;
	}).unsubscribe;
	assembleHook.register(({ eventType }) => ({
		type: eventType,
		display: viewport ? { viewport } : void 0
	}));
	return { stop: () => {
		unsubscribeViewport();
		if (animationFrameId) cancelAnimationFrame(animationFrameId);
	} };
}
//#endregion


//# sourceMappingURL=displayContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/vital/vitalCollection.mjs






//#region src/domain/vital/vitalCollection.ts
function startVitalCollection(lifeCycle, pageStateHistory) {
	const vitalTracker = startEventTracker(lifeCycle);
	function isValid(vital) {
		return !pageStateHistory.wasInPageStateDuringPeriod("frozen", vital.startClocks.relative, vital.duration);
	}
	function addDurationVital(vital) {
		if (isValid(vital)) lifeCycle.notify(13, processVital(vital));
	}
	function addOperationStepVital(name, stepType, options, failureReason) {
		const { operationKey, context, description, handlingStack } = options || {};
		const vital = {
			name,
			type: VitalType.OPERATION_STEP,
			operationKey,
			failureReason,
			stepType,
			startClocks: (0,entries_time/* clocksNow */.$I)(),
			context: sanitize(context),
			description,
			handlingStack
		};
		lifeCycle.notify(13, processVital(vital));
	}
	function startDurationVital(name, options = {}, startClocks = (0,entries_time/* clocksNow */.$I)()) {
		const { id } = vitalTracker.start(options.vitalKey ?? name, startClocks, {
			name,
			...options
		});
		lifeCycle.notify(17, {
			id,
			name,
			startClocks,
			...options
		});
	}
	function stopDurationVital(name, options = {}, stopClocks = (0,entries_time/* clocksNow */.$I)()) {
		const stopped = vitalTracker.stop(options.vitalKey ?? name, stopClocks, options);
		if (stopped) addDurationVital({
			type: VitalType.DURATION,
			...stopped
		});
	}
	return {
		addOperationStepVital,
		addDurationVital,
		startDurationVital,
		stopDurationVital
	};
}
function processVital(vital) {
	const { startClocks, type, name, description, context, handlingStack } = vital;
	const vitalData = {
		id: (vital.type === VitalType.DURATION ? vital.id : void 0) ?? generateUUID(),
		type,
		name,
		description,
		...type === VitalType.DURATION ? { duration: (0,entries_time/* toServerDuration */.dg)(vital.duration) } : {
			step_type: vital.stepType,
			operation_key: vital.operationKey,
			failure_reason: vital.failureReason
		}
	};
	return {
		rawRumEvent: {
			date: startClocks.timeStamp,
			vital: vitalData,
			type: RumEventType.VITAL,
			context
		},
		startClocks,
		duration: type === VitalType.DURATION ? vital.duration : void 0,
		domainContext: handlingStack ? { handlingStack } : {}
	};
}
//#endregion


//# sourceMappingURL=vitalCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/sessionContext.mjs



//#region src/domain/contexts/sessionContext.ts
function startSessionContext(assembleHook, configuration, sessionManager, recorderApi, viewHistory) {
	assembleHook.register(({ eventType, startTime }) => {
		const session = sessionManager.findTrackedSession(startTime);
		const view = viewHistory.findView(startTime);
		if (!session || !view) return assembly_hook/* DISCARDED */.C_;
		let hasReplay;
		let sampledForReplay;
		let isActive;
		if (eventType === RumEventType.VIEW) {
			hasReplay = recorderApi.getReplayStats(view.id) ? true : void 0;
			sampledForReplay = computeSessionReplayState(session, configuration) === 1;
			isActive = view.sessionIsActive ? void 0 : false;
		} else hasReplay = recorderApi.isRecording() ? true : void 0;
		return {
			type: eventType,
			session: {
				id: session.id,
				type: "user",
				has_replay: hasReplay,
				sampled_for_replay: sampledForReplay,
				is_active: isActive
			}
		};
	});
}
//#endregion


//# sourceMappingURL=sessionContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/browser/cookieAccess.mjs










//#region src/browser/cookieAccess.ts
const TEST_COOKIE_NAME_PREFIX = "dd_cookie_test_";
async function areCookiesAuthorized(createAccess, cookieOptions) {
	const testCookieName = `${TEST_COOKIE_NAME_PREFIX}${generateUUID()}`;
	const testCookieValue = "test";
	const access = createAccess(testCookieName, cookieOptions);
	try {
		await access.getAllAndSet(() => ({
			value: testCookieValue,
			expireDelay: entries_time/* ONE_MINUTE */.yR
		}));
		return (await access.getAll()).includes(testCookieValue);
	} catch (error) {
		display/* display.error */.jf.error(error);
		return false;
	} finally {
		try {
			await access.delete();
		} catch {}
	}
}
function createCookieStoreAccess(cookieName, cookieOptions) {
	const cookieStore = (0,mockable/* mockable */.C)(globalObject/* globalObject.cookieStore */.Z.cookieStore);
	const observable = new tools_observable/* Observable */.y$(() => {
		return (0,addEventListener/* addEventListener */.Oo)(cookieStore, "change", (event) => {
			if (event.changed.some((event) => event.name === cookieName) || event.deleted.some((event) => event.name === cookieName)) observable.notify();
		}).stop;
	});
	return {
		async getAll() {
			return (await cookieStore.getAll(cookieName)).map((item) => item.value);
		},
		delete() {
			return cookieStore.delete({
				name: cookieName,
				domain: cookieOptions.domain,
				path: "/",
				partitioned: cookieOptions.partitioned
			});
		},
		async getAllAndSet(cb) {
			const items = await cookieStore.getAll(cookieName);
			const { value, expireDelay } = cb(items.map((item) => item.value));
			try {
				await cookieStore.set({
					name: cookieName,
					value,
					expires: (0,entries_time/* dateNow */.m6)() + expireDelay,
					path: "/",
					sameSite: cookieOptions.crossSite ? "none" : "strict",
					domain: cookieOptions.domain,
					secure: cookieOptions.secure,
					partitioned: cookieOptions.partitioned
				});
			} catch (error) {
				if (!cookieName.startsWith("dd_cookie_test_")) {
					const documentCookies = getCookies(cookieName);
					(0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Failed to set cookie using Cookie Store API", {
						"error.message": error.message,
						newValue: value,
						cookieOptions: { ...cookieOptions },
						cookies: items.map((item) => ({ ...item })),
						cookieCount: items.length,
						documentCookies
					});
				}
			}
		},
		observable
	};
}
const WATCH_COOKIE_INTERVAL_DELAY = entries_time/* ONE_SECOND */.WT;
function createDocumentCookieAccess(cookieName, cookieOptions) {
	let previousCookieValues = getCookies(cookieName);
	const observable = new tools_observable/* Observable */.y$(() => {
		const watchCookieIntervalId = (0,timer/* setInterval */.Zi)(() => {
			notifyCookieValueIfChanged(getCookies(cookieName));
		}, WATCH_COOKIE_INTERVAL_DELAY);
		return () => {
			(0,timer/* clearInterval */.cv)(watchCookieIntervalId);
		};
	});
	function notifyCookieValueIfChanged(cookieValues) {
		if (String(cookieValues) !== String(previousCookieValues)) {
			previousCookieValues = cookieValues;
			observable.notify();
		}
	}
	return {
		getAll() {
			return Promise.resolve(getCookies(cookieName));
		},
		async getAllAndSet(cb) {
			const { value, expireDelay } = cb(getCookies(cookieName));
			setCookie(cookieName, value, expireDelay, cookieOptions);
			await Promise.resolve();
			notifyCookieValueIfChanged([value]);
		},
		async delete() {
			deleteCookie(cookieName, cookieOptions);
			await Promise.resolve();
			notifyCookieValueIfChanged([]);
		},
		observable
	};
}
function isCookieStoreSupported() {
	const cookieStore = (0,mockable/* mockable */.C)(globalObject/* globalObject.cookieStore */.Z.cookieStore);
	return Boolean(cookieStore && (0,addEventListener/* isEventSupported */.jO)(cookieStore, "change"));
}
//#endregion


//# sourceMappingURL=cookieAccess.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/browser/cookieObservable.mjs


//#region src/browser/cookieObservable.ts
function createCookieObservable(cookieName) {
	const detectCookieChangeStrategy = isCookieStoreSupported() ? listenToCookieStoreChange() : watchCookieFallback;
	return new tools_observable/* Observable */.y$((observable) => detectCookieChangeStrategy(cookieName, (event) => observable.notify(event)));
}
function listenToCookieStoreChange() {
	return (cookieName, callback) => {
		return (0,addEventListener/* addEventListener */.Oo)(globalObject/* globalObject.cookieStore */.Z.cookieStore, addEventListener/* DOM_EVENT.CHANGE */.EZ.CHANGE, (event) => {
			const changeEvent = event.changed.find((event) => event.name === cookieName) || event.deleted.find((event) => event.name === cookieName);
			if (changeEvent) callback(changeEvent.value);
		}).stop;
	};
}
const cookieObservable_WATCH_COOKIE_INTERVAL_DELAY = entries_time/* ONE_SECOND */.WT;
function watchCookieFallback(cookieName, callback) {
	let previousCookieValue = getCookie(cookieName);
	const watchCookieIntervalId = (0,timer/* setInterval */.Zi)(() => {
		const cookieValue = getCookie(cookieName);
		if (cookieValue !== previousCookieValue) {
			previousCookieValue = cookieValue;
			callback(cookieValue);
		}
	}, cookieObservable_WATCH_COOKIE_INTERVAL_DELAY);
	return () => {
		(0,timer/* clearInterval */.cv)(watchCookieIntervalId);
	};
}
//#endregion


//# sourceMappingURL=cookieObservable.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/ciVisibilityContext.mjs




//#region src/domain/contexts/ciVisibilityContext.ts
const CI_VISIBILITY_TEST_ID_COOKIE_NAME = "datadog-ci-visibility-test-execution-id";
function startCiVisibilityContext(assembleHook, cookieObservable = createCookieObservable(CI_VISIBILITY_TEST_ID_COOKIE_NAME)) {
	let testExecutionId = getInitCookie("datadog-ci-visibility-test-execution-id") || readCypressTraceId();
	const cookieObservableSubscription = cookieObservable.subscribe((value) => {
		testExecutionId = value;
	});
	assembleHook.register(({ eventType }) => {
		if (typeof testExecutionId !== "string") return assembly_hook/* SKIPPED */.kb;
		return {
			type: eventType,
			session: { type: "ci_test" },
			ci_test: { test_execution_id: testExecutionId }
		};
	});
	return { stop: () => {
		cookieObservableSubscription.unsubscribe();
	} };
}
function readCypressTraceId() {
	const cypress = window.Cypress;
	if (!cypress) return;
	try {
		return cypress.env("traceId");
	} catch {
		display/* display.warn */.jf.warn("Failed to read Cypress test execution id via Cypress.env(). Upgrade dd-trace-js to >= 5.88.0 to keep RUM ↔ test correlation working.");
		return;
	}
}
//#endregion


//# sourceMappingURL=ciVisibilityContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/longTask/longTaskCollection.mjs





//#region src/domain/longTask/longTaskCollection.ts
function startLongTaskCollection(lifeCycle, configuration) {
	const subscription = createPerformanceObservable({
		type: supportPerformanceTimingEvent("long-animation-frame") ? "long-animation-frame" : "longtask",
		buffered: true
	}).subscribe((entries) => {
		for (const entry of entries) {
			if (!configuration.trackLongTasks) break;
			const startClocks = (0,entries_time/* relativeToClocks */.DY)(entry.startTime);
			const rawRumEvent = processEntry(entry, startClocks);
			lifeCycle.notify(13, {
				rawRumEvent,
				startClocks,
				duration: entry.duration,
				domainContext: { performanceEntry: entry }
			});
		}
	});
	return { stop: () => subscription.unsubscribe() };
}
function processEntry(entry, startClocks) {
	const id = generateUUID();
	const duration = (0,entries_time/* toServerDuration */.dg)(entry.duration);
	const baseEvent = {
		date: startClocks.timeStamp,
		type: RumEventType.LONG_TASK,
		_dd: { discarded: false }
	};
	if (entry.entryType === "longtask") return {
		...baseEvent,
		long_task: {
			id,
			entry_type: RumLongTaskEntryType.LONG_TASK,
			duration
		}
	};
	const debugIdByUrl = (0,sourceCodeContext/* buildDebugIdByUrl */.J)(entry.scripts.map((script) => script.sourceURL).filter((url) => !!url));
	return {
		...baseEvent,
		_dd: {
			discarded: false,
			debug_ids: debugIdByUrl
		},
		long_task: {
			id,
			entry_type: RumLongTaskEntryType.LONG_ANIMATION_FRAME,
			duration,
			blocking_duration: (0,entries_time/* toServerDuration */.dg)(entry.blockingDuration),
			first_ui_event_timestamp: (0,entries_time/* toServerDuration */.dg)(entry.firstUIEventTimestamp),
			render_start: (0,entries_time/* toServerDuration */.dg)(entry.renderStart),
			style_and_layout_start: (0,entries_time/* toServerDuration */.dg)(entry.styleAndLayoutStart),
			start_time: (0,entries_time/* toServerDuration */.dg)(entry.startTime),
			scripts: entry.scripts.map((script) => ({
				duration: (0,entries_time/* toServerDuration */.dg)(script.duration),
				pause_duration: (0,entries_time/* toServerDuration */.dg)(script.pauseDuration),
				forced_style_and_layout_duration: (0,entries_time/* toServerDuration */.dg)(script.forcedStyleAndLayoutDuration),
				start_time: (0,entries_time/* toServerDuration */.dg)(script.startTime),
				execution_start: (0,entries_time/* toServerDuration */.dg)(script.executionStart),
				source_url: script.sourceURL,
				source_function_name: script.sourceFunctionName,
				source_char_position: script.sourceCharPosition,
				invoker: script.invoker,
				invoker_type: script.invokerType,
				window_attribution: script.windowAttribution
			}))
		}
	};
}
//#endregion


//# sourceMappingURL=longTaskCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/synthetics/syntheticsWorkerValues.mjs



//#region src/domain/synthetics/syntheticsWorkerValues.ts
const cookieNamePrefix = "datadog-synthetics-";
const SYNTHETICS_TEST_ID_COOKIE_NAME = `${cookieNamePrefix}public-id`;
const SYNTHETICS_RESULT_ID_COOKIE_NAME = `${cookieNamePrefix}result-id`;
const SYNTHETICS_INJECTS_RUM_COOKIE_NAME = `${cookieNamePrefix}injects-rum`;
const SYNTHETICS_CONTEXT_COOKIE_NAME = `${cookieNamePrefix}rum-context`;
function willSyntheticsInjectRum() {
	if (globalObject/* isWorkerEnvironment */.j) return false;
	return Boolean(globalObject/* globalObject._DATADOG_SYNTHETICS_INJECTS_RUM */.Z._DATADOG_SYNTHETICS_INJECTS_RUM || getInitCookie(SYNTHETICS_INJECTS_RUM_COOKIE_NAME));
}
function getSyntheticsContext() {
	const raw = getRawSyntheticsContext();
	return isValidSyntheticsContext(raw) ? raw : void 0;
}
function isSyntheticsTest() {
	return Boolean(getSyntheticsContext());
}
function getRawSyntheticsContext() {
	const rawGlobal = globalObject/* globalObject._DATADOG_SYNTHETICS_RUM_CONTEXT */.Z._DATADOG_SYNTHETICS_RUM_CONTEXT;
	if (rawGlobal) return rawGlobal;
	const rawCookie = getInitCookie(SYNTHETICS_CONTEXT_COOKIE_NAME);
	if (rawCookie) return (0,objectUtils/* tryJsonParse */.Cy)(decodeURIComponent(rawCookie));
	return {
		test_id: window._DATADOG_SYNTHETICS_PUBLIC_ID || getInitCookie(SYNTHETICS_TEST_ID_COOKIE_NAME),
		result_id: window._DATADOG_SYNTHETICS_RESULT_ID || getInitCookie(SYNTHETICS_RESULT_ID_COOKIE_NAME)
	};
}
function isValidSyntheticsContext(value) {
	return typeof value === "object" && value !== null && typeof value.test_id === "string" && typeof value.result_id === "string";
}
//#endregion


//# sourceMappingURL=syntheticsWorkerValues.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/syntheticsContext.mjs



//#region src/domain/contexts/syntheticsContext.ts
function startSyntheticsContext(assembleHook) {
	assembleHook.register(({ eventType }) => {
		if (!isSyntheticsTest()) return assembly_hook/* SKIPPED */.kb;
		return {
			type: eventType,
			session: { type: "synthetics" },
			synthetics: {
				...getSyntheticsContext(),
				injected: willSyntheticsInjectRum()
			}
		};
	});
}
//#endregion


//# sourceMappingURL=syntheticsContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/limitModification.mjs


//#region src/domain/limitModification.ts
/**
* Allows declaring and enforcing modifications to specific fields of an object.
* Only supports modifying properties of an object (even if nested in an array).
* Does not support array manipulation (adding/removing items).
*
* Modifications of the object are sanitized only if the field was actually changed by the modifier function (i.e., value is different).
* This ensures consistent SDK behavior regardless of whether limitModification is called.
* Only string fields are handled this way, object fields are sanitized regardless of whether the modifier function was called or not.
*/
function limitModification(object, modifiableFieldPaths, modifier) {
	const clone = (0,mergeInto/* deepClone */.I8)(object);
	const result = modifier(clone);
	(0,polyfills/* objectEntries */.qP)(modifiableFieldPaths).forEach(([fieldPath, fieldType]) => setValueAtPath(object, clone, fieldPath.split(/\.|(?=\[\])/), fieldType));
	return result;
}
function setValueAtPath(object, clone, pathSegments, fieldType) {
	const [field, ...restPathSegments] = pathSegments;
	if (field === "[]") {
		if (Array.isArray(object) && Array.isArray(clone)) object.forEach((item, i) => setValueAtPath(item, clone[i], restPathSegments, fieldType));
		return;
	}
	if (!isValidObject(object) || !isValidObject(clone)) return;
	if (restPathSegments.length > 0) return setValueAtPath(object[field], clone[field], restPathSegments, fieldType);
	setNestedValue(object, field, clone[field], fieldType);
}
function setNestedValue(object, field, value, fieldType) {
	if (object[field] === value) return;
	const newType = (0,typeUtils/* getType */.oL)(value);
	if (newType === fieldType) object[field] = sanitize(value);
	else if (fieldType === "object" && (newType === "undefined" || newType === "null")) object[field] = {};
	else if (fieldType === "array" && (newType === "undefined" || newType === "null")) object[field] = [];
}
function isValidObject(object) {
	return (0,typeUtils/* getType */.oL)(object) === "object";
}
//#endregion


//# sourceMappingURL=limitModification.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/eventRateLimiter/createEventRateLimiter.mjs


//#region src/domain/eventRateLimiter/createEventRateLimiter.ts
const EVENT_RATE_LIMIT = 3e3;
function createEventRateLimiter(eventType, onLimitReached, limit = EVENT_RATE_LIMIT) {
	let eventCount = 0;
	let allowNextEvent = false;
	return { isLimitReached() {
		if (eventCount === 0) (0,timer/* setTimeout */.iK)(() => {
			eventCount = 0;
		}, entries_time/* ONE_MINUTE */.yR);
		eventCount += 1;
		if (eventCount <= limit || allowNextEvent) {
			allowNextEvent = false;
			return false;
		}
		if (eventCount === limit + 1) {
			allowNextEvent = true;
			try {
				onLimitReached(`Reached max number of ${eventType}s by minute: ${limit}`);
			} finally {
				allowNextEvent = false;
			}
		}
		return true;
	} };
}
//#endregion


//# sourceMappingURL=createEventRateLimiter.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/tags.mjs
var tags = __webpack_require__(19783);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/assembly.mjs






//#region src/domain/assembly.ts
const COMMON_MODIFIABLE_FIELD_PATHS = {
	"view.name": "string",
	"view.url": "string",
	"view.referrer": "string",
	context: "object",
	service: "string",
	version: "string"
};
const MODIFIABLE_FIELD_PATHS_BY_EVENT = {
	[RumEventType.VIEW]: {
		...COMMON_MODIFIABLE_FIELD_PATHS,
		"view.performance.lcp.resource_url": "string"
	},
	[RumEventType.ERROR]: {
		...COMMON_MODIFIABLE_FIELD_PATHS,
		"error.message": "string",
		"error.stack": "string",
		"error.handling_stack": "string",
		"error.resource.url": "string",
		"error.fingerprint": "string",
		"_dd.debug_ids": "array"
	},
	[RumEventType.RESOURCE]: {
		...COMMON_MODIFIABLE_FIELD_PATHS,
		"resource.url": "string",
		"resource.graphql.variables": "string",
		"resource.request.headers": "object",
		"resource.response.headers": "object",
		"resource.websocket.close_reason": "string",
		"resource.websocket.protocol": "string"
	},
	[RumEventType.ACTION]: {
		...COMMON_MODIFIABLE_FIELD_PATHS,
		"action.target.name": "string"
	},
	[RumEventType.LONG_TASK]: {
		...COMMON_MODIFIABLE_FIELD_PATHS,
		"long_task.scripts[].source_url": "string",
		"long_task.scripts[].invoker": "string",
		"_dd.debug_ids": "array"
	},
	[RumEventType.VITAL]: COMMON_MODIFIABLE_FIELD_PATHS
};
function startRumAssembly(configuration, lifeCycle, assembleHook, reportError, eventRateLimit) {
	const eventRateLimiters = {
		[RumEventType.ERROR]: createEventRateLimiter(RumEventType.ERROR, reportError, eventRateLimit),
		[RumEventType.ACTION]: createEventRateLimiter(RumEventType.ACTION, reportError, eventRateLimit),
		[RumEventType.VITAL]: createEventRateLimiter(RumEventType.VITAL, reportError, eventRateLimit)
	};
	lifeCycle.subscribe(13, ({ startClocks, duration, rawRumEvent, domainContext }) => {
		const defaultRumEventAttributes = assembleHook.trigger({
			eventType: rawRumEvent.type,
			rawRumEvent,
			domainContext,
			startTime: startClocks.relative,
			duration
		});
		if (defaultRumEventAttributes === assembly_hook/* DISCARDED */.C_) return;
		const serverRumEvent = (0,mergeInto/* combine */.$e)(defaultRumEventAttributes, rawRumEvent, { ddtags: (0,tags/* buildTags */.MS)(configuration).join(",") });
		if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
			if ((0,objectUtils/* isEmptyObject */.Qr)(serverRumEvent.context)) delete serverRumEvent.context;
			lifeCycle.notify(14, serverRumEvent);
		}
	});
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
	if (beforeSend) {
		const result = limitModification(event, MODIFIABLE_FIELD_PATHS_BY_EVENT[event.type], (event) => beforeSend(event, domainContext));
		if (result === false && event.type !== RumEventType.VIEW) return false;
		if (result === false) display/* display.warn */.jf.warn("Can't dismiss view events using beforeSend!");
	}
	return !eventRateLimiters[event.type]?.isLimitReached();
}
//#endregion


//# sourceMappingURL=assembly.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/domain/connectivity/connectivity.mjs
var connectivity = __webpack_require__(2770);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/connectivityContext.mjs

//#region src/domain/contexts/connectivityContext.ts
function startConnectivityContext(assembleHook) {
	assembleHook.register(({ eventType }) => ({
		type: eventType,
		connectivity: (0,connectivity/* getConnectivity */.T)()
	}));
}
//#endregion


//# sourceMappingURL=connectivityContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/defaultContext.mjs


//#region src/domain/contexts/defaultContext.ts
function startDefaultContext(assembleHook, configuration, sdkName) {
	assembleHook.register(({ eventType }) => {
		const source = configuration.source;
		return {
			type: eventType,
			_dd: {
				format_version: 2,
				drift: (0,entries_time/* clockDrift */.Pv)(),
				configuration: {
					session_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionSampleRate, 3),
					session_replay_sample_rate: (0,numberUtils/* round */.NM)(configuration.sessionReplaySampleRate, 3),
					profiling_sample_rate: (0,numberUtils/* round */.NM)(configuration.profilingSampleRate, 3),
					trace_sample_rate: (0,numberUtils/* round */.NM)(configuration.traceSampleRate, 3)
				},
				browser_sdk_version: (0,eventBridge/* canUseEventBridge */.xT)() ? "7.7.0" : void 0,
				sdk_name: sdkName
			},
			application: { id: configuration.applicationId },
			date: (0,entries_time/* timeStampNow */.n$)(),
			source
		};
	});
}
//#endregion


//# sourceMappingURL=defaultContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/event/eventCollection.mjs



//#region src/domain/event/eventCollection.ts
const allowedEventTypes = [
	RumEventType.ACTION,
	RumEventType.ERROR,
	RumEventType.LONG_TASK,
	RumEventType.RESOURCE,
	RumEventType.VITAL
];
function startEventCollection(lifeCycle) {
	return { addEvent: (startTime, event, domainContext, duration) => {
		if (!allowedEventTypes.includes(event.type)) return;
		lifeCycle.notify(13, {
			startClocks: (0,entries_time/* relativeToClocks */.DY)(startTime),
			rawRumEvent: event,
			domainContext,
			duration
		});
	} };
}
//#endregion


//# sourceMappingURL=eventCollection.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/sourceCodeMfeContext.mjs


//#region src/domain/contexts/sourceCodeMfeContext.ts
/**
* Attributes service and version from the source code context (injected at build time by the
* Datadog build plugins) to RUM events emitted by micro-frontend bundles.
*
* Note: service/version attribution relies on a single URL (the top frame of the error stack, or the
* first script of a long animation frame). Debug IDs, on the other hand, are resolved separately and
* cover every bundle URL across the full error cause chain — not just that top frame.
*/
function startSourceCodeMfeContext(assembleHook) {
	assembleHook.register(({ domainContext, rawRumEvent }) => {
		const url = getSourceUrl(domainContext, rawRumEvent);
		if (!url) return assembly_hook/* SKIPPED */.kb;
		const context = (0,sourceCodeContext/* getSourceCodeContext */.q)(url);
		if (!context) return assembly_hook/* SKIPPED */.kb;
		return {
			type: rawRumEvent.type,
			service: context.service,
			version: context.version
		};
	});
}
function getSourceUrl(domainContext, rawRumEvent) {
	if (rawRumEvent.type === "long_task" && rawRumEvent.long_task.entry_type === "long-animation-frame") return rawRumEvent.long_task.scripts[0]?.source_url;
	let stack;
	if ("handlingStack" in domainContext) stack = domainContext.handlingStack;
	if (rawRumEvent.type === "error" && rawRumEvent.error.stack) stack = rawRumEvent.error.stack;
	return (0,computeStackTrace/* computeStackTrace */._)({ stack }).stack[0]?.url;
}
//#endregion


//# sourceMappingURL=sourceCodeMfeContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/contexts/tabContext.mjs

//#region src/domain/contexts/tabContext.ts
const TAB_ID_STORAGE_KEY = "_dd_tab_id";
let cachedTabId;
function startTabContext(assembleHook) {
	const tabId = retrieveOrCreateTabId();
	assembleHook.register(() => ({ tab: { id: tabId } }));
}
function retrieveOrCreateTabId() {
	if (!cachedTabId) cachedTabId = getOrCreateIdInSessionStorage() ?? generateUUID();
	return cachedTabId;
}
function getOrCreateIdInSessionStorage() {
	try {
		const existingId = sessionStorage.getItem(TAB_ID_STORAGE_KEY);
		if (existingId) return existingId;
		const newId = generateUUID();
		sessionStorage.setItem(TAB_ID_STORAGE_KEY, newId);
		return newId;
	} catch {
		return;
	}
}
//#endregion


//# sourceMappingURL=tabContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/storeContextManager.mjs



//#region src/domain/context/storeContextManager.ts
const CONTEXT_STORE_KEY_PREFIX = "_dd_c";
const storageListeners = [];
function storeContextManager(contextManager, productKey, customerDataType) {
	if (typeof window === "undefined" || typeof localStorage === "undefined") return;
	const storageKey = buildStorageKey(productKey, customerDataType);
	storageListeners.push((0,addEventListener/* addEventListener */.Oo)(window, "storage", ({ key }) => {
		if (storageKey === key) synchronizeWithStorage();
	}));
	contextManager.changeObservable.subscribe(dumpToStorage);
	const contextFromStorage = (0,mergeInto/* combine */.$e)(getFromStorage(), contextManager.getContext());
	if (!(0,objectUtils/* isEmptyObject */.Qr)(contextFromStorage)) contextManager.setContext(contextFromStorage);
	function synchronizeWithStorage() {
		contextManager.setContext(getFromStorage());
	}
	function dumpToStorage() {
		localStorage.setItem(storageKey, JSON.stringify(contextManager.getContext()));
	}
	function getFromStorage() {
		const rawContext = localStorage.getItem(storageKey);
		return rawContext ? (0,objectUtils/* tryJsonParse */.Cy)(rawContext) ?? {} : {};
	}
}
function buildStorageKey(productKey, customerDataType) {
	return `${CONTEXT_STORE_KEY_PREFIX}_${productKey}_${customerDataType}`;
}
function removeStorageListeners() {
	storageListeners.map((listener) => listener.stop());
}
//#endregion


//# sourceMappingURL=storeContextManager.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/contexts/globalContext.mjs



//#region src/domain/contexts/globalContext.ts
function startGlobalContext(assembleHook, configuration, productKey, useContextNamespace) {
	const globalContextManager = buildGlobalContextManager();
	if (configuration.storeContextsAcrossPages) storeContextManager(globalContextManager, productKey, 2);
	assembleHook.register(() => {
		const context = globalContextManager.getContext();
		return useContextNamespace ? { context } : context;
	});
	return globalContextManager;
}
function buildGlobalContextManager() {
	return createContextManager("global context");
}
//#endregion


//# sourceMappingURL=globalContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/contexts/userContext.mjs





//#region src/domain/contexts/userContext.ts
function startUserContext(hook, configuration, sessionManager, productKey) {
	const userContextManager = buildUserContextManager();
	if (configuration.storeContextsAcrossPages) storeContextManager(userContextManager, productKey, 1);
	hook.register(({ eventType, startTime }) => {
		const user = userContextManager.getContext();
		const session = sessionManager.findTrackedSession(startTime);
		if (session?.anonymousId && !user.anonymous_id && !!configuration.trackAnonymousUser) user.anonymous_id = session.anonymousId;
		if ((0,objectUtils/* isEmptyObject */.Qr)(user)) return assembly_hook/* SKIPPED */.kb;
		return {
			type: eventType,
			usr: user
		};
	});
	return userContextManager;
}
function buildUserContextManager() {
	return createContextManager("user", { propertiesConfig: {
		id: { type: "string" },
		name: { type: "string" },
		email: { type: "string" }
	} });
}
//#endregion


//# sourceMappingURL=userContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/contexts/accountContext.mjs





//#region src/domain/contexts/accountContext.ts
function startAccountContext(assembleHook, configuration, productKey) {
	const accountContextManager = buildAccountContextManager();
	if (configuration.storeContextsAcrossPages) storeContextManager(accountContextManager, productKey, 4);
	assembleHook.register(() => {
		const account = accountContextManager.getContext();
		if ((0,objectUtils/* isEmptyObject */.Qr)(account) || !account.id) return assembly_hook/* SKIPPED */.kb;
		return { account };
	});
	return accountContextManager;
}
function buildAccountContextManager() {
	return createContextManager("account", { propertiesConfig: {
		id: {
			type: "string",
			required: true
		},
		name: { type: "string" }
	} });
}
//#endregion


//# sourceMappingURL=accountContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/startRum.mjs































//#region src/boot/startRum.ts
function startRum(configuration, sessionManager, recorderApi, profilerApi, initialViewOptions, createEncoder, bufferedDataObservable, telemetry, hooks, sdkName) {
	const cleanupTasks = [];
	const lifeCycle = new LifeCycle();
	lifeCycle.subscribe(14, (event) => (0,sendToExtension/* sendToExtension */.j)("rum", event));
	sessionManager.expireObservable.subscribe(() => lifeCycle.notify(10));
	sessionManager.renewObservable.subscribe(() => lifeCycle.notify(11));
	const reportError = (message) => {
		lifeCycle.notify(15, { error: {
			message,
			source: error_types/* ErrorSource.AGENT */.zH.AGENT,
			startClocks: (0,entries_time/* clocksNow */.$I)()
		} });
		(0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Error reported to customer", { "error.message": message });
	};
	if (!(0,eventBridge/* canUseEventBridge */.xT)()) {
		const batch = startRumBatch(configuration, lifeCycle, reportError, sessionManager.expireObservable, createEncoder);
		const preparePageExitSubscription = batch.prepareUrgentFlushObservable.subscribe((reason) => {
			lifeCycle.notify(12, reason);
		});
		cleanupTasks.push(() => preparePageExitSubscription.unsubscribe());
		cleanupTasks.push(() => batch.stop());
		startCustomerDataTelemetry(telemetry, lifeCycle, batch.flushObservable);
	} else {
		startRumEventBridge(lifeCycle);
		const pageMayExitSubscription = (0,pageMayExitObservable/* createPageMayExitObservable */.FP)().subscribe((event) => {
			lifeCycle.notify(12, event.reason);
		});
		cleanupTasks.push(() => pageMayExitSubscription.unsubscribe());
	}
	const { stop: stopRumEventCollection, ...startRumEventCollectionResult } = startRumEventCollection(lifeCycle, hooks, configuration, sessionManager, recorderApi, initialViewOptions, bufferedDataObservable, sdkName, reportError);
	cleanupTasks.push(stopRumEventCollection);
	bufferedDataObservable.unbuffer();
	cleanupTasks.push(() => profilerApi.stop());
	return {
		...startRumEventCollectionResult,
		lifeCycle,
		sessionManager,
		stopSession: () => sessionManager.expire(),
		telemetry,
		stop: () => {
			cleanupTasks.forEach((task) => task());
		},
		hooks
	};
}
function startRumEventCollection(lifeCycle, hooks, configuration, sessionManager, recorderApi, initialViewOptions, bufferedDataObservable, sdkName, reportError) {
	const cleanupTasks = [];
	const domMutationObservable = createDOMMutationObservable();
	const locationChangeObservable = createLocationChangeObservable();
	const { observable: windowOpenObservable, stop: stopWindowOpen } = createWindowOpenObservable();
	cleanupTasks.push(stopWindowOpen);
	const { assemble: assembleHook } = hooks;
	startDefaultContext(assembleHook, configuration, sdkName);
	const pageStateHistory = startPageStateHistory(assembleHook);
	cleanupTasks.push(() => pageStateHistory.stop());
	const viewHistory = startViewHistory(lifeCycle);
	cleanupTasks.push(() => viewHistory.stop());
	const urlContexts = startUrlContexts(lifeCycle, assembleHook, locationChangeObservable);
	cleanupTasks.push(() => urlContexts.stop());
	const featureFlagContexts = startFeatureFlagContexts(lifeCycle, assembleHook, configuration);
	startSessionContext(assembleHook, configuration, sessionManager, recorderApi, viewHistory);
	startConnectivityContext(assembleHook);
	startTabContext(assembleHook);
	const globalContext = startGlobalContext(assembleHook, configuration, "rum", true);
	const userContext = startUserContext(assembleHook, configuration, sessionManager, "rum");
	const accountContext = startAccountContext(assembleHook, configuration, "rum");
	const actionCollection = startActionCollection(lifeCycle, hooks, domMutationObservable, windowOpenObservable, configuration);
	cleanupTasks.push(actionCollection.stop);
	const eventCollection = startEventCollection(lifeCycle);
	const displayContext = startDisplayContext(assembleHook);
	cleanupTasks.push(displayContext.stop);
	const ciVisibilityContext = startCiVisibilityContext(assembleHook);
	cleanupTasks.push(ciVisibilityContext.stop);
	startSyntheticsContext(assembleHook);
	startRumAssembly(configuration, lifeCycle, assembleHook, reportError);
	const { addTiming, setLoadingTime, startView, setViewName, setViewContext, setViewContextProperty, getViewContext, stop: stopViewCollection } = startViewCollection(lifeCycle, hooks, configuration, domMutationObservable, windowOpenObservable, locationChangeObservable, recorderApi, viewHistory, initialViewOptions);
	startSourceCodeMfeContext(assembleHook);
	cleanupTasks.push(stopViewCollection);
	const resourceCollection = startResourceCollection(lifeCycle, configuration);
	cleanupTasks.push(resourceCollection.stop);
	const { stop: stopLongTaskCollection } = startLongTaskCollection(lifeCycle, configuration);
	cleanupTasks.push(stopLongTaskCollection);
	const { addError } = startErrorCollection(lifeCycle, bufferedDataObservable);
	startRequestCollection(lifeCycle, configuration, sessionManager, userContext, accountContext, bufferedDataObservable);
	const vitalCollection = startVitalCollection(lifeCycle, pageStateHistory);
	if (configuration.trackResources && (configuration.betaTrackWebSockets || (0,experimentalFeatures/* isExperimentalFeatureEnabled */.W_)(experimentalFeatures/* ExperimentalFeature.TRACK_WEBSOCKETS */.uh.TRACK_WEBSOCKETS))) {
		const webSocketCollection = startWebSocketCollection(lifeCycle, viewHistory, vitalCollection.addDurationVital);
		cleanupTasks.push(webSocketCollection.stop);
	}
	const internalContext = startInternalContext(configuration.applicationId, sessionManager, viewHistory, actionCollection.actionContexts, urlContexts);
	return {
		addAction: actionCollection.addAction,
		startAction: actionCollection.startAction,
		stopAction: actionCollection.stopAction,
		startResource: resourceCollection.startResource,
		stopResource: resourceCollection.stopResource,
		addEvent: eventCollection.addEvent,
		addError,
		addTiming,
		setLoadingTime,
		addFeatureFlagEvaluation: featureFlagContexts.addFeatureFlagEvaluation,
		startView,
		setViewContext,
		setViewContextProperty,
		getViewContext,
		setViewName,
		viewHistory,
		sessionManager,
		stopSession: () => sessionManager.expire(),
		getInternalContext: internalContext.get,
		startDurationVital: vitalCollection.startDurationVital,
		stopDurationVital: vitalCollection.stopDurationVital,
		addDurationVital: vitalCollection.addDurationVital,
		addOperationStepVital: vitalCollection.addOperationStepVital,
		globalContext,
		userContext,
		accountContext,
		stop: () => cleanupTasks.forEach((task) => task())
	};
}
//#endregion


//# sourceMappingURL=startRum.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/plugins.mjs
//#region src/domain/plugins.ts
function callPluginsMethod(plugins, methodName, parameter) {
	if (!plugins) return;
	for (const plugin of plugins) {
		const method = plugin[methodName];
		if (method) method(parameter);
	}
}
//#endregion


//# sourceMappingURL=plugins.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/hooks.mjs

//#region src/domain/hooks.ts
function createHooks() {
	return {
		assemble: (0,assembly_hook/* createHook */.Bi)(),
		assembleTelemetry: (0,assembly_hook/* createHook */.Bi)()
	};
}
//#endregion


//# sourceMappingURL=hooks.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/contexts/trackingConsentContext.mjs

//#region src/domain/contexts/trackingConsentContext.ts
function startTrackingConsentContext(assembleTelemetryHook, trackingConsentState) {
	assembleTelemetryHook.register(() => {
		if (!trackingConsentState.isGranted()) return assembly_hook/* DISCARDED */.C_;
		return assembly_hook/* SKIPPED */.kb;
	});
}
//#endregion


//# sourceMappingURL=trackingConsentContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/defineContextMethod.mjs


//#region src/domain/context/defineContextMethod.ts
function defineContextMethod(getStrategy, contextName, methodName, usage) {
	return (0,monitor/* monitor */.zk)((...args) => {
		if (usage) (0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: usage });
		return getStrategy()[contextName][methodName](...args);
	});
}
function bufferContextCalls(preStartContextManager, name, bufferApiCalls) {
	preStartContextManager.changeObservable.subscribe(() => {
		const context = preStartContextManager.getContext();
		bufferApiCalls.notify((startResult) => startResult[name].setContext(context));
	});
}
//#endregion


//# sourceMappingURL=defineContextMethod.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/context/contextConstants.mjs
//#region src/domain/context/contextConstants.ts
let CustomerDataType = /* @__PURE__ */ function(CustomerDataType) {
	CustomerDataType[CustomerDataType["FeatureFlag"] = 0] = "FeatureFlag";
	CustomerDataType[CustomerDataType["User"] = 1] = "User";
	CustomerDataType[CustomerDataType["GlobalContext"] = 2] = "GlobalContext";
	CustomerDataType[CustomerDataType["View"] = 3] = "View";
	CustomerDataType[CustomerDataType["Account"] = 4] = "Account";
	return CustomerDataType;
}({});
const CustomerContextKey = {
	userContext: "userContext",
	globalContext: "globalContext",
	accountContext: "accountContext"
};
const ContextManagerMethod = {
	getContext: "getContext",
	setContext: "setContext",
	setContextProperty: "setContextProperty",
	removeContextProperty: "removeContextProperty",
	clearContext: "clearContext"
};
//#endregion


//# sourceMappingURL=contextConstants.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/boot/displayAlreadyInitializedError.mjs

//#region src/boot/displayAlreadyInitializedError.ts
function displayAlreadyInitializedError(sdkName, initConfiguration) {
	if (!initConfiguration.silentMultipleInit) display/* display.error */.jf.error(`${sdkName} is already initialized.`);
}
//#endregion


//# sourceMappingURL=displayAlreadyInitializedError.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/extension/extensionUtils.mjs
//#region src/domain/extension/extensionUtils.ts
const EXTENSION_PREFIXES = ["chrome-extension://", "moz-extension://"];
function containsExtensionUrl(str) {
	return EXTENSION_PREFIXES.some((prefix) => str.includes(prefix));
}
/**
* Utility function to detect if the SDK is being initialized in an unsupported browser extension environment.
*
* @param windowLocation - The current window location to check
* @param stack - The error stack to check for extension URLs
* @returns true if running in an unsupported browser extension environment
*/
function isUnsupportedExtensionEnvironment(windowLocation, stack = "") {
	if (containsExtensionUrl(windowLocation)) return false;
	return containsExtensionUrl(stack.split("\n").filter((line) => {
		const trimmedLine = line.trim();
		return trimmedLine.length && /^at\s+|@/.test(trimmedLine);
	})[1] || "");
}
//#endregion


//# sourceMappingURL=extensionUtils.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/allowedTrackingOrigins.mjs





//#region src/domain/allowedTrackingOrigins.ts
const ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN = "Running the Browser SDK in a Web extension content script is forbidden unless the `allowedTrackingOrigins` option is provided.";
const ERROR_NOT_ALLOWED_TRACKING_ORIGIN = "SDK initialized on a non-allowed domain.";
function isAllowedTrackingOrigins(configuration, errorStack) {
	const location = (0,mockable/* mockable */.C)(globalObject/* globalObject.location */.Z.location);
	const windowOrigin = location ? location.origin : "";
	const allowedTrackingOrigins = configuration.allowedTrackingOrigins;
	if (!allowedTrackingOrigins) {
		if (isUnsupportedExtensionEnvironment(windowOrigin, errorStack)) {
			display/* display.error */.jf.error(ERROR_DOES_NOT_HAVE_ALLOWED_TRACKING_ORIGIN);
			return false;
		}
		return true;
	}
	const isAllowed = matchList(allowedTrackingOrigins, windowOrigin);
	if (!isAllowed) display/* display.error */.jf.error(ERROR_NOT_ALLOWED_TRACKING_ORIGIN);
	return isAllowed;
}
//#endregion


//# sourceMappingURL=allowedTrackingOrigins.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStateValidation.mjs
//#region src/domain/session/sessionStateValidation.ts
const SESSION_ENTRY_REGEXP = /^([a-zA-Z]+)=([a-z0-9-]+)$/;
function isValidSessionString(sessionString) {
	return !!sessionString && (sessionString.indexOf("&") !== -1 || SESSION_ENTRY_REGEXP.test(sessionString));
}
//#endregion


//# sourceMappingURL=sessionStateValidation.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionState.mjs






function getCreatedDate(state) {
	return state.created ? Number(state.created) : void 0;
}
function getExpireDate(state) {
	const expireDate = state.expire && Number(state.expire);
	const createdDate = getCreatedDate(state);
	if (expireDate && createdDate) return Math.min(expireDate, createdDate + sessionConstants/* SESSION_TIME_OUT_DELAY */.TN);
}
function getExpiredSessionState(previousSessionState, configuration) {
	const expiredSessionState = { isExpired: "1" };
	if (configuration.trackAnonymousUser && previousSessionState?.anonymousId) expiredSessionState.anonymousId = previousSessionState?.anonymousId;
	return expiredSessionState;
}
function isSessionInNotStartedState(session) {
	return (0,objectUtils/* isEmptyObject */.Qr)(session);
}
function isSessionInExpiredState(session) {
	return session.isExpired !== void 0 || !isActiveSession(session);
}
function isActiveSession(sessionState) {
	const expireDate = getExpireDate(sessionState);
	return expireDate ? (0,entries_time/* dateNow */.m6)() < expireDate : false;
}
function expandSessionState(session) {
	session.expire = String((0,entries_time/* dateNow */.m6)() + sessionConstants/* SESSION_EXPIRATION_DELAY */.sr);
}
function toSessionString(session) {
	return (0,polyfills/* objectEntries */.qP)(session).map(([key, value]) => key === "anonymousId" ? `aid=${value}` : `${key}=${value}`).join("&");
}
function toSessionState(sessionString) {
	const session = {};
	if (isValidSessionString(sessionString)) sessionString.split("&").forEach((entry) => {
		const matches = SESSION_ENTRY_REGEXP.exec(entry);
		if (matches !== null) {
			const [, key, value] = matches;
			if (key === "aid") session.anonymousId = value;
			else session[key] = value;
		}
	});
	return session;
}
function initializeSession(state, configuration) {
	if (isSessionInNotStartedState(state)) {
		if (configuration.trackAnonymousUser) state.anonymousId = generateUUID();
		return getExpiredSessionState(state, configuration);
	}
	return state;
}
function expandOrRenew(state, configuration) {
	if (isSessionInNotStartedState(state)) return state;
	let newState = state;
	if (isSessionInExpiredState(state)) newState = getExpiredSessionState(state, configuration);
	if (!newState.id) {
		newState.id = generateUUID();
		newState.created = String((0,entries_time/* dateNow */.m6)());
	}
	if (configuration.trackAnonymousUser && !newState.anonymousId) newState.anonymousId = generateUUID();
	delete newState.isExpired;
	expandSessionState(newState);
	return newState;
}
function expandOnly(state) {
	if (isSessionInExpiredState(state) || isSessionInNotStartedState(state) || !state.id) return state;
	expandSessionState(state);
	return state;
}
//#endregion


//# sourceMappingURL=sessionState.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionStoreStrategy.mjs
//#region src/domain/session/storeStrategies/sessionStoreStrategy.ts
const SESSION_STORE_KEY = "_dd_s_v2";
const LEGACY_SESSION_STORE_KEY = "_dd_s";
//#endregion


//# sourceMappingURL=sessionStoreStrategy.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInCookie.mjs









//#region src/domain/session/storeStrategies/sessionInCookie.ts
const SESSION_COOKIE_VERSION = 0;
async function selectCookieStrategy(configuration) {
	const cookieOptions = buildCookieOptions(configuration);
	if (!cookieOptions) return;
	if (isCookieStoreSupported() && await areCookiesAuthorized(createCookieStoreAccess, cookieOptions)) return {
		type: sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE,
		cookieOptions,
		cookieApi: 1
	};
	if (await areCookiesAuthorized(createDocumentCookieAccess, cookieOptions)) return {
		type: sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE,
		cookieOptions,
		cookieApi: 0
	};
}
let pendingChain;
function initCookieStrategy(sessionStoreStrategyType, configuration) {
	const { cookieOptions, cookieApi } = sessionStoreStrategyType;
	const sessionObservable = new tools_observable/* Observable */.y$();
	const trackAnonymousUser = !!configuration.trackAnonymousUser;
	const opts = encodeCookieOptions(cookieOptions);
	const cookieAccess = (0,mockable/* mockable */.C)(createCookieAccess)(cookieApi, cookieOptions);
	let isFirstCall = true;
	cookieAccess.observable.subscribe(() => {
		cookieAccess.getAll().then((cookieValues) => {
			sessionObservable.notify(findMatchingSessionState(cookieValues, opts));
		}).catch((error) => (0,monitor/* monitorError */.$y)(/* @__PURE__ */ new Error(`Error while reading session cookies on change: ${error}`)));
	});
	function applyAndWrite(fn) {
		return cookieAccess.getAllAndSet((cookieValues) => {
			let currentState = findMatchingSessionState(cookieValues, opts);
			if (isFirstCall && (0,objectUtils/* isEmptyObject */.Qr)(currentState)) currentState = findMatchingSessionState(getCookies(LEGACY_SESSION_STORE_KEY), opts);
			isFirstCall = false;
			return {
				value: buildSessionString(fn(currentState), cookieOptions),
				expireDelay: trackAnonymousUser ? sessionConstants/* SESSION_COOKIE_EXPIRATION_DELAY */.uY : sessionConstants/* SESSION_TIME_OUT_DELAY */.TN
			};
		});
	}
	return {
		async setSessionState(fn, _operation) {
			if (typeof navigator !== "undefined" && navigator.locks) await navigator.locks.request(SESSION_STORE_KEY, () => applyAndWrite(fn)).catch((error) => {
				if (isContextGoingAwayError(error)) return;
				throw error;
			});
			else {
				pendingChain = (pendingChain ?? Promise.resolve()).then(() => applyAndWrite(fn));
				await pendingChain;
			}
		},
		sessionObservable
	};
}
function isContextGoingAwayError(error) {
	if (!(error instanceof Error)) return false;
	return error.name === "AbortError" || error.message.includes("no longer runnable");
}
function createCookieAccess(cookieApi, cookieOptions) {
	return cookieApi === 1 ? createCookieStoreAccess(SESSION_STORE_KEY, cookieOptions) : createDocumentCookieAccess(SESSION_STORE_KEY, cookieOptions);
}
function findMatchingSessionState(items, opts) {
	let sessionState;
	for (const item of items.slice().reverse()) {
		sessionState = toSessionState(item);
		if (sessionState.c === opts) break;
	}
	delete sessionState?.c;
	return sessionState ?? {};
}
function buildSessionString(sessionState, cookieOptions) {
	return toSessionString((0,objectUtils/* isEmptyObject */.Qr)(sessionState) ? sessionState : {
		...sessionState,
		c: encodeCookieOptions(cookieOptions)
	});
}
function encodeCookieOptions(cookieOptions) {
	const domainCount = cookieOptions.domain ? cookieOptions.domain.split(".").length - 1 : 0;
	let byte = 0;
	byte |= SESSION_COOKIE_VERSION << 5;
	byte |= domainCount << 1;
	byte |= cookieOptions.crossSite ? 1 : 0;
	return byte.toString(16);
}
//#endregion


//# sourceMappingURL=sessionInCookie.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInLocalStorage.mjs






//#region src/domain/session/storeStrategies/sessionInLocalStorage.ts
const LOCAL_STORAGE_TEST_KEY = "_dd_test_";
function selectLocalStorageStrategy() {
	try {
		const id = generateUUID();
		const testKey = `${LOCAL_STORAGE_TEST_KEY}${id}`;
		localStorage.setItem(testKey, id);
		const retrievedId = localStorage.getItem(testKey);
		localStorage.removeItem(testKey);
		return id === retrievedId ? { type: sessionConstants/* SessionPersistence.LOCAL_STORAGE */._q.LOCAL_STORAGE } : void 0;
	} catch {
		return;
	}
}
function initLocalStorageStrategy() {
	const sessionObservable = new tools_observable/* Observable */.y$((observable) => (0,addEventListener/* addEventListener */.Oo)(window, "storage", (event) => {
		if (event.key === "_dd_s_v2" && event.storageArea === localStorage) observable.notify(toSessionState(event.newValue));
	}).stop);
	let isFirstCall = true;
	return {
		async setSessionState(fn, _operation) {
			let currentState = toSessionState(localStorage.getItem(SESSION_STORE_KEY));
			if (isFirstCall && isSessionInNotStartedState(currentState)) currentState = toSessionState(localStorage.getItem(LEGACY_SESSION_STORE_KEY));
			isFirstCall = false;
			const newState = fn(currentState);
			localStorage.setItem(SESSION_STORE_KEY, toSessionString(newState));
			await Promise.resolve();
			sessionObservable.notify(newState);
		},
		sessionObservable
	};
}
//#endregion


//# sourceMappingURL=sessionInLocalStorage.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/storeStrategies/sessionInMemory.mjs




//#region src/domain/session/storeStrategies/sessionInMemory.ts
const MEMORY_SESSION_STORE_KEY = "_DD_SESSION";
function selectMemorySessionStoreStrategy() {
	return { type: sessionConstants/* SessionPersistence.MEMORY */._q.MEMORY };
}
function initMemorySessionStoreStrategy() {
	const globalObjectWithSession = globalObject/* globalObject */.Z;
	if (!globalObjectWithSession["_DD_SESSION"]) globalObjectWithSession[MEMORY_SESSION_STORE_KEY] = {};
	const memorySession = globalObjectWithSession[MEMORY_SESSION_STORE_KEY];
	const sessionObservable = new tools_observable/* Observable */.y$();
	const previousOnChange = memorySession.onChange;
	memorySession.onChange = (state) => {
		previousOnChange?.(state);
		sessionObservable.notify(state);
	};
	return {
		async setSessionState(fn, _operation) {
			const newState = (0,objectUtils/* shallowClone */.mv)(fn(memorySession.state ?? {}));
			memorySession.state = newState;
			await Promise.resolve();
			memorySession.onChange?.(newState);
		},
		sessionObservable
	};
}
//#endregion


//# sourceMappingURL=sessionInMemory.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionStore.mjs






//#region src/domain/session/sessionStore.ts
/**
* Selects the correct session store strategy type based on the configuration and storage
* availability. When an array is provided, tries each persistence type in order until one
* successfully initializes.
*/
async function selectSessionStoreStrategyType(configuration) {
	const persistenceList = normalizePersistenceList(configuration.sessionPersistence);
	for (const persistence of persistenceList) {
		const strategyType = await selectStrategyForPersistence(persistence, configuration);
		if (strategyType !== void 0) return strategyType;
	}
}
function normalizePersistenceList(sessionPersistence) {
	if (sessionPersistence !== void 0) return sessionPersistence;
	if (globalObject/* isWorkerEnvironment */.j) return [sessionConstants/* SessionPersistence.MEMORY */._q.MEMORY];
	return [sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE];
}
function selectStrategyForPersistence(persistence, configuration) {
	switch (persistence) {
		case sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE: return selectCookieStrategy(configuration);
		case sessionConstants/* SessionPersistence.LOCAL_STORAGE */._q.LOCAL_STORAGE: return selectLocalStorageStrategy();
		case sessionConstants/* SessionPersistence.MEMORY */._q.MEMORY: return selectMemorySessionStoreStrategy();
		default:
			display/* display.error */.jf.error(`Invalid session persistence '${String(persistence)}'`);
			return;
	}
}
function getSessionStoreStrategy(sessionStoreStrategyType, configuration) {
	switch (sessionStoreStrategyType.type) {
		case sessionConstants/* SessionPersistence.COOKIE */._q.COOKIE: return initCookieStrategy(sessionStoreStrategyType, configuration);
		case sessionConstants/* SessionPersistence.LOCAL_STORAGE */._q.LOCAL_STORAGE: return initLocalStorageStrategy();
		case sessionConstants/* SessionPersistence.MEMORY */._q.MEMORY: return initMemorySessionStoreStrategy();
	}
}
//#endregion


//# sourceMappingURL=sessionStore.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/session/sessionManager.mjs















//#region src/domain/session/sessionManager.ts
const VISIBILITY_CHECK_DELAY = entries_time/* ONE_MINUTE */.yR;
const MAX_SESSION_CONTEXT_HISTORY_ENTRIES = 1e3;
const TRACKED_SESSION_MAX_AGE = entries_time/* ONE_HOUR */.dV * 12;
let stopCallbacks = [];
async function startSessionManager(configuration, trackingConsentState) {
	const startTime = (0,entries_time/* relativeNow */._q)();
	const renewObservable = new tools_observable/* Observable */.y$();
	const expireObservable = new tools_observable/* Observable */.y$();
	const sessionStoreStrategyType = await (0,mockable/* mockable */.C)(selectSessionStoreStrategyType)(configuration);
	if (!sessionStoreStrategyType) {
		display/* display.warn */.jf.warn("No storage available for session. We will not send any data.");
		return;
	}
	const strategy = (0,mockable/* mockable */.C)(getSessionStoreStrategy)(sessionStoreStrategyType, configuration);
	const sessionContextHistory = (0,valueHistory/* createValueHistory */.p)({ maxEntries: MAX_SESSION_CONTEXT_HISTORY_ENTRIES });
	stopCallbacks.push(() => sessionContextHistory.stop());
	let sessionExpired = false;
	const { throttled: throttledExpandOrRenew, cancel: cancelExpandOrRenew } = (0,functionUtils/* throttle */.P)(() => {
		sessionExpired = false;
		strategy.setSessionState((state) => expandOrRenew(state, configuration), "expandOrRenewOnActivity").catch(monitor/* monitorError */.$y);
	}, entries_time/* ONE_SECOND */.WT);
	stopCallbacks.push(cancelExpandOrRenew);
	let expirationTimeoutId;
	stopCallbacks.push(() => (0,timer/* clearTimeout */.gr)(expirationTimeoutId));
	let stopped = false;
	stopCallbacks.push(() => {
		stopped = true;
	});
	let initialState = await resolveInitialState().catch((error) => (0,monitor/* monitorError */.$y)(/* @__PURE__ */ new Error(`Error while resolving initial session state: ${error}`)));
	if (!initialState || stopped) return;
	while (!trackingConsentState.isGranted()) {
		expire();
		await new Promise((resolve) => trackingConsentState.onGrantedOnce(resolve));
		if (stopped) return;
		initialState = await resolveInitialState().catch(monitor/* monitorError */.$y);
		if (!initialState || stopped) return;
	}
	sessionContextHistory.add(buildSessionContext(initialState), (0,entries_time/* clocksOrigin */.cQ)().relative);
	scheduleExpirationTimeout(initialState);
	subscribeToSessionChanges();
	setupSessionTracking();
	(0,telemetry_telemetry/* addTelemetryMetrics */.qZ)("Session manager init metrics", { metrics: { duration: (0,entries_time/* elapsed */._J)(startTime, (0,entries_time/* relativeNow */._q)()) } });
	return buildSessionManager();
	async function resolveInitialState() {
		let state = {};
		await strategy.setSessionState((currentState) => {
			state = expandOrRenew(initializeSession(currentState, configuration), configuration);
			return state;
		}, "initialize");
		return state;
	}
	function subscribeToSessionChanges() {
		const subscription = strategy.sessionObservable.subscribe((sessionState) => {
			scheduleExpirationTimeout(sessionState);
			handleStateChange(sessionState);
		});
		stopCallbacks.push(() => subscription.unsubscribe());
	}
	function scheduleExpirationTimeout(state) {
		(0,timer/* clearTimeout */.gr)(expirationTimeoutId);
		const expireDate = getExpireDate(state);
		if (expireDate) expirationTimeoutId = (0,timer/* setTimeout */.iK)(() => {
			strategy.setSessionState((state) => {
				if (isSessionInExpiredState(state)) {
					if (!trackingConsentState.isGranted()) delete state.anonymousId;
					return getExpiredSessionState(state, configuration);
				}
				return state;
			}, "expireOnTimeout").catch(monitor/* monitorError */.$y);
		}, expireDate - (0,entries_time/* dateNow */.m6)());
	}
	function setupSessionTracking() {
		trackingConsentState.observable.subscribe(() => {
			if (trackingConsentState.isGranted()) {
				sessionExpired = false;
				strategy.setSessionState((state) => expandOrRenew(state, configuration), "expandOrRenewOnConsent").catch(monitor/* monitorError */.$y);
			} else expire();
		});
		if (!globalObject/* isWorkerEnvironment */.j) {
			trackActivity(() => {
				if (trackingConsentState.isGranted()) throttledExpandOrRenew();
			});
			trackVisibility(() => {
				if (!sessionExpired) strategy.setSessionState((state) => expandOnly(state), "expandOnVisibility").catch(monitor/* monitorError */.$y);
			});
			trackResume(() => {
				strategy.setSessionState((state) => initializeSession(state, configuration), "initializeOnResume").catch(monitor/* monitorError */.$y);
			});
		}
	}
	function buildSessionManager() {
		return {
			findSession: (startTime, options) => sessionContextHistory.find(startTime, options),
			findTrackedSession: (startTime, { returnInactive = false, maxAge = TRACKED_SESSION_MAX_AGE } = {}) => {
				const session = sessionContextHistory.find(startTime, { returnInactive });
				if (!session || session.id === "invalid" || !(0,sampler/* isSampled */.HR)(session.id, configuration.sessionSampleRate)) return;
				if ((0,entries_time/* dateNow */.m6)() - session.createdAt > maxAge) return;
				return session;
			},
			renewObservable,
			expireObservable,
			expire,
			updateSessionState: (partialState) => {
				strategy.setSessionState((state) => ({
					...state,
					...partialState
				}), "updateState").catch(monitor/* monitorError */.$y);
			}
		};
	}
	function handleStateChange(newState) {
		const previousSession = sessionContextHistory.find();
		const hadSession = previousSession?.id !== void 0;
		const hasSession = newState.id !== void 0;
		const sessionIdChanged = hadSession && hasSession && previousSession.id !== newState.id;
		if (hadSession && (!hasSession || sessionIdChanged)) {
			sessionExpired = true;
			expireObservable.notify();
			sessionContextHistory.closeActive((0,entries_time/* relativeNow */._q)());
		}
		if (hasSession && (!hadSession || sessionIdChanged)) {
			if (sessionExpired) return;
			sessionContextHistory.add(buildSessionContext(newState), (0,entries_time/* relativeNow */._q)());
			renewObservable.notify();
		} else if (hadSession && hasSession && !sessionIdChanged) previousSession.isReplayForced = !!newState.forcedReplay;
	}
	function expire() {
		cancelExpandOrRenew();
		const expiredState = getExpiredSessionState(sessionContextHistory.find(), configuration);
		if (!trackingConsentState.isGranted()) delete expiredState.anonymousId;
		handleStateChange(expiredState);
		strategy.setSessionState((state) => {
			if (!trackingConsentState.isGranted()) delete state.anonymousId;
			return getExpiredSessionState(state, configuration);
		}, "expire").catch(monitor/* monitorError */.$y);
	}
	function buildSessionContext(sessionState) {
		const createdAt = getCreatedDate(sessionState) ?? (0,entries_time/* timeStampNow */.n$)();
		if (!sessionState.id) return {
			id: "invalid",
			isReplayForced: false,
			anonymousId: void 0,
			createdAt
		};
		return {
			id: sessionState.id,
			isReplayForced: !!sessionState.forcedReplay,
			anonymousId: sessionState.anonymousId,
			createdAt
		};
	}
}
function startSessionManagerStub() {
	let sessionContext = {
		id: generateUUID(),
		isReplayForced: false,
		anonymousId: void 0,
		createdAt: (0,entries_time/* timeStampNow */.n$)()
	};
	return Promise.resolve({
		findSession: () => sessionContext,
		findTrackedSession: () => sessionContext,
		renewObservable: new tools_observable/* Observable */.y$(),
		expireObservable: new tools_observable/* Observable */.y$(),
		expire: functionUtils/* noop */.Z,
		updateSessionState: (state) => {
			sessionContext = {
				...sessionContext,
				...state
			};
		}
	});
}
function stopSessionManager() {
	stopCallbacks.forEach((e) => e());
	stopCallbacks = [];
}
function trackActivity(expandOrRenewSession) {
	const { stop } = (0,addEventListener/* addEventListeners */.yw)(window, [
		"click",
		"touchstart",
		"keydown",
		"scroll"
	], expandOrRenewSession, {
		capture: true,
		passive: true
	});
	stopCallbacks.push(stop);
}
function trackVisibility(expandSession) {
	const expandSessionWhenVisible = () => {
		if (document.visibilityState === "visible") expandSession();
	};
	const { stop } = (0,addEventListener/* addEventListener */.Oo)(document, "visibilitychange", expandSessionWhenVisible);
	stopCallbacks.push(stop);
	const visibilityCheckInterval = (0,timer/* setInterval */.Zi)(expandSessionWhenVisible, VISIBILITY_CHECK_DELAY);
	stopCallbacks.push(() => {
		(0,timer/* clearInterval */.cv)(visibilityCheckInterval);
	});
}
function trackResume(cb) {
	const { stop } = (0,addEventListener/* addEventListener */.Oo)(window, "resume", cb, { capture: true });
	stopCallbacks.push(stop);
}
//#endregion


//# sourceMappingURL=sessionManager.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-core/esm/domain/contexts/telemetrySessionContext.mjs

//#region src/domain/contexts/telemetrySessionContext.ts
function startTelemetrySessionContext(assembleTelemetryHook, sessionManager, extraContext) {
	assembleTelemetryHook.register(({ startTime }) => {
		const session = sessionManager.findTrackedSession(startTime);
		if (!session) return assembly_hook/* SKIPPED */.kb;
		return {
			session: { id: session.id },
			anonymous_id: session.anonymousId,
			...extraContext
		};
	});
}
//#endregion


//# sourceMappingURL=telemetrySessionContext.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/preStartRum.mjs








//#region src/boot/preStartRum.ts
function createPreStartStrategy({ ignoreInitIfSyntheticsWillInjectRum = true, startDeflateWorker, sdkName }, trackingConsentState, doStartRum) {
	const bufferApiCalls = new tools_observable/* BufferedObservable */.fk(500, (count) => {
		(0,telemetry_telemetry/* addTelemetryDebug */.eJ)("preStartRum buffer data lost", { count });
	});
	const globalContext = buildGlobalContextManager();
	bufferContextCalls(globalContext, CustomerContextKey.globalContext, bufferApiCalls);
	const userContext = buildUserContextManager();
	bufferContextCalls(userContext, CustomerContextKey.userContext, bufferApiCalls);
	const accountContext = buildAccountContextManager();
	bufferContextCalls(accountContext, CustomerContextKey.accountContext, bufferApiCalls);
	let firstStartViewCall;
	let deflateWorker;
	let cachedInitConfiguration;
	let cachedConfiguration;
	let sessionManager;
	let telemetry;
	const hooks = createHooks();
	const trackingConsentStateSubscription = trackingConsentState.observable.subscribe(tryStartRum);
	const emptyContext = {};
	let started = false;
	function tryStartRum() {
		if (started || !cachedInitConfiguration || !cachedConfiguration || !sessionManager || !telemetry) return;
		trackingConsentStateSubscription.unsubscribe();
		let initialViewOptions;
		if (cachedConfiguration.trackViewsManually) {
			if (!firstStartViewCall) return;
			initialViewOptions = firstStartViewCall.options;
		}
		const callbackToSkip = cachedConfiguration.trackViewsManually ? firstStartViewCall?.callback : void 0;
		const startRumResult = doStartRum(cachedConfiguration, sessionManager, deflateWorker, initialViewOptions, telemetry, hooks);
		started = true;
		bufferApiCalls.subscribe((callback) => {
			if (callback !== callbackToSkip) callback(startRumResult);
		});
		bufferApiCalls.unbuffer();
	}
	function doInit(initConfiguration, errorStack) {
		const eventBridgeAvailable = (0,eventBridge/* canUseEventBridge */.xT)();
		if (eventBridgeAvailable) initConfiguration = overrideInitConfigurationForBridge(initConfiguration);
		cachedInitConfiguration = initConfiguration;
		if (cachedConfiguration) {
			displayAlreadyInitializedError("DD_RUM", initConfiguration);
			return;
		}
		const configuration = validateAndBuildRumConfiguration(initConfiguration);
		if (!configuration || !isAllowedTrackingOrigins(configuration, errorStack ?? "")) return;
		if (configuration.compressIntakeRequests && !eventBridgeAvailable && startDeflateWorker) {
			deflateWorker = startDeflateWorker(configuration, "Datadog RUM", functionUtils/* noop */.Z);
			if (!deflateWorker) return;
		}
		cachedConfiguration = configuration;
		trackingConsentState.tryToInit(configuration.trackingConsent);
		trackingConsentState.onGrantedOnce(() => {
			const { assembleTelemetry: assembleTelemetryHook } = hooks;
			startTrackingConsentContext(assembleTelemetryHook, trackingConsentState);
			telemetry = (0,mockable/* mockable */.C)(telemetry_telemetry/* startTelemetry */.VL)(telemetry_telemetry/* TelemetryService.RUM */.y0.RUM, configuration, assembleTelemetryHook, sdkName);
			if (globalObject/* isWorkerEnvironment */.j) {
				display/* display.warn */.jf.warn("The RUM SDK is not supported in a web or service worker environment.");
				return;
			}
			((0,eventBridge/* canUseEventBridge */.xT)() ? startSessionManagerStub() : (0,mockable/* mockable */.C)(startSessionManager)(configuration, trackingConsentState)).then((newSessionManager) => {
				if (!newSessionManager) return;
				sessionManager = newSessionManager;
				startTelemetrySessionContext(assembleTelemetryHook, sessionManager, { application: { id: configuration.applicationId } });
				(0,telemetry_telemetry/* addTelemetryConfiguration */.Uo)(serializeRumConfiguration(initConfiguration));
				tryStartRum();
			}).catch(monitor/* monitorError */.$y);
		});
	}
	const addOperationStepVital = (name, stepType, options, failureReason) => {
		bufferApiCalls.notify((startRumResult) => startRumResult.addOperationStepVital(sanitize(name), stepType, sanitize(options), sanitize(failureReason)));
	};
	return {
		init(initConfiguration, publicApi, errorStack) {
			if (!initConfiguration) {
				display/* display.error */.jf.error("Missing configuration");
				return;
			}
			(0,experimentalFeatures/* initFeatureFlags */.fG)(initConfiguration.enableExperimentalFeatures);
			(0,addEventListener/* setAllowUntrustedEvents */.$k)(initConfiguration.allowUntrustedEvents);
			cachedInitConfiguration = initConfiguration;
			if (ignoreInitIfSyntheticsWillInjectRum && willSyntheticsInjectRum()) return;
			callPluginsMethod(initConfiguration.plugins, "onInit", {
				initConfiguration,
				publicApi
			});
			if (getRemoteConfigurationId(initConfiguration)) {
				const supportedContextManagers = {
					user: userContext,
					context: globalContext
				};
				if (!!initConfiguration.remoteConfigurationId || !!initConfiguration.remoteConfiguration?.sync) fetchAndApplyRemoteConfiguration(initConfiguration, supportedContextManagers).then((resolvedInitConfiguration) => {
					if (resolvedInitConfiguration) doInit(resolvedInitConfiguration, errorStack);
				}).catch(monitor/* monitorError */.$y);
				else {
					const resolvedInitConfiguration = getRemoteConfiguration(initConfiguration, supportedContextManagers);
					if (resolvedInitConfiguration) doInit(resolvedInitConfiguration, errorStack);
				}
			} else doInit(initConfiguration, errorStack);
		},
		get initConfiguration() {
			return cachedInitConfiguration;
		},
		getInternalContext: functionUtils/* noop */.Z,
		stopSession: functionUtils/* noop */.Z,
		addTiming(name, time = (0,entries_time/* timeStampNow */.n$)()) {
			bufferApiCalls.notify((startRumResult) => startRumResult.addTiming(name, time));
		},
		setLoadingTime: ((callTimestamp) => {
			bufferApiCalls.notify((startRumResult) => startRumResult.setLoadingTime(callTimestamp));
		}),
		startView(options, startClocks = (0,entries_time/* clocksNow */.$I)()) {
			const callback = (startRumResult) => {
				startRumResult.startView(options, startClocks);
			};
			bufferApiCalls.notify(callback);
			if (!firstStartViewCall) {
				firstStartViewCall = {
					options,
					callback
				};
				tryStartRum();
			}
		},
		setViewName(name) {
			bufferApiCalls.notify((startRumResult) => startRumResult.setViewName(name));
		},
		setViewContext(context) {
			bufferApiCalls.notify((startRumResult) => startRumResult.setViewContext(context));
		},
		setViewContextProperty(key, value) {
			bufferApiCalls.notify((startRumResult) => startRumResult.setViewContextProperty(key, value));
		},
		getViewContext: () => emptyContext,
		globalContext,
		userContext,
		accountContext,
		addAction(action) {
			bufferApiCalls.notify((startRumResult) => startRumResult.addAction(action));
		},
		startAction(name, options) {
			const startClocks = (0,entries_time/* clocksNow */.$I)();
			bufferApiCalls.notify((startRumResult) => startRumResult.startAction(name, options, startClocks));
		},
		stopAction(name, options) {
			const stopClocks = (0,entries_time/* clocksNow */.$I)();
			bufferApiCalls.notify((startRumResult) => startRumResult.stopAction(name, options, stopClocks));
		},
		startResource(url, options) {
			const startClocks = (0,entries_time/* clocksNow */.$I)();
			bufferApiCalls.notify((startRumResult) => startRumResult.startResource(url, options, startClocks));
		},
		stopResource(url, options) {
			const stopClocks = (0,entries_time/* clocksNow */.$I)();
			bufferApiCalls.notify((startRumResult) => startRumResult.stopResource(url, options, stopClocks));
		},
		addError(providedError) {
			bufferApiCalls.notify((startRumResult) => startRumResult.addError(providedError));
		},
		addFeatureFlagEvaluation(key, value) {
			bufferApiCalls.notify((startRumResult) => startRumResult.addFeatureFlagEvaluation(key, value));
		},
		startDurationVital(name, options) {
			const startClocks = (0,entries_time/* clocksNow */.$I)();
			bufferApiCalls.notify((startRumResult) => startRumResult.startDurationVital(name, options, startClocks));
		},
		stopDurationVital(name, options) {
			const stopClocks = (0,entries_time/* clocksNow */.$I)();
			bufferApiCalls.notify((startRumResult) => startRumResult.stopDurationVital(name, options, stopClocks));
		},
		addDurationVital(vital) {
			bufferApiCalls.notify((startRumResult) => startRumResult.addDurationVital(vital));
		},
		addOperationStepVital
	};
}
function overrideInitConfigurationForBridge(initConfiguration) {
	return {
		...initConfiguration,
		applicationId: "00000000-aaaa-0000-aaaa-000000000000",
		clientToken: "empty",
		sessionSampleRate: 100,
		defaultPrivacyLevel: initConfiguration.defaultPrivacyLevel ?? (0,eventBridge/* getEventBridge */.Ad)()?.getPrivacyLevel()
	};
}
//#endregion


//# sourceMappingURL=preStartRum.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/tools/encoder.mjs
var encoder = __webpack_require__(65010);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/boot/init.mjs
var init = __webpack_require__(77089);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/boot/rumPublicApi.mjs









//#region src/boot/rumPublicApi.ts
function makeRumPublicApi(recorderApi, profilerApi, options = {}) {
	const trackingConsentState = createTrackingConsentState();
	const bufferedData = startBufferingData();
	let strategy = createPreStartStrategy(options, trackingConsentState, (configuration, sessionManager, deflateWorker, initialViewOptions, telemetry, hooks) => {
		const createEncoder = deflateWorker && options.createDeflateEncoder ? (streamId) => options.createDeflateEncoder(deflateWorker, streamId) : encoder/* createIdentityEncoder */.G;
		const startRumResult = (0,mockable/* mockable */.C)(startRum)(configuration, sessionManager, recorderApi, profilerApi, initialViewOptions, createEncoder, bufferedData.observable, telemetry, hooks, options.sdkName);
		recorderApi.onRumStart(startRumResult.lifeCycle, configuration, sessionManager, startRumResult.viewHistory, deflateWorker, startRumResult.telemetry);
		profilerApi.onRumStart(startRumResult.lifeCycle, startRumResult.hooks, configuration, sessionManager, startRumResult.viewHistory, createEncoder);
		strategy = createPostStartStrategy(strategy, startRumResult);
		callPluginsMethod(configuration.plugins, "onRumStart", {
			addEvent: startRumResult.addEvent,
			addError: startRumResult.addError
		});
		return startRumResult;
	});
	const getStrategy = () => strategy;
	const startView = (options) => {
		const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)("view");
		(0,monitor/* callMonitored */.L6)(() => {
			const sanitizedOptions = typeof options === "object" ? options : { name: options };
			strategy.startView({
				...sanitizedOptions,
				handlingStack
			});
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "start-view" });
		});
	};
	const startOperation = (name, options) => {
		const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)("vital");
		(0,monitor/* callMonitored */.L6)(() => {
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({
				feature: "add-operation-step-vital",
				action_type: "start"
			});
			strategy.addOperationStepVital(name, "start", {
				...options,
				handlingStack
			});
		});
	};
	const succeedOperation = (0,monitor/* monitor */.zk)((name, options) => {
		(0,telemetry_telemetry/* addTelemetryUsage */.eG)({
			feature: "add-operation-step-vital",
			action_type: "succeed"
		});
		strategy.addOperationStepVital(name, "end", options);
	});
	const failOperation = (0,monitor/* monitor */.zk)((name, failureReason, options) => {
		(0,telemetry_telemetry/* addTelemetryUsage */.eG)({
			feature: "add-operation-step-vital",
			action_type: "fail"
		});
		strategy.addOperationStepVital(name, "end", options, failureReason);
	});
	const rumPublicApi = (0,init/* makePublicApi */.r)({
		init: (initConfiguration) => {
			const errorStack = (/* @__PURE__ */ new Error()).stack;
			(0,monitor/* callMonitored */.L6)(() => strategy.init(initConfiguration, rumPublicApi, errorStack));
		},
		setTrackingConsent: (0,monitor/* monitor */.zk)((trackingConsent) => {
			trackingConsentState.update(trackingConsent);
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({
				feature: "set-tracking-consent",
				tracking_consent: trackingConsent
			});
		}),
		setViewName: (0,monitor/* monitor */.zk)((name) => {
			strategy.setViewName(name);
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "set-view-name" });
		}),
		setViewContext: (0,monitor/* monitor */.zk)((context) => {
			strategy.setViewContext(context);
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "set-view-context" });
		}),
		setViewContextProperty: (0,monitor/* monitor */.zk)((key, value) => {
			strategy.setViewContextProperty(key, value);
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "set-view-context-property" });
		}),
		getViewContext: (0,monitor/* monitor */.zk)(() => {
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "set-view-context-property" });
			return strategy.getViewContext();
		}),
		getInternalContext: (0,monitor/* monitor */.zk)((startTime) => strategy.getInternalContext(startTime)),
		getInitConfiguration: (0,monitor/* monitor */.zk)(() => (0,mergeInto/* deepClone */.I8)(strategy.initConfiguration)),
		addAction: (name, context) => {
			const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)("action");
			(0,monitor/* callMonitored */.L6)(() => {
				strategy.addAction({
					name: sanitize(name),
					context: sanitize(context),
					startClocks: (0,entries_time/* clocksNow */.$I)(),
					type: ActionType.CUSTOM,
					handlingStack
				});
				(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "add-action" });
			});
		},
		startAction: (0,monitor/* monitor */.zk)((name, options) => {
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "start-action" });
			strategy.startAction(sanitize(name), {
				type: sanitize(options?.type),
				context: sanitize(options?.context),
				actionKey: options?.actionKey
			});
		}),
		stopAction: (0,monitor/* monitor */.zk)((name, options) => {
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "stop-action" });
			strategy.stopAction(sanitize(name), {
				type: sanitize(options?.type),
				context: sanitize(options?.context),
				actionKey: options?.actionKey
			});
		}),
		startResource: (0,monitor/* monitor */.zk)((url, options) => {
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "start-resource" });
			strategy.startResource(sanitize(url), {
				type: sanitize(options?.type),
				method: sanitize(options?.method),
				context: sanitize(options?.context),
				resourceKey: options?.resourceKey
			});
		}),
		stopResource: (0,monitor/* monitor */.zk)((url, options) => {
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "stop-resource" });
			strategy.stopResource(sanitize(url), {
				type: sanitize(options?.type),
				statusCode: options?.statusCode,
				size: options?.size,
				context: sanitize(options?.context),
				resourceKey: options?.resourceKey
			});
		}),
		addError: (error, context) => {
			const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)("error");
			(0,monitor/* callMonitored */.L6)(() => {
				strategy.addError({
					error,
					handlingStack,
					context: sanitize(context),
					startClocks: (0,entries_time/* clocksNow */.$I)()
				});
				(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "add-error" });
			});
		},
		addTiming: (0,monitor/* monitor */.zk)((name, time) => {
			strategy.addTiming(sanitize(name), time);
		}),
		setViewLoadingTime: (0,monitor/* monitor */.zk)(() => {
			const callTimestamp = (0,entries_time/* timeStampNow */.n$)();
			strategy.setLoadingTime(callTimestamp);
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "addViewLoadingTime" });
		}),
		setGlobalContext: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.setContext, "set-global-context"),
		getGlobalContext: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.getContext, "get-global-context"),
		setGlobalContextProperty: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.setContextProperty, "set-global-context-property"),
		removeGlobalContextProperty: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.removeContextProperty, "remove-global-context-property"),
		clearGlobalContext: defineContextMethod(getStrategy, CustomerContextKey.globalContext, ContextManagerMethod.clearContext, "clear-global-context"),
		setUser: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.setContext, "set-user"),
		getUser: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.getContext, "get-user"),
		setUserProperty: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.setContextProperty, "set-user-property"),
		removeUserProperty: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.removeContextProperty, "remove-user-property"),
		clearUser: defineContextMethod(getStrategy, CustomerContextKey.userContext, ContextManagerMethod.clearContext, "clear-user"),
		setAccount: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.setContext, "set-account"),
		getAccount: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.getContext, "get-account"),
		setAccountProperty: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.setContextProperty, "set-account-property"),
		removeAccountProperty: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.removeContextProperty, "remove-account-property"),
		clearAccount: defineContextMethod(getStrategy, CustomerContextKey.accountContext, ContextManagerMethod.clearContext, "clear-account"),
		startView,
		stopSession: (0,monitor/* monitor */.zk)(() => {
			strategy.stopSession();
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "stop-session" });
		}),
		addFeatureFlagEvaluation: (0,monitor/* monitor */.zk)((key, value) => {
			strategy.addFeatureFlagEvaluation(sanitize(key), sanitize(value));
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "add-feature-flag-evaluation" });
		}),
		getSessionReplayLink: (0,monitor/* monitor */.zk)(() => recorderApi.getSessionReplayLink()),
		startSessionReplayRecording: (0,monitor/* monitor */.zk)((options) => {
			recorderApi.start(options);
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({
				feature: "start-session-replay-recording",
				force: options?.force
			});
		}),
		stopSessionReplayRecording: (0,monitor/* monitor */.zk)(() => recorderApi.stop()),
		addDurationVital: (name, options) => {
			const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)("vital");
			(0,monitor/* callMonitored */.L6)(() => {
				(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "add-duration-vital" });
				strategy.addDurationVital({
					id: generateUUID(),
					name: sanitize(name),
					type: VitalType.DURATION,
					startClocks: (0,entries_time/* timeStampToClocks */.lO)(options.startTime),
					duration: options.duration,
					context: sanitize(options?.context),
					description: sanitize(options?.description),
					handlingStack
				});
			});
		},
		startDurationVital: (name, options) => {
			const handlingStack = (0,stackTrace_handlingStack/* createHandlingStack */.Xp)("vital");
			(0,monitor/* callMonitored */.L6)(() => {
				(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "start-duration-vital" });
				strategy.startDurationVital(sanitize(name), {
					vitalKey: options?.vitalKey,
					context: sanitize(options?.context),
					description: sanitize(options?.description),
					handlingStack
				});
			});
		},
		stopDurationVital: (0,monitor/* monitor */.zk)((name, options) => {
			(0,telemetry_telemetry/* addTelemetryUsage */.eG)({ feature: "stop-duration-vital" });
			strategy.stopDurationVital(sanitize(name), {
				vitalKey: options?.vitalKey,
				context: sanitize(options?.context),
				description: sanitize(options?.description)
			});
		}),
		startOperation,
		succeedOperation,
		failOperation,
		startFeatureOperation: startOperation,
		succeedFeatureOperation: succeedOperation,
		failFeatureOperation: failOperation,
		DEFAULT_TRACKED_RESOURCE_HEADERS: DEFAULT_TRACKED_RESOURCE_HEADERS
	});
	return rumPublicApi;
}
function createPostStartStrategy(preStartStrategy, startRumResult) {
	return {
		...preStartStrategy,
		init: (initConfiguration) => {
			displayAlreadyInitializedError("DD_RUM", initConfiguration);
		},
		getInternalContext: startRumResult.getInternalContext,
		stopSession: startRumResult.stopSession,
		getViewContext: startRumResult.getViewContext,
		globalContext: startRumResult.globalContext,
		userContext: startRumResult.userContext,
		accountContext: startRumResult.accountContext
	};
}
//#endregion


//# sourceMappingURL=rumPublicApi.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/domain/getSessionReplayUrl.mjs

//#region src/domain/getSessionReplayUrl.ts
function getSessionReplayUrl(configuration, { session, viewContext, errorType }) {
	const sessionId = session ? session.id : "no-session-id";
	const parameters = [];
	if (errorType !== void 0) parameters.push(`error-type=${errorType}`);
	if (viewContext) {
		parameters.push(`seed=${viewContext.id}`);
		parameters.push(`from=${viewContext.startClocks.timeStamp}`);
	}
	return `${getDatadogSiteUrl(configuration)}${`/rum/replay/sessions/${sessionId}`}?${parameters.join("&")}`;
}
function getDatadogSiteUrl(rumConfiguration) {
	const site = rumConfiguration.site;
	const subdomain = rumConfiguration.subdomain || getSiteDefaultSubdomain(rumConfiguration);
	return `https://${subdomain ? `${subdomain}.` : ""}${site}`;
}
function getSiteDefaultSubdomain(configuration) {
	switch (configuration.site) {
		case intakeSites/* INTAKE_SITE_US1 */.D_:
		case intakeSites/* INTAKE_SITE_EU1 */.Ds: return "app";
		case intakeSites/* INTAKE_SITE_STAGING */.DZ: return "dd";
		default: return;
	}
}
//#endregion


//# sourceMappingURL=getSessionReplayUrl.mjs.map
// EXTERNAL MODULE: ./node_modules/@datadog/browser-core/esm/transport/httpRequest.mjs + 1 modules
var transport_httpRequest = __webpack_require__(50434);
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/transport/formDataTransport.mjs




//#region src/transport/formDataTransport.ts
function createFormDataTransport(configuration, lifeCycle, createEncoder, streamId) {
	const reportError = (message) => {
		lifeCycle.notify(15, { error: {
			message,
			source: error_types/* ErrorSource.AGENT */.zH.AGENT,
			startClocks: (0,entries_time/* clocksNow */.$I)()
		} });
		(0,telemetry_telemetry/* addTelemetryDebug */.eJ)("Error reported to customer", { "error.message": message });
	};
	const httpRequest = (0,transport_httpRequest/* createHttpRequest */.UF)([(0,endpointBuilder/* createEndpointBuilder */.Ez)(configuration, "profile")], reportError);
	const encoder = createEncoder(streamId);
	return { async send({ event, ...attachments }) {
		const formData = new FormData();
		const serializedEvent = (0,jsonStringify/* jsonStringify */.l)(event);
		if (!serializedEvent) throw new Error("Failed to serialize event");
		formData.append("event", new Blob([serializedEvent], { type: "application/json" }), "event.json");
		let bytesCount = serializedEvent.length;
		for (const [key, value] of (0,polyfills/* objectEntries */.qP)(attachments)) {
			const serializedValue = (0,jsonStringify/* jsonStringify */.l)(value);
			if (!serializedValue) throw new Error("Failed to serialize attachment");
			const result = await encode(encoder, serializedValue);
			bytesCount += result.outputBytesCount;
			formData.append(key, new Blob([result.output]), key);
		}
		httpRequest.send({
			data: formData,
			bytesCount
		});
	} };
}
function encode(encoder, data) {
	return new Promise((resolve) => {
		encoder.write(data);
		encoder.finish((encoderResult) => {
			resolve(encoderResult);
		});
	});
}
//#endregion


//# sourceMappingURL=formDataTransport.mjs.map
;// CONCATENATED MODULE: ./node_modules/@datadog/browser-rum-core/esm/index.mjs
























/***/ }),

/***/ 83417:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ getSegmentsCount; },
/* harmony export */   "MA": function() { return /* binding */ getReplayStats; },
/* harmony export */   "pk": function() { return /* binding */ addWroteData; },
/* harmony export */   "ui": function() { return /* binding */ addSegment; },
/* harmony export */   "xK": function() { return /* binding */ addRecord; }
/* harmony export */ });
/* unused harmony export MAX_STATS_HISTORY */
//#region src/domain/replayStats.ts
const MAX_STATS_HISTORY = 1e3;
let statsPerView;
function getSegmentsCount(viewId) {
	return getOrCreateReplayStats(viewId).segments_count;
}
function addSegment(viewId) {
	getOrCreateReplayStats(viewId).segments_count += 1;
}
function addRecord(viewId) {
	getOrCreateReplayStats(viewId).records_count += 1;
}
function addWroteData(viewId, additionalBytesCount) {
	getOrCreateReplayStats(viewId).segments_total_raw_size += additionalBytesCount;
}
function getReplayStats(viewId) {
	return statsPerView?.get(viewId);
}
function getOrCreateReplayStats(viewId) {
	if (!statsPerView) statsPerView = /* @__PURE__ */ new Map();
	let replayStats;
	if (statsPerView.has(viewId)) replayStats = statsPerView.get(viewId);
	else {
		replayStats = {
			records_count: 0,
			segments_count: 0,
			segments_total_raw_size: 0
		};
		statsPerView.set(viewId, replayStats);
		if (statsPerView.size > 1e3) deleteOldestStats();
	}
	return replayStats;
}
function deleteOldestStats() {
	if (!statsPerView) return;
	const toDelete = statsPerView.keys().next().value;
	if (toDelete) statsPerView.delete(toDelete);
}
//#endregion


//# sourceMappingURL=replayStats.mjs.map

/***/ }),

/***/ 99731:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bi": function() { return /* binding */ createHook; },
/* harmony export */   "C_": function() { return /* binding */ DISCARDED; },
/* harmony export */   "kb": function() { return /* binding */ SKIPPED; }
/* harmony export */ });
/* harmony import */ var _util_mergeInto_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91303);

//#region src/assembly/hook.ts
/**
* Creates a new `Hook` instance with no registered callbacks.
*
* @typeParam Params - The input type passed to registered callbacks.
* @typeParam Result - The return type that callbacks contribute to.
*/
function createHook() {
	let callbacks = [];
	return {
		register(callback) {
			callbacks.push(callback);
			return { unregister() {
				callbacks = callbacks.filter((cb) => cb !== callback);
			} };
		},
		trigger(params) {
			const results = [];
			for (const callback of callbacks) {
				const result = callback(params);
				if (result === "DISCARDED") return DISCARDED;
				if (result === "SKIPPED") continue;
				results.push(result);
			}
			return (0,_util_mergeInto_mjs__WEBPACK_IMPORTED_MODULE_0__/* .combine */ .$e)(...results);
		}
	};
}
/** Sentinel returned by a hook callback to discard the entire event (no further callbacks are invoked). */
const DISCARDED = "DISCARDED";
/** Sentinel returned by a hook callback to opt out of contributing a result (other callbacks still run). */
const SKIPPED = "SKIPPED";
//#endregion


//# sourceMappingURL=hook.mjs.map

/***/ }),

/***/ 18907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ clocksNow; },
/* harmony export */   "DY": function() { return /* binding */ relativeToClocks; },
/* harmony export */   "MN": function() { return /* binding */ isRelativeTime; },
/* harmony export */   "P5": function() { return /* binding */ ONE_YEAR; },
/* harmony export */   "Pv": function() { return /* binding */ clockDrift; },
/* harmony export */   "U": function() { return /* binding */ getTimeOrigin; },
/* harmony export */   "WK": function() { return /* binding */ addDuration; },
/* harmony export */   "WT": function() { return /* binding */ ONE_SECOND; },
/* harmony export */   "_J": function() { return /* binding */ elapsed; },
/* harmony export */   "_q": function() { return /* binding */ relativeNow; },
/* harmony export */   "cQ": function() { return /* binding */ clocksOrigin; },
/* harmony export */   "dV": function() { return /* binding */ ONE_HOUR; },
/* harmony export */   "dg": function() { return /* binding */ toServerDuration; },
/* harmony export */   "lO": function() { return /* binding */ timeStampToClocks; },
/* harmony export */   "m6": function() { return /* binding */ dateNow; },
/* harmony export */   "n$": function() { return /* binding */ timeStampNow; },
/* harmony export */   "yR": function() { return /* binding */ ONE_MINUTE; },
/* harmony export */   "zj": function() { return /* binding */ toRelativeTime; }
/* harmony export */ });
/* unused harmony exports ONE_DAY, toTimeStamp */
//#region src/entries/time.ts
/** One second in milliseconds. */
const ONE_SECOND = 1e3;
/** One minute in milliseconds. */
const ONE_MINUTE = 60 * ONE_SECOND;
/** One hour in milliseconds. */
const ONE_HOUR = 60 * ONE_MINUTE;
/** One day in milliseconds. */
const ONE_DAY = (/* unused pure expression or super */ null && (1440 * 60 * 1e3));
/** One year in milliseconds. */
const ONE_YEAR = 365 * 24 * 60 * 60 * 1e3;
/**
* Returns the current time as a Unix timestamp in milliseconds.
*
* Prefer this over `Date.now()` because some environments incorrectly polyfill `Date.now` —
* for example, old versions of `datejs` patched it to return a `Date` instance instead of a
* number, which silently breaks arithmetic. `new Date().getTime()` is unaffected by such patches.
*
* @returns Current Unix timestamp in milliseconds.
*/
function dateNow() {
	return (/* @__PURE__ */ new Date()).getTime();
}
/**
* Returns the current time as a {@link TimeStamp}.
*
* @returns Current Unix timestamp in milliseconds, typed as {@link TimeStamp}.
*/
function timeStampNow() {
	return dateNow();
}
function elapsed(start, end) {
	return end - start;
}
function toServerDuration(duration) {
	if (typeof duration !== "number") return duration;
	return Math.round(duration * 1e6);
}
function addDuration(a, b) {
	return a + b;
}
/**
* Returns the current relative time in milliseconds since navigation start, sourced from
* `performance.now()`. In Node.js (≥16), this is relative to the process start time.
*
* @returns Current relative time as a {@link RelativeTime}.
*/
function relativeNow() {
	return performance.now();
}
/**
* Returns the current time as both a relative time and an absolute timestamp.
*
* @returns A {@link ClocksState} with the current relative and absolute times.
*/
function clocksNow() {
	return {
		relative: relativeNow(),
		timeStamp: timeStampNow()
	};
}
/**
* Returns the clocks state at the navigation/process origin (relative = 0).
*
* @returns A {@link ClocksState} with `relative = 0` and the navigation start timestamp.
*/
function clocksOrigin() {
	return {
		relative: 0,
		timeStamp: getTimeOrigin()
	};
}
/**
* Converts a relative time to a {@link ClocksState} with a corrected absolute timestamp.
* Applies a drift correction when the system clock moved forward relative to `performance.now()`.
*
* @param relative - The relative time to convert.
* @returns A {@link ClocksState} with the relative time and its corrected absolute timestamp.
*/
function relativeToClocks(relative) {
	return {
		relative,
		timeStamp: getCorrectedTimeStamp(relative)
	};
}
/**
* Converts an absolute timestamp to a {@link ClocksState} with its corresponding relative time.
*
* @param timeStamp - The absolute timestamp to convert.
* @returns A {@link ClocksState} with the timestamp and its relative time since navigation start.
*/
function timeStampToClocks(timeStamp) {
	return {
		relative: toRelativeTime(timeStamp),
		timeStamp
	};
}
/**
* Converts an absolute timestamp to a relative time since navigation start.
*
* @param timestamp - An absolute Unix timestamp.
* @returns The corresponding {@link RelativeTime} since navigation start.
*/
function toRelativeTime(timestamp) {
	return timestamp - getTimeOrigin();
}
/**
* Converts a relative time since navigation start to an absolute timestamp.
*
* @param relativeTime - Time in milliseconds since navigation start.
* @returns The corresponding absolute {@link TimeStamp}.
*/
function toTimeStamp(relativeTime) {
	return Math.round(addDuration(getTimeOrigin(), relativeTime));
}
/**
* Returns `true` if the given value is more likely a relative time than an absolute timestamp.
* Heuristic: values smaller than one year are treated as relative.
*
* @param time - A value that may be either a {@link RelativeTime} or a {@link TimeStamp}.
*/
function isRelativeTime(time) {
	return time < ONE_YEAR;
}
/**
* Returns the drift in milliseconds between `Date.now()` and `performance.now()` relative to
* navigation start. A positive value means the system clock ran ahead of the performance timer.
*
* @returns Clock drift in milliseconds.
*/
function clockDrift() {
	return Math.round(dateNow() - addDuration(getTimeOrigin(), performance.now()));
}
/**
* Time origin slightly changes on some rare cases — cache it.
*/
let timeOrigin;
/**
* Returns the time origin — the start of the current navigation in browsers, or the process
* start time in Node.js.
*
* Prefers `performance.timing.navigationStart` over `performance.timeOrigin` because
* `timeOrigin` can be much farther in the past than the actual navigation start (Firefox 71,
* https://bugzilla.mozilla.org/show_bug.cgi?id=1429926) and is not supported in Safari <15.
* Falls back to `performance.timeOrigin` in environments without `performance.timing`
* (Service Workers, Node.js)
*
* @returns The time origin as a {@link TimeStamp}.
*/
function getTimeOrigin() {
	if (timeOrigin === void 0) timeOrigin = performance.timing?.navigationStart ?? performance.timeOrigin;
	return timeOrigin;
}
function getCorrectedTimeStamp(relativeTime) {
	const correctedOrigin = dateNow() - performance.now();
	if (correctedOrigin > getTimeOrigin()) return Math.round(addDuration(correctedOrigin, relativeTime));
	return toTimeStamp(relativeTime);
}
//#endregion


//# sourceMappingURL=time.mjs.map

/***/ }),

/***/ 39464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ez": function() { return /* binding */ createEndpointBuilder; },
/* harmony export */   "ji": function() { return /* binding */ createReplicaEndpointBuilder; },
/* harmony export */   "lp": function() { return /* binding */ buildEndpointUrl; }
/* harmony export */ });
/* harmony import */ var _util_urlPolyfill_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56140);
/* harmony import */ var _entries_time_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18907);
/* harmony import */ var _intakeSites_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94174);



//#region src/transport/endpointBuilder.ts
/** Creates an {@link EndpointBuilder} for the given track type. */
function createEndpointBuilder(configuration, trackType, extraParameters) {
	return {
		build(api, payload) {
			return buildEndpointUrl({
				proxy: configuration.proxy,
				site: configuration.site,
				path: `/api/v2/${trackType}`,
				parameters: buildEndpointParameters(configuration, trackType, api, payload, extraParameters)
			});
		},
		trackType
	};
}
/**
* Build the endpoint for the replica (dual shipping) site, if a replica is configured.
*
* The replica always targets the US1 site but keeps the `proxy` and `source` of the main
* configuration. The RUM track additionally carries the replica `application.id`.
*/
function createReplicaEndpointBuilder({ replica, proxy, source }, trackType) {
	if (!replica) return;
	return createEndpointBuilder({
		clientToken: replica.clientToken,
		proxy,
		source,
		site: _intakeSites_mjs__WEBPACK_IMPORTED_MODULE_0__/* .INTAKE_SITE_US1 */ .D_
	}, trackType, trackType === "rum" ? [`application.id=${replica.applicationId}`] : void 0);
}
/** Builds a Datadog intake URL from the given options. */
function buildEndpointUrl({ proxy, site = _intakeSites_mjs__WEBPACK_IMPORTED_MODULE_0__/* .INTAKE_SITE_US1 */ .D_, path, parameters = "", subdomain }) {
	let pathAndParameters = path;
	if (parameters) pathAndParameters += `?${parameters}`;
	if (typeof proxy === "string") {
		let url = `${(0,_util_urlPolyfill_mjs__WEBPACK_IMPORTED_MODULE_1__/* .normalizeUrl */ .D5)(proxy)}?ddforward=${encodeURIComponent(pathAndParameters)}`;
		if (subdomain) url += `&ddforwardSubdomain=${subdomain}`;
		return url;
	}
	if (typeof proxy === "function") return proxy({
		path,
		parameters,
		subdomain
	});
	const domainParts = site.split(".");
	const extension = domainParts.pop();
	let domain = `browser-intake-${domainParts.join("-")}.${extension}`;
	if (subdomain) domain = `${subdomain}.${domain}`;
	return `https://${domain}${pathAndParameters}`;
}
/**
* Build parameters to be used for an intake request. Parameters should be re-built for each
* request, as they change randomly.
*/
function buildEndpointParameters({ clientToken, source = "browser" }, trackType, api, { retry, encoding }, extraParameters = []) {
	const parameters = [
		`ddsource=${source}`,
		`dd-api-key=${clientToken}`,
		`dd-evp-origin-version=${encodeURIComponent("7.7.0")}`,
		"dd-evp-origin=browser",
		`dd-request-id=${generateUUID()}`
	].concat(extraParameters);
	if (encoding) parameters.push(`dd-evp-encoding=${encoding}`);
	if (trackType === "rum") {
		parameters.push(`batch_time=${(0,_entries_time_mjs__WEBPACK_IMPORTED_MODULE_2__/* .timeStampNow */ .n$)()}`, `_dd.api=${api}`);
		if (retry) parameters.push(`_dd.retry_count=${retry.count}`, `_dd.retry_after=${retry.lastFailureStatus}`);
	}
	return parameters.join("&");
}
/**
* UUID v4
* from https://gist.github.com/jed/982883
*/
function generateUUID(placeholder) {
	return placeholder ? (parseInt(placeholder, 10) ^ Math.random() * 16 >> parseInt(placeholder, 10) / 4).toString(16) : `10000000-1000-4000-8000-100000000000`.replace(/[018]/g, generateUUID);
}
//#endregion


//# sourceMappingURL=endpointBuilder.mjs.map

/***/ }),

/***/ 94174:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DZ": function() { return /* binding */ INTAKE_SITE_STAGING; },
/* harmony export */   "D_": function() { return /* binding */ INTAKE_SITE_US1; },
/* harmony export */   "Ds": function() { return /* binding */ INTAKE_SITE_EU1; },
/* harmony export */   "iU": function() { return /* binding */ isIntakeUrl; },
/* harmony export */   "tx": function() { return /* binding */ INTAKE_SITE_US2_FED; },
/* harmony export */   "y7": function() { return /* binding */ INTAKE_SITE_US1_FED; }
/* harmony export */ });
/* unused harmony export INTAKE_URL_PARAMETERS */
//#region src/transport/intakeSites.ts
/** Datadog staging environment (internal use). */
const INTAKE_SITE_STAGING = "datad0g.com";
/** Datadog US1 site (default). */
const INTAKE_SITE_US1 = "datadoghq.com";
/** Datadog EU1 site. */
const INTAKE_SITE_EU1 = "datadoghq.eu";
/** Datadog US1 FedRAMP site. */
const INTAKE_SITE_US1_FED = "ddog-gov.com";
/** Datadog US2 FedRAMP site. */
const INTAKE_SITE_US2_FED = "us2.ddog-gov.com";
/** URL query parameters that identify a Datadog intake request. */
const INTAKE_URL_PARAMETERS = [
	"ddsource",
	"dd-api-key",
	"dd-request-id"
];
/** Returns true if the URL targets a Datadog intake endpoint. */
function isIntakeUrl(url) {
	return INTAKE_URL_PARAMETERS.every((param) => url.includes(param));
}
//#endregion


//# sourceMappingURL=intakeSites.mjs.map

/***/ }),

/***/ 61846:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ getDebugMode; },
/* harmony export */   "y": function() { return /* binding */ setDebugMode; }
/* harmony export */ });
//#region src/util/debug.ts
let debugMode = false;
/**
* Enables or disables debug mode globally.
*
* Debug mode is a process-wide toggle that SDKs check (via {@link getDebugMode}) to decide whether
* to emit internal diagnostic logs to the console. It does not affect any data sent to Datadog.
*
* @param newDebugMode - `true` to enable debug mode, `false` to disable it.
*/
function setDebugMode(newDebugMode) {
	debugMode = newDebugMode;
}
/**
* Returns whether debug mode is currently enabled (see {@link setDebugMode}).
*
* @returns `true` when debug mode is on.
*/
function getDebugMode() {
	return debugMode;
}
//#endregion


//# sourceMappingURL=debug.mjs.map

/***/ }),

/***/ 95323:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IA": function() { return /* binding */ MORE_DETAILS; },
/* harmony export */   "aA": function() { return /* binding */ DOCS_ORIGIN; },
/* harmony export */   "fT": function() { return /* binding */ createDisplay; },
/* harmony export */   "jG": function() { return /* binding */ globalConsole; },
/* harmony export */   "vA": function() { return /* binding */ ConsoleApiName; }
/* harmony export */ });
/* unused harmony export originalConsoleMethods */
//#region src/util/display.ts
/** Base origin for Datadog documentation links referenced in display messages. */
const DOCS_ORIGIN = "https://docs.datadoghq.com";
/** Prefix used before a documentation link in a display message (e.g. `"${MORE_DETAILS} ${DOCS_ORIGIN}/..."`). */
const MORE_DETAILS = "More details:";
/** Names of the console methods wrapped by {@link Display}. */
const ConsoleApiName = {
	log: "log",
	debug: "debug",
	info: "info",
	warn: "warn",
	error: "error"
};
/**
* When building JS bundles, some users might use a plugin[1] or configuration[2] to remove
* "console.*" references. This causes some issue as we expect `console.*` to be defined.
* As a workaround, let's use a variable alias, so those expressions won't be taken into account by
* simple static analysis.
*
* [1]: https://babeljs.io/docs/babel-plugin-transform-remove-console/
* [2]: https://github.com/terser/terser#compress-options (look for drop_console)
*/
const globalConsole = console;
/**
* Keep references on console methods to avoid triggering patched behaviors
*
* NB: in some setup, console could already be patched by another SDK.
* In this case, some display messages can be sent by the other SDK
* but we should be safe from infinite loop nonetheless.
*/
const originalConsoleMethods = {
	log: globalConsole.log,
	debug: globalConsole.debug,
	info: globalConsole.info,
	warn: globalConsole.warn,
	error: globalConsole.error
};
/**
* Creates a {@link Display} bound to the original (unpatched) console methods, prefixing every
* message with the given prefix.
*
* Capturing the original console methods up front avoids triggering behaviors added by another SDK
* (or the host application) that may have patched `console.*` afterwards.
*
* @param prefix - String prepended to every logged message (e.g. to attribute output to an SDK).
* @returns A {@link Display} whose methods forward to the original console methods.
*/
function createDisplay(prefix) {
	return {
		debug: originalConsoleMethods.debug.bind(globalConsole, prefix),
		log: originalConsoleMethods.log.bind(globalConsole, prefix),
		info: originalConsoleMethods.info.bind(globalConsole, prefix),
		warn: originalConsoleMethods.warn.bind(globalConsole, prefix),
		error: originalConsoleMethods.error.bind(globalConsole, prefix)
	};
}
//#endregion


//# sourceMappingURL=display.mjs.map

/***/ }),

/***/ 35262:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ globalObject; },
/* harmony export */   "j": function() { return /* binding */ isWorkerEnvironment; }
/* harmony export */ });
//#region src/util/globalObject.ts
/** The global object for the current JS environment. */
const globalObject = globalThis;
/** True when the SDK is running inside a Web Worker. */
const isWorkerEnvironment = "WorkerGlobalScope" in globalObject;
//#endregion


//# sourceMappingURL=globalObject.mjs.map

/***/ }),

/***/ 91303:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ combine; },
/* harmony export */   "I8": function() { return /* binding */ deepClone; }
/* harmony export */ });
/* unused harmony export mergeInto */
/* harmony import */ var _typeUtils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45880);

//#region src/util/mergeInto.ts
/**
* Recursively merges `source` into `destination` in place and returns the result.
* - Objects are merged key by key.
* - Arrays are merged index by index.
* - Primitive and class-instance values replace the destination.
* - `undefined` source values leave the destination unchanged.
* - Circular references in `source` are silently dropped.
*
* Prefer `combine` for a non-mutating deep merge or `deepClone` for a simple deep copy.
*
* @returns The merged value — either `destination` (mutated) or `source` when they cannot be merged.
*/
function mergeInto(destination, source) {
	return mergeIntoInternal(destination, source, createCircularReferenceChecker());
}
function mergeIntoInternal(destination, source, circularReferenceChecker) {
	if (source === void 0) return destination;
	if (typeof source !== "object" || source === null) return source;
	else if (source instanceof Date) return new Date(source.getTime());
	else if (source instanceof RegExp) return new RegExp(source.source, source.flags);
	if (circularReferenceChecker.hasAlreadyBeenSeen(source)) return;
	else if (Array.isArray(source)) {
		const merged = Array.isArray(destination) ? destination : [];
		for (let i = 0; i < source.length; ++i) merged[i] = mergeIntoInternal(merged[i], source[i], circularReferenceChecker);
		return merged;
	}
	const merged = (0,_typeUtils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getType */ .oL)(destination) === "object" ? destination : {};
	for (const key in source) if (Object.prototype.hasOwnProperty.call(source, key) && key !== "__proto__") merged[key] = mergeIntoInternal(merged[key], source[key], circularReferenceChecker);
	return merged;
}
/**
* A simplistic implementation of a deep clone algorithm.
* Caveats:
* - It doesn't maintain prototype chains - don't use with instances of custom classes.
* - It doesn't handle Map and Set
*
* @returns A deep copy of `value` with the same type.
*/
function deepClone(value) {
	return mergeInto(void 0, value);
}
function combine(...sources) {
	let destination;
	for (const source of sources) {
		if (source === void 0 || source === null) continue;
		destination = mergeInto(destination, source);
	}
	return destination;
}
function createCircularReferenceChecker() {
	const set = /* @__PURE__ */ new WeakSet();
	return { hasAlreadyBeenSeen(value) {
		const has = set.has(value);
		if (!has) set.add(value);
		return has;
	} };
}
//#endregion


//# sourceMappingURL=mergeInto.mjs.map

/***/ }),

/***/ 45880:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isMatchOption; },
/* harmony export */   "oL": function() { return /* binding */ getType; },
/* harmony export */   "sK": function() { return /* binding */ isIndexableObject; },
/* harmony export */   "zz": function() { return /* binding */ isPercentage; }
/* harmony export */ });
//#region src/util/typeUtils.ts
/**
* Similar to `typeof`, but distinguish plain objects from `null` and arrays
*
* @returns `'null'` for `null`, `'array'` for arrays, or the result of `typeof` for everything else.
*/
function getType(value) {
	if (value === null) return "null";
	if (Array.isArray(value)) return "array";
	return typeof value;
}
/**
* Checks whether a value can have properties. Use this when you have an unknown value and you want
* to access its properties as unknown. This is a friendly solution for dealing with unknown objects
* in TypeScript.
*
* This function is intended to be used on values that will be used as "plain objects", i.e. not
* Array, Date, RegExp or other class instances. But it's safe to use on any value.
*
* @returns `true` if `value` is a non-null object that is not an array.
* @example
* ```
* // Before:
* if (typeof value === 'object' && value !== null && 'property' in value && typeof value.property === 'string') {
*   // use value.property
* }
* // After:
* if (isIndexableObject(value) && typeof value.property === 'string') {
*   // use value.property
* }
* ```
*/
function isIndexableObject(value) {
	return getType(value) === "object";
}
/**
* Checks whether `value` is a valid percentage: a number between 0 and 100 inclusive.
*/
function isPercentage(value) {
	return typeof value === "number" && value >= 0 && value <= 100;
}
/**
* Checks whether `value` can be used to match against a string: a string, a RegExp, or a
* predicate function.
*/
function isMatchOption(value) {
	return typeof value === "string" || value instanceof RegExp || typeof value === "function";
}
//#endregion


//# sourceMappingURL=typeUtils.mjs.map

/***/ }),

/***/ 56140:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D5": function() { return /* binding */ normalizeUrl; },
/* harmony export */   "Q2": function() { return /* binding */ buildUrl; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "ye": function() { return /* binding */ getPathName; }
/* harmony export */ });
/* unused harmony export getPristineWindow */
/* harmony import */ var _globalObject_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35262);

//#region src/util/urlPolyfill.ts
/** Resolves a URL against the current page location, returning a normalized absolute URL string. */
function normalizeUrl(url) {
	return buildUrl(url, _globalObject_mjs__WEBPACK_IMPORTED_MODULE_0__/* .globalObject.location */ .Z.location?.href).href;
}
/** Returns true if the given string is a valid URL. */
function isValidUrl(url) {
	try {
		return !!buildUrl(url);
	} catch {
		return false;
	}
}
/** Extracts the pathname from a URL, ensuring it starts with `/`. */
function getPathName(url) {
	const pathname = buildUrl(url).pathname;
	return pathname[0] === "/" ? pathname : `/${pathname}`;
}
/** Constructs a URL object, using the native URL constructor from a pristine iframe to avoid polyfill interference. */
function buildUrl(url, base) {
	const { URL } = getPristineWindow();
	try {
		return base !== void 0 ? new URL(url, base) : new URL(url);
	} catch (error) {
		throw new Error(`Failed to construct URL: ${String(error)}`);
	}
}
let getPristineGlobalObjectCache;
/**
* Returns a `{ URL }` object sourced from a pristine iframe, bypassing any patched URL constructor.
* Falls back to the current global if iframe creation fails.
*/
function getPristineWindow() {
	if (!getPristineGlobalObjectCache) {
		let iframe;
		let pristineWindow;
		try {
			iframe = document.createElement("iframe");
			iframe.style.display = "none";
			document.body.appendChild(iframe);
			pristineWindow = iframe.contentWindow ?? _globalObject_mjs__WEBPACK_IMPORTED_MODULE_0__/* .globalObject */ .Z;
		} catch {
			pristineWindow = _globalObject_mjs__WEBPACK_IMPORTED_MODULE_0__/* .globalObject */ .Z;
		}
		getPristineGlobalObjectCache = { URL: pristineWindow.URL };
		iframe?.remove();
	}
	return getPristineGlobalObjectCache;
}
//#endregion


//# sourceMappingURL=urlPolyfill.mjs.map

/***/ }),

/***/ 59108:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v4": function() { return /* binding */ v4; }
/* harmony export */ });
var IDX=256, HEX=[], BUFFER;
while (IDX--) HEX[IDX] = (IDX + 256).toString(16).substring(1);

function v4() {
	var i=0, num, out='';

	if (!BUFFER || ((IDX + 16) > 256)) {
		BUFFER = Array(i=256);
		while (i--) BUFFER[i] = 256 * Math.random() | 0;
		i = IDX = 0;
	}

	for (; i < 16; i++) {
		num = BUFFER[IDX + i];
		if (i==6) out += HEX[num & 15 | 64];
		else if (i==8) out += HEX[num & 63 | 128];
		else out += HEX[num];

		if (i & 1 && i > 1 && i < 11) out += '-';
	}

	IDX++;
	return out;
}


/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 51438:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 15761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);



class FocusManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onFocus => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onFocus(); // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }

      return;
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(focused => {
      if (typeof focused === 'boolean') {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }

  setFocused(focused) {
    const changed = this.focused !== focused;

    if (changed) {
      this.focused = focused;
      this.onFocus();
    }
  }

  onFocus() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }

  isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  }

}
const focusManager = new FocusManager();


//# sourceMappingURL=focusManager.mjs.map


/***/ }),

/***/ 9499:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gm": function() { return /* binding */ infiniteQueryBehavior; },
/* harmony export */   "Qy": function() { return /* binding */ hasNextPage; },
/* harmony export */   "ZF": function() { return /* binding */ hasPreviousPage; }
/* harmony export */ });
/* unused harmony exports getNextPageParam, getPreviousPageParam */
function infiniteQueryBehavior() {
  return {
    onFetch: context => {
      context.fetchFn = () => {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        let newPageParams = oldPageParams;
        let cancelled = false;

        const addSignalProperty = object => {
          Object.defineProperty(object, 'signal', {
            enumerable: true,
            get: () => {
              var _context$signal;

              if ((_context$signal = context.signal) != null && _context$signal.aborted) {
                cancelled = true;
              } else {
                var _context$signal2;

                (_context$signal2 = context.signal) == null ? void 0 : _context$signal2.addEventListener('abort', () => {
                  cancelled = true;
                });
              }

              return context.signal;
            }
          });
        }; // Get query function


        const queryFn = context.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));

        const buildNewPages = (pages, param, page, previous) => {
          newPageParams = previous ? [param, ...newPageParams] : [...newPageParams, param];
          return previous ? [page, ...pages] : [...pages, page];
        }; // Create function to fetch a page


        const fetchPage = (pages, manual, param, previous) => {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          const queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param,
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const queryFnResult = queryFn(queryFnContext);
          const promise = Promise.resolve(queryFnResult).then(page => buildNewPages(pages, param, page, previous));
          return promise;
        };

        let promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param, true);
        } // Refetch pages
        else {
          newPageParams = [];
          const manual = typeof context.options.getNextPageParam === 'undefined';
          const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

          promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

          for (let i = 1; i < oldPages.length; i++) {
            promise = promise.then(pages => {
              const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

              if (shouldFetchNextPage) {
                const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                return fetchPage(pages, manual, param);
              }

              return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
            });
          }
        }

        const finalPromise = promise.then(pages => ({
          pages,
          pageParams: newPageParams
        }));
        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    const nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }

  return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    const previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }

  return;
}


//# sourceMappingURL=infiniteQueryBehavior.mjs.map


/***/ }),

/***/ 30819:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ defaultLogger; }
/* harmony export */ });
const defaultLogger = console;


//# sourceMappingURL=logger.mjs.map


/***/ }),

/***/ 89886:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _logger_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30819);
/* harmony import */ var _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30081);
/* harmony import */ var _removable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89643);
/* harmony import */ var _retryer_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72379);





// CLASS
class Mutation extends _removable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Removable */ .F {
  constructor(config) {
    super();
    this.defaultOptions = config.defaultOptions;
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.logger = config.logger || _logger_mjs__WEBPACK_IMPORTED_MODULE_1__/* .defaultLogger */ ._;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.setOptions(config.options);
    this.scheduleGc();
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  get meta() {
    return this.options.meta;
  }

  setState(state) {
    this.dispatch({
      type: 'setState',
      state
    });
  }

  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer); // Stop the mutation from being garbage collected

      this.clearGcTimeout();
      this.mutationCache.notify({
        type: 'observerAdded',
        mutation: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    this.observers = this.observers.filter(x => x !== observer);
    this.scheduleGc();
    this.mutationCache.notify({
      type: 'observerRemoved',
      mutation: this,
      observer
    });
  }

  optionalRemove() {
    if (!this.observers.length) {
      if (this.state.status === 'loading') {
        this.scheduleGc();
      } else {
        this.mutationCache.remove(this);
      }
    }
  }

  continue() {
    var _this$retryer$continu, _this$retryer;

    return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
  }

  async execute() {
    const executeMutation = () => {
      var _this$options$retry;

      this.retryer = (0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .createRetryer */ .Mz)({
        fn: () => {
          if (!this.options.mutationFn) {
            return Promise.reject('No mutationFn found');
          }

          return this.options.mutationFn(this.state.variables);
        },
        onFail: (failureCount, error) => {
          this.dispatch({
            type: 'failed',
            failureCount,
            error
          });
        },
        onPause: () => {
          this.dispatch({
            type: 'pause'
          });
        },
        onContinue: () => {
          this.dispatch({
            type: 'continue'
          });
        },
        retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      });
      return this.retryer.promise;
    };

    const restored = this.state.status === 'loading';

    try {
      var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;

      if (!restored) {
        var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;

        this.dispatch({
          type: 'loading',
          variables: this.options.variables
        }); // Notify cache callback

        await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));

        if (context !== this.state.context) {
          this.dispatch({
            type: 'loading',
            context,
            variables: this.state.variables
          });
        }
      }

      const data = await executeMutation(); // Notify cache callback

      await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback

      await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
      this.dispatch({
        type: 'success',
        data
      });
      return data;
    } catch (error) {
      try {
        var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;

        // Notify cache callback
        await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));

        if (false) {}

        await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback

        await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
        throw error;
      } finally {
        this.dispatch({
          type: 'error',
          error: error
        });
      }
    }
  }

  dispatch(action) {
    const reducer = state => {
      switch (action.type) {
        case 'failed':
          return { ...state,
            failureCount: action.failureCount,
            failureReason: action.error
          };

        case 'pause':
          return { ...state,
            isPaused: true
          };

        case 'continue':
          return { ...state,
            isPaused: false
          };

        case 'loading':
          return { ...state,
            context: action.context,
            data: undefined,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !(0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .canFetch */ .Kw)(this.options.networkMode),
            status: 'loading',
            variables: action.variables
          };

        case 'success':
          return { ...state,
            data: action.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: 'success',
            isPaused: false
          };

        case 'error':
          return { ...state,
            data: undefined,
            error: action.error,
            failureCount: state.failureCount + 1,
            failureReason: action.error,
            isPaused: false,
            status: 'error'
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__/* .notifyManager.batch */ .V.batch(() => {
      this.observers.forEach(observer => {
        observer.onMutationUpdate(action);
      });
      this.mutationCache.notify({
        mutation: this,
        type: 'updated',
        action
      });
    });
  }

}
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}


//# sourceMappingURL=mutation.mjs.map


/***/ }),

/***/ 30081:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export createNotifyManager */
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);


function createNotifyManager() {
  let queue = [];
  let transactions = 0;

  let notifyFn = callback => {
    callback();
  };

  let batchNotifyFn = callback => {
    callback();
  };

  const batch = callback => {
    let result;
    transactions++;

    try {
      result = callback();
    } finally {
      transactions--;

      if (!transactions) {
        flush();
      }
    }

    return result;
  };

  const schedule = callback => {
    if (transactions) {
      queue.push(callback);
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        notifyFn(callback);
      });
    }
  };
  /**
   * All calls to the wrapped function will be batched.
   */


  const batchCalls = callback => {
    return (...args) => {
      schedule(() => {
        callback(...args);
      });
    };
  };

  const flush = () => {
    const originalQueue = queue;
    queue = [];

    if (originalQueue.length) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        batchNotifyFn(() => {
          originalQueue.forEach(callback => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */


  const setNotifyFunction = fn => {
    notifyFn = fn;
  };
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */


  const setBatchNotifyFunction = fn => {
    batchNotifyFn = fn;
  };

  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction,
    setBatchNotifyFunction
  };
} // SINGLETON

const notifyManager = createNotifyManager();


//# sourceMappingURL=notifyManager.mjs.map


/***/ }),

/***/ 96474:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33989);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32161);



const onlineEvents = ['online', 'offline'];
class OnlineManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onOnline => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onOnline(); // Listen to online


        onlineEvents.forEach(event => {
          window.addEventListener(event, listener, false);
        });
        return () => {
          // Be sure to unsubscribe if a new handler is set
          onlineEvents.forEach(event => {
            window.removeEventListener(event, listener);
          });
        };
      }

      return;
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(online => {
      if (typeof online === 'boolean') {
        this.setOnline(online);
      } else {
        this.onOnline();
      }
    });
  }

  setOnline(online) {
    const changed = this.online !== online;

    if (changed) {
      this.online = online;
      this.onOnline();
    }
  }

  onOnline() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }

  isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  }

}
const onlineManager = new OnlineManager();


//# sourceMappingURL=onlineManager.mjs.map


/***/ }),

/***/ 89643:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Removable; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32161);


class Removable {
  destroy() {
    this.clearGcTimeout();
  }

  scheduleGc() {
    this.clearGcTimeout();

    if ((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isValidTimeout */ .PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(() => {
        this.optionalRemove();
      }, this.cacheTime);
    }
  }

  updateCacheTime(newCacheTime) {
    // Default to 5 minutes (Infinity for server-side) if no cache time is set
    this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : _utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk ? Infinity : 5 * 60 * 1000);
  }

  clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  }

}


//# sourceMappingURL=removable.mjs.map


/***/ }),

/***/ 72379:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "Kw": function() { return /* binding */ canFetch; },
/* harmony export */   "Mz": function() { return /* binding */ createRetryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15761);
/* harmony import */ var _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96474);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32161);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * 2 ** failureCount, 30000);
}

function canFetch(networkMode) {
  return (networkMode != null ? networkMode : 'online') === 'online' ? _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline() : true;
}
class CancelledError {
  constructor(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }

}
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  let promiseResolve;
  let promiseReject;
  const promise = new Promise((outerResolve, outerReject) => {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  const cancel = cancelOptions => {
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      config.abort == null ? void 0 : config.abort();
    }
  };

  const cancelRetry = () => {
    isRetryCancelled = true;
  };

  const continueRetry = () => {
    isRetryCancelled = false;
  };

  const shouldPause = () => !_focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || config.networkMode !== 'always' && !_onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline();

  const resolve = value => {
    if (!isResolved) {
      isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  const reject = value => {
    if (!isResolved) {
      isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  const pause = () => {
    return new Promise(continueResolve => {
      continueFn = value => {
        const canContinue = isResolved || !shouldPause();

        if (canContinue) {
          continueResolve(value);
        }

        return canContinue;
      };

      config.onPause == null ? void 0 : config.onPause();
    }).then(() => {
      continueFn = undefined;

      if (!isResolved) {
        config.onContinue == null ? void 0 : config.onContinue();
      }
    });
  }; // Create loop function


  const run = () => {
    // Do nothing if already resolved
    if (isResolved) {
      return;
    }

    let promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }

    Promise.resolve(promiseOrValue).then(resolve).catch(error => {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (isResolved) {
        return;
      } // Do we need to retry the request?


      const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);

      if (isRetryCancelled || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(failureCount, error); // Delay

      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(() => {
        if (shouldPause()) {
          return pause();
        }

        return;
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  if (canFetch(config.networkMode)) {
    run();
  } else {
    pause().then(run);
  }

  return {
    promise,
    cancel,
    continue: () => {
      const didContinue = continueFn == null ? void 0 : continueFn();
      return didContinue ? promise : Promise.resolve();
    },
    cancelRetry,
    continueRetry
  };
}


//# sourceMappingURL=retryer.mjs.map


/***/ }),

/***/ 33989:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
class Subscribable {
  constructor() {
    this.listeners = new Set();
    this.subscribe = this.subscribe.bind(this);
  }

  subscribe(listener) {
    const identity = {
      listener
    };
    this.listeners.add(identity);
    this.onSubscribe();
    return () => {
      this.listeners.delete(identity);
      this.onUnsubscribe();
    };
  }

  hasListeners() {
    return this.listeners.size > 0;
  }

  onSubscribe() {// Do nothing
  }

  onUnsubscribe() {// Do nothing
  }

}


//# sourceMappingURL=subscribable.mjs.map


/***/ }),

/***/ 32161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "oE": function() { return /* binding */ replaceData; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, isError, isPlainArray, isPlainObject, isQueryKey, parseMutationFilterArgs, partialDeepEqual, replaceAt, replaceEqualDeep */
// TYPES
// UTILS
const isServer = typeof window === 'undefined' || 'Deno' in window;
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
  return array1.filter(x => !array2.includes(x));
}
function replaceAt(array, index, value) {
  const copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return { ...arg3,
      queryKey: arg1,
      queryFn: arg2
    };
  }

  return { ...arg2,
    queryKey: arg1
  };
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return { ...arg3,
        mutationKey: arg1,
        mutationFn: arg2
      };
    }

    return { ...arg2,
      mutationKey: arg1
    };
  }

  if (typeof arg1 === 'function') {
    return { ...arg2,
      mutationFn: arg1
    };
  }

  return { ...arg1
  };
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    queryKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    mutationKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function matchQuery(filters, query) {
  const {
    type = 'all',
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  if (type !== 'all') {
    const isActive = query.isActive();

    if (type === 'active' && !isActive) {
      return false;
    }

    if (type === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  const {
    exact,
    fetching,
    predicate,
    mutationKey
  } = filters;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */

function hashQueryKey(queryKey) {
  return JSON.stringify(queryKey, (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
    result[key] = val[key];
    return result;
  }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(key => !partialDeepEqual(a[key], b[key]));
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b, depth = 0) {
  if (a === b) {
    return a;
  }

  if (depth > 500) return b;
  const array = isPlainArray(a) && isPlainArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aSize = array ? a.length : Object.keys(a).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;

    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key], depth + 1);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  const ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  const prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  sleep(0).then(callback);
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }

  return;
}
function replaceData(prevData, data, options) {
  // Use prev data if an isDataEqual function is defined and returns `true`
  if (options.isDataEqual != null && options.isDataEqual(prevData, data)) {
    return prevData;
  } else if (typeof options.structuralSharing === 'function') {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
  }

  return data;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 85945:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NL": function() { return /* binding */ useQueryClient; },
/* harmony export */   "aH": function() { return /* binding */ QueryClientProvider; }
/* harmony export */ });
/* unused harmony export defaultContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
'use client';


const defaultContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(context, contextSharing) {
  if (context) {
    return context;
  }

  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

const useQueryClient = ({
  context
} = {}) => {
  const queryClient = react__WEBPACK_IMPORTED_MODULE_0__.useContext(getQueryClientContext(context, react__WEBPACK_IMPORTED_MODULE_0__.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
const QueryClientProvider = ({
  client,
  children,
  context,
  contextSharing = false
}) => {
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    client.mount();
    return () => {
      client.unmount();
    };
  }, [client]);

  if (false) {}

  const Context = getQueryClientContext(context, contextSharing);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(QueryClientSharingContext.Provider, {
    value: !context && contextSharing
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
    value: client
  }, children));
};


//# sourceMappingURL=QueryClientProvider.mjs.map


/***/ }),

/***/ 92729:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lib_axios; }
});

// NAMESPACE OBJECT: ./node_modules/axios/lib/platform/common/utils.js
var common_utils_namespaceObject = {};
__webpack_require__.r(common_utils_namespaceObject);
__webpack_require__.d(common_utils_namespaceObject, {
  "hasBrowserEnv": function() { return hasBrowserEnv; },
  "hasStandardBrowserEnv": function() { return hasStandardBrowserEnv; },
  "hasStandardBrowserWebWorkerEnv": function() { return hasStandardBrowserWebWorkerEnv; },
  "navigator": function() { return _navigator; },
  "origin": function() { return origin; }
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/bind.js


/**
 * Create a bound version of a function with a specified `this` context
 *
 * @param {Function} fn - The function to bind
 * @param {*} thisArg - The value to be passed as the `this` parameter
 * @returns {Function} A new function that will call the original function with the specified `this` context
 */
function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/utils.js
/* provided dependency */ var process = __webpack_require__(83454);




// utils is a library of generic helper functions non-specific to axios

const { toString: utils_toString } = Object.prototype;
const { getPrototypeOf } = Object;
const { iterator, toStringTag } = Symbol;

const kindOf = ((cache) => (thing) => {
  const str = utils_toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type;
};

const typeOfTest = (type) => (thing) => typeof thing === type;

/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const { isArray } = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return (
    val !== null &&
    !isUndefined(val) &&
    val.constructor !== null &&
    !isUndefined(val.constructor) &&
    isFunction(val.constructor.isBuffer) &&
    val.constructor.isBuffer(val)
  );
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = (thing) => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (
    (prototype === null ||
      prototype === Object.prototype ||
      Object.getPrototypeOf(prototype) === null) &&
    !(toStringTag in val) &&
    !(iterator in val)
  );
};

/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */
const isEmptyObject = (val) => {
  // Early return for non-objects or Buffers to prevent RangeError
  if (!isObject(val) || isBuffer(val)) {
    return false;
  }

  try {
    return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
  } catch (e) {
    // Fallback for any other objects that might cause RangeError with Object.keys()
    return false;
  }
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */
const isReactNativeBlob = (value) => {
  return !!(value && typeof value.uri !== 'undefined');
};

/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */
const isReactNative = (formData) => formData && typeof formData.getParts !== 'undefined';

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function getGlobal() {
  if (typeof globalThis !== 'undefined') return globalThis;
  if (typeof self !== 'undefined') return self;
  if (typeof window !== 'undefined') return window;
  if (typeof global !== 'undefined') return global;
  return {};
}

const G = getGlobal();
const FormDataCtor = typeof G.FormData !== 'undefined' ? G.FormData : undefined;

const isFormData = (thing) => {
  if (!thing) return false;
  if (FormDataCtor && thing instanceof FormDataCtor) return true;
  // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
  const proto = getPrototypeOf(thing);
  if (!proto || proto === Object.prototype) return false;
  if (!isFunction(thing.append)) return false;
  const kind = kindOf(thing);
  return (
    kind === 'formdata' ||
    // detect form-data instance
    (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
  );
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = [
  'ReadableStream',
  'Request',
  'Response',
  'Headers',
].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => {
  return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, { allOwnKeys = false } = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Buffer check
    if (isBuffer(obj)) {
      return;
    }

    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */
function findKey(obj, key) {
  if (isBuffer(obj)) {
    return null;
  }

  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== 'undefined') return globalThis;
  return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : global;
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(...objs) {
  const { caseless, skipUndefined } = (isContextDefined(this) && this) || {};
  const result = {};
  const assignValue = (val, key) => {
    // Skip dangerous property names to prevent prototype pollution
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return;
    }

    // findKey lowercases the key, so caseless lookup only applies to strings —
    // symbol keys are identity-matched.
    const targetKey = (caseless && typeof key === 'string' && findKey(result, key)) || key;
    // Read via own-prop only — a bare `result[targetKey]` walks the prototype
    // chain, so a polluted Object.prototype value could surface here and get
    // copied into the merged result.
    const existing = utils_hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
    if (isPlainObject(existing) && isPlainObject(val)) {
      result[targetKey] = merge(existing, val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else if (!skipUndefined || !isUndefined(val)) {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = objs.length; i < l; i++) {
    const source = objs[i];
    if (!source || isBuffer(source)) {
      continue;
    }

    forEach(source, assignValue);

    if (typeof source !== 'object' || isArray(source)) {
      continue;
    }

    const symbols = Object.getOwnPropertySymbols(source);
    for (let j = 0; j < symbols.length; j++) {
      const symbol = symbols[j];
      if (propertyIsEnumerable.call(source, symbol)) {
        assignValue(source[symbol], symbol);
      }
    }
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, { allOwnKeys } = {}) => {
  forEach(
    b,
    (val, key) => {
      if (thisArg && isFunction(val)) {
        Object.defineProperty(a, key, {
          // Null-proto descriptor so a polluted Object.prototype.get cannot
          // hijack defineProperty's accessor-vs-data resolution.
          __proto__: null,
          value: bind(val, thisArg),
          writable: true,
          enumerable: true,
          configurable: true,
        });
      } else {
        Object.defineProperty(a, key, {
          __proto__: null,
          value: val,
          writable: true,
          enumerable: true,
          configurable: true,
        });
      }
    },
    { allOwnKeys }
  );
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xfeff) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  Object.defineProperty(constructor.prototype, 'constructor', {
    __proto__: null,
    value: constructor,
    writable: true,
    enumerable: false,
    configurable: true,
  });
  Object.defineProperty(constructor, 'super', {
    __proto__: null,
    value: superConstructor.prototype,
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};

/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = ((TypedArray) => {
  // eslint-disable-next-line func-names
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[iterator];

  const _iterator = generator.call(obj);

  let result;

  while ((result = _iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = (str) => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
    return p1.toUpperCase() + p2;
  });
};

/* Creating a function that will check if an object has a property. */
const utils_hasOwnProperty = (
  ({ hasOwnProperty }) =>
  (obj, prop) =>
    hasOwnProperty.call(obj, prop)
)(Object.prototype);

const { propertyIsEnumerable } = Object.prototype;

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].includes(name)) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      };
    }
  });
};

/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop = () => {};

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite((value = +value)) ? value : defaultValue;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(
    thing &&
    isFunction(thing.append) &&
    thing[toStringTag] === 'FormData' &&
    thing[iterator]
  );
}

/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */
const toJSONObject = (obj) => {
  const visited = new WeakSet();

  const visit = (source) => {
    if (isObject(source)) {
      if (visited.has(source)) {
        return;
      }

      //Buffer check
      if (isBuffer(source)) {
        return source;
      }

      if (!('toJSON' in source)) {
        // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
        visited.add(source);
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        visited.delete(source);

        return target;
      }
    }

    return source;
  };

  return visit(obj);
};

/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */
const isAsyncFn = kindOfTest('AsyncFunction');

/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */
const isThenable = (thing) =>
  thing &&
  (isObject(thing) || isFunction(thing)) &&
  isFunction(thing.then) &&
  isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported
    ? ((token, callbacks) => {
        _global.addEventListener(
          'message',
          ({ source, data }) => {
            if (source === _global && data === token) {
              callbacks.length && callbacks.shift()();
            }
          },
          false
        );

        return (cb) => {
          callbacks.push(cb);
          _global.postMessage(token, '*');
        };
      })(`axios@${Math.random()}`, [])
    : (cb) => setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));

/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */
const asap =
  typeof queueMicrotask !== 'undefined'
    ? queueMicrotask.bind(_global)
    : (typeof process !== 'undefined' && process.nextTick) || _setImmediate;

// *********************

const isIterable = (thing) => thing != null && isFunction(thing[iterator]);

/* harmony default export */ var utils = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isEmptyObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isReactNativeBlob,
  isReactNative,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty: utils_hasOwnProperty,
  hasOwnProp: utils_hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap,
  isIterable,
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseHeaders.js




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils.toObjectSet([
  'age',
  'authorization',
  'content-length',
  'content-type',
  'etag',
  'expires',
  'from',
  'host',
  'if-modified-since',
  'if-unmodified-since',
  'last-modified',
  'location',
  'max-forwards',
  'proxy-authorization',
  'referer',
  'retry-after',
  'user-agent',
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ var parseHeaders = ((rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders &&
    rawHeaders.split('\n').forEach(function parser(line) {
      i = line.indexOf(':');
      key = line.substring(0, i).trim().toLowerCase();
      val = line.substring(i + 1).trim();

      if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
        return;
      }

      if (key === 'set-cookie') {
        if (parsed[key]) {
          parsed[key].push(val);
        } else {
          parsed[key] = [val];
        }
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    });

  return parsed;
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/sanitizeHeaderValue.js




function trimSPorHTAB(str) {
  let start = 0;
  let end = str.length;

  while (start < end) {
    const code = str.charCodeAt(start);

    if (code !== 0x09 && code !== 0x20) {
      break;
    }

    start += 1;
  }

  while (end > start) {
    const code = str.charCodeAt(end - 1);

    if (code !== 0x09 && code !== 0x20) {
      break;
    }

    end -= 1;
  }

  return start === 0 && end === str.length ? str : str.slice(start, end);
}

// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');

function sanitizeValue(value, invalidChars) {
  if (utils.isArray(value)) {
    return value.map((item) => sanitizeValue(item, invalidChars));
  }

  return trimSPorHTAB(String(value).replace(invalidChars, ''));
}

const sanitizeHeaderValue = (value) =>
  sanitizeValue(value, INVALID_UNICODE_HEADER_VALUE_CHARS);

const sanitizeByteStringHeaderValue = (value) =>
  sanitizeValue(value, INVALID_BYTE_STRING_HEADER_VALUE_CHARS);

function toByteStringHeaderObject(headers) {
  const byteStringHeaders = Object.create(null);

  utils.forEach(headers.toJSON(), (value, header) => {
    byteStringHeaders[header] = sanitizeByteStringHeaderValue(value);
  });

  return byteStringHeaders;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosHeaders.js






const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils.isArray(value) ? value.map(normalizeValue) : sanitizeHeaderValue(String(value));
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils.isString(value)) return;

  if (utils.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header
    .trim()
    .toLowerCase()
    .replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function (arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true,
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        return;
      }

      const key = utils.findKey(self, lHeader);

      if (
        !key ||
        self[key] === undefined ||
        _rewrite === true ||
        (_rewrite === undefined && self[key] !== false)
      ) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils.isObject(header) && utils.isIterable(header)) {
      let obj = {},
        dest,
        key;
      for (const entry of header) {
        if (!utils.isArray(entry)) {
          throw new TypeError('Object iterator must return a key-value pair');
        }

        obj[(key = entry[0])] = (dest = obj[key])
          ? utils.isArray(dest)
            ? [...dest, entry[1]]
            : [dest, entry[1]]
          : entry[1];
      }

      setHeaders(obj, valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils.findKey(this, header);

      return !!(
        key &&
        this[key] !== undefined &&
        (!matcher || matchHeaderValue(this, this[key], key, matcher))
      );
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils.forEach(this, (value, header) => {
      const key = utils.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils.forEach(this, (value, header) => {
      value != null &&
        value !== false &&
        (obj[header] = asStrings && utils.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON())
      .map(([header, value]) => header + ': ' + value)
      .join('\n');
  }

  getSetCookie() {
    return this.get('set-cookie') || [];
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals =
      (this[$internals] =
      this[$internals] =
        {
          accessors: {},
        });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor([
  'Content-Type',
  'Content-Length',
  'Accept',
  'Accept-Encoding',
  'User-Agent',
  'Authorization',
]);

// reserved names hotfix
utils.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    },
  };
});

utils.freezeMethods(AxiosHeaders);

/* harmony default export */ var core_AxiosHeaders = (AxiosHeaders);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/AxiosError.js





const REDACTED = '[REDACTED ****]';

function hasOwnOrPrototypeToJSON(source) {
  if (utils.hasOwnProp(source, 'toJSON')) {
    return true;
  }

  let prototype = Object.getPrototypeOf(source);

  while (prototype && prototype !== Object.prototype) {
    if (utils.hasOwnProp(prototype, 'toJSON')) {
      return true;
    }

    prototype = Object.getPrototypeOf(prototype);
  }

  return false;
}

// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function redactConfig(config, redactKeys) {
  const lowerKeys = new Set(redactKeys.map((k) => String(k).toLowerCase()));
  const seen = [];

  const visit = (source) => {
    if (source === null || typeof source !== 'object') return source;
    if (utils.isBuffer(source)) return source;
    if (seen.indexOf(source) !== -1) return undefined;

    if (source instanceof core_AxiosHeaders) {
      source = source.toJSON();
    }

    seen.push(source);

    let result;
    if (utils.isArray(source)) {
      result = [];
      source.forEach((v, i) => {
        const reducedValue = visit(v);
        if (!utils.isUndefined(reducedValue)) {
          result[i] = reducedValue;
        }
      });
    } else {
      if (!utils.isPlainObject(source) && hasOwnOrPrototypeToJSON(source)) {
        seen.pop();
        return source;
      }

      result = Object.create(null);
      for (const [key, value] of Object.entries(source)) {
        const reducedValue = lowerKeys.has(key.toLowerCase()) ? REDACTED : visit(value);
        if (!utils.isUndefined(reducedValue)) {
          result[key] = reducedValue;
        }
      }
    }

    seen.pop();
    return result;
  };

  return visit(config);
}

class AxiosError extends Error {
  static from(error, code, config, request, response, customProps) {
    const axiosError = new AxiosError(error.message, code || error.code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;

    // Preserve status from the original error if not already set from response
    if (error.status != null && axiosError.status == null) {
      axiosError.status = error.status;
    }

    customProps && Object.assign(axiosError, customProps);
    return axiosError;
  }

  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(message, code, config, request, response) {
    super(message);

    // Make message enumerable to maintain backward compatibility
    // The native Error constructor sets message as non-enumerable,
    // but axios < v1.13.3 had it as enumerable
    Object.defineProperty(this, 'message', {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: message,
      enumerable: true,
      writable: true,
      configurable: true,
    });

    this.name = 'AxiosError';
    this.isAxiosError = true;
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
      this.response = response;
      this.status = response.status;
    }
  }

  toJSON() {
    // Opt-in redaction: when the request config carries a `redact` array, the
    // value of any matching key (case-insensitive, at any depth) is replaced
    // with REDACTED in the serialized snapshot. Undefined or empty leaves the
    // existing serialization behavior unchanged.
    const config = this.config;
    const redactKeys = config && utils.hasOwnProp(config, 'redact') ? config.redact : undefined;
    const serializedConfig =
      utils.isArray(redactKeys) && redactKeys.length > 0
        ? redactConfig(config, redactKeys)
        : utils.toJSONObject(config);

    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: serializedConfig,
      code: this.code,
      status: this.status,
    };
  }
}

// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
AxiosError.ECONNABORTED = 'ECONNABORTED';
AxiosError.ETIMEDOUT = 'ETIMEDOUT';
AxiosError.ECONNREFUSED = 'ECONNREFUSED';
AxiosError.ERR_NETWORK = 'ERR_NETWORK';
AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
AxiosError.ERR_CANCELED = 'ERR_CANCELED';
AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';

/* harmony default export */ var core_AxiosError = (AxiosError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/null.js
// eslint-disable-next-line strict
/* harmony default export */ var helpers_null = (null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toFormData.js
/* provided dependency */ var Buffer = __webpack_require__(48764)["lW"];




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils.isPlainObject(thing) || utils.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path
    .concat(key)
    .map(function each(token, i) {
      // eslint-disable-next-line no-param-reassign
      token = removeBrackets(token);
      return !dots && i ? '[' + token + ']' : token;
    })
    .join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils.toFlatObject(utils, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (helpers_null || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils.toFlatObject(
    options,
    {
      metaTokens: true,
      dots: false,
      indexes: false,
    },
    false,
    function defined(option, source) {
      // eslint-disable-next-line no-eq-null,eqeqeq
      return !utils.isUndefined(source[option]);
    }
  );

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || (typeof Blob !== 'undefined' && Blob);
  const maxDepth = options.maxDepth === undefined ? 100 : options.maxDepth;
  const useBlob = _Blob && utils.isSpecCompliantForm(formData);

  if (!utils.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isBoolean(value)) {
      return value.toString();
    }

    if (!useBlob && utils.isBlob(value)) {
      throw new core_AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (utils.isReactNative(formData) && utils.isReactNativeBlob(value)) {
      formData.append(renderKey(path, key, dots), convertValue(value));
      return false;
    }

    if (value && !path && typeof value === 'object') {
      if (utils.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils.isArray(value) && isFlatArray(value)) ||
        ((utils.isFileList(value) || utils.endsWith(key, '[]')) && (arr = utils.toArray(value)))
      ) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils.isUndefined(el) || el === null) &&
            formData.append(
              // eslint-disable-next-line no-nested-ternary
              indexes === true
                ? renderKey([key], index, dots)
                : indexes === null
                  ? key
                  : key + '[]',
              convertValue(el)
            );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable,
  });

  function build(value, path, depth = 0) {
    if (utils.isUndefined(value)) return;

    if (depth > maxDepth) {
      throw new core_AxiosError(
        'Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth,
        core_AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
    }

    if (stack.indexOf(value) !== -1) {
      throw new Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils.forEach(value, function each(el, key) {
      const result =
        !(utils.isUndefined(el) || el === null) &&
        visitor.call(formData, el, utils.isString(key) ? key.trim() : key, path, exposedHelpers);

      if (result === true) {
        build(el, path ? path.concat(key) : [key], depth + 1);
      }
    });

    stack.pop();
  }

  if (!utils.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ var helpers_toFormData = (toFormData);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/AxiosURLSearchParams.js




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && helpers_toFormData(params, this, options);
}

const AxiosURLSearchParams_prototype = AxiosURLSearchParams.prototype;

AxiosURLSearchParams_prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

AxiosURLSearchParams_prototype.toString = function toString(encoder) {
  const _encode = encoder
    ? function (value) {
        return encoder.call(this, value, encode);
      }
    : encode;

  return this._pairs
    .map(function each(pair) {
      return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '')
    .join('&');
};

/* harmony default export */ var helpers_AxiosURLSearchParams = (AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/buildURL.js





/**
 * It replaces URL-encoded forms of `:`, `$`, `,`, and spaces with
 * their plain counterparts (`:`, `$`, `,`, `+`).
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function buildURL_encode(val) {
  return encodeURIComponent(val)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  if (!params) {
    return url;
  }

  const _encode = (options && options.encode) || buildURL_encode;

  const _options = utils.isFunction(options)
    ? {
        serialize: options,
      }
    : options;

  const serializeFn = _options && _options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, _options);
  } else {
    serializedParams = utils.isURLSearchParams(params)
      ? params.toString()
      : new helpers_AxiosURLSearchParams(params, _options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf('#');

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/InterceptorManager.js




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null,
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ var core_InterceptorManager = (InterceptorManager);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/transitional.js


/* harmony default export */ var defaults_transitional = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false,
  legacyInterceptorReqResOrdering: true,
  advertiseZstdAcceptEncoding: false,
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/URLSearchParams.js



/* harmony default export */ var classes_URLSearchParams = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : helpers_AxiosURLSearchParams);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/FormData.js


/* harmony default export */ var classes_FormData = (typeof FormData !== 'undefined' ? FormData : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/classes/Blob.js


/* harmony default export */ var classes_Blob = (typeof Blob !== 'undefined' ? Blob : null);

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/browser/index.js




/* harmony default export */ var browser = ({
  isBrowser: true,
  classes: {
    URLSearchParams: classes_URLSearchParams,
    FormData: classes_FormData,
    Blob: classes_Blob,
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data'],
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/common/utils.js
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = (typeof navigator === 'object' && navigator) || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv =
  hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = (hasBrowserEnv && window.location.href) || 'http://localhost';



;// CONCATENATED MODULE: ./node_modules/axios/lib/platform/index.js



/* harmony default export */ var platform = ({
  ...common_utils_namespaceObject,
  ...browser,
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/toURLEncodedForm.js






function toURLEncodedForm(data, options) {
  return helpers_toFormData(data, new platform.classes.URLSearchParams(), {
    visitor: function (value, key, path, helpers) {
      if (platform.isNode && utils.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    },
    ...options,
  });
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/formDataToJSON.js




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils.matchAll(/\w+|\[(\w*)]/g, name).map((match) => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils.hasOwnProp(target, name)) {
        target[name] = utils.isArray(target[name])
          ? target[name].concat(value)
          : [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!utils.hasOwnProp(target, name) || !utils.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils.isFormData(formData) && utils.isFunction(formData.entries)) {
    const obj = {};

    utils.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ var helpers_formDataToJSON = (formDataToJSON);

;// CONCATENATED MODULE: ./node_modules/axios/lib/defaults/index.js










const own = (obj, key) => (obj != null && utils.hasOwnProp(obj, key) ? obj[key] : undefined);

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {
  transitional: defaults_transitional,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [
    function transformRequest(data, headers) {
      const contentType = headers.getContentType() || '';
      const hasJSONContentType = contentType.indexOf('application/json') > -1;
      const isObjectPayload = utils.isObject(data);

      if (isObjectPayload && utils.isHTMLForm(data)) {
        data = new FormData(data);
      }

      const isFormData = utils.isFormData(data);

      if (isFormData) {
        return hasJSONContentType ? JSON.stringify(helpers_formDataToJSON(data)) : data;
      }

      if (
        utils.isArrayBuffer(data) ||
        utils.isBuffer(data) ||
        utils.isStream(data) ||
        utils.isFile(data) ||
        utils.isBlob(data) ||
        utils.isReadableStream(data)
      ) {
        return data;
      }
      if (utils.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils.isURLSearchParams(data)) {
        headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
        return data.toString();
      }

      let isFileList;

      if (isObjectPayload) {
        const formSerializer = own(this, 'formSerializer');
        if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
          return toURLEncodedForm(data, formSerializer).toString();
        }

        if (
          (isFileList = utils.isFileList(data)) ||
          contentType.indexOf('multipart/form-data') > -1
        ) {
          const env = own(this, 'env');
          const _FormData = env && env.FormData;

          return helpers_toFormData(
            isFileList ? { 'files[]': data } : data,
            _FormData && new _FormData(),
            formSerializer
          );
        }
      }

      if (isObjectPayload || hasJSONContentType) {
        headers.setContentType('application/json', false);
        return stringifySafely(data);
      }

      return data;
    },
  ],

  transformResponse: [
    function transformResponse(data) {
      const transitional = own(this, 'transitional') || defaults.transitional;
      const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
      const responseType = own(this, 'responseType');
      const JSONRequested = responseType === 'json';

      if (utils.isResponse(data) || utils.isReadableStream(data)) {
        return data;
      }

      if (
        data &&
        utils.isString(data) &&
        ((forcedJSONParsing && !responseType) || JSONRequested)
      ) {
        const silentJSONParsing = transitional && transitional.silentJSONParsing;
        const strictJSONParsing = !silentJSONParsing && JSONRequested;

        try {
          return JSON.parse(data, own(this, 'parseReviver'));
        } catch (e) {
          if (strictJSONParsing) {
            if (e.name === 'SyntaxError') {
              throw core_AxiosError.from(e, core_AxiosError.ERR_BAD_RESPONSE, this, null, own(this, 'response'));
            }
            throw e;
          }
        }
      }

      return data;
    },
  ],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob,
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      Accept: 'application/json, text/plain, */*',
      'Content-Type': undefined,
    },
  },
};

utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'query'], (method) => {
  defaults.headers[method] = {};
});

/* harmony default export */ var lib_defaults = (defaults);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/transformData.js






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || lib_defaults;
  const context = response || config;
  const headers = core_AxiosHeaders.from(context.headers);
  let data = context.data;

  utils.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/isCancel.js


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CanceledError.js




class CanceledError extends core_AxiosError {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(message, config, request) {
    super(message == null ? 'canceled' : message, core_AxiosError.ERR_CANCELED, config, request);
    this.name = 'CanceledError';
    this.__CANCEL__ = true;
  }
}

/* harmony default export */ var cancel_CanceledError = (CanceledError);

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/settle.js




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new core_AxiosError(
      'Request failed with status code ' + response.status,
      response.status >= 400 && response.status < 500 ? core_AxiosError.ERR_BAD_REQUEST : core_AxiosError.ERR_BAD_RESPONSE,
      response.config,
      response.request,
      response
    ));
  }
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/parseProtocol.js


function parseProtocol(url) {
  const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
  return (match && match[1]) || '';
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/speedometer.js


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round((bytesCount * 1000) / passed) : undefined;
  };
}

/* harmony default export */ var helpers_speedometer = (speedometer);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/throttle.js
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn(...args);
  };

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

/* harmony default export */ var helpers_throttle = (throttle);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/progressEventReducer.js




const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = helpers_speedometer(50, 250);

  return helpers_throttle((e) => {
    if (!e || typeof e.loaded !== 'number') {
      return;
    }
    const rawLoaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
    const progressBytes = Math.max(0, loaded - bytesNotified);
    const rate = _speedometer(progressBytes);

    bytesNotified = Math.max(bytesNotified, loaded);

    const data = {
      loaded,
      total,
      progress: total ? loaded / total : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true,
    };

    listener(data);
  }, freq);
};

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [
    (loaded) =>
      throttled[0]({
        lengthComputable,
        total,
        loaded,
      }),
    throttled[1],
  ];
};

const asyncDecorator =
  (fn) =>
  (...args) =>
    utils.asap(() => fn(...args));

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isURLSameOrigin.js


/* harmony default export */ var isURLSameOrigin = (platform.hasStandardBrowserEnv
  ? ((origin, isMSIE) => (url) => {
      url = new URL(url, platform.origin);

      return (
        origin.protocol === url.protocol &&
        origin.host === url.host &&
        (isMSIE || origin.port === url.port)
      );
    })(
      new URL(platform.origin),
      platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
    )
  : () => true);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/cookies.js



/* harmony default export */ var cookies = (platform.hasStandardBrowserEnv
  ? // Standard browser envs support document.cookie
    {
      write(name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;

        const cookie = [`${name}=${encodeURIComponent(value)}`];

        if (utils.isNumber(expires)) {
          cookie.push(`expires=${new Date(expires).toUTCString()}`);
        }
        if (utils.isString(path)) {
          cookie.push(`path=${path}`);
        }
        if (utils.isString(domain)) {
          cookie.push(`domain=${domain}`);
        }
        if (secure === true) {
          cookie.push('secure');
        }
        if (utils.isString(sameSite)) {
          cookie.push(`SameSite=${sameSite}`);
        }

        document.cookie = cookie.join('; ');
      },

      read(name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].replace(/^\s+/, '');
          const eq = cookie.indexOf('=');
          if (eq !== -1 && cookie.slice(0, eq) === name) {
            return decodeURIComponent(cookie.slice(eq + 1));
          }
        }
        return null;
      },

      remove(name) {
        this.write(name, '', Date.now() - 86400000, '/');
      },
    }
  : // Non-standard browser env (web workers, react-native) lack needed support.
    {
      write() {},
      read() {
        return null;
      },
      remove() {},
    });

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAbsoluteURL.js


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  if (typeof url !== 'string') {
    return false;
  }

  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/combineURLs.js


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/buildFullPath.js





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
  let isRelativeUrl = !isAbsoluteURL(requestedURL);
  if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/mergeConfig.js





const headersToObject = (thing) => (thing instanceof core_AxiosHeaders ? { ...thing } : thing);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};

  // Use a null-prototype object so that downstream reads such as `config.auth`
  // or `config.baseURL` cannot inherit polluted values from Object.prototype.
  // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
  // ergonomics for user code that relies on it.
  const config = Object.create(null);
  Object.defineProperty(config, 'hasOwnProperty', {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: false,
    writable: true,
    configurable: true,
  });

  function getMergedValue(target, source, prop, caseless) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge.call({ caseless }, target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(a, b, prop, caseless) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(a, b, prop, caseless);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a, prop, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (utils.hasOwnProp(config2, prop)) {
      return getMergedValue(a, b);
    } else if (utils.hasOwnProp(config1, prop)) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    allowedSocketPaths: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b, prop) =>
      mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true),
  };

  utils.forEach(Object.keys({ ...config1, ...config2 }), function computeConfigValue(prop) {
    if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
    const merge = utils.hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
    const a = utils.hasOwnProp(config1, prop) ? config1[prop] : undefined;
    const b = utils.hasOwnProp(config2, prop) ? config2[prop] : undefined;
    const configValue = merge(a, b, prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/resolveConfig.js









const FORM_DATA_CONTENT_HEADERS = ['content-type', 'content-length'];

function setFormDataHeaders(headers, formHeaders, policy) {
  if (policy !== 'content-only') {
    headers.set(formHeaders);
    return;
  }

  Object.entries(formHeaders).forEach(([key, val]) => {
    if (FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) {
      headers.set(key, val);
    }
  });
}

/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */
const encodeUTF8 = (str) =>
  encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  );

function resolveConfig(config) {
  const newConfig = mergeConfig({}, config);

  // Read only own properties to prevent prototype pollution gadgets
  // (e.g. Object.prototype.baseURL = 'https://evil.com').
  const own = (key) => (utils.hasOwnProp(newConfig, key) ? newConfig[key] : undefined);

  const data = own('data');
  let withXSRFToken = own('withXSRFToken');
  const xsrfHeaderName = own('xsrfHeaderName');
  const xsrfCookieName = own('xsrfCookieName');
  let headers = own('headers');
  const auth = own('auth');
  const baseURL = own('baseURL');
  const allowAbsoluteUrls = own('allowAbsoluteUrls');
  const url = own('url');

  newConfig.headers = headers = core_AxiosHeaders.from(headers);

  newConfig.url = buildURL(
    buildFullPath(baseURL, url, allowAbsoluteUrls),
    own('params'),
    own('paramsSerializer')
  );

  // HTTP basic authentication
  if (auth) {
    headers.set(
      'Authorization',
      'Basic ' +
        btoa((auth.username || '') + ':' + (auth.password ? encodeUTF8(auth.password) : ''))
    );
  }

  if (utils.isFormData(data)) {
    if (
      platform.hasStandardBrowserEnv ||
      platform.hasStandardBrowserWebWorkerEnv ||
      utils.isReactNative(data)
    ) {
      headers.setContentType(undefined); // browser/web worker/RN handles it
    } else if (utils.isFunction(data.getHeaders)) {
      // Node.js FormData (like form-data package)
      setFormDataHeaders(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    if (utils.isFunction(withXSRFToken)) {
      withXSRFToken = withXSRFToken(newConfig);
    }

    // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
    // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
    // the XSRF token cross-origin.
    const shouldSendXSRF =
      withXSRFToken === true || (withXSRFToken == null && isURLSameOrigin(newConfig.url));

    if (shouldSendXSRF) {
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
}

/* harmony default export */ var helpers_resolveConfig = (resolveConfig);

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/xhr.js












const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ var xhr = (isXHRAdapterSupported &&
  function (config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
      const _config = helpers_resolveConfig(config);
      let requestData = _config.data;
      const requestHeaders = core_AxiosHeaders.from(_config.headers).normalize();
      let { responseType, onUploadProgress, onDownloadProgress } = _config;
      let onCanceled;
      let uploadThrottled, downloadThrottled;
      let flushUpload, flushDownload;

      function done() {
        flushUpload && flushUpload(); // flush events
        flushDownload && flushDownload(); // flush events

        _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

        _config.signal && _config.signal.removeEventListener('abort', onCanceled);
      }

      let request = new XMLHttpRequest();

      request.open(_config.method.toUpperCase(), _config.url, true);

      // Set the request timeout in MS
      request.timeout = _config.timeout;

      function onloadend() {
        if (!request) {
          return;
        }
        // Prepare the response
        const responseHeaders = core_AxiosHeaders.from(
          'getAllResponseHeaders' in request && request.getAllResponseHeaders()
        );
        const responseData =
          !responseType || responseType === 'text' || responseType === 'json'
            ? request.responseText
            : request.response;
        const response = {
          data: responseData,
          status: request.status,
          statusText: request.statusText,
          headers: responseHeaders,
          config,
          request,
        };

        settle(
          function _resolve(value) {
            resolve(value);
            done();
          },
          function _reject(err) {
            reject(err);
            done();
          },
          response
        );

        // Clean up request
        request = null;
      }

      if ('onloadend' in request) {
        // Use onloadend if available
        request.onloadend = onloadend;
      } else {
        // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
          if (!request || request.readyState !== 4) {
            return;
          }

          // The request errored out and we didn't get a response, this will be
          // handled by onerror instead
          // With one exception: request that using file: protocol, most browsers
          // will return status as 0 even though it's a successful request
          if (
            request.status === 0 &&
            !(request.responseURL && request.responseURL.startsWith('file:'))
          ) {
            return;
          }
          // readystate handler is calling before onerror or ontimeout handlers,
          // so we should call onloadend on the next 'tick'
          setTimeout(onloadend);
        };
      }

      // Handle browser request cancellation (as opposed to a manual cancellation)
      request.onabort = function handleAbort() {
        if (!request) {
          return;
        }

        reject(new core_AxiosError('Request aborted', core_AxiosError.ECONNABORTED, config, request));
        done();

        // Clean up request
        request = null;
      };

      // Handle low level network errors
      request.onerror = function handleError(event) {
        // Browsers deliver a ProgressEvent in XHR onerror
        // (message may be empty; when present, surface it)
        // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
        const msg = event && event.message ? event.message : 'Network Error';
        const err = new core_AxiosError(msg, core_AxiosError.ERR_NETWORK, config, request);
        // attach the underlying event for consumers who want details
        err.event = event || null;
        reject(err);
        done();
        request = null;
      };

      // Handle timeout
      request.ontimeout = function handleTimeout() {
        let timeoutErrorMessage = _config.timeout
          ? 'timeout of ' + _config.timeout + 'ms exceeded'
          : 'timeout exceeded';
        const transitional = _config.transitional || defaults_transitional;
        if (_config.timeoutErrorMessage) {
          timeoutErrorMessage = _config.timeoutErrorMessage;
        }
        reject(
          new core_AxiosError(
            timeoutErrorMessage,
            transitional.clarifyTimeoutError ? core_AxiosError.ETIMEDOUT : core_AxiosError.ECONNABORTED,
            config,
            request
          )
        );
        done();

        // Clean up request
        request = null;
      };

      // Remove Content-Type if data is undefined
      requestData === undefined && requestHeaders.setContentType(null);

      // Add headers to the request
      if ('setRequestHeader' in request) {
        utils.forEach(toByteStringHeaderObject(requestHeaders), function setRequestHeader(val, key) {
          request.setRequestHeader(key, val);
        });
      }

      // Add withCredentials to request if needed
      if (!utils.isUndefined(_config.withCredentials)) {
        request.withCredentials = !!_config.withCredentials;
      }

      // Add responseType to request if needed
      if (responseType && responseType !== 'json') {
        request.responseType = _config.responseType;
      }

      // Handle progress if needed
      if (onDownloadProgress) {
        [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
        request.addEventListener('progress', downloadThrottled);
      }

      // Not all browsers support upload events
      if (onUploadProgress && request.upload) {
        [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);

        request.upload.addEventListener('progress', uploadThrottled);

        request.upload.addEventListener('loadend', flushUpload);
      }

      if (_config.cancelToken || _config.signal) {
        // Handle cancellation
        // eslint-disable-next-line func-names
        onCanceled = (cancel) => {
          if (!request) {
            return;
          }
          reject(!cancel || cancel.type ? new cancel_CanceledError(null, config, request) : cancel);
          request.abort();
          done();
          request = null;
        };

        _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
        if (_config.signal) {
          _config.signal.aborted
            ? onCanceled()
            : _config.signal.addEventListener('abort', onCanceled);
        }
      }

      const protocol = parseProtocol(_config.url);

      if (protocol && !platform.protocols.includes(protocol)) {
        reject(
          new core_AxiosError(
            'Unsupported protocol ' + protocol + ':',
            core_AxiosError.ERR_BAD_REQUEST,
            config
          )
        );
        return;
      }

      // Send the request
      request.send(requestData || null);
    });
  });

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/composeSignals.js




const composeSignals = (signals, timeout) => {
  signals = signals ? signals.filter(Boolean) : [];

  if (!timeout && !signals.length) {
    return;
  }

  const controller = new AbortController();

  let aborted = false;

  const onabort = function (reason) {
    if (!aborted) {
      aborted = true;
      unsubscribe();
      const err = reason instanceof Error ? reason : this.reason;
      controller.abort(
        err instanceof core_AxiosError
          ? err
          : new cancel_CanceledError(err instanceof Error ? err.message : err)
      );
    }
  };

  let timer =
    timeout &&
    setTimeout(() => {
      timer = null;
      onabort(new core_AxiosError(`timeout of ${timeout}ms exceeded`, core_AxiosError.ETIMEDOUT));
    }, timeout);

  const unsubscribe = () => {
    if (!signals) { return; }
    timer && clearTimeout(timer);
    timer = null;
    signals.forEach((signal) => {
      signal.unsubscribe
        ? signal.unsubscribe(onabort)
        : signal.removeEventListener('abort', onabort);
    });
    signals = null;
  };

  signals.forEach((signal) => signal.addEventListener('abort', onabort));

  const { signal } = controller;

  signal.unsubscribe = () => utils.asap(unsubscribe);

  return signal;
};

/* harmony default export */ var helpers_composeSignals = (composeSignals);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/trackStream.js
const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };

  return new ReadableStream(
    {
      async pull(controller) {
        try {
          const { done, value } = await iterator.next();

          if (done) {
            _onFinish();
            controller.close();
            return;
          }

          let len = value.byteLength;
          if (onProgress) {
            let loadedBytes = (bytes += len);
            onProgress(loadedBytes);
          }
          controller.enqueue(new Uint8Array(value));
        } catch (err) {
          _onFinish(err);
          throw err;
        }
      },
      cancel(reason) {
        _onFinish(reason);
        return iterator.return();
      },
    },
    {
      highWaterMark: 2,
    }
  );
};

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/estimateDataURLDecodedBytes.js
/* provided dependency */ var estimateDataURLDecodedBytes_Buffer = __webpack_require__(48764)["lW"];
/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: use UTF-8 byteLength of the encoded body as a safe upper bound.
 *
 * @param {string} url
 * @returns {number}
 */
function estimateDataURLDecodedBytes(url) {
  if (!url || typeof url !== 'string') return 0;
  if (!url.startsWith('data:')) return 0;

  const comma = url.indexOf(',');
  if (comma < 0) return 0;

  const meta = url.slice(5, comma);
  const body = url.slice(comma + 1);
  const isBase64 = /;base64/i.test(meta);

  if (isBase64) {
    let effectiveLen = body.length;
    const len = body.length; // cache length

    for (let i = 0; i < len; i++) {
      if (body.charCodeAt(i) === 37 /* '%' */ && i + 2 < len) {
        const a = body.charCodeAt(i + 1);
        const b = body.charCodeAt(i + 2);
        const isHex =
          ((a >= 48 && a <= 57) || (a >= 65 && a <= 70) || (a >= 97 && a <= 102)) &&
          ((b >= 48 && b <= 57) || (b >= 65 && b <= 70) || (b >= 97 && b <= 102));

        if (isHex) {
          effectiveLen -= 2;
          i += 2;
        }
      }
    }

    let pad = 0;
    let idx = len - 1;

    const tailIsPct3D = (j) =>
      j >= 2 &&
      body.charCodeAt(j - 2) === 37 && // '%'
      body.charCodeAt(j - 1) === 51 && // '3'
      (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'

    if (idx >= 0) {
      if (body.charCodeAt(idx) === 61 /* '=' */) {
        pad++;
        idx--;
      } else if (tailIsPct3D(idx)) {
        pad++;
        idx -= 3;
      }
    }

    if (pad === 1 && idx >= 0) {
      if (body.charCodeAt(idx) === 61 /* '=' */) {
        pad++;
      } else if (tailIsPct3D(idx)) {
        pad++;
      }
    }

    const groups = Math.floor(effectiveLen / 4);
    const bytes = groups * 3 - (pad || 0);
    return bytes > 0 ? bytes : 0;
  }

  if (typeof estimateDataURLDecodedBytes_Buffer !== 'undefined' && typeof estimateDataURLDecodedBytes_Buffer.byteLength === 'function') {
    return estimateDataURLDecodedBytes_Buffer.byteLength(body, 'utf8');
  }

  // Compute UTF-8 byte length directly from UTF-16 code units without allocating
  // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
  // Using body.length here would undercount non-ASCII (e.g. '€' is 1 code unit
  // but 3 UTF-8 bytes).
  let bytes = 0;
  for (let i = 0, len = body.length; i < len; i++) {
    const c = body.charCodeAt(i);
    if (c < 0x80) {
      bytes += 1;
    } else if (c < 0x800) {
      bytes += 2;
    } else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
      const next = body.charCodeAt(i + 1);
      if (next >= 0xdc00 && next <= 0xdfff) {
        bytes += 4;
        i++;
      } else {
        bytes += 3;
      }
    } else {
      bytes += 3;
    }
  }
  return bytes;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/env/data.js
const VERSION = "1.17.0";
;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/fetch.js













const DEFAULT_CHUNK_SIZE = 64 * 1024;

const { isFunction: fetch_isFunction } = utils;

/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */
const fetch_encodeUTF8 = (str) =>
  encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  );

// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const decodeURIComponentSafe = (value) => {
  if (!utils.isString(value)) {
    return value;
  }

  try {
    return decodeURIComponent(value);
  } catch (error) {
    return value;
  }
};

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false;
  }
};

const maybeWithAuthCredentials = (url) => {
  const protocolIndex = url.indexOf('://');
  let urlToCheck = url;
  if (protocolIndex !== -1) {
    urlToCheck = urlToCheck.slice(protocolIndex + 3);
  }
  return urlToCheck.includes('@') || urlToCheck.includes(':');
};

const factory = (env) => {
  const globalObject =
    utils.global !== undefined && utils.global !== null
      ? utils.global
      : globalThis;
  const { ReadableStream, TextEncoder } = globalObject;

  env = utils.merge.call(
    {
      skipUndefined: true,
    },
    {
      Request: globalObject.Request,
      Response: globalObject.Response,
    },
    env
  );

  const { fetch: envFetch, Request, Response } = env;
  const isFetchSupported = envFetch ? fetch_isFunction(envFetch) : typeof fetch === 'function';
  const isRequestSupported = fetch_isFunction(Request);
  const isResponseSupported = fetch_isFunction(Response);

  if (!isFetchSupported) {
    return false;
  }

  const isReadableStreamSupported = isFetchSupported && fetch_isFunction(ReadableStream);

  const encodeText =
    isFetchSupported &&
    (typeof TextEncoder === 'function'
      ? (
          (encoder) => (str) =>
            encoder.encode(str)
        )(new TextEncoder())
      : async (str) => new Uint8Array(await new Request(str).arrayBuffer()));

  const supportsRequestStream =
    isRequestSupported &&
    isReadableStreamSupported &&
    test(() => {
      let duplexAccessed = false;

      const request = new Request(platform.origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex() {
          duplexAccessed = true;
          return 'half';
        },
      });

      const hasContentType = request.headers.has('Content-Type');

      if (request.body != null) {
        request.body.cancel();
      }

      return duplexAccessed && !hasContentType;
    });

  const supportsResponseStream =
    isResponseSupported &&
    isReadableStreamSupported &&
    test(() => utils.isReadableStream(new Response('').body));

  const resolvers = {
    stream: supportsResponseStream && ((res) => res.body),
  };

  isFetchSupported &&
    (() => {
      ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach((type) => {
        !resolvers[type] &&
          (resolvers[type] = (res, config) => {
            let method = res && res[type];

            if (method) {
              return method.call(res);
            }

            throw new core_AxiosError(
              `Response type '${type}' is not supported`,
              core_AxiosError.ERR_NOT_SUPPORT,
              config
            );
          });
      });
    })();

  const getBodyLength = async (body) => {
    if (body == null) {
      return 0;
    }

    if (utils.isBlob(body)) {
      return body.size;
    }

    if (utils.isSpecCompliantForm(body)) {
      const _request = new Request(platform.origin, {
        method: 'POST',
        body,
      });
      return (await _request.arrayBuffer()).byteLength;
    }

    if (utils.isArrayBufferView(body) || utils.isArrayBuffer(body)) {
      return body.byteLength;
    }

    if (utils.isURLSearchParams(body)) {
      body = body + '';
    }

    if (utils.isString(body)) {
      return (await encodeText(body)).byteLength;
    }
  };

  const resolveBodyLength = async (headers, body) => {
    const length = utils.toFiniteNumber(headers.getContentLength());

    return length == null ? getBodyLength(body) : length;
  };

  return async (config) => {
    let {
      url,
      method,
      data,
      signal,
      cancelToken,
      timeout,
      onDownloadProgress,
      onUploadProgress,
      responseType,
      headers,
      withCredentials = 'same-origin',
      fetchOptions,
      maxContentLength,
      maxBodyLength,
    } = helpers_resolveConfig(config);

    const hasMaxContentLength = utils.isNumber(maxContentLength) && maxContentLength > -1;
    const hasMaxBodyLength = utils.isNumber(maxBodyLength) && maxBodyLength > -1;
    const own = (key) => (utils.hasOwnProp(config, key) ? config[key] : undefined);

    let _fetch = envFetch || fetch;

    responseType = responseType ? (responseType + '').toLowerCase() : 'text';

    let composedSignal = helpers_composeSignals(
      [signal, cancelToken && cancelToken.toAbortSignal()],
      timeout
    );

    let request = null;

    const unsubscribe =
      composedSignal &&
      composedSignal.unsubscribe &&
      (() => {
        composedSignal.unsubscribe();
      });

    let requestContentLength;

    try {
      // HTTP basic authentication
      let auth = undefined;
      const configAuth = own('auth');

      if (configAuth) {
        const username = configAuth.username || '';
        const password = configAuth.password || '';
        auth = {
          username,
          password
        };
      }

      if (maybeWithAuthCredentials(url)) {
        const parsedURL = new URL(url, platform.origin);

        if (!auth && (parsedURL.username || parsedURL.password)) {
          const urlUsername = decodeURIComponentSafe(parsedURL.username);
          const urlPassword = decodeURIComponentSafe(parsedURL.password);
          auth = {
            username: urlUsername,
            password: urlPassword
          };
        }

        if (parsedURL.username || parsedURL.password) {
          parsedURL.username = '';
          parsedURL.password = '';
          url = parsedURL.href;
        }
      }

      if (auth) {
        headers.delete('authorization');
        headers.set(
          'Authorization',
          'Basic ' + btoa(fetch_encodeUTF8((auth.username || '') + ':' + (auth.password || '')))
        );
      }

      // Enforce maxContentLength for data: URLs up-front so we never materialize
      // an oversized payload. The HTTP adapter applies the same check (see http.js
      // "if (protocol === 'data:')" branch).
      if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
        const estimated = estimateDataURLDecodedBytes(url);
        if (estimated > maxContentLength) {
          throw new core_AxiosError(
            'maxContentLength size of ' + maxContentLength + ' exceeded',
            core_AxiosError.ERR_BAD_RESPONSE,
            config,
            request
          );
        }
      }

      // Enforce maxBodyLength against the outbound request body before dispatch.
      // Mirrors http.js behavior (ERR_BAD_REQUEST / 'Request body larger than
      // maxBodyLength limit'). Skip when the body length cannot be determined
      // (e.g. a live ReadableStream supplied by the caller).
      if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
        const outboundLength = await resolveBodyLength(headers, data);
        if (
          typeof outboundLength === 'number' &&
          isFinite(outboundLength) &&
          outboundLength > maxBodyLength
        ) {
          throw new core_AxiosError(
            'Request body larger than maxBodyLength limit',
            core_AxiosError.ERR_BAD_REQUEST,
            config,
            request
          );
        }
      }

      if (
        onUploadProgress &&
        supportsRequestStream &&
        method !== 'get' &&
        method !== 'head' &&
        (requestContentLength = await resolveBodyLength(headers, data)) !== 0
      ) {
        let _request = new Request(url, {
          method: 'POST',
          body: data,
          duplex: 'half',
        });

        let contentTypeHeader;

        if (utils.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
          headers.setContentType(contentTypeHeader);
        }

        if (_request.body) {
          const [onProgress, flush] = progressEventDecorator(
            requestContentLength,
            progressEventReducer(asyncDecorator(onUploadProgress))
          );

          data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
        }
      }

      if (!utils.isString(withCredentials)) {
        withCredentials = withCredentials ? 'include' : 'omit';
      }

      // Cloudflare Workers throws when credentials are defined
      // see https://github.com/cloudflare/workerd/issues/902
      const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;

      // If data is FormData and Content-Type is multipart/form-data without boundary,
      // delete it so fetch can set it correctly with the boundary
      if (utils.isFormData(data)) {
        const contentType = headers.getContentType();
        if (
          contentType &&
          /^multipart\/form-data/i.test(contentType) &&
          !/boundary=/i.test(contentType)
        ) {
          headers.delete('content-type');
        }
      }

      // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
      headers.set('User-Agent', 'axios/' + VERSION, false);

      const resolvedOptions = {
        ...fetchOptions,
        signal: composedSignal,
        method: method.toUpperCase(),
        headers: toByteStringHeaderObject(headers.normalize()),
        body: data,
        duplex: 'half',
        credentials: isCredentialsSupported ? withCredentials : undefined,
      };

      request = isRequestSupported && new Request(url, resolvedOptions);

      let response = await (isRequestSupported
        ? _fetch(request, fetchOptions)
        : _fetch(url, resolvedOptions));

      // Cheap pre-check: if the server honestly declares a content-length that
      // already exceeds the cap, reject before we start streaming.
      if (hasMaxContentLength) {
        const declaredLength = utils.toFiniteNumber(response.headers.get('content-length'));
        if (declaredLength != null && declaredLength > maxContentLength) {
          throw new core_AxiosError(
            'maxContentLength size of ' + maxContentLength + ' exceeded',
            core_AxiosError.ERR_BAD_RESPONSE,
            config,
            request
          );
        }
      }

      const isStreamResponse =
        supportsResponseStream && (responseType === 'stream' || responseType === 'response');

      if (
        supportsResponseStream &&
        response.body &&
        (onDownloadProgress || hasMaxContentLength || (isStreamResponse && unsubscribe))
      ) {
        const options = {};

        ['status', 'statusText', 'headers'].forEach((prop) => {
          options[prop] = response[prop];
        });

        const responseContentLength = utils.toFiniteNumber(response.headers.get('content-length'));

        const [onProgress, flush] =
          (onDownloadProgress &&
            progressEventDecorator(
              responseContentLength,
              progressEventReducer(asyncDecorator(onDownloadProgress), true)
            )) ||
          [];

        let bytesRead = 0;
        const onChunkProgress = (loadedBytes) => {
          if (hasMaxContentLength) {
            bytesRead = loadedBytes;
            if (bytesRead > maxContentLength) {
              throw new core_AxiosError(
                'maxContentLength size of ' + maxContentLength + ' exceeded',
                core_AxiosError.ERR_BAD_RESPONSE,
                config,
                request
              );
            }
          }
          onProgress && onProgress(loadedBytes);
        };

        response = new Response(
          trackStream(response.body, DEFAULT_CHUNK_SIZE, onChunkProgress, () => {
            flush && flush();
            unsubscribe && unsubscribe();
          }),
          options
        );
      }

      responseType = responseType || 'text';

      let responseData = await resolvers[utils.findKey(resolvers, responseType) || 'text'](
        response,
        config
      );

      // Fallback enforcement for environments without ReadableStream support
      // (legacy runtimes). Detect materialized size from typed output; skip
      // streams/Response passthrough since the user will read those themselves.
      if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
        let materializedSize;
        if (responseData != null) {
          if (typeof responseData.byteLength === 'number') {
            materializedSize = responseData.byteLength;
          } else if (typeof responseData.size === 'number') {
            materializedSize = responseData.size;
          } else if (typeof responseData === 'string') {
            materializedSize =
              typeof TextEncoder === 'function'
                ? new TextEncoder().encode(responseData).byteLength
                : responseData.length;
          }
        }
        if (typeof materializedSize === 'number' && materializedSize > maxContentLength) {
          throw new core_AxiosError(
            'maxContentLength size of ' + maxContentLength + ' exceeded',
            core_AxiosError.ERR_BAD_RESPONSE,
            config,
            request
          );
        }
      }

      !isStreamResponse && unsubscribe && unsubscribe();

      return await new Promise((resolve, reject) => {
        settle(resolve, reject, {
          data: responseData,
          headers: core_AxiosHeaders.from(response.headers),
          status: response.status,
          statusText: response.statusText,
          config,
          request,
        });
      });
    } catch (err) {
      unsubscribe && unsubscribe();

      // Safari can surface fetch aborts as a DOMException-like object whose
      // branded getters throw. Prefer our composed signal reason before reading
      // the caught error, preserving timeout vs cancellation semantics.
      if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof core_AxiosError) {
        const canceledError = composedSignal.reason;
        canceledError.config = config;
        request && (canceledError.request = request);
        err !== canceledError && (canceledError.cause = err);
        throw canceledError;
      }

      if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
        throw Object.assign(
          new core_AxiosError(
            'Network Error',
            core_AxiosError.ERR_NETWORK,
            config,
            request,
            err && err.response
          ),
          {
            cause: err.cause || err,
          }
        );
      }

      throw core_AxiosError.from(err, err && err.code, config, request, err && err.response);
    }
  };
};

const seedCache = new Map();

const getFetch = (config) => {
  let env = (config && config.env) || {};
  const { fetch, Request, Response } = env;
  const seeds = [Request, Response, fetch];

  let len = seeds.length,
    i = len,
    seed,
    target,
    map = seedCache;

  while (i--) {
    seed = seeds[i];
    target = map.get(seed);

    target === undefined && map.set(seed, (target = i ? new Map() : factory(env)));

    map = target;
  }

  return target;
};

const adapter = getFetch();

/* harmony default export */ var adapters_fetch = ((/* unused pure expression or super */ null && (adapter)));

;// CONCATENATED MODULE: ./node_modules/axios/lib/adapters/adapters.js






/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */
const knownAdapters = {
  http: helpers_null,
  xhr: xhr,
  fetch: {
    get: getFetch,
  },
};

// Assign adapter names for easier debugging and identification
utils.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      // Null-proto descriptors so a polluted Object.prototype.get cannot turn
      // these data descriptors into accessor descriptors on the way in.
      Object.defineProperty(fn, 'name', { __proto__: null, value });
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', { __proto__: null, value });
  }
});

/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */
const renderReason = (reason) => `- ${reason}`;

/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */
const isResolvedHandle = (adapter) =>
  utils.isFunction(adapter) || adapter === null || adapter === false;

/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */
function getAdapter(adapters, config) {
  adapters = utils.isArray(adapters) ? adapters : [adapters];

  const { length } = adapters;
  let nameOrAdapter;
  let adapter;

  const rejectedReasons = {};

  for (let i = 0; i < length; i++) {
    nameOrAdapter = adapters[i];
    let id;

    adapter = nameOrAdapter;

    if (!isResolvedHandle(nameOrAdapter)) {
      adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

      if (adapter === undefined) {
        throw new core_AxiosError(`Unknown adapter '${id}'`);
      }
    }

    if (adapter && (utils.isFunction(adapter) || (adapter = adapter.get(config)))) {
      break;
    }

    rejectedReasons[id || '#' + i] = adapter;
  }

  if (!adapter) {
    const reasons = Object.entries(rejectedReasons).map(
      ([id, state]) =>
        `adapter ${id} ` +
        (state === false ? 'is not supported by the environment' : 'is not available in the build')
    );

    let s = length
      ? reasons.length > 1
        ? 'since :\n' + reasons.map(renderReason).join('\n')
        : ' ' + renderReason(reasons[0])
      : 'as no adapter specified';

    throw new core_AxiosError(
      `There is no suitable adapter to dispatch the request ` + s,
      'ERR_NOT_SUPPORT'
    );
  }

  return adapter;
}

/**
 * Exports Axios adapters and utility to resolve an adapter
 */
/* harmony default export */ var adapters = ({
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter,

  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: knownAdapters,
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/dispatchRequest.js









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new cancel_CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = core_AxiosHeaders.from(config.headers);

  // Transform request data
  config.data = transformData.call(config, config.transformRequest);

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || lib_defaults.adapter, config);

  return adapter(config).then(
    function onAdapterResolution(response) {
      throwIfCancellationRequested(config);

      // Expose the current response on config so that transformResponse can
      // attach it to any AxiosError it throws (e.g. on JSON parse failure).
      // We clean it up afterwards to avoid polluting the config object.
      config.response = response;
      try {
        response.data = transformData.call(config, config.transformResponse, response);
      } finally {
        delete config.response;
      }

      response.headers = core_AxiosHeaders.from(response.headers);

      return response;
    },
    function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config);

        // Transform response data
        if (reason && reason.response) {
          config.response = reason.response;
          try {
            reason.response.data = transformData.call(
              config,
              config.transformResponse,
              reason.response
            );
          } finally {
            delete config.response;
          }
          reason.response.headers = core_AxiosHeaders.from(reason.response.headers);
        }
      }

      return Promise.reject(reason);
    }
  );
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/validator.js





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return (
      '[Axios v' +
      VERSION +
      "] Transitional option '" +
      opt +
      "'" +
      desc +
      (message ? '. ' + message : '')
    );
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new core_AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        core_AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

validators.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new core_AxiosError('options must be an object', core_AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
    // a non-function validator and cause a TypeError.
    const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new core_AxiosError(
          'option ' + opt + ' must be ' + result,
          core_AxiosError.ERR_BAD_OPTION_VALUE
        );
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new core_AxiosError('Unknown option ' + opt, core_AxiosError.ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ var validator = ({
  assertOptions,
  validators,
});

;// CONCATENATED MODULE: ./node_modules/axios/lib/core/Axios.js












const Axios_validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig || {};
    this.interceptors = {
      request: new core_InterceptorManager(),
      response: new core_InterceptorManager(),
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};

        Error.captureStackTrace ? Error.captureStackTrace(dummy) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = (() => {
          if (!dummy.stack) {
            return '';
          }

          const firstNewlineIndex = dummy.stack.indexOf('\n');

          return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
        })();
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack) {
            const firstNewlineIndex = stack.indexOf('\n');
            const secondNewlineIndex =
              firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
            const stackWithoutTwoTopLines =
              secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);

            if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) {
              err.stack += '\n' + stack;
            }
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const { transitional, paramsSerializer, headers } = config;

    if (transitional !== undefined) {
      validator.assertOptions(
        transitional,
        {
          silentJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
          forcedJSONParsing: Axios_validators.transitional(Axios_validators.boolean),
          clarifyTimeoutError: Axios_validators.transitional(Axios_validators.boolean),
          legacyInterceptorReqResOrdering: Axios_validators.transitional(Axios_validators.boolean),
          advertiseZstdAcceptEncoding: Axios_validators.transitional(Axios_validators.boolean),
        },
        false
      );
    }

    if (paramsSerializer != null) {
      if (utils.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer,
        };
      } else {
        validator.assertOptions(
          paramsSerializer,
          {
            encode: Axios_validators.function,
            serialize: Axios_validators.function,
          },
          true
        );
      }
    }

    // Set config.allowAbsoluteUrls
    if (config.allowAbsoluteUrls !== undefined) {
      // do nothing
    } else if (this.defaults.allowAbsoluteUrls !== undefined) {
      config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
    } else {
      config.allowAbsoluteUrls = true;
    }

    validator.assertOptions(
      config,
      {
        baseUrl: Axios_validators.spelling('baseURL'),
        withXsrfToken: Axios_validators.spelling('withXSRFToken'),
      },
      true
    );

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils.merge(headers.common, headers[config.method]);

    headers &&
      utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'query', 'common'], (method) => {
        delete headers[method];
      });

    config.headers = core_AxiosHeaders.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      const transitional = config.transitional || defaults_transitional;
      const legacyInterceptorReqResOrdering =
        transitional && transitional.legacyInterceptorReqResOrdering;

      if (legacyInterceptorReqResOrdering) {
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      } else {
        requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      }
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift(...requestInterceptorChain);
      chain.push(...responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url, config.allowAbsoluteUrls);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(
      mergeConfig(config || {}, {
        method,
        url,
        data: (config || {}).data,
      })
    );
  };
});

utils.forEach(['post', 'put', 'patch', 'query'], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(
        mergeConfig(config || {}, {
          method,
          headers: isForm
            ? {
                'Content-Type': 'multipart/form-data',
              }
            : {},
          url,
          data,
        })
      );
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  // QUERY is a safe/idempotent read method; multipart form bodies don't fit
  // its semantics, so no queryForm shorthand is generated.
  if (method !== 'query') {
    Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
  }
});

/* harmony default export */ var core_Axios = (Axios);

;// CONCATENATED MODULE: ./node_modules/axios/lib/cancel/CancelToken.js




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then((cancel) => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = (onfulfilled) => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise((resolve) => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new cancel_CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel,
    };
  }
}

/* harmony default export */ var cancel_CancelToken = (CancelToken);

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/spread.js


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  const args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/isAxiosError.js




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}

;// CONCATENATED MODULE: ./node_modules/axios/lib/helpers/HttpStatusCode.js
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ var helpers_HttpStatusCode = (HttpStatusCode);

;// CONCATENATED MODULE: ./node_modules/axios/lib/axios.js




















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new core_Axios(defaultConfig);
  const instance = bind(core_Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, core_Axios.prototype, context, { allOwnKeys: true });

  // Copy context to instance
  utils.extend(instance, context, null, { allOwnKeys: true });

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(lib_defaults);

// Expose Axios class to allow class inheritance
axios.Axios = core_Axios;

// Expose Cancel & CancelToken
axios.CanceledError = cancel_CanceledError;
axios.CancelToken = cancel_CancelToken;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = helpers_toFormData;

// Expose AxiosError class
axios.AxiosError = core_AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = core_AxiosHeaders;

axios.formToJSON = (thing) => helpers_formDataToJSON(utils.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = helpers_HttpStatusCode;

axios.default = axios;

// this module should only have a default export
/* harmony default export */ var lib_axios = (axios);


/***/ }),

/***/ 96475:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ dset; }
/* harmony export */ });
function dset(obj, keys, val) {
	keys.split && (keys=keys.split('.'));
	var i=0, l=keys.length, t=obj, x, k;
	while (i < l) {
		k = ''+keys[i++];
		if (k === '__proto__' || k === 'constructor' || k === 'prototype') break;
		t = t[k] = (i === l) ? val : (typeof(x=t[k])===typeof(keys)) ? x : (keys[i]*0 !== 0 || !!~(''+keys[i]).indexOf('.')) ? {} : [];
	}
}


/***/ }),

/***/ 31955:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ api; }
/* harmony export */ });
/*! js-cookie v3.0.8 | MIT */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (key === '__proto__') continue
      target[key] = source[key];
    }
  }
  return target
}

var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};

function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get(name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        if (!(found in jar)) jar[found] = converter.read(value, found);
        if (name === found) {
          break
        }
      } catch (_e) {
        // Do nothing...
      }
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);